// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!../../node_modules/@fullcalendar/core/main.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../node_modules/css-loader/dist/cjs.js!../../node_modules/@fullcalendar/daygrid/main.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../node_modules/css-loader/dist/cjs.js!../../node_modules/@fullcalendar/bootstrap/main.css";
import ___CSS_LOADER_AT_RULE_IMPORT_3___ from "-!../../node_modules/css-loader/dist/cjs.js!../../node_modules/@fullcalendar/timegrid/main.css";
import ___CSS_LOADER_AT_RULE_IMPORT_4___ from "-!../../node_modules/css-loader/dist/cjs.js!../../node_modules/@fullcalendar/list/main.css";
import ___CSS_LOADER_AT_RULE_IMPORT_5___ from "-!../../node_modules/css-loader/dist/cjs.js!../../node_modules/flatpickr/dist/flatpickr.css";
import ___CSS_LOADER_AT_RULE_IMPORT_6___ from "-!../../node_modules/css-loader/dist/cjs.js!../../node_modules/react-perfect-scrollbar/dist/css/styles.css";
import ___CSS_LOADER_AT_RULE_IMPORT_7___ from "-!../../node_modules/css-loader/dist/cjs.js!../../node_modules/ag-grid-enterprise/styles/ag-grid.css";
import ___CSS_LOADER_AT_RULE_IMPORT_8___ from "-!../../node_modules/css-loader/dist/cjs.js!../../node_modules/ag-grid-enterprise/styles/ag-theme-alpine-no-font.css";
import ___CSS_LOADER_AT_RULE_IMPORT_9___ from "-!../../node_modules/css-loader/dist/cjs.js!../../node_modules/ag-grid-enterprise/styles/ag-theme-alpine.css";
import ___CSS_LOADER_AT_RULE_IMPORT_10___ from "-!../../node_modules/css-loader/dist/cjs.js!../../node_modules/ag-grid-enterprise/styles/ag-theme-balham-no-font.css";
import ___CSS_LOADER_AT_RULE_IMPORT_11___ from "-!../../node_modules/css-loader/dist/cjs.js!../../node_modules/ag-grid-enterprise/styles/ag-theme-balham.css";
import ___CSS_LOADER_AT_RULE_IMPORT_12___ from "-!../../node_modules/css-loader/dist/cjs.js!../../node_modules/react-datepicker/dist/react-datepicker.css";
import ___CSS_LOADER_AT_RULE_IMPORT_13___ from "-!../../node_modules/css-loader/dist/cjs.js!../../node_modules/react-modern-drawer/dist/index.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%2343d39e%27 d=%27M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 4 5%27%3e%3cpath fill=%27%23bcc1cc%27 d=%27M2 0L0 2h4zm0 5L0 3h4z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23ff5c75%27 viewBox=%27-2 -2 7 7%27%3e%3cpath stroke=%27%23ff5c75%27 d=%27M0 0l3 3m0-3L0 3%27/%3e%3ccircle r=%27.5%27/%3e%3ccircle cx=%273%27 r=%27.5%27/%3e%3ccircle cy=%273%27 r=%27.5%27/%3e%3ccircle cx=%273%27 cy=%273%27 r=%27.5%27/%3e%3c/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%23fff%27 d=%27M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 4 4%27%3e%3cpath stroke=%27%23fff%27 d=%27M0 2h4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg viewBox=%270 0 30 30%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3cpath stroke=%27rgba%280, 0, 0, 0.5%29%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg viewBox=%270 0 30 30%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.5%29%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23fff%27 viewBox=%270 0 8 8%27%3e%3cpath d=%27M5.25 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23fff%27 viewBox=%270 0 8 8%27%3e%3cpath d=%27M2.75 0l-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 4-4-4-4z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("./fonts/unicons.eot?2256574", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("./fonts/unicons.woff2?2256574", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("./fonts/unicons.woff?2256574", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("./fonts/unicons.ttf?2256574", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("./fonts/unicons.svg?2256574", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../images/plugin/multiple-arrow.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../images/Login.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Nunito+Sans:300,400,600,700,900&display=swap);"]);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_3___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_4___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_5___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_6___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_7___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_8___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_9___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_10___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_11___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_12___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___, { hash: "#unicons" });
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*!
 * Bootstrap v4.6.2 (https://getbootstrap.com/)
 * Copyright 2011-2022 The Bootstrap Authors
 * Copyright 2011-2022 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 */
:root {
  --blue: #5369f8;
  --indigo: #564ab1;
  --purple: #6f42c1;
  --pink: #e83e8c;
  --red: #ff5c75;
  --orange: #f77e53;
  --yellow: #ffbe0b;
  --green: #43d39e;
  --teal: #1ce1ac;
  --cyan: #25c2e3;
  --white: #fff;
  --gray: #8790a4;
  --gray-dark: #bcc1cc;
  --primary: #5369f8;
  --secondary: #292d36;
  --success: #43d39e;
  --info: #25c2e3;
  --warning: #ffbe0b;
  --danger: #ff5c75;
  --light: #3b414e;
  --dark: #bcc1cc;
  --breakpoint-xs: 0;
  --breakpoint-sm: 576px;
  --breakpoint-md: 768px;
  --breakpoint-lg: 992px;
  --breakpoint-xl: 1200px;
  --font-family-sans-serif: "Nunito Sans", sans-serif;
  --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

html {
  font-family: sans-serif;
  line-height: 1.15;
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

article, aside, figcaption, figure, footer, header, hgroup, main, nav, section {
  display: block;
}

body {
  margin: 0;
  font-family: "Nunito Sans", sans-serif;
  font-size: 0.9rem;
  font-weight: 400;
  line-height: 1.5;
  color: #a1a8b8;
  text-align: left;
  background-color: #64687C;
}

[tabindex="-1"]:focus:not(:focus-visible) {
  outline: 0 !important;
}

hr {
  box-sizing: content-box;
  height: 0;
  overflow: visible;
}

h1, h2, h3, h4, h5, h6 {
  margin-top: 0;
  margin-bottom: 0.5rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title],
abbr[data-original-title] {
  text-decoration: underline;
  text-decoration: underline dotted;
  cursor: help;
  border-bottom: 0;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 700;
}

dd {
  margin-bottom: 0.5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

small {
  font-size: 80%;
}

sub,
sup {
  position: relative;
  font-size: 75%;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

a {
  color: #5369f8;
  text-decoration: none;
  background-color: transparent;
}
a:hover {
  color: rgb(9.9525139665, 41.2318435754, 244.5474860335);
  text-decoration: underline;
}

a:not([href]):not([class]) {
  color: inherit;
  text-decoration: none;
}
a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-size: 1em;
}

pre {
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  -ms-overflow-style: scrollbar;
}

figure {
  margin: 0 0 1rem;
}

img {
  vertical-align: middle;
  border-style: none;
}

svg {
  overflow: hidden;
  vertical-align: middle;
}

table {
  border-collapse: collapse;
}

caption {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  color: #6b768d;
  text-align: left;
  caption-side: bottom;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

label {
  display: inline-block;
  margin-bottom: 0.5rem;
}

button {
  border-radius: 0;
}

button:focus:not(:focus-visible) {
  outline: 0;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
input {
  overflow: visible;
}

button,
select {
  text-transform: none;
}

[role=button] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}

button,
[type=button],
[type=reset],
[type=submit] {
  -webkit-appearance: button;
}

button:not(:disabled),
[type=button]:not(:disabled),
[type=reset]:not(:disabled),
[type=submit]:not(:disabled) {
  cursor: pointer;
}

button::-moz-focus-inner,
[type=button]::-moz-focus-inner,
[type=reset]::-moz-focus-inner,
[type=submit]::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

input[type=radio],
input[type=checkbox] {
  box-sizing: border-box;
  padding: 0;
}

textarea {
  overflow: auto;
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  display: block;
  width: 100%;
  max-width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: 1.5rem;
  line-height: inherit;
  color: inherit;
  white-space: normal;
}

progress {
  vertical-align: baseline;
}

[type=number]::-webkit-inner-spin-button,
[type=number]::-webkit-outer-spin-button {
  height: auto;
}

[type=search] {
  outline-offset: -2px;
  -webkit-appearance: none;
}

[type=search]::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-file-upload-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

summary {
  display: list-item;
  cursor: pointer;
}

template {
  display: none;
}

[hidden] {
  display: none !important;
}

h1, h2, h3, h4, h5, h6,
.h1, .h2, .h3, .h4, .h5, .h6 {
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2;
}

h1, .h1 {
  font-size: 2.25rem;
}

h2, .h2 {
  font-size: 1.8rem;
}

h3, .h3 {
  font-size: 1.575rem;
}

h4, .h4 {
  font-size: 1.35rem;
}

h5, .h5 {
  font-size: 1.125rem;
}

h6, .h6 {
  font-size: 0.9rem;
}

.lead {
  font-size: 1.125rem;
  font-weight: 300;
}

.display-1 {
  font-size: 6rem;
  font-weight: 300;
  line-height: 1.2;
}

.display-2 {
  font-size: 5.5rem;
  font-weight: 300;
  line-height: 1.2;
}

.display-3 {
  font-size: 4.5rem;
  font-weight: 300;
  line-height: 1.2;
}

.display-4 {
  font-size: 3.5rem;
  font-weight: 300;
  line-height: 1.2;
}

hr {
  margin-top: 1rem;
  margin-bottom: 1rem;
  border: 0;
  border-top: 1px solid #3b414e;
}

small,
.small {
  font-size: 80%;
  font-weight: 400;
}

mark,
.mark {
  padding: 0.2em;
  background-color: #fcf8e3;
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}
.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 90%;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 1.125rem;
}

.blockquote-footer {
  display: block;
  font-size: 80%;
  color: #8790a4;
}
.blockquote-footer::before {
  content: "— ";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: #3b414e;
  border: 1px solid #3b414e;
  border-radius: 0.3rem;
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 90%;
  color: #8790a4;
}

code {
  font-size: 87.5%;
  color: #e83e8c;
  word-wrap: break-word;
}
a > code {
  color: inherit;
}

kbd {
  padding: 0.2rem 0.4rem;
  font-size: 87.5%;
  color: #fff;
  background-color: #d6d9e0;
  border-radius: 0.2rem;
}
kbd kbd {
  padding: 0;
  font-size: 100%;
  font-weight: 700;
}

pre {
  display: block;
  font-size: 87.5%;
  color: #d6d9e0;
}
pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

.pre-scrollable {
  max-height: 340px;
  overflow-y: scroll;
}

.container,
.container-fluid,
.container-xl,
.container-lg,
.container-md,
.container-sm {
  width: 100%;
  padding-right: 12px;
  padding-left: 12px;
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container-sm, .container {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .container-md, .container-sm, .container {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .container-lg, .container-md, .container-sm, .container {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .container-xl, .container-lg, .container-md, .container-sm, .container {
    max-width: 1140px;
  }
}
.row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -12px;
  margin-left: -12px;
}

.no-gutters {
  margin-right: 0;
  margin-left: 0;
}
.no-gutters > .col,
.no-gutters > [class*=col-] {
  padding-right: 0;
  padding-left: 0;
}

.col-xl,
.col-xl-auto, .col-xl-12, .col-xl-11, .col-xl-10, .col-xl-9, .col-xl-8, .col-xl-7, .col-xl-6, .col-xl-5, .col-xl-4, .col-xl-3, .col-xl-2, .col-xl-1, .col-lg,
.col-lg-auto, .col-lg-12, .col-lg-11, .col-lg-10, .col-lg-9, .col-lg-8, .col-lg-7, .col-lg-6, .col-lg-5, .col-lg-4, .col-lg-3, .col-lg-2, .col-lg-1, .col-md,
.col-md-auto, .col-md-12, .col-md-11, .col-md-10, .col-md-9, .col-md-8, .col-md-7, .col-md-6, .col-md-5, .col-md-4, .col-md-3, .col-md-2, .col-md-1, .col-sm,
.col-sm-auto, .col-sm-12, .col-sm-11, .col-sm-10, .col-sm-9, .col-sm-8, .col-sm-7, .col-sm-6, .col-sm-5, .col-sm-4, .col-sm-3, .col-sm-2, .col-sm-1, .col,
.col-auto, .col-12, .col-11, .col-10, .col-9, .col-8, .col-7, .col-6, .col-5, .col-4, .col-3, .col-2, .col-1 {
  position: relative;
  width: 100%;
  padding-right: 12px;
  padding-left: 12px;
}

.col {
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
}

.row-cols-1 > * {
  flex: 0 0 100%;
  max-width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 50%;
  max-width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 33.3333333333%;
  max-width: 33.3333333333%;
}

.row-cols-4 > * {
  flex: 0 0 25%;
  max-width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 20%;
  max-width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 16.6666666667%;
  max-width: 16.6666666667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
  max-width: 100%;
}

.col-1 {
  flex: 0 0 8.33333333%;
  max-width: 8.33333333%;
}

.col-2 {
  flex: 0 0 16.66666667%;
  max-width: 16.66666667%;
}

.col-3 {
  flex: 0 0 25%;
  max-width: 25%;
}

.col-4 {
  flex: 0 0 33.33333333%;
  max-width: 33.33333333%;
}

.col-5 {
  flex: 0 0 41.66666667%;
  max-width: 41.66666667%;
}

.col-6 {
  flex: 0 0 50%;
  max-width: 50%;
}

.col-7 {
  flex: 0 0 58.33333333%;
  max-width: 58.33333333%;
}

.col-8 {
  flex: 0 0 66.66666667%;
  max-width: 66.66666667%;
}

.col-9 {
  flex: 0 0 75%;
  max-width: 75%;
}

.col-10 {
  flex: 0 0 83.33333333%;
  max-width: 83.33333333%;
}

.col-11 {
  flex: 0 0 91.66666667%;
  max-width: 91.66666667%;
}

.col-12 {
  flex: 0 0 100%;
  max-width: 100%;
}

.order-first {
  order: -1;
}

.order-last {
  order: 13;
}

.order-0 {
  order: 0;
}

.order-1 {
  order: 1;
}

.order-2 {
  order: 2;
}

.order-3 {
  order: 3;
}

.order-4 {
  order: 4;
}

.order-5 {
  order: 5;
}

.order-6 {
  order: 6;
}

.order-7 {
  order: 7;
}

.order-8 {
  order: 8;
}

.order-9 {
  order: 9;
}

.order-10 {
  order: 10;
}

.order-11 {
  order: 11;
}

.order-12 {
  order: 12;
}

.offset-1 {
  margin-left: 8.33333333%;
}

.offset-2 {
  margin-left: 16.66666667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.33333333%;
}

.offset-5 {
  margin-left: 41.66666667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.33333333%;
}

.offset-8 {
  margin-left: 66.66666667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.33333333%;
}

.offset-11 {
  margin-left: 91.66666667%;
}

@media (min-width: 576px) {
  .col-sm {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .row-cols-sm-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .row-cols-sm-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .row-cols-sm-3 > * {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .row-cols-sm-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .row-cols-sm-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
  }
  .row-cols-sm-6 > * {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  .col-sm-1 {
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .col-sm-2 {
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .col-sm-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .col-sm-5 {
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .col-sm-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .col-sm-8 {
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .col-sm-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .col-sm-11 {
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .col-sm-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-sm-first {
    order: -1;
  }
  .order-sm-last {
    order: 13;
  }
  .order-sm-0 {
    order: 0;
  }
  .order-sm-1 {
    order: 1;
  }
  .order-sm-2 {
    order: 2;
  }
  .order-sm-3 {
    order: 3;
  }
  .order-sm-4 {
    order: 4;
  }
  .order-sm-5 {
    order: 5;
  }
  .order-sm-6 {
    order: 6;
  }
  .order-sm-7 {
    order: 7;
  }
  .order-sm-8 {
    order: 8;
  }
  .order-sm-9 {
    order: 9;
  }
  .order-sm-10 {
    order: 10;
  }
  .order-sm-11 {
    order: 11;
  }
  .order-sm-12 {
    order: 12;
  }
  .offset-sm-0 {
    margin-left: 0;
  }
  .offset-sm-1 {
    margin-left: 8.33333333%;
  }
  .offset-sm-2 {
    margin-left: 16.66666667%;
  }
  .offset-sm-3 {
    margin-left: 25%;
  }
  .offset-sm-4 {
    margin-left: 33.33333333%;
  }
  .offset-sm-5 {
    margin-left: 41.66666667%;
  }
  .offset-sm-6 {
    margin-left: 50%;
  }
  .offset-sm-7 {
    margin-left: 58.33333333%;
  }
  .offset-sm-8 {
    margin-left: 66.66666667%;
  }
  .offset-sm-9 {
    margin-left: 75%;
  }
  .offset-sm-10 {
    margin-left: 83.33333333%;
  }
  .offset-sm-11 {
    margin-left: 91.66666667%;
  }
}
@media (min-width: 768px) {
  .col-md {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .row-cols-md-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .row-cols-md-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .row-cols-md-3 > * {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .row-cols-md-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .row-cols-md-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
  }
  .row-cols-md-6 > * {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  .col-md-1 {
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .col-md-2 {
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .col-md-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-md-4 {
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .col-md-5 {
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .col-md-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-md-7 {
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .col-md-8 {
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .col-md-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-md-10 {
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .col-md-11 {
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .col-md-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-md-first {
    order: -1;
  }
  .order-md-last {
    order: 13;
  }
  .order-md-0 {
    order: 0;
  }
  .order-md-1 {
    order: 1;
  }
  .order-md-2 {
    order: 2;
  }
  .order-md-3 {
    order: 3;
  }
  .order-md-4 {
    order: 4;
  }
  .order-md-5 {
    order: 5;
  }
  .order-md-6 {
    order: 6;
  }
  .order-md-7 {
    order: 7;
  }
  .order-md-8 {
    order: 8;
  }
  .order-md-9 {
    order: 9;
  }
  .order-md-10 {
    order: 10;
  }
  .order-md-11 {
    order: 11;
  }
  .order-md-12 {
    order: 12;
  }
  .offset-md-0 {
    margin-left: 0;
  }
  .offset-md-1 {
    margin-left: 8.33333333%;
  }
  .offset-md-2 {
    margin-left: 16.66666667%;
  }
  .offset-md-3 {
    margin-left: 25%;
  }
  .offset-md-4 {
    margin-left: 33.33333333%;
  }
  .offset-md-5 {
    margin-left: 41.66666667%;
  }
  .offset-md-6 {
    margin-left: 50%;
  }
  .offset-md-7 {
    margin-left: 58.33333333%;
  }
  .offset-md-8 {
    margin-left: 66.66666667%;
  }
  .offset-md-9 {
    margin-left: 75%;
  }
  .offset-md-10 {
    margin-left: 83.33333333%;
  }
  .offset-md-11 {
    margin-left: 91.66666667%;
  }
}
@media (min-width: 992px) {
  .col-lg {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .row-cols-lg-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .row-cols-lg-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .row-cols-lg-3 > * {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .row-cols-lg-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .row-cols-lg-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
  }
  .row-cols-lg-6 > * {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  .col-lg-1 {
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .col-lg-2 {
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .col-lg-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .col-lg-5 {
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .col-lg-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .col-lg-8 {
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .col-lg-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .col-lg-11 {
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .col-lg-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-lg-first {
    order: -1;
  }
  .order-lg-last {
    order: 13;
  }
  .order-lg-0 {
    order: 0;
  }
  .order-lg-1 {
    order: 1;
  }
  .order-lg-2 {
    order: 2;
  }
  .order-lg-3 {
    order: 3;
  }
  .order-lg-4 {
    order: 4;
  }
  .order-lg-5 {
    order: 5;
  }
  .order-lg-6 {
    order: 6;
  }
  .order-lg-7 {
    order: 7;
  }
  .order-lg-8 {
    order: 8;
  }
  .order-lg-9 {
    order: 9;
  }
  .order-lg-10 {
    order: 10;
  }
  .order-lg-11 {
    order: 11;
  }
  .order-lg-12 {
    order: 12;
  }
  .offset-lg-0 {
    margin-left: 0;
  }
  .offset-lg-1 {
    margin-left: 8.33333333%;
  }
  .offset-lg-2 {
    margin-left: 16.66666667%;
  }
  .offset-lg-3 {
    margin-left: 25%;
  }
  .offset-lg-4 {
    margin-left: 33.33333333%;
  }
  .offset-lg-5 {
    margin-left: 41.66666667%;
  }
  .offset-lg-6 {
    margin-left: 50%;
  }
  .offset-lg-7 {
    margin-left: 58.33333333%;
  }
  .offset-lg-8 {
    margin-left: 66.66666667%;
  }
  .offset-lg-9 {
    margin-left: 75%;
  }
  .offset-lg-10 {
    margin-left: 83.33333333%;
  }
  .offset-lg-11 {
    margin-left: 91.66666667%;
  }
}
@media (min-width: 1200px) {
  .col-xl {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .row-cols-xl-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .row-cols-xl-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .row-cols-xl-3 > * {
    flex: 0 0 33.3333333333%;
    max-width: 33.3333333333%;
  }
  .row-cols-xl-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .row-cols-xl-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
  }
  .row-cols-xl-6 > * {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  .col-xl-1 {
    flex: 0 0 8.33333333%;
    max-width: 8.33333333%;
  }
  .col-xl-2 {
    flex: 0 0 16.66666667%;
    max-width: 16.66666667%;
  }
  .col-xl-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 33.33333333%;
    max-width: 33.33333333%;
  }
  .col-xl-5 {
    flex: 0 0 41.66666667%;
    max-width: 41.66666667%;
  }
  .col-xl-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 58.33333333%;
    max-width: 58.33333333%;
  }
  .col-xl-8 {
    flex: 0 0 66.66666667%;
    max-width: 66.66666667%;
  }
  .col-xl-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 83.33333333%;
    max-width: 83.33333333%;
  }
  .col-xl-11 {
    flex: 0 0 91.66666667%;
    max-width: 91.66666667%;
  }
  .col-xl-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-xl-first {
    order: -1;
  }
  .order-xl-last {
    order: 13;
  }
  .order-xl-0 {
    order: 0;
  }
  .order-xl-1 {
    order: 1;
  }
  .order-xl-2 {
    order: 2;
  }
  .order-xl-3 {
    order: 3;
  }
  .order-xl-4 {
    order: 4;
  }
  .order-xl-5 {
    order: 5;
  }
  .order-xl-6 {
    order: 6;
  }
  .order-xl-7 {
    order: 7;
  }
  .order-xl-8 {
    order: 8;
  }
  .order-xl-9 {
    order: 9;
  }
  .order-xl-10 {
    order: 10;
  }
  .order-xl-11 {
    order: 11;
  }
  .order-xl-12 {
    order: 12;
  }
  .offset-xl-0 {
    margin-left: 0;
  }
  .offset-xl-1 {
    margin-left: 8.33333333%;
  }
  .offset-xl-2 {
    margin-left: 16.66666667%;
  }
  .offset-xl-3 {
    margin-left: 25%;
  }
  .offset-xl-4 {
    margin-left: 33.33333333%;
  }
  .offset-xl-5 {
    margin-left: 41.66666667%;
  }
  .offset-xl-6 {
    margin-left: 50%;
  }
  .offset-xl-7 {
    margin-left: 58.33333333%;
  }
  .offset-xl-8 {
    margin-left: 66.66666667%;
  }
  .offset-xl-9 {
    margin-left: 75%;
  }
  .offset-xl-10 {
    margin-left: 83.33333333%;
  }
  .offset-xl-11 {
    margin-left: 91.66666667%;
  }
}
.table {
  width: 100%;
  margin-bottom: 1rem;
  color: #a1a8b8;
}
.table th,
.table td {
  padding: 0.75rem;
  vertical-align: top;
  border-top: 1px solid #3b414e;
}
.table thead th {
  vertical-align: bottom;
  border-bottom: 2px solid #3b414e;
}
.table tbody + tbody {
  border-top: 2px solid #3b414e;
}

.table-sm th,
.table-sm td {
  padding: 0.3rem;
}

.table-bordered {
  border: 1px solid #3b414e;
}
.table-bordered th,
.table-bordered td {
  border: 1px solid #3b414e;
}
.table-bordered thead th,
.table-bordered thead td {
  border-bottom-width: 2px;
}

.table-borderless th,
.table-borderless td,
.table-borderless thead th,
.table-borderless tbody + tbody {
  border: 0;
}

.table-striped tbody tr:nth-of-type(odd) {
  background-color: #3b414e;
}

.table-hover tbody tr:hover {
  color: #a1a8b8;
  background-color: #3b414e;
}

.table-primary,
.table-primary > th,
.table-primary > td {
  background-color: rgb(206.84, 213, 253.04);
}
.table-primary th,
.table-primary td,
.table-primary thead th,
.table-primary tbody + tbody {
  border-color: rgb(165.56, 177, 251.36);
}

.table-hover .table-primary:hover {
  background-color: rgb(182.3372067039, 191.6312849162, 252.0427932961);
}
.table-hover .table-primary:hover > td,
.table-hover .table-primary:hover > th {
  background-color: rgb(182.3372067039, 191.6312849162, 252.0427932961);
}

.table-secondary,
.table-secondary > th,
.table-secondary > td {
  background-color: rgb(195.08, 196.2, 198.72);
}
.table-secondary th,
.table-secondary td,
.table-secondary thead th,
.table-secondary tbody + tbody {
  border-color: rgb(143.72, 145.8, 150.48);
}

.table-hover .table-secondary:hover {
  background-color: rgb(181.9306024096, 183.2963855422, 186.3693975904);
}
.table-hover .table-secondary:hover > td,
.table-hover .table-secondary:hover > th {
  background-color: rgb(181.9306024096, 183.2963855422, 186.3693975904);
}

.table-success,
.table-success > th,
.table-success > td {
  background-color: rgb(202.36, 242.68, 227.84);
}
.table-success th,
.table-success td,
.table-success thead th,
.table-success tbody + tbody {
  border-color: rgb(157.24, 232.12, 204.56);
}

.table-hover .table-success:hover {
  background-color: rgb(181.6962068966, 237.8437931034, 217.178362069);
}
.table-hover .table-success:hover > td,
.table-hover .table-success:hover > th {
  background-color: rgb(181.6962068966, 237.8437931034, 217.178362069);
}

.table-info,
.table-info > th,
.table-info > td {
  background-color: rgb(193.96, 237.92, 247.16);
}
.table-info th,
.table-info td,
.table-info thead th,
.table-info tbody + tbody {
  border-color: rgb(141.64, 223.28, 240.44);
}

.table-hover .table-info:hover {
  background-color: rgb(171.3624390244, 231.5968292683, 244.2575609756);
}
.table-hover .table-info:hover > td,
.table-hover .table-info:hover > th {
  background-color: rgb(171.3624390244, 231.5968292683, 244.2575609756);
}

.table-warning,
.table-warning > th,
.table-warning > td {
  background-color: rgb(255, 236.8, 186.68);
}
.table-warning th,
.table-warning td,
.table-warning thead th,
.table-warning tbody + tbody {
  border-color: rgb(255, 221.2, 128.12);
}

.table-hover .table-warning:hover {
  background-color: rgb(255, 230.0069672131, 161.18);
}
.table-hover .table-warning:hover > td,
.table-hover .table-warning:hover > th {
  background-color: rgb(255, 230.0069672131, 161.18);
}

.table-danger,
.table-danger > th,
.table-danger > td {
  background-color: rgb(255, 209.36, 216.36);
}
.table-danger th,
.table-danger td,
.table-danger thead th,
.table-danger tbody + tbody {
  border-color: rgb(255, 170.24, 183.24);
}

.table-hover .table-danger:hover {
  background-color: rgb(255, 183.86, 194.7710429448);
}
.table-hover .table-danger:hover > td,
.table-hover .table-danger:hover > th {
  background-color: rgb(255, 183.86, 194.7710429448);
}

.table-light,
.table-light > th,
.table-light > td {
  background-color: rgb(200.12, 201.8, 205.44);
}
.table-light th,
.table-light td,
.table-light thead th,
.table-light tbody + tbody {
  border-color: rgb(153.08, 156.2, 162.96);
}

.table-hover .table-light:hover {
  background-color: rgb(186.720536193, 188.8107238606, 193.339463807);
}
.table-hover .table-light:hover > td,
.table-hover .table-light:hover > th {
  background-color: rgb(186.720536193, 188.8107238606, 193.339463807);
}

.table-dark,
.table-dark > th,
.table-dark > td {
  background-color: rgb(236.24, 237.64, 240.72);
}
.table-dark th,
.table-dark td,
.table-dark thead th,
.table-dark tbody + tbody {
  border-color: rgb(220.16, 222.76, 228.48);
}

.table-hover .table-dark:hover {
  background-color: rgb(221.7611864407, 224.2416949153, 229.6988135593);
}
.table-hover .table-dark:hover > td,
.table-hover .table-dark:hover > th {
  background-color: rgb(221.7611864407, 224.2416949153, 229.6988135593);
}

.table-active,
.table-active > th,
.table-active > td {
  background-color: #3b414e;
}

.table-hover .table-active:hover {
  background-color: rgb(48.0182481752, 52.901459854, 63.4817518248);
}
.table-hover .table-active:hover > td,
.table-hover .table-active:hover > th {
  background-color: rgb(48.0182481752, 52.901459854, 63.4817518248);
}

.table .thead-dark th {
  color: #fff;
  background-color: #3b414e;
  border-color: rgb(75.4726277372, 83.147810219, 99.7773722628);
}
.table .thead-light th {
  color: #a1a8b8;
  background-color: #3b414e;
  border-color: #3b414e;
}

.table-dark {
  color: #fff;
  background-color: #3b414e;
}
.table-dark th,
.table-dark td,
.table-dark thead th {
  border-color: rgb(75.4726277372, 83.147810219, 99.7773722628);
}
.table-dark.table-bordered {
  border: 0;
}
.table-dark.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(255, 255, 255, 0.05);
}
.table-dark.table-hover tbody tr:hover {
  color: #fff;
  background-color: rgba(255, 255, 255, 0.075);
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-sm > .table-bordered {
    border: 0;
  }
}
@media (max-width: 767.98px) {
  .table-responsive-md {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-md > .table-bordered {
    border: 0;
  }
}
@media (max-width: 991.98px) {
  .table-responsive-lg {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-lg > .table-bordered {
    border: 0;
  }
}
@media (max-width: 1199.98px) {
  .table-responsive-xl {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-xl > .table-bordered {
    border: 0;
  }
}
.table-responsive {
  display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}
.table-responsive > .table-bordered {
  border: 0;
}

.form-control {
  display: block;
  width: 100%;
  height: calc(1.5em + 0.94rem + 2px);
  padding: 0.47rem 0.75rem;
  font-size: 0.9rem;
  font-weight: 400;
  line-height: 1.5;
  color: #a1a8b8;
  background-color: rgb(54.3965517241, 59.8362068966, 71.8034482759);
  background-clip: padding-box;
  border: 1px solid #3b414e;
  border-radius: 0.3rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}
.form-control::-ms-expand {
  background-color: transparent;
  border: 0;
}
.form-control:focus {
  color: #a1a8b8;
  background-color: rgb(56.5948275862, 62.2543103448, 74.7051724138);
  border-color: rgb(63.3927007299, 69.8394160584, 83.8072992701);
  outline: 0;
  box-shadow: none;
}
.form-control::placeholder {
  color: #8790a4;
  opacity: 1;
}
.form-control:disabled, .form-control[readonly] {
  background-color: rgb(52.1982758621, 57.4181034483, 68.9017241379);
  opacity: 1;
}

input[type=date].form-control,
input[type=time].form-control,
input[type=datetime-local].form-control,
input[type=month].form-control {
  appearance: none;
}

select.form-control:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #a1a8b8;
}
select.form-control:focus::-ms-value {
  color: #a1a8b8;
  background-color: rgb(54.3965517241, 59.8362068966, 71.8034482759);
}

.form-control-file,
.form-control-range {
  display: block;
  width: 100%;
}

.col-form-label {
  padding-top: calc(0.47rem + 1px);
  padding-bottom: calc(0.47rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5;
}

.col-form-label-lg {
  padding-top: calc(0.5rem + 1px);
  padding-bottom: calc(0.5rem + 1px);
  font-size: 1.125rem;
  line-height: 1.5;
}

.col-form-label-sm {
  padding-top: calc(0.25rem + 1px);
  padding-bottom: calc(0.25rem + 1px);
  font-size: 0.7875rem;
  line-height: 1.5;
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.47rem 0;
  margin-bottom: 0;
  font-size: 0.9rem;
  line-height: 1.5;
  color: #a1a8b8;
  background-color: transparent;
  border: solid transparent;
  border-width: 1px 0;
}
.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  height: calc(1.5em + 0.5rem + 2px);
  padding: 0.25rem 0.5rem;
  font-size: 0.7875rem;
  line-height: 1.5;
  border-radius: 0.2rem;
}

.form-control-lg {
  height: calc(1.5em + 1rem + 2px);
  padding: 0.5rem 1rem;
  font-size: 1.125rem;
  line-height: 1.5;
  border-radius: 0.5rem;
}

select.form-control[size], select.form-control[multiple] {
  height: auto;
}

textarea.form-control {
  height: auto;
}

.form-group {
  margin-bottom: 1rem;
}

.form-text {
  display: block;
  margin-top: 0.25rem;
}

.form-row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -5px;
  margin-left: -5px;
}
.form-row > .col,
.form-row > [class*=col-] {
  padding-right: 5px;
  padding-left: 5px;
}

.form-check {
  position: relative;
  display: block;
  padding-left: 1.25rem;
}

.form-check-input {
  position: absolute;
  margin-top: 0.3rem;
  margin-left: -1.25rem;
}
.form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
  color: #6b768d;
}

.form-check-label {
  margin-bottom: 0;
}

.form-check-inline {
  display: inline-flex;
  align-items: center;
  padding-left: 0;
  margin-right: 0.75rem;
}
.form-check-inline .form-check-input {
  position: static;
  margin-top: 0;
  margin-right: 0.3125rem;
  margin-left: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #43d39e;
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.7875rem;
  line-height: 1.5;
  color: #d6d9e0;
  background-color: rgba(67, 211, 158, 0.9);
  border-radius: 0.3rem;
}
.form-row > .col > .valid-tooltip, .form-row > [class*=col-] > .valid-tooltip {
  left: 5px;
}

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: #43d39e;
  padding-right: calc(1.5em + 0.94rem) !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.235rem) center;
  background-size: calc(0.75em + 0.47rem) calc(0.75em + 0.47rem);
}
.was-validated .form-control:valid:focus, .form-control.is-valid:focus {
  border-color: #43d39e;
  box-shadow: 0 0 0 0.15rem rgba(67, 211, 158, 0.25);
}

.was-validated select.form-control:valid, select.form-control.is-valid {
  padding-right: 3rem !important;
  background-position: right 1.5rem center;
}

.was-validated textarea.form-control:valid, textarea.form-control.is-valid {
  padding-right: calc(1.5em + 0.94rem);
  background-position: top calc(0.375em + 0.235rem) right calc(0.375em + 0.235rem);
}

.was-validated .custom-select:valid, .custom-select.is-valid {
  border-color: #43d39e;
  padding-right: calc((1em + 0.94rem) * 3 / 4 + 1.75rem) !important;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat right 0.75rem center/8px 10px, rgb(54.3965517241, 59.8362068966, 71.8034482759) url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center right 1.75rem/calc(0.75em + 0.47rem) calc(0.75em + 0.47rem) no-repeat;
}
.was-validated .custom-select:valid:focus, .custom-select.is-valid:focus {
  border-color: #43d39e;
  box-shadow: 0 0 0 0.15rem rgba(67, 211, 158, 0.25);
}

.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: #43d39e;
}
.was-validated .form-check-input:valid ~ .valid-feedback,
.was-validated .form-check-input:valid ~ .valid-tooltip, .form-check-input.is-valid ~ .valid-feedback,
.form-check-input.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .custom-control-input:valid ~ .custom-control-label, .custom-control-input.is-valid ~ .custom-control-label {
  color: #43d39e;
}
.was-validated .custom-control-input:valid ~ .custom-control-label::before, .custom-control-input.is-valid ~ .custom-control-label::before {
  border-color: #43d39e;
}
.was-validated .custom-control-input:valid:checked ~ .custom-control-label::before, .custom-control-input.is-valid:checked ~ .custom-control-label::before {
  border-color: rgb(108.3275862069, 220.6724137931, 179.3232758621);
  background-color: rgb(108.3275862069, 220.6724137931, 179.3232758621);
}
.was-validated .custom-control-input:valid:focus ~ .custom-control-label::before, .custom-control-input.is-valid:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.15rem rgba(67, 211, 158, 0.25);
}
.was-validated .custom-control-input:valid:focus:not(:checked) ~ .custom-control-label::before, .custom-control-input.is-valid:focus:not(:checked) ~ .custom-control-label::before {
  border-color: #43d39e;
}

.was-validated .custom-file-input:valid ~ .custom-file-label, .custom-file-input.is-valid ~ .custom-file-label {
  border-color: #43d39e;
}
.was-validated .custom-file-input:valid:focus ~ .custom-file-label, .custom-file-input.is-valid:focus ~ .custom-file-label {
  border-color: #43d39e;
  box-shadow: 0 0 0 0.15rem rgba(67, 211, 158, 0.25);
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #ff5c75;
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.7875rem;
  line-height: 1.5;
  color: #fff;
  background-color: rgba(255, 92, 117, 0.9);
  border-radius: 0.3rem;
}
.form-row > .col > .invalid-tooltip, .form-row > [class*=col-] > .invalid-tooltip {
  left: 5px;
}

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: #ff5c75;
  padding-right: calc(1.5em + 0.94rem) !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.235rem) center;
  background-size: calc(0.75em + 0.47rem) calc(0.75em + 0.47rem);
}
.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
  border-color: #ff5c75;
  box-shadow: 0 0 0 0.15rem rgba(255, 92, 117, 0.25);
}

.was-validated select.form-control:invalid, select.form-control.is-invalid {
  padding-right: 3rem !important;
  background-position: right 1.5rem center;
}

.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 0.94rem);
  background-position: top calc(0.375em + 0.235rem) right calc(0.375em + 0.235rem);
}

.was-validated .custom-select:invalid, .custom-select.is-invalid {
  border-color: #ff5c75;
  padding-right: calc((1em + 0.94rem) * 3 / 4 + 1.75rem) !important;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat right 0.75rem center/8px 10px, rgb(54.3965517241, 59.8362068966, 71.8034482759) url(${___CSS_LOADER_URL_REPLACEMENT_2___}) center right 1.75rem/calc(0.75em + 0.47rem) calc(0.75em + 0.47rem) no-repeat;
}
.was-validated .custom-select:invalid:focus, .custom-select.is-invalid:focus {
  border-color: #ff5c75;
  box-shadow: 0 0 0 0.15rem rgba(255, 92, 117, 0.25);
}

.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: #ff5c75;
}
.was-validated .form-check-input:invalid ~ .invalid-feedback,
.was-validated .form-check-input:invalid ~ .invalid-tooltip, .form-check-input.is-invalid ~ .invalid-feedback,
.form-check-input.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .custom-control-input:invalid ~ .custom-control-label, .custom-control-input.is-invalid ~ .custom-control-label {
  color: #ff5c75;
}
.was-validated .custom-control-input:invalid ~ .custom-control-label::before, .custom-control-input.is-invalid ~ .custom-control-label::before {
  border-color: #ff5c75;
}
.was-validated .custom-control-input:invalid:checked ~ .custom-control-label::before, .custom-control-input.is-invalid:checked ~ .custom-control-label::before {
  border-color: rgb(255, 143, 160.1779141104);
  background-color: rgb(255, 143, 160.1779141104);
}
.was-validated .custom-control-input:invalid:focus ~ .custom-control-label::before, .custom-control-input.is-invalid:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.15rem rgba(255, 92, 117, 0.25);
}
.was-validated .custom-control-input:invalid:focus:not(:checked) ~ .custom-control-label::before, .custom-control-input.is-invalid:focus:not(:checked) ~ .custom-control-label::before {
  border-color: #ff5c75;
}

.was-validated .custom-file-input:invalid ~ .custom-file-label, .custom-file-input.is-invalid ~ .custom-file-label {
  border-color: #ff5c75;
}
.was-validated .custom-file-input:invalid:focus ~ .custom-file-label, .custom-file-input.is-invalid:focus ~ .custom-file-label {
  border-color: #ff5c75;
  box-shadow: 0 0 0 0.15rem rgba(255, 92, 117, 0.25);
}

.form-inline {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
}
.form-inline .form-check {
  width: 100%;
}
@media (min-width: 576px) {
  .form-inline label {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0;
  }
  .form-inline .form-group {
    display: flex;
    flex: 0 0 auto;
    flex-flow: row wrap;
    align-items: center;
    margin-bottom: 0;
  }
  .form-inline .form-control {
    display: inline-block;
    width: auto;
    vertical-align: middle;
  }
  .form-inline .form-control-plaintext {
    display: inline-block;
  }
  .form-inline .input-group,
  .form-inline .custom-select {
    width: auto;
  }
  .form-inline .form-check {
    display: flex;
    align-items: center;
    justify-content: center;
    width: auto;
    padding-left: 0;
  }
  .form-inline .form-check-input {
    position: relative;
    flex-shrink: 0;
    margin-top: 0;
    margin-right: 0.25rem;
    margin-left: 0;
  }
  .form-inline .custom-control {
    align-items: center;
    justify-content: center;
  }
  .form-inline .custom-control-label {
    margin-bottom: 0;
  }
}

.btn {
  display: inline-block;
  font-weight: 400;
  color: #a1a8b8;
  text-align: center;
  vertical-align: middle;
  user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.47rem 0.75rem;
  font-size: 0.9rem;
  line-height: 1.5;
  border-radius: 0.3rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}
.btn:hover {
  color: #a1a8b8;
  text-decoration: none;
}
.btn:focus, .btn.focus {
  outline: 0;
  box-shadow: 0 0 0 0.15rem rgba(83, 105, 248, 0.25);
}
.btn.disabled, .btn:disabled {
  opacity: 0.65;
}
.btn:not(:disabled):not(.disabled) {
  cursor: pointer;
}
a.btn.disabled,
fieldset:disabled a.btn {
  pointer-events: none;
}

.btn-primary {
  color: #fff;
  background-color: #5369f8;
  border-color: #5369f8;
}
.btn-primary:hover {
  color: #fff;
  background-color: rgb(46.2458100559, 72.9469273743, 246.5041899441);
  border-color: rgb(33.9944134078, 62.2625698324, 246.0055865922);
}
.btn-primary:focus, .btn-primary.focus {
  color: #fff;
  background-color: rgb(46.2458100559, 72.9469273743, 246.5041899441);
  border-color: rgb(33.9944134078, 62.2625698324, 246.0055865922);
  box-shadow: 0 0 0 0.15rem rgba(108.8, 127.5, 249.05, 0.5);
}
.btn-primary.disabled, .btn-primary:disabled {
  color: #fff;
  background-color: #5369f8;
  border-color: #5369f8;
}
.btn-primary:not(:disabled):not(.disabled):active, .btn-primary:not(:disabled):not(.disabled).active, .show > .btn-primary.dropdown-toggle {
  color: #fff;
  background-color: rgb(33.9944134078, 62.2625698324, 246.0055865922);
  border-color: rgb(21.7430167598, 51.5782122905, 245.5069832402);
}
.btn-primary:not(:disabled):not(.disabled):active:focus, .btn-primary:not(:disabled):not(.disabled).active:focus, .show > .btn-primary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.15rem rgba(108.8, 127.5, 249.05, 0.5);
}

.btn-secondary {
  color: #fff;
  background-color: #292d36;
  border-color: #292d36;
}
.btn-secondary:hover {
  color: #fff;
  background-color: rgb(24.4921052632, 26.8815789474, 32.2578947368);
  border-color: rgb(18.9894736842, 20.8421052632, 25.0105263158);
}
.btn-secondary:focus, .btn-secondary.focus {
  color: #fff;
  background-color: rgb(24.4921052632, 26.8815789474, 32.2578947368);
  border-color: rgb(18.9894736842, 20.8421052632, 25.0105263158);
  box-shadow: 0 0 0 0.15rem rgba(73.1, 76.5, 84.15, 0.5);
}
.btn-secondary.disabled, .btn-secondary:disabled {
  color: #fff;
  background-color: #292d36;
  border-color: #292d36;
}
.btn-secondary:not(:disabled):not(.disabled):active, .btn-secondary:not(:disabled):not(.disabled).active, .show > .btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: rgb(18.9894736842, 20.8421052632, 25.0105263158);
  border-color: rgb(13.4868421053, 14.8026315789, 17.7631578947);
}
.btn-secondary:not(:disabled):not(.disabled):active:focus, .btn-secondary:not(:disabled):not(.disabled).active:focus, .show > .btn-secondary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.15rem rgba(73.1, 76.5, 84.15, 0.5);
}

.btn-success {
  color: #d6d9e0;
  background-color: #43d39e;
  border-color: #43d39e;
}
.btn-success:hover {
  color: #fff;
  background-color: rgb(45.4698275862, 194.2801724138, 139.5096982759);
  border-color: rgb(43.0517241379, 183.9482758621, 132.0905172414);
}
.btn-success:focus, .btn-success.focus {
  color: #fff;
  background-color: rgb(45.4698275862, 194.2801724138, 139.5096982759);
  border-color: rgb(43.0517241379, 183.9482758621, 132.0905172414);
  box-shadow: 0 0 0 0.15rem rgba(89.05, 211.9, 167.9, 0.5);
}
.btn-success.disabled, .btn-success:disabled {
  color: #d6d9e0;
  background-color: #43d39e;
  border-color: #43d39e;
}
.btn-success:not(:disabled):not(.disabled):active, .btn-success:not(:disabled):not(.disabled).active, .show > .btn-success.dropdown-toggle {
  color: #fff;
  background-color: rgb(43.0517241379, 183.9482758621, 132.0905172414);
  border-color: rgb(40.6336206897, 173.6163793103, 124.6713362069);
}
.btn-success:not(:disabled):not(.disabled):active:focus, .btn-success:not(:disabled):not(.disabled).active:focus, .show > .btn-success.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.15rem rgba(89.05, 211.9, 167.9, 0.5);
}

.btn-info {
  color: #d6d9e0;
  background-color: #25c2e3;
  border-color: #25c2e3;
}
.btn-info:hover {
  color: #fff;
  background-color: rgb(25.6951219512, 169.7713414634, 200.0548780488);
  border-color: rgb(24.243902439, 160.1829268293, 188.756097561);
}
.btn-info:focus, .btn-info.focus {
  color: #fff;
  background-color: rgb(25.6951219512, 169.7713414634, 200.0548780488);
  border-color: rgb(24.243902439, 160.1829268293, 188.756097561);
  box-shadow: 0 0 0 0.15rem rgba(63.55, 197.45, 226.55, 0.5);
}
.btn-info.disabled, .btn-info:disabled {
  color: #d6d9e0;
  background-color: #25c2e3;
  border-color: #25c2e3;
}
.btn-info:not(:disabled):not(.disabled):active, .btn-info:not(:disabled):not(.disabled).active, .show > .btn-info.dropdown-toggle {
  color: #fff;
  background-color: rgb(24.243902439, 160.1829268293, 188.756097561);
  border-color: rgb(22.7926829268, 150.5945121951, 177.4573170732);
}
.btn-info:not(:disabled):not(.disabled):active:focus, .btn-info:not(:disabled):not(.disabled).active:focus, .show > .btn-info.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.15rem rgba(63.55, 197.45, 226.55, 0.5);
}

.btn-warning {
  color: #d6d9e0;
  background-color: #ffbe0b;
  border-color: #ffbe0b;
}
.btn-warning:hover {
  color: #d6d9e0;
  background-color: rgb(227.75, 167.0788934426, 0);
  border-color: rgb(215, 157.7254098361, 0);
}
.btn-warning:focus, .btn-warning.focus {
  color: #d6d9e0;
  background-color: rgb(227.75, 167.0788934426, 0);
  border-color: rgb(215, 157.7254098361, 0);
  box-shadow: 0 0 0 0.15rem rgba(248.85, 194.05, 42.95, 0.5);
}
.btn-warning.disabled, .btn-warning:disabled {
  color: #d6d9e0;
  background-color: #ffbe0b;
  border-color: #ffbe0b;
}
.btn-warning:not(:disabled):not(.disabled):active, .btn-warning:not(:disabled):not(.disabled).active, .show > .btn-warning.dropdown-toggle {
  color: #d6d9e0;
  background-color: rgb(215, 157.7254098361, 0);
  border-color: rgb(202.25, 148.3719262295, 0);
}
.btn-warning:not(:disabled):not(.disabled):active:focus, .btn-warning:not(:disabled):not(.disabled).active:focus, .show > .btn-warning.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.15rem rgba(248.85, 194.05, 42.95, 0.5);
}

.btn-danger {
  color: #fff;
  background-color: #ff5c75;
  border-color: #ff5c75;
}
.btn-danger:hover {
  color: #fff;
  background-color: rgb(255, 53.75, 84.6165644172);
  border-color: rgb(255, 41, 73.8220858896);
}
.btn-danger:focus, .btn-danger.focus {
  color: #fff;
  background-color: rgb(255, 53.75, 84.6165644172);
  border-color: rgb(255, 41, 73.8220858896);
  box-shadow: 0 0 0 0.15rem rgba(255, 116.45, 137.7, 0.5);
}
.btn-danger.disabled, .btn-danger:disabled {
  color: #fff;
  background-color: #ff5c75;
  border-color: #ff5c75;
}
.btn-danger:not(:disabled):not(.disabled):active, .btn-danger:not(:disabled):not(.disabled).active, .show > .btn-danger.dropdown-toggle {
  color: #fff;
  background-color: rgb(255, 41, 73.8220858896);
  border-color: rgb(255, 28.25, 63.027607362);
}
.btn-danger:not(:disabled):not(.disabled):active:focus, .btn-danger:not(:disabled):not(.disabled).active:focus, .show > .btn-danger.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.15rem rgba(255, 116.45, 137.7, 0.5);
}

.btn-light {
  color: #fff;
  background-color: #3b414e;
  border-color: #3b414e;
}
.btn-light:hover {
  color: #fff;
  background-color: rgb(42.5273722628, 46.852189781, 56.2226277372);
  border-color: rgb(37.0364963504, 40.802919708, 48.9635036496);
}
.btn-light:focus, .btn-light.focus {
  color: #fff;
  background-color: rgb(42.5273722628, 46.852189781, 56.2226277372);
  border-color: rgb(37.0364963504, 40.802919708, 48.9635036496);
  box-shadow: 0 0 0 0.15rem rgba(88.4, 93.5, 104.55, 0.5);
}
.btn-light.disabled, .btn-light:disabled {
  color: #fff;
  background-color: #3b414e;
  border-color: #3b414e;
}
.btn-light:not(:disabled):not(.disabled):active, .btn-light:not(:disabled):not(.disabled).active, .show > .btn-light.dropdown-toggle {
  color: #fff;
  background-color: rgb(37.0364963504, 40.802919708, 48.9635036496);
  border-color: rgb(31.545620438, 34.753649635, 41.704379562);
}
.btn-light:not(:disabled):not(.disabled):active:focus, .btn-light:not(:disabled):not(.disabled).active:focus, .show > .btn-light.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.15rem rgba(88.4, 93.5, 104.55, 0.5);
}

.btn-dark {
  color: #d6d9e0;
  background-color: #bcc1cc;
  border-color: #bcc1cc;
}
.btn-dark:hover {
  color: #d6d9e0;
  background-color: rgb(166.281779661, 172.9025423729, 187.468220339);
  border-color: rgb(159.0423728814, 166.2033898305, 181.9576271186);
}
.btn-dark:focus, .btn-dark.focus {
  color: #d6d9e0;
  background-color: rgb(166.281779661, 172.9025423729, 187.468220339);
  border-color: rgb(159.0423728814, 166.2033898305, 181.9576271186);
  box-shadow: 0 0 0 0.15rem rgba(191.9, 196.6, 207, 0.5);
}
.btn-dark.disabled, .btn-dark:disabled {
  color: #d6d9e0;
  background-color: #bcc1cc;
  border-color: #bcc1cc;
}
.btn-dark:not(:disabled):not(.disabled):active, .btn-dark:not(:disabled):not(.disabled).active, .show > .btn-dark.dropdown-toggle {
  color: #d6d9e0;
  background-color: rgb(159.0423728814, 166.2033898305, 181.9576271186);
  border-color: rgb(151.8029661017, 159.5042372881, 176.4470338983);
}
.btn-dark:not(:disabled):not(.disabled):active:focus, .btn-dark:not(:disabled):not(.disabled).active:focus, .show > .btn-dark.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.15rem rgba(191.9, 196.6, 207, 0.5);
}

.btn-outline-primary {
  color: #5369f8;
  border-color: #5369f8;
}
.btn-outline-primary:hover {
  color: #fff;
  background-color: #5369f8;
  border-color: #5369f8;
}
.btn-outline-primary:focus, .btn-outline-primary.focus {
  box-shadow: 0 0 0 0.15rem rgba(83, 105, 248, 0.5);
}
.btn-outline-primary.disabled, .btn-outline-primary:disabled {
  color: #5369f8;
  background-color: transparent;
}
.btn-outline-primary:not(:disabled):not(.disabled):active, .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .btn-outline-primary.dropdown-toggle {
  color: #fff;
  background-color: #5369f8;
  border-color: #5369f8;
}
.btn-outline-primary:not(:disabled):not(.disabled):active:focus, .btn-outline-primary:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-primary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.15rem rgba(83, 105, 248, 0.5);
}

.btn-outline-secondary {
  color: #292d36;
  border-color: #292d36;
}
.btn-outline-secondary:hover {
  color: #fff;
  background-color: #292d36;
  border-color: #292d36;
}
.btn-outline-secondary:focus, .btn-outline-secondary.focus {
  box-shadow: 0 0 0 0.15rem rgba(41, 45, 54, 0.5);
}
.btn-outline-secondary.disabled, .btn-outline-secondary:disabled {
  color: #292d36;
  background-color: transparent;
}
.btn-outline-secondary:not(:disabled):not(.disabled):active, .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .btn-outline-secondary.dropdown-toggle {
  color: #fff;
  background-color: #292d36;
  border-color: #292d36;
}
.btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .btn-outline-secondary:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-secondary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.15rem rgba(41, 45, 54, 0.5);
}

.btn-outline-success {
  color: #43d39e;
  border-color: #43d39e;
}
.btn-outline-success:hover {
  color: #d6d9e0;
  background-color: #43d39e;
  border-color: #43d39e;
}
.btn-outline-success:focus, .btn-outline-success.focus {
  box-shadow: 0 0 0 0.15rem rgba(67, 211, 158, 0.5);
}
.btn-outline-success.disabled, .btn-outline-success:disabled {
  color: #43d39e;
  background-color: transparent;
}
.btn-outline-success:not(:disabled):not(.disabled):active, .btn-outline-success:not(:disabled):not(.disabled).active, .show > .btn-outline-success.dropdown-toggle {
  color: #d6d9e0;
  background-color: #43d39e;
  border-color: #43d39e;
}
.btn-outline-success:not(:disabled):not(.disabled):active:focus, .btn-outline-success:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-success.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.15rem rgba(67, 211, 158, 0.5);
}

.btn-outline-info {
  color: #25c2e3;
  border-color: #25c2e3;
}
.btn-outline-info:hover {
  color: #d6d9e0;
  background-color: #25c2e3;
  border-color: #25c2e3;
}
.btn-outline-info:focus, .btn-outline-info.focus {
  box-shadow: 0 0 0 0.15rem rgba(37, 194, 227, 0.5);
}
.btn-outline-info.disabled, .btn-outline-info:disabled {
  color: #25c2e3;
  background-color: transparent;
}
.btn-outline-info:not(:disabled):not(.disabled):active, .btn-outline-info:not(:disabled):not(.disabled).active, .show > .btn-outline-info.dropdown-toggle {
  color: #d6d9e0;
  background-color: #25c2e3;
  border-color: #25c2e3;
}
.btn-outline-info:not(:disabled):not(.disabled):active:focus, .btn-outline-info:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-info.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.15rem rgba(37, 194, 227, 0.5);
}

.btn-outline-warning {
  color: #ffbe0b;
  border-color: #ffbe0b;
}
.btn-outline-warning:hover {
  color: #d6d9e0;
  background-color: #ffbe0b;
  border-color: #ffbe0b;
}
.btn-outline-warning:focus, .btn-outline-warning.focus {
  box-shadow: 0 0 0 0.15rem rgba(255, 190, 11, 0.5);
}
.btn-outline-warning.disabled, .btn-outline-warning:disabled {
  color: #ffbe0b;
  background-color: transparent;
}
.btn-outline-warning:not(:disabled):not(.disabled):active, .btn-outline-warning:not(:disabled):not(.disabled).active, .show > .btn-outline-warning.dropdown-toggle {
  color: #d6d9e0;
  background-color: #ffbe0b;
  border-color: #ffbe0b;
}
.btn-outline-warning:not(:disabled):not(.disabled):active:focus, .btn-outline-warning:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-warning.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.15rem rgba(255, 190, 11, 0.5);
}

.btn-outline-danger {
  color: #ff5c75;
  border-color: #ff5c75;
}
.btn-outline-danger:hover {
  color: #fff;
  background-color: #ff5c75;
  border-color: #ff5c75;
}
.btn-outline-danger:focus, .btn-outline-danger.focus {
  box-shadow: 0 0 0 0.15rem rgba(255, 92, 117, 0.5);
}
.btn-outline-danger.disabled, .btn-outline-danger:disabled {
  color: #ff5c75;
  background-color: transparent;
}
.btn-outline-danger:not(:disabled):not(.disabled):active, .btn-outline-danger:not(:disabled):not(.disabled).active, .show > .btn-outline-danger.dropdown-toggle {
  color: #fff;
  background-color: #ff5c75;
  border-color: #ff5c75;
}
.btn-outline-danger:not(:disabled):not(.disabled):active:focus, .btn-outline-danger:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-danger.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.15rem rgba(255, 92, 117, 0.5);
}

.btn-outline-light {
  color: #3b414e;
  border-color: #3b414e;
}
.btn-outline-light:hover {
  color: #fff;
  background-color: #3b414e;
  border-color: #3b414e;
}
.btn-outline-light:focus, .btn-outline-light.focus {
  box-shadow: 0 0 0 0.15rem rgba(59, 65, 78, 0.5);
}
.btn-outline-light.disabled, .btn-outline-light:disabled {
  color: #3b414e;
  background-color: transparent;
}
.btn-outline-light:not(:disabled):not(.disabled):active, .btn-outline-light:not(:disabled):not(.disabled).active, .show > .btn-outline-light.dropdown-toggle {
  color: #fff;
  background-color: #3b414e;
  border-color: #3b414e;
}
.btn-outline-light:not(:disabled):not(.disabled):active:focus, .btn-outline-light:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-light.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.15rem rgba(59, 65, 78, 0.5);
}

.btn-outline-dark {
  color: #bcc1cc;
  border-color: #bcc1cc;
}
.btn-outline-dark:hover {
  color: #d6d9e0;
  background-color: #bcc1cc;
  border-color: #bcc1cc;
}
.btn-outline-dark:focus, .btn-outline-dark.focus {
  box-shadow: 0 0 0 0.15rem rgba(188, 193, 204, 0.5);
}
.btn-outline-dark.disabled, .btn-outline-dark:disabled {
  color: #bcc1cc;
  background-color: transparent;
}
.btn-outline-dark:not(:disabled):not(.disabled):active, .btn-outline-dark:not(:disabled):not(.disabled).active, .show > .btn-outline-dark.dropdown-toggle {
  color: #d6d9e0;
  background-color: #bcc1cc;
  border-color: #bcc1cc;
}
.btn-outline-dark:not(:disabled):not(.disabled):active:focus, .btn-outline-dark:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-dark.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.15rem rgba(188, 193, 204, 0.5);
}

.btn-link {
  font-weight: 400;
  color: #5369f8;
  text-decoration: none;
}
.btn-link:hover {
  color: rgb(9.9525139665, 41.2318435754, 244.5474860335);
  text-decoration: underline;
}
.btn-link:focus, .btn-link.focus {
  text-decoration: underline;
}
.btn-link:disabled, .btn-link.disabled {
  color: #8790a4;
  pointer-events: none;
}

.btn-lg, .btn-group-lg > .btn {
  padding: 0.5rem 1rem;
  font-size: 1.125rem;
  line-height: 1.5;
  border-radius: 0.5rem;
}

.btn-sm, .btn-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.7875rem;
  line-height: 1.5;
  border-radius: 0.2rem;
}

.btn-block {
  display: block;
  width: 100%;
}
.btn-block + .btn-block {
  margin-top: 0.5rem;
}

input[type=submit].btn-block,
input[type=reset].btn-block,
input[type=button].btn-block {
  width: 100%;
}

.fade {
  transition: opacity 0.15s linear;
}
@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}
.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  position: relative;
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}
.collapsing.width {
  width: 0;
  height: auto;
  transition: width 0.35s ease;
}
@media (prefers-reduced-motion: reduce) {
  .collapsing.width {
    transition: none;
  }
}

.dropup,
.dropright,
.dropdown,
.dropleft {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  display: none;
  float: left;
  min-width: 10rem;
  padding: 0.5rem 0;
  margin: 0.125rem 0 0;
  font-size: 0.9rem;
  color: #a1a8b8;
  text-align: left;
  list-style: none;
  background-color: #323742;
  background-clip: padding-box;
  border: 1px solid rgb(58.7931034483, 64.6724137931, 77.6068965517);
  border-radius: 0.3rem;
}

.dropdown-menu-left {
  right: auto;
  left: 0;
}

.dropdown-menu-right {
  right: 0;
  left: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-left {
    right: auto;
    left: 0;
  }
  .dropdown-menu-sm-right {
    right: 0;
    left: auto;
  }
}
@media (min-width: 768px) {
  .dropdown-menu-md-left {
    right: auto;
    left: 0;
  }
  .dropdown-menu-md-right {
    right: 0;
    left: auto;
  }
}
@media (min-width: 992px) {
  .dropdown-menu-lg-left {
    right: auto;
    left: 0;
  }
  .dropdown-menu-lg-right {
    right: 0;
    left: auto;
  }
}
@media (min-width: 1200px) {
  .dropdown-menu-xl-left {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xl-right {
    right: 0;
    left: auto;
  }
}
.dropup .dropdown-menu {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: 0.125rem;
}
.dropright .dropdown-menu {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: 0.125rem;
}
.dropright .dropdown-toggle::after {
  vertical-align: 0;
}

.dropleft .dropdown-menu {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: 0.125rem;
}
.dropleft .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-menu[x-placement^=top], .dropdown-menu[x-placement^=right], .dropdown-menu[x-placement^=bottom], .dropdown-menu[x-placement^=left] {
  right: auto;
  bottom: auto;
}

.dropdown-divider {
  height: 0;
  margin: 0.5rem 0;
  overflow: hidden;
  border-top: 1px solid #323742;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: 0.35rem 1.5rem;
  clear: both;
  font-weight: 400;
  color: #d6d9e0;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
}
.dropdown-item:hover, .dropdown-item:focus {
  color: rgb(228.5208333333, 230.4583333333, 234.9791666667);
  text-decoration: none;
  background-color: #3b414e;
}
.dropdown-item.active, .dropdown-item:active {
  color: rgb(228.5208333333, 230.4583333333, 234.9791666667);
  text-decoration: none;
  background-color: #3b414e;
}
.dropdown-item.disabled, .dropdown-item:disabled {
  color: #8790a4;
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: 0.5rem 1.5rem;
  margin-bottom: 0;
  font-size: 0.7875rem;
  color: #8790a4;
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: 0.35rem 1.5rem;
  color: #d6d9e0;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}
.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}
.btn-group > .btn:hover,
.btn-group-vertical > .btn:hover {
  z-index: 1;
}
.btn-group > .btn:focus, .btn-group > .btn:active, .btn-group > .btn.active,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.btn-toolbar .input-group {
  width: auto;
}

.btn-group > .btn:not(:first-child),
.btn-group > .btn-group:not(:first-child) {
  margin-left: -1px;
}
.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.btn-group > .btn:not(:first-child),
.btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 0.5625rem;
  padding-left: 0.5625rem;
}
.dropdown-toggle-split::after, .dropup .dropdown-toggle-split::after, .dropright .dropdown-toggle-split::after {
  margin-left: 0;
}
.dropleft .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: -1px;
}
.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.btn-group-toggle > .btn,
.btn-group-toggle > .btn-group > .btn {
  margin-bottom: 0;
}
.btn-group-toggle > .btn input[type=radio],
.btn-group-toggle > .btn input[type=checkbox],
.btn-group-toggle > .btn-group > .btn input[type=radio],
.btn-group-toggle > .btn-group > .btn input[type=checkbox] {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}
.input-group > .form-control,
.input-group > .form-control-plaintext,
.input-group > .custom-select,
.input-group > .custom-file {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
  margin-bottom: 0;
}
.input-group > .form-control + .form-control,
.input-group > .form-control + .custom-select,
.input-group > .form-control + .custom-file,
.input-group > .form-control-plaintext + .form-control,
.input-group > .form-control-plaintext + .custom-select,
.input-group > .form-control-plaintext + .custom-file,
.input-group > .custom-select + .form-control,
.input-group > .custom-select + .custom-select,
.input-group > .custom-select + .custom-file,
.input-group > .custom-file + .form-control,
.input-group > .custom-file + .custom-select,
.input-group > .custom-file + .custom-file {
  margin-left: -1px;
}
.input-group > .form-control:focus,
.input-group > .custom-select:focus,
.input-group > .custom-file .custom-file-input:focus ~ .custom-file-label {
  z-index: 3;
}
.input-group > .custom-file .custom-file-input:focus {
  z-index: 4;
}
.input-group > .form-control:not(:first-child),
.input-group > .custom-select:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group > .custom-file {
  display: flex;
  align-items: center;
}
.input-group > .custom-file:not(:last-child) .custom-file-label, .input-group > .custom-file:not(:last-child) .custom-file-label::after {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group > .custom-file:not(:first-child) .custom-file-label {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
.input-group:not(.has-validation) > .form-control:not(:last-child),
.input-group:not(.has-validation) > .custom-select:not(:last-child),
.input-group:not(.has-validation) > .custom-file:not(:last-child) .custom-file-label,
.input-group:not(.has-validation) > .custom-file:not(:last-child) .custom-file-label::after {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.input-group.has-validation > .form-control:nth-last-child(n+3),
.input-group.has-validation > .custom-select:nth-last-child(n+3),
.input-group.has-validation > .custom-file:nth-last-child(n+3) .custom-file-label,
.input-group.has-validation > .custom-file:nth-last-child(n+3) .custom-file-label::after {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group-prepend,
.input-group-append {
  display: flex;
}
.input-group-prepend .btn,
.input-group-append .btn {
  position: relative;
  z-index: 2;
}
.input-group-prepend .btn:focus,
.input-group-append .btn:focus {
  z-index: 3;
}
.input-group-prepend .btn + .btn,
.input-group-prepend .btn + .input-group-text,
.input-group-prepend .input-group-text + .input-group-text,
.input-group-prepend .input-group-text + .btn,
.input-group-append .btn + .btn,
.input-group-append .btn + .input-group-text,
.input-group-append .input-group-text + .input-group-text,
.input-group-append .input-group-text + .btn {
  margin-left: -1px;
}

.input-group-prepend {
  margin-right: -1px;
}

.input-group-append {
  margin-left: -1px;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.47rem 0.75rem;
  margin-bottom: 0;
  font-size: 0.9rem;
  font-weight: 400;
  line-height: 1.5;
  color: #a1a8b8;
  text-align: center;
  white-space: nowrap;
  background-color: #3b414e;
  border: 1px solid #3b414e;
  border-radius: 0.3rem;
}
.input-group-text input[type=radio],
.input-group-text input[type=checkbox] {
  margin-top: 0;
}

.input-group-lg > .form-control:not(textarea),
.input-group-lg > .custom-select {
  height: calc(1.5em + 1rem + 2px);
}

.input-group-lg > .form-control,
.input-group-lg > .custom-select,
.input-group-lg > .input-group-prepend > .input-group-text,
.input-group-lg > .input-group-append > .input-group-text,
.input-group-lg > .input-group-prepend > .btn,
.input-group-lg > .input-group-append > .btn {
  padding: 0.5rem 1rem;
  font-size: 1.125rem;
  line-height: 1.5;
  border-radius: 0.5rem;
}

.input-group-sm > .form-control:not(textarea),
.input-group-sm > .custom-select {
  height: calc(1.5em + 0.5rem + 2px);
}

.input-group-sm > .form-control,
.input-group-sm > .custom-select,
.input-group-sm > .input-group-prepend > .input-group-text,
.input-group-sm > .input-group-append > .input-group-text,
.input-group-sm > .input-group-prepend > .btn,
.input-group-sm > .input-group-append > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.7875rem;
  line-height: 1.5;
  border-radius: 0.2rem;
}

.input-group-lg > .custom-select,
.input-group-sm > .custom-select {
  padding-right: 1.75rem;
}

.input-group > .input-group-prepend > .btn,
.input-group > .input-group-prepend > .input-group-text,
.input-group:not(.has-validation) > .input-group-append:not(:last-child) > .btn,
.input-group:not(.has-validation) > .input-group-append:not(:last-child) > .input-group-text,
.input-group.has-validation > .input-group-append:nth-last-child(n+3) > .btn,
.input-group.has-validation > .input-group-append:nth-last-child(n+3) > .input-group-text,
.input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),
.input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group > .input-group-append > .btn,
.input-group > .input-group-append > .input-group-text,
.input-group > .input-group-prepend:not(:first-child) > .btn,
.input-group > .input-group-prepend:not(:first-child) > .input-group-text,
.input-group > .input-group-prepend:first-child > .btn:not(:first-child),
.input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.custom-control {
  position: relative;
  z-index: 1;
  display: block;
  min-height: 1.35rem;
  padding-left: 1.5rem;
  print-color-adjust: exact;
}

.custom-control-inline {
  display: inline-flex;
  margin-right: 1rem;
}

.custom-control-input {
  position: absolute;
  left: 0;
  z-index: -1;
  width: 1rem;
  height: 1.175rem;
  opacity: 0;
}
.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #5369f8;
  background-color: #5369f8;
}
.custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: none;
}
.custom-control-input:focus:not(:checked) ~ .custom-control-label::before {
  border-color: rgb(63.3927007299, 69.8394160584, 83.8072992701);
}
.custom-control-input:not(:disabled):active ~ .custom-control-label::before {
  color: #fff;
  background-color: rgb(254.5195530726, 254.5810055866, 254.9804469274);
  border-color: rgb(254.5195530726, 254.5810055866, 254.9804469274);
}
.custom-control-input[disabled] ~ .custom-control-label, .custom-control-input:disabled ~ .custom-control-label {
  color: #8790a4;
}
.custom-control-input[disabled] ~ .custom-control-label::before, .custom-control-input:disabled ~ .custom-control-label::before {
  background-color: rgb(52.1982758621, 57.4181034483, 68.9017241379);
}

.custom-control-label {
  position: relative;
  margin-bottom: 0;
  vertical-align: top;
}
.custom-control-label::before {
  position: absolute;
  top: 0.175rem;
  left: -1.5rem;
  display: block;
  width: 1rem;
  height: 1rem;
  pointer-events: none;
  content: "";
  background-color: rgb(54.3965517241, 59.8362068966, 71.8034482759);
  border: 1px solid #3b414e;
}
.custom-control-label::after {
  position: absolute;
  top: 0.175rem;
  left: -1.5rem;
  display: block;
  width: 1rem;
  height: 1rem;
  content: "";
  background: 50%/50% 50% no-repeat;
}

.custom-checkbox .custom-control-label::before {
  border-radius: 0.3rem;
}
.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::before {
  border-color: #5369f8;
  background-color: #5369f8;
}
.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}
.custom-checkbox .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(83, 105, 248, 0.5);
}
.custom-checkbox .custom-control-input:disabled:indeterminate ~ .custom-control-label::before {
  background-color: rgba(83, 105, 248, 0.5);
}

.custom-radio .custom-control-label::before {
  border-radius: 50%;
}
.custom-radio .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
.custom-radio .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(83, 105, 248, 0.5);
}

.custom-switch {
  padding-left: 2.25rem;
}
.custom-switch .custom-control-label::before {
  left: -2.25rem;
  width: 1.75rem;
  pointer-events: all;
  border-radius: 0.5rem;
}
.custom-switch .custom-control-label::after {
  top: calc(0.175rem + 2px);
  left: calc(-2.25rem + 2px);
  width: calc(1rem - 4px);
  height: calc(1rem - 4px);
  background-color: #3b414e;
  border-radius: 0.5rem;
  transition: transform 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .custom-switch .custom-control-label::after {
    transition: none;
  }
}
.custom-switch .custom-control-input:checked ~ .custom-control-label::after {
  background-color: rgb(54.3965517241, 59.8362068966, 71.8034482759);
  transform: translateX(0.75rem);
}
.custom-switch .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(83, 105, 248, 0.5);
}

.custom-select {
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 0.94rem + 2px);
  padding: 0.47rem 1.75rem 0.47rem 0.75rem;
  font-size: 0.9rem;
  font-weight: 400;
  line-height: 1.5;
  color: #a1a8b8;
  vertical-align: middle;
  background: rgb(54.3965517241, 59.8362068966, 71.8034482759) url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat right 0.75rem center/8px 10px;
  border: 1px solid #3b414e;
  border-radius: 0.3rem;
  appearance: none;
}
.custom-select:focus {
  border-color: rgb(63.3927007299, 69.8394160584, 83.8072992701);
  outline: 0;
  box-shadow: 0 0 0 0.15rem rgba(83, 105, 248, 0.25);
}
.custom-select:focus::-ms-value {
  color: #a1a8b8;
  background-color: rgb(54.3965517241, 59.8362068966, 71.8034482759);
}
.custom-select[multiple], .custom-select[size]:not([size="1"]) {
  height: auto;
  padding-right: 0.75rem;
  background-image: none;
}
.custom-select:disabled {
  color: #8790a4;
  background-color: #323742;
}
.custom-select::-ms-expand {
  display: none;
}
.custom-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #a1a8b8;
}

.custom-select-sm {
  height: calc(1.5em + 0.5rem + 2px);
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 0.7875rem;
}

.custom-select-lg {
  height: calc(1.5em + 1rem + 2px);
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1rem;
  font-size: 1.125rem;
}

.custom-file {
  position: relative;
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 0.94rem + 2px);
  margin-bottom: 0;
}

.custom-file-input {
  position: relative;
  z-index: 2;
  width: 100%;
  height: calc(1.5em + 0.94rem + 2px);
  margin: 0;
  overflow: hidden;
  opacity: 0;
}
.custom-file-input:focus ~ .custom-file-label {
  border-color: rgb(63.3927007299, 69.8394160584, 83.8072992701);
  box-shadow: none;
}
.custom-file-input[disabled] ~ .custom-file-label, .custom-file-input:disabled ~ .custom-file-label {
  background-color: rgb(52.1982758621, 57.4181034483, 68.9017241379);
}
.custom-file-input:lang(en) ~ .custom-file-label::after {
  content: "Browse";
}
.custom-file-input ~ .custom-file-label[data-browse]::after {
  content: attr(data-browse);
}

.custom-file-label {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1;
  height: calc(1.5em + 0.94rem + 2px);
  padding: 0.47rem 0.75rem;
  overflow: hidden;
  font-weight: 400;
  line-height: 1.5;
  color: #a1a8b8;
  background-color: rgb(54.3965517241, 59.8362068966, 71.8034482759);
  border: 1px solid #3b414e;
  border-radius: 0.3rem;
}
.custom-file-label::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
  display: block;
  height: calc(1.5em + 0.94rem);
  padding: 0.47rem 0.75rem;
  line-height: 1.5;
  color: #a1a8b8;
  content: "Browse";
  background-color: #3b414e;
  border-left: inherit;
  border-radius: 0 0.3rem 0.3rem 0;
}

.custom-range {
  width: 100%;
  height: 1.3rem;
  padding: 0;
  background-color: transparent;
  appearance: none;
}
.custom-range:focus {
  outline: 0;
}
.custom-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #64687C, none;
}
.custom-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #64687C, none;
}
.custom-range:focus::-ms-thumb {
  box-shadow: 0 0 0 1px #64687C, none;
}
.custom-range::-moz-focus-outer {
  border: 0;
}
.custom-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  background-color: #5369f8;
  border: 0;
  border-radius: 1rem;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .custom-range::-webkit-slider-thumb {
    transition: none;
  }
}
.custom-range::-webkit-slider-thumb {
  appearance: none;
}
.custom-range::-webkit-slider-thumb:active {
  background-color: rgb(254.5195530726, 254.5810055866, 254.9804469274);
}
.custom-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #3b414e;
  border-color: transparent;
  border-radius: 1rem;
}
.custom-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  background-color: #5369f8;
  border: 0;
  border-radius: 1rem;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .custom-range::-moz-range-thumb {
    transition: none;
  }
}
.custom-range::-moz-range-thumb {
  appearance: none;
}
.custom-range::-moz-range-thumb:active {
  background-color: rgb(254.5195530726, 254.5810055866, 254.9804469274);
}
.custom-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #3b414e;
  border-color: transparent;
  border-radius: 1rem;
}
.custom-range::-ms-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: 0;
  margin-right: 0.15rem;
  margin-left: 0.15rem;
  background-color: #5369f8;
  border: 0;
  border-radius: 1rem;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .custom-range::-ms-thumb {
    transition: none;
  }
}
.custom-range::-ms-thumb {
  appearance: none;
}
.custom-range::-ms-thumb:active {
  background-color: rgb(254.5195530726, 254.5810055866, 254.9804469274);
}
.custom-range::-ms-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: transparent;
  border-color: transparent;
  border-width: 0.5rem;
}
.custom-range::-ms-fill-lower {
  background-color: #3b414e;
  border-radius: 1rem;
}
.custom-range::-ms-fill-upper {
  margin-right: 15px;
  background-color: #3b414e;
  border-radius: 1rem;
}
.custom-range:disabled::-webkit-slider-thumb {
  background-color: #6b768d;
}
.custom-range:disabled::-webkit-slider-runnable-track {
  cursor: default;
}
.custom-range:disabled::-moz-range-thumb {
  background-color: #6b768d;
}
.custom-range:disabled::-moz-range-track {
  cursor: default;
}
.custom-range:disabled::-ms-thumb {
  background-color: #6b768d;
}

.custom-control-label::before,
.custom-file-label,
.custom-select {
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .custom-control-label::before,
  .custom-file-label,
  .custom-select {
    transition: none;
  }
}

.nav {
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: 0.5rem 1rem;
}
.nav-link:hover, .nav-link:focus {
  text-decoration: none;
}
.nav-link.disabled {
  color: #8790a4;
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  border-bottom: 1px solid #3b414e;
}
.nav-tabs .nav-link {
  margin-bottom: -1px;
  background-color: transparent;
  border: 1px solid transparent;
  border-top-left-radius: 0.3rem;
  border-top-right-radius: 0.3rem;
}
.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  isolation: isolate;
  border-color: #323742 #323742 #3b414e;
}
.nav-tabs .nav-link.disabled {
  color: #8790a4;
  background-color: transparent;
  border-color: transparent;
}
.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: #a1a8b8;
  background-color: #323742;
  border-color: #3b414e #3b414e #323742;
}
.nav-tabs .dropdown-menu {
  margin-top: -1px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills .nav-link {
  background: none;
  border: 0;
  border-radius: 0.3rem;
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #fff;
  background-color: #5369f8;
}

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}

.tab-content > .tab-pane {
  display: none;
}
.tab-content > .active {
  display: block;
}

.navbar {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 1rem;
}
.navbar .container,
.navbar .container-fluid,
.navbar .container-sm,
.navbar .container-md,
.navbar .container-lg,
.navbar .container-xl {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
}
.navbar-brand {
  display: inline-block;
  padding-top: 0.33125rem;
  padding-bottom: 0.33125rem;
  margin-right: 1rem;
  font-size: 1.125rem;
  line-height: inherit;
  white-space: nowrap;
}
.navbar-brand:hover, .navbar-brand:focus {
  text-decoration: none;
}

.navbar-nav {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}
.navbar-nav .nav-link {
  padding-right: 0;
  padding-left: 0;
}
.navbar-nav .dropdown-menu {
  position: static;
  float: none;
}

.navbar-text {
  display: inline-block;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}

.navbar-toggler {
  padding: 0.25rem 0.75rem;
  font-size: 1.125rem;
  line-height: 1;
  background-color: transparent;
  border: 1px solid transparent;
  border-radius: 0.3rem;
}
.navbar-toggler:hover, .navbar-toggler:focus {
  text-decoration: none;
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  content: "";
  background: 50%/100% 100% no-repeat;
}

.navbar-nav-scroll {
  max-height: 75vh;
  overflow-y: auto;
}

@media (max-width: 575.98px) {
  .navbar-expand-sm > .container,
  .navbar-expand-sm > .container-fluid,
  .navbar-expand-sm > .container-sm,
  .navbar-expand-sm > .container-md,
  .navbar-expand-sm > .container-lg,
  .navbar-expand-sm > .container-xl {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-sm > .container,
  .navbar-expand-sm > .container-fluid,
  .navbar-expand-sm > .container-sm,
  .navbar-expand-sm > .container-md,
  .navbar-expand-sm > .container-lg,
  .navbar-expand-sm > .container-xl {
    flex-wrap: nowrap;
  }
  .navbar-expand-sm .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
}
@media (max-width: 767.98px) {
  .navbar-expand-md > .container,
  .navbar-expand-md > .container-fluid,
  .navbar-expand-md > .container-sm,
  .navbar-expand-md > .container-md,
  .navbar-expand-md > .container-lg,
  .navbar-expand-md > .container-xl {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 768px) {
  .navbar-expand-md {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-md > .container,
  .navbar-expand-md > .container-fluid,
  .navbar-expand-md > .container-sm,
  .navbar-expand-md > .container-md,
  .navbar-expand-md > .container-lg,
  .navbar-expand-md > .container-xl {
    flex-wrap: nowrap;
  }
  .navbar-expand-md .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
}
@media (max-width: 991.98px) {
  .navbar-expand-lg > .container,
  .navbar-expand-lg > .container-fluid,
  .navbar-expand-lg > .container-sm,
  .navbar-expand-lg > .container-md,
  .navbar-expand-lg > .container-lg,
  .navbar-expand-lg > .container-xl {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-lg > .container,
  .navbar-expand-lg > .container-fluid,
  .navbar-expand-lg > .container-sm,
  .navbar-expand-lg > .container-md,
  .navbar-expand-lg > .container-lg,
  .navbar-expand-lg > .container-xl {
    flex-wrap: nowrap;
  }
  .navbar-expand-lg .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
}
@media (max-width: 1199.98px) {
  .navbar-expand-xl > .container,
  .navbar-expand-xl > .container-fluid,
  .navbar-expand-xl > .container-sm,
  .navbar-expand-xl > .container-md,
  .navbar-expand-xl > .container-lg,
  .navbar-expand-xl > .container-xl {
    padding-right: 0;
    padding-left: 0;
  }
}
@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-xl > .container,
  .navbar-expand-xl > .container-fluid,
  .navbar-expand-xl > .container-sm,
  .navbar-expand-xl > .container-md,
  .navbar-expand-xl > .container-lg,
  .navbar-expand-xl > .container-xl {
    flex-wrap: nowrap;
  }
  .navbar-expand-xl .navbar-nav-scroll {
    overflow: visible;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
}
.navbar-expand > .container,
.navbar-expand > .container-fluid,
.navbar-expand > .container-sm,
.navbar-expand > .container-md,
.navbar-expand > .container-lg,
.navbar-expand > .container-xl {
  padding-right: 0;
  padding-left: 0;
}
.navbar-expand {
  flex-flow: row nowrap;
  justify-content: flex-start;
}
.navbar-expand .navbar-nav {
  flex-direction: row;
}
.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}
.navbar-expand .navbar-nav .nav-link {
  padding-right: 0.5rem;
  padding-left: 0.5rem;
}
.navbar-expand > .container,
.navbar-expand > .container-fluid,
.navbar-expand > .container-sm,
.navbar-expand > .container-md,
.navbar-expand > .container-lg,
.navbar-expand > .container-xl {
  flex-wrap: nowrap;
}
.navbar-expand .navbar-nav-scroll {
  overflow: visible;
}
.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}
.navbar-expand .navbar-toggler {
  display: none;
}

.navbar-light .navbar-brand {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-brand:hover, .navbar-light .navbar-brand:focus {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-nav .nav-link {
  color: rgba(0, 0, 0, 0.5);
}
.navbar-light .navbar-nav .nav-link:hover, .navbar-light .navbar-nav .nav-link:focus {
  color: rgba(0, 0, 0, 0.7);
}
.navbar-light .navbar-nav .nav-link.disabled {
  color: rgba(0, 0, 0, 0.3);
}
.navbar-light .navbar-nav .show > .nav-link,
.navbar-light .navbar-nav .active > .nav-link,
.navbar-light .navbar-nav .nav-link.show,
.navbar-light .navbar-nav .nav-link.active {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-toggler {
  color: rgba(0, 0, 0, 0.5);
  border-color: rgba(0, 0, 0, 0.1);
}
.navbar-light .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
.navbar-light .navbar-text {
  color: rgba(0, 0, 0, 0.5);
}
.navbar-light .navbar-text a {
  color: rgba(0, 0, 0, 0.9);
}
.navbar-light .navbar-text a:hover, .navbar-light .navbar-text a:focus {
  color: rgba(0, 0, 0, 0.9);
}

.navbar-dark .navbar-brand {
  color: #fff;
}
.navbar-dark .navbar-brand:hover, .navbar-dark .navbar-brand:focus {
  color: #fff;
}
.navbar-dark .navbar-nav .nav-link {
  color: rgba(255, 255, 255, 0.5);
}
.navbar-dark .navbar-nav .nav-link:hover, .navbar-dark .navbar-nav .nav-link:focus {
  color: rgba(255, 255, 255, 0.75);
}
.navbar-dark .navbar-nav .nav-link.disabled {
  color: rgba(255, 255, 255, 0.25);
}
.navbar-dark .navbar-nav .show > .nav-link,
.navbar-dark .navbar-nav .active > .nav-link,
.navbar-dark .navbar-nav .nav-link.show,
.navbar-dark .navbar-nav .nav-link.active {
  color: #fff;
}
.navbar-dark .navbar-toggler {
  color: rgba(255, 255, 255, 0.5);
  border-color: rgba(255, 255, 255, 0.1);
}
.navbar-dark .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
.navbar-dark .navbar-text {
  color: rgba(255, 255, 255, 0.5);
}
.navbar-dark .navbar-text a {
  color: #fff;
}
.navbar-dark .navbar-text a:hover, .navbar-dark .navbar-text a:focus {
  color: #fff;
}

.card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #494E67;
  background-clip: border-box;
  border: 0 solid rgba(0, 0, 0, 0.125);
  border-radius: 0.5rem;
}
.card > hr {
  margin-right: 0;
  margin-left: 0;
}
.card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}
.card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: calc(0.5rem - 0);
  border-top-right-radius: calc(0.5rem - 0);
}
.card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: calc(0.5rem - 0);
  border-bottom-left-radius: calc(0.5rem - 0);
}
.card > .card-header + .list-group,
.card > .list-group + .card-footer {
  border-top: 0;
}

.card-body {
  flex: 1 1 auto;
  min-height: 1px;
  padding: 1.25rem;
}

.card-title {
  margin-bottom: 0.75rem;
}

.card-subtitle {
  margin-top: -0.375rem;
  margin-bottom: 0;
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link:hover {
  text-decoration: none;
}
.card-link + .card-link {
  margin-left: 1.25rem;
}

.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: #3b414e;
  border-bottom: 0 solid rgba(0, 0, 0, 0.125);
}
.card-header:first-child {
  border-radius: calc(0.5rem - 0) calc(0.5rem - 0) 0 0;
}

.card-footer {
  padding: 0.75rem 1.25rem;
  background-color: #3b414e;
  border-top: 0 solid rgba(0, 0, 0, 0.125);
}
.card-footer:last-child {
  border-radius: 0 0 calc(0.5rem - 0) calc(0.5rem - 0);
}

.card-header-tabs {
  margin-right: -0.625rem;
  margin-bottom: -0.75rem;
  margin-left: -0.625rem;
  border-bottom: 0;
}

.card-header-pills {
  margin-right: -0.625rem;
  margin-left: -0.625rem;
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 1.25rem;
  border-radius: calc(0.5rem - 0);
}

.card-img,
.card-img-top,
.card-img-bottom {
  flex-shrink: 0;
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: calc(0.5rem - 0);
  border-top-right-radius: calc(0.5rem - 0);
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: calc(0.5rem - 0);
  border-bottom-left-radius: calc(0.5rem - 0);
}

.card-deck .card {
  margin-bottom: 12px;
}
@media (min-width: 576px) {
  .card-deck {
    display: flex;
    flex-flow: row wrap;
    margin-right: -12px;
    margin-left: -12px;
  }
  .card-deck .card {
    flex: 1 0 0%;
    margin-right: 12px;
    margin-bottom: 0;
    margin-left: 12px;
  }
}

.card-group > .card {
  margin-bottom: 12px;
}
@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0 0%;
    margin-bottom: 0;
  }
  .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-top,
  .card-group > .card:not(:last-child) .card-header {
    border-top-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-bottom,
  .card-group > .card:not(:last-child) .card-footer {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-top,
  .card-group > .card:not(:first-child) .card-header {
    border-top-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-bottom,
  .card-group > .card:not(:first-child) .card-footer {
    border-bottom-left-radius: 0;
  }
}

.card-columns .card {
  margin-bottom: 0.75rem;
}
@media (min-width: 576px) {
  .card-columns {
    column-count: 3;
    column-gap: 1.25rem;
    orphans: 1;
    widows: 1;
  }
  .card-columns .card {
    display: inline-block;
    width: 100%;
  }
}

.accordion {
  overflow-anchor: none;
}
.accordion > .card {
  overflow: hidden;
}
.accordion > .card:not(:last-of-type) {
  border-bottom: 0;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.accordion > .card:not(:first-of-type) {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.accordion > .card > .card-header {
  border-radius: 0;
  margin-bottom: 0;
}

.breadcrumb {
  display: flex;
  flex-wrap: wrap;
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  list-style: none;
  background-color: #323742;
  border-radius: 0.3rem;
}

.breadcrumb-item + .breadcrumb-item {
  padding-left: 0.5rem;
}
.breadcrumb-item + .breadcrumb-item::before {
  float: left;
  padding-right: 0.5rem;
  color: #8790a4;
  content: "/";
}
.breadcrumb-item + .breadcrumb-item:hover::before {
  text-decoration: underline;
}
.breadcrumb-item + .breadcrumb-item:hover::before {
  text-decoration: none;
}
.breadcrumb-item.active {
  color: #8790a4;
}

.pagination {
  display: flex;
  padding-left: 0;
  list-style: none;
  border-radius: 0.3rem;
}

.page-link {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #6b768d;
  background-color: #323742;
  border: 1px solid #3b414e;
}
.page-link:hover {
  z-index: 2;
  color: #6b768d;
  text-decoration: none;
  background-color: #323742;
  border-color: #3b414e;
}
.page-link:focus {
  z-index: 3;
  outline: 0;
  box-shadow: 0 0 0 0.15rem rgba(83, 105, 248, 0.25);
}

.page-item:first-child .page-link {
  margin-left: 0;
  border-top-left-radius: 0.3rem;
  border-bottom-left-radius: 0.3rem;
}
.page-item:last-child .page-link {
  border-top-right-radius: 0.3rem;
  border-bottom-right-radius: 0.3rem;
}
.page-item.active .page-link {
  z-index: 3;
  color: #fff;
  background-color: #5369f8;
  border-color: #5369f8;
}
.page-item.disabled .page-link {
  color: #8790a4;
  pointer-events: none;
  cursor: auto;
  background-color: #323742;
  border-color: #3b414e;
}

.pagination-lg .page-link {
  padding: 0.75rem 1.5rem;
  font-size: 1.125rem;
  line-height: 1.5;
}
.pagination-lg .page-item:first-child .page-link {
  border-top-left-radius: 0.3rem;
  border-bottom-left-radius: 0.3rem;
}
.pagination-lg .page-item:last-child .page-link {
  border-top-right-radius: 0.3rem;
  border-bottom-right-radius: 0.3rem;
}

.pagination-sm .page-link {
  padding: 0.25rem 0.5rem;
  font-size: 0.7875rem;
  line-height: 1.5;
}
.pagination-sm .page-item:first-child .page-link {
  border-top-left-radius: 0.2rem;
  border-bottom-left-radius: 0.2rem;
}
.pagination-sm .page-item:last-child .page-link {
  border-top-right-radius: 0.2rem;
  border-bottom-right-radius: 0.2rem;
}

.badge {
  display: inline-block;
  padding: 0.25em 0.4em;
  font-size: 75%;
  font-weight: 600;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.3rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .badge {
    transition: none;
  }
}
a.badge:hover, a.badge:focus {
  text-decoration: none;
}

.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.badge-pill {
  padding-right: 0.6em;
  padding-left: 0.6em;
  border-radius: 10rem;
}

.badge-primary {
  color: #fff;
  background-color: #5369f8;
}
a.badge-primary:hover, a.badge-primary:focus {
  color: #fff;
  background-color: rgb(33.9944134078, 62.2625698324, 246.0055865922);
}
a.badge-primary:focus, a.badge-primary.focus {
  outline: 0;
  box-shadow: 0 0 0 0.15rem rgba(83, 105, 248, 0.5);
}

.badge-secondary {
  color: #fff;
  background-color: #292d36;
}
a.badge-secondary:hover, a.badge-secondary:focus {
  color: #fff;
  background-color: rgb(18.9894736842, 20.8421052632, 25.0105263158);
}
a.badge-secondary:focus, a.badge-secondary.focus {
  outline: 0;
  box-shadow: 0 0 0 0.15rem rgba(41, 45, 54, 0.5);
}

.badge-success {
  color: #d6d9e0;
  background-color: #43d39e;
}
a.badge-success:hover, a.badge-success:focus {
  color: #d6d9e0;
  background-color: rgb(43.0517241379, 183.9482758621, 132.0905172414);
}
a.badge-success:focus, a.badge-success.focus {
  outline: 0;
  box-shadow: 0 0 0 0.15rem rgba(67, 211, 158, 0.5);
}

.badge-info {
  color: #d6d9e0;
  background-color: #25c2e3;
}
a.badge-info:hover, a.badge-info:focus {
  color: #d6d9e0;
  background-color: rgb(24.243902439, 160.1829268293, 188.756097561);
}
a.badge-info:focus, a.badge-info.focus {
  outline: 0;
  box-shadow: 0 0 0 0.15rem rgba(37, 194, 227, 0.5);
}

.badge-warning {
  color: #d6d9e0;
  background-color: #ffbe0b;
}
a.badge-warning:hover, a.badge-warning:focus {
  color: #d6d9e0;
  background-color: rgb(215, 157.7254098361, 0);
}
a.badge-warning:focus, a.badge-warning.focus {
  outline: 0;
  box-shadow: 0 0 0 0.15rem rgba(255, 190, 11, 0.5);
}

.badge-danger {
  color: #fff;
  background-color: #ff5c75;
}
a.badge-danger:hover, a.badge-danger:focus {
  color: #fff;
  background-color: rgb(255, 41, 73.8220858896);
}
a.badge-danger:focus, a.badge-danger.focus {
  outline: 0;
  box-shadow: 0 0 0 0.15rem rgba(255, 92, 117, 0.5);
}

.badge-light {
  color: #fff;
  background-color: #3b414e;
}
a.badge-light:hover, a.badge-light:focus {
  color: #fff;
  background-color: rgb(37.0364963504, 40.802919708, 48.9635036496);
}
a.badge-light:focus, a.badge-light.focus {
  outline: 0;
  box-shadow: 0 0 0 0.15rem rgba(59, 65, 78, 0.5);
}

.badge-dark {
  color: #d6d9e0;
  background-color: #bcc1cc;
}
a.badge-dark:hover, a.badge-dark:focus {
  color: #d6d9e0;
  background-color: rgb(159.0423728814, 166.2033898305, 181.9576271186);
}
a.badge-dark:focus, a.badge-dark.focus {
  outline: 0;
  box-shadow: 0 0 0 0.15rem rgba(188, 193, 204, 0.5);
}

.jumbotron {
  padding: 2rem 1rem;
  margin-bottom: 2rem;
  background-color: #323742;
  border-radius: 0.5rem;
}
@media (min-width: 576px) {
  .jumbotron {
    padding: 4rem 2rem;
  }
}

.jumbotron-fluid {
  padding-right: 0;
  padding-left: 0;
  border-radius: 0;
}

.alert {
  position: relative;
  padding: 0.75rem 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 0.3rem;
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 700;
}

.alert-dismissible {
  padding-right: 3.85rem;
}
.alert-dismissible .close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 0.75rem 1.25rem;
  color: inherit;
}

.alert-primary {
  color: rgb(43.16, 54.6, 128.96);
  background-color: #5369f8;
  border-color: #5369f8;
}
.alert-primary hr {
  border-top-color: rgb(58.4972067039, 83.6312849162, 247.0027932961);
}
.alert-primary .alert-link {
  color: rgb(30.3714803625, 38.4217522659, 90.7485196375);
}

.alert-secondary {
  color: rgb(21.32, 23.4, 28.08);
  background-color: #292d36;
  border-color: #292d36;
}
.alert-secondary hr {
  border-top-color: rgb(29.9947368421, 32.9210526316, 39.5052631579);
}
.alert-secondary .alert-link {
  color: black;
}

.alert-success {
  color: rgb(34.84, 109.72, 82.16);
  background-color: #43d39e;
  border-color: #43d39e;
}
.alert-success hr {
  border-top-color: rgb(47.8879310345, 204.6120689655, 146.9288793103);
}
.alert-success .alert-link {
  color: rgb(22.5486330935, 71.0113669065, 53.1743884892);
}

.alert-info {
  color: rgb(19.24, 100.88, 118.04);
  background-color: #25c2e3;
  border-color: #25c2e3;
}
.alert-info hr {
  border-top-color: rgb(27.1463414634, 179.3597560976, 211.3536585366);
}
.alert-info .alert-link {
  color: rgb(12.0922727273, 63.4027272727, 74.1877272727);
}

.alert-warning {
  color: rgb(132.6, 98.8, 5.72);
  background-color: #ffbe0b;
  border-color: #ffbe0b;
}
.alert-warning hr {
  border-top-color: rgb(240.5, 176.4323770492, 0);
}
.alert-warning .alert-link {
  color: rgb(83.7090225564, 62.3714285714, 3.6109774436);
}

.alert-danger {
  color: rgb(132.6, 47.84, 60.84);
  background-color: #ff5c75;
  border-color: #ff5c75;
}
.alert-danger hr {
  border-top-color: rgb(255, 66.5, 95.4110429448);
}
.alert-danger .alert-link {
  color: rgb(95.1216138329, 34.3183861671, 43.6440345821);
}

.alert-light {
  color: rgb(30.68, 33.8, 40.56);
  background-color: #3b414e;
  border-color: #3b414e;
}
.alert-light hr {
  border-top-color: rgb(48.0182481752, 52.901459854, 63.4817518248);
}
.alert-light .alert-link {
  color: rgb(8.7164963504, 9.602919708, 11.5235036496);
}

.alert-dark {
  color: rgb(97.76, 100.36, 106.08);
  background-color: #bcc1cc;
  border-color: #bcc1cc;
}
.alert-dark hr {
  border-top-color: rgb(173.5211864407, 179.6016949153, 192.9788135593);
}
.alert-dark .alert-link {
  color: rgb(73.3008163265, 75.2503061224, 79.5391836735);
}

@keyframes progress-bar-stripes {
  from {
    background-position: 0.75rem 0;
  }
  to {
    background-position: 0 0;
  }
}
.progress {
  display: flex;
  height: 0.75rem;
  overflow: hidden;
  line-height: 0;
  font-size: 0.675rem;
  background-color: #3b414e;
  border-radius: 0.3rem;
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  background-color: #5369f8;
  transition: width 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: 0.75rem 0.75rem;
}

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes;
}
@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}

.media {
  display: flex;
  align-items: flex-start;
}

.media-body {
  flex: 1;
}

.list-group {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: 0.3rem;
}

.list-group-item-action {
  width: 100%;
  color: #a1a8b8;
  text-align: inherit;
}
.list-group-item-action:hover, .list-group-item-action:focus {
  z-index: 1;
  color: #a1a8b8;
  text-decoration: none;
  background-color: #212529;
}
.list-group-item-action:active {
  color: #a1a8b8;
  background-color: #323742;
}

.list-group-item {
  position: relative;
  display: block;
  padding: 0.75rem 1.25rem;
  background-color: #323742;
  border: 1px solid #3b414e;
}
.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}
.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}
.list-group-item.disabled, .list-group-item:disabled {
  color: #8790a4;
  pointer-events: none;
  background-color: #323742;
}
.list-group-item.active {
  z-index: 2;
  color: #fff;
  background-color: #5369f8;
  border-color: #5369f8;
}
.list-group-item + .list-group-item {
  border-top-width: 0;
}
.list-group-item + .list-group-item.active {
  margin-top: -1px;
  border-top-width: 1px;
}

.list-group-horizontal {
  flex-direction: row;
}
.list-group-horizontal > .list-group-item:first-child {
  border-bottom-left-radius: 0.3rem;
  border-top-right-radius: 0;
}
.list-group-horizontal > .list-group-item:last-child {
  border-top-right-radius: 0.3rem;
  border-bottom-left-radius: 0;
}
.list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: 1px;
  border-left-width: 0;
}
.list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: -1px;
  border-left-width: 1px;
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }
  .list-group-horizontal-sm > .list-group-item:first-child {
    border-bottom-left-radius: 0.3rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item:last-child {
    border-top-right-radius: 0.3rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }
  .list-group-horizontal-md > .list-group-item:first-child {
    border-bottom-left-radius: 0.3rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item:last-child {
    border-top-right-radius: 0.3rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }
  .list-group-horizontal-lg > .list-group-item:first-child {
    border-bottom-left-radius: 0.3rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item:last-child {
    border-top-right-radius: 0.3rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }
  .list-group-horizontal-xl > .list-group-item:first-child {
    border-bottom-left-radius: 0.3rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item:last-child {
    border-top-right-radius: 0.3rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: 1px;
    border-left-width: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: -1px;
    border-left-width: 1px;
  }
}
.list-group-flush {
  border-radius: 0;
}
.list-group-flush > .list-group-item {
  border-width: 0 0 1px;
}
.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-primary {
  color: rgb(43.16, 54.6, 128.96);
  background-color: rgb(206.84, 213, 253.04);
}
.list-group-item-primary.list-group-item-action:hover, .list-group-item-primary.list-group-item-action:focus {
  color: rgb(43.16, 54.6, 128.96);
  background-color: rgb(182.3372067039, 191.6312849162, 252.0427932961);
}
.list-group-item-primary.list-group-item-action.active {
  color: #fff;
  background-color: rgb(43.16, 54.6, 128.96);
  border-color: rgb(43.16, 54.6, 128.96);
}

.list-group-item-secondary {
  color: rgb(21.32, 23.4, 28.08);
  background-color: rgb(195.08, 196.2, 198.72);
}
.list-group-item-secondary.list-group-item-action:hover, .list-group-item-secondary.list-group-item-action:focus {
  color: rgb(21.32, 23.4, 28.08);
  background-color: rgb(181.9306024096, 183.2963855422, 186.3693975904);
}
.list-group-item-secondary.list-group-item-action.active {
  color: #fff;
  background-color: rgb(21.32, 23.4, 28.08);
  border-color: rgb(21.32, 23.4, 28.08);
}

.list-group-item-success {
  color: rgb(34.84, 109.72, 82.16);
  background-color: rgb(202.36, 242.68, 227.84);
}
.list-group-item-success.list-group-item-action:hover, .list-group-item-success.list-group-item-action:focus {
  color: rgb(34.84, 109.72, 82.16);
  background-color: rgb(181.6962068966, 237.8437931034, 217.178362069);
}
.list-group-item-success.list-group-item-action.active {
  color: #fff;
  background-color: rgb(34.84, 109.72, 82.16);
  border-color: rgb(34.84, 109.72, 82.16);
}

.list-group-item-info {
  color: rgb(19.24, 100.88, 118.04);
  background-color: rgb(193.96, 237.92, 247.16);
}
.list-group-item-info.list-group-item-action:hover, .list-group-item-info.list-group-item-action:focus {
  color: rgb(19.24, 100.88, 118.04);
  background-color: rgb(171.3624390244, 231.5968292683, 244.2575609756);
}
.list-group-item-info.list-group-item-action.active {
  color: #fff;
  background-color: rgb(19.24, 100.88, 118.04);
  border-color: rgb(19.24, 100.88, 118.04);
}

.list-group-item-warning {
  color: rgb(132.6, 98.8, 5.72);
  background-color: rgb(255, 236.8, 186.68);
}
.list-group-item-warning.list-group-item-action:hover, .list-group-item-warning.list-group-item-action:focus {
  color: rgb(132.6, 98.8, 5.72);
  background-color: rgb(255, 230.0069672131, 161.18);
}
.list-group-item-warning.list-group-item-action.active {
  color: #fff;
  background-color: rgb(132.6, 98.8, 5.72);
  border-color: rgb(132.6, 98.8, 5.72);
}

.list-group-item-danger {
  color: rgb(132.6, 47.84, 60.84);
  background-color: rgb(255, 209.36, 216.36);
}
.list-group-item-danger.list-group-item-action:hover, .list-group-item-danger.list-group-item-action:focus {
  color: rgb(132.6, 47.84, 60.84);
  background-color: rgb(255, 183.86, 194.7710429448);
}
.list-group-item-danger.list-group-item-action.active {
  color: #fff;
  background-color: rgb(132.6, 47.84, 60.84);
  border-color: rgb(132.6, 47.84, 60.84);
}

.list-group-item-light {
  color: rgb(30.68, 33.8, 40.56);
  background-color: rgb(200.12, 201.8, 205.44);
}
.list-group-item-light.list-group-item-action:hover, .list-group-item-light.list-group-item-action:focus {
  color: rgb(30.68, 33.8, 40.56);
  background-color: rgb(186.720536193, 188.8107238606, 193.339463807);
}
.list-group-item-light.list-group-item-action.active {
  color: #fff;
  background-color: rgb(30.68, 33.8, 40.56);
  border-color: rgb(30.68, 33.8, 40.56);
}

.list-group-item-dark {
  color: rgb(97.76, 100.36, 106.08);
  background-color: rgb(236.24, 237.64, 240.72);
}
.list-group-item-dark.list-group-item-action:hover, .list-group-item-dark.list-group-item-action:focus {
  color: rgb(97.76, 100.36, 106.08);
  background-color: rgb(221.7611864407, 224.2416949153, 229.6988135593);
}
.list-group-item-dark.list-group-item-action.active {
  color: #fff;
  background-color: rgb(97.76, 100.36, 106.08);
  border-color: rgb(97.76, 100.36, 106.08);
}

.close {
  float: right;
  font-size: 1.35rem;
  font-weight: 700;
  line-height: 1;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  opacity: 0.5;
}
.close:hover {
  color: #000;
  text-decoration: none;
}
.close:not(:disabled):not(.disabled):hover, .close:not(:disabled):not(.disabled):focus {
  opacity: 0.75;
}

button.close {
  padding: 0;
  background-color: transparent;
  border: 0;
}

a.close.disabled {
  pointer-events: none;
}

.toast {
  flex-basis: 350px;
  max-width: 350px;
  font-size: 0.875rem;
  background-color: #3b414e;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.1);
  opacity: 0;
  border-radius: 0.25rem;
}
.toast:not(:last-child) {
  margin-bottom: 0.75rem;
}
.toast.showing {
  opacity: 1;
}
.toast.show {
  display: block;
  opacity: 1;
}
.toast.hide {
  display: none;
}

.toast-header {
  display: flex;
  align-items: center;
  padding: 0.25rem 0.75rem;
  color: #8790a4;
  background-color: rgb(56.803649635, 62.5802919708, 75.096350365);
  background-clip: padding-box;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  border-top-left-radius: calc(0.25rem - 1px);
  border-top-right-radius: calc(0.25rem - 1px);
}

.toast-body {
  padding: 0.75rem;
}

.modal-open {
  overflow: hidden;
}
.modal-open .modal {
  overflow-x: hidden;
  overflow-y: auto;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1050;
  display: none;
  width: 100%;
  height: 100%;
  overflow: hidden;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: 0.5rem;
  pointer-events: none;
}
.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
}
@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}
.modal.fade .modal-dialog {
  transform: translate(0, -50px);
}
.modal.show .modal-dialog {
  transform: none;
}
.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  display: flex;
  max-height: calc(100% - 1rem);
}
.modal-dialog-scrollable .modal-content {
  max-height: calc(100vh - 1rem);
  overflow: hidden;
}
.modal-dialog-scrollable .modal-header,
.modal-dialog-scrollable .modal-footer {
  flex-shrink: 0;
}
.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - 1rem);
}
.modal-dialog-centered::before {
  display: block;
  height: calc(100vh - 1rem);
  height: min-content;
  content: "";
}
.modal-dialog-centered.modal-dialog-scrollable {
  flex-direction: column;
  justify-content: center;
  height: 100%;
}
.modal-dialog-centered.modal-dialog-scrollable .modal-content {
  max-height: none;
}
.modal-dialog-centered.modal-dialog-scrollable::before {
  content: none;
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: #323742;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.5rem;
  outline: 0;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000;
}
.modal-backdrop.fade {
  opacity: 0;
}
.modal-backdrop.show {
  opacity: 0.5;
}

.modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 1rem 1rem;
  border-bottom: 1px solid #3b414e;
  border-top-left-radius: calc(0.3rem - 1px);
  border-top-right-radius: calc(0.3rem - 1px);
}
.modal-header .close {
  padding: 1rem 1rem;
  margin: -1rem -1rem -1rem auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: 1.5;
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: 1rem;
}

.modal-footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: 0.75rem;
  border-top: 1px solid #3b414e;
  border-bottom-right-radius: calc(0.3rem - 1px);
  border-bottom-left-radius: calc(0.3rem - 1px);
}
.modal-footer > * {
  margin: 0.25rem;
}

.modal-scrollbar-measure {
  position: absolute;
  top: -9999px;
  width: 50px;
  height: 50px;
  overflow: scroll;
}

@media (min-width: 576px) {
  .modal-dialog {
    max-width: 500px;
    margin: 1.75rem auto;
  }
  .modal-dialog-scrollable {
    max-height: calc(100% - 3.5rem);
  }
  .modal-dialog-scrollable .modal-content {
    max-height: calc(100vh - 3.5rem);
  }
  .modal-dialog-centered {
    min-height: calc(100% - 3.5rem);
  }
  .modal-dialog-centered::before {
    height: calc(100vh - 3.5rem);
    height: min-content;
  }
  .modal-sm {
    max-width: 300px;
  }
}
@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    max-width: 800px;
  }
}
@media (min-width: 1200px) {
  .modal-xl {
    max-width: 1140px;
  }
}
.tooltip {
  position: absolute;
  z-index: 1070;
  display: block;
  margin: 0;
  font-family: "Nunito Sans", sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: 0.7875rem;
  word-wrap: break-word;
  opacity: 0;
}
.tooltip.show {
  opacity: 0.9;
}
.tooltip .arrow {
  position: absolute;
  display: block;
  width: 0.8rem;
  height: 0.4rem;
}
.tooltip .arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top, .bs-tooltip-auto[x-placement^=top] {
  padding: 0.4rem 0;
}
.bs-tooltip-top .arrow, .bs-tooltip-auto[x-placement^=top] .arrow {
  bottom: 0;
}
.bs-tooltip-top .arrow::before, .bs-tooltip-auto[x-placement^=top] .arrow::before {
  top: 0;
  border-width: 0.4rem 0.4rem 0;
  border-top-color: #d6d9e0;
}

.bs-tooltip-right, .bs-tooltip-auto[x-placement^=right] {
  padding: 0 0.4rem;
}
.bs-tooltip-right .arrow, .bs-tooltip-auto[x-placement^=right] .arrow {
  left: 0;
  width: 0.4rem;
  height: 0.8rem;
}
.bs-tooltip-right .arrow::before, .bs-tooltip-auto[x-placement^=right] .arrow::before {
  right: 0;
  border-width: 0.4rem 0.4rem 0.4rem 0;
  border-right-color: #d6d9e0;
}

.bs-tooltip-bottom, .bs-tooltip-auto[x-placement^=bottom] {
  padding: 0.4rem 0;
}
.bs-tooltip-bottom .arrow, .bs-tooltip-auto[x-placement^=bottom] .arrow {
  top: 0;
}
.bs-tooltip-bottom .arrow::before, .bs-tooltip-auto[x-placement^=bottom] .arrow::before {
  bottom: 0;
  border-width: 0 0.4rem 0.4rem;
  border-bottom-color: #d6d9e0;
}

.bs-tooltip-left, .bs-tooltip-auto[x-placement^=left] {
  padding: 0 0.4rem;
}
.bs-tooltip-left .arrow, .bs-tooltip-auto[x-placement^=left] .arrow {
  right: 0;
  width: 0.4rem;
  height: 0.8rem;
}
.bs-tooltip-left .arrow::before, .bs-tooltip-auto[x-placement^=left] .arrow::before {
  left: 0;
  border-width: 0.4rem 0 0.4rem 0.4rem;
  border-left-color: #d6d9e0;
}

.tooltip-inner {
  max-width: 200px;
  padding: 0.25rem 0.5rem;
  color: #3b414e;
  text-align: center;
  background-color: #d6d9e0;
  border-radius: 0.3rem;
}

.popover {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1060;
  display: block;
  max-width: 276px;
  font-family: "Nunito Sans", sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: 0.7875rem;
  word-wrap: break-word;
  background-color: #d6d9e0;
  background-clip: padding-box;
  border: 1px solid rgb(199.4791666667, 203.5416666667, 213.0208333333);
  border-radius: 0.5rem;
}
.popover .arrow {
  position: absolute;
  display: block;
  width: 1rem;
  height: 0.5rem;
  margin: 0 0.5rem;
}
.popover .arrow::before, .popover .arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-popover-top, .bs-popover-auto[x-placement^=top] {
  margin-bottom: 0.5rem;
}
.bs-popover-top > .arrow, .bs-popover-auto[x-placement^=top] > .arrow {
  bottom: calc(-0.5rem - 1px);
}
.bs-popover-top > .arrow::before, .bs-popover-auto[x-placement^=top] > .arrow::before {
  bottom: 0;
  border-width: 0.5rem 0.5rem 0;
  border-top-color: rgb(199.4791666667, 203.5416666667, 213.0208333333);
}
.bs-popover-top > .arrow::after, .bs-popover-auto[x-placement^=top] > .arrow::after {
  bottom: 1px;
  border-width: 0.5rem 0.5rem 0;
  border-top-color: #d6d9e0;
}

.bs-popover-right, .bs-popover-auto[x-placement^=right] {
  margin-left: 0.5rem;
}
.bs-popover-right > .arrow, .bs-popover-auto[x-placement^=right] > .arrow {
  left: calc(-0.5rem - 1px);
  width: 0.5rem;
  height: 1rem;
  margin: 0.5rem 0;
}
.bs-popover-right > .arrow::before, .bs-popover-auto[x-placement^=right] > .arrow::before {
  left: 0;
  border-width: 0.5rem 0.5rem 0.5rem 0;
  border-right-color: rgb(199.4791666667, 203.5416666667, 213.0208333333);
}
.bs-popover-right > .arrow::after, .bs-popover-auto[x-placement^=right] > .arrow::after {
  left: 1px;
  border-width: 0.5rem 0.5rem 0.5rem 0;
  border-right-color: #d6d9e0;
}

.bs-popover-bottom, .bs-popover-auto[x-placement^=bottom] {
  margin-top: 0.5rem;
}
.bs-popover-bottom > .arrow, .bs-popover-auto[x-placement^=bottom] > .arrow {
  top: calc(-0.5rem - 1px);
}
.bs-popover-bottom > .arrow::before, .bs-popover-auto[x-placement^=bottom] > .arrow::before {
  top: 0;
  border-width: 0 0.5rem 0.5rem 0.5rem;
  border-bottom-color: rgb(199.4791666667, 203.5416666667, 213.0208333333);
}
.bs-popover-bottom > .arrow::after, .bs-popover-auto[x-placement^=bottom] > .arrow::after {
  top: 1px;
  border-width: 0 0.5rem 0.5rem 0.5rem;
  border-bottom-color: #d6d9e0;
}
.bs-popover-bottom .popover-header::before, .bs-popover-auto[x-placement^=bottom] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: 1rem;
  margin-left: -0.5rem;
  content: "";
  border-bottom: 1px solid rgb(205.2875, 208.925, 217.4125);
}

.bs-popover-left, .bs-popover-auto[x-placement^=left] {
  margin-right: 0.5rem;
}
.bs-popover-left > .arrow, .bs-popover-auto[x-placement^=left] > .arrow {
  right: calc(-0.5rem - 1px);
  width: 0.5rem;
  height: 1rem;
  margin: 0.5rem 0;
}
.bs-popover-left > .arrow::before, .bs-popover-auto[x-placement^=left] > .arrow::before {
  right: 0;
  border-width: 0.5rem 0 0.5rem 0.5rem;
  border-left-color: rgb(199.4791666667, 203.5416666667, 213.0208333333);
}
.bs-popover-left > .arrow::after, .bs-popover-auto[x-placement^=left] > .arrow::after {
  right: 1px;
  border-width: 0.5rem 0 0.5rem 0.5rem;
  border-left-color: #d6d9e0;
}

.popover-header {
  padding: 0.5rem 0.75rem;
  margin-bottom: 0;
  font-size: 0.9rem;
  color: #323742;
  background-color: rgb(205.2875, 208.925, 217.4125);
  border-bottom: 1px solid rgb(190.7666666667, 195.4666666667, 206.4333333333);
  border-top-left-radius: calc(0.3rem - 1px);
  border-top-right-radius: calc(0.3rem - 1px);
}
.popover-header:empty {
  display: none;
}

.popover-body {
  padding: 0.5rem 0.75rem;
  color: #323742;
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}
.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

.carousel-item-next:not(.carousel-item-left),
.active.carousel-item-right {
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-right),
.active.carousel-item-left {
  transform: translateX(-100%);
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}
.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-left,
.carousel-fade .carousel-item-prev.carousel-item-right {
  z-index: 1;
  opacity: 1;
}
.carousel-fade .active.carousel-item-left,
.carousel-fade .active.carousel-item-right {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-left,
  .carousel-fade .active.carousel-item-right {
    transition: none;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #fff;
  text-align: center;
  background: none;
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
  .carousel-control-next {
    transition: none;
  }
}
.carousel-control-prev:hover, .carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #fff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  background: 50%/100% 100% no-repeat;
}

.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 15;
  display: flex;
  justify-content: center;
  padding-left: 0;
  margin-right: 15%;
  margin-left: 15%;
  list-style: none;
}
.carousel-indicators li {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #fff;
  background-clip: padding-box;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: 0.5;
  transition: opacity 0.6s ease;
}
@media (prefers-reduced-motion: reduce) {
  .carousel-indicators li {
    transition: none;
  }
}
.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 20px;
  left: 15%;
  z-index: 10;
  padding-top: 20px;
  padding-bottom: 20px;
  color: #fff;
  text-align: center;
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg);
  }
}
.spinner-border {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: -0.125em;
  border: 0.25em solid currentcolor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: 0.75s linear infinite spinner-border;
}

.spinner-border-sm {
  width: 1rem;
  height: 1rem;
  border-width: 0.2em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}
.spinner-grow {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: -0.125em;
  background-color: currentcolor;
  border-radius: 50%;
  opacity: 0;
  animation: 0.75s linear infinite spinner-grow;
}

.spinner-grow-sm {
  width: 1rem;
  height: 1rem;
}

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
  .spinner-grow {
    animation-duration: 1.5s;
  }
}
.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.bg-primary {
  background-color: #5369f8 !important;
}

a.bg-primary:hover, a.bg-primary:focus,
button.bg-primary:hover,
button.bg-primary:focus {
  background-color: rgb(33.9944134078, 62.2625698324, 246.0055865922) !important;
}

.bg-secondary {
  background-color: #292d36 !important;
}

a.bg-secondary:hover, a.bg-secondary:focus,
button.bg-secondary:hover,
button.bg-secondary:focus {
  background-color: rgb(18.9894736842, 20.8421052632, 25.0105263158) !important;
}

.bg-success {
  background-color: #43d39e !important;
}

a.bg-success:hover, a.bg-success:focus,
button.bg-success:hover,
button.bg-success:focus {
  background-color: rgb(43.0517241379, 183.9482758621, 132.0905172414) !important;
}

.bg-info {
  background-color: #25c2e3 !important;
}

a.bg-info:hover, a.bg-info:focus,
button.bg-info:hover,
button.bg-info:focus {
  background-color: rgb(24.243902439, 160.1829268293, 188.756097561) !important;
}

.bg-warning {
  background-color: #ffbe0b !important;
}

a.bg-warning:hover, a.bg-warning:focus,
button.bg-warning:hover,
button.bg-warning:focus {
  background-color: rgb(215, 157.7254098361, 0) !important;
}

.bg-danger {
  background-color: #ff5c75 !important;
}

a.bg-danger:hover, a.bg-danger:focus,
button.bg-danger:hover,
button.bg-danger:focus {
  background-color: rgb(255, 41, 73.8220858896) !important;
}

.bg-light {
  background-color: #3b414e !important;
}

a.bg-light:hover, a.bg-light:focus,
button.bg-light:hover,
button.bg-light:focus {
  background-color: rgb(37.0364963504, 40.802919708, 48.9635036496) !important;
}

.bg-dark {
  background-color: #bcc1cc !important;
}

a.bg-dark:hover, a.bg-dark:focus,
button.bg-dark:hover,
button.bg-dark:focus {
  background-color: rgb(159.0423728814, 166.2033898305, 181.9576271186) !important;
}

.bg-white {
  background-color: #fff !important;
}

.bg-transparent {
  background-color: transparent !important;
}

.border {
  border: 1px solid #3b414e !important;
}

.border-top {
  border-top: 1px solid #3b414e !important;
}

.border-right {
  border-right: 1px solid #3b414e !important;
}

.border-bottom {
  border-bottom: 1px solid #3b414e !important;
}

.border-left {
  border-left: 1px solid #3b414e !important;
}

.border-0 {
  border: 0 !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-right-0 {
  border-right: 0 !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-left-0 {
  border-left: 0 !important;
}

.border-primary {
  border-color: #5369f8 !important;
}

.border-secondary {
  border-color: #292d36 !important;
}

.border-success {
  border-color: #43d39e !important;
}

.border-info {
  border-color: #25c2e3 !important;
}

.border-warning {
  border-color: #ffbe0b !important;
}

.border-danger {
  border-color: #ff5c75 !important;
}

.border-light {
  border-color: #3b414e !important;
}

.border-dark {
  border-color: #bcc1cc !important;
}

.border-white {
  border-color: #fff !important;
}

.rounded-sm {
  border-radius: 0.2rem !important;
}

.rounded {
  border-radius: 0.3rem !important;
}

.rounded-top {
  border-top-left-radius: 0.3rem !important;
  border-top-right-radius: 0.3rem !important;
}

.rounded-right {
  border-top-right-radius: 0.3rem !important;
  border-bottom-right-radius: 0.3rem !important;
}

.rounded-bottom {
  border-bottom-right-radius: 0.3rem !important;
  border-bottom-left-radius: 0.3rem !important;
}

.rounded-left {
  border-top-left-radius: 0.3rem !important;
  border-bottom-left-radius: 0.3rem !important;
}

.rounded-lg {
  border-radius: 0.5rem !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: 50rem !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.d-none {
  display: none !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

@media (min-width: 576px) {
  .d-sm-none {
    display: none !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
}
@media (min-width: 768px) {
  .d-md-none {
    display: none !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
}
@media (min-width: 992px) {
  .d-lg-none {
    display: none !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
}
@media (min-width: 1200px) {
  .d-xl-none {
    display: none !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
}
@media print {
  .d-print-none {
    display: none !important;
  }
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
}
.embed-responsive {
  position: relative;
  display: block;
  width: 100%;
  padding: 0;
  overflow: hidden;
}
.embed-responsive::before {
  display: block;
  content: "";
}
.embed-responsive .embed-responsive-item,
.embed-responsive iframe,
.embed-responsive embed,
.embed-responsive object,
.embed-responsive video {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

.embed-responsive-21by9::before {
  padding-top: 42.85714286%;
}

.embed-responsive-16by9::before {
  padding-top: 56.25%;
}

.embed-responsive-4by3::before {
  padding-top: 75%;
}

.embed-responsive-1by1::before {
  padding-top: 100%;
}

.embed-responsive-21by9::before {
  padding-top: 42.85714286%;
}

.embed-responsive-16by9::before {
  padding-top: 56.25%;
}

.embed-responsive-4by3::before {
  padding-top: 75%;
}

.embed-responsive-1by1::before {
  padding-top: 100%;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

@media (min-width: 576px) {
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
}
@media (min-width: 768px) {
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
}
@media (min-width: 992px) {
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
}
@media (min-width: 1200px) {
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
}
.float-left {
  float: left !important;
}

.float-right {
  float: right !important;
}

.float-none {
  float: none !important;
}

@media (min-width: 576px) {
  .float-sm-left {
    float: left !important;
  }
  .float-sm-right {
    float: right !important;
  }
  .float-sm-none {
    float: none !important;
  }
}
@media (min-width: 768px) {
  .float-md-left {
    float: left !important;
  }
  .float-md-right {
    float: right !important;
  }
  .float-md-none {
    float: none !important;
  }
}
@media (min-width: 992px) {
  .float-lg-left {
    float: left !important;
  }
  .float-lg-right {
    float: right !important;
  }
  .float-lg-none {
    float: none !important;
  }
}
@media (min-width: 1200px) {
  .float-xl-left {
    float: left !important;
  }
  .float-xl-right {
    float: right !important;
  }
  .float-xl-none {
    float: none !important;
  }
}
.user-select-all {
  user-select: all !important;
}

.user-select-auto {
  user-select: auto !important;
}

.user-select-none {
  user-select: none !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

@supports (position: sticky) {
  .sticky-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.sr-only-focusable:active, .sr-only-focusable:focus {
  position: static;
  width: auto;
  height: auto;
  overflow: visible;
  clip: auto;
  white-space: normal;
}

.shadow-sm {
  box-shadow: 0 0.05rem 0.01rem rgba(161, 168, 184, 0.075) !important;
}

.shadow {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
}

.shadow-lg {
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.mw-100 {
  max-width: 100% !important;
}

.mh-100 {
  max-height: 100% !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.vw-100 {
  width: 100vw !important;
}

.vh-100 {
  height: 100vh !important;
}

.m-0 {
  margin: 0 !important;
}

.mt-0,
.my-0 {
  margin-top: 0 !important;
}

.mr-0,
.mx-0 {
  margin-right: 0 !important;
}

.mb-0,
.my-0 {
  margin-bottom: 0 !important;
}

.ml-0,
.mx-0 {
  margin-left: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.mt-1,
.my-1 {
  margin-top: 0.25rem !important;
}

.mr-1,
.mx-1 {
  margin-right: 0.25rem !important;
}

.mb-1,
.my-1 {
  margin-bottom: 0.25rem !important;
}

.ml-1,
.mx-1 {
  margin-left: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.mt-2,
.my-2 {
  margin-top: 0.5rem !important;
}

.mr-2,
.mx-2 {
  margin-right: 0.5rem !important;
}

.mb-2,
.my-2 {
  margin-bottom: 0.5rem !important;
}

.ml-2,
.mx-2 {
  margin-left: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.mt-3,
.my-3 {
  margin-top: 1rem !important;
}

.mr-3,
.mx-3 {
  margin-right: 1rem !important;
}

.mb-3,
.my-3 {
  margin-bottom: 1rem !important;
}

.ml-3,
.mx-3 {
  margin-left: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.mt-4,
.my-4 {
  margin-top: 1.5rem !important;
}

.mr-4,
.mx-4 {
  margin-right: 1.5rem !important;
}

.mb-4,
.my-4 {
  margin-bottom: 1.5rem !important;
}

.ml-4,
.mx-4 {
  margin-left: 1.5rem !important;
}

.m-5 {
  margin: 3rem !important;
}

.mt-5,
.my-5 {
  margin-top: 3rem !important;
}

.mr-5,
.mx-5 {
  margin-right: 3rem !important;
}

.mb-5,
.my-5 {
  margin-bottom: 3rem !important;
}

.ml-5,
.mx-5 {
  margin-left: 3rem !important;
}

.p-0 {
  padding: 0 !important;
}

.pt-0,
.py-0 {
  padding-top: 0 !important;
}

.pr-0,
.px-0 {
  padding-right: 0 !important;
}

.pb-0,
.py-0 {
  padding-bottom: 0 !important;
}

.pl-0,
.px-0 {
  padding-left: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.pt-1,
.py-1 {
  padding-top: 0.25rem !important;
}

.pr-1,
.px-1 {
  padding-right: 0.25rem !important;
}

.pb-1,
.py-1 {
  padding-bottom: 0.25rem !important;
}

.pl-1,
.px-1 {
  padding-left: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.pt-2,
.py-2 {
  padding-top: 0.5rem !important;
}

.pr-2,
.px-2 {
  padding-right: 0.5rem !important;
}

.pb-2,
.py-2 {
  padding-bottom: 0.5rem !important;
}

.pl-2,
.px-2 {
  padding-left: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.pt-3,
.py-3 {
  padding-top: 1rem !important;
}

.pr-3,
.px-3 {
  padding-right: 1rem !important;
}

.pb-3,
.py-3 {
  padding-bottom: 1rem !important;
}

.pl-3,
.px-3 {
  padding-left: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.pt-4,
.py-4 {
  padding-top: 1.5rem !important;
}

.pr-4,
.px-4 {
  padding-right: 1.5rem !important;
}

.pb-4,
.py-4 {
  padding-bottom: 1.5rem !important;
}

.pl-4,
.px-4 {
  padding-left: 1.5rem !important;
}

.p-5 {
  padding: 3rem !important;
}

.pt-5,
.py-5 {
  padding-top: 3rem !important;
}

.pr-5,
.px-5 {
  padding-right: 3rem !important;
}

.pb-5,
.py-5 {
  padding-bottom: 3rem !important;
}

.pl-5,
.px-5 {
  padding-left: 3rem !important;
}

.m-n1 {
  margin: -0.25rem !important;
}

.mt-n1,
.my-n1 {
  margin-top: -0.25rem !important;
}

.mr-n1,
.mx-n1 {
  margin-right: -0.25rem !important;
}

.mb-n1,
.my-n1 {
  margin-bottom: -0.25rem !important;
}

.ml-n1,
.mx-n1 {
  margin-left: -0.25rem !important;
}

.m-n2 {
  margin: -0.5rem !important;
}

.mt-n2,
.my-n2 {
  margin-top: -0.5rem !important;
}

.mr-n2,
.mx-n2 {
  margin-right: -0.5rem !important;
}

.mb-n2,
.my-n2 {
  margin-bottom: -0.5rem !important;
}

.ml-n2,
.mx-n2 {
  margin-left: -0.5rem !important;
}

.m-n3 {
  margin: -1rem !important;
}

.mt-n3,
.my-n3 {
  margin-top: -1rem !important;
}

.mr-n3,
.mx-n3 {
  margin-right: -1rem !important;
}

.mb-n3,
.my-n3 {
  margin-bottom: -1rem !important;
}

.ml-n3,
.mx-n3 {
  margin-left: -1rem !important;
}

.m-n4 {
  margin: -1.5rem !important;
}

.mt-n4,
.my-n4 {
  margin-top: -1.5rem !important;
}

.mr-n4,
.mx-n4 {
  margin-right: -1.5rem !important;
}

.mb-n4,
.my-n4 {
  margin-bottom: -1.5rem !important;
}

.ml-n4,
.mx-n4 {
  margin-left: -1.5rem !important;
}

.m-n5 {
  margin: -3rem !important;
}

.mt-n5,
.my-n5 {
  margin-top: -3rem !important;
}

.mr-n5,
.mx-n5 {
  margin-right: -3rem !important;
}

.mb-n5,
.my-n5 {
  margin-bottom: -3rem !important;
}

.ml-n5,
.mx-n5 {
  margin-left: -3rem !important;
}

.m-auto {
  margin: auto !important;
}

.mt-auto,
.my-auto {
  margin-top: auto !important;
}

.mr-auto,
.mx-auto {
  margin-right: auto !important;
}

.mb-auto,
.my-auto {
  margin-bottom: auto !important;
}

.ml-auto,
.mx-auto {
  margin-left: auto !important;
}

@media (min-width: 576px) {
  .m-sm-0 {
    margin: 0 !important;
  }
  .mt-sm-0,
  .my-sm-0 {
    margin-top: 0 !important;
  }
  .mr-sm-0,
  .mx-sm-0 {
    margin-right: 0 !important;
  }
  .mb-sm-0,
  .my-sm-0 {
    margin-bottom: 0 !important;
  }
  .ml-sm-0,
  .mx-sm-0 {
    margin-left: 0 !important;
  }
  .m-sm-1 {
    margin: 0.25rem !important;
  }
  .mt-sm-1,
  .my-sm-1 {
    margin-top: 0.25rem !important;
  }
  .mr-sm-1,
  .mx-sm-1 {
    margin-right: 0.25rem !important;
  }
  .mb-sm-1,
  .my-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-sm-1,
  .mx-sm-1 {
    margin-left: 0.25rem !important;
  }
  .m-sm-2 {
    margin: 0.5rem !important;
  }
  .mt-sm-2,
  .my-sm-2 {
    margin-top: 0.5rem !important;
  }
  .mr-sm-2,
  .mx-sm-2 {
    margin-right: 0.5rem !important;
  }
  .mb-sm-2,
  .my-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-sm-2,
  .mx-sm-2 {
    margin-left: 0.5rem !important;
  }
  .m-sm-3 {
    margin: 1rem !important;
  }
  .mt-sm-3,
  .my-sm-3 {
    margin-top: 1rem !important;
  }
  .mr-sm-3,
  .mx-sm-3 {
    margin-right: 1rem !important;
  }
  .mb-sm-3,
  .my-sm-3 {
    margin-bottom: 1rem !important;
  }
  .ml-sm-3,
  .mx-sm-3 {
    margin-left: 1rem !important;
  }
  .m-sm-4 {
    margin: 1.5rem !important;
  }
  .mt-sm-4,
  .my-sm-4 {
    margin-top: 1.5rem !important;
  }
  .mr-sm-4,
  .mx-sm-4 {
    margin-right: 1.5rem !important;
  }
  .mb-sm-4,
  .my-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-sm-4,
  .mx-sm-4 {
    margin-left: 1.5rem !important;
  }
  .m-sm-5 {
    margin: 3rem !important;
  }
  .mt-sm-5,
  .my-sm-5 {
    margin-top: 3rem !important;
  }
  .mr-sm-5,
  .mx-sm-5 {
    margin-right: 3rem !important;
  }
  .mb-sm-5,
  .my-sm-5 {
    margin-bottom: 3rem !important;
  }
  .ml-sm-5,
  .mx-sm-5 {
    margin-left: 3rem !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .pt-sm-0,
  .py-sm-0 {
    padding-top: 0 !important;
  }
  .pr-sm-0,
  .px-sm-0 {
    padding-right: 0 !important;
  }
  .pb-sm-0,
  .py-sm-0 {
    padding-bottom: 0 !important;
  }
  .pl-sm-0,
  .px-sm-0 {
    padding-left: 0 !important;
  }
  .p-sm-1 {
    padding: 0.25rem !important;
  }
  .pt-sm-1,
  .py-sm-1 {
    padding-top: 0.25rem !important;
  }
  .pr-sm-1,
  .px-sm-1 {
    padding-right: 0.25rem !important;
  }
  .pb-sm-1,
  .py-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-sm-1,
  .px-sm-1 {
    padding-left: 0.25rem !important;
  }
  .p-sm-2 {
    padding: 0.5rem !important;
  }
  .pt-sm-2,
  .py-sm-2 {
    padding-top: 0.5rem !important;
  }
  .pr-sm-2,
  .px-sm-2 {
    padding-right: 0.5rem !important;
  }
  .pb-sm-2,
  .py-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-sm-2,
  .px-sm-2 {
    padding-left: 0.5rem !important;
  }
  .p-sm-3 {
    padding: 1rem !important;
  }
  .pt-sm-3,
  .py-sm-3 {
    padding-top: 1rem !important;
  }
  .pr-sm-3,
  .px-sm-3 {
    padding-right: 1rem !important;
  }
  .pb-sm-3,
  .py-sm-3 {
    padding-bottom: 1rem !important;
  }
  .pl-sm-3,
  .px-sm-3 {
    padding-left: 1rem !important;
  }
  .p-sm-4 {
    padding: 1.5rem !important;
  }
  .pt-sm-4,
  .py-sm-4 {
    padding-top: 1.5rem !important;
  }
  .pr-sm-4,
  .px-sm-4 {
    padding-right: 1.5rem !important;
  }
  .pb-sm-4,
  .py-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-sm-4,
  .px-sm-4 {
    padding-left: 1.5rem !important;
  }
  .p-sm-5 {
    padding: 3rem !important;
  }
  .pt-sm-5,
  .py-sm-5 {
    padding-top: 3rem !important;
  }
  .pr-sm-5,
  .px-sm-5 {
    padding-right: 3rem !important;
  }
  .pb-sm-5,
  .py-sm-5 {
    padding-bottom: 3rem !important;
  }
  .pl-sm-5,
  .px-sm-5 {
    padding-left: 3rem !important;
  }
  .m-sm-n1 {
    margin: -0.25rem !important;
  }
  .mt-sm-n1,
  .my-sm-n1 {
    margin-top: -0.25rem !important;
  }
  .mr-sm-n1,
  .mx-sm-n1 {
    margin-right: -0.25rem !important;
  }
  .mb-sm-n1,
  .my-sm-n1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-sm-n1,
  .mx-sm-n1 {
    margin-left: -0.25rem !important;
  }
  .m-sm-n2 {
    margin: -0.5rem !important;
  }
  .mt-sm-n2,
  .my-sm-n2 {
    margin-top: -0.5rem !important;
  }
  .mr-sm-n2,
  .mx-sm-n2 {
    margin-right: -0.5rem !important;
  }
  .mb-sm-n2,
  .my-sm-n2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-sm-n2,
  .mx-sm-n2 {
    margin-left: -0.5rem !important;
  }
  .m-sm-n3 {
    margin: -1rem !important;
  }
  .mt-sm-n3,
  .my-sm-n3 {
    margin-top: -1rem !important;
  }
  .mr-sm-n3,
  .mx-sm-n3 {
    margin-right: -1rem !important;
  }
  .mb-sm-n3,
  .my-sm-n3 {
    margin-bottom: -1rem !important;
  }
  .ml-sm-n3,
  .mx-sm-n3 {
    margin-left: -1rem !important;
  }
  .m-sm-n4 {
    margin: -1.5rem !important;
  }
  .mt-sm-n4,
  .my-sm-n4 {
    margin-top: -1.5rem !important;
  }
  .mr-sm-n4,
  .mx-sm-n4 {
    margin-right: -1.5rem !important;
  }
  .mb-sm-n4,
  .my-sm-n4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-sm-n4,
  .mx-sm-n4 {
    margin-left: -1.5rem !important;
  }
  .m-sm-n5 {
    margin: -3rem !important;
  }
  .mt-sm-n5,
  .my-sm-n5 {
    margin-top: -3rem !important;
  }
  .mr-sm-n5,
  .mx-sm-n5 {
    margin-right: -3rem !important;
  }
  .mb-sm-n5,
  .my-sm-n5 {
    margin-bottom: -3rem !important;
  }
  .ml-sm-n5,
  .mx-sm-n5 {
    margin-left: -3rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mt-sm-auto,
  .my-sm-auto {
    margin-top: auto !important;
  }
  .mr-sm-auto,
  .mx-sm-auto {
    margin-right: auto !important;
  }
  .mb-sm-auto,
  .my-sm-auto {
    margin-bottom: auto !important;
  }
  .ml-sm-auto,
  .mx-sm-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 768px) {
  .m-md-0 {
    margin: 0 !important;
  }
  .mt-md-0,
  .my-md-0 {
    margin-top: 0 !important;
  }
  .mr-md-0,
  .mx-md-0 {
    margin-right: 0 !important;
  }
  .mb-md-0,
  .my-md-0 {
    margin-bottom: 0 !important;
  }
  .ml-md-0,
  .mx-md-0 {
    margin-left: 0 !important;
  }
  .m-md-1 {
    margin: 0.25rem !important;
  }
  .mt-md-1,
  .my-md-1 {
    margin-top: 0.25rem !important;
  }
  .mr-md-1,
  .mx-md-1 {
    margin-right: 0.25rem !important;
  }
  .mb-md-1,
  .my-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-md-1,
  .mx-md-1 {
    margin-left: 0.25rem !important;
  }
  .m-md-2 {
    margin: 0.5rem !important;
  }
  .mt-md-2,
  .my-md-2 {
    margin-top: 0.5rem !important;
  }
  .mr-md-2,
  .mx-md-2 {
    margin-right: 0.5rem !important;
  }
  .mb-md-2,
  .my-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-md-2,
  .mx-md-2 {
    margin-left: 0.5rem !important;
  }
  .m-md-3 {
    margin: 1rem !important;
  }
  .mt-md-3,
  .my-md-3 {
    margin-top: 1rem !important;
  }
  .mr-md-3,
  .mx-md-3 {
    margin-right: 1rem !important;
  }
  .mb-md-3,
  .my-md-3 {
    margin-bottom: 1rem !important;
  }
  .ml-md-3,
  .mx-md-3 {
    margin-left: 1rem !important;
  }
  .m-md-4 {
    margin: 1.5rem !important;
  }
  .mt-md-4,
  .my-md-4 {
    margin-top: 1.5rem !important;
  }
  .mr-md-4,
  .mx-md-4 {
    margin-right: 1.5rem !important;
  }
  .mb-md-4,
  .my-md-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-md-4,
  .mx-md-4 {
    margin-left: 1.5rem !important;
  }
  .m-md-5 {
    margin: 3rem !important;
  }
  .mt-md-5,
  .my-md-5 {
    margin-top: 3rem !important;
  }
  .mr-md-5,
  .mx-md-5 {
    margin-right: 3rem !important;
  }
  .mb-md-5,
  .my-md-5 {
    margin-bottom: 3rem !important;
  }
  .ml-md-5,
  .mx-md-5 {
    margin-left: 3rem !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .pt-md-0,
  .py-md-0 {
    padding-top: 0 !important;
  }
  .pr-md-0,
  .px-md-0 {
    padding-right: 0 !important;
  }
  .pb-md-0,
  .py-md-0 {
    padding-bottom: 0 !important;
  }
  .pl-md-0,
  .px-md-0 {
    padding-left: 0 !important;
  }
  .p-md-1 {
    padding: 0.25rem !important;
  }
  .pt-md-1,
  .py-md-1 {
    padding-top: 0.25rem !important;
  }
  .pr-md-1,
  .px-md-1 {
    padding-right: 0.25rem !important;
  }
  .pb-md-1,
  .py-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-md-1,
  .px-md-1 {
    padding-left: 0.25rem !important;
  }
  .p-md-2 {
    padding: 0.5rem !important;
  }
  .pt-md-2,
  .py-md-2 {
    padding-top: 0.5rem !important;
  }
  .pr-md-2,
  .px-md-2 {
    padding-right: 0.5rem !important;
  }
  .pb-md-2,
  .py-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-md-2,
  .px-md-2 {
    padding-left: 0.5rem !important;
  }
  .p-md-3 {
    padding: 1rem !important;
  }
  .pt-md-3,
  .py-md-3 {
    padding-top: 1rem !important;
  }
  .pr-md-3,
  .px-md-3 {
    padding-right: 1rem !important;
  }
  .pb-md-3,
  .py-md-3 {
    padding-bottom: 1rem !important;
  }
  .pl-md-3,
  .px-md-3 {
    padding-left: 1rem !important;
  }
  .p-md-4 {
    padding: 1.5rem !important;
  }
  .pt-md-4,
  .py-md-4 {
    padding-top: 1.5rem !important;
  }
  .pr-md-4,
  .px-md-4 {
    padding-right: 1.5rem !important;
  }
  .pb-md-4,
  .py-md-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-md-4,
  .px-md-4 {
    padding-left: 1.5rem !important;
  }
  .p-md-5 {
    padding: 3rem !important;
  }
  .pt-md-5,
  .py-md-5 {
    padding-top: 3rem !important;
  }
  .pr-md-5,
  .px-md-5 {
    padding-right: 3rem !important;
  }
  .pb-md-5,
  .py-md-5 {
    padding-bottom: 3rem !important;
  }
  .pl-md-5,
  .px-md-5 {
    padding-left: 3rem !important;
  }
  .m-md-n1 {
    margin: -0.25rem !important;
  }
  .mt-md-n1,
  .my-md-n1 {
    margin-top: -0.25rem !important;
  }
  .mr-md-n1,
  .mx-md-n1 {
    margin-right: -0.25rem !important;
  }
  .mb-md-n1,
  .my-md-n1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-md-n1,
  .mx-md-n1 {
    margin-left: -0.25rem !important;
  }
  .m-md-n2 {
    margin: -0.5rem !important;
  }
  .mt-md-n2,
  .my-md-n2 {
    margin-top: -0.5rem !important;
  }
  .mr-md-n2,
  .mx-md-n2 {
    margin-right: -0.5rem !important;
  }
  .mb-md-n2,
  .my-md-n2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-md-n2,
  .mx-md-n2 {
    margin-left: -0.5rem !important;
  }
  .m-md-n3 {
    margin: -1rem !important;
  }
  .mt-md-n3,
  .my-md-n3 {
    margin-top: -1rem !important;
  }
  .mr-md-n3,
  .mx-md-n3 {
    margin-right: -1rem !important;
  }
  .mb-md-n3,
  .my-md-n3 {
    margin-bottom: -1rem !important;
  }
  .ml-md-n3,
  .mx-md-n3 {
    margin-left: -1rem !important;
  }
  .m-md-n4 {
    margin: -1.5rem !important;
  }
  .mt-md-n4,
  .my-md-n4 {
    margin-top: -1.5rem !important;
  }
  .mr-md-n4,
  .mx-md-n4 {
    margin-right: -1.5rem !important;
  }
  .mb-md-n4,
  .my-md-n4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-md-n4,
  .mx-md-n4 {
    margin-left: -1.5rem !important;
  }
  .m-md-n5 {
    margin: -3rem !important;
  }
  .mt-md-n5,
  .my-md-n5 {
    margin-top: -3rem !important;
  }
  .mr-md-n5,
  .mx-md-n5 {
    margin-right: -3rem !important;
  }
  .mb-md-n5,
  .my-md-n5 {
    margin-bottom: -3rem !important;
  }
  .ml-md-n5,
  .mx-md-n5 {
    margin-left: -3rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mt-md-auto,
  .my-md-auto {
    margin-top: auto !important;
  }
  .mr-md-auto,
  .mx-md-auto {
    margin-right: auto !important;
  }
  .mb-md-auto,
  .my-md-auto {
    margin-bottom: auto !important;
  }
  .ml-md-auto,
  .mx-md-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 992px) {
  .m-lg-0 {
    margin: 0 !important;
  }
  .mt-lg-0,
  .my-lg-0 {
    margin-top: 0 !important;
  }
  .mr-lg-0,
  .mx-lg-0 {
    margin-right: 0 !important;
  }
  .mb-lg-0,
  .my-lg-0 {
    margin-bottom: 0 !important;
  }
  .ml-lg-0,
  .mx-lg-0 {
    margin-left: 0 !important;
  }
  .m-lg-1 {
    margin: 0.25rem !important;
  }
  .mt-lg-1,
  .my-lg-1 {
    margin-top: 0.25rem !important;
  }
  .mr-lg-1,
  .mx-lg-1 {
    margin-right: 0.25rem !important;
  }
  .mb-lg-1,
  .my-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-lg-1,
  .mx-lg-1 {
    margin-left: 0.25rem !important;
  }
  .m-lg-2 {
    margin: 0.5rem !important;
  }
  .mt-lg-2,
  .my-lg-2 {
    margin-top: 0.5rem !important;
  }
  .mr-lg-2,
  .mx-lg-2 {
    margin-right: 0.5rem !important;
  }
  .mb-lg-2,
  .my-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-lg-2,
  .mx-lg-2 {
    margin-left: 0.5rem !important;
  }
  .m-lg-3 {
    margin: 1rem !important;
  }
  .mt-lg-3,
  .my-lg-3 {
    margin-top: 1rem !important;
  }
  .mr-lg-3,
  .mx-lg-3 {
    margin-right: 1rem !important;
  }
  .mb-lg-3,
  .my-lg-3 {
    margin-bottom: 1rem !important;
  }
  .ml-lg-3,
  .mx-lg-3 {
    margin-left: 1rem !important;
  }
  .m-lg-4 {
    margin: 1.5rem !important;
  }
  .mt-lg-4,
  .my-lg-4 {
    margin-top: 1.5rem !important;
  }
  .mr-lg-4,
  .mx-lg-4 {
    margin-right: 1.5rem !important;
  }
  .mb-lg-4,
  .my-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-lg-4,
  .mx-lg-4 {
    margin-left: 1.5rem !important;
  }
  .m-lg-5 {
    margin: 3rem !important;
  }
  .mt-lg-5,
  .my-lg-5 {
    margin-top: 3rem !important;
  }
  .mr-lg-5,
  .mx-lg-5 {
    margin-right: 3rem !important;
  }
  .mb-lg-5,
  .my-lg-5 {
    margin-bottom: 3rem !important;
  }
  .ml-lg-5,
  .mx-lg-5 {
    margin-left: 3rem !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .pt-lg-0,
  .py-lg-0 {
    padding-top: 0 !important;
  }
  .pr-lg-0,
  .px-lg-0 {
    padding-right: 0 !important;
  }
  .pb-lg-0,
  .py-lg-0 {
    padding-bottom: 0 !important;
  }
  .pl-lg-0,
  .px-lg-0 {
    padding-left: 0 !important;
  }
  .p-lg-1 {
    padding: 0.25rem !important;
  }
  .pt-lg-1,
  .py-lg-1 {
    padding-top: 0.25rem !important;
  }
  .pr-lg-1,
  .px-lg-1 {
    padding-right: 0.25rem !important;
  }
  .pb-lg-1,
  .py-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-lg-1,
  .px-lg-1 {
    padding-left: 0.25rem !important;
  }
  .p-lg-2 {
    padding: 0.5rem !important;
  }
  .pt-lg-2,
  .py-lg-2 {
    padding-top: 0.5rem !important;
  }
  .pr-lg-2,
  .px-lg-2 {
    padding-right: 0.5rem !important;
  }
  .pb-lg-2,
  .py-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-lg-2,
  .px-lg-2 {
    padding-left: 0.5rem !important;
  }
  .p-lg-3 {
    padding: 1rem !important;
  }
  .pt-lg-3,
  .py-lg-3 {
    padding-top: 1rem !important;
  }
  .pr-lg-3,
  .px-lg-3 {
    padding-right: 1rem !important;
  }
  .pb-lg-3,
  .py-lg-3 {
    padding-bottom: 1rem !important;
  }
  .pl-lg-3,
  .px-lg-3 {
    padding-left: 1rem !important;
  }
  .p-lg-4 {
    padding: 1.5rem !important;
  }
  .pt-lg-4,
  .py-lg-4 {
    padding-top: 1.5rem !important;
  }
  .pr-lg-4,
  .px-lg-4 {
    padding-right: 1.5rem !important;
  }
  .pb-lg-4,
  .py-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-lg-4,
  .px-lg-4 {
    padding-left: 1.5rem !important;
  }
  .p-lg-5 {
    padding: 3rem !important;
  }
  .pt-lg-5,
  .py-lg-5 {
    padding-top: 3rem !important;
  }
  .pr-lg-5,
  .px-lg-5 {
    padding-right: 3rem !important;
  }
  .pb-lg-5,
  .py-lg-5 {
    padding-bottom: 3rem !important;
  }
  .pl-lg-5,
  .px-lg-5 {
    padding-left: 3rem !important;
  }
  .m-lg-n1 {
    margin: -0.25rem !important;
  }
  .mt-lg-n1,
  .my-lg-n1 {
    margin-top: -0.25rem !important;
  }
  .mr-lg-n1,
  .mx-lg-n1 {
    margin-right: -0.25rem !important;
  }
  .mb-lg-n1,
  .my-lg-n1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-lg-n1,
  .mx-lg-n1 {
    margin-left: -0.25rem !important;
  }
  .m-lg-n2 {
    margin: -0.5rem !important;
  }
  .mt-lg-n2,
  .my-lg-n2 {
    margin-top: -0.5rem !important;
  }
  .mr-lg-n2,
  .mx-lg-n2 {
    margin-right: -0.5rem !important;
  }
  .mb-lg-n2,
  .my-lg-n2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-lg-n2,
  .mx-lg-n2 {
    margin-left: -0.5rem !important;
  }
  .m-lg-n3 {
    margin: -1rem !important;
  }
  .mt-lg-n3,
  .my-lg-n3 {
    margin-top: -1rem !important;
  }
  .mr-lg-n3,
  .mx-lg-n3 {
    margin-right: -1rem !important;
  }
  .mb-lg-n3,
  .my-lg-n3 {
    margin-bottom: -1rem !important;
  }
  .ml-lg-n3,
  .mx-lg-n3 {
    margin-left: -1rem !important;
  }
  .m-lg-n4 {
    margin: -1.5rem !important;
  }
  .mt-lg-n4,
  .my-lg-n4 {
    margin-top: -1.5rem !important;
  }
  .mr-lg-n4,
  .mx-lg-n4 {
    margin-right: -1.5rem !important;
  }
  .mb-lg-n4,
  .my-lg-n4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-lg-n4,
  .mx-lg-n4 {
    margin-left: -1.5rem !important;
  }
  .m-lg-n5 {
    margin: -3rem !important;
  }
  .mt-lg-n5,
  .my-lg-n5 {
    margin-top: -3rem !important;
  }
  .mr-lg-n5,
  .mx-lg-n5 {
    margin-right: -3rem !important;
  }
  .mb-lg-n5,
  .my-lg-n5 {
    margin-bottom: -3rem !important;
  }
  .ml-lg-n5,
  .mx-lg-n5 {
    margin-left: -3rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mt-lg-auto,
  .my-lg-auto {
    margin-top: auto !important;
  }
  .mr-lg-auto,
  .mx-lg-auto {
    margin-right: auto !important;
  }
  .mb-lg-auto,
  .my-lg-auto {
    margin-bottom: auto !important;
  }
  .ml-lg-auto,
  .mx-lg-auto {
    margin-left: auto !important;
  }
}
@media (min-width: 1200px) {
  .m-xl-0 {
    margin: 0 !important;
  }
  .mt-xl-0,
  .my-xl-0 {
    margin-top: 0 !important;
  }
  .mr-xl-0,
  .mx-xl-0 {
    margin-right: 0 !important;
  }
  .mb-xl-0,
  .my-xl-0 {
    margin-bottom: 0 !important;
  }
  .ml-xl-0,
  .mx-xl-0 {
    margin-left: 0 !important;
  }
  .m-xl-1 {
    margin: 0.25rem !important;
  }
  .mt-xl-1,
  .my-xl-1 {
    margin-top: 0.25rem !important;
  }
  .mr-xl-1,
  .mx-xl-1 {
    margin-right: 0.25rem !important;
  }
  .mb-xl-1,
  .my-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-xl-1,
  .mx-xl-1 {
    margin-left: 0.25rem !important;
  }
  .m-xl-2 {
    margin: 0.5rem !important;
  }
  .mt-xl-2,
  .my-xl-2 {
    margin-top: 0.5rem !important;
  }
  .mr-xl-2,
  .mx-xl-2 {
    margin-right: 0.5rem !important;
  }
  .mb-xl-2,
  .my-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-xl-2,
  .mx-xl-2 {
    margin-left: 0.5rem !important;
  }
  .m-xl-3 {
    margin: 1rem !important;
  }
  .mt-xl-3,
  .my-xl-3 {
    margin-top: 1rem !important;
  }
  .mr-xl-3,
  .mx-xl-3 {
    margin-right: 1rem !important;
  }
  .mb-xl-3,
  .my-xl-3 {
    margin-bottom: 1rem !important;
  }
  .ml-xl-3,
  .mx-xl-3 {
    margin-left: 1rem !important;
  }
  .m-xl-4 {
    margin: 1.5rem !important;
  }
  .mt-xl-4,
  .my-xl-4 {
    margin-top: 1.5rem !important;
  }
  .mr-xl-4,
  .mx-xl-4 {
    margin-right: 1.5rem !important;
  }
  .mb-xl-4,
  .my-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-xl-4,
  .mx-xl-4 {
    margin-left: 1.5rem !important;
  }
  .m-xl-5 {
    margin: 3rem !important;
  }
  .mt-xl-5,
  .my-xl-5 {
    margin-top: 3rem !important;
  }
  .mr-xl-5,
  .mx-xl-5 {
    margin-right: 3rem !important;
  }
  .mb-xl-5,
  .my-xl-5 {
    margin-bottom: 3rem !important;
  }
  .ml-xl-5,
  .mx-xl-5 {
    margin-left: 3rem !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .pt-xl-0,
  .py-xl-0 {
    padding-top: 0 !important;
  }
  .pr-xl-0,
  .px-xl-0 {
    padding-right: 0 !important;
  }
  .pb-xl-0,
  .py-xl-0 {
    padding-bottom: 0 !important;
  }
  .pl-xl-0,
  .px-xl-0 {
    padding-left: 0 !important;
  }
  .p-xl-1 {
    padding: 0.25rem !important;
  }
  .pt-xl-1,
  .py-xl-1 {
    padding-top: 0.25rem !important;
  }
  .pr-xl-1,
  .px-xl-1 {
    padding-right: 0.25rem !important;
  }
  .pb-xl-1,
  .py-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-xl-1,
  .px-xl-1 {
    padding-left: 0.25rem !important;
  }
  .p-xl-2 {
    padding: 0.5rem !important;
  }
  .pt-xl-2,
  .py-xl-2 {
    padding-top: 0.5rem !important;
  }
  .pr-xl-2,
  .px-xl-2 {
    padding-right: 0.5rem !important;
  }
  .pb-xl-2,
  .py-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-xl-2,
  .px-xl-2 {
    padding-left: 0.5rem !important;
  }
  .p-xl-3 {
    padding: 1rem !important;
  }
  .pt-xl-3,
  .py-xl-3 {
    padding-top: 1rem !important;
  }
  .pr-xl-3,
  .px-xl-3 {
    padding-right: 1rem !important;
  }
  .pb-xl-3,
  .py-xl-3 {
    padding-bottom: 1rem !important;
  }
  .pl-xl-3,
  .px-xl-3 {
    padding-left: 1rem !important;
  }
  .p-xl-4 {
    padding: 1.5rem !important;
  }
  .pt-xl-4,
  .py-xl-4 {
    padding-top: 1.5rem !important;
  }
  .pr-xl-4,
  .px-xl-4 {
    padding-right: 1.5rem !important;
  }
  .pb-xl-4,
  .py-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-xl-4,
  .px-xl-4 {
    padding-left: 1.5rem !important;
  }
  .p-xl-5 {
    padding: 3rem !important;
  }
  .pt-xl-5,
  .py-xl-5 {
    padding-top: 3rem !important;
  }
  .pr-xl-5,
  .px-xl-5 {
    padding-right: 3rem !important;
  }
  .pb-xl-5,
  .py-xl-5 {
    padding-bottom: 3rem !important;
  }
  .pl-xl-5,
  .px-xl-5 {
    padding-left: 3rem !important;
  }
  .m-xl-n1 {
    margin: -0.25rem !important;
  }
  .mt-xl-n1,
  .my-xl-n1 {
    margin-top: -0.25rem !important;
  }
  .mr-xl-n1,
  .mx-xl-n1 {
    margin-right: -0.25rem !important;
  }
  .mb-xl-n1,
  .my-xl-n1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-xl-n1,
  .mx-xl-n1 {
    margin-left: -0.25rem !important;
  }
  .m-xl-n2 {
    margin: -0.5rem !important;
  }
  .mt-xl-n2,
  .my-xl-n2 {
    margin-top: -0.5rem !important;
  }
  .mr-xl-n2,
  .mx-xl-n2 {
    margin-right: -0.5rem !important;
  }
  .mb-xl-n2,
  .my-xl-n2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-xl-n2,
  .mx-xl-n2 {
    margin-left: -0.5rem !important;
  }
  .m-xl-n3 {
    margin: -1rem !important;
  }
  .mt-xl-n3,
  .my-xl-n3 {
    margin-top: -1rem !important;
  }
  .mr-xl-n3,
  .mx-xl-n3 {
    margin-right: -1rem !important;
  }
  .mb-xl-n3,
  .my-xl-n3 {
    margin-bottom: -1rem !important;
  }
  .ml-xl-n3,
  .mx-xl-n3 {
    margin-left: -1rem !important;
  }
  .m-xl-n4 {
    margin: -1.5rem !important;
  }
  .mt-xl-n4,
  .my-xl-n4 {
    margin-top: -1.5rem !important;
  }
  .mr-xl-n4,
  .mx-xl-n4 {
    margin-right: -1.5rem !important;
  }
  .mb-xl-n4,
  .my-xl-n4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-xl-n4,
  .mx-xl-n4 {
    margin-left: -1.5rem !important;
  }
  .m-xl-n5 {
    margin: -3rem !important;
  }
  .mt-xl-n5,
  .my-xl-n5 {
    margin-top: -3rem !important;
  }
  .mr-xl-n5,
  .mx-xl-n5 {
    margin-right: -3rem !important;
  }
  .mb-xl-n5,
  .my-xl-n5 {
    margin-bottom: -3rem !important;
  }
  .ml-xl-n5,
  .mx-xl-n5 {
    margin-left: -3rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mt-xl-auto,
  .my-xl-auto {
    margin-top: auto !important;
  }
  .mr-xl-auto,
  .mx-xl-auto {
    margin-right: auto !important;
  }
  .mb-xl-auto,
  .my-xl-auto {
    margin-bottom: auto !important;
  }
  .ml-xl-auto,
  .mx-xl-auto {
    margin-left: auto !important;
  }
}
.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  pointer-events: auto;
  content: "";
  background-color: rgba(0, 0, 0, 0);
}

.text-monospace {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace !important;
}

.text-justify {
  text-align: justify !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.text-left {
  text-align: left !important;
}

.text-right {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

@media (min-width: 576px) {
  .text-sm-left {
    text-align: left !important;
  }
  .text-sm-right {
    text-align: right !important;
  }
  .text-sm-center {
    text-align: center !important;
  }
}
@media (min-width: 768px) {
  .text-md-left {
    text-align: left !important;
  }
  .text-md-right {
    text-align: right !important;
  }
  .text-md-center {
    text-align: center !important;
  }
}
@media (min-width: 992px) {
  .text-lg-left {
    text-align: left !important;
  }
  .text-lg-right {
    text-align: right !important;
  }
  .text-lg-center {
    text-align: center !important;
  }
}
@media (min-width: 1200px) {
  .text-xl-left {
    text-align: left !important;
  }
  .text-xl-right {
    text-align: right !important;
  }
  .text-xl-center {
    text-align: center !important;
  }
}
.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.font-weight-light {
  font-weight: 300 !important;
}

.font-weight-lighter {
  font-weight: lighter !important;
}

.font-weight-normal {
  font-weight: 400 !important;
}

.font-weight-bold {
  font-weight: 700 !important;
}

.font-weight-bolder {
  font-weight: bolder !important;
}

.font-italic {
  font-style: italic !important;
}

.text-white {
  color: #fff !important;
}

.text-primary {
  color: #5369f8 !important;
}

a.text-primary:hover, a.text-primary:focus {
  color: rgb(9.9525139665, 41.2318435754, 244.5474860335) !important;
}

.text-secondary {
  color: #292d36 !important;
}

a.text-secondary:hover, a.text-secondary:focus {
  color: rgb(7.9842105263, 8.7631578947, 10.5157894737) !important;
}

.text-success {
  color: #43d39e !important;
}

a.text-success:hover, a.text-success:focus {
  color: rgb(38.2155172414, 163.2844827586, 117.2521551724) !important;
}

.text-info {
  color: #25c2e3 !important;
}

a.text-info:hover, a.text-info:focus {
  color: rgb(21.3414634146, 141.006097561, 166.1585365854) !important;
}

.text-warning {
  color: #ffbe0b !important;
}

a.text-warning:hover, a.text-warning:focus {
  color: rgb(189.5, 139.018442623, 0) !important;
}

.text-danger {
  color: #ff5c75 !important;
}

a.text-danger:hover, a.text-danger:focus {
  color: rgb(255, 15.5, 52.2331288344) !important;
}

.text-light {
  color: #3b414e !important;
}

a.text-light:hover, a.text-light:focus {
  color: rgb(26.0547445255, 28.704379562, 34.4452554745) !important;
}

.text-dark {
  color: #bcc1cc !important;
}

a.text-dark:hover, a.text-dark:focus {
  color: rgb(144.563559322, 152.8050847458, 170.936440678) !important;
}

.text-body {
  color: #a1a8b8 !important;
}

.text-muted {
  color: #6b768d !important;
}

.text-black-50 {
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-hide {
  font: 0/0 a;
  color: transparent;
  text-shadow: none;
  background-color: transparent;
  border: 0;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-break {
  word-break: break-word !important;
  word-wrap: break-word !important;
}

.text-reset {
  color: inherit !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

@media print {
  *,
  *::before,
  *::after {
    text-shadow: none !important;
    box-shadow: none !important;
  }
  a:not(.btn) {
    text-decoration: underline;
  }
  abbr[title]::after {
    content: " (" attr(title) ")";
  }
  pre {
    white-space: pre-wrap !important;
  }
  pre,
  blockquote {
    border: 1px solid #6b768d;
    page-break-inside: avoid;
  }
  tr,
  img {
    page-break-inside: avoid;
  }
  p,
  h2,
  h3 {
    orphans: 3;
    widows: 3;
  }
  h2,
  h3 {
    page-break-after: avoid;
  }
  @page {
    size: a3;
  }
  body {
    min-width: 992px !important;
  }
  .container {
    min-width: 992px !important;
  }
  .navbar {
    display: none;
  }
  .badge {
    border: 1px solid #000;
  }
  .table {
    border-collapse: collapse !important;
  }
  .table td,
  .table th {
    background-color: #fff !important;
  }
  .table-bordered th,
  .table-bordered td {
    border: 1px solid #3b414e !important;
  }
  .table-dark {
    color: inherit;
  }
  .table-dark th,
  .table-dark td,
  .table-dark thead th,
  .table-dark tbody + tbody {
    border-color: #3b414e;
  }
  .table .thead-dark th {
    color: inherit;
    border-color: #3b414e;
  }
}
.custom-accordionwitharrow .card + .card {
  margin-top: 0.5rem;
}
.custom-accordionwitharrow .card .card-header {
  background-color: transparent;
}
.custom-accordionwitharrow .accordion-arrow {
  font-size: 1.2rem;
}
.custom-accordionwitharrow a.collapsed i.accordion-arrow:before {
  content: "\\e831";
}

.custom-accordion .card {
  overflow: visible;
  border-color: transparent !important;
  border-left: 2px dashed #3b414e !important;
  box-shadow: none;
  padding-left: 40px;
}
.custom-accordion .card .card-header {
  border-radius: 7px !important;
}
.custom-accordion .card .card-header:before {
  content: "";
  position: absolute;
  left: 6px;
  top: 22px;
  width: 42px;
  height: 2px;
  background: #3b414e;
}
.custom-accordion .card .icon {
  position: absolute;
  left: -18px;
  top: -2px;
}

.badge-soft {
  color: #bcc1cc;
}

.badge-soft-primary {
  background-color: rgba(83, 105, 248, 0.2);
  color: #5369f8 !important;
}

.badge-soft-secondary {
  background-color: rgba(41, 45, 54, 0.2);
  color: #292d36 !important;
}

.badge-soft-success {
  background-color: rgba(67, 211, 158, 0.2);
  color: #43d39e !important;
}

.badge-soft-info {
  background-color: rgba(37, 194, 227, 0.2);
  color: #25c2e3 !important;
}

.badge-soft-warning {
  background-color: rgba(255, 190, 11, 0.2);
  color: #ffbe0b !important;
}

.badge-soft-danger {
  background-color: rgba(255, 92, 117, 0.2);
  color: #ff5c75 !important;
}

.badge-soft-light {
  background-color: rgba(59, 65, 78, 0.2);
  color: #3b414e !important;
}

.badge-soft-dark {
  background-color: rgba(188, 193, 204, 0.2);
  color: #bcc1cc !important;
}

.bg-soft-primary {
  background-color: rgba(83, 105, 248, 0.25) !important;
}

.bg-soft-secondary {
  background-color: rgba(41, 45, 54, 0.25) !important;
}

.bg-soft-success {
  background-color: rgba(67, 211, 158, 0.25) !important;
}

.bg-soft-info {
  background-color: rgba(37, 194, 227, 0.25) !important;
}

.bg-soft-warning {
  background-color: rgba(255, 190, 11, 0.25) !important;
}

.bg-soft-danger {
  background-color: rgba(255, 92, 117, 0.25) !important;
}

.bg-soft-light {
  background-color: rgba(59, 65, 78, 0.25) !important;
}

.bg-soft-dark {
  background-color: rgba(188, 193, 204, 0.25) !important;
}

.bg-gradient {
  background: linear-gradient(to bottom, #564ab1, #746dad);
}

.breadcrumb-item + .breadcrumb-item::before {
  font-family: "unicons";
}

.btn {
  color: #fff;
}
.btn:focus {
  box-shadow: none;
}
.btn .icon svg {
  width: 1rem;
  height: 1rem;
  margin-left: 0.1rem;
  margin-top: -2px;
}

.btn-rounded {
  border-radius: 2em;
}

.btn-light, .btn-white {
  color: #d6d9e0;
}

.btn-white {
  border-color: #3b414e;
}
.btn-white:hover, .btn-white:focus {
  background-color: #3b414e;
  border-color: #576073;
}

.btn-link {
  font-weight: 400;
  color: #5369f8;
  background-color: transparent;
}
.btn-link:hover {
  color: rgb(9.9525139665, 41.2318435754, 244.5474860335);
  text-decoration: underline;
  background-color: transparent;
  border-color: transparent;
}
.btn-link:focus, .btn-link.focus {
  text-decoration: underline;
  border-color: transparent;
  box-shadow: none;
}
.btn-link:disabled, .btn-link.disabled {
  color: #8790a4;
  pointer-events: none;
}

.btn-xs {
  padding: 0.2rem 0.6rem;
  font-size: 0.75rem;
  border-radius: 0.15rem;
}

.btn-soft-primary {
  background-color: rgba(83, 105, 248, 0.5);
  color: #5369f8;
  border-color: rgba(83, 105, 248, 0.5);
}
.btn-soft-primary:focus {
  box-shadow: none;
}
.btn-soft-primary:hover, .btn-soft-primary:focus {
  background-color: rgba(83, 105, 248, 0.55);
  color: #5369f8;
}

.btn-soft-secondary {
  background-color: rgba(41, 45, 54, 0.5);
  color: #292d36;
  border-color: rgba(41, 45, 54, 0.5);
}
.btn-soft-secondary:focus {
  box-shadow: none;
}
.btn-soft-secondary:hover, .btn-soft-secondary:focus {
  background-color: rgba(41, 45, 54, 0.55);
  color: #292d36;
}

.btn-soft-success {
  background-color: rgba(67, 211, 158, 0.5);
  color: #43d39e;
  border-color: rgba(67, 211, 158, 0.5);
}
.btn-soft-success:focus {
  box-shadow: none;
}
.btn-soft-success:hover, .btn-soft-success:focus {
  background-color: rgba(67, 211, 158, 0.55);
  color: #43d39e;
}

.btn-soft-info {
  background-color: rgba(37, 194, 227, 0.5);
  color: #25c2e3;
  border-color: rgba(37, 194, 227, 0.5);
}
.btn-soft-info:focus {
  box-shadow: none;
}
.btn-soft-info:hover, .btn-soft-info:focus {
  background-color: rgba(37, 194, 227, 0.55);
  color: #25c2e3;
}

.btn-soft-warning {
  background-color: rgba(255, 190, 11, 0.5);
  color: #ffbe0b;
  border-color: rgba(255, 190, 11, 0.5);
}
.btn-soft-warning:focus {
  box-shadow: none;
}
.btn-soft-warning:hover, .btn-soft-warning:focus {
  background-color: rgba(255, 190, 11, 0.55);
  color: #ffbe0b;
}

.btn-soft-danger {
  background-color: rgba(255, 92, 117, 0.5);
  color: #ff5c75;
  border-color: rgba(255, 92, 117, 0.5);
}
.btn-soft-danger:focus {
  box-shadow: none;
}
.btn-soft-danger:hover, .btn-soft-danger:focus {
  background-color: rgba(255, 92, 117, 0.55);
  color: #ff5c75;
}

.btn-soft-light {
  background-color: rgba(59, 65, 78, 0.5);
  color: #3b414e;
  border-color: rgba(59, 65, 78, 0.5);
}
.btn-soft-light:focus {
  box-shadow: none;
}
.btn-soft-light:hover, .btn-soft-light:focus {
  background-color: rgba(59, 65, 78, 0.55);
  color: #3b414e;
}

.btn-soft-dark {
  background-color: rgba(188, 193, 204, 0.5);
  color: #bcc1cc;
  border-color: rgba(188, 193, 204, 0.5);
}
.btn-soft-dark:focus {
  box-shadow: none;
}
.btn-soft-dark:hover, .btn-soft-dark:focus {
  background-color: rgba(188, 193, 204, 0.55);
  color: #bcc1cc;
}

.btn-outline-primary {
  color: #5369f8;
  border-color: #5369f8;
}
.btn-outline-primary:hover {
  color: #fff;
  background-color: #5369f8;
  border-color: #5369f8;
}
.btn-outline-primary:focus, .btn-outline-primary.focus {
  box-shadow: 0 0 0 0.15rem rgba(83, 105, 248, 0.5);
}
.btn-outline-primary.disabled, .btn-outline-primary:disabled {
  color: #5369f8;
  background-color: transparent;
}
.btn-outline-primary:not(:disabled):not(.disabled):active, .btn-outline-primary:not(:disabled):not(.disabled).active, .show > .btn-outline-primary.dropdown-toggle {
  color: #fff;
  background-color: #5369f8;
  border-color: #5369f8;
}
.btn-outline-primary:not(:disabled):not(.disabled):active:focus, .btn-outline-primary:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-primary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.15rem rgba(83, 105, 248, 0.5);
}
.btn-outline-primary:focus {
  box-shadow: none;
}

.btn-outline-secondary {
  color: #292d36;
  border-color: #292d36;
}
.btn-outline-secondary:hover {
  color: #fff;
  background-color: #292d36;
  border-color: #292d36;
}
.btn-outline-secondary:focus, .btn-outline-secondary.focus {
  box-shadow: 0 0 0 0.15rem rgba(41, 45, 54, 0.5);
}
.btn-outline-secondary.disabled, .btn-outline-secondary:disabled {
  color: #292d36;
  background-color: transparent;
}
.btn-outline-secondary:not(:disabled):not(.disabled):active, .btn-outline-secondary:not(:disabled):not(.disabled).active, .show > .btn-outline-secondary.dropdown-toggle {
  color: #fff;
  background-color: #292d36;
  border-color: #292d36;
}
.btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .btn-outline-secondary:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-secondary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.15rem rgba(41, 45, 54, 0.5);
}
.btn-outline-secondary:focus {
  box-shadow: none;
}

.btn-outline-success {
  color: #43d39e;
  border-color: #43d39e;
}
.btn-outline-success:hover {
  color: #d6d9e0;
  background-color: #43d39e;
  border-color: #43d39e;
}
.btn-outline-success:focus, .btn-outline-success.focus {
  box-shadow: 0 0 0 0.15rem rgba(67, 211, 158, 0.5);
}
.btn-outline-success.disabled, .btn-outline-success:disabled {
  color: #43d39e;
  background-color: transparent;
}
.btn-outline-success:not(:disabled):not(.disabled):active, .btn-outline-success:not(:disabled):not(.disabled).active, .show > .btn-outline-success.dropdown-toggle {
  color: #d6d9e0;
  background-color: #43d39e;
  border-color: #43d39e;
}
.btn-outline-success:not(:disabled):not(.disabled):active:focus, .btn-outline-success:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-success.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.15rem rgba(67, 211, 158, 0.5);
}
.btn-outline-success:focus {
  box-shadow: none;
}

.btn-outline-info {
  color: #25c2e3;
  border-color: #25c2e3;
}
.btn-outline-info:hover {
  color: #d6d9e0;
  background-color: #25c2e3;
  border-color: #25c2e3;
}
.btn-outline-info:focus, .btn-outline-info.focus {
  box-shadow: 0 0 0 0.15rem rgba(37, 194, 227, 0.5);
}
.btn-outline-info.disabled, .btn-outline-info:disabled {
  color: #25c2e3;
  background-color: transparent;
}
.btn-outline-info:not(:disabled):not(.disabled):active, .btn-outline-info:not(:disabled):not(.disabled).active, .show > .btn-outline-info.dropdown-toggle {
  color: #d6d9e0;
  background-color: #25c2e3;
  border-color: #25c2e3;
}
.btn-outline-info:not(:disabled):not(.disabled):active:focus, .btn-outline-info:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-info.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.15rem rgba(37, 194, 227, 0.5);
}
.btn-outline-info:focus {
  box-shadow: none;
}

.btn-outline-warning {
  color: #ffbe0b;
  border-color: #ffbe0b;
}
.btn-outline-warning:hover {
  color: #d6d9e0;
  background-color: #ffbe0b;
  border-color: #ffbe0b;
}
.btn-outline-warning:focus, .btn-outline-warning.focus {
  box-shadow: 0 0 0 0.15rem rgba(255, 190, 11, 0.5);
}
.btn-outline-warning.disabled, .btn-outline-warning:disabled {
  color: #ffbe0b;
  background-color: transparent;
}
.btn-outline-warning:not(:disabled):not(.disabled):active, .btn-outline-warning:not(:disabled):not(.disabled).active, .show > .btn-outline-warning.dropdown-toggle {
  color: #d6d9e0;
  background-color: #ffbe0b;
  border-color: #ffbe0b;
}
.btn-outline-warning:not(:disabled):not(.disabled):active:focus, .btn-outline-warning:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-warning.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.15rem rgba(255, 190, 11, 0.5);
}
.btn-outline-warning:focus {
  box-shadow: none;
}

.btn-outline-danger {
  color: #ff5c75;
  border-color: #ff5c75;
}
.btn-outline-danger:hover {
  color: #fff;
  background-color: #ff5c75;
  border-color: #ff5c75;
}
.btn-outline-danger:focus, .btn-outline-danger.focus {
  box-shadow: 0 0 0 0.15rem rgba(255, 92, 117, 0.5);
}
.btn-outline-danger.disabled, .btn-outline-danger:disabled {
  color: #ff5c75;
  background-color: transparent;
}
.btn-outline-danger:not(:disabled):not(.disabled):active, .btn-outline-danger:not(:disabled):not(.disabled).active, .show > .btn-outline-danger.dropdown-toggle {
  color: #fff;
  background-color: #ff5c75;
  border-color: #ff5c75;
}
.btn-outline-danger:not(:disabled):not(.disabled):active:focus, .btn-outline-danger:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-danger.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.15rem rgba(255, 92, 117, 0.5);
}
.btn-outline-danger:focus {
  box-shadow: none;
}

.btn-outline-light {
  color: #3b414e;
  border-color: #3b414e;
}
.btn-outline-light:hover {
  color: #fff;
  background-color: #3b414e;
  border-color: #3b414e;
}
.btn-outline-light:focus, .btn-outline-light.focus {
  box-shadow: 0 0 0 0.15rem rgba(59, 65, 78, 0.5);
}
.btn-outline-light.disabled, .btn-outline-light:disabled {
  color: #3b414e;
  background-color: transparent;
}
.btn-outline-light:not(:disabled):not(.disabled):active, .btn-outline-light:not(:disabled):not(.disabled).active, .show > .btn-outline-light.dropdown-toggle {
  color: #fff;
  background-color: #3b414e;
  border-color: #3b414e;
}
.btn-outline-light:not(:disabled):not(.disabled):active:focus, .btn-outline-light:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-light.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.15rem rgba(59, 65, 78, 0.5);
}
.btn-outline-light:focus {
  box-shadow: none;
}

.btn-outline-dark {
  color: #bcc1cc;
  border-color: #bcc1cc;
}
.btn-outline-dark:hover {
  color: #d6d9e0;
  background-color: #bcc1cc;
  border-color: #bcc1cc;
}
.btn-outline-dark:focus, .btn-outline-dark.focus {
  box-shadow: 0 0 0 0.15rem rgba(188, 193, 204, 0.5);
}
.btn-outline-dark.disabled, .btn-outline-dark:disabled {
  color: #bcc1cc;
  background-color: transparent;
}
.btn-outline-dark:not(:disabled):not(.disabled):active, .btn-outline-dark:not(:disabled):not(.disabled).active, .show > .btn-outline-dark.dropdown-toggle {
  color: #d6d9e0;
  background-color: #bcc1cc;
  border-color: #bcc1cc;
}
.btn-outline-dark:not(:disabled):not(.disabled):active:focus, .btn-outline-dark:not(:disabled):not(.disabled).active:focus, .show > .btn-outline-dark.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.15rem rgba(188, 193, 204, 0.5);
}
.btn-outline-dark:focus {
  box-shadow: none;
}

.card {
  margin-bottom: 24px;
  box-shadow: 0 0.05rem 0.01rem rgba(161, 168, 184, 0.075);
  border-radius: 10px;
  background-color: #494E67;
}

.card-drop {
  display: inline-block;
  font-size: 20px;
  line-height: 30px;
  color: inherit;
  height: 30px;
  width: 30px;
  border-radius: 50%;
  text-align: center;
  margin-top: -6px;
}
.card-drop:hover {
  background-color: #323742;
  color: #bcc1cc;
}

.card-title,
.card-header {
  margin-top: 0;
}

.card-nav {
  margin: -0.5rem 0;
}

.card-box {
  background-color: #494E67;
  padding: 1.25rem;
  box-shadow: 0 0.05rem 0.01rem rgba(161, 168, 184, 0.075);
  margin-bottom: 24px;
  border-radius: 0.5rem;
}

.header-title {
  font-size: 1.04rem;
  font-weight: 700;
}

.sub-header {
  margin-bottom: 24px;
  color: #8790a4;
}

.dropdown-menu {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  animation-name: DropDownSlide;
  animation-duration: 0.3s;
  animation-fill-mode: both;
  margin: 0;
  font-size: 0.9rem;
  position: absolute;
  z-index: 1000;
}
.dropdown-menu.show {
  top: 100% !important;
}

.dropdown-menu-right {
  right: 0 !important;
  left: auto !important;
}

.dropdown-menu[x-placement^=right], .dropdown-menu[x-placement^=top], .dropdown-menu[x-placement^=left] {
  top: auto !important;
  animation: none !important;
}

@keyframes DropDownSlide {
  100% {
    -webkit-transform: translateY(0);
    transform: translateY(0);
  }
  0% {
    -webkit-transform: translateY(-20px);
    transform: translateY(-20px);
  }
}
.dropdown-lg {
  width: 320px;
}

@media (max-width: 767.98px) {
  .dropdown-lg {
    width: 200px !important;
  }
}
.drop-ani-none .dropdown-menu {
  top: 0 !important;
  animation: none !important;
}

.form-control-light {
  background-color: #212529;
  border-color: #212529;
}

input.form-control[type=color],
input.form-control[type=range] {
  min-height: 39px;
}

.custom-select.is-invalid:focus, .form-control.is-invalid:focus, .custom-select:invalid:focus, .form-control:invalid:focus,
.custom-select.is-valid:focus, .form-control.is-valid:focus, .custom-select:valid:focus, .form-control:valid:focus {
  box-shadow: none !important;
}

.comment-area-box .form-control {
  border-color: #3b414e;
  border-radius: 0.3rem 0.3rem 0 0;
}
.comment-area-box .comment-area-btn {
  background-color: #212529;
  padding: 10px;
  border: 1px solid #3b414e;
  border-top: none;
  border-radius: 0 0 0.3rem 0.3rem;
}

input:focus {
  outline: none;
}

.modal-title {
  margin-top: 0;
}

.modal-full {
  width: 92%;
  max-width: none;
}

.modal-demo {
  background-color: #fff;
  width: 600px !important;
  border-radius: 4px;
  display: none;
  position: relative;
}
.modal-demo .close {
  position: absolute;
  top: 15px;
  right: 25px;
  color: #3b414e;
}

@media (max-width: 768px) {
  .modal-demo {
    width: 96% !important;
  }
}
.custom-modal-title {
  padding: 15px 25px 15px 25px;
  line-height: 22px;
  font-size: 18px;
  background-color: #bcc1cc;
  color: #fff;
  text-align: left;
  margin: 0;
}

.custom-modal-text {
  padding: 20px;
}

.custombox-modal-wrapper {
  text-align: left;
}

.custombox-modal-flash .close,
.custombox-modal-rotatedown .close {
  top: 20px;
  z-index: 9999;
}

.nav-tabs {
  border-bottom: 2px solid rgba(135, 144, 164, 0.2);
}
.nav-tabs .nav-item {
  margin-bottom: -2px;
}
.nav-tabs li a {
  border-color: transparent !important;
  padding: 0.625rem 1.25rem;
}
.nav-tabs li a.active {
  border-bottom: 2px solid #5369f8 !important;
}

.nav-tabs > li > a, .nav-pills > li > a {
  color: #a1a8b8;
  font-weight: 700;
}

.nav-pills {
  background: #64687C;
  border-radius: 0.3rem;
  padding: 6px 2px;
}
.nav-pills .nav-link {
  background-color: transparent;
  color: #a1a8b8;
}
.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #a1a8b8;
  background-color: #494E67;
  box-shadow: 0 0.05rem 0.01rem rgba(161, 168, 184, 0.075);
}

.navtab-bg li > a {
  background-color: #3b414e;
  margin: 0 5px;
}

.pagination-rounded .page-link {
  border-radius: 30px !important;
  margin: 0 3px;
  border: none;
}

.popover-header {
  margin-top: 0;
}

.progress-sm {
  height: 5px;
}

.progress-md {
  height: 8px;
}

.progress-lg {
  height: 12px;
}

.progress-xl {
  height: 15px;
}

.progress-xxl {
  height: 25px;
}

/* Progressbar Vertical */
.progress-vertical {
  min-height: 250px;
  height: 250px;
  width: 10px;
  position: relative;
  display: inline-block;
  margin-bottom: 0;
  margin-right: 20px;
}
.progress-vertical .progress-bar {
  width: 100%;
}
.progress-vertical.progress-xl {
  width: 15px;
}
.progress-vertical.progress-lg {
  width: 12px;
}
.progress-vertical.progress-md {
  width: 8px;
}
.progress-vertical.progress-sm {
  width: 5px;
}

.progress-vertical-bottom {
  min-height: 250px;
  height: 250px;
  position: relative;
  width: 10px;
  display: inline-block;
  margin-bottom: 0;
  margin-right: 20px;
}
.progress-vertical-bottom .progress-bar {
  width: 100%;
  bottom: 0;
  position: absolute;
}
.progress-vertical-bottom.progress-xl {
  width: 15px;
}
.progress-vertical-bottom.progress-lg {
  width: 12px;
}
.progress-vertical-bottom.progress-md {
  width: 8px;
}
.progress-vertical-bottom.progress-sm {
  width: 5px;
}

.progress-w-percent {
  min-height: 20px;
  margin-bottom: 20px;
}
.progress-w-percent .progress {
  width: 80%;
  float: left;
  margin-top: 8px;
}
.progress-w-percent .progress-value {
  width: 20%;
  float: right;
  text-align: right;
  line-height: 20px;
}

a {
  text-decoration: none !important;
}
a:focus {
  outline: none;
}

label {
  font-weight: 600;
}

button:focus {
  outline: none;
}

.blockquote {
  padding: 10px 20px;
  margin-bottom: 20px;
  border-left: 4px solid #323742;
}
.blockquote.blockquote-reverse {
  border-left: 0;
  border-right: 4px solid #323742;
  text-align: right;
}

.icon-dual {
  color: #8790a4;
  fill: rgba(135, 144, 164, 0.12);
}

.icon-dual-primary {
  color: #5369f8;
  fill: rgba(83, 105, 248, 0.16);
}

.icon-dual-secondary {
  color: #292d36;
  fill: rgba(41, 45, 54, 0.16);
}

.icon-dual-success {
  color: #43d39e;
  fill: rgba(67, 211, 158, 0.16);
}

.icon-dual-info {
  color: #25c2e3;
  fill: rgba(37, 194, 227, 0.16);
}

.icon-dual-warning {
  color: #ffbe0b;
  fill: rgba(255, 190, 11, 0.16);
}

.icon-dual-danger {
  color: #ff5c75;
  fill: rgba(255, 92, 117, 0.16);
}

.icon-dual-light {
  color: #3b414e;
  fill: rgba(59, 65, 78, 0.16);
}

.icon-dual-dark {
  color: #bcc1cc;
  fill: rgba(188, 193, 204, 0.16);
}

.icon-xs {
  height: 16px;
  width: 16px;
}

.icon-lg {
  height: 32px;
  width: 32px;
}

.icon-xl {
  height: 48px;
  width: 48px;
}

.icon-xxl {
  height: 72px;
  width: 72px;
}

.table-centered td, .table-centered th {
  vertical-align: middle !important;
}

.table th {
  font-weight: 700;
}
.table .table-user img {
  height: 30px;
  width: 30px;
}

.action-icon {
  color: #8790a4;
  font-size: 1.2rem;
  display: inline-block;
  padding: 0 3px;
}
.action-icon:hover {
  color: #a1a8b8;
}

.table-nowrap th, .table-nowrap td {
  white-space: nowrap;
}

.h1,
.h2,
.h3,
.h4,
.h5,
.h6,
h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 10px 0;
  font-family: "Nunito Sans", sans-serif;
  color: #a1a8b8;
  font-weight: 600;
}

p {
  line-height: 1.6;
}

.font-size-11 {
  font-size: 11px !important;
}

.font-size-12 {
  font-size: 12px !important;
}

.font-size-13 {
  font-size: 13px !important;
}

.font-size-14 {
  font-size: 14px !important;
}

.font-size-15 {
  font-size: 15px !important;
}

.font-size-16 {
  font-size: 16px !important;
}

.font-size-17 {
  font-size: 17px !important;
}

.font-size-18 {
  font-size: 18px !important;
}

.font-size-19 {
  font-size: 19px !important;
}

.font-size-20 {
  font-size: 20px !important;
}

.font-size-22 {
  font-size: 22px !important;
}

.font-size-24 {
  font-size: 24px !important;
}

.text-unline-dashed {
  border-bottom: #576073 1px dashed !important;
  padding-bottom: 1px;
}

@font-face {
  font-family: "unicons";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format("svg");
  font-weight: normal;
  font-style: normal;
}
/* Chrome hack: SVG is rendered more smooth in Windozze. 100% magic, uncomment if you need it. */
/* Note, that will break hinting! In other OS-es font will be not as sharp as it could be */
/*
@media screen and (-webkit-min-device-pixel-ratio:0) {
  @font-face {
    font-family: 'unicons';
    src: url('./ts/unicons.svg?2256574#unicons') format('svg');
  }
}
*/
.uil {
  line-height: inherit;
}

[class^=uil-]:before, [class*=" uil-"]:before {
  font-family: "unicons";
  font-style: normal;
  font-weight: normal;
  speak: none;
  display: inline-block;
  text-decoration: inherit;
  width: 1em;
  text-align: center;
  /* opacity: .8; */
  /* For safety - reset parent styles, that can break glyph codes*/
  font-variant: normal;
  text-transform: none;
  /* fix buttons height, for twitter bootstrap */
  line-height: 1em;
  /* Animation center compensation - margins should be symmetric */
  /* remove if not needed */
  /* you can be more comfortable with increased icons size */
  font-size: 120%;
  /* Font smoothing. That was taken from TWBS */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* Uncomment for 3D effect */
  /* text-shadow: 1px 1px 1px rgba(127, 127, 127, 0.3); */
}

.uil-0-plus:before {
  content: "\\e800";
}

/* '' */
.uil-10-plus:before {
  content: "\\e801";
}

/* '' */
.uil-12-plus:before {
  content: "\\e802";
}

/* '' */
.uil-13-plus:before {
  content: "\\e803";
}

/* '' */
.uil-16-plus:before {
  content: "\\e804";
}

/* '' */
.uil-17-plus:before {
  content: "\\e805";
}

/* '' */
.uil-18-plus:before {
  content: "\\e806";
}

/* '' */
.uil-21-plus:before {
  content: "\\e807";
}

/* '' */
.uil-3-plus:before {
  content: "\\e808";
}

/* '' */
.uil-500px:before {
  content: "\\e809";
}

/* '' */
.uil-6-plus:before {
  content: "\\e80a";
}

/* '' */
.uil-abacus:before {
  content: "\\e80b";
}

/* '' */
.uil-accessible-icon-alt:before {
  content: "\\e80c";
}

/* '' */
.uil-adjust-alt:before {
  content: "\\e80d";
}

/* '' */
.uil-adjust-circle:before {
  content: "\\e80e";
}

/* '' */
.uil-adjust-half:before {
  content: "\\e80f";
}

/* '' */
.uil-adjust:before {
  content: "\\e810";
}

/* '' */
.uil-adobe-alt:before {
  content: "\\e811";
}

/* '' */
.uil-adobe:before {
  content: "\\e812";
}

/* '' */
.uil-airplay:before {
  content: "\\e813";
}

/* '' */
.uil-align-alt:before {
  content: "\\e814";
}

/* '' */
.uil-align-center-alt:before {
  content: "\\e815";
}

/* '' */
.uil-align-center-h:before {
  content: "\\e816";
}

/* '' */
.uil-align-center-justify:before {
  content: "\\e817";
}

/* '' */
.uil-align-center-v:before {
  content: "\\e818";
}

/* '' */
.uil-align-center:before {
  content: "\\e819";
}

/* '' */
.uil-align-justify:before {
  content: "\\e81a";
}

/* '' */
.uil-align-left-justify:before {
  content: "\\e81b";
}

/* '' */
.uil-align-left:before {
  content: "\\e81c";
}

/* '' */
.uil-align-letter-right:before {
  content: "\\e81d";
}

/* '' */
.uil-align-right-justify:before {
  content: "\\e81e";
}

/* '' */
.uil-align-right:before {
  content: "\\e81f";
}

/* '' */
.uil-align:before {
  content: "\\e820";
}

/* '' */
.uil-amazon:before {
  content: "\\e821";
}

/* '' */
.uil-ambulance:before {
  content: "\\e822";
}

/* '' */
.uil-analysis:before {
  content: "\\e823";
}

/* '' */
.uil-analytics:before {
  content: "\\e824";
}

/* '' */
.uil-anchor:before {
  content: "\\e825";
}

/* '' */
.uil-android-alt:before {
  content: "\\e826";
}

/* '' */
.uil-android-phone-slash:before {
  content: "\\e827";
}

/* '' */
.uil-android:before {
  content: "\\e828";
}

/* '' */
.uil-angle-double-down:before {
  content: "\\e829";
}

/* '' */
.uil-angle-double-left:before {
  content: "\\e82a";
}

/* '' */
.uil-angle-double-right:before {
  content: "\\e82b";
}

/* '' */
.uil-angle-double-up:before {
  content: "\\e82c";
}

/* '' */
.uil-angle-down:before {
  content: "\\e82d";
}

/* '' */
.uil-angle-left:before {
  content: "\\e82e";
}

/* '' */
.uil-angle-right-b:before {
  content: "\\e82f";
}

/* '' */
.uil-angle-right:before {
  content: "\\e830";
}

/* '' */
.uil-angle-up:before {
  content: "\\e831";
}

/* '' */
.uil-angry:before {
  content: "\\e832";
}

/* '' */
.uil-ankh:before {
  content: "\\e833";
}

/* '' */
.uil-annoyed-alt:before {
  content: "\\e834";
}

/* '' */
.uil-annoyed:before {
  content: "\\e835";
}

/* '' */
.uil-apple-alt:before {
  content: "\\e836";
}

/* '' */
.uil-apple:before {
  content: "\\e837";
}

/* '' */
.uil-apps:before {
  content: "\\e838";
}

/* '' */
.uil-archive-alt:before {
  content: "\\e839";
}

/* '' */
.uil-archive:before {
  content: "\\e83a";
}

/* '' */
.uil-archway:before {
  content: "\\e83b";
}

/* '' */
.uil-arrow-break:before {
  content: "\\e83c";
}

/* '' */
.uil-arrow-circle-down:before {
  content: "\\e83d";
}

/* '' */
.uil-arrow-circle-left:before {
  content: "\\e83e";
}

/* '' */
.uil-arrow-circle-right:before {
  content: "\\e83f";
}

/* '' */
.uil-arrow-circle-up:before {
  content: "\\e840";
}

/* '' */
.uil-arrow-compress-h:before {
  content: "\\e841";
}

/* '' */
.uil-arrow-down-left:before {
  content: "\\e842";
}

/* '' */
.uil-arrow-down-right:before {
  content: "\\e843";
}

/* '' */
.uil-arrow-down:before {
  content: "\\e844";
}

/* '' */
.uil-arrow-from-right:before {
  content: "\\e845";
}

/* '' */
.uil-arrow-from-top:before {
  content: "\\e846";
}

/* '' */
.uil-arrow-growth:before {
  content: "\\e847";
}

/* '' */
.uil-arrow-left:before {
  content: "\\e848";
}

/* '' */
.uil-arrow-random:before {
  content: "\\e849";
}

/* '' */
.uil-arrow-resize-diagonal:before {
  content: "\\e84a";
}

/* '' */
.uil-arrow-right:before {
  content: "\\e84b";
}

/* '' */
.uil-arrow-to-bottom:before {
  content: "\\e84c";
}

/* '' */
.uil-arrow-to-right:before {
  content: "\\e84d";
}

/* '' */
.uil-arrow-up-left:before {
  content: "\\e84e";
}

/* '' */
.uil-arrow-up-right:before {
  content: "\\e84f";
}

/* '' */
.uil-arrow-up:before {
  content: "\\e850";
}

/* '' */
.uil-arrows-h-alt:before {
  content: "\\e851";
}

/* '' */
.uil-arrows-h:before {
  content: "\\e852";
}

/* '' */
.uil-arrows-left-down:before {
  content: "\\e853";
}

/* '' */
.uil-arrows-maximize:before {
  content: "\\e854";
}

/* '' */
.uil-arrows-merge:before {
  content: "\\e855";
}

/* '' */
.uil-arrows-resize-h:before {
  content: "\\e856";
}

/* '' */
.uil-arrows-resize-v:before {
  content: "\\e857";
}

/* '' */
.uil-arrows-resize:before {
  content: "\\e858";
}

/* '' */
.uil-arrows-right-down:before {
  content: "\\e859";
}

/* '' */
.uil-arrows-shrink-h:before {
  content: "\\e85a";
}

/* '' */
.uil-arrows-shrink-v:before {
  content: "\\e85b";
}

/* '' */
.uil-arrows-up-right:before {
  content: "\\e85c";
}

/* '' */
.uil-arrows-v-alt:before {
  content: "\\e85d";
}

/* '' */
.uil-arrows-v:before {
  content: "\\e85e";
}

/* '' */
.uil-assistive-listening-systems:before {
  content: "\\e85f";
}

/* '' */
.uil-asterisk:before {
  content: "\\e860";
}

/* '' */
.uil-at:before {
  content: "\\e861";
}

/* '' */
.uil-atm-card:before {
  content: "\\e862";
}

/* '' */
.uil-atom:before {
  content: "\\e863";
}

/* '' */
.uil-auto-flash:before {
  content: "\\e864";
}

/* '' */
.uil-award-alt:before {
  content: "\\e865";
}

/* '' */
.uil-award:before {
  content: "\\e866";
}

/* '' */
.uil-baby-carriage:before {
  content: "\\e867";
}

/* '' */
.uil-backpack:before {
  content: "\\e868";
}

/* '' */
.uil-backspace:before {
  content: "\\e869";
}

/* '' */
.uil-backward:before {
  content: "\\e86a";
}

/* '' */
.uil-bag-alt:before {
  content: "\\e86b";
}

/* '' */
.uil-bag-slash:before {
  content: "\\e86c";
}

/* '' */
.uil-bag:before {
  content: "\\e86d";
}

/* '' */
.uil-balance-scale:before {
  content: "\\e86e";
}

/* '' */
.uil-ball:before {
  content: "\\e86f";
}

/* '' */
.uil-ban:before {
  content: "\\e870";
}

/* '' */
.uil-bars:before {
  content: "\\e871";
}

/* '' */
.uil-baseball-ball:before {
  content: "\\e872";
}

/* '' */
.uil-basketball-hoop:before {
  content: "\\e873";
}

/* '' */
.uil-basketball:before {
  content: "\\e874";
}

/* '' */
.uil-bath:before {
  content: "\\e875";
}

/* '' */
.uil-battery-bolt:before {
  content: "\\e876";
}

/* '' */
.uil-battery-empty:before {
  content: "\\e877";
}

/* '' */
.uil-bed-double:before {
  content: "\\e878";
}

/* '' */
.uil-bed:before {
  content: "\\e879";
}

/* '' */
.uil-behance-alt:before {
  content: "\\e87a";
}

/* '' */
.uil-behance:before {
  content: "\\e87b";
}

/* '' */
.uil-bell-school:before {
  content: "\\e87c";
}

/* '' */
.uil-bell-slash:before {
  content: "\\e87d";
}

/* '' */
.uil-bell:before {
  content: "\\e87e";
}

/* '' */
.uil-bill:before {
  content: "\\e87f";
}

/* '' */
.uil-bitcoin-alt:before {
  content: "\\e880";
}

/* '' */
.uil-bitcoin-bold:before {
  content: "\\e881";
}

/* '' */
.uil-bitcoin-circle:before {
  content: "\\e882";
}

/* '' */
.uil-bitcoin:before {
  content: "\\e883";
}

/* '' */
.uil-black-berry:before {
  content: "\\e884";
}

/* '' */
.uil-blogger-alt:before {
  content: "\\e885";
}

/* '' */
.uil-blogger:before {
  content: "\\e886";
}

/* '' */
.uil-bluetooth-b:before {
  content: "\\e887";
}

/* '' */
.uil-bold:before {
  content: "\\e888";
}

/* '' */
.uil-bolt-alt:before {
  content: "\\e889";
}

/* '' */
.uil-bolt-slash:before {
  content: "\\e88a";
}

/* '' */
.uil-bolt:before {
  content: "\\e88b";
}

/* '' */
.uil-book-alt:before {
  content: "\\e88c";
}

/* '' */
.uil-book-medical:before {
  content: "\\e88d";
}

/* '' */
.uil-book-open:before {
  content: "\\e88e";
}

/* '' */
.uil-book-reader:before {
  content: "\\e88f";
}

/* '' */
.uil-book:before {
  content: "\\e890";
}

/* '' */
.uil-bookmark-full:before {
  content: "\\e891";
}

/* '' */
.uil-bookmark:before {
  content: "\\e892";
}

/* '' */
.uil-books:before {
  content: "\\e893";
}

/* '' */
.uil-boombox:before {
  content: "\\e894";
}

/* '' */
.uil-border-alt:before {
  content: "\\e895";
}

/* '' */
.uil-border-bottom:before {
  content: "\\e896";
}

/* '' */
.uil-border-clear:before {
  content: "\\e897";
}

/* '' */
.uil-border-horizontal:before {
  content: "\\e898";
}

/* '' */
.uil-border-inner:before {
  content: "\\e899";
}

/* '' */
.uil-border-left:before {
  content: "\\e89a";
}

/* '' */
.uil-border-out:before {
  content: "\\e89b";
}

/* '' */
.uil-border-right:before {
  content: "\\e89c";
}

/* '' */
.uil-border-top:before {
  content: "\\e89d";
}

/* '' */
.uil-border-vertical:before {
  content: "\\e89e";
}

/* '' */
.uil-bowling-ball:before {
  content: "\\e89f";
}

/* '' */
.uil-box:before {
  content: "\\e8a0";
}

/* '' */
.uil-briefcase-alt:before {
  content: "\\e8a1";
}

/* '' */
.uil-briefcase:before {
  content: "\\e8a2";
}

/* '' */
.uil-bright:before {
  content: "\\e8a3";
}

/* '' */
.uil-brightness-empty:before {
  content: "\\e8a4";
}

/* '' */
.uil-brightness-half:before {
  content: "\\e8a5";
}

/* '' */
.uil-brightness-low:before {
  content: "\\e8a6";
}

/* '' */
.uil-brightness-minus:before {
  content: "\\e8a7";
}

/* '' */
.uil-brightness-plus:before {
  content: "\\e8a8";
}

/* '' */
.uil-brightness:before {
  content: "\\e8a9";
}

/* '' */
.uil-bring-bottom:before {
  content: "\\e8aa";
}

/* '' */
.uil-bring-front:before {
  content: "\\e8ab";
}

/* '' */
.uil-brush-alt:before {
  content: "\\e8ac";
}

/* '' */
.uil-bug:before {
  content: "\\e8ad";
}

/* '' */
.uil-building:before {
  content: "\\e8ae";
}

/* '' */
.uil-bullseye:before {
  content: "\\e8af";
}

/* '' */
.uil-bus-alt:before {
  content: "\\e8b0";
}

/* '' */
.uil-bus-school:before {
  content: "\\e8b1";
}

/* '' */
.uil-bus:before {
  content: "\\e8b2";
}

/* '' */
.uil-calcualtor:before {
  content: "\\e8b3";
}

/* '' */
.uil-calculator-alt:before {
  content: "\\e8b4";
}

/* '' */
.uil-calculator:before {
  content: "\\e8b5";
}

/* '' */
.uil-calendar-alt:before {
  content: "\\e8b6";
}

/* '' */
.uil-calendar-slash:before {
  content: "\\e8b7";
}

/* '' */
.uil-calender:before {
  content: "\\e8b8";
}

/* '' */
.uil-calling:before {
  content: "\\e8b9";
}

/* '' */
.uil-camera-change:before {
  content: "\\e8ba";
}

/* '' */
.uil-camera-plus:before {
  content: "\\e8bb";
}

/* '' */
.uil-camera-slash:before {
  content: "\\e8bc";
}

/* '' */
.uil-camera:before {
  content: "\\e8bd";
}

/* '' */
.uil-cancel:before {
  content: "\\e8be";
}

/* '' */
.uil-capsule:before {
  content: "\\e8bf";
}

/* '' */
.uil-capture:before {
  content: "\\e8c0";
}

/* '' */
.uil-car-sideview:before {
  content: "\\e8c1";
}

/* '' */
.uil-car-slash:before {
  content: "\\e8c2";
}

/* '' */
.uil-car-wash:before {
  content: "\\e8c3";
}

/* '' */
.uil-car:before {
  content: "\\e8c4";
}

/* '' */
.uil-card-atm:before {
  content: "\\e8c5";
}

/* '' */
.uil-caret-right:before {
  content: "\\e8c6";
}

/* '' */
.uil-cart:before {
  content: "\\e8c7";
}

/* '' */
.uil-cell:before {
  content: "\\e8c8";
}

/* '' */
.uil-celsius:before {
  content: "\\e8c9";
}

/* '' */
.uil-chart-bar-alt:before {
  content: "\\e8ca";
}

/* '' */
.uil-chart-bar:before {
  content: "\\e8cb";
}

/* '' */
.uil-chart-down:before {
  content: "\\e8cc";
}

/* '' */
.uil-chart-growth-alt:before {
  content: "\\e8cd";
}

/* '' */
.uil-chart-growth:before {
  content: "\\e8ce";
}

/* '' */
.uil-chart-line:before {
  content: "\\e8cf";
}

/* '' */
.uil-chart-pie-alt:before {
  content: "\\e8d0";
}

/* '' */
.uil-chart-pie:before {
  content: "\\e8d1";
}

/* '' */
.uil-chart:before {
  content: "\\e8d2";
}

/* '' */
.uil-chat-bubble-user:before {
  content: "\\e8d3";
}

/* '' */
.uil-chat-info:before {
  content: "\\e8d4";
}

/* '' */
.uil-chat:before {
  content: "\\e8d5";
}

/* '' */
.uil-check-circle:before {
  content: "\\e8d6";
}

/* '' */
.uil-check-square:before {
  content: "\\e8d7";
}

/* '' */
.uil-check:before {
  content: "\\e8d8";
}

/* '' */
.uil-circle-layer:before {
  content: "\\e8d9";
}

/* '' */
.uil-circle:before {
  content: "\\e8da";
}

/* '' */
.uil-circuit:before {
  content: "\\e8db";
}

/* '' */
.uil-clapper-board:before {
  content: "\\e8dc";
}

/* '' */
.uil-clipboard-alt:before {
  content: "\\e8dd";
}

/* '' */
.uil-clipboard-blank:before {
  content: "\\e8de";
}

/* '' */
.uil-clipboard-notes:before {
  content: "\\e8df";
}

/* '' */
.uil-clipboard:before {
  content: "\\e8e0";
}

/* '' */
.uil-clock-eight:before {
  content: "\\e8e1";
}

/* '' */
.uil-clock-five:before {
  content: "\\e8e2";
}

/* '' */
.uil-clock-nine:before {
  content: "\\e8e3";
}

/* '' */
.uil-clock-seven:before {
  content: "\\e8e4";
}

/* '' */
.uil-clock-ten:before {
  content: "\\e8e5";
}

/* '' */
.uil-clock-three:before {
  content: "\\e8e6";
}

/* '' */
.uil-clock-two:before {
  content: "\\e8e7";
}

/* '' */
.uil-clock:before {
  content: "\\e8e8";
}

/* '' */
.uil-closed-captioning:before {
  content: "\\e8e9";
}

/* '' */
.uil-cloud-block:before {
  content: "\\e8ea";
}

/* '' */
.uil-cloud-bookmark:before {
  content: "\\e8eb";
}

/* '' */
.uil-cloud-check:before {
  content: "\\e8ec";
}

/* '' */
.uil-cloud-computing:before {
  content: "\\e8ed";
}

/* '' */
.uil-cloud-data-connection:before {
  content: "\\e8ee";
}

/* '' */
.uil-cloud-database-tree:before {
  content: "\\e8ef";
}

/* '' */
.uil-cloud-download:before {
  content: "\\e8f0";
}

/* '' */
.uil-cloud-drizzle:before {
  content: "\\e8f1";
}

/* '' */
.uil-cloud-exclamation:before {
  content: "\\e8f2";
}

/* '' */
.uil-cloud-hail:before {
  content: "\\e8f3";
}

/* '' */
.uil-cloud-heart:before {
  content: "\\e8f4";
}

/* '' */
.uil-cloud-info:before {
  content: "\\e8f5";
}

/* '' */
.uil-cloud-lock:before {
  content: "\\e8f6";
}

/* '' */
.uil-cloud-meatball:before {
  content: "\\e8f7";
}

/* '' */
.uil-cloud-moon-hail:before {
  content: "\\e8f8";
}

/* '' */
.uil-cloud-moon-meatball:before {
  content: "\\e8f9";
}

/* '' */
.uil-cloud-moon-rain:before {
  content: "\\e8fa";
}

/* '' */
.uil-cloud-moon-showers:before {
  content: "\\e8fb";
}

/* '' */
.uil-cloud-moon:before {
  content: "\\e8fc";
}

/* '' */
.uil-cloud-question:before {
  content: "\\e8fd";
}

/* '' */
.uil-cloud-rain-sun:before {
  content: "\\e8fe";
}

/* '' */
.uil-cloud-rain:before {
  content: "\\e8ff";
}

/* '' */
.uil-cloud-redo:before {
  content: "\\e900";
}

/* '' */
.uil-cloud-set:before {
  content: "\\e901";
}

/* '' */
.uil-cloud-share:before {
  content: "\\e902";
}

/* '' */
.uil-cloud-shield:before {
  content: "\\e903";
}

/* '' */
.uil-cloud-showers-alt:before {
  content: "\\e904";
}

/* '' */
.uil-cloud-showers-heavy:before {
  content: "\\e905";
}

/* '' */
.uil-cloud-showers:before {
  content: "\\e906";
}

/* '' */
.uil-cloud-slash:before {
  content: "\\e907";
}

/* '' */
.uil-cloud-sun-hail:before {
  content: "\\e908";
}

/* '' */
.uil-cloud-sun-meatball:before {
  content: "\\e909";
}

/* '' */
.uil-cloud-sun-rain-alt:before {
  content: "\\e90a";
}

/* '' */
.uil-cloud-sun-rain:before {
  content: "\\e90b";
}

/* '' */
.uil-cloud-sun-tear:before {
  content: "\\e90c";
}

/* '' */
.uil-cloud-sun:before {
  content: "\\e90d";
}

/* '' */
.uil-cloud-times:before {
  content: "\\e90e";
}

/* '' */
.uil-cloud-unlock:before {
  content: "\\e90f";
}

/* '' */
.uil-cloud-upload:before {
  content: "\\e910";
}

/* '' */
.uil-cloud-wifi:before {
  content: "\\e911";
}

/* '' */
.uil-cloud-wind:before {
  content: "\\e912";
}

/* '' */
.uil-cloud:before {
  content: "\\e913";
}

/* '' */
.uil-clouds:before {
  content: "\\e914";
}

/* '' */
.uil-club:before {
  content: "\\e915";
}

/* '' */
.uil-code:before {
  content: "\\e916";
}

/* '' */
.uil-coffee:before {
  content: "\\e917";
}

/* '' */
.uil-cog:before {
  content: "\\e918";
}

/* '' */
.uil-coins:before {
  content: "\\e919";
}

/* '' */
.uil-columns:before {
  content: "\\e91a";
}

/* '' */
.uil-comment-alt-block:before {
  content: "\\e91b";
}

/* '' */
.uil-comment-alt-chart-lines:before {
  content: "\\e91c";
}

/* '' */
.uil-comment-alt-check:before {
  content: "\\e91d";
}

/* '' */
.uil-comment-alt-dots:before {
  content: "\\e91e";
}

/* '' */
.uil-comment-alt-download:before {
  content: "\\e91f";
}

/* '' */
.uil-comment-alt-edit:before {
  content: "\\e920";
}

/* '' */
.uil-comment-alt-exclamation:before {
  content: "\\e921";
}

/* '' */
.uil-comment-alt-heart:before {
  content: "\\e922";
}

/* '' */
.uil-comment-alt-image:before {
  content: "\\e923";
}

/* '' */
.uil-comment-alt-info:before {
  content: "\\e924";
}

/* '' */
.uil-comment-alt-lines:before {
  content: "\\e925";
}

/* '' */
.uil-comment-alt-lock:before {
  content: "\\e926";
}

/* '' */
.uil-comment-alt-medical:before {
  content: "\\e927";
}

/* '' */
.uil-comment-alt-message:before {
  content: "\\e928";
}

/* '' */
.uil-comment-alt-notes:before {
  content: "\\e929";
}

/* '' */
.uil-comment-alt-plus:before {
  content: "\\e92a";
}

/* '' */
.uil-comment-alt-question:before {
  content: "\\e92b";
}

/* '' */
.uil-comment-alt-redo:before {
  content: "\\e92c";
}

/* '' */
.uil-comment-alt-search:before {
  content: "\\e92d";
}

/* '' */
.uil-comment-alt-share:before {
  content: "\\e92e";
}

/* '' */
.uil-comment-alt-shield:before {
  content: "\\e92f";
}

/* '' */
.uil-comment-alt-slash:before {
  content: "\\e930";
}

/* '' */
.uil-comment-alt-upload:before {
  content: "\\e931";
}

/* '' */
.uil-comment-alt-verify:before {
  content: "\\e932";
}

/* '' */
.uil-comment-alt:before {
  content: "\\e933";
}

/* '' */
.uil-comment-block:before {
  content: "\\e934";
}

/* '' */
.uil-comment-chart-line:before {
  content: "\\e935";
}

/* '' */
.uil-comment-check:before {
  content: "\\e936";
}

/* '' */
.uil-comment-dots:before {
  content: "\\e937";
}

/* '' */
.uil-comment-download:before {
  content: "\\e938";
}

/* '' */
.uil-comment-edit:before {
  content: "\\e939";
}

/* '' */
.uil-comment-exclamation:before {
  content: "\\e93a";
}

/* '' */
.uil-comment-heart:before {
  content: "\\e93b";
}

/* '' */
.uil-comment-image:before {
  content: "\\e93c";
}

/* '' */
.uil-comment-info-alt:before {
  content: "\\e93d";
}

/* '' */
.uil-comment-info:before {
  content: "\\e93e";
}

/* '' */
.uil-comment-lines:before {
  content: "\\e93f";
}

/* '' */
.uil-comment-lock:before {
  content: "\\e940";
}

/* '' */
.uil-comment-medical:before {
  content: "\\e941";
}

/* '' */
.uil-comment-message:before {
  content: "\\e942";
}

/* '' */
.uil-comment-notes:before {
  content: "\\e943";
}

/* '' */
.uil-comment-plus:before {
  content: "\\e944";
}

/* '' */
.uil-comment-question:before {
  content: "\\e945";
}

/* '' */
.uil-comment-redo:before {
  content: "\\e946";
}

/* '' */
.uil-comment-search:before {
  content: "\\e947";
}

/* '' */
.uil-comment-share:before {
  content: "\\e948";
}

/* '' */
.uil-comment-shield:before {
  content: "\\e949";
}

/* '' */
.uil-comment-slash:before {
  content: "\\e94a";
}

/* '' */
.uil-comment-upload:before {
  content: "\\e94b";
}

/* '' */
.uil-comment-verify:before {
  content: "\\e94c";
}

/* '' */
.uil-comment:before {
  content: "\\e94d";
}

/* '' */
.uil-comments-alt:before {
  content: "\\e94e";
}

/* '' */
.uil-comments:before {
  content: "\\e94f";
}

/* '' */
.uil-commnet-alt-slash:before {
  content: "\\e950";
}

/* '' */
.uil-compact-disc:before {
  content: "\\e951";
}

/* '' */
.uil-compass:before {
  content: "\\e952";
}

/* '' */
.uil-compress-alt-left:before {
  content: "\\e953";
}

/* '' */
.uil-compress-alt:before {
  content: "\\e954";
}

/* '' */
.uil-compress-arrows:before {
  content: "\\e955";
}

/* '' */
.uil-compress-lines:before {
  content: "\\e956";
}

/* '' */
.uil-compress-point:before {
  content: "\\e957";
}

/* '' */
.uil-compress-v:before {
  content: "\\e958";
}

/* '' */
.uil-compress:before {
  content: "\\e959";
}

/* '' */
.uil-computer-mouse:before {
  content: "\\e95a";
}

/* '' */
.uil-confused:before {
  content: "\\e95b";
}

/* '' */
.uil-constructor:before {
  content: "\\e95c";
}

/* '' */
.uil-copy-alt:before {
  content: "\\e95d";
}

/* '' */
.uil-copy-landscape:before {
  content: "\\e95e";
}

/* '' */
.uil-copy:before {
  content: "\\e95f";
}

/* '' */
.uil-copyright:before {
  content: "\\e960";
}

/* '' */
.uil-corner-down-left:before {
  content: "\\e961";
}

/* '' */
.uil-corner-down-right-alt:before {
  content: "\\e962";
}

/* '' */
.uil-corner-down-right:before {
  content: "\\e963";
}

/* '' */
.uil-corner-left-down:before {
  content: "\\e964";
}

/* '' */
.uil-corner-right-down:before {
  content: "\\e965";
}

/* '' */
.uil-corner-up-left-alt:before {
  content: "\\e966";
}

/* '' */
.uil-corner-up-left:before {
  content: "\\e967";
}

/* '' */
.uil-corner-up-right-alt:before {
  content: "\\e968";
}

/* '' */
.uil-corner-up-right:before {
  content: "\\e969";
}

/* '' */
.uil-creative-commons-pd-alt:before {
  content: "\\e96a";
}

/* '' */
.uil-creative-commons-pd:before {
  content: "\\e96b";
}

/* '' */
.uil-crockery:before {
  content: "\\e96c";
}

/* '' */
.uil-crop-alt-rotate-left:before {
  content: "\\e96d";
}

/* '' */
.uil-crop-alt-rotate-right:before {
  content: "\\e96e";
}

/* '' */
.uil-crop-alt:before {
  content: "\\e96f";
}

/* '' */
.uil-crosshair-alt:before {
  content: "\\e970";
}

/* '' */
.uil-crosshair:before {
  content: "\\e971";
}

/* '' */
.uil-crosshairs:before {
  content: "\\e972";
}

/* '' */
.uil-cube:before {
  content: "\\e973";
}

/* '' */
.uil-dashboard:before {
  content: "\\e974";
}

/* '' */
.uil-data-sharing:before {
  content: "\\e975";
}

/* '' */
.uil-database-alt:before {
  content: "\\e976";
}

/* '' */
.uil-database:before {
  content: "\\e977";
}

/* '' */
.uil-desert:before {
  content: "\\e978";
}

/* '' */
.uil-desktop-alt-slash:before {
  content: "\\e979";
}

/* '' */
.uil-desktop-alt:before {
  content: "\\e97a";
}

/* '' */
.uil-desktop-cloud-alt:before {
  content: "\\e97b";
}

/* '' */
.uil-desktop-slash:before {
  content: "\\e97c";
}

/* '' */
.uil-desktop:before {
  content: "\\e97d";
}

/* '' */
.uil-dialpad-alt:before {
  content: "\\e97e";
}

/* '' */
.uil-dialpad:before {
  content: "\\e97f";
}

/* '' */
.uil-diamond:before {
  content: "\\e980";
}

/* '' */
.uil-diary-alt:before {
  content: "\\e981";
}

/* '' */
.uil-diary:before {
  content: "\\e982";
}

/* '' */
.uil-dice-five:before {
  content: "\\e983";
}

/* '' */
.uil-dice-four:before {
  content: "\\e984";
}

/* '' */
.uil-dice-one:before {
  content: "\\e985";
}

/* '' */
.uil-dice-six:before {
  content: "\\e986";
}

/* '' */
.uil-dice-three:before {
  content: "\\e987";
}

/* '' */
.uil-dice-two:before {
  content: "\\e988";
}

/* '' */
.uil-direction:before {
  content: "\\e989";
}

/* '' */
.uil-directions:before {
  content: "\\e98a";
}

/* '' */
.uil-dizzy-meh:before {
  content: "\\e98b";
}

/* '' */
.uil-dna:before {
  content: "\\e98c";
}

/* '' */
.uil-document-layout-center:before {
  content: "\\e98d";
}

/* '' */
.uil-document-layout-left:before {
  content: "\\e98e";
}

/* '' */
.uil-document-layout-right:before {
  content: "\\e98f";
}

/* '' */
.uil-document:before {
  content: "\\e990";
}

/* '' */
.uil-dollar-alt:before {
  content: "\\e991";
}

/* '' */
.uil-dollar-sign-alt:before {
  content: "\\e992";
}

/* '' */
.uil-dollar-sign:before {
  content: "\\e993";
}

/* '' */
.uil-down-arrow:before {
  content: "\\e994";
}

/* '' */
.uil-download-alt:before {
  content: "\\e995";
}

/* '' */
.uil-dribbble:before {
  content: "\\e996";
}

/* '' */
.uil-drill:before {
  content: "\\e997";
}

/* '' */
.uil-dropbox:before {
  content: "\\e998";
}

/* '' */
.uil-dumbbell:before {
  content: "\\e999";
}

/* '' */
.uil-ear:before {
  content: "\\e99a";
}

/* '' */
.uil-edit-alt:before {
  content: "\\e99b";
}

/* '' */
.uil-edit:before {
  content: "\\e99c";
}

/* '' */
.uil-ellipsis-h:before {
  content: "\\e99d";
}

/* '' */
.uil-ellipsis-v:before {
  content: "\\e99e";
}

/* '' */
.uil-emoji:before {
  content: "\\e99f";
}

/* '' */
.uil-enter:before {
  content: "\\e9a0";
}

/* '' */
.uil-entry:before {
  content: "\\e9a1";
}

/* '' */
.uil-envelope-add:before {
  content: "\\e9a2";
}

/* '' */
.uil-envelope-alt:before {
  content: "\\e9a3";
}

/* '' */
.uil-envelope-block:before {
  content: "\\e9a4";
}

/* '' */
.uil-envelope-bookmark:before {
  content: "\\e9a5";
}

/* '' */
.uil-envelope-check:before {
  content: "\\e9a6";
}

/* '' */
.uil-envelope-download-alt:before {
  content: "\\e9a7";
}

/* '' */
.uil-envelope-download:before {
  content: "\\e9a8";
}

/* '' */
.uil-envelope-edit:before {
  content: "\\e9a9";
}

/* '' */
.uil-envelope-exclamation:before {
  content: "\\e9aa";
}

/* '' */
.uil-envelope-heart:before {
  content: "\\e9ab";
}

/* '' */
.uil-envelope-info:before {
  content: "\\e9ac";
}

/* '' */
.uil-envelope-lock:before {
  content: "\\e9ad";
}

/* '' */
.uil-envelope-minus:before {
  content: "\\e9ae";
}

/* '' */
.uil-envelope-open:before {
  content: "\\e9af";
}

/* '' */
.uil-envelope-question:before {
  content: "\\e9b0";
}

/* '' */
.uil-envelope-receive:before {
  content: "\\e9b1";
}

/* '' */
.uil-envelope-redo:before {
  content: "\\e9b2";
}

/* '' */
.uil-envelope-search:before {
  content: "\\e9b3";
}

/* '' */
.uil-envelope-send:before {
  content: "\\e9b4";
}

/* '' */
.uil-envelope-share:before {
  content: "\\e9b5";
}

/* '' */
.uil-envelope-shield:before {
  content: "\\e9b6";
}

/* '' */
.uil-envelope-star:before {
  content: "\\e9b7";
}

/* '' */
.uil-envelope-times:before {
  content: "\\e9b8";
}

/* '' */
.uil-envelope-upload-alt:before {
  content: "\\e9b9";
}

/* '' */
.uil-envelope-upload:before {
  content: "\\e9ba";
}

/* '' */
.uil-envelope:before {
  content: "\\e9bb";
}

/* '' */
.uil-envelopes:before {
  content: "\\e9bc";
}

/* '' */
.uil-equal-circle:before {
  content: "\\e9bd";
}

/* '' */
.uil-euro-circle:before {
  content: "\\e9be";
}

/* '' */
.uil-euro:before {
  content: "\\e9bf";
}

/* '' */
.uil-exchange-alt:before {
  content: "\\e9c0";
}

/* '' */
.uil-exchange:before {
  content: "\\e9c1";
}

/* '' */
.uil-exclamation-circle:before {
  content: "\\e9c2";
}

/* '' */
.uil-exclamation-octagon:before {
  content: "\\e9c3";
}

/* '' */
.uil-exclamation-triangle:before {
  content: "\\e9c4";
}

/* '' */
.uil-exclude:before {
  content: "\\e9c5";
}

/* '' */
.uil-exit:before {
  content: "\\e9c6";
}

/* '' */
.uil-expand-alt:before {
  content: "\\e9c7";
}

/* '' */
.uil-expand-arrows-alt:before {
  content: "\\e9c8";
}

/* '' */
.uil-expand-arrows:before {
  content: "\\e9c9";
}

/* '' */
.uil-expand-from-corner:before {
  content: "\\e9ca";
}

/* '' */
.uil-expand-left:before {
  content: "\\e9cb";
}

/* '' */
.uil-expand-right:before {
  content: "\\e9cc";
}

/* '' */
.uil-export:before {
  content: "\\e9cd";
}

/* '' */
.uil-exposure-alt:before {
  content: "\\e9ce";
}

/* '' */
.uil-exposure-increase:before {
  content: "\\e9cf";
}

/* '' */
.uil-external-link-alt:before {
  content: "\\e9d0";
}

/* '' */
.uil-eye-slash:before {
  content: "\\e9d1";
}

/* '' */
.uil-eye:before {
  content: "\\e9d2";
}

/* '' */
.uil-facebook-f:before {
  content: "\\e9d3";
}

/* '' */
.uil-facebook-messenger-alt:before {
  content: "\\e9d4";
}

/* '' */
.uil-facebook-messenger:before {
  content: "\\e9d5";
}

/* '' */
.uil-facebook:before {
  content: "\\e9d6";
}

/* '' */
.uil-fahrenheit:before {
  content: "\\e9d7";
}

/* '' */
.uil-fast-mail-alt:before {
  content: "\\e9d8";
}

/* '' */
.uil-fast-mail:before {
  content: "\\e9d9";
}

/* '' */
.uil-favorite:before {
  content: "\\e9da";
}

/* '' */
.uil-feedback:before {
  content: "\\e9db";
}

/* '' */
.uil-file-alt:before {
  content: "\\e9dc";
}

/* '' */
.uil-file-blank:before {
  content: "\\e9dd";
}

/* '' */
.uil-file-block-alt:before {
  content: "\\e9de";
}

/* '' */
.uil-file-bookmark-alt:before {
  content: "\\e9df";
}

/* '' */
.uil-file-check-alt:before {
  content: "\\e9e0";
}

/* '' */
.uil-file-check:before {
  content: "\\e9e1";
}

/* '' */
.uil-file-contract-dollar:before {
  content: "\\e9e2";
}

/* '' */
.uil-file-copy-alt:before {
  content: "\\e9e3";
}

/* '' */
.uil-file-download-alt:before {
  content: "\\e9e4";
}

/* '' */
.uil-file-download:before {
  content: "\\e9e5";
}

/* '' */
.uil-file-edit-alt:before {
  content: "\\e9e6";
}

/* '' */
.uil-file-exclamation-alt:before {
  content: "\\e9e7";
}

/* '' */
.uil-file-exclamation:before {
  content: "\\e9e8";
}

/* '' */
.uil-file-heart:before {
  content: "\\e9e9";
}

/* '' */
.uil-file-info-alt:before {
  content: "\\e9ea";
}

/* '' */
.uil-file-landscape-alt:before {
  content: "\\e9eb";
}

/* '' */
.uil-file-landscape:before {
  content: "\\e9ec";
}

/* '' */
.uil-file-lanscape-slash:before {
  content: "\\e9ed";
}

/* '' */
.uil-file-lock-alt:before {
  content: "\\e9ee";
}

/* '' */
.uil-file-medical-alt:before {
  content: "\\e9ef";
}

/* '' */
.uil-file-medical:before {
  content: "\\e9f0";
}

/* '' */
.uil-file-minus-alt:before {
  content: "\\e9f1";
}

/* '' */
.uil-file-minus:before {
  content: "\\e9f2";
}

/* '' */
.uil-file-network:before {
  content: "\\e9f3";
}

/* '' */
.uil-file-plus-alt:before {
  content: "\\e9f4";
}

/* '' */
.uil-file-plus:before {
  content: "\\e9f5";
}

/* '' */
.uil-file-question-alt:before {
  content: "\\e9f6";
}

/* '' */
.uil-file-question:before {
  content: "\\e9f7";
}

/* '' */
.uil-file-redo-alt:before {
  content: "\\e9f8";
}

/* '' */
.uil-file-search-alt:before {
  content: "\\e9f9";
}

/* '' */
.uil-file-share-alt:before {
  content: "\\e9fa";
}

/* '' */
.uil-file-shield-alt:before {
  content: "\\e9fb";
}

/* '' */
.uil-file-slash:before {
  content: "\\e9fc";
}

/* '' */
.uil-file-times-alt:before {
  content: "\\e9fd";
}

/* '' */
.uil-file-times:before {
  content: "\\e9fe";
}

/* '' */
.uil-file-upload-alt:before {
  content: "\\e9ff";
}

/* '' */
.uil-file-upload:before {
  content: "\\ea00";
}

/* '' */
.uil-file:before {
  content: "\\ea01";
}

/* '' */
.uil-files-landscapes-alt:before {
  content: "\\ea02";
}

/* '' */
.uil-files-landscapes:before {
  content: "\\ea03";
}

/* '' */
.uil-film:before {
  content: "\\ea04";
}

/* '' */
.uil-filter-slash:before {
  content: "\\ea05";
}

/* '' */
.uil-filter:before {
  content: "\\ea06";
}

/* '' */
.uil-fire:before {
  content: "\\ea07";
}

/* '' */
.uil-flask-potion:before {
  content: "\\ea08";
}

/* '' */
.uil-flask:before {
  content: "\\ea09";
}

/* '' */
.uil-flip-h-alt:before {
  content: "\\ea0a";
}

/* '' */
.uil-flip-h:before {
  content: "\\ea0b";
}

/* '' */
.uil-flip-v-alt:before {
  content: "\\ea0c";
}

/* '' */
.uil-flip-v:before {
  content: "\\ea0d";
}

/* '' */
.uil-flower:before {
  content: "\\ea0e";
}

/* '' */
.uil-focus-add:before {
  content: "\\ea0f";
}

/* '' */
.uil-focus-target:before {
  content: "\\ea10";
}

/* '' */
.uil-focus:before {
  content: "\\ea11";
}

/* '' */
.uil-folder-check:before {
  content: "\\ea12";
}

/* '' */
.uil-folder-download:before {
  content: "\\ea13";
}

/* '' */
.uil-folder-exclamation:before {
  content: "\\ea14";
}

/* '' */
.uil-folder-heart:before {
  content: "\\ea15";
}

/* '' */
.uil-folder-info:before {
  content: "\\ea16";
}

/* '' */
.uil-folder-lock:before {
  content: "\\ea17";
}

/* '' */
.uil-folder-medical:before {
  content: "\\ea18";
}

/* '' */
.uil-folder-minus:before {
  content: "\\ea19";
}

/* '' */
.uil-folder-network:before {
  content: "\\ea1a";
}

/* '' */
.uil-folder-plus:before {
  content: "\\ea1b";
}

/* '' */
.uil-folder-question:before {
  content: "\\ea1c";
}

/* '' */
.uil-folder-slash:before {
  content: "\\ea1d";
}

/* '' */
.uil-folder-times:before {
  content: "\\ea1e";
}

/* '' */
.uil-folder-upload:before {
  content: "\\ea1f";
}

/* '' */
.uil-folder:before {
  content: "\\ea20";
}

/* '' */
.uil-food:before {
  content: "\\ea21";
}

/* '' */
.uil-football-american:before {
  content: "\\ea22";
}

/* '' */
.uil-football-ball:before {
  content: "\\ea23";
}

/* '' */
.uil-football:before {
  content: "\\ea24";
}

/* '' */
.uil-forecastcloud-moon-tear:before {
  content: "\\ea25";
}

/* '' */
.uil-forwaded-call:before {
  content: "\\ea26";
}

/* '' */
.uil-forward:before {
  content: "\\ea27";
}

/* '' */
.uil-frown:before {
  content: "\\ea28";
}

/* '' */
.uil-game-structure:before {
  content: "\\ea29";
}

/* '' */
.uil-game:before {
  content: "\\ea2a";
}

/* '' */
.uil-gift:before {
  content: "\\ea2b";
}

/* '' */
.uil-github-alt:before {
  content: "\\ea2c";
}

/* '' */
.uil-github:before {
  content: "\\ea2d";
}

/* '' */
.uil-glass-martini-alt-slash:before {
  content: "\\ea2e";
}

/* '' */
.uil-glass-martini-alt:before {
  content: "\\ea2f";
}

/* '' */
.uil-glass-martini:before {
  content: "\\ea30";
}

/* '' */
.uil-glass-tea:before {
  content: "\\ea31";
}

/* '' */
.uil-glass:before {
  content: "\\ea32";
}

/* '' */
.uil-globe:before {
  content: "\\ea33";
}

/* '' */
.uil-gold:before {
  content: "\\ea34";
}

/* '' */
.uil-google-drive-alt:before {
  content: "\\ea35";
}

/* '' */
.uil-google-drive:before {
  content: "\\ea36";
}

/* '' */
.uil-google-hangouts-alt:before {
  content: "\\ea37";
}

/* '' */
.uil-google-hangouts:before {
  content: "\\ea38";
}

/* '' */
.uil-google-play:before {
  content: "\\ea39";
}

/* '' */
.uil-google:before {
  content: "\\ea3a";
}

/* '' */
.uil-graduation-hat:before {
  content: "\\ea3b";
}

/* '' */
.uil-graph-bar:before {
  content: "\\ea3c";
}

/* '' */
.uil-grid:before {
  content: "\\ea3d";
}

/* '' */
.uil-grids:before {
  content: "\\ea3e";
}

/* '' */
.uil-grin-tongue-wink-alt:before {
  content: "\\ea3f";
}

/* '' */
.uil-grin-tongue-wink:before {
  content: "\\ea40";
}

/* '' */
.uil-grin:before {
  content: "\\ea41";
}

/* '' */
.uil-grip-horizontal-line:before {
  content: "\\ea42";
}

/* '' */
.uil-hdd:before {
  content: "\\ea43";
}

/* '' */
.uil-headphones-alt:before {
  content: "\\ea44";
}

/* '' */
.uil-headphones:before {
  content: "\\ea45";
}

/* '' */
.uil-heart-alt:before {
  content: "\\ea46";
}

/* '' */
.uil-heart-medical:before {
  content: "\\ea47";
}

/* '' */
.uil-heart-rate:before {
  content: "\\ea48";
}

/* '' */
.uil-heart-sign:before {
  content: "\\ea49";
}

/* '' */
.uil-heart:before {
  content: "\\ea4a";
}

/* '' */
.uil-heartbeat:before {
  content: "\\ea4b";
}

/* '' */
.uil-history-alt:before {
  content: "\\ea4c";
}

/* '' */
.uil-history:before {
  content: "\\ea4d";
}

/* '' */
.uil-home-alt:before {
  content: "\\ea4e";
}

/* '' */
.uil-home:before {
  content: "\\ea4f";
}

/* '' */
.uil-horizontal-align-center:before {
  content: "\\ea50";
}

/* '' */
.uil-horizontal-align-left:before {
  content: "\\ea51";
}

/* '' */
.uil-horizontal-align-right:before {
  content: "\\ea52";
}

/* '' */
.uil-horizontal-distribution-center:before {
  content: "\\ea53";
}

/* '' */
.uil-horizontal-distribution-left:before {
  content: "\\ea54";
}

/* '' */
.uil-horizontal-distribution-right:before {
  content: "\\ea55";
}

/* '' */
.uil-hourglass:before {
  content: "\\ea56";
}

/* '' */
.uil-html3-alt:before {
  content: "\\ea57";
}

/* '' */
.uil-html3:before {
  content: "\\ea58";
}

/* '' */
.uil-hunting:before {
  content: "\\ea59";
}

/* '' */
.uil-image-alt-slash:before {
  content: "\\ea5a";
}

/* '' */
.uil-image-block:before {
  content: "\\ea5b";
}

/* '' */
.uil-image-broken:before {
  content: "\\ea5c";
}

/* '' */
.uil-image-check:before {
  content: "\\ea5d";
}

/* '' */
.uil-image-download:before {
  content: "\\ea5e";
}

/* '' */
.uil-image-edit:before {
  content: "\\ea5f";
}

/* '' */
.uil-image-lock:before {
  content: "\\ea60";
}

/* '' */
.uil-image-minus:before {
  content: "\\ea61";
}

/* '' */
.uil-image-plus:before {
  content: "\\ea62";
}

/* '' */
.uil-image-question:before {
  content: "\\ea63";
}

/* '' */
.uil-image-redo:before {
  content: "\\ea64";
}

/* '' */
.uil-image-resize-landscape:before {
  content: "\\ea65";
}

/* '' */
.uil-image-resize-square:before {
  content: "\\ea66";
}

/* '' */
.uil-image-search:before {
  content: "\\ea67";
}

/* '' */
.uil-image-share:before {
  content: "\\ea68";
}

/* '' */
.uil-image-shield:before {
  content: "\\ea69";
}

/* '' */
.uil-image-slash:before {
  content: "\\ea6a";
}

/* '' */
.uil-image-times:before {
  content: "\\ea6b";
}

/* '' */
.uil-image-upload:before {
  content: "\\ea6c";
}

/* '' */
.uil-image-v:before {
  content: "\\ea6d";
}

/* '' */
.uil-image:before {
  content: "\\ea6e";
}

/* '' */
.uil-images:before {
  content: "\\ea6f";
}

/* '' */
.uil-import:before {
  content: "\\ea70";
}

/* '' */
.uil-incoming-call:before {
  content: "\\ea71";
}

/* '' */
.uil-info-circle:before {
  content: "\\ea72";
}

/* '' */
.uil-instagram-alt:before {
  content: "\\ea73";
}

/* '' */
.uil-instagram:before {
  content: "\\ea74";
}

/* '' */
.uil-intercom-alt:before {
  content: "\\ea75";
}

/* '' */
.uil-intercom:before {
  content: "\\ea76";
}

/* '' */
.uil-invoice:before {
  content: "\\ea77";
}

/* '' */
.uil-italic:before {
  content: "\\ea78";
}

/* '' */
.uil-jackhammer:before {
  content: "\\ea79";
}

/* '' */
.uil-java-script:before {
  content: "\\ea7a";
}

/* '' */
.uil-kayak:before {
  content: "\\ea7b";
}

/* '' */
.uil-key-skeleton-alt:before {
  content: "\\ea7c";
}

/* '' */
.uil-key-skeleton:before {
  content: "\\ea7d";
}

/* '' */
.uil-keyboard-alt:before {
  content: "\\ea7e";
}

/* '' */
.uil-keyboard-hide:before {
  content: "\\ea7f";
}

/* '' */
.uil-keyboard-show:before {
  content: "\\ea80";
}

/* '' */
.uil-keyboard:before {
  content: "\\ea81";
}

/* '' */
.uil-keyhole-circle:before {
  content: "\\ea82";
}

/* '' */
.uil-keyhole-square-full:before {
  content: "\\ea83";
}

/* '' */
.uil-keyhole-square:before {
  content: "\\ea84";
}

/* '' */
.uil-kid:before {
  content: "\\ea85";
}

/* '' */
.uil-label-alt:before {
  content: "\\ea86";
}

/* '' */
.uil-label:before {
  content: "\\ea87";
}

/* '' */
.uil-lamp:before {
  content: "\\ea88";
}

/* '' */
.uil-laptop-cloud:before {
  content: "\\ea89";
}

/* '' */
.uil-laptop:before {
  content: "\\ea8a";
}

/* '' */
.uil-laughing:before {
  content: "\\ea8b";
}

/* '' */
.uil-layer-group-slash:before {
  content: "\\ea8c";
}

/* '' */
.uil-layer-group:before {
  content: "\\ea8d";
}

/* '' */
.uil-layers-alt:before {
  content: "\\ea8e";
}

/* '' */
.uil-layers-slash:before {
  content: "\\ea8f";
}

/* '' */
.uil-layers:before {
  content: "\\ea90";
}

/* '' */
.uil-left-arrow-from-left:before {
  content: "\\ea91";
}

/* '' */
.uil-left-arrow-to-left:before {
  content: "\\ea92";
}

/* '' */
.uil-left-indent-alt:before {
  content: "\\ea93";
}

/* '' */
.uil-left-indent:before {
  content: "\\ea94";
}

/* '' */
.uil-left-to-right-text-direction:before {
  content: "\\ea95";
}

/* '' */
.uil-life-ring:before {
  content: "\\ea96";
}

/* '' */
.uil-lightbulb-alt:before {
  content: "\\ea97";
}

/* '' */
.uil-lightbulb:before {
  content: "\\ea98";
}

/* '' */
.uil-line-alt:before {
  content: "\\ea99";
}

/* '' */
.uil-line-spacing:before {
  content: "\\ea9a";
}

/* '' */
.uil-line:before {
  content: "\\ea9b";
}

/* '' */
.uil-link-alt:before {
  content: "\\ea9c";
}

/* '' */
.uil-link-broken:before {
  content: "\\ea9d";
}

/* '' */
.uil-link-h:before {
  content: "\\ea9e";
}

/* '' */
.uil-link:before {
  content: "\\ea9f";
}

/* '' */
.uil-linkedin-alt:before {
  content: "\\eaa0";
}

/* '' */
.uil-linkedin:before {
  content: "\\eaa1";
}

/* '' */
.uil-list-ui-alt:before {
  content: "\\eaa2";
}

/* '' */
.uil-list-ul:before {
  content: "\\eaa3";
}

/* '' */
.uil-location-arrow-alt:before {
  content: "\\eaa4";
}

/* '' */
.uil-location-arrow:before {
  content: "\\eaa5";
}

/* '' */
.uil-location-pin-alt:before {
  content: "\\eaa6";
}

/* '' */
.uil-location-point:before {
  content: "\\eaa7";
}

/* '' */
.uil-location:before {
  content: "\\eaa8";
}

/* '' */
.uil-lock-access:before {
  content: "\\eaa9";
}

/* '' */
.uil-lock-alt:before {
  content: "\\eaaa";
}

/* '' */
.uil-lock-open-alt:before {
  content: "\\eaab";
}

/* '' */
.uil-lock-slash:before {
  content: "\\eaac";
}

/* '' */
.uil-lock:before {
  content: "\\eaad";
}

/* '' */
.uil-mailbox-alt:before {
  content: "\\eaae";
}

/* '' */
.uil-mailbox:before {
  content: "\\eaaf";
}

/* '' */
.uil-map-marker-alt:before {
  content: "\\eab0";
}

/* '' */
.uil-map-marker-edit:before {
  content: "\\eab1";
}

/* '' */
.uil-map-marker-info:before {
  content: "\\eab2";
}

/* '' */
.uil-map-marker-minus:before {
  content: "\\eab3";
}

/* '' */
.uil-map-marker-plus:before {
  content: "\\eab4";
}

/* '' */
.uil-map-marker-question:before {
  content: "\\eab5";
}

/* '' */
.uil-map-marker-shield:before {
  content: "\\eab6";
}

/* '' */
.uil-map-marker-slash:before {
  content: "\\eab7";
}

/* '' */
.uil-map-marker:before {
  content: "\\eab8";
}

/* '' */
.uil-map-pin-alt:before {
  content: "\\eab9";
}

/* '' */
.uil-map-pin:before {
  content: "\\eaba";
}

/* '' */
.uil-map:before {
  content: "\\eabb";
}

/* '' */
.uil-mars:before {
  content: "\\eabc";
}

/* '' */
.uil-master-card:before {
  content: "\\eabd";
}

/* '' */
.uil-maximize-left:before {
  content: "\\eabe";
}

/* '' */
.uil-medal:before {
  content: "\\eabf";
}

/* '' */
.uil-medical-drip:before {
  content: "\\eac0";
}

/* '' */
.uil-medical-square-full:before {
  content: "\\eac1";
}

/* '' */
.uil-medical-square:before {
  content: "\\eac2";
}

/* '' */
.uil-medical:before {
  content: "\\eac3";
}

/* '' */
.uil-medium-m:before {
  content: "\\eac4";
}

/* '' */
.uil-medkit:before {
  content: "\\eac5";
}

/* '' */
.uil-meeting-board:before {
  content: "\\eac6";
}

/* '' */
.uil-megaphone:before {
  content: "\\eac7";
}

/* '' */
.uil-meh-alt:before {
  content: "\\eac8";
}

/* '' */
.uil-meh-closed-eye:before {
  content: "\\eac9";
}

/* '' */
.uil-meh:before {
  content: "\\eaca";
}

/* '' */
.uil-message:before {
  content: "\\eacb";
}

/* '' */
.uil-metro:before {
  content: "\\eacc";
}

/* '' */
.uil-microphone-slash:before {
  content: "\\eacd";
}

/* '' */
.uil-microphone:before {
  content: "\\eace";
}

/* '' */
.uil-minus-circle:before {
  content: "\\eacf";
}

/* '' */
.uil-minus-path:before {
  content: "\\ead0";
}

/* '' */
.uil-minus-square-full:before {
  content: "\\ead1";
}

/* '' */
.uil-minus-square:before {
  content: "\\ead2";
}

/* '' */
.uil-minus:before {
  content: "\\ead3";
}

/* '' */
.uil-missed-call:before {
  content: "\\ead4";
}

/* '' */
.uil-mobey-bill-slash:before {
  content: "\\ead5";
}

/* '' */
.uil-mobile-android-alt:before {
  content: "\\ead6";
}

/* '' */
.uil-mobile-android:before {
  content: "\\ead7";
}

/* '' */
.uil-mobile-vibrate:before {
  content: "\\ead8";
}

/* '' */
.uil-modem:before {
  content: "\\ead9";
}

/* '' */
.uil-money-bill-stack:before {
  content: "\\eada";
}

/* '' */
.uil-money-bill:before {
  content: "\\eadb";
}

/* '' */
.uil-money-insert:before {
  content: "\\eadc";
}

/* '' */
.uil-money-stack:before {
  content: "\\eadd";
}

/* '' */
.uil-money-withdraw:before {
  content: "\\eade";
}

/* '' */
.uil-money-withdrawal:before {
  content: "\\eadf";
}

/* '' */
.uil-moneybag-alt:before {
  content: "\\eae0";
}

/* '' */
.uil-moneybag:before {
  content: "\\eae1";
}

/* '' */
.uil-monitor-heart-rate:before {
  content: "\\eae2";
}

/* '' */
.uil-monitor:before {
  content: "\\eae3";
}

/* '' */
.uil-moon-eclipse:before {
  content: "\\eae4";
}

/* '' */
.uil-moon:before {
  content: "\\eae5";
}

/* '' */
.uil-moonset:before {
  content: "\\eae6";
}

/* '' */
.uil-mountains-sun:before {
  content: "\\eae7";
}

/* '' */
.uil-mountains:before {
  content: "\\eae8";
}

/* '' */
.uil-mouse-alt:before {
  content: "\\eae9";
}

/* '' */
.uil-mouse:before {
  content: "\\eaea";
}

/* '' */
.uil-multiply:before {
  content: "\\eaeb";
}

/* '' */
.uil-music-note:before {
  content: "\\eaec";
}

/* '' */
.uil-music-tune-slash:before {
  content: "\\eaed";
}

/* '' */
.uil-music:before {
  content: "\\eaee";
}

/* '' */
.uil-n-a:before {
  content: "\\eaef";
}

/* '' */
.uil-navigator:before {
  content: "\\eaf0";
}

/* '' */
.uil-nerd:before {
  content: "\\eaf1";
}

/* '' */
.uil-newspaper:before {
  content: "\\eaf2";
}

/* '' */
.uil-ninja:before {
  content: "\\eaf3";
}

/* '' */
.uil-no-entry:before {
  content: "\\eaf4";
}

/* '' */
.uil-notebooks:before {
  content: "\\eaf5";
}

/* '' */
.uil-notes:before {
  content: "\\eaf6";
}

/* '' */
.uil-object-group:before {
  content: "\\eaf7";
}

/* '' */
.uil-object-ungroup:before {
  content: "\\eaf8";
}

/* '' */
.uil-octagon:before {
  content: "\\eaf9";
}

/* '' */
.uil-opera-alt:before {
  content: "\\eafa";
}

/* '' */
.uil-opera:before {
  content: "\\eafb";
}

/* '' */
.uil-outgoing-call:before {
  content: "\\eafc";
}

/* '' */
.uil-package:before {
  content: "\\eafd";
}

/* '' */
.uil-padlock:before {
  content: "\\eafe";
}

/* '' */
.uil-paint-tool:before {
  content: "\\eaff";
}

/* '' */
.uil-palette:before {
  content: "\\eb00";
}

/* '' */
.uil-panorama-h-alt:before {
  content: "\\eb01";
}

/* '' */
.uil-panorama-h:before {
  content: "\\eb02";
}

/* '' */
.uil-panorama-v:before {
  content: "\\eb03";
}

/* '' */
.uil-paperclip:before {
  content: "\\eb04";
}

/* '' */
.uil-paragraph:before {
  content: "\\eb05";
}

/* '' */
.uil-parcel:before {
  content: "\\eb06";
}

/* '' */
.uil-parking-square:before {
  content: "\\eb07";
}

/* '' */
.uil-pathfinder-unite:before {
  content: "\\eb08";
}

/* '' */
.uil-pathfinder:before {
  content: "\\eb09";
}

/* '' */
.uil-pause-circle:before {
  content: "\\eb0a";
}

/* '' */
.uil-pause:before {
  content: "\\eb0b";
}

/* '' */
.uil-paypal:before {
  content: "\\eb0c";
}

/* '' */
.uil-pen:before {
  content: "\\eb0d";
}

/* '' */
.uil-pentagon:before {
  content: "\\eb0e";
}

/* '' */
.uil-percentage:before {
  content: "\\eb0f";
}

/* '' */
.uil-phone-alt:before {
  content: "\\eb10";
}

/* '' */
.uil-phone-pause:before {
  content: "\\eb11";
}

/* '' */
.uil-phone-slash:before {
  content: "\\eb12";
}

/* '' */
.uil-phone-times:before {
  content: "\\eb13";
}

/* '' */
.uil-phone-volume:before {
  content: "\\eb14";
}

/* '' */
.uil-phone:before {
  content: "\\eb15";
}

/* '' */
.uil-picture:before {
  content: "\\eb16";
}

/* '' */
.uil-plane-arrival:before {
  content: "\\eb17";
}

/* '' */
.uil-plane-departure:before {
  content: "\\eb18";
}

/* '' */
.uil-plane-fly:before {
  content: "\\eb19";
}

/* '' */
.uil-plane:before {
  content: "\\eb1a";
}

/* '' */
.uil-play-circle:before {
  content: "\\eb1b";
}

/* '' */
.uil-play:before {
  content: "\\eb1c";
}

/* '' */
.uil-plug:before {
  content: "\\eb1d";
}

/* '' */
.uil-plus-circle:before {
  content: "\\eb1e";
}

/* '' */
.uil-plus-square:before {
  content: "\\eb1f";
}

/* '' */
.uil-plus:before {
  content: "\\eb20";
}

/* '' */
.uil-podium:before {
  content: "\\eb21";
}

/* '' */
.uil-polygon:before {
  content: "\\eb22";
}

/* '' */
.uil-post-stamp:before {
  content: "\\eb23";
}

/* '' */
.uil-postcard:before {
  content: "\\eb24";
}

/* '' */
.uil-pound-circle:before {
  content: "\\eb25";
}

/* '' */
.uil-pound:before {
  content: "\\eb26";
}

/* '' */
.uil-power:before {
  content: "\\eb27";
}

/* '' */
.uil-prescription-bottle:before {
  content: "\\eb28";
}

/* '' */
.uil-presentation-check:before {
  content: "\\eb29";
}

/* '' */
.uil-presentation-edit:before {
  content: "\\eb2a";
}

/* '' */
.uil-presentation-line:before {
  content: "\\eb2b";
}

/* '' */
.uil-presentation-lines-alt:before {
  content: "\\eb2c";
}

/* '' */
.uil-presentation-minus:before {
  content: "\\eb2d";
}

/* '' */
.uil-presentation-play:before {
  content: "\\eb2e";
}

/* '' */
.uil-presentation-plus:before {
  content: "\\eb2f";
}

/* '' */
.uil-presentation-times:before {
  content: "\\eb30";
}

/* '' */
.uil-presentation:before {
  content: "\\eb31";
}

/* '' */
.uil-previous:before {
  content: "\\eb32";
}

/* '' */
.uil-pricetag-alt:before {
  content: "\\eb33";
}

/* '' */
.uil-print-slash:before {
  content: "\\eb34";
}

/* '' */
.uil-print:before {
  content: "\\eb35";
}

/* '' */
.uil-process:before {
  content: "\\eb36";
}

/* '' */
.uil-processor:before {
  content: "\\eb37";
}

/* '' */
.uil-pump:before {
  content: "\\eb38";
}

/* '' */
.uil-puzzle-piece:before {
  content: "\\eb39";
}

/* '' */
.uil-question-circle:before {
  content: "\\eb3a";
}

/* '' */
.uil-raddit-alien-alt:before {
  content: "\\eb3b";
}

/* '' */
.uil-rainbow:before {
  content: "\\eb3c";
}

/* '' */
.uil-raindrops-alt:before {
  content: "\\eb3d";
}

/* '' */
.uil-raindrops:before {
  content: "\\eb3e";
}

/* '' */
.uil-react:before {
  content: "\\eb3f";
}

/* '' */
.uil-receipt-alt:before {
  content: "\\eb40";
}

/* '' */
.uil-receipt:before {
  content: "\\eb41";
}

/* '' */
.uil-record-audio:before {
  content: "\\eb42";
}

/* '' */
.uil-reddit-alien-alt:before {
  content: "\\eb43";
}

/* '' */
.uil-redo:before {
  content: "\\eb44";
}

/* '' */
.uil-refresh:before {
  content: "\\eb45";
}

/* '' */
.uil-registered:before {
  content: "\\eb46";
}

/* '' */
.uil-repeat:before {
  content: "\\eb47";
}

/* '' */
.uil-restaurant:before {
  content: "\\eb48";
}

/* '' */
.uil-right-indent-alt:before {
  content: "\\eb49";
}

/* '' */
.uil-right-to-left-text-direction:before {
  content: "\\eb4a";
}

/* '' */
.uil-robot:before {
  content: "\\eb4b";
}

/* '' */
.uil-rope-way:before {
  content: "\\eb4c";
}

/* '' */
.uil-rotate-360:before {
  content: "\\eb4d";
}

/* '' */
.uil-rss-alt:before {
  content: "\\eb4e";
}

/* '' */
.uil-rss-interface:before {
  content: "\\eb4f";
}

/* '' */
.uil-rss:before {
  content: "\\eb50";
}

/* '' */
.uil-ruler-combined:before {
  content: "\\eb51";
}

/* '' */
.uil-ruler:before {
  content: "\\eb52";
}

/* '' */
.uil-sad-cry:before {
  content: "\\eb53";
}

/* '' */
.uil-sad-crying:before {
  content: "\\eb54";
}

/* '' */
.uil-sad-dizzy:before {
  content: "\\eb55";
}

/* '' */
.uil-sad-squint:before {
  content: "\\eb56";
}

/* '' */
.uil-sad:before {
  content: "\\eb57";
}

/* '' */
.uil-scaling-left:before {
  content: "\\eb58";
}

/* '' */
.uil-scaling-right:before {
  content: "\\eb59";
}

/* '' */
.uil-scenery:before {
  content: "\\eb5a";
}

/* '' */
.uil-schedule:before {
  content: "\\eb5b";
}

/* '' */
.uil-science:before {
  content: "\\eb5c";
}

/* '' */
.uil-screw:before {
  content: "\\eb5d";
}

/* '' */
.uil-scroll-h:before {
  content: "\\eb5e";
}

/* '' */
.uil-scroll:before {
  content: "\\eb5f";
}

/* '' */
.uil-search-alt:before {
  content: "\\eb60";
}

/* '' */
.uil-search-minus:before {
  content: "\\eb61";
}

/* '' */
.uil-search-plus:before {
  content: "\\eb62";
}

/* '' */
.uil-search:before {
  content: "\\eb63";
}

/* '' */
.uil-selfie:before {
  content: "\\eb64";
}

/* '' */
.uil-server-alt:before {
  content: "\\eb65";
}

/* '' */
.uil-server-connection:before {
  content: "\\eb66";
}

/* '' */
.uil-server-network-alt:before {
  content: "\\eb67";
}

/* '' */
.uil-server-network:before {
  content: "\\eb68";
}

/* '' */
.uil-server:before {
  content: "\\eb69";
}

/* '' */
.uil-servers:before {
  content: "\\eb6a";
}

/* '' */
.uil-servicemark:before {
  content: "\\eb6b";
}

/* '' */
.uil-share-alt:before {
  content: "\\eb6c";
}

/* '' */
.uil-shield-check:before {
  content: "\\eb6d";
}

/* '' */
.uil-shield-exclamation:before {
  content: "\\eb6e";
}

/* '' */
.uil-shield-question:before {
  content: "\\eb6f";
}

/* '' */
.uil-shield-slash:before {
  content: "\\eb70";
}

/* '' */
.uil-shield:before {
  content: "\\eb71";
}

/* '' */
.uil-ship:before {
  content: "\\eb72";
}

/* '' */
.uil-shop:before {
  content: "\\eb73";
}

/* '' */
.uil-shopping-basket:before {
  content: "\\eb74";
}

/* '' */
.uil-shopping-cart-alt:before {
  content: "\\eb75";
}

/* '' */
.uil-shopping-trolley:before {
  content: "\\eb76";
}

/* '' */
.uil-shovel:before {
  content: "\\eb77";
}

/* '' */
.uil-shrink:before {
  content: "\\eb78";
}

/* '' */
.uil-shuffle:before {
  content: "\\eb79";
}

/* '' */
.uil-shutter-alt:before {
  content: "\\eb7a";
}

/* '' */
.uil-shutter:before {
  content: "\\eb7b";
}

/* '' */
.uil-sick:before {
  content: "\\eb7c";
}

/* '' */
.uil-sigma:before {
  content: "\\eb7d";
}

/* '' */
.uil-sign-alt:before {
  content: "\\eb7e";
}

/* '' */
.uil-sign-in-alt:before {
  content: "\\eb7f";
}

/* '' */
.uil-sign-left:before {
  content: "\\eb80";
}

/* '' */
.uil-sign-out-alt:before {
  content: "\\eb81";
}

/* '' */
.uil-sign-right:before {
  content: "\\eb82";
}

/* '' */
.uil-signal-alt-3:before {
  content: "\\eb83";
}

/* '' */
.uil-signal-alt:before {
  content: "\\eb84";
}

/* '' */
.uil-signal:before {
  content: "\\eb85";
}

/* '' */
.uil-silence:before {
  content: "\\eb86";
}

/* '' */
.uil-silent-squint:before {
  content: "\\eb87";
}

/* '' */
.uil-sim-card:before {
  content: "\\eb88";
}

/* '' */
.uil-sitemap:before {
  content: "\\eb89";
}

/* '' */
.uil-skip-forward-alt:before {
  content: "\\eb8a";
}

/* '' */
.uil-skip-forward-circle:before {
  content: "\\eb8b";
}

/* '' */
.uil-skip-forward:before {
  content: "\\eb8c";
}

/* '' */
.uil-skype-alt:before {
  content: "\\eb8d";
}

/* '' */
.uil-skype:before {
  content: "\\eb8e";
}

/* '' */
.uil-slack-alt:before {
  content: "\\eb8f";
}

/* '' */
.uil-slack:before {
  content: "\\eb90";
}

/* '' */
.uil-sliders-v-alt:before {
  content: "\\eb91";
}

/* '' */
.uil-sliders-v:before {
  content: "\\eb92";
}

/* '' */
.uil-smile-beam:before {
  content: "\\eb93";
}

/* '' */
.uil-smile-dizzy:before {
  content: "\\eb94";
}

/* '' */
.uil-smile-squint-wink-alt:before {
  content: "\\eb95";
}

/* '' */
.uil-smile-squint-wink:before {
  content: "\\eb96";
}

/* '' */
.uil-smile-wink-alt:before {
  content: "\\eb97";
}

/* '' */
.uil-smile-wink:before {
  content: "\\eb98";
}

/* '' */
.uil-smile:before {
  content: "\\eb99";
}

/* '' */
.uil-snapchat-alt:before {
  content: "\\eb9a";
}

/* '' */
.uil-snapchat-ghost:before {
  content: "\\eb9b";
}

/* '' */
.uil-snapchat-square:before {
  content: "\\eb9c";
}

/* '' */
.uil-snow-flake:before {
  content: "\\eb9d";
}

/* '' */
.uil-snowflake-alt:before {
  content: "\\eb9e";
}

/* '' */
.uil-snowflake:before {
  content: "\\eb9f";
}

/* '' */
.uil-sort-amount-down:before {
  content: "\\eba0";
}

/* '' */
.uil-sort-amount-up:before {
  content: "\\eba1";
}

/* '' */
.uil-sort:before {
  content: "\\eba2";
}

/* '' */
.uil-sorting:before {
  content: "\\eba3";
}

/* '' */
.uil-space-key:before {
  content: "\\eba4";
}

/* '' */
.uil-spade:before {
  content: "\\eba5";
}

/* '' */
.uil-sperms:before {
  content: "\\eba6";
}

/* '' */
.uil-spin:before {
  content: "\\eba7";
}

/* '' */
.uil-sport:before {
  content: "\\eba8";
}

/* '' */
.uil-square-full:before {
  content: "\\eba9";
}

/* '' */
.uil-square-shape:before {
  content: "\\ebaa";
}

/* '' */
.uil-square:before {
  content: "\\ebab";
}

/* '' */
.uil-squint:before {
  content: "\\ebac";
}

/* '' */
.uil-star-half-alt:before {
  content: "\\ebad";
}

/* '' */
.uil-star:before {
  content: "\\ebae";
}

/* '' */
.uil-step-backward-alt:before {
  content: "\\ebaf";
}

/* '' */
.uil-step-backward-circle:before {
  content: "\\ebb0";
}

/* '' */
.uil-step-backward:before {
  content: "\\ebb1";
}

/* '' */
.uil-step-forward:before {
  content: "\\ebb2";
}

/* '' */
.uil-stop-circle:before {
  content: "\\ebb3";
}

/* '' */
.uil-stopwatch-slash:before {
  content: "\\ebb4";
}

/* '' */
.uil-stopwatch:before {
  content: "\\ebb5";
}

/* '' */
.uil-store-alt:before {
  content: "\\ebb6";
}

/* '' */
.uil-store:before {
  content: "\\ebb7";
}

/* '' */
.uil-streering:before {
  content: "\\ebb8";
}

/* '' */
.uil-stretcher:before {
  content: "\\ebb9";
}

/* '' */
.uil-subject:before {
  content: "\\ebba";
}

/* '' */
.uil-subway-alt:before {
  content: "\\ebbb";
}

/* '' */
.uil-subway:before {
  content: "\\ebbc";
}

/* '' */
.uil-suitcase-alt:before {
  content: "\\ebbd";
}

/* '' */
.uil-suitcase:before {
  content: "\\ebbe";
}

/* '' */
.uil-sun:before {
  content: "\\ebbf";
}

/* '' */
.uil-sunset:before {
  content: "\\ebc0";
}

/* '' */
.uil-surprise:before {
  content: "\\ebc1";
}

/* '' */
.uil-swatchbook:before {
  content: "\\ebc2";
}

/* '' */
.uil-swiggy:before {
  content: "\\ebc3";
}

/* '' */
.uil-swimmer:before {
  content: "\\ebc4";
}

/* '' */
.uil-symbol:before {
  content: "\\ebc5";
}

/* '' */
.uil-sync-exclamation:before {
  content: "\\ebc6";
}

/* '' */
.uil-sync-slash:before {
  content: "\\ebc7";
}

/* '' */
.uil-sync:before {
  content: "\\ebc8";
}

/* '' */
.uil-syringe:before {
  content: "\\ebc9";
}

/* '' */
.uil-table:before {
  content: "\\ebca";
}

/* '' */
.uil-tablet:before {
  content: "\\ebcb";
}

/* '' */
.uil-tablets:before {
  content: "\\ebcc";
}

/* '' */
.uil-tachometer-fast:before {
  content: "\\ebcd";
}

/* '' */
.uil-tag-alt:before {
  content: "\\ebce";
}

/* '' */
.uil-tag:before {
  content: "\\ebcf";
}

/* '' */
.uil-tape:before {
  content: "\\ebd0";
}

/* '' */
.uil-taxi:before {
  content: "\\ebd1";
}

/* '' */
.uil-tear:before {
  content: "\\ebd2";
}

/* '' */
.uil-technology:before {
  content: "\\ebd3";
}

/* '' */
.uil-telegram-alt:before {
  content: "\\ebd4";
}

/* '' */
.uil-telegram:before {
  content: "\\ebd5";
}

/* '' */
.uil-telescope:before {
  content: "\\ebd6";
}

/* '' */
.uil-temperature-empty:before {
  content: "\\ebd7";
}

/* '' */
.uil-temperature-half:before {
  content: "\\ebd8";
}

/* '' */
.uil-temperature-minus:before {
  content: "\\ebd9";
}

/* '' */
.uil-temperature-plus:before {
  content: "\\ebda";
}

/* '' */
.uil-temperature-quarter:before {
  content: "\\ebdb";
}

/* '' */
.uil-temperature-three-quarter:before {
  content: "\\ebdc";
}

/* '' */
.uil-temperature:before {
  content: "\\ebdd";
}

/* '' */
.uil-text-fields:before {
  content: "\\ebde";
}

/* '' */
.uil-text-size:before {
  content: "\\ebdf";
}

/* '' */
.uil-text-strike-through:before {
  content: "\\ebe0";
}

/* '' */
.uil-text:before {
  content: "\\ebe1";
}

/* '' */
.uil-th-large:before {
  content: "\\ebe2";
}

/* '' */
.uil-th-slash:before {
  content: "\\ebe3";
}

/* '' */
.uil-th:before {
  content: "\\ebe4";
}

/* '' */
.uil-thermometer:before {
  content: "\\ebe5";
}

/* '' */
.uil-thumbs-down:before {
  content: "\\ebe6";
}

/* '' */
.uil-thumbs-up:before {
  content: "\\ebe7";
}

/* '' */
.uil-thunderstorm-moon:before {
  content: "\\ebe8";
}

/* '' */
.uil-thunderstorm-sun:before {
  content: "\\ebe9";
}

/* '' */
.uil-thunderstorm:before {
  content: "\\ebea";
}

/* '' */
.uil-ticket:before {
  content: "\\ebeb";
}

/* '' */
.uil-times-circle:before {
  content: "\\ebec";
}

/* '' */
.uil-times-square:before {
  content: "\\ebed";
}

/* '' */
.uil-times:before {
  content: "\\ebee";
}

/* '' */
.uil-toggle-off:before {
  content: "\\ebef";
}

/* '' */
.uil-toggle-on:before {
  content: "\\ebf0";
}

/* '' */
.uil-top-arrow-from-top:before {
  content: "\\ebf1";
}

/* '' */
.uil-top-arrow-to-top:before {
  content: "\\ebf2";
}

/* '' */
.uil-tornado:before {
  content: "\\ebf3";
}

/* '' */
.uil-trademark-circle:before {
  content: "\\ebf4";
}

/* '' */
.uil-trademark:before {
  content: "\\ebf5";
}

/* '' */
.uil-traffic-barrier:before {
  content: "\\ebf6";
}

/* '' */
.uil-trash-alt:before {
  content: "\\ebf7";
}

/* '' */
.uil-trash:before {
  content: "\\ebf8";
}

/* '' */
.uil-trees:before {
  content: "\\ebf9";
}

/* '' */
.uil-triangle:before {
  content: "\\ebfa";
}

/* '' */
.uil-trophy:before {
  content: "\\ebfb";
}

/* '' */
.uil-trowel:before {
  content: "\\ebfc";
}

/* '' */
.uil-truck-case:before {
  content: "\\ebfd";
}

/* '' */
.uil-truck-loading:before {
  content: "\\ebfe";
}

/* '' */
.uil-truck:before {
  content: "\\ebff";
}

/* '' */
.uil-tumblr-alt:before {
  content: "\\ec00";
}

/* '' */
.uil-tumblr-square:before {
  content: "\\ec01";
}

/* '' */
.uil-tumblr:before {
  content: "\\ec02";
}

/* '' */
.uil-tv-retro-slash:before {
  content: "\\ec03";
}

/* '' */
.uil-tv-retro:before {
  content: "\\ec04";
}

/* '' */
.uil-twitter-alt:before {
  content: "\\ec05";
}

/* '' */
.uil-twitter:before {
  content: "\\ec06";
}

/* '' */
.uil-umbrella:before {
  content: "\\ec07";
}

/* '' */
.uil-unamused:before {
  content: "\\ec08";
}

/* '' */
.uil-underline:before {
  content: "\\ec09";
}

/* '' */
.uil-university:before {
  content: "\\ec0a";
}

/* '' */
.uil-unlock-alt:before {
  content: "\\ec0b";
}

/* '' */
.uil-unlock:before {
  content: "\\ec0c";
}

/* '' */
.uil-upload-alt:before {
  content: "\\ec0d";
}

/* '' */
.uil-upload:before {
  content: "\\ec0e";
}

/* '' */
.uil-usd-circle:before {
  content: "\\ec0f";
}

/* '' */
.uil-usd-square:before {
  content: "\\ec10";
}

/* '' */
.uil-user-check:before {
  content: "\\ec11";
}

/* '' */
.uil-user-circle:before {
  content: "\\ec12";
}

/* '' */
.uil-user-exclamation:before {
  content: "\\ec13";
}

/* '' */
.uil-user-hard-hat:before {
  content: "\\ec14";
}

/* '' */
.uil-user-minus:before {
  content: "\\ec15";
}

/* '' */
.uil-user-plus:before {
  content: "\\ec16";
}

/* '' */
.uil-user-square:before {
  content: "\\ec17";
}

/* '' */
.uil-user-times:before {
  content: "\\ec18";
}

/* '' */
.uil-user:before {
  content: "\\ec19";
}

/* '' */
.uil-users-alt:before {
  content: "\\ec1a";
}

/* '' */
.uil-utensils-alt:before {
  content: "\\ec1b";
}

/* '' */
.uil-utensils:before {
  content: "\\ec1c";
}

/* '' */
.uil-vector-square-alt:before {
  content: "\\ec1d";
}

/* '' */
.uil-vector-square:before {
  content: "\\ec1e";
}

/* '' */
.uil-venus:before {
  content: "\\ec1f";
}

/* '' */
.uil-vertical-align-bottom:before {
  content: "\\ec20";
}

/* '' */
.uil-vertical-align-center:before {
  content: "\\ec21";
}

/* '' */
.uil-vertical-align-top:before {
  content: "\\ec22";
}

/* '' */
.uil-vertical-distribute-bottom:before {
  content: "\\ec23";
}

/* '' */
.uil-vertical-distribution-center:before {
  content: "\\ec24";
}

/* '' */
.uil-vertical-distribution-top:before {
  content: "\\ec25";
}

/* '' */
.uil-video-slash:before {
  content: "\\ec26";
}

/* '' */
.uil-video:before {
  content: "\\ec27";
}

/* '' */
.uil-visual-studio:before {
  content: "\\ec28";
}

/* '' */
.uil-vk-alt:before {
  content: "\\ec29";
}

/* '' */
.uil-vk:before {
  content: "\\ec2a";
}

/* '' */
.uil-voicemail-rectangle:before {
  content: "\\ec2b";
}

/* '' */
.uil-voicemail:before {
  content: "\\ec2c";
}

/* '' */
.uil-volleyball:before {
  content: "\\ec2d";
}

/* '' */
.uil-volume-down:before {
  content: "\\ec2e";
}

/* '' */
.uil-volume-mute:before {
  content: "\\ec2f";
}

/* '' */
.uil-volume-off:before {
  content: "\\ec30";
}

/* '' */
.uil-volume-up:before {
  content: "\\ec31";
}

/* '' */
.uil-volume:before {
  content: "\\ec32";
}

/* '' */
.uil-vuejs-alt:before {
  content: "\\ec33";
}

/* '' */
.uil-vuejs:before {
  content: "\\ec34";
}

/* '' */
.uil-wall:before {
  content: "\\ec35";
}

/* '' */
.uil-wallet:before {
  content: "\\ec36";
}

/* '' */
.uil-watch-alt:before {
  content: "\\ec37";
}

/* '' */
.uil-watch:before {
  content: "\\ec38";
}

/* '' */
.uil-water-drop-slash:before {
  content: "\\ec39";
}

/* '' */
.uil-water-glass:before {
  content: "\\ec3a";
}

/* '' */
.uil-water:before {
  content: "\\ec3b";
}

/* '' */
.uil-web-grid-alt:before {
  content: "\\ec3c";
}

/* '' */
.uil-web-grid:before {
  content: "\\ec3d";
}

/* '' */
.uil-web-section-alt:before {
  content: "\\ec3e";
}

/* '' */
.uil-web-section:before {
  content: "\\ec3f";
}

/* '' */
.uil-webcam:before {
  content: "\\ec40";
}

/* '' */
.uil-weight:before {
  content: "\\ec41";
}

/* '' */
.uil-whatsapp:before {
  content: "\\ec42";
}

/* '' */
.uil-wheel-barrow:before {
  content: "\\ec43";
}

/* '' */
.uil-wheelchair-alt:before {
  content: "\\ec44";
}

/* '' */
.uil-wheelchair:before {
  content: "\\ec45";
}

/* '' */
.uil-wifi-router:before {
  content: "\\ec46";
}

/* '' */
.uil-wifi-slash:before {
  content: "\\ec47";
}

/* '' */
.uil-wifi:before {
  content: "\\ec48";
}

/* '' */
.uil-wind-moon:before {
  content: "\\ec49";
}

/* '' */
.uil-wind-sun:before {
  content: "\\ec4a";
}

/* '' */
.uil-wind:before {
  content: "\\ec4b";
}

/* '' */
.uil-window-grid:before {
  content: "\\ec4c";
}

/* '' */
.uil-window-maximize:before {
  content: "\\ec4d";
}

/* '' */
.uil-window-restore:before {
  content: "\\ec4e";
}

/* '' */
.uil-window-section:before {
  content: "\\ec4f";
}

/* '' */
.uil-window:before {
  content: "\\ec50";
}

/* '' */
.uil-windsock:before {
  content: "\\ec51";
}

/* '' */
.uil-wrap-text:before {
  content: "\\ec52";
}

/* '' */
.uil-wrench:before {
  content: "\\ec53";
}

/* '' */
.uil-yellow:before {
  content: "\\ec54";
}

/* '' */
.uil-yen-circle:before {
  content: "\\ec55";
}

/* '' */
.uil-yen:before {
  content: "\\ec56";
}

/* '' */
.uil-yin-yang:before {
  content: "\\ec57";
}

/* '' */
.uil-youtube-alt:before {
  content: "\\ec58";
}

/* '' */
.uil-youtube:before {
  content: "\\ec59";
}

/* '' */
.dropdown-toggle::after {
  content: none;
}

/* =======================
    TABLE OF CSS
    1. Fonts 
    2. General 
    3. Left Menu 
    4. Topbar 
    5. Page Head 
    6. Footer 
    7. Horizontal Nav 
    8. Right Sidebar 
    9. Layouts 
    10. Helper 
    11. Social 
    12. Widgets 
    13. Custom Checkbox 
    14. Custom Radio 
    15. Print 
    16. Preloader 
    17. Plugins 
    18. Components Demo 
    19. Tasks 
    20. Email 
    21. Timeline 
    22. Extra Pages 
    23. Authentication 
   ======================= */
/* 1. Fonts */
/* 2. General */
html {
  position: relative;
  min-height: 100%;
}

body {
  padding-bottom: 10px;
  overflow-x: hidden;
  background: #64687C;
}

button {
  outline: transparent;
  background: transparent;
  border: none;
}

fieldset {
  font-family: sans-serif;
  border: 1px solid #1F497D;
  background: #fff;
  border-radius: 5px;
  padding: 15px;
}
fieldset label {
  font-size: smaller;
}

fieldset legend {
  background: #ffffff;
  color: #045a5e;
  padding: 8px 10px;
  font-size: 13px;
  border-radius: 4px;
  box-shadow: 0 0 0 1px #045a5e;
  margin-left: 6px;
}

/* 3. Left Menu */
.button {
  background-color: #4CAF50; /* Green */
  border: none;
  color: white;
  padding: 1px 10px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 13px;
  margin: 4px 2px;
  transition-duration: 0.4s;
  cursor: pointer;
}

.button4 {
  background-color: white;
  color: black;
  border: 2px solid #e7e7e7;
}

.button4:hover {
  background-color: #e7e7e7;
}

.button5 {
  background-color: white;
  color: black;
  border: 2px solid #e7e7e7;
}

.button5:hover {
  background-color: #555555;
  color: white;
}

.nav-second-level-dark li a,
.nav-thrid-level-dark li a {
  padding: 8px 20px;
  color: #038FDD !important;
  display: block;
  position: relative;
  transition: all 0.4s;
}
.nav-second-level-dark li a:focus, .nav-second-level-dark li a:hover,
.nav-thrid-level-dark li a:focus,
.nav-thrid-level-dark li a:hover {
  color: #fa8c15 !important;
}
.nav-second-level-dark li > a.active,
.nav-thrid-level-dark li > a.active {
  color: #fa8c15 !important;
}

.nav-second-level li a,
.nav-thrid-level li a {
  padding: 8px 20px;
  color: #4BB3BC;
  display: block;
  position: relative;
  transition: all 0.4s;
}
.nav-second-level li a:focus, .nav-second-level li a:hover,
.nav-thrid-level li a:focus,
.nav-thrid-level li a:hover {
  color: #4BB3BC;
}
.nav-second-level li > a.active,
.nav-thrid-level li > a.active {
  color: #4BB3BC;
}

#wrapper {
  height: 100%;
  overflow: hidden;
  width: 100%;
}

.content-page {
  margin-left: 250px;
  overflow: hidden;
  padding: 0px 12.5px 5px 12.5px;
  min-height: 80vh;
  margin-top: 55px;
}

.For-Themes {
  display: flex;
  justify-content: space-evenly;
  margin-top: 10px;
}

.left-side-menu-dark {
  width: 250px;
  background: #003366;
  bottom: 0;
  padding: 0 0 30px 0;
  position: fixed;
  top: 55px;
  transition-duration: 0.2s;
  box-shadow: 1px 0.05rem 0.01rem rgba(75, 75, 90, 0.075);
  z-index: 99;
}
.left-side-menu-dark .sidebar-content {
  height: 100%;
  padding-bottom: 30px;
}

.left-side-menu-light {
  width: 250px;
  background: #323742;
  bottom: 0;
  padding: 0 0 30px 0;
  position: fixed;
  top: 55px;
  transition-duration: 0.2s;
  box-shadow: 1px 0.05rem 0.01rem rgba(75, 75, 90, 0.075);
  z-index: 99;
}
.left-side-menu-light .sidebar-content {
  height: 100%;
  padding-bottom: 30px;
}

#sidebar-menu {
  padding-bottom: 30px;
}
#sidebar-menu > ul > li.mm-active > a {
  border-left: 3px solid #4BB3BC;
  color: #4BB3BC;
  background-color: rgba(22, 191, 199, 0.05);
}
#sidebar-menu > ul > li.mm-active > a svg {
  color: #4BB3BC;
  fill: rgba(75, 179, 188, 0.1);
}
#sidebar-menu > ul > li > a {
  color: #4BB3BC;
  display: block;
  padding: 12px 30px;
  font-size: 15px;
  font-weight: 400;
  position: relative;
  transition: all 0.4s;
  border-left: 3px solid transparent;
}
#sidebar-menu > ul > li > a svg {
  display: inline-block;
  width: 16px;
  height: 16px;
  margin: 0 10px 0 3px;
  color: #4BB3BC;
  fill: rgba(75, 179, 188, 0.12);
}
#sidebar-menu > ul > li > a:hover, #sidebar-menu > ul > li > a:focus, #sidebar-menu > ul > li > a:active {
  color: #4BB3BC;
  text-decoration: none;
  background-color: rgba(22, 191, 199, 0.05);
}
#sidebar-menu > ul > li > a:hover svg, #sidebar-menu > ul > li > a:focus svg, #sidebar-menu > ul > li > a:active svg {
  color: #4BB3BC;
  fill: rgba(75, 179, 188, 0.1);
}
#sidebar-menu > ul > li > a > span {
  vertical-align: middle;
}
#sidebar-menu > ul > li > a i {
  display: inline-block;
  line-height: 1rem;
  margin: 0 10px 0 3px;
  text-align: center;
  vertical-align: middle;
  width: 20px;
}
#sidebar-menu > ul > li > a.active {
  border-left: 3px solid #4BB3BC;
  color: #4BB3BC;
  background-color: rgba(22, 191, 199, 0.05);
}
#sidebar-menu > ul > li > a.active svg {
  color: #4BB3BC;
  fill: rgba(75, 179, 188, 0.1);
}
#sidebar-menu > ul > li > ul {
  padding-left: 43px;
}
#sidebar-menu > ul > li > ul ul {
  padding-left: 20px;
}
#sidebar-menu .menu-arrow {
  transition: transform 0.15s;
  position: absolute;
  right: 30px;
  display: inline-block;
  font-family: "unicons";
  text-rendering: auto;
  line-height: 1.3rem;
  font-size: 0.9rem;
  transform: translate(0, 0);
  top: 15px;
}
#sidebar-menu .menu-arrow:before {
  content: "\\e82f";
}
#sidebar-menu .badge {
  margin-top: 3px;
}
#sidebar-menu .nav-second-level > li .menu-arrow {
  top: 8px;
}
#sidebar-menu li.mm-active > a > span.menu-arrow {
  transform: rotate(90deg);
}
#sidebar-menu .menu-title {
  padding: 15px 30px 10px 30px;
  letter-spacing: 0.05em;
  pointer-events: none;
  cursor: default;
  font-size: 0.6875rem;
  text-transform: uppercase;
  color: #4BB3BC;
}

#sidebar-menu-dark {
  padding-bottom: 30px;
}
#sidebar-menu-dark > ul > li.mm-active > a {
  border-left: 3px solid #4BB3BC;
  color: #fa8c15 !important;
}
#sidebar-menu-dark > ul > li.mm-active > a svg {
  color: #4BB3BC;
  fill: rgba(75, 179, 188, 0.1);
}
#sidebar-menu-dark > ul > li > a {
  color: #038FDD;
  display: block;
  padding: 12px 30px;
  font-size: 15px;
  font-weight: 400;
  position: relative;
  transition: all 0.4s;
  border-left: 3px solid transparent;
}
#sidebar-menu-dark > ul > li > a svg {
  display: inline-block;
  width: 16px;
  height: 16px;
  margin: 0 10px 0 3px;
  fill: rgba(75, 179, 188, 0.12);
}
#sidebar-menu-dark > ul > li > a:hover, #sidebar-menu-dark > ul > li > a:focus, #sidebar-menu-dark > ul > li > a:active {
  color: #fa8c15;
  text-decoration: none;
}
#sidebar-menu-dark > ul > li > a:hover svg, #sidebar-menu-dark > ul > li > a:focus svg, #sidebar-menu-dark > ul > li > a:active svg {
  color: #4BB3BC;
  fill: rgba(75, 179, 188, 0.1);
}
#sidebar-menu-dark > ul > li > a > span {
  vertical-align: middle;
}
#sidebar-menu-dark > ul > li > a i {
  display: inline-block;
  line-height: 1rem;
  margin: 0 10px 0 3px;
  text-align: center;
  vertical-align: middle;
  width: 20px;
}
#sidebar-menu-dark > ul > li > a.active {
  border-left: 3px solid #4BB3BC;
  color: #fa8c15;
}
#sidebar-menu-dark > ul > li > a.active svg {
  fill: rgba(75, 179, 188, 0.1);
}
#sidebar-menu-dark > ul > li > ul {
  padding-left: 43px;
}
#sidebar-menu-dark > ul > li > ul ul {
  padding-left: 20px;
}
#sidebar-menu-dark .menu-arrow {
  transition: transform 0.15s;
  position: absolute;
  right: 30px;
  display: inline-block;
  font-family: "unicons";
  text-rendering: auto;
  line-height: 1.3rem;
  font-size: 0.9rem;
  transform: translate(0, 0);
  top: 15px;
}
#sidebar-menu-dark .menu-arrow:before {
  content: "\\e82f";
}
#sidebar-menu-dark .badge {
  margin-top: 3px;
}
#sidebar-menu-dark .nav-second-level > li .menu-arrow {
  top: 8px;
}
#sidebar-menu-dark li.mm-active > a > span.menu-arrow {
  transform: rotate(90deg);
}
#sidebar-menu-dark .menu-title {
  padding: 15px 30px 10px 30px;
  letter-spacing: 0.05em;
  pointer-events: none;
  cursor: default;
  font-size: 0.6875rem;
  text-transform: uppercase;
  color: #4BB3BC;
}

.user-profile {
  padding: 15px 20px 15px 30px;
}
.user-profile .avatar-xs {
  display: none;
}
.user-profile .pro-user-name {
  color: #4BB3BC;
  font-weight: 600;
}
.user-profile .pro-user-desc {
  text-transform: uppercase;
  font-size: 0.6rem;
  font-weight: 700;
  letter-spacing: 1px;
}
.user-profile .dropdown-toggle svg {
  width: 18px;
  height: 18px;
  color: #4BB3BC;
  background-color: rgba(75, 179, 188, 0.1);
  border-radius: 3px;
}

.user-profile-dark {
  padding: 15px 20px 15px 30px;
}
.user-profile-dark .avatar-xs {
  display: none;
}
.user-profile-dark .pro-user-name {
  color: #038FDD !important;
  font-weight: 600;
}
.user-profile-dark .pro-user-desc {
  text-transform: uppercase;
  font-size: 0.6rem;
  font-weight: 700;
  letter-spacing: 1px;
  color: #038FDD !important;
}
.user-profile-dark .dropdown-toggle svg {
  width: 18px;
  height: 18px;
  color: #038FDD !important;
  background-color: rgba(75, 179, 188, 0.1);
  border-radius: 3px;
}

.left-side-menu-condensed .logo {
  width: 70px !important;
  text-align: center;
}
.left-side-menu-condensed .logo span.logo-lg {
  display: none;
}
.left-side-menu-condensed .logo span.logo-sm {
  display: block !important;
}
.left-side-menu-condensed .navbar-custom {
  left: 0 !important;
  padding-left: 10px;
}
.left-side-menu-condensed .navbar-custom .button-menu-mobile.disable-btn {
  display: block !important;
}
.left-side-menu-condensed .left-side-menu {
  position: absolute;
  width: 70px !important;
  z-index: 5;
}
.left-side-menu-condensed .left-side-menu .slimScrollDiv,
.left-side-menu-condensed .left-side-menu .slimscroll-menu {
  overflow: inherit !important;
  height: auto !important;
}
.left-side-menu-condensed .left-side-menu .slimScrollBar {
  visibility: hidden;
}
.left-side-menu-condensed .left-side-menu .sidebar-content {
  height: auto;
}
.left-side-menu-condensed .left-side-menu #sidebar-menu .menu-title,
.left-side-menu-condensed .left-side-menu #sidebar-menu .menu-arrow,
.left-side-menu-condensed .left-side-menu #sidebar-menu .label,
.left-side-menu-condensed .left-side-menu #sidebar-menu .badge {
  display: none !important;
}
.left-side-menu-condensed .left-side-menu #sidebar-menu > ul > li {
  position: relative;
  white-space: nowrap;
}
.left-side-menu-condensed .left-side-menu #sidebar-menu > ul > li > a {
  padding: 15px;
  min-height: 54px;
  transition: none;
  margin: 0px;
}
.left-side-menu-condensed .left-side-menu #sidebar-menu > ul > li > a:hover, .left-side-menu-condensed .left-side-menu #sidebar-menu > ul > li > a:active, .left-side-menu-condensed .left-side-menu #sidebar-menu > ul > li > a:focus {
  color: #4BB3BC;
}
.left-side-menu-condensed .left-side-menu #sidebar-menu > ul > li > a svg {
  width: 26px;
}
.left-side-menu-condensed .left-side-menu #sidebar-menu > ul > li > a span {
  display: none;
  padding-left: 25px;
  vertical-align: baseline;
}
.left-side-menu-condensed .left-side-menu #sidebar-menu > ul > li > a.active {
  background-color: rgba(22, 191, 199, 0.05);
}
.left-side-menu-condensed .left-side-menu #sidebar-menu > ul > li:hover > a {
  position: relative;
  width: calc(190px + 70px);
  color: #4BB3BC !important;
  background-color: rgba(22, 191, 199, 0.05);
  transition: none;
}
.left-side-menu-condensed .left-side-menu #sidebar-menu > ul > li:hover > a span {
  display: inline;
}
.left-side-menu-condensed .left-side-menu #sidebar-menu > ul > li:hover a.open :after, .left-side-menu-condensed .left-side-menu #sidebar-menu > ul > li:hover a.mm-active :after {
  display: none;
}
.left-side-menu-condensed .left-side-menu #sidebar-menu > ul > li:hover > ul {
  display: block;
  left: 70px;
  position: absolute;
  width: 190px;
  height: auto !important;
  box-shadow: 0 0.05rem 0.01rem rgba(161, 168, 184, 0.075);
}
.left-side-menu-condensed .left-side-menu #sidebar-menu > ul > li:hover > ul ul {
  box-shadow: 0 0.05rem 0.01rem rgba(161, 168, 184, 0.075);
}
.left-side-menu-condensed .left-side-menu #sidebar-menu > ul > li:hover > ul a {
  box-shadow: none;
  padding: 8px 20px;
  position: relative;
  width: 190px;
  z-index: 6;
}
.left-side-menu-condensed .left-side-menu #sidebar-menu > ul > li:hover > ul a:hover {
  color: #4BB3BC;
}
.left-side-menu-condensed .left-side-menu #sidebar-menu > ul ul {
  padding: 5px 0;
  z-index: 9999;
  display: none;
  background-color: #323742;
}
.left-side-menu-condensed .left-side-menu #sidebar-menu > ul ul li:hover > ul {
  display: block;
  left: 190px;
  margin-top: -36px;
  height: auto !important;
  position: absolute;
  width: 190px;
}
.left-side-menu-condensed .left-side-menu #sidebar-menu > ul ul li > a span.pull-right {
  position: absolute;
  right: 20px;
  top: 12px;
  transform: rotate(270deg);
}
.left-side-menu-condensed .left-side-menu #sidebar-menu > ul ul li.active a {
  color: #564ab1;
}
.left-side-menu-condensed .user-profile {
  padding: 15px;
}
.left-side-menu-condensed .user-profile .avatar-sm {
  display: none;
}
.left-side-menu-condensed .user-profile .avatar-xs {
  display: block;
}
.left-side-menu-condensed .user-profile .pro-user-name,
.left-side-menu-condensed .user-profile .pro-user-desc {
  display: none;
}
.left-side-menu-condensed .user-profile .profile-dropdown-menu .dropdown-toggle svg {
  background-color: transparent;
}
.left-side-menu-condensed .content-page {
  margin-left: 70px !important;
}
.left-side-menu-condensed .footer {
  left: 70px !important;
}
.left-side-menu-condensed .user-box {
  display: none;
}

@media (min-width: 769px) {
  body.left-side-menu-condensed {
    min-height: 1200px;
  }
}
@media (max-width: 1024px) {
  .left-side-menu {
    top: 55px;
    padding: 12px 0;
  }
  .left-side-menu-condensed .left-side-menu {
    padding-top: 12px;
  }
}
@media (max-width: 767.98px) {
  body {
    overflow-x: hidden;
  }
  .left-side-menu {
    display: none;
    z-index: 10 !important;
    top: 55px;
  }
  .sidebar-enable .left-side-menu {
    display: block;
  }
  .content-page, .left-side-menu-condensed .content-page {
    margin-left: 0 !important;
    padding: 0 10px;
  }
  .pro-user-name {
    display: none;
  }
  .logo-box {
    display: none;
  }
}
/* 4. Topbar */
.navbar-custom {
  padding: 0px 0px 0 32px;
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  height: 55px;
  z-index: 100;
  background-color: #262939;
  box-shadow: 0 0.05rem 0.01rem rgba(161, 168, 184, 0.075);
}
.navbar-custom .topnav-menu > li {
  float: left;
}
.navbar-custom .topnav-menu .nav-link {
  padding: 0 15px;
  color: #4BB3BC;
  min-width: 32px;
  display: block;
  line-height: 55px;
  text-align: center;
  max-height: 55px;
  cursor: pointer;
}
.navbar-custom .topnav-menu .nav-link svg {
  height: 20px;
  width: 20px;
  color: #4BB3BC;
  fill: rgba(75, 179, 188, 0.12);
}
.navbar-custom .topnav-menu .nav-link:hover svg, .navbar-custom .topnav-menu .nav-link:focus svg, .navbar-custom .topnav-menu .nav-link:active svg {
  color: #4BB3BC;
  fill: rgba(75, 179, 188, 0.1);
}
.navbar-custom .dropdown.show .nav-link {
  background-color: rgba(255, 255, 255, 0.05);
}
.navbar-custom .menu-left {
  overflow: hidden;
}
.navbar-custom {
  /* Search */
}
.navbar-custom .app-search {
  padding: 17px 0;
  overflow: hidden;
  margin-left: 15px;
  margin-right: 15px;
}
.navbar-custom .app-search form {
  max-width: 320px;
}
.navbar-custom .app-search .form-control {
  border: 1px solid transparent;
  height: 38px;
  padding-left: 40px;
  padding-right: 20px;
  border: 1.5px solid #64687C;
  border-radius: 0px;
}
.navbar-custom .app-search .form-control:focus {
  background-color: #fff;
  border: 1px solid #64687C;
}
.navbar-custom .app-search svg {
  position: absolute;
  z-index: 10;
  font-size: 18px;
  color: #16BFC7;
  line-height: 38px;
  left: 10px;
  top: 10px;
  width: 20px;
  height: 20px;
}
.navbar-custom .button-menu-mobile {
  border: none;
  color: #6b768d;
  display: block;
  height: 55px;
  line-height: 55px;
  width: 60px;
  background-color: transparent;
  font-size: 24px;
  cursor: pointer;
  margin-right: 45px;
}
.navbar-custom .button-menu-mobile.disable-btn {
  display: none;
}
.navbar-custom .button-menu-mobile .menu-icon {
  display: inline-block;
}
.navbar-custom .button-menu-mobile .close-icon {
  display: none;
}
.navbar-custom .button-menu-mobile.open .menu-icon {
  display: none;
}
.navbar-custom .button-menu-mobile.open .close-icon {
  display: inline-block;
}
.navbar-custom .logo span.logo-sm {
  display: none;
}

.text-logo {
  text-transform: uppercase;
  font-weight: 900;
  letter-spacing: 1px;
}

/* Notification */
@keyframes blinker {
  50% {
    opacity: 0;
  }
}
.noti-scroll {
  max-height: 230px;
}

.notification-list {
  margin-left: 0;
}
.notification-list .noti-title {
  background-color: transparent;
  padding: 7px 20px 15px;
}
.notification-list .noti-icon {
  font-size: 21px;
  vertical-align: middle;
}
.notification-list .noti-icon-badge {
  display: inline-block;
  position: absolute;
  top: 24px;
  right: 16px;
  width: 12px;
  height: 12px;
  background-color: #ff5c75;
  border: 2px solid #262939;
  border-radius: 50%;
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175);
  animation: blinker 3s linear infinite;
  animation-fill-mode: initial;
}
.notification-list .notify-item {
  padding: 12px 20px;
}
.notification-list .notify-item .notify-icon {
  float: left;
  height: 36px;
  width: 36px;
  font-size: 16px;
  line-height: 36px;
  text-align: center;
  margin-right: 10px;
  border-radius: 50%;
  color: #fff;
}
.notification-list .notify-item .notify-details {
  margin-bottom: 5px;
  overflow: hidden;
  margin-left: 45px;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #bcc1cc;
  line-height: 1.5;
}
.notification-list .notify-item .notify-details b {
  font-weight: 500;
}
.notification-list .notify-item .notify-details small {
  display: block;
}
.notification-list .notify-item .notify-details span {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
}
.notification-list .notify-item .user-msg {
  margin-left: 45px;
  white-space: normal;
  line-height: 16px;
}
.notification-list .profile-dropdown-items .notify-item {
  padding: 0.35rem 1.5rem;
}

.profile-dropdown {
  display: none;
}

.profile-dropdown-items {
  width: 170px;
}
.profile-dropdown-items i {
  vertical-align: middle;
  margin-right: 5px;
}

.nav-user {
  padding: 0 12px !important;
}
.nav-user img {
  height: 32px;
  width: 32px;
}

@media (max-width: 1024px) {
  .navbar-custom {
    left: 0;
    padding: 0 10px;
    margin: 0px;
  }
  .navbar-custom .button-menu-mobile.disable-btn {
    display: block;
  }
  .navbar-custom .logo {
    display: none;
  }
}
@media (max-width: 575.98px) {
  .navbar-custom .page-title {
    display: none;
  }
}
/* 5. Page Head */
.page-title-topbar {
  font-size: 20px;
  margin: 0;
  line-height: 55px;
}

.page-title .breadcrumb {
  background-color: transparent;
  padding: 0;
  margin-bottom: 0;
}
.page-title h4 {
  font-size: 19px;
}

/* 6. Footer */
.footer {
  bottom: 0;
  padding: 19px 15px 20px;
  position: absolute;
  right: 0;
  color: #8790a4;
  left: 250px;
}
.footer .footer-links a {
  color: #8790a4;
  margin-left: 1.5rem;
  transition: all 0.4s;
}
.footer .footer-links a:hover {
  color: #d6d9e0;
}
.footer .footer-links a:first-of-type {
  margin-left: 0;
}

.footer-alt {
  left: 0 !important;
  text-align: center;
  background-color: transparent;
}

@media (max-width: 767.98px) {
  .footer {
    left: 0 !important;
    text-align: center;
  }
}
/* 7. Horizontal Nav */
body[data-layout=topnav] .container-fluid, body[data-layout=topnav] .container-sm, body[data-layout=topnav] .container-md, body[data-layout=topnav] .container-lg, body[data-layout=topnav] .container-xl {
  padding-right: 24px;
  padding-left: 24px;
}
body[data-layout=topnav] .navbar-custom {
  position: relative;
  padding: 0px;
}
body[data-layout=topnav] .navbar-custom .topnav-menu .nav-link:hover svg, body[data-layout=topnav] .navbar-custom .topnav-menu .nav-link:focus svg, body[data-layout=topnav] .navbar-custom .topnav-menu .nav-link:active svg {
  color: #4BB3BC;
}
body[data-layout=topnav] .content-page {
  margin-top: 0px;
  margin-left: 0px !important;
  padding: 5px 0px 5px 0;
}
body[data-layout=topnav] .footer {
  left: 0;
}
body[data-layout=topnav] .user-profile {
  padding: 20px 0px;
}
body[data-layout=topnav] .profile-dropdown {
  display: block;
}
@media (max-width: 1024px) {
  body[data-layout=topnav] .button-menu-mobile.disable-btn {
    display: none;
  }
}
@media (max-width: 375px) {
  body[data-layout=topnav] .button-menu-mobile.disable-btn {
    display: block;
  }
}

.topnav {
  background: #323742;
}

.topbar-nav {
  margin: 0;
  padding: 0;
}
.topbar-nav .badge {
  display: none;
}
.topbar-nav .metismenu {
  display: flex;
  flex-direction: column;
  margin: 0;
}
.topbar-nav .metismenu .has-arrow:after {
  width: 0.4em;
  height: 0.4em;
  right: 1rem;
  transform: rotate(45deg) translate(0, -50%);
}
.topbar-nav .metismenu .menu-title {
  display: none;
}
.topbar-nav .metismenu li:hover, .topbar-nav .metismenu li:focus, .topbar-nav .metismenu li:active {
  color: #4BB3BC;
  text-decoration: none;
}
.topbar-nav .metismenu li:hover svg, .topbar-nav .metismenu li:focus svg, .topbar-nav .metismenu li:active svg {
  color: #4BB3BC;
  fill: rgba(75, 179, 188, 0.1);
}
.topbar-nav .metismenu li a {
  color: #4BB3BC;
  font-size: 1rem;
  position: relative;
  padding: 1rem;
  display: block;
}
.topbar-nav .metismenu li a svg {
  display: inline-block;
  width: 16px;
  height: 16px;
  margin: 0 5px 0 0;
  color: #4BB3BC;
  fill: rgba(75, 179, 188, 0.12);
}
.topbar-nav .metismenu li a > span {
  vertical-align: middle;
}
.topbar-nav .metismenu li a:hover, .topbar-nav .metismenu li a:focus, .topbar-nav .metismenu li a:active {
  color: #4BB3BC;
  text-decoration: none;
}
.topbar-nav .metismenu li a:hover svg, .topbar-nav .metismenu li a:focus svg, .topbar-nav .metismenu li a:active svg {
  color: #4BB3BC;
  fill: rgba(75, 179, 188, 0.1);
}
.topbar-nav .metismenu li:nth-child(2) a {
  padding-left: 0px;
}
.topbar-nav .metismenu li .menu-arrow {
  transition: transform 0.15s;
  display: inline-block;
  font-family: "unicons";
  text-rendering: auto;
  line-height: 1.3rem;
  font-size: 1.25rem;
  transform: translate(0, 0);
  vertical-align: middle;
  margin-left: 5px;
}
.topbar-nav .metismenu li .menu-arrow:before {
  content: "\\e82d";
}
.topbar-nav .metismenu li.mm-active > a {
  color: #4BB3BC;
}
.topbar-nav .metismenu li.mm-active > a svg {
  color: #4BB3BC;
  fill: rgba(75, 179, 188, 0.1);
}
.topbar-nav .metismenu li.mm-active > a > span.menu-arrow {
  transform: rotate(180deg);
}
.topbar-nav .metismenu li.active > a {
  color: #4BB3BC;
}
.topbar-nav .metismenu li.active > a svg {
  color: #4BB3BC;
  fill: rgba(75, 179, 188, 0.1);
}
.topbar-nav .metismenu li .nav-second-level {
  color: #4BB3BC;
  background-color: #323742;
  background-clip: padding-box;
  border-radius: 0 0 0.3rem 0.3rem;
  min-width: calc(10rem + 1.5rem);
  font-size: calc(0.9rem - 0.01rem);
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.175);
  padding: 0.5rem 0;
}
.topbar-nav .metismenu li .nav-second-level li:hover, .topbar-nav .metismenu li .nav-second-level li:focus, .topbar-nav .metismenu li .nav-second-level li:active {
  color: #4BB3BC;
  text-decoration: none;
}
.topbar-nav .metismenu li .nav-second-level li:first-of-type {
  padding-top: 0.5rem;
}
.topbar-nav .metismenu li .nav-second-level li:last-of-type {
  padding-bottom: 0.5rem;
}
.topbar-nav .metismenu li .nav-second-level a {
  display: block;
  width: 100%;
  padding: 0.35rem 1.5rem !important;
  clear: both;
  font-size: 0.9rem;
  font-weight: 400;
  line-height: 1.5;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
}
.topbar-nav .metismenu li .nav-second-level a:hover, .topbar-nav .metismenu li .nav-second-level a:focus {
  color: rgb(228.5208333333, 230.4583333333, 234.9791666667);
  text-decoration: none;
  background-color: #3b414e;
}
.topbar-nav .metismenu li .nav-second-level .has-arrow:after {
  margin-top: -2px;
}
.topbar-nav .metismenu li .nav-second-level .menu-arrow {
  float: right;
}
.topbar-nav .metismenu li .nav-third-level {
  color: #4BB3BC;
  min-width: calc(10rem + 1.5rem);
}
.topbar-nav .metismenu li .nav-third-level li:hover, .topbar-nav .metismenu li .nav-third-level li:focus, .topbar-nav .metismenu li .nav-third-level li:active {
  color: #4BB3BC;
  text-decoration: none;
}
.topbar-nav .metismenu li .nav-third-level li:first-of-type {
  padding-top: 0.5rem;
}
.topbar-nav .metismenu li .nav-third-level li:last-of-type {
  padding-bottom: 0.5rem;
}
.topbar-nav .metismenu li .nav-third-level a {
  display: block;
  width: 100%;
  padding: 0.35rem 1.5rem !important;
  clear: both;
  font-size: 0.9rem;
  font-weight: 400;
  line-height: 1.5;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
  padding-left: 2.2rem !important;
}
.topbar-nav .metismenu li .nav-third-level a:hover, .topbar-nav .metismenu li .nav-third-level a:focus {
  color: rgb(228.5208333333, 230.4583333333, 234.9791666667);
  text-decoration: none;
  background-color: #3b414e;
}
.topbar-nav .metismenu li .nav-third-level .has-arrow:after {
  margin-top: -2px;
}
.topbar-nav .metismenu li .nav-third-level .menu-arrow {
  float: right;
}

@media (min-width: 992px) {
  body[data-layout=topnav] .container-fluid, body[data-layout=topnav] .container-sm, body[data-layout=topnav] .container-md, body[data-layout=topnav] .container-lg, body[data-layout=topnav] .container-xl {
    max-width: 85%;
  }
  body[data-layout=topnav] .navbar-custom .logo {
    display: block;
  }
  body[data-layout=topnav] .navbar-custom .logo span.logo-sm {
    display: none !important;
  }
  body[data-layout=topnav] .navbar-custom .logo span.logo-lg {
    display: block;
  }
  body[data-layout=topnav].left-side-menu-condensed .navbar-custom .button-menu-mobile.disable-btn {
    display: none !important;
  }
  body[data-layout=topnav].boxed-layout .container-fluid, body[data-layout=topnav].boxed-layout .container-sm, body[data-layout=topnav].boxed-layout .container-md, body[data-layout=topnav].boxed-layout .container-lg, body[data-layout=topnav].boxed-layout .container-xl {
    max-width: 97%;
  }
  .topbar-nav .metismenu {
    flex-direction: row;
  }
  .topbar-nav .metismenu > li {
    flex-direction: column;
  }
  .topbar-nav .metismenu > li > ul {
    position: absolute;
    z-index: 1001;
  }
  .topbar-nav .metismenu .side-nav-item:first-of-type .side-nav-link {
    padding-left: 0;
  }
  .navbar-toggle {
    display: none;
  }
}
@media (max-width: 991.98px) {
  body[data-layout=topnav] .navbar-custom .container-fluid, body[data-layout=topnav] .navbar-custom .container-sm, body[data-layout=topnav] .navbar-custom .container-md, body[data-layout=topnav] .navbar-custom .container-lg, body[data-layout=topnav] .navbar-custom .container-xl {
    padding-right: 12px;
    padding-left: 12px;
  }
  .topnav {
    overflow: auto;
  }
  .topbar-nav {
    max-height: 400px;
  }
  .topbar-nav .metismenu li a {
    padding: 15px 0px;
  }
  .topbar-nav .metismenu li .nav-second-level {
    box-shadow: none;
    padding-top: 0px;
  }
  .topbar-nav .metismenu li .nav-second-level li:first-of-type {
    padding: 0;
  }
  .topbar-nav .metismenu li .nav-second-level a {
    padding-right: 0px !important;
  }
  .topbar-nav .metismenu li .nav-second-level a:hover, .topbar-nav .metismenu li .nav-second-level a:focus {
    background-color: transparent;
  }
  .topbar-nav .metismenu li .menu-arrow {
    float: right;
    margin-top: 2px;
  }
}
@media (min-width: 992px) and (max-width: 1180px) {
  .topbar-nav .metismenu li .menu-arrow {
    display: none;
  }
}
/* 8. Right Sidebar */
.right-bar {
  background-color: #323742;
  box-shadow: 0 0 24px 0 rgba(0, 0, 0, 0.06), 0 1px 0 0 rgba(0, 0, 0, 0.02);
  display: block;
  position: fixed;
  transition: all 200ms ease-out;
  width: 260px;
  z-index: 9999;
  float: right !important;
  right: -270px;
  top: 0;
  bottom: 0;
  padding-bottom: 60px;
}
.right-bar .rightbar-title {
  padding: 25px 25px;
}
.right-bar .right-bar-toggle {
  height: 24px;
  width: 24px;
  line-height: 24px;
  text-align: center;
  border-radius: 50%;
  margin-top: -4px;
}
.right-bar .demo-img {
  height: 200px;
}

.rightbar-overlay {
  background-color: rgba(188, 193, 204, 0.55);
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: none;
  z-index: 9998;
  transition: all 0.2s ease-out;
}

.right-bar-enabled .right-bar {
  right: 0;
}
.right-bar-enabled .rightbar-overlay {
  display: block;
}

@media (max-width: 767.98px) {
  .right-bar {
    overflow: auto;
  }
  .right-bar .slimscroll-menu {
    height: auto !important;
  }
}
.activity-widget .activity-list {
  border-bottom: 1px solid #323742;
  padding: 12px 0px;
}
.activity-widget .activity-list:last-child {
  border: none;
}

.upgrade-wid .laptop-img {
  position: relative;
  bottom: 22px;
}

/* 9. Layouts */
@media (min-width: 1200px) {
  .scrollable-layout {
    padding-bottom: 0;
  }
  .scrollable-layout #wrapper {
    display: flex;
  }
  .scrollable-layout .left-side-menu {
    position: relative;
    min-width: 250px;
    min-height: 100vh;
  }
  .scrollable-layout .navbar-custom {
    position: absolute;
  }
  .scrollable-layout .content-page {
    margin-left: 0;
    width: 100%;
    padding-bottom: 60px;
  }
  .scrollable-layout.left-side-menu-condensed .left-side-menu {
    min-width: 70px;
  }
  .scrollable-layout.left-side-menu-condensed .content-page {
    margin-left: 0px !important;
  }
}
.boxed-layout {
  background: rgb(95.4464285714, 99.2642857143, 118.3535714286);
}
.boxed-layout #wrapper {
  max-width: 1300px;
  margin: 0 auto;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  background: #64687C;
}
.boxed-layout .navbar-custom {
  max-width: 1300px;
  margin: 0 auto;
}
.boxed-layout .footer {
  margin: 0 auto;
  max-width: calc(1300px - 250px);
  background: #64687C;
}
.boxed-layout.left-side-menu-condensed {
  min-height: auto;
}
.boxed-layout.left-side-menu-condensed .footer {
  max-width: calc(1300px - 70px);
}

/* 10. Helper */
.width-xs {
  min-width: 80px;
}

.width-sm {
  min-width: 95px;
}

.width-md {
  min-width: 110px;
}

.width-lg {
  min-width: 140px;
}

.width-xl {
  min-width: 160px;
}

.font-family-secondary {
  font-family: "Nunito Sans", sans-serif;
}

.avatar-xs {
  height: 1.5rem;
  width: 1.5rem;
}

.avatar-sm {
  height: 2.25rem;
  width: 2.25rem;
}

.avatar {
  height: 3rem;
  width: 3rem;
}

.avatar-md {
  height: 3.5rem;
  width: 3.5rem;
}

.avatar-lg {
  height: 4.5rem;
  width: 4.5rem;
}

.avatar-xl {
  height: 6rem;
  width: 6rem;
}

.avatar-xxl {
  height: 7.5rem;
  width: 7.5rem;
}

.avatar-title {
  align-items: center;
  color: #fff;
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;
}

.avatar-group {
  padding-left: 12px;
}
.avatar-group .avatar-group-item {
  margin: 0 0 10px -12px;
  display: inline-block;
  border: 2px solid #fff;
  border-radius: 50%;
}

.font-weight-medium {
  font-weight: 500;
}

.font-weight-semibold {
  font-weight: 600;
}

.sp-line-1,
.sp-line-2,
.sp-line-3,
.sp-line-4 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}

.sp-line-1 {
  -webkit-line-clamp: 1;
}

.sp-line-2 {
  -webkit-line-clamp: 2;
}

.sp-line-3 {
  -webkit-line-clamp: 3;
}

.sp-line-4 {
  -webkit-line-clamp: 4;
}

.pull-in {
  margin-left: -1.25rem;
  margin-right: -1.25rem;
}

/* 11. Social */
.social-list-item {
  height: 2rem;
  width: 2rem;
  line-height: calc(2rem - 4px);
  display: block;
  border: 2px solid #6b768d;
  border-radius: 50%;
  color: #6b768d;
}

/* 12. Widgets */
.widget-flat {
  position: relative;
  overflow: hidden;
}
.widget-flat i.widget-icon {
  font-size: 36px;
}

/* Chat widget */
.conversation-list {
  list-style: none;
  height: 332px;
  padding: 0 7px;
}
.conversation-list li {
  margin-bottom: 24px;
}
.conversation-list .chat-avatar {
  float: left;
  text-align: center;
  width: 34px;
}
.conversation-list .chat-avatar img {
  border-radius: 100%;
  width: 100%;
}
.conversation-list .chat-avatar i {
  font-size: 12px;
  font-style: normal;
}
.conversation-list .ctext-wrap {
  background: rgb(239.817877095, 241.7597765363, 254.382122905);
  color: #5369f8;
  border-radius: 0.3rem;
  display: inline-block;
  padding: 4px 12px;
  position: relative;
  min-width: 160px;
}
.conversation-list .ctext-wrap i {
  display: block;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  position: relative;
}
.conversation-list .ctext-wrap p {
  margin: 0;
  padding-top: 3px;
}
.conversation-list .ctext-wrap:after {
  right: 98%;
  top: 0;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
  border-top-color: rgb(239.817877095, 241.7597765363, 254.382122905);
  border-width: 6px;
  margin-left: -1px;
  border-right-color: rgb(239.817877095, 241.7597765363, 254.382122905);
}
.conversation-list .conversation-text {
  float: left;
  font-size: 12px;
  margin-left: 12px;
  width: 70%;
}
.conversation-list .odd .chat-avatar {
  float: right !important;
}
.conversation-list .odd .conversation-text {
  float: right !important;
  margin-right: 12px;
  text-align: right;
  width: 70% !important;
}
.conversation-list .odd .ctext-wrap {
  background-color: #3b414e;
  color: #a1a8b8;
}
.conversation-list .odd .ctext-wrap:after {
  border-color: transparent;
  border-left-color: #3b414e;
  border-top-color: #3b414e;
  left: 99% !important;
}

/* profile / users */
.profile-widget {
  position: relative;
}
.profile-widget .card-action {
  position: absolute;
  right: 7px;
  top: 12px;
  z-index: 100;
}
.profile-widget .card-img-top {
  max-height: 220px;
}
.profile-widget .profile-info {
  margin-top: -2.7rem;
}

.calendar-widget .flatpickr-calendar {
  box-shadow: none;
  border: 1px solid #3b414e !important;
}
.calendar-widget .flatpickr-input {
  display: none;
}

/* 13. Custom Checkbox */
.checkbox label {
  display: inline-block;
  padding-left: 8px;
  position: relative;
  font-weight: normal;
  margin-bottom: 0;
}
.checkbox label::before {
  background-color: #3b414e;
  border-radius: 3px;
  border: 2px solid #3b414e;
  content: "";
  display: inline-block;
  height: 18px;
  left: 0;
  margin-left: -18px;
  position: absolute;
  transition: 0.3s ease-in-out;
  width: 18px;
  outline: none !important;
  top: 2px;
}
.checkbox label::after {
  color: #a1a8b8;
  display: inline-block;
  font-size: 11px;
  height: 18px;
  left: 0;
  margin-left: -18px;
  padding-left: 3px;
  padding-top: 2px;
  position: absolute;
  top: 0;
  width: 18px;
}
.checkbox input[type=checkbox] {
  cursor: pointer;
  opacity: 0;
  z-index: 1;
  outline: none !important;
}
.checkbox input[type=checkbox]:disabled + label {
  opacity: 0.65;
}
.checkbox input[type=checkbox]:focus + label::before {
  outline-offset: -2px;
  outline: none;
}
.checkbox input[type=checkbox]:checked + label::after {
  content: "";
  position: absolute;
  top: 6px;
  left: 7px;
  display: table;
  width: 4px;
  height: 8px;
  border: 2px solid #a1a8b8;
  border-top-width: 0;
  border-left-width: 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  -o-transform: rotate(45deg);
  transform: rotate(45deg);
}
.checkbox input[type=checkbox]:disabled + label::before {
  background-color: #3b414e;
  cursor: not-allowed;
}

.checkbox.checkbox-circle label::before {
  border-radius: 50%;
}

.checkbox.checkbox-inline {
  margin-top: 0;
}

.checkbox.checkbox-single input {
  height: 18px;
  width: 18px;
  position: absolute;
}
.checkbox.checkbox-single label {
  height: 18px;
  width: 18px;
}
.checkbox.checkbox-single label:before {
  margin-left: 0;
}
.checkbox.checkbox-single label:after {
  margin-left: 0;
}

.checkbox-primary input[type=checkbox]:checked + label::before {
  background-color: #5369f8;
  border-color: #5369f8;
}
.checkbox-primary input[type=checkbox]:checked + label::after {
  border-color: #fff;
}

.checkbox-secondary input[type=checkbox]:checked + label::before {
  background-color: #292d36;
  border-color: #292d36;
}
.checkbox-secondary input[type=checkbox]:checked + label::after {
  border-color: #fff;
}

.checkbox-success input[type=checkbox]:checked + label::before {
  background-color: #43d39e;
  border-color: #43d39e;
}
.checkbox-success input[type=checkbox]:checked + label::after {
  border-color: #fff;
}

.checkbox-info input[type=checkbox]:checked + label::before {
  background-color: #25c2e3;
  border-color: #25c2e3;
}
.checkbox-info input[type=checkbox]:checked + label::after {
  border-color: #fff;
}

.checkbox-warning input[type=checkbox]:checked + label::before {
  background-color: #ffbe0b;
  border-color: #ffbe0b;
}
.checkbox-warning input[type=checkbox]:checked + label::after {
  border-color: #fff;
}

.checkbox-danger input[type=checkbox]:checked + label::before {
  background-color: #ff5c75;
  border-color: #ff5c75;
}
.checkbox-danger input[type=checkbox]:checked + label::after {
  border-color: #fff;
}

.checkbox-light input[type=checkbox]:checked + label::before {
  background-color: #3b414e;
  border-color: #3b414e;
}
.checkbox-light input[type=checkbox]:checked + label::after {
  border-color: #fff;
}

.checkbox-dark input[type=checkbox]:checked + label::before {
  background-color: #bcc1cc;
  border-color: #bcc1cc;
}
.checkbox-dark input[type=checkbox]:checked + label::after {
  border-color: #fff;
}

/* 14. Custom Radio */
.radio label {
  display: inline-block;
  padding-left: 8px;
  position: relative;
  font-weight: normal;
  margin-bottom: 0;
}
.radio label::before {
  -o-transition: border 0.5s ease-in-out;
  -webkit-transition: border 0.5s ease-in-out;
  background-color: #fff;
  border-radius: 50%;
  border: 2px solid #8790a4;
  content: "";
  display: inline-block;
  height: 18px;
  left: 0;
  margin-left: -18px;
  position: absolute;
  transition: border 0.5s ease-in-out;
  width: 18px;
  outline: none !important;
}
.radio label::after {
  -moz-transition: -moz-transform 0.1s cubic-bezier(0.8, -0.33, 0.2, 1.33);
  -ms-transform: scale(0, 0);
  -o-transform: scale(0, 0);
  -o-transition: -o-transform 0.1s cubic-bezier(0.8, -0.33, 0.2, 1.33);
  -webkit-transform: scale(0, 0);
  -webkit-transition: -webkit-transform 0.1s cubic-bezier(0.8, -0.33, 0.2, 1.33);
  background-color: #a1a8b8;
  border-radius: 50%;
  content: " ";
  display: inline-block;
  height: 10px;
  left: 6px;
  margin-left: -20px;
  position: absolute;
  top: 4px;
  transform: scale(0, 0);
  transition: transform 0.1s cubic-bezier(0.8, -0.33, 0.2, 1.33);
  width: 10px;
}
.radio input[type=radio] {
  cursor: pointer;
  opacity: 0;
  z-index: 1;
  outline: none !important;
}
.radio input[type=radio]:disabled + label {
  opacity: 0.65;
}
.radio input[type=radio]:focus + label::before {
  outline-offset: -2px;
  outline: 5px auto -webkit-focus-ring-color;
  outline: thin dotted;
}
.radio input[type=radio]:checked + label::after {
  -ms-transform: scale(1, 1);
  -o-transform: scale(1, 1);
  -webkit-transform: scale(1, 1);
  transform: scale(1, 1);
}
.radio input[type=radio]:disabled + label::before {
  cursor: not-allowed;
}

.radio.radio-inline {
  margin-top: 0;
}

.radio.radio-single label {
  height: 17px;
}

.radio-primary input[type=radio] + label::after {
  background-color: #5369f8;
}
.radio-primary input[type=radio]:checked + label::before {
  border-color: #5369f8;
}
.radio-primary input[type=radio]:checked + label::after {
  background-color: #5369f8;
}

.radio-secondary input[type=radio] + label::after {
  background-color: #292d36;
}
.radio-secondary input[type=radio]:checked + label::before {
  border-color: #292d36;
}
.radio-secondary input[type=radio]:checked + label::after {
  background-color: #292d36;
}

.radio-success input[type=radio] + label::after {
  background-color: #43d39e;
}
.radio-success input[type=radio]:checked + label::before {
  border-color: #43d39e;
}
.radio-success input[type=radio]:checked + label::after {
  background-color: #43d39e;
}

.radio-info input[type=radio] + label::after {
  background-color: #25c2e3;
}
.radio-info input[type=radio]:checked + label::before {
  border-color: #25c2e3;
}
.radio-info input[type=radio]:checked + label::after {
  background-color: #25c2e3;
}

.radio-warning input[type=radio] + label::after {
  background-color: #ffbe0b;
}
.radio-warning input[type=radio]:checked + label::before {
  border-color: #ffbe0b;
}
.radio-warning input[type=radio]:checked + label::after {
  background-color: #ffbe0b;
}

.radio-danger input[type=radio] + label::after {
  background-color: #ff5c75;
}
.radio-danger input[type=radio]:checked + label::before {
  border-color: #ff5c75;
}
.radio-danger input[type=radio]:checked + label::after {
  background-color: #ff5c75;
}

.radio-light input[type=radio] + label::after {
  background-color: #3b414e;
}
.radio-light input[type=radio]:checked + label::before {
  border-color: #3b414e;
}
.radio-light input[type=radio]:checked + label::after {
  background-color: #3b414e;
}

.radio-dark input[type=radio] + label::after {
  background-color: #bcc1cc;
}
.radio-dark input[type=radio]:checked + label::before {
  border-color: #bcc1cc;
}
.radio-dark input[type=radio]:checked + label::after {
  background-color: #bcc1cc;
}

/* 15. Print */
@media print {
  .left-side-menu,
  .right-bar,
  .page-title-box,
  .navbar-custom,
  .footer {
    display: none;
  }
  .card-body,
  .content-page,
  .right-bar,
  .content,
  body {
    padding: 0;
    margin: 0;
  }
}
/* 16. Preloader */
.preloader {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.75);
  z-index: 9999;
}

.status {
  height: 80px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -40px 0 0 -40px;
}

.spinner > div {
  display: inline-block;
  width: 16px;
  height: 16px;
  background: #fff;
  border: 2px solid #5369f8;
  border-radius: 50%;
  animation: circle-loader 1s infinite ease-in-out both;
  margin: 0px 7px;
}
.spinner .circle1 {
  animation-delay: -0.32s;
}
.spinner .circle2 {
  animation-delay: -0.16s;
}

@keyframes circle-loader {
  0%, 80%, 100% {
    transform: scale(0.4);
  }
  40% {
    transform: scale(1);
  }
}
/* 17. Plugins */
.slimScrollDiv {
  height: auto !important;
}

.ps .ps__rail-y {
  background: transparent !important;
}
.ps .ps__rail-y:hover {
  background: transparent !important;
}

.ps__thumb-y {
  width: 4px !important;
  background: #eff1f5;
}

.ps__rail-y:hover > .ps__thumb-y,
.ps__rail-y:focus > .ps__thumb-y,
.ps__rail-y.ps--clicking .ps__thumb-y {
  width: 4px !important;
  background: #eff1f5;
}

.apex-charts {
  min-height: 10px !important;
}
.apex-charts text {
  font-family: "Nunito Sans", sans-serif !important;
  fill: #a1a8b8;
}
.apex-charts .apexcharts-canvas {
  margin: 0 auto;
}

.apexcharts-tooltip-title,
.apexcharts-tooltip-text {
  font-family: "Nunito Sans", sans-serif !important;
}

.apexcharts-legend-series {
  font-weight: 400;
}

.apexcharts-gridline {
  pointer-events: none;
  stroke: #3b414e;
}

.apexcharts-legend-text {
  color: #8790a4 !important;
  font-family: "Nunito Sans", sans-serif !important;
  font-size: 13px !important;
}

.apexcharts-pie-label {
  fill: #fff !important;
}

.apexcharts-yaxis text,
.apexcharts-xaxis text {
  font-family: "Nunito Sans", sans-serif !important;
  fill: #6b768d;
}

.apexcharts-point-annotations text,
.apexcharts-xaxis-annotations text,
.apexcharts-yaxis-annotations text {
  fill: #fff;
}

.apexcharts-radar-series polygon {
  fill: transparent;
  stroke: #3b414e;
}
.apexcharts-radar-series line {
  stroke: #3b414e;
}

.apexcharts-pie-label,
.apexcharts-datalabel,
.apexcharts-datalabel-label,
.apexcharts-datalabel-value {
  fill: #fff !important;
}

.calendar {
  float: left;
  margin-bottom: 0;
}

.fc-view {
  margin-top: 30px;
}

.none-border .modal-footer {
  border-top: none;
}

.fc-toolbar {
  margin: 10px 0 5px 0;
}
.fc-toolbar h2 {
  font-size: 1.25rem;
  line-height: 1.875rem;
  text-transform: uppercase;
}

.fc-day-grid-event .fc-time {
  font-weight: 500;
}

th.fc-day-header {
  padding: 0.5rem 0;
}

.fc-day {
  background: transparent;
}

.fc-toolbar .fc-state-active,
.fc-toolbar .ui-state-active,
.fc-toolbar button:focus,
.fc-toolbar button:hover,
.fc-toolbar .ui-state-hover {
  z-index: 0;
}

.fc th.fc-widget-header {
  background: #3b414e;
  font-size: 13px;
  line-height: 20px;
  padding: 10px 0;
  text-transform: uppercase;
  font-weight: 500;
}

.fc-unthemed th,
.fc-unthemed td,
.fc-unthemed thead,
.fc-unthemed tbody,
.fc-unthemed .fc-divider,
.fc-unthemed .fc-row,
.fc-unthemed .fc-popover {
  border-color: #3b414e;
}
.fc-unthemed td.fc-today,
.fc-unthemed .fc-divider {
  background: #3b414e;
}

.fc-button {
  background: #3b414e;
  border: none;
  color: #a1a8b8;
  text-transform: capitalize;
  box-shadow: none;
  border-radius: 3px;
  margin: 0 3px;
  padding: 6px 12px;
  height: auto;
}

.fc-text-arrow {
  font-family: inherit;
  font-size: 1rem;
}

.fc-state-hover {
  background: #3b414e;
}

.fc-state-highlight {
  background: #3b414e;
}

.fc-state-down,
.fc-state-active,
.fc-state-disabled {
  background-color: #5369f8;
  color: #fff;
  text-shadow: none;
}

.fc-cell-overlay {
  background: #3b414e;
}

.fc-unthemed .fc-today {
  background: #fff;
}

.fc-event {
  border-radius: 2px !important;
  border: none !important;
  border-color: transparent !important;
  cursor: move;
  font-size: 0.8125rem !important;
  margin: 5px 7px !important;
  padding: 5px 5px !important;
  text-align: center !important;
}

.external-event {
  cursor: move;
  margin: 10px 0;
  padding: 8px 10px;
  color: #fff;
  border-radius: 4px;
}

.fc-basic-view td.fc-week-number span {
  padding-right: 8px;
}
.fc-basic-view td.fc-day-number {
  padding-right: 8px;
}
.fc-basic-view .fc-content {
  color: #fff;
}

.fc-time-grid-event .fc-content {
  color: #fff;
}

@media (max-width: 767.98px) {
  .fc-toolbar {
    display: block;
  }
  .fc-toolbar .fc-left,
  .fc-toolbar .fc-right,
  .fc-toolbar .fc-center {
    float: none;
    display: block;
    clear: both;
    margin: 10px 0;
  }
  .fc .fc-toolbar > * > * {
    float: none;
  }
  .fc-today-button {
    display: none;
  }
}
.fc-toolbar .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.7875rem;
  line-height: 1.5;
  border-radius: 0.2rem;
}

.react-select > div {
  border: 1px solid #3b414e;
  background-color: transparent;
}
.react-select > div:hover {
  border: 1px solid #3b414e;
}
.react-select .react-select__single-value {
  color: #a1a8b8;
}

.rbt-token {
  background-color: rgba(83, 105, 248, 0.2) !important;
  color: #5369f8 !important;
}

.rbt-input-multi.focus {
  box-shadow: none !important;
  background-color: rgb(56.5948275862, 62.2543103448, 74.7051724138) !important;
  border-color: rgb(63.3927007299, 69.8394160584, 83.8072992701) !important;
}

.react-select__control--is-focused {
  border-color: rgb(63.3927007299, 69.8394160584, 83.8072992701) !important;
  box-shadow: none !important;
}

.react-select__indicator-separator {
  display: none;
}

.react-select__dropdown-indicator {
  color: #8790a4;
}

.react-select__menu {
  background-color: #323742 !important;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
  border: none !important;
  border-radius: 0.3rem !important;
  z-index: 1000 !important;
}

.react-select__menu-list {
  border: 1px solid rgb(58.7931034483, 64.6724137931, 77.6068965517) !important;
  border-radius: 0.3rem !important;
}

.react-select__option {
  padding: 0.35rem 1.5rem !important;
  color: #d6d9e0 !important;
}
.react-select__option:hover {
  color: rgb(228.5208333333, 230.4583333333, 234.9791666667) !important;
  background-color: #3b414e !important;
}

.react-select__option--is-focused,
.react-select__option--is-selected {
  color: rgb(228.5208333333, 230.4583333333, 234.9791666667) !important;
  background-color: #3b414e !important;
}

.react-select__multi-value {
  background-color: rgba(83, 105, 248, 0.2) !important;
  color: #5369f8 !important;
}
.react-select__multi-value .react-select__multi-value__label {
  color: #5369f8;
}
.react-select__multi-value .react-select__multi-value__remove:hover {
  background-color: rgba(83, 105, 248, 0.2) !important;
  color: #5369f8 !important;
}

.ms-container {
  background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_16___}) no-repeat 50% 50%;
  width: auto;
  max-width: 370px;
}
.ms-container .ms-list {
  box-shadow: none;
  border: 1px solid #3b414e;
}
.ms-container .ms-list.ms-focus {
  box-shadow: none;
  border: 1px solid rgb(63.3927007299, 69.8394160584, 83.8072992701);
}
.ms-container .ms-selectable {
  background-color: rgb(54.3965517241, 59.8362068966, 71.8034482759);
}
.ms-container .ms-selectable li.ms-elem-selectable {
  border: none;
  padding: 5px 10px;
  color: #8790a4;
}
.ms-container .ms-selectable li.ms-hover {
  background-color: #5369f8;
  color: #fff;
}
.ms-container .ms-selection {
  background-color: rgb(54.3965517241, 59.8362068966, 71.8034482759);
}
.ms-container .ms-selection li.ms-elem-selection {
  border: none;
  padding: 5px 10px;
  color: #8790a4;
}
.ms-container .ms-selection li.ms-hover {
  background-color: #5369f8;
  color: #fff;
}

.ms-selectable {
  box-shadow: none;
  outline: none !important;
}

.ms-optgroup-label {
  font-weight: 500;
  font-family: "Nunito Sans", sans-serif;
  color: #bcc1cc !important;
  font-size: 13px;
}

.flatpickr-calendar {
  overflow: hidden;
  background-color: #494E67;
  box-shadow: none;
  border: 2px solid #3b414e;
}
.flatpickr-calendar .flatpickr-time {
  border: none !important;
}
.flatpickr-calendar .flatpickr-time input,
.flatpickr-calendar .flatpickr-time .flatpickr-am-pm {
  color: #8790a4;
}
.flatpickr-calendar .flatpickr-time input:focus, .flatpickr-calendar .flatpickr-time input:hover,
.flatpickr-calendar .flatpickr-time .flatpickr-am-pm:focus,
.flatpickr-calendar .flatpickr-time .flatpickr-am-pm:hover {
  background: #3b414e;
}

.flatpickr-day {
  color: #8790a4;
}
.flatpickr-day.selected, .flatpickr-day.startRange, .flatpickr-day.endRange, .flatpickr-day.selected.inRange, .flatpickr-day.startRange.inRange, .flatpickr-day.endRange.inRange, .flatpickr-day.selected:focus, .flatpickr-day.startRange:focus, .flatpickr-day.endRange:focus, .flatpickr-day.selected:hover, .flatpickr-day.startRange:hover, .flatpickr-day.endRange:hover, .flatpickr-day.selected.prevMonthDay, .flatpickr-day.startRange.prevMonthDay, .flatpickr-day.endRange.prevMonthDay, .flatpickr-day.selected.nextMonthDay, .flatpickr-day.startRange.nextMonthDay, .flatpickr-day.endRange.nextMonthDay {
  background: #5369f8 !important;
  border-color: #5369f8 !important;
}
.flatpickr-day.selected.startRange + .endRange:not(:nth-child(7n+1)), .flatpickr-day.startRange.startRange + .endRange:not(:nth-child(7n+1)), .flatpickr-day.endRange.startRange + .endRange:not(:nth-child(7n+1)) {
  box-shadow: -10px 0 0 #5369f8 !important;
}
.flatpickr-day.today {
  border-color: #3b414e !important;
}
.flatpickr-day.inRange {
  background: rgb(41.2068965517, 45.3275862069, 54.3931034483) !important;
  border-color: rgb(41.2068965517, 45.3275862069, 54.3931034483) !important;
  box-shadow: -10px 0 0 rgb(41.2068965517, 45.3275862069, 54.3931034483) !important;
}
.flatpickr-day.inRange.nextMonthDay {
  background: rgb(41.2068965517, 45.3275862069, 54.3931034483) !important;
  border-color: rgb(41.2068965517, 45.3275862069, 54.3931034483) !important;
}
.flatpickr-day.flatpickr-disabled, .flatpickr-day.flatpickr-disabled:hover, .flatpickr-day.prevMonthDay, .flatpickr-day.nextMonthDay, .flatpickr-day.notAllowed, .flatpickr-day.notAllowed.prevMonthDay, .flatpickr-day.notAllowed.nextMonthDay {
  color: rgba(135, 144, 164, 0.4);
}
.flatpickr-day.prevMonthDay.inRange, .flatpickr-day.nextMonthDay.inRange, .flatpickr-day.today.inRange, .flatpickr-day.today:hover, .flatpickr-day.today:focus, .flatpickr-day.prevMonthDay.today.inRange, .flatpickr-day.nextMonthDay.today.inRange, .flatpickr-day:hover, .flatpickr-day.prevMonthDay:hover, .flatpickr-day.nextMonthDay:hover, .flatpickr-day:focus, .flatpickr-day.prevMonthDay:focus, .flatpickr-day.nextMonthDay:focus {
  background: #3b414e !important;
  border-color: #3b414e !important;
  color: #8790a4;
}

.flatpickr-time input:hover,
.flatpickr-time .flatpickr-am-pm:hover,
.flatpickr-time input:focus,
.flatpickr-time .flatpickr-am-pm:focus {
  background: #212529 !important;
}

.flatpickr-months .flatpickr-month {
  height: 48px !important;
}
.flatpickr-months .flatpickr-prev-month,
.flatpickr-months .flatpickr-next-month {
  fill: #a1a8b8 !important;
}

.flatpickr-current-month {
  color: #a1a8b8;
  font-size: 1rem !important;
  padding: 8px 0 0 0 !important;
}
.flatpickr-current-month .flatpickr-monthDropdown-months .flatpickr-monthDropdown-month {
  color: #a1a8b8;
}

.flatpickr-weekdays {
  background: #5369f8 !important;
  display: none;
}

.flatpickr-weekday {
  color: rgba(255, 255, 255, 0.6) !important;
}

.bootstrap-touchspin .btn .input-group-text {
  padding: 0;
  border: none;
  background-color: transparent;
  color: inherit;
}

.parsley-errors-list {
  margin: 0;
  padding: 0;
}
.parsley-errors-list > li {
  list-style: none;
  color: #ff5c75;
  margin-top: 10px;
  padding: 4px 7px 4px 28px;
  position: relative;
  display: inline-block;
  background-color: rgba(255, 92, 117, 0.2);
  border-radius: 7px;
}
.parsley-errors-list > li:before {
  content: "\\ebee";
  font-family: "unicons";
  position: absolute;
  left: 8px;
  top: 4px;
}
.parsley-errors-list > li:after {
  content: "";
  border: 8px solid transparent;
  border-bottom-color: rgba(255, 92, 117, 0.2);
  position: absolute;
  left: 14px;
  top: -16px;
}

.parsley-error {
  border-color: #ff5c75;
}

.parsley-success {
  border-color: #43d39e;
}

.sw-main {
  box-shadow: none;
  border: 1px solid rgb(54.6072992701, 60.1605839416, 72.1927007299);
}
.sw-main .sw-toolbar {
  background: transparent;
  padding: 10px;
}
.sw-main .step-content {
  background-color: transparent !important;
}

.sw-theme-default .step-content {
  background-color: transparent;
}
.sw-theme-default > ul.step-anchor > li > a {
  color: #8790a4;
}
.sw-theme-default > ul.step-anchor > li > a:hover {
  color: #8790a4;
}
.sw-theme-default > ul.step-anchor > li > a:after {
  background: #5369f8;
}
.sw-theme-default > ul.step-anchor > li.active > a {
  color: #5369f8 !important;
}
.sw-theme-default > ul.step-anchor > li.done > a {
  color: #8790a4 !important;
}
.sw-theme-default > ul.step-anchor > li.done > a:after {
  background: #43d39e;
}

.sw-theme-arrows > ul.step-anchor {
  background: #3b414e;
  border-bottom-color: #3b414e;
}
.sw-theme-arrows > ul.step-anchor > li > a, .sw-theme-arrows > ul.step-anchor > li > a:hover {
  background: #3b414e;
  color: #8790a4;
}
.sw-theme-arrows > ul.step-anchor > li > a::after {
  border-left-color: #3b414e !important;
}
.sw-theme-arrows > ul.step-anchor > li > a::before {
  border-left-color: #576073 !important;
}
.sw-theme-arrows > ul.step-anchor > li.active > a {
  background: #5369f8 !important;
  border-color: #5369f8 !important;
}
.sw-theme-arrows > ul.step-anchor > li.active > a:after {
  border-left-color: #5369f8 !important;
}
.sw-theme-arrows > ul.step-anchor > li.done > a {
  background: rgb(200.6134078212, 207.5698324022, 252.7865921788) !important;
  border-color: rgb(200.6134078212, 207.5698324022, 252.7865921788) !important;
}
.sw-theme-arrows > ul.step-anchor > li.done > a:after {
  border-left-color: rgb(200.6134078212, 207.5698324022, 252.7865921788) !important;
}
.sw-theme-arrows > ul.step-anchor > li.done > a::before {
  border-left-color: #5369f8 !important;
}

.sw-theme-circles > ul.step-anchor {
  margin-top: 30px;
  background-color: transparent;
}
.sw-theme-circles > ul.step-anchor:before {
  background-color: #3b414e;
}
.sw-theme-circles > ul.step-anchor > li > a {
  font-size: 14px;
  width: 40px;
  height: 40px;
  padding: 12px 0;
  background-color: #3b414e;
  border-color: #323742 !important;
  box-shadow: none !important;
}
.sw-theme-circles > ul.step-anchor > li > a:hover {
  background-color: #3b414e;
}
.sw-theme-circles > ul.step-anchor > li > a small {
  bottom: -20px;
  width: 100%;
}
.sw-theme-circles > ul.step-anchor > li > a, .sw-theme-circles > ul.step-anchor > li > a:hover {
  color: #8790a4;
}
.sw-theme-circles > ul.step-anchor > li > a small, .sw-theme-circles > ul.step-anchor > li > a:hover small {
  color: #8790a4;
}
.sw-theme-circles > ul.step-anchor > li.active > a {
  background: #5369f8 !important;
  border-color: #5369f8 !important;
  color: #fff !important;
}
.sw-theme-circles > ul.step-anchor > li.active > a > small {
  color: #5369f8;
}
.sw-theme-circles > ul.step-anchor > li.done > a {
  background: #43d39e !important;
  border-color: #43d39e !important;
  color: #fff !important;
}
.sw-theme-circles > ul.step-anchor > li.done > a > small {
  color: #43d39e;
}

.sw-theme-dots > ul.step-anchor {
  background-color: transparent;
}
.sw-theme-dots > ul.step-anchor:before {
  background-color: #3b414e;
}
.sw-theme-dots > ul.step-anchor > li > a:before {
  bottom: -6px;
  background: #3b414e;
}
.sw-theme-dots > ul.step-anchor > li > a:after {
  left: 45%;
  bottom: -8px;
  background: #576073;
}
.sw-theme-dots > ul.step-anchor > li > a, .sw-theme-dots > ul.step-anchor > li > a:hover, .sw-theme-dots > ul.step-anchor > li > a:focus {
  color: #8790a4;
}
.sw-theme-dots > ul.step-anchor > li.active > a {
  color: #5369f8;
}
.sw-theme-dots > ul.step-anchor > li.active > a:after {
  background: #5369f8;
}
.sw-theme-dots > ul.step-anchor > li.done > a {
  color: #43d39e;
}
.sw-theme-dots > ul.step-anchor > li.done > a:after {
  background: #43d39e;
}

@media (max-width: 768px) {
  .sw-main > ul.step-anchor > li {
    display: block;
    width: 100%;
  }
  .sw-theme-circles > ul.step-anchor > li > a > small {
    bottom: 14px;
    left: 76px;
  }
  .sw-theme-dots > ul.step-anchor > li > a:after {
    top: -36px;
    left: -31px !important;
  }
}
/* rich text editor */
.rich-editor-wrapper {
  border: 1px solid #3b414e;
  border-radius: 0.25rem;
  min-height: 220px;
}
.rich-editor-wrapper .rich-editor {
  padding: 0.45rem 0.9rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: #a1a8b8;
}
.rich-editor-wrapper .rdw-dropdown-wrapper {
  box-shadow: none;
  border: 1px solid #3b414e;
  border-radius: 0.25rem;
}

.hide-toolbar {
  display: none !important;
}

@media (max-width: 767.98px) {
  .rich-editor-wrapper {
    min-height: 300px;
  }
}
.rdw-editor-toolbar {
  background: transparent !important;
  color: #a1a8b8;
  border: 1px solid #3b414e !important;
}
.rdw-editor-toolbar .rdw-option-wrapper {
  background: transparent !important;
  border: 1px solid #3b414e !important;
}
.rdw-editor-toolbar .rdw-option-wrapper:hover {
  box-shadow: none !important;
}

.dropzone {
  border: 2px dashed rgba(188, 193, 204, 0.2);
  background: rgb(58.7931034483, 64.6724137931, 77.6068965517);
  border-radius: 6px;
}

.react-bootstrap-table-pagination-list .pagination {
  justify-content: flex-end;
}

.react-bootstrap-table table {
  table-layout: auto;
}

@media (max-width: 767.98px) {
  .react-bootstrap-table-pagination-list .pagination {
    margin-top: 10px;
    justify-content: flex-start;
  }
}
.react-bs-table-sizePerPage-dropdown .btn {
  padding: 0.28rem 0.8rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.15rem;
}

#pagination-list .pagination li a {
  padding: 0.5rem 0.75rem;
  border-radius: 50%;
  display: block;
  line-height: 1.25;
  margin: 0 3px;
}
#pagination-list .pagination li.active a {
  background-color: #5369f8;
  color: #fff;
}

#transaction-list .sort {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat right 0.75rem center/8px 10px;
}

#noresult-list .error-message {
  display: none;
}

.tasklist {
  min-height: 40px;
  margin-bottom: 0;
}
.tasklist > li {
  background-color: #494E67;
  box-shadow: 0 0.05rem 0.01rem rgba(161, 168, 184, 0.075);
  padding: 20px;
  margin-bottom: 24px;
  border-radius: 7px;
}
.tasklist > li:last-of-type {
  margin-bottom: 0;
}
.tasklist > li:last-of-type .btn-sm, .tasklist > li:last-of-type .btn-group-sm > .btn {
  padding: 2px 8px;
  font-size: 12px;
}

.task-placeholder {
  border: 1px dashed #3b414e !important;
  background-color: #494E67 !important;
  padding: 20px;
  box-shadow: none !important;
}

/*!
* metismenujs - v1.4.0
* A menu plugin
* https://github.com/onokumus/metismenujs#readme
*
* Made by Osman Nuri Okumus <onokumus@gmail.com> (https://github.com/onokumus)
* Under MIT License
*/
:where(html) {
  --mm-transition-timing-function: ease;
  --mm-trantisition-duration: 0.35s;
}

.metismenu .mm-collapse:not(.mm-show) {
  display: none;
}

.metismenu .mm-collapsing {
  position: relative;
  height: 0;
  overflow: hidden;
  flex-wrap: nowrap;
  transition: height var(--mm-trantisition-duration) var(--mm-transition-timing-function);
}

.metismenu .has-arrow {
  position: relative;
}

.metismenu .has-arrow::after {
  position: absolute;
  content: "";
  width: 0.5em;
  height: 0.5em;
  border-width: 0 0 1px 1px;
  border-style: solid;
  border-color: initial;
  inset-inline-end: 1em;
  transform: rotate(45deg) translate(0, -50%);
  transform-origin: top;
  top: 50%;
  transition: transform var(--mm-trantisition-duration) var(--mm-transition-timing-function);
}

*[dir=rtl] .metismenu .has-arrow::after {
  transform: rotate(-135deg) translate(0, -50%);
}

.metismenu .mm-active > .has-arrow::after,
.metismenu .has-arrow[aria-expanded=true]::after {
  transform: rotate(-45deg) translate(0, -50%);
}

@media (prefers-reduced-motion: reduce) {
  .metismenu .mm-collapsing,
  .metismenu .has-arrow::after {
    transition-duration: 0.000000001s;
  }
}
.metismenu {
  padding: 0;
}
.metismenu li {
  list-style: none;
}
.metismenu li a[aria-expanded=true] {
  color: #4BB3BC !important;
}
.metismenu ul {
  padding: 0;
}
.metismenu ul li {
  width: 100%;
}
.metismenu .mm-collapse:not(.mm-show) {
  display: none;
}
.metismenu .mm-collapsing {
  position: relative;
  height: 0;
  overflow: hidden;
  transition-timing-function: ease;
  transition-duration: 0.35s;
  transition-property: height, visibility;
}

.recon-names ul {
  padding: 0;
  margin: 0;
  min-width: 170px;
  font-size: 12px;
}
.recon-names li {
  padding: 0;
  margin: 0;
  height: 40px;
}

.cron_builder_bordering {
  border: none;
  border-top: none;
  text-align: center;
  padding: 10px;
  background: #fff;
}

.cron_builder_bordering_dark {
  border: 1px solid #ddd;
  border-top: none;
  text-align: center;
  padding: 10px;
  background: #323742;
  color: white;
}

.cron_builder_bordering input, .cron_builder_bordering select {
  width: 100px;
  margin-right: 10px;
  margin-left: 10px;
  border: none;
  border-radius: 4px;
  outline: none;
  padding-left: 5px;
  cursor: pointer;
}

.cron_builder_bordering_dark input, .cron_builder_bordering_dark select {
  width: 100px;
  margin-right: 10px;
  margin-left: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  outline: none;
  padding-left: 5px;
  cursor: pointer;
  background-color: #323742;
  color: white;
}

.df {
  display: flex;
}

.cron-builder-bg {
  background-color: #086090;
  color: white;
  text-align: center;
  margin-bottom: 4px;
  padding: 8px 0px;
}

.cron-builder-bg-dark {
  background-color: #323742;
  color: white;
  text-align: center;
  margin-bottom: 4px;
  padding: 8px 0px;
}

.cron_builder_bordering select {
  background-color: white;
  width: 75px;
  cursor: pointer;
  padding: 4px 2px;
  border-radius: 4px;
}

.cron_builder_bordering_dark select {
  background-color: #323742;
  color: white;
  width: 75px;
  cursor: pointer;
  padding: 4px 2px;
  border-radius: 4px;
}

.cron_builder_bordering select option:hover {
  background-color: #086090;
}

.cron_builder_bordering_dark select option:hover {
  background-color: #323742;
}

.well-small input {
  width: auto !important;
}

.cron_builder_bordering input[type=radio] {
  margin-top: 0px;
  vertical-align: middle;
}

.cron_builder_bordering_dark input[type=radio] {
  margin-top: 0px;
  vertical-align: middle;
}

.cron_builder {
  border: 1px solid #d0cbcb;
  padding: 5px;
  background-color: rgba(221, 222, 241, 0.2392156863);
  width: 100%;
}

.cron_builder_dark {
  border: 1px solid #d0cbcb;
  padding: 5px;
  background-color: #64687C;
  width: 100%;
}

.text_align_left {
  text-align: left;
}

.cron_builder .nav li {
  cursor: pointer;
  flex: 0 0 85px;
  text-align: center;
}

.cron_builder .nav li a {
  color: #337ab7;
}

.cron_builder_dark .nav li {
  cursor: pointer;
  flex: 0 0 85px;
  text-align: center;
}

.cron_builder_dark .nav li a {
  color: white;
}

.cron_builder .nav-tabs .nav-link:focus, .cron_builder .nav-tabs .nav-link:hover {
  box-shadow: 5px 1px #16BFC7;
  border: 1px solid #16BFC7;
  border-bottom: none !important;
  background-color: white;
}

.cron_builder_dark .nav-tabs .nav-link:focus, .cron_builder_dark .nav-tabs .nav-link:hover {
  justify-content: space-around;
  box-shadow: 5px 1px #16BFC7;
  border: 1px solid #16BFC7;
  border-bottom: none;
  background-color: transparent;
}

.cron_builder .nav-tabs .nav-item.show .nav-link, .cron_builder .nav-tabs .nav-link.active {
  box-shadow: 5px 1px #16BFC7;
  border: 1px solid #16BFC7;
  border-bottom: none !important;
  background-color: rgba(221, 222, 241, 0.2392156863);
  color: black !important;
}

.cron_builder_dark .nav-tabs {
  justify-content: space-around;
}

.cron_builder_dark .nav-tabs .nav-item.show .nav-link, .cron_builder_dark .nav-tabs .nav-link.active {
  box-shadow: 5px 1px #16BFC7;
  border: 1px solid #16BFC7;
  border-bottom: none !important;
  background-color: #323742;
  color: #16BFC7 !important;
}

.cron_builder {
  font-size: 14px;
}

.cron_builder_dark {
  font-size: 14px;
}

.cron_builder .well {
  min-height: 20px;
  padding: 19px;
  margin-bottom: 20px;
  background-color: #f5f5f5;
  border: 1px solid #e3e3e3;
  border-radius: 4px;
  /* -webkit-box-shadow: inset 0 1px 1px rgb(0 0 0 / 5%); */
  /* box-shadow: inset 0 1px 1px rgb(0 0 0 / 5%); */
}

.cron_builder_dark .well {
  min-height: 20px;
  padding: 19px;
  margin-bottom: 20px;
  background-color: #64687C !important;
  border: 1px solid #e3e3e3;
  border-radius: 4px;
  /* -webkit-box-shadow: inset 0 1px 1px rgb(0 0 0 / 5%); */
  /* box-shadow: inset 0 1px 1px rgb(0 0 0 / 5%); */
}

@media screen and (max-width: 767px) {
  .cron_builder .nav li {
    cursor: pointer;
    flex: 0 0 65px;
    text-align: center;
  }
}
@media screen and (max-width: 767px) {
  .cron_builder_dark .nav li {
    cursor: pointer;
    flex: 0 0 65px;
    text-align: center;
  }
}
.ruleGroup {
  padding: 0.5rem;
  border: 1px solid #7f81a2;
  border-radius: 4px;
  background: rgba(0, 75, 183, 0.2);
}
.ruleGroup .rule,
.ruleGroup .ruleGroup {
  margin-top: 0.5rem;
  margin-left: 0.5rem;
}
.ruleGroup .ruleGroup-combinators.betweenRules {
  margin-top: 0.5rem;
}
.ruleGroup .ruleGroup-notToggle {
  margin-right: 0.5rem;
}

.react-datepicker__time-container {
  width: 90px !important;
}
.react-datepicker__time-container .react-datepicker__time {
  width: 90px !important;
}
.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box {
  width: 90px !important;
}
.react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list {
  width: 90px !important;
}
.react-datepicker__time-container .react-datepicker__header:not(.react-datepicker__header--has-time-select) {
  height: 64px;
}

.text-muted {
  color: #4bb3bc !important;
}

.for-update-recon-setup {
  margin-top: 20px;
}

.card-title {
  color: #4bb3bc !important;
}

.btn-primary {
  color: #fff;
  background: #16bfc7;
  border: none;
}

.btn-link {
  color: #16bfc7 !important;
}

.btn-primary.disabled,
.btn-primary:disabled {
  color: #fff !important;
  background-color: #566768 !important;
  border-color: #566768 !important;
}

.list-group-item.active {
  z-index: 2;
  color: #fff;
  background-color: #16bfc7 !important;
  border-color: #16bfc7 !important;
}

.box-layout {
  border: 0px solid;
  padding: 0px !important;
  width: 30vh !important;
  border-radius: 3px;
  height: fit-content;
  min-height: 86vh;
  margin-left: 10px;
  margin-right: 10px;
  box-shadow: 2px 2px 2px rgba(68, 60, 124, 0.0784313725);
}

.view-style {
  background: rgba(0, 75, 183, 0.2) !important;
  border: 1px solid #7f81a2 !important;
  border-radius: 2px !important;
}

.view-text-box-dark {
  background-color: #3b3b3b;
  color: white !important;
  border-color: rgb(118, 118, 118) !important;
  border-radius: 2px !important;
  height: 23px;
  box-sizing: border-box;
  font-size: inherit;
  font-family: inherit;
  border: 1px solid;
}

.view-text-box {
  height: 23px;
  box-sizing: border-box;
  font-size: inherit;
  font-family: inherit;
  border: 1px solid;
}

.box-layout-dark {
  background-color: #494e67;
}

.box-layout-white {
  background-color: #ffffff;
}

.contextMenu {
  z-index: 999;
  position: fixed;
  opacity: 1;
  pointer-events: auto;
  top: 172px;
  left: 331px;
  border: 1px solid #16bfc7;
  background-color: #16bfc7;
  padding: 5px;
  border-radius: 3px;
  color: #fff;
}

.forHeader {
  margin: 0px 0px 0px 0px !important;
  height: 50px !important;
  padding-top: 5px !important;
  background-color: #373c53 !important;
  border-radius: 3px !important;
  font-size: 16px !important;
  padding-top: 12px !important;
  padding-left: 13px !important;
}

.forHeaderSource {
  margin: 0px 0px 0px 0px !important;
  height: 50px !important;
  padding-top: 5px !important;
  background-color: #373c53 !important;
  border-radius: 3px !important;
  font-size: 16px !important;
  padding-top: 12px !important;
  padding-left: 13px !important;
  width: 231px !important;
}

.forHeader-dark {
  background-color: #373c53 !important;
}

.forHeader-white {
  background-color: #d7e1ec !important;
  color: black !important;
}

.nav-tabs li a.active {
  color: #16bfc7 !important;
  border-radius: 0px !important;
  font-size: 14px !important;
  border: none !important;
  width: 100% !important;
}

.for-edit-button {
  float: right;
}

.for-nav-item {
  padding-left: 10px;
}

.for-title-name {
  font-size: 19px;
  padding-top: 10px;
  font-weight: 100;
}

.for-title-name-white {
  color: black;
}

.for-title-name-dark {
  color: white;
}

.commentHeight {
  height: 130px !important;
}

.nav-tabs .nav-link {
  font-size: 14px;
  padding: 5.5px 0px 5px 20px;
  font-weight: normal;
}

.nav-tabs {
  border-bottom: none !important;
}

.col-md-2 {
  flex: 0 0 16.66667%;
  max-width: 15%;
}

.for-closing-icon {
  width: 25px;
  margin: 12px 10px 0px 24px;
  opacity: 0.7;
}

.for-source-type-layout {
  margin-top: 8px;
  margin-right: 20px;
}

.top-recon-container {
  display: flex;
  justify-content: space-between;
}

.for-recon-card-header-white {
  background-color: white;
}

.for-recon-card-header-dark {
  background-color: #494e67 !important;
}

.btn-secondary {
  color: #fff;
  background-color: #16bfc7;
  border: none;
}

.btn-secondary:hover {
  color: #fff;
  background-color: #16bfc7;
  border: none;
  opacity: 0.8;
}

.btn-secondary:focus {
  color: #fff;
  background-color: #16bfc7;
  border: none;
}

.for-recon-cardBody {
  padding: 0px;
}

.for-recon-card-white {
  background-color: white;
}

.for-recon-card-dark {
  background-color: #494e67;
}

.for-layout-recon {
  display: flex;
  justify-content: flex-start;
}

.for-select {
  width: 12vw !important;
  height: 25px;
  border-radius: 4px;
  border: 0.5px solid;
  background-color: transparent;
  margin-top: 0.1px;
  padding: 2px;
  font-size: 15px;
  opacity: 0.8;
}

.for-select-dark {
  border-color: white;
  color: white !important;
  background-color: #373c53;
}

.css-yk16xz-control {
  border-color: black;
  color: black !important;
  background-color: white;
}

.for-recon-save-botton {
  position: fixed;
  top: 110px;
  right: 13px;
  z-index: 999;
}

.top-bar-dark {
  width: 300px;
  background-color: #121317;
}

.top-bar-light {
  width: 250px;
  background-color: #f6f6f6;
}

.TOP-CONTAINER {
  display: flex;
  flex-direction: column;
}

.InContainer .ag-cell-inline-editing {
  height: 100%;
}

.ps__thumb-x {
  background-color: transparent;
  border-radius: 6px;
  transition: background-color 0.2s linear, height 0.2s ease-in-out;
  -webkit-transition: background-color 0.2s linear, height 0.2s ease-in-out;
  height: 6px;
  bottom: 2px;
  position: absolute;
}

.ps__thumb-y {
  background-color: transparent;
  border-radius: 6px;
  transition: background-color 0.2s linear, height 0.2s ease-in-out;
  -webkit-transition: background-color 0.2s linear, height 0.2s ease-in-out;
  height: 6px;
  bottom: 2px;
  position: absolute;
}

.main-common {
  transition: margin-left 0.5s;
  margin-top: 62px;
  padding-left: 30px !important;
  padding-right: 30px !important;
}
@media screen and (max-height: 450px) {
  .main-common .sidebar {
    padding-top: 15px;
  }
  .main-common .sidebar a {
    font-size: 18px;
  }
}

.main {
  margin-left: 78px;
}

.main2 {
  margin-left: 300px !important;
}

#sidebar-menu > ul > li > a {
  color: #6e768e;
  display: block;
  padding: 12px 35px !important;
  font-size: 15px;
  font-weight: 400;
  position: relative;
  transition: all 0.4s;
  border-left: 3px solid transparent;
  margin-left: -13px;
}

#sidebar-menu > ul > li > a svg {
  display: inline-block;
  width: 16px;
  height: 16px;
  margin: 0 20px 0 9px;
  color: #6e768e;
  fill: rgba(110, 118, 142, 0.12);
}

.user-profile {
  padding: 14px 20px 14px 40px !important;
}

#sidebar-menu > ul > li > a > span {
  vertical-align: middle;
  margin-left: 18px;
}

.media-body {
  flex: 1;
  margin-left: 6px;
}

#sidebar-menu .menu-arrow {
  transition: transform 0.15s;
  position: absolute;
  right: 30px;
  display: inline-block;
  font-family: "unicons";
  text-rendering: auto;
  line-height: 1.3rem;
  font-size: 0.9rem;
  transform: translate(0, 0);
  top: 15px;
  /* left: 9px; */
  margin-right: 15px;
}

.nav-second-level li a,
.nav-thrid-level li a {
  padding: 9px 49px;
  color: #6e768e;
  display: block;
  position: relative;
  transition: all 0.4s;
}

#sidebar-menu {
  padding-bottom: 30px;
}

.footer {
  bottom: 0;
  padding: 19px 15px 20px;
  position: absolute;
  right: 0;
  color: #8790a4;
  left: 759px;
}

.sidebar {
  position: fixed;
  margin-top: 10px !important;
  z-index: 1;
  top: 3px;
  left: 0;
  overflow-x: hidden;
  transition: 0.5s;
  padding-top: 60px;
  white-space: nowrap;
  height: 1600px;
}

.sidebar-light {
  width: 78px;
}

.sidebar-dark {
  width: 300px !important;
}

.sidebar a {
  padding: 8px 8px 8px 32px;
  text-decoration: none;
  font-size: 15px;
  color: #818181;
  display: block;
  transition: 0.3s;
}

.sidebar a:hover {
  color: #f1f1f1;
}

.sidebar .closebtn {
  position: absolute;
  top: 0;
  right: 25px;
  font-size: 36px;
  margin-left: 50px;
}

.material-icons,
.icon-text {
  vertical-align: middle;
}

.material-icons {
  padding-bottom: 3px;
}

.for-recon-select-container {
  display: flex !important;
}

.for-select-recon-explorer {
  padding: 5px !important;
  margin-top: 5px !important;
  width: 200px;
}

.recon-names.recon-nav-item {
  text-align: left;
  display: block;
  width: 100%;
}

.source-settings-button {
  margin-top: 10vh;
}

.ag-theme-alpine .ag-cell-wrapper > *:not(.ag-cell-value):not(.ag-group-value) {
  height: 20px;
  display: flex;
  align-items: center;
  flex: none;
}

.for-settings-tab {
  margin-left: 0px !important;
  margin-top: 0px !important;
  padding: 25px;
  width: 383px;
  border-radius: 0px;
  height: 80vh;
  overflow: auto;
}

.for-settings-tab-light {
  background-color: white;
}

.for-settings-tab-dark {
  background-color: #494e67;
}

.for-tab-title {
  font-size: 20px;
  font-style: italic;
  color: #16bfc7;
  border: 1px solid;
  width: 158px;
  padding-left: 39px;
}

.table th {
  font-weight: 700;
  width: 266px;
}

.ruleGroup .ruleGroup-header {
  padding: 5px;
}
.ruleGroup .rule-value {
  width: 30%;
}
.ruleGroup .rule-operators {
  width: 30%;
}
.ruleGroup .rule-fields {
  width: 30%;
}
.ruleGroup .ruleGroup-combinators {
  width: 30%;
}

.cron_builder {
  width: 100%;
}
.cron_builder .nav-tabs {
  justify-content: space-around;
}

.headingContainer {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.for-modal-body-calculations {
  height: fit-content !important;
  min-height: 490px !important;
  padding-bottom: 26px;
  border-radius: 10px;
}

.css-26l3qy-menu {
  position: absolute !important;
  z-index: 99999999 !important;
}

fieldset legend {
  background: transparent !important;
  color: cadetblue;
  padding: 8px 10px;
  font-size: 13px;
  border-radius: 4px;
  box-shadow: 0 0 0 1px #3b414e;
  margin-left: 6px;
}

fieldset {
  font-family: sans-serif;
  border: 1px solid #3b414e;
  background: transparent !important;
  border-radius: 5px;
  padding: 15px;
  margin-top: 20px;
  height: 370px;
}

.for-card-header {
  border-radius: 5px;
}

.for-card-footer {
  border-radius: 0px 0px 5px 5px;
}

.table th,
.table td {
  padding: 0.75rem;
  vertical-align: top;
  font-size: 13px !important;
  width: 104px !important;
  border: none;
  padding-left: 15px;
}

.table-bordered {
  border: 1px solid;
}

.table thead th {
  vertical-align: bottom;
  border-bottom: 1px solid;
}

.for-add-fields-button {
  padding-left: 8px;
  padding-top: 8px;
}

.for-dashboard-reco {
  position: absolute;
  z-index: 9;
  top: 106px;
  left: 166px;
}

.for-salesChart {
  display: flex;
  justify-content: space-between;
}

.buttonMargin {
  margin-top: 10px;
  margin-left: 10px !important;
}

.topbar-text-width {
  width: 150px;
}

.for-layout-graph {
  justify-content: space-between !important;
}

.for-graphql-modal {
  margin-top: 300px !important;
}

.for-link-top {
  color: #4bb4bc !important;
}

.for-scheme-color {
  color: #4bb3bc;
  font-size: 18.5px;
}

.remove-border {
  border-bottom: none !important;
}

.forFormSource {
  margin-left: 475px !important;
}

.date-search-button {
  margin-left: 7px;
}

.for-label {
  width: 175px;
}

.InContainer {
  display: flex !important;
  justify-content: space-between !important;
}

.forUpperDashboard {
  max-height: 8vh;
  display: flex !important;
  justify-content: center !important;
}

.export {
  height: 35px;
  width: 35px;
  margin-left: 10px;
  margin-top: 2px;
}

#filter-text-box {
  height: 32px !important;
  margin-top: 6px !important;
}

.filter-text-box {
  height: 32px !important;
  margin-top: 10px !important;
}

.ps {
  overflow-y: auto !important;
}

.submit-button {
  margin-top: 1px !important;
  margin-bottom: 0px !important;
  border: none;
}

.for-modal {
  top: -200px;
  left: 100px;
  width: 82%;
}

.match-status-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-left: -146px !important;
  font-size: 15px;
  margin-top: 20px;
}

.for-multiselect {
  margin-left: 100px;
  width: 410px;
}

.for-search-button {
  margin: 16px 0px 0px 321px !important;
  width: 112px;
}

.for-search-button-date-source {
  margin: 16px 0px 0px 295px !important;
  width: 112px;
}

.for-clear-button-recon {
  margin: 16px 0px 0px 25px !important;
  width: 112px;
}

.for-showAllItems-button-recon {
  margin: 16px 0px 0px 25px !important;
  width: 135px;
}

.remove-border {
  border-bottom: none !important;
  width: 500px;
}

.forForm {
  margin-top: 33px;
  width: 980px;
  display: flex;
  justify-content: space-evenly;
}

.for-height {
  height: 28px;
}

.process-date {
  font-size: 20px;
  margin-top: 6px;
  text-align: center;
  margin-right: 5px;
  font-weight: bolder;
}

.for-label-recon {
  width: 180px;
  margin-left: -23px;
}

.forMargin {
  margin: 6px;
}

.calculation-container {
  margin-bottom: -7px;
  display: flex;
  justify-content: space-evenly !important;
}

.calculation-container-context {
  width: 1400px !important;
  display: flex;
  justify-content: space-evenly !important;
}

.calculation-headings {
  font-weight: bold;
  font-size: 16px;
}

.middle {
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
  z-index: 999 !important;
}

.bar {
  width: 10px;
  height: 70px;
  background: #fff;
  display: inline-block;
  transform-origin: bottom center;
  border-top-right-radius: 20px;
  border-top-left-radius: 20px;
  /*   box-shadow:5px 10px 20px inset rgba(255,23,25.2); */
  animation: loader 1.2s linear infinite;
}

.bar1 {
  animation-delay: 0.1s;
}

.bar2 {
  animation-delay: 0.2s;
}

.bar3 {
  animation-delay: 0.3s;
}

.bar4 {
  animation-delay: 0.4s;
}

.bar5 {
  animation-delay: 0.5s;
}

.bar6 {
  animation-delay: 0.6s;
}

.bar7 {
  animation-delay: 0.7s;
}

.bar8 {
  animation-delay: 0.8s;
}

@keyframes loader {
  0% {
    transform: scaleY(0.1);
    background: red;
  }
  50% {
    transform: scaleY(1);
    background: yellowgreen;
  }
  100% {
    transform: scaleY(0.1);
    background: transparent;
  }
}
/* Style the tab */
.tab {
  height: 50px;
  overflow: hidden;
  background-color: #d7e1ec;
}

.tab-dark {
  height: 50px;
  overflow: hidden;
  background-color: #373c53;
}

.tab-trigger {
  height: 58px;
  overflow: hidden;
  background-color: #d7e1ec;
}

.tab-dark-trigger {
  height: 58px;
  overflow: hidden;
  background-color: #373c53;
}

/* Style the buttons that are used to open the tab content */
.tab li {
  background-color: inherit;
  float: left;
  border: none;
  outline: none;
  cursor: pointer;
  padding: 14px 16px;
  transition: 0.3s;
}

.tab-dark li {
  background-color: inherit;
  float: left;
  border: none;
  outline: none;
  cursor: pointer;
  padding: 14px 16px;
  transition: 0.3s;
  color: white;
}

/* Change background color of buttons on hover */
.tab li:hover {
  background-color: white;
}

.tab-dark li:hover {
  background-color: #64687c;
}

/* Create an active/current tablink class */
.tab li.active {
  box-shadow: 5px 1px #16bfc7;
  border: 1px solid #16bfc7;
  border-bottom: none !important;
  background-color: none;
}

.tab-dark li.active {
  box-shadow: 5px 1px #16bfc7;
  border: 1px solid #16bfc7;
  border-bottom: none !important;
  background-color: none;
}

/* Trigger event tabs use their own wrapper class, so they need the same
   button, hover and active-tab treatment as .tab / .tab-dark */
.tab-trigger li,
.tab-dark-trigger li {
  background-color: inherit;
  float: left;
  border: none;
  outline: none;
  cursor: pointer;
  padding: 14px 16px;
  transition: 0.3s;
}

.tab-dark-trigger li {
  color: white;
}

.tab-trigger li:hover {
  background-color: white;
}

.tab-dark-trigger li:hover {
  background-color: #64687c;
}

.tab-trigger li.active,
.tab-dark-trigger li.active {
  box-shadow: 5px 1px #16bfc7;
  border: 1px solid #16bfc7;
  border-bottom: none !important;
  background-color: none;
}

.table .condition-width {
  width: 30% !important;
}

.table .action-width {
  width: 10% !important;
}

.list-group-item-dark {
  background-color: #494e67 !important;
  color: #a1a8b8;
}

.react-datepicker-wrapper {
  width: 100%;
}

.ag-row-group.ag-row-level-0 {
  background-color: rgba(24, 29, 31, 0.07);
}

.ag-row-group.ag-row-level-1 {
  background-color: rgba(24, 29, 31, 0.07);
}

.ag-row-group.ag-row-level-2 {
  background-color: rgba(24, 29, 31, 0.07);
}

.ag-theme-alpine-dark {
  --ag-background-color: #494e67;
  --ag-foreground-color: white;
  --ag-border-color: grey;
  --ag-secondary-border-color: grey;
  --ag-modal-overlay-background-color: rgba(24, 29, 31, 0.66);
  --ag-header-background-color: #494e67;
  --ag-tooltip-background-color: #222628;
  --ag-odd-row-background-color: #494e67;
  --ag-header-cell-hover-background-color: #494e67;
  --ag-header-cell-moving-background-color: #494e67;
  --ag-control-panel-background-color: #494e67;
  --ag-subheader-background-color: #000;
  --ag-input-disabled-background-color: #282c2f;
  --ag-input-focus-box-shadow: 0 0 2px 0.5px rgba(255, 255, 255, 0.5), 0 0 4px 3px var(--ag-input-focus-border-color);
  --ag-card-shadow: 0 1px 20px 1px black;
  --ag-disabled-foreground-color: rgba(255, 255, 255, 0.5);
  --ag-chip-background-color: rgba(255, 255, 255, 0.07);
  --ag-input-disabled-border-color: rgba(104, 104, 110, 0.3);
  --ag-input-disabled-background-color: rgba(104, 104, 110, 0.07);
}

.div-img {
  position: fixed;
  bottom: 5px;
  right: 5px;
  padding: 10px;
  justify-content: center;
  align-items: center;
  display: flex;
  padding-top: 20%;
}

.enlarge {
  transition: transform 0.2s;
  width: 50px;
  height: 50px;
  margin: 0 auto;
  border-radius: 0px;
}

.enlarge:hover {
  transform: scale(1.5);
}

.typing {
  position: relative;
}
.typing .typingDot {
  content: "";
  animation: blink 1.5s infinite;
  animation-fill-mode: both;
  height: 10px;
  width: 10px;
  background: #3b5998;
  position: absolute;
  left: 0;
  top: 0;
  border-radius: 50%;
}
.typing .typingDot:nth-child(2) {
  animation-delay: 0.2s;
  margin-left: 15px;
}
.typing .typingDot:nth-child(3) {
  animation-delay: 0.4s;
  margin-left: 30px;
}

@keyframes blink {
  0% {
    opacity: 0.1;
  }
  20% {
    opacity: 1;
  }
  100% {
    opacity: 0.1;
  }
}
.floating-button {
  position: fixed;
  top: 120px;
  bottom: 20px;
  /* Adjust as needed */
  right: 20px;
  /* Adjust as needed */
  border: none;
  border-radius: 5%;
  /* Makes the button circular */
  width: 50px;
  /* Adjust as needed */
  height: 50px;
  /* Adjust as needed */
  font-size: 20px;
  text-align: center;
  line-height: 50px;
  /* Vertically center the text */
  cursor: pointer;
  z-index: 1000;
  /* Ensure the button is above other content */
}

.join-line {
  position: relative;
  padding-left: 20px;
}

.join-line:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 2px;
  background-color: #dee2e6;
}

.query-section {
  background-color: #f8f9fa;
  border-radius: 5px;
  padding: 15px;
}

.table-hover tbody tr:hover {
  background-color: rgba(0, 0, 0, 0.03);
  cursor: pointer;
}

table .override-font {
  font-size: 16px !important;
}

/* 18. Components Demo */
.button-list {
  margin-left: -8px;
  margin-bottom: -12px;
}
.button-list .btn {
  margin-bottom: 12px;
  margin-left: 8px;
}

.icons-list-demo div {
  cursor: pointer;
  line-height: 45px;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
  overflow: hidden;
  color: #8790a4;
}
.icons-list-demo div p {
  margin-bottom: 0;
  line-height: inherit;
}
.icons-list-demo i {
  text-align: center;
  vertical-align: middle;
  font-size: 22px;
  width: 50px;
  height: 50px;
  line-height: 50px;
  margin-right: 12px;
  border-radius: 50%;
  display: inline-block;
  transition: all 0.2s;
}
.icons-list-demo .col-lg-4 {
  border-radius: 3px;
  background-clip: padding-box;
  margin-top: 10px;
}
.icons-list-demo .col-lg-4:hover i {
  background-color: #5369f8;
  color: #fff;
  text-shadow: 5px 5px rgba(255, 255, 255, 0.2);
}

.icons-list .icon-item {
  padding: 15px 0;
  color: #8790a4;
}
.icons-list .icon-item svg {
  margin-right: 10px;
}
.icons-list .icon-item span {
  line-height: 30px;
  display: inline-block;
  vertical-align: middle;
}

/* 19. Tasks */
.board {
  display: block;
  white-space: nowrap;
  overflow-x: auto;
}

.tasks {
  display: inline-block;
  width: 22rem;
  padding: 0 1rem 1rem 1rem;
  vertical-align: top;
  margin-bottom: 24px;
  background-color: #494E67;
  border-radius: 0.2rem;
}
.tasks.tasks:not(:last-child) {
  margin-right: 1.25rem;
}
.tasks .card {
  white-space: normal;
  margin-top: 1rem;
}
.tasks .task-header {
  background-color: #494E67;
  padding: 1rem;
  margin: 0 -1rem;
  border-radius: 0.2rem;
}

.task-list-items {
  min-height: 100px;
  position: relative;
}
.task-list-items .card {
  cursor: pointer;
}
.task-list-items:before {
  content: "No Tasks";
  position: absolute;
  line-height: 110px;
  width: 100%;
  text-align: center;
  font-weight: 600;
}

.task-modal-content .form-control-light {
  background-color: rgb(55.4956896552, 61.0452586207, 73.2543103448) !important;
  border-color: rgb(55.4956896552, 61.0452586207, 73.2543103448) !important;
}

.gantt-task-details {
  min-width: 220px;
}

.task-search .search-input {
  padding-left: 32px;
  z-index: 10;
}
.task-search .icon-search {
  z-index: 11;
  position: absolute;
  left: 10px;
  top: 10px;
}

.cursor-pointer {
  cursor: pointer;
}

/* 20. Email */
.email-container {
  margin-bottom: 24px;
  background-color: #494E67;
}
.email-container .inbox-leftbar {
  padding: 1.25rem;
  width: 250px;
  float: left;
  padding-bottom: 184px;
  margin-bottom: -184px;
}
.email-container .inbox-rightbar {
  margin-left: 250px;
  border-left: 5px solid #64687C;
  padding: 0 0 1.5rem 25px;
}

.message-list {
  display: block;
  padding-left: 0;
}
.message-list li {
  position: relative;
  display: block;
  height: 48px;
  line-height: 48px;
  cursor: default;
  transition-duration: 0.3s;
  background: #494E67;
  margin-bottom: 1px;
  box-shadow: 0 0.05rem 0.01rem rgba(161, 168, 184, 0.075);
}
.message-list li a {
  color: #a1a8b8;
}
.message-list li:hover {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  transition-duration: 0.05s;
}
.message-list li .col-mail {
  float: left;
  position: relative;
}
.message-list li .col-mail-1 {
  width: 320px;
}
.message-list li .col-mail-1 .star-toggle,
.message-list li .col-mail-1 .checkbox-wrapper-mail,
.message-list li .col-mail-1 .dot {
  display: block;
  float: left;
}
.message-list li .col-mail-1 .dot {
  border: 4px solid transparent;
  border-radius: 100px;
  margin: 22px 26px 0;
  height: 0;
  width: 0;
  line-height: 0;
  font-size: 0;
}
.message-list li .col-mail-1 .checkbox-wrapper-mail {
  margin: 15px 10px 0 20px;
}
.message-list li .col-mail-1 .star-toggle {
  color: #6b768d;
  margin-left: 10px;
}
.message-list li .col-mail-1 .title {
  position: absolute;
  top: 0;
  left: 100px;
  right: 0;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin-bottom: 0;
  line-height: 50px;
}
.message-list li .col-mail-2 {
  position: absolute;
  top: 0;
  left: 320px;
  right: 0;
  bottom: 0;
}
.message-list li .col-mail-2 .subject,
.message-list li .col-mail-2 .date {
  position: absolute;
  top: 0;
}
.message-list li .col-mail-2 .subject {
  left: 0;
  right: 110px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.message-list li .col-mail-2 .date {
  right: 0;
  width: 100px;
  padding-left: 10px;
}
.message-list li.active,
.message-list li.mail-selected {
  background: #212529;
  transition-duration: 0.05s;
}
.message-list li.active,
.message-list li.active:hover {
  box-shadow: inset 3px 0 0 #25c2e3;
}
.message-list li.unread a {
  color: rgb(173.5211864407, 179.6016949153, 192.9788135593);
}
.message-list .checkbox-wrapper-mail {
  cursor: pointer;
  height: 20px;
  width: 20px;
  position: relative;
  display: inline-block;
  box-shadow: inset 0 0 0 2px #576073;
  border-radius: 3px;
}
.message-list .checkbox-wrapper-mail input {
  opacity: 0;
  cursor: pointer;
}
.message-list .checkbox-wrapper-mail input:checked ~ label {
  opacity: 1;
}
.message-list .checkbox-wrapper-mail label {
  position: absolute;
  top: 3px;
  left: 3px;
  right: 3px;
  bottom: 3px;
  cursor: pointer;
  background: #8790a4;
  opacity: 0;
  margin-bottom: 0 !important;
  transition-duration: 0.05s;
}
.message-list .checkbox-wrapper-mail label:active {
  background: #87949b;
}

.mail-list a {
  color: #a1a8b8;
  padding: 7px 10px;
  display: block;
}

.reply-box {
  border: 2px solid #3b414e;
}

@media (max-width: 648px) {
  .email-container .inbox-leftbar {
    width: 100%;
    float: none;
    margin-bottom: 21px;
    padding-bottom: 1.25rem;
  }
  .email-container .inbox-rightbar {
    margin-left: 0;
    border: 0;
    padding-left: 0;
  }
}
@media (max-width: 520px) {
  .inbox-rightbar > .btn-group {
    margin-bottom: 10px;
  }
  .message-list li .col-mail-1 {
    width: 150px;
  }
  .message-list li .col-mail-1 .title {
    left: 80px;
  }
  .message-list li .col-mail-2 {
    left: 160px;
  }
  .message-list li .col-mail-2 .date {
    text-align: right;
    padding-right: 10px;
    padding-left: 20px;
  }
}
.chatbox {
  position: fixed;
  right: 35px;
  bottom: 10px;
  width: 300px;
  background-color: #494E67;
  border-radius: 0.3rem;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  z-index: 99;
}
.chatbox .chat-input .form-control {
  padding-right: 60px;
}
.chatbox .chat-link {
  position: absolute;
  right: 4px;
  top: 10px;
}

/* 21. Timeline */
/************** Horizontal timeline **************/
.left-timeline .events {
  border-left: 3px solid #3b414e;
  padding-left: 35px;
}
.left-timeline .events .event-list {
  position: relative;
}
.left-timeline .events .event-list::before {
  content: "";
  position: absolute;
  left: -45px;
  top: 6px;
  height: 18px;
  width: 18px;
  background-color: #5369f8;
  border-radius: 50%;
  border: 5px solid #494E67;
  z-index: 9;
}
.left-timeline .events .event-list::after {
  content: "";
  position: absolute;
  left: -38px;
  top: 14px;
  height: 3px;
  width: 30px;
  background-color: #3b414e;
}
.left-timeline .album img {
  height: 36px;
  width: auto;
  border-radius: 4px;
}

.timeline {
  margin-bottom: 50px;
  position: relative;
}
.timeline:before {
  background-color: #3b414e;
  bottom: 0;
  content: "";
  left: 50%;
  position: absolute;
  top: 30px;
  width: 2px;
  z-index: 0;
}
.timeline .time-show {
  margin-bottom: 30px;
  margin-top: 30px;
  position: relative;
}
.timeline .timeline-box {
  display: block;
  position: relative;
  padding: 20px;
}
.timeline .timeline-album {
  margin-top: 12px;
}
.timeline .timeline-album a {
  display: inline-block;
  margin-right: 5px;
}
.timeline .timeline-album img {
  height: 36px;
  width: auto;
  border-radius: 3px;
}

@media (min-width: 768px) {
  .timeline .time-show {
    right: 69px;
    text-align: right;
  }
  .timeline .timeline-box {
    margin-left: 15px;
  }
  .timeline .timeline-icon {
    background: #5369f8;
    border-radius: 50%;
    display: block;
    height: 20px;
    left: -24px;
    margin-top: -10px;
    position: absolute;
    text-align: center;
    top: 15%;
    width: 20px;
    border: 5px solid #494E67;
    z-index: 9;
  }
  .timeline .timeline-icon:before {
    content: "";
    position: absolute;
    height: 3px;
    width: 19px;
    background-color: #3b414e;
    left: 15px;
    top: 3px;
  }
  .timeline .timeline-desk {
    display: table-cell;
    vertical-align: top;
    width: 50%;
  }
  .timeline-item {
    display: flex;
  }
  .timeline-item:before {
    content: "";
    display: block;
    width: 50%;
  }
  .timeline-item.timeline-item-left:after {
    content: "";
    display: block;
    width: 50%;
  }
  .timeline-item.timeline-item-left .timeline-desk .album {
    float: right;
    margin-top: 20px;
  }
  .timeline-item.timeline-item-left .timeline-desk .album a {
    float: right;
    margin-left: 5px;
  }
  .timeline-item.timeline-item-left .timeline-icon {
    left: auto;
    right: -26px;
  }
  .timeline-item.timeline-item-left .timeline-icon:before {
    left: auto;
    right: 15px;
  }
  .timeline-item.timeline-item-left:before {
    display: none;
  }
  .timeline-item.timeline-item-left .timeline-box {
    margin-right: 15px;
    margin-left: 0;
    text-align: right;
  }
}
@media (max-width: 767.98px) {
  .timeline .time-show {
    text-align: center;
    position: relative;
  }
  .timeline .event-date {
    float: left !important;
    margin-right: 1.5rem;
    margin-left: 0 !important;
  }
  .timeline .timeline-icon {
    display: none;
  }
}
/* 22. Extra Pages */
.card-pricing .card-pricing-features li {
  padding: 10px;
}
.card-pricing .card-pricing-features li:before {
  color: #5369f8;
}

/* 23. Authentication */
body.authentication-bg {
  background-size: cover;
  background-repeat: no-repeat;
  padding-bottom: 0;
}

.authentication-form .form-group .input-group-text {
  background-color: transparent;
}
.authentication-form .form-group .input-group-text svg {
  height: 22px;
  width: 22px;
}

.icon-fb {
  color: #3c5a98;
}

.icon-google {
  color: #e94134;
}

.auth-page-sidebar {
  padding: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
  background-repeat: no-repeat;
  background-size: cover;
  height: 100%;
  position: relative;
}
.auth-page-sidebar .overlay {
  flex: 1;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.4);
}
.auth-page-sidebar .auth-user-testimonial {
  text-align: center;
  color: #fff;
  position: absolute;
  margin: 0 auto;
  padding: 0 1.75rem;
  bottom: 3rem;
  left: 0;
  right: 0;
}

.ruleGroup {
  padding: 0.5rem;
  border: 1px solid #7f81a2;
  border-radius: 4px;
  background: rgba(0, 75, 183, 0.2);
}
.ruleGroup .rule,
.ruleGroup .ruleGroup {
  margin-top: 0.5rem;
  margin-left: 0.5rem;
}
.ruleGroup .ruleGroup-combinators.betweenRules {
  margin-top: 0.5rem;
}
.ruleGroup .ruleGroup-notToggle {
  margin-right: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/scss/theme-dark.scss","webpack://./node_modules/bootstrap/scss/bootstrap.scss","webpack://./node_modules/bootstrap/scss/_root.scss","webpack://./node_modules/bootstrap/scss/_reboot.scss","webpack://./src/scss/_variables-dark.scss","webpack://./node_modules/bootstrap/scss/vendor/_rfs.scss","webpack://./node_modules/bootstrap/scss/mixins/_hover.scss","webpack://./node_modules/bootstrap/scss/_type.scss","webpack://./node_modules/bootstrap/scss/mixins/_lists.scss","webpack://./node_modules/bootstrap/scss/_images.scss","webpack://./node_modules/bootstrap/scss/mixins/_image.scss","webpack://./node_modules/bootstrap/scss/mixins/_border-radius.scss","webpack://./node_modules/bootstrap/scss/_code.scss","webpack://./node_modules/bootstrap/scss/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_breakpoints.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid-framework.scss","webpack://./node_modules/bootstrap/scss/_tables.scss","webpack://./node_modules/bootstrap/scss/mixins/_table-row.scss","webpack://./node_modules/bootstrap/scss/_forms.scss","webpack://./node_modules/bootstrap/scss/mixins/_transition.scss","webpack://./node_modules/bootstrap/scss/mixins/_forms.scss","webpack://./node_modules/bootstrap/scss/mixins/_gradients.scss","webpack://./node_modules/bootstrap/scss/_buttons.scss","webpack://./node_modules/bootstrap/scss/mixins/_buttons.scss","webpack://./node_modules/bootstrap/scss/_variables.scss","webpack://./node_modules/bootstrap/scss/_transitions.scss","webpack://./node_modules/bootstrap/scss/_dropdown.scss","webpack://./node_modules/bootstrap/scss/mixins/_nav-divider.scss","webpack://./node_modules/bootstrap/scss/_button-group.scss","webpack://./node_modules/bootstrap/scss/_input-group.scss","webpack://./node_modules/bootstrap/scss/_custom-forms.scss","webpack://./node_modules/bootstrap/scss/_nav.scss","webpack://./node_modules/bootstrap/scss/_navbar.scss","webpack://./node_modules/bootstrap/scss/_card.scss","webpack://./node_modules/bootstrap/scss/_breadcrumb.scss","webpack://./node_modules/bootstrap/scss/_pagination.scss","webpack://./node_modules/bootstrap/scss/mixins/_pagination.scss","webpack://./node_modules/bootstrap/scss/_badge.scss","webpack://./node_modules/bootstrap/scss/mixins/_badge.scss","webpack://./node_modules/bootstrap/scss/_jumbotron.scss","webpack://./node_modules/bootstrap/scss/_alert.scss","webpack://./node_modules/bootstrap/scss/mixins/_alert.scss","webpack://./node_modules/bootstrap/scss/_progress.scss","webpack://./node_modules/bootstrap/scss/_media.scss","webpack://./node_modules/bootstrap/scss/_list-group.scss","webpack://./node_modules/bootstrap/scss/mixins/_list-group.scss","webpack://./node_modules/bootstrap/scss/_close.scss","webpack://./node_modules/bootstrap/scss/_toasts.scss","webpack://./node_modules/bootstrap/scss/_modal.scss","webpack://./node_modules/bootstrap/scss/_tooltip.scss","webpack://./node_modules/bootstrap/scss/mixins/_reset-text.scss","webpack://./node_modules/bootstrap/scss/_popover.scss","webpack://./node_modules/bootstrap/scss/_carousel.scss","webpack://./node_modules/bootstrap/scss/mixins/_clearfix.scss","webpack://./node_modules/bootstrap/scss/_spinners.scss","webpack://./node_modules/bootstrap/scss/utilities/_align.scss","webpack://./node_modules/bootstrap/scss/mixins/_background-variant.scss","webpack://./node_modules/bootstrap/scss/utilities/_background.scss","webpack://./node_modules/bootstrap/scss/utilities/_borders.scss","webpack://./node_modules/bootstrap/scss/utilities/_display.scss","webpack://./node_modules/bootstrap/scss/utilities/_embed.scss","webpack://./node_modules/bootstrap/scss/utilities/_flex.scss","webpack://./node_modules/bootstrap/scss/utilities/_float.scss","webpack://./node_modules/bootstrap/scss/utilities/_interactions.scss","webpack://./node_modules/bootstrap/scss/utilities/_overflow.scss","webpack://./node_modules/bootstrap/scss/utilities/_position.scss","webpack://./node_modules/bootstrap/scss/utilities/_screenreaders.scss","webpack://./node_modules/bootstrap/scss/mixins/_screen-reader.scss","webpack://./node_modules/bootstrap/scss/utilities/_shadows.scss","webpack://./node_modules/bootstrap/scss/utilities/_sizing.scss","webpack://./node_modules/bootstrap/scss/utilities/_spacing.scss","webpack://./node_modules/bootstrap/scss/utilities/_stretched-link.scss","webpack://./node_modules/bootstrap/scss/utilities/_text.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-truncate.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-emphasis.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-hide.scss","webpack://./node_modules/bootstrap/scss/utilities/_visibility.scss","webpack://./node_modules/bootstrap/scss/_print.scss","webpack://./src/scss/custom/components/_accordions.scss","webpack://./src/scss/custom/components/_badge.scss","webpack://./src/scss/custom/components/_backgrounds.scss","webpack://./src/scss/custom/components/_breadcrumb.scss","webpack://./src/scss/custom/components/_buttons.scss","webpack://./src/scss/custom/components/_card.scss","webpack://./src/scss/custom/components/_dropdown.scss","webpack://./src/scss/custom/components/_forms.scss","webpack://./src/scss/custom/components/_modal.scss","webpack://./src/scss/custom/components/_nav.scss","webpack://./src/scss/custom/components/_pagination.scss","webpack://./src/scss/custom/components/_popover.scss","webpack://./src/scss/custom/components/_progress.scss","webpack://./src/scss/custom/components/_reboot.scss","webpack://./src/scss/custom/components/_tables.scss","webpack://./src/scss/custom/components/_type.scss","webpack://./src/scss/custom/plugins/icons/_unicons.scss","webpack://./src/scss/icons.scss","webpack://./src/scss/app-dark.scss","webpack://./src/scss/custom/structure/_general.scss","webpack://./src/scss/custom/structure/_left-menu.scss","webpack://./src/scss/custom/structure/_topbar.scss","webpack://./src/scss/custom/structure/_page-head.scss","webpack://./src/scss/custom/structure/_footer.scss","webpack://./src/scss/custom/structure/_horizontal-nav.scss","webpack://./src/scss/custom/structure/_right-sidebar.scss","webpack://./src/scss/custom/structure/_layouts.scss","webpack://./src/scss/custom/components/_helper.scss","webpack://./src/scss/custom/components/_social.scss","webpack://./src/scss/custom/components/_widgets.scss","webpack://./src/scss/custom/components/_custom-checkbox.scss","webpack://./src/scss/custom/components/_custom-radio.scss","webpack://./src/scss/custom/components/_print.scss","webpack://./src/scss/custom/components/_preloader.scss","webpack://./src/scss/custom/plugins/_slimscroll.scss","webpack://./src/scss/custom/plugins/_apexcharts.scss","webpack://./src/scss/custom/plugins/_calendar.scss","webpack://./src/scss/custom/plugins/_react-select.scss","webpack://./src/scss/custom/plugins/_multiple-select.scss","webpack://./src/scss/custom/plugins/_flatpickr.scss","webpack://./src/scss/custom/plugins/_bootstrap-touchspin.scss","webpack://./src/scss/custom/plugins/_parsley.scss","webpack://./src/scss/custom/plugins/_form-wizard.scss","webpack://./src/scss/custom/plugins/_editor.scss","webpack://./src/scss/custom/plugins/_dropzone.scss","webpack://./src/scss/custom/plugins/_datatable.scss","webpack://./src/scss/custom/plugins/_table-list-js.scss","webpack://./src/scss/custom/plugins/_kanban.scss","webpack://./node_modules/metismenujs/scss/metismenujs.scss","webpack://./src/scss/custom/plugins/_metismenu.scss","webpack://./src/scss/source-tabs.scss","webpack://./src/scss/cron-builder.scss","webpack://./node_modules/react-querybuilder/dist/query-builder.scss","webpack://./src/scss/main.scss","webpack://./src/scss/custom/pages/_components-demo.scss","webpack://./src/scss/custom/pages/_tasks.scss","webpack://./src/scss/custom/pages/_email.scss","webpack://./src/scss/custom/pages/_timeline.scss","webpack://./src/scss/custom/pages/_extra-pages.scss","webpack://./src/scss/custom/pages/_authentication.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;;;;;EAAA;ACAA;EAGI,eAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA,eAAA;EAAA,cAAA;EAAA,iBAAA;EAAA,iBAAA;EAAA,gBAAA;EAAA,eAAA;EAAA,eAAA;EAAA,aAAA;EAAA,eAAA;EAAA,oBAAA;EAIA,kBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,eAAA;EAAA,kBAAA;EAAA,iBAAA;EAAA,gBAAA;EAAA,eAAA;EAIA,kBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,sBAAA;EAAA,uBAAA;EAKF,mDAAA;EACA,6GAAA;AFkCF;;AGjCA;;;EAGE,sBAAA;AHoCF;;AGjCA;EACE,uBAAA;EACA,iBAAA;EACA,8BAAA;EACA,6CAAA;AHoCF;;AG9BA;EACE,cAAA;AHiCF;;AGvBA;EACE,SAAA;EACA,sCCsS4B;ECjKxB,iBAAA;EFnIJ,gBCiT4B;EDhT5B,gBCqT4B;EDpT5B,cCgCS;ED/BT,gBAAA;EACA,yBCmL0B;AJzJ5B;;AGdA;EACE,qBAAA;AHiBF;;AGRA;EACE,uBAAA;EACA,SAAA;EACA,iBAAA;AHWF;;AGEA;EACE,aAAA;EACA,qBCmR4B;AJlR9B;;AGMA;EACE,aAAA;EACA,mBCqJ0B;AJxJ5B;;AGcA;;EAEE,0BAAA;EACA,iCAAA;EACA,YAAA;EACA,gBAAA;EACA,8BAAA;AHXF;;AGcA;EACE,mBAAA;EACA,kBAAA;EACA,oBAAA;AHXF;;AGcA;;;EAGE,aAAA;EACA,mBAAA;AHXF;;AGcA;;;;EAIE,gBAAA;AHXF;;AGcA;EACE,gBCoN4B;AJ/N9B;;AGcA;EACE,qBAAA;EACA,cAAA;AHXF;;AGcA;EACE,gBAAA;AHXF;;AGcA;;EAEE,mBCuM4B;AJlN9B;;AGcA;EEII,cAAA;ALdJ;;AGmBA;;EAEE,kBAAA;EEPE,cAAA;EFSF,cAAA;EACA,wBAAA;AHhBF;;AGmBA;EAAM,eAAA;AHfN;;AGgBA;EAAM,WAAA;AHZN;;AGmBA;EACE,cCsDwC;EDrDxC,qBCsDwC;EDrDxC,6BAAA;AHhBF;AMhKE;EHmLE,uDCmDsC;EDlDtC,0BCmDsC;AJnE1C;;AGyBA;EACE,cAAA;EACA,qBAAA;AHtBF;AMzKE;EHkME,cAAA;EACA,qBAAA;AHtBJ;;AG+BA;;;;EAIE,iGC0H4B;EClL1B,cAAA;AL6BJ;;AG+BA;EAEE,aAAA;EAEA,mBAAA;EAEA,cAAA;EAGA,6BAAA;AHjCF;;AGyCA;EAEE,gBAAA;AHvCF;;AG+CA;EACE,sBAAA;EACA,kBAAA;AH5CF;;AG+CA;EAGE,gBAAA;EACA,sBAAA;AH9CF;;AGsDA;EACE,yBAAA;AHnDF;;AGsDA;EACE,oBCgJ4B;ED/I5B,uBC+I4B;ED9I5B,cClMS;EDmMT,gBAAA;EACA,oBAAA;AHnDF;;AG0DA;EAEE,mBAAA;EACA,gCAAA;AHxDF;;AGgEA;EAEE,qBAAA;EACA,qBC6NsC;AJ3RxC;;AGoEA;EAEE,gBAAA;AHlEF;;AG0EA;EACE,UAAA;AHvEF;;AG0EA;;;;;EAKE,SAAA;EACA,oBAAA;EEhKE,kBAAA;EFkKF,oBAAA;AHvEF;;AG0EA;;EAEE,iBAAA;AHvEF;;AG0EA;;EAEE,oBAAA;AHvEF;;AG6EA;EACE,eAAA;AH1EF;;AGgFA;EACE,iBAAA;AH7EF;;AGoFA;;;;EAIE,0BAAA;AHjFF;;AG0FI;;;;EACE,eAAA;AHpFN;;AG0FA;;;;EAIE,UAAA;EACA,kBAAA;AHvFF;;AG0FA;;EAEE,sBAAA;EACA,UAAA;AHvFF;;AG2FA;EACE,cAAA;EAEA,gBAAA;AHzFF;;AG4FA;EAME,YAAA;EAEA,UAAA;EACA,SAAA;EACA,SAAA;AH/FF;;AGoGA;EACE,cAAA;EACA,WAAA;EACA,eAAA;EACA,UAAA;EACA,qBAAA;EE9OI,iBAAA;EFgPJ,oBAAA;EACA,cAAA;EACA,mBAAA;AHjGF;;AGoGA;EACE,wBAAA;AHjGF;;AGqGA;;EAEE,YAAA;AHlGF;;AGqGA;EAKE,oBAAA;EACA,wBAAA;AHtGF;;AG6GA;EACE,wBAAA;AH1GF;;AGkHA;EACE,aAAA;EACA,0BAAA;AH/GF;;AGsHA;EACE,qBAAA;AHnHF;;AGsHA;EACE,kBAAA;EACA,eAAA;AHnHF;;AGsHA;EACE,aAAA;AHnHF;;AGwHA;EACE,wBAAA;AHrHF;;AOvWA;;EAEE,qBHwW4B;EGtW5B,gBHwW4B;EGvW5B,gBHwW4B;AJC9B;;AOrWA;EFqKM,kBAAA;ALoMN;;AOxWA;EFoKM,iBAAA;ALwMN;;AO3WA;EFmKM,mBAAA;AL4MN;;AO9WA;EFkKM,kBAAA;ALgNN;;AOjXA;EFiKM,mBAAA;ALoNN;;AOpXA;EFgKM,iBAAA;ALwNN;;AOtXA;EF8JM,mBAAA;EE5JJ,gBH0W4B;AJe9B;;AOrXA;EFwJM,eAAA;EEtJJ,gBH6V4B;EG5V5B,gBHoV4B;AJoC9B;;AOtXA;EFmJM,iBAAA;EEjJJ,gBHyV4B;EGxV5B,gBH+U4B;AJ0C9B;;AOvXA;EF8IM,iBAAA;EE5IJ,gBHqV4B;EGpV5B,gBH0U4B;AJgD9B;;AOxXA;EFyIM,iBAAA;EEvIJ,gBHiV4B;EGhV5B,gBHqU4B;AJsD9B;;AOnXA;EACE,gBH+IO;EG9IP,mBH8IO;EG7IP,SAAA;EACA,6BAAA;APsXF;;AO9WA;;EFkGI,cAAA;EE/FF,gBH6R4B;AJoF9B;;AO9WA;;EAEE,cHqU4B;EGpU5B,yBH6U4B;AJoC9B;;AOzWA;EC/EE,eAAA;EACA,gBAAA;AR4bF;;AOzWA;ECpFE,eAAA;EACA,gBAAA;ARicF;;AO3WA;EACE,qBAAA;AP8WF;AO5WE;EACE,oBHuT0B;AJuD9B;;AOpWA;EF2DI,cAAA;EEzDF,yBAAA;APuWF;;AOnWA;EACE,mBHsFO;EClBH,mBAAA;ALmSN;;AOnWA;EACE,cAAA;EF+CE,cAAA;EE7CF,cHrCS;AJ2YX;AOpWE;EACE,aAAA;APsWJ;;ASzdA;ECIE,eAAA;EAGA,YAAA;AVudF;;ASxdA;EACE,gBLsjCkC;EKrjClC,yBLgES;EK/DT,yBAAA;EEEE,qBAAA;EDPF,eAAA;EAGA,YAAA;AVgeF;;ASldA;EAEE,qBAAA;ATodF;;ASjdA;EACE,qBAAA;EACA,cAAA;ATodF;;ASjdA;EJ8HI,cAAA;EI5HF,cL0CS;AJ0aX;;AY3fA;EPmKI,gBAAA;EOjKF,cRyGQ;EQxGR,qBAAA;AZ8fF;AY3fE;EACE,cAAA;AZ6fJ;;AYxfA;EACE,sBAAA;EPsJE,gBAAA;EOpJF,WR4DS;EQ3DT,yBRoES;EOnEP,qBAAA;AX2fJ;AYxfE;EACE,UAAA;EP8IA,eAAA;EO5IA,gBR2U0B;AJ+K9B;;AYpfA;EACE,cAAA;EPqIE,gBAAA;EOnIF,cRoDS;AJmcX;AYpfE;EPgIE,kBAAA;EO9HA,cAAA;EACA,kBAAA;AZsfJ;;AYjfA;EACE,iBR+mCkC;EQ9mClC,kBAAA;AZofF;;Aa5hBE;;;;;;ECDA,WAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AdsiBF;;AenfI;EFzCE;IACE,gBT+Pe;EJiSrB;AACF;AezfI;EFzCE;IACE,gBT+Pe;EJsSrB;AACF;Ae9fI;EFzCE;IACE,gBT+Pe;EJ2SrB;AACF;AengBI;EFzCE;IACE,iBT+Pe;EJgTrB;AACF;AaphBE;ECnCA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;Ad0jBF;;AaphBE;EACE,eAAA;EACA,cAAA;AbuhBJ;AarhBI;;EAEE,gBAAA;EACA,eAAA;AbuhBN;;AgB7kBE;;;;;;EACE,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AhBqlBJ;;AgB/jBM;EACE,aAAA;EACA,YAAA;EACA,eAAA;AhBkkBR;;ActiBE;EACE,cAAA;EACA,eAAA;AdyiBJ;;Ac3iBE;EACE,aAAA;EACA,cAAA;Ad8iBJ;;AchjBE;EACE,wBAAA;EACA,yBAAA;AdmjBJ;;AcrjBE;EACE,aAAA;EACA,cAAA;AdwjBJ;;Ac1jBE;EACE,aAAA;EACA,cAAA;Ad6jBJ;;Ac/jBE;EACE,wBAAA;EACA,yBAAA;AdkkBJ;;AgBrlBM;EFCJ,cAAA;EACA,WAAA;EACA,eAAA;AdwlBF;;AgBrlBU;EFbR,qBAAA;EAIA,sBAAA;AdmmBF;;AgB1lBU;EFbR,sBAAA;EAIA,uBAAA;AdwmBF;;AgB/lBU;EFbR,aAAA;EAIA,cAAA;Ad6mBF;;AgBpmBU;EFbR,sBAAA;EAIA,uBAAA;AdknBF;;AgBzmBU;EFbR,sBAAA;EAIA,uBAAA;AdunBF;;AgB9mBU;EFbR,aAAA;EAIA,cAAA;Ad4nBF;;AgBnnBU;EFbR,sBAAA;EAIA,uBAAA;AdioBF;;AgBxnBU;EFbR,sBAAA;EAIA,uBAAA;AdsoBF;;AgB7nBU;EFbR,aAAA;EAIA,cAAA;Ad2oBF;;AgBloBU;EFbR,sBAAA;EAIA,uBAAA;AdgpBF;;AgBvoBU;EFbR,sBAAA;EAIA,uBAAA;AdqpBF;;AgB5oBU;EFbR,cAAA;EAIA,eAAA;Ad0pBF;;AgB3oBM;EAAwB,SAAA;AhB+oB9B;;AgB7oBM;EAAuB,SAAA;AhBipB7B;;AgB9oBQ;EAAwB,QADb;AhBmpBnB;;AgBlpBQ;EAAwB,QADb;AhBupBnB;;AgBtpBQ;EAAwB,QADb;AhB2pBnB;;AgB1pBQ;EAAwB,QADb;AhB+pBnB;;AgB9pBQ;EAAwB,QADb;AhBmqBnB;;AgBlqBQ;EAAwB,QADb;AhBuqBnB;;AgBtqBQ;EAAwB,QADb;AhB2qBnB;;AgB1qBQ;EAAwB,QADb;AhB+qBnB;;AgB9qBQ;EAAwB,QADb;AhBmrBnB;;AgBlrBQ;EAAwB,QADb;AhBurBnB;;AgBtrBQ;EAAwB,SADb;AhB2rBnB;;AgB1rBQ;EAAwB,SADb;AhB+rBnB;;AgB9rBQ;EAAwB,SADb;AhBmsBnB;;AgB3rBY;EFhBV,wBAAA;Ad+sBF;;AgB/rBY;EFhBV,yBAAA;AdmtBF;;AgBnsBY;EFhBV,gBAAA;AdutBF;;AgBvsBY;EFhBV,yBAAA;Ad2tBF;;AgB3sBY;EFhBV,yBAAA;Ad+tBF;;AgB/sBY;EFhBV,gBAAA;AdmuBF;;AgBntBY;EFhBV,yBAAA;AduuBF;;AgBvtBY;EFhBV,yBAAA;Ad2uBF;;AgB3tBY;EFhBV,gBAAA;Ad+uBF;;AgB/tBY;EFhBV,yBAAA;AdmvBF;;AgBnuBY;EFhBV,yBAAA;AduvBF;;AelvBI;EC3BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;EhBixBN;EcrvBA;IACE,cAAA;IACA,eAAA;EduvBF;EczvBA;IACE,aAAA;IACA,cAAA;Ed2vBF;Ec7vBA;IACE,wBAAA;IACA,yBAAA;Ed+vBF;EcjwBA;IACE,aAAA;IACA,cAAA;EdmwBF;EcrwBA;IACE,aAAA;IACA,cAAA;EduwBF;EczwBA;IACE,wBAAA;IACA,yBAAA;Ed2wBF;EgB9xBI;IFCJ,cAAA;IACA,WAAA;IACA,eAAA;EdgyBA;EgB7xBQ;IFbR,qBAAA;IAIA,sBAAA;Ed0yBA;EgBjyBQ;IFbR,sBAAA;IAIA,uBAAA;Ed8yBA;EgBryBQ;IFbR,aAAA;IAIA,cAAA;EdkzBA;EgBzyBQ;IFbR,sBAAA;IAIA,uBAAA;EdszBA;EgB7yBQ;IFbR,sBAAA;IAIA,uBAAA;Ed0zBA;EgBjzBQ;IFbR,aAAA;IAIA,cAAA;Ed8zBA;EgBrzBQ;IFbR,sBAAA;IAIA,uBAAA;Edk0BA;EgBzzBQ;IFbR,sBAAA;IAIA,uBAAA;Eds0BA;EgB7zBQ;IFbR,aAAA;IAIA,cAAA;Ed00BA;EgBj0BQ;IFbR,sBAAA;IAIA,uBAAA;Ed80BA;EgBr0BQ;IFbR,sBAAA;IAIA,uBAAA;Edk1BA;EgBz0BQ;IFbR,cAAA;IAIA,eAAA;Eds1BA;EgBv0BI;IAAwB,SAAA;EhB00B5B;EgBx0BI;IAAuB,SAAA;EhB20B3B;EgBx0BM;IAAwB,QADb;EhB40BjB;EgB30BM;IAAwB,QADb;EhB+0BjB;EgB90BM;IAAwB,QADb;EhBk1BjB;EgBj1BM;IAAwB,QADb;EhBq1BjB;EgBp1BM;IAAwB,QADb;EhBw1BjB;EgBv1BM;IAAwB,QADb;EhB21BjB;EgB11BM;IAAwB,QADb;EhB81BjB;EgB71BM;IAAwB,QADb;EhBi2BjB;EgBh2BM;IAAwB,QADb;EhBo2BjB;EgBn2BM;IAAwB,QADb;EhBu2BjB;EgBt2BM;IAAwB,SADb;EhB02BjB;EgBz2BM;IAAwB,SADb;EhB62BjB;EgB52BM;IAAwB,SADb;EhBg3BjB;EgBx2BU;IFhBV,cAAA;Ed23BA;EgB32BU;IFhBV,wBAAA;Ed83BA;EgB92BU;IFhBV,yBAAA;Edi4BA;EgBj3BU;IFhBV,gBAAA;Edo4BA;EgBp3BU;IFhBV,yBAAA;Edu4BA;EgBv3BU;IFhBV,yBAAA;Ed04BA;EgB13BU;IFhBV,gBAAA;Ed64BA;EgB73BU;IFhBV,yBAAA;Edg5BA;EgBh4BU;IFhBV,yBAAA;Edm5BA;EgBn4BU;IFhBV,gBAAA;Eds5BA;EgBt4BU;IFhBV,yBAAA;Edy5BA;EgBz4BU;IFhBV,yBAAA;Ed45BA;AACF;Aex5BI;EC3BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;EhBs7BN;Ec15BA;IACE,cAAA;IACA,eAAA;Ed45BF;Ec95BA;IACE,aAAA;IACA,cAAA;Edg6BF;Ecl6BA;IACE,wBAAA;IACA,yBAAA;Edo6BF;Ect6BA;IACE,aAAA;IACA,cAAA;Edw6BF;Ec16BA;IACE,aAAA;IACA,cAAA;Ed46BF;Ec96BA;IACE,wBAAA;IACA,yBAAA;Edg7BF;EgBn8BI;IFCJ,cAAA;IACA,WAAA;IACA,eAAA;Edq8BA;EgBl8BQ;IFbR,qBAAA;IAIA,sBAAA;Ed+8BA;EgBt8BQ;IFbR,sBAAA;IAIA,uBAAA;Edm9BA;EgB18BQ;IFbR,aAAA;IAIA,cAAA;Edu9BA;EgB98BQ;IFbR,sBAAA;IAIA,uBAAA;Ed29BA;EgBl9BQ;IFbR,sBAAA;IAIA,uBAAA;Ed+9BA;EgBt9BQ;IFbR,aAAA;IAIA,cAAA;Edm+BA;EgB19BQ;IFbR,sBAAA;IAIA,uBAAA;Edu+BA;EgB99BQ;IFbR,sBAAA;IAIA,uBAAA;Ed2+BA;EgBl+BQ;IFbR,aAAA;IAIA,cAAA;Ed++BA;EgBt+BQ;IFbR,sBAAA;IAIA,uBAAA;Edm/BA;EgB1+BQ;IFbR,sBAAA;IAIA,uBAAA;Edu/BA;EgB9+BQ;IFbR,cAAA;IAIA,eAAA;Ed2/BA;EgB5+BI;IAAwB,SAAA;EhB++B5B;EgB7+BI;IAAuB,SAAA;EhBg/B3B;EgB7+BM;IAAwB,QADb;EhBi/BjB;EgBh/BM;IAAwB,QADb;EhBo/BjB;EgBn/BM;IAAwB,QADb;EhBu/BjB;EgBt/BM;IAAwB,QADb;EhB0/BjB;EgBz/BM;IAAwB,QADb;EhB6/BjB;EgB5/BM;IAAwB,QADb;EhBggCjB;EgB//BM;IAAwB,QADb;EhBmgCjB;EgBlgCM;IAAwB,QADb;EhBsgCjB;EgBrgCM;IAAwB,QADb;EhBygCjB;EgBxgCM;IAAwB,QADb;EhB4gCjB;EgB3gCM;IAAwB,SADb;EhB+gCjB;EgB9gCM;IAAwB,SADb;EhBkhCjB;EgBjhCM;IAAwB,SADb;EhBqhCjB;EgB7gCU;IFhBV,cAAA;EdgiCA;EgBhhCU;IFhBV,wBAAA;EdmiCA;EgBnhCU;IFhBV,yBAAA;EdsiCA;EgBthCU;IFhBV,gBAAA;EdyiCA;EgBzhCU;IFhBV,yBAAA;Ed4iCA;EgB5hCU;IFhBV,yBAAA;Ed+iCA;EgB/hCU;IFhBV,gBAAA;EdkjCA;EgBliCU;IFhBV,yBAAA;EdqjCA;EgBriCU;IFhBV,yBAAA;EdwjCA;EgBxiCU;IFhBV,gBAAA;Ed2jCA;EgB3iCU;IFhBV,yBAAA;Ed8jCA;EgB9iCU;IFhBV,yBAAA;EdikCA;AACF;Ae7jCI;EC3BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;EhB2lCN;Ec/jCA;IACE,cAAA;IACA,eAAA;EdikCF;EcnkCA;IACE,aAAA;IACA,cAAA;EdqkCF;EcvkCA;IACE,wBAAA;IACA,yBAAA;EdykCF;Ec3kCA;IACE,aAAA;IACA,cAAA;Ed6kCF;Ec/kCA;IACE,aAAA;IACA,cAAA;EdilCF;EcnlCA;IACE,wBAAA;IACA,yBAAA;EdqlCF;EgBxmCI;IFCJ,cAAA;IACA,WAAA;IACA,eAAA;Ed0mCA;EgBvmCQ;IFbR,qBAAA;IAIA,sBAAA;EdonCA;EgB3mCQ;IFbR,sBAAA;IAIA,uBAAA;EdwnCA;EgB/mCQ;IFbR,aAAA;IAIA,cAAA;Ed4nCA;EgBnnCQ;IFbR,sBAAA;IAIA,uBAAA;EdgoCA;EgBvnCQ;IFbR,sBAAA;IAIA,uBAAA;EdooCA;EgB3nCQ;IFbR,aAAA;IAIA,cAAA;EdwoCA;EgB/nCQ;IFbR,sBAAA;IAIA,uBAAA;Ed4oCA;EgBnoCQ;IFbR,sBAAA;IAIA,uBAAA;EdgpCA;EgBvoCQ;IFbR,aAAA;IAIA,cAAA;EdopCA;EgB3oCQ;IFbR,sBAAA;IAIA,uBAAA;EdwpCA;EgB/oCQ;IFbR,sBAAA;IAIA,uBAAA;Ed4pCA;EgBnpCQ;IFbR,cAAA;IAIA,eAAA;EdgqCA;EgBjpCI;IAAwB,SAAA;EhBopC5B;EgBlpCI;IAAuB,SAAA;EhBqpC3B;EgBlpCM;IAAwB,QADb;EhBspCjB;EgBrpCM;IAAwB,QADb;EhBypCjB;EgBxpCM;IAAwB,QADb;EhB4pCjB;EgB3pCM;IAAwB,QADb;EhB+pCjB;EgB9pCM;IAAwB,QADb;EhBkqCjB;EgBjqCM;IAAwB,QADb;EhBqqCjB;EgBpqCM;IAAwB,QADb;EhBwqCjB;EgBvqCM;IAAwB,QADb;EhB2qCjB;EgB1qCM;IAAwB,QADb;EhB8qCjB;EgB7qCM;IAAwB,QADb;EhBirCjB;EgBhrCM;IAAwB,SADb;EhBorCjB;EgBnrCM;IAAwB,SADb;EhBurCjB;EgBtrCM;IAAwB,SADb;EhB0rCjB;EgBlrCU;IFhBV,cAAA;EdqsCA;EgBrrCU;IFhBV,wBAAA;EdwsCA;EgBxrCU;IFhBV,yBAAA;Ed2sCA;EgB3rCU;IFhBV,gBAAA;Ed8sCA;EgB9rCU;IFhBV,yBAAA;EditCA;EgBjsCU;IFhBV,yBAAA;EdotCA;EgBpsCU;IFhBV,gBAAA;EdutCA;EgBvsCU;IFhBV,yBAAA;Ed0tCA;EgB1sCU;IFhBV,yBAAA;Ed6tCA;EgB7sCU;IFhBV,gBAAA;EdguCA;EgBhtCU;IFhBV,yBAAA;EdmuCA;EgBntCU;IFhBV,yBAAA;EdsuCA;AACF;AeluCI;EC3BE;IACE,aAAA;IACA,YAAA;IACA,eAAA;EhBgwCN;EcpuCA;IACE,cAAA;IACA,eAAA;EdsuCF;EcxuCA;IACE,aAAA;IACA,cAAA;Ed0uCF;Ec5uCA;IACE,wBAAA;IACA,yBAAA;Ed8uCF;EchvCA;IACE,aAAA;IACA,cAAA;EdkvCF;EcpvCA;IACE,aAAA;IACA,cAAA;EdsvCF;EcxvCA;IACE,wBAAA;IACA,yBAAA;Ed0vCF;EgB7wCI;IFCJ,cAAA;IACA,WAAA;IACA,eAAA;Ed+wCA;EgB5wCQ;IFbR,qBAAA;IAIA,sBAAA;EdyxCA;EgBhxCQ;IFbR,sBAAA;IAIA,uBAAA;Ed6xCA;EgBpxCQ;IFbR,aAAA;IAIA,cAAA;EdiyCA;EgBxxCQ;IFbR,sBAAA;IAIA,uBAAA;EdqyCA;EgB5xCQ;IFbR,sBAAA;IAIA,uBAAA;EdyyCA;EgBhyCQ;IFbR,aAAA;IAIA,cAAA;Ed6yCA;EgBpyCQ;IFbR,sBAAA;IAIA,uBAAA;EdizCA;EgBxyCQ;IFbR,sBAAA;IAIA,uBAAA;EdqzCA;EgB5yCQ;IFbR,aAAA;IAIA,cAAA;EdyzCA;EgBhzCQ;IFbR,sBAAA;IAIA,uBAAA;Ed6zCA;EgBpzCQ;IFbR,sBAAA;IAIA,uBAAA;Edi0CA;EgBxzCQ;IFbR,cAAA;IAIA,eAAA;Edq0CA;EgBtzCI;IAAwB,SAAA;EhByzC5B;EgBvzCI;IAAuB,SAAA;EhB0zC3B;EgBvzCM;IAAwB,QADb;EhB2zCjB;EgB1zCM;IAAwB,QADb;EhB8zCjB;EgB7zCM;IAAwB,QADb;EhBi0CjB;EgBh0CM;IAAwB,QADb;EhBo0CjB;EgBn0CM;IAAwB,QADb;EhBu0CjB;EgBt0CM;IAAwB,QADb;EhB00CjB;EgBz0CM;IAAwB,QADb;EhB60CjB;EgB50CM;IAAwB,QADb;EhBg1CjB;EgB/0CM;IAAwB,QADb;EhBm1CjB;EgBl1CM;IAAwB,QADb;EhBs1CjB;EgBr1CM;IAAwB,SADb;EhBy1CjB;EgBx1CM;IAAwB,SADb;EhB41CjB;EgB31CM;IAAwB,SADb;EhB+1CjB;EgBv1CU;IFhBV,cAAA;Ed02CA;EgB11CU;IFhBV,wBAAA;Ed62CA;EgB71CU;IFhBV,yBAAA;Edg3CA;EgBh2CU;IFhBV,gBAAA;Edm3CA;EgBn2CU;IFhBV,yBAAA;Eds3CA;EgBt2CU;IFhBV,yBAAA;Edy3CA;EgBz2CU;IFhBV,gBAAA;Ed43CA;EgB52CU;IFhBV,yBAAA;Ed+3CA;EgB/2CU;IFhBV,yBAAA;Edk4CA;EgBl3CU;IFhBV,gBAAA;Edq4CA;EgBr3CU;IFhBV,yBAAA;Edw4CA;EgBx3CU;IFhBV,yBAAA;Ed24CA;AACF;AiB/7CA;EACE,WAAA;EACA,mBbgMO;Ea/LP,cb4ES;AJq3CX;AiB97CE;;EAEE,gBbqZ0B;EapZ1B,mBAAA;EACA,6BAAA;AjBg8CJ;AiB77CE;EACE,sBAAA;EACA,gCAAA;AjB+7CJ;AiB57CE;EACE,6BAAA;AjB87CJ;;AiBp7CE;;EAEE,eb+X0B;AJwjC9B;;AiB96CA;EACE,yBAAA;AjBi7CF;AiB/6CE;;EAEE,yBAAA;AjBi7CJ;AiB76CI;;EAEE,wBAAA;AjB+6CN;;AiBz6CE;;;;EAIE,SAAA;AjB46CJ;;AiBn6CE;EACE,yBbIO;AJk6CX;;AMr+CE;EW2EI,cbJK;EaKL,yBbTK;AJu6CX;;AkBh/CI;;;EAGE,0CD2F+B;AjBw5CrC;AkB/+CM;;;;EAIE,sCDmFyE;AjB85CjF;;AMt/CE;EYiBM,qEAJe;AlB6+CvB;AkBv+CQ;;EAEE,qEARa;AlBi/CvB;;AkBpgDI;;;EAGE,4CD2F+B;AjB46CrC;AkBngDM;;;;EAIE,wCDmFyE;AjBk7CjF;;AM1gDE;EYiBM,qEAJe;AlBigDvB;AkB3/CQ;;EAEE,qEARa;AlBqgDvB;;AkBxhDI;;;EAGE,6CD2F+B;AjBg8CrC;AkBvhDM;;;;EAIE,yCDmFyE;AjBs8CjF;;AM9hDE;EYiBM,oEAJe;AlBqhDvB;AkB/gDQ;;EAEE,oEARa;AlByhDvB;;AkB5iDI;;;EAGE,6CD2F+B;AjBo9CrC;AkB3iDM;;;;EAIE,yCDmFyE;AjB09CjF;;AMljDE;EYiBM,qEAJe;AlByiDvB;AkBniDQ;;EAEE,qEARa;AlB6iDvB;;AkBhkDI;;;EAGE,yCD2F+B;AjBw+CrC;AkB/jDM;;;;EAIE,qCDmFyE;AjB8+CjF;;AMtkDE;EYiBM,kDAJe;AlB6jDvB;AkBvjDQ;;EAEE,kDARa;AlBikDvB;;AkBplDI;;;EAGE,0CD2F+B;AjB4/CrC;AkBnlDM;;;;EAIE,sCDmFyE;AjBkgDjF;;AM1lDE;EYiBM,kDAJe;AlBilDvB;AkB3kDQ;;EAEE,kDARa;AlBqlDvB;;AkBxmDI;;;EAGE,4CD2F+B;AjBghDrC;AkBvmDM;;;;EAIE,wCDmFyE;AjBshDjF;;AM9mDE;EYiBM,mEAJe;AlBqmDvB;AkB/lDQ;;EAEE,mEARa;AlBymDvB;;AkB5nDI;;;EAGE,6CD2F+B;AjBoiDrC;AkB3nDM;;;;EAIE,yCDmFyE;AjB0iDjF;;AMloDE;EYiBM,qEAJe;AlBynDvB;AkBnnDQ;;EAEE,qEARa;AlB6nDvB;;AkBhpDI;;;EAGE,yBdsEK;AJ6kDX;;AMhpDE;EYiBM,iEAJe;AlBuoDvB;AkBjoDQ;;EAEE,iEARa;AlB2oDvB;;AiBnjDI;EACE,WbtCK;EauCL,yBbpCK;EaqCL,6DbkUwB;AJovC9B;AiBjjDI;EACE,cbvCK;EawCL,yBb5CK;Ea6CL,qBb7CK;AJgmDX;;AiB9iDA;EACE,WbtDS;EauDT,yBbpDS;AJqmDX;AiB/iDE;;;EAGE,6Db8S0B;AJmwC9B;AiB9iDE;EACE,SAAA;AjBgjDJ;AiB5iDI;EACE,2CbkSwB;AJ4wC9B;AMnrDE;EW4IM,Wb5EG;Ea6EH,4Cb4RsB;AJ8wC9B;;Ae1nDI;EEiGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;EjB4hDN;EiBzhDM;IACE,SAAA;EjB2hDR;AACF;AetoDI;EEiGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;EjBuiDN;EiBpiDM;IACE,SAAA;EjBsiDR;AACF;AejpDI;EEiGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;EjBkjDN;EiB/iDM;IACE,SAAA;EjBijDR;AACF;Ae5pDI;EEiGA;IAEI,cAAA;IACA,WAAA;IACA,gBAAA;IACA,iCAAA;EjB6jDN;EiB1jDM;IACE,SAAA;EjB4jDR;AACF;AiBtkDI;EAEI,cAAA;EACA,WAAA;EACA,gBAAA;EACA,iCAAA;AjBukDR;AiBpkDQ;EACE,SAAA;AjBskDV;;AmBnvDA;EACE,cAAA;EACA,WAAA;EACA,mCf4iBsC;Ee3iBtC,wBAAA;Ed0KI,iBAAA;EcvKJ,gBfqV4B;EepV5B,gBfyV4B;EexV5B,cfoES;EenET,kEf0gBsC;EezgBtC,4BAAA;EACA,yBAAA;ERAE,qBAAA;ESFE,wEDQJ;AnBivDF;AoBrvDM;EDdN;ICeQ,gBAAA;EpBwvDN;AACF;AmBnvDE;EACE,6BAAA;EACA,SAAA;AnBqvDJ;AqBrwDE;EACE,cjBqEO;EiBpEP,kEjBuhBoC;EiBthBpC,8DjBuhBoC;EiBthBpC,UAAA;EAKE,gBjBohBkC;AJ+uCxC;AmBrvDE;EACE,cf6CO;Ee3CP,UAAA;AnBsvDJ;AmB9uDE;EAEE,kEf0eoC;EexepC,UAAA;AnB8uDJ;;AmBtuDE;;;;EACE,gBAAA;AnB4uDJ;;AmBtuDE;EACE,kBAAA;EACA,0BAAA;AnByuDJ;AmBtuDE;EAME,cfMO;EeLP,kEf4coC;AJuxCxC;;AmB9tDA;;EAEE,cAAA;EACA,WAAA;AnBiuDF;;AmBvtDA;EACE,gCAAA;EACA,mCAAA;EACA,gBAAA;EdiEE,kBAAA;Ec/DF,gBfkQ4B;AJw9C9B;;AmBvtDA;EACE,+BAAA;EACA,kCAAA;Ed0EI,mBAAA;EcxEJ,gBf6L4B;AJ6hD9B;;AmBvtDA;EACE,gCAAA;EACA,mCAAA;EdmEI,oBAAA;EcjEJ,gBfuL4B;AJmiD9B;;AmBjtDA;EACE,cAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EdoDI,iBAAA;EclDJ,gBfqO4B;EepO5B,cfhDS;EeiDT,6BAAA;EACA,yBAAA;EACA,mBAAA;AnBotDF;AmBltDE;EAEE,gBAAA;EACA,eAAA;AnBmtDJ;;AmBvsDA;EACE,kCf8ZsC;Ee7ZtC,uBAAA;Ed2BI,oBAAA;EczBJ,gBf+I4B;EOxR1B,qBAAA;AXo1DJ;;AmBvsDA;EACE,gCfuZsC;EetZtC,oBAAA;EdmBI,mBAAA;EcjBJ,gBfsI4B;EOvR1B,qBAAA;AX41DJ;;AmBrsDE;EAEE,YAAA;AnBusDJ;;AmBnsDA;EACE,YAAA;AnBssDF;;AmB9rDA;EACE,mBf4YsC;AJqzCxC;;AmB9rDA;EACE,cAAA;EACA,mBf6XsC;AJo0CxC;;AmBzrDA;EACE,aAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;AnB4rDF;AmB1rDE;;EAEE,kBAAA;EACA,iBAAA;AnB4rDJ;;AmBnrDA;EACE,kBAAA;EACA,cAAA;EACA,qBfkWsC;AJo1CxC;;AmBnrDA;EACE,kBAAA;EACA,kBf8VsC;Ee7VtC,qBAAA;AnBsrDF;AmBnrDE;EAEE,cfrJO;AJy0DX;;AmBhrDA;EACE,gBAAA;AnBmrDF;;AmBhrDA;EACE,oBAAA;EACA,mBAAA;EACA,eAAA;EACA,qBf+UsC;AJo2CxC;AmBhrDE;EACE,gBAAA;EACA,aAAA;EACA,uBf0UoC;EezUpC,cAAA;AnBkrDJ;;AqB/3DE;EACE,aAAA;EACA,WAAA;EACA,mBjB4gBoC;ECvZpC,cAAA;EgBnHA,cFqNqC;AnB6qDzC;;AqB/3DE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EhBwHE,oBAAA;EgBtHF,gBjByS0B;EiBxS1B,cAAA;EACA,yCAAA;EV9CA,qBAAA;AXi7DJ;AqB93DI;EAEE,SAAA;ArB+3DN;;AqB13DI;;;;EAEE,cAAA;ArB+3DN;;AqB76DI;EAoDE,qBFkLmC;EE/KjC,+CAAA;EACA,yDAAA;EACA,4BAAA;EACA,0DAAA;EACA,8DAAA;ArB23DR;AqBx3DM;EACE,qBFuKiC;EEtKjC,kDAAA;ArB03DR;;AqB17DI;EAyEI,8BAAA;EACA,wCAAA;ArBq3DR;;AqB/7DI;EAmFI,oCjB8bgC;EiB7bhC,gFAAA;ArBg3DR;;AqBp8DI;EA2FE,qBF2ImC;EExIjC,iEAAA;EACA,kQAAA;ArB22DR;AqBx2DM;EACE,qBFmIiC;EElIjC,kDAAA;ArB02DR;;AqBn2DM;EACE,cF0HiC;AnB4uDzC;AqBn2DM;;;EAEE,cAAA;ArBs2DR;;AqB/1DM;EACE,cF6GiC;AnBqvDzC;AqBh2DQ;EACE,qBF0G+B;AnBwvDzC;AqB71DQ;EACE,iEAAA;EC5JN,qED6J2B;ArB+1D/B;AqB11DQ;EACE,kDAAA;ArB41DV;AqBz1DQ;EACE,qBFyF+B;AnBkwDzC;;AqBl1DM;EACE,qBF+EiC;AnBswDzC;AqBj1DQ;EACE,qBF0E+B;EEzE/B,kDAAA;ArBm1DV;;AqBp+DE;EACE,aAAA;EACA,WAAA;EACA,mBjB4gBoC;ECvZpC,cAAA;EgBnHA,cFqNqC;AnBkxDzC;;AqBp+DE;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EhBwHE,oBAAA;EgBtHF,gBjByS0B;EiBxS1B,WAAA;EACA,yCAAA;EV9CA,qBAAA;AXshEJ;AqBn+DI;EAEE,SAAA;ArBo+DN;;AqB/9DI;;;;EAEE,cAAA;ArBo+DN;;AqBlhEI;EAoDE,qBFkLmC;EE/KjC,+CAAA;EACA,yDAAA;EACA,4BAAA;EACA,0DAAA;EACA,8DAAA;ArBg+DR;AqB79DM;EACE,qBFuKiC;EEtKjC,kDAAA;ArB+9DR;;AqB/hEI;EAyEI,8BAAA;EACA,wCAAA;ArB09DR;;AqBpiEI;EAmFI,oCjB8bgC;EiB7bhC,gFAAA;ArBq9DR;;AqBziEI;EA2FE,qBF2ImC;EExIjC,iEAAA;EACA,kQAAA;ArBg9DR;AqB78DM;EACE,qBFmIiC;EElIjC,kDAAA;ArB+8DR;;AqBx8DM;EACE,cF0HiC;AnBi1DzC;AqBx8DM;;;EAEE,cAAA;ArB28DR;;AqBp8DM;EACE,cF6GiC;AnB01DzC;AqBr8DQ;EACE,qBF0G+B;AnB61DzC;AqBl8DQ;EACE,2CAAA;EC5JN,+CD6J2B;ArBo8D/B;AqB/7DQ;EACE,kDAAA;ArBi8DV;AqB97DQ;EACE,qBFyF+B;AnBu2DzC;;AqBv7DM;EACE,qBF+EiC;AnB22DzC;AqBt7DQ;EACE,qBF0E+B;EEzE/B,kDAAA;ArBw7DV;;AmBn2DA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AnBs2DF;AmBj2DE;EACE,WAAA;AnBm2DJ;AelkEI;EIoOA;IACE,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,gBAAA;EnBi2DJ;EmB71DE;IACE,aAAA;IACA,cAAA;IACA,mBAAA;IACA,mBAAA;IACA,gBAAA;EnB+1DJ;EmB31DE;IACE,qBAAA;IACA,WAAA;IACA,sBAAA;EnB61DJ;EmBz1DE;IACE,qBAAA;EnB21DJ;EmBx1DE;;IAEE,WAAA;EnB01DJ;EmBr1DE;IACE,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,WAAA;IACA,eAAA;EnBu1DJ;EmBr1DE;IACE,kBAAA;IACA,cAAA;IACA,aAAA;IACA,qBfiPkC;IehPlC,cAAA;EnBu1DJ;EmBp1DE;IACE,mBAAA;IACA,uBAAA;EnBs1DJ;EmBp1DE;IACE,gBAAA;EnBs1DJ;AACF;;AuBxqEA;EACE,qBAAA;EAEA,gBnByV4B;EmBxV5B,cnByES;EmBxET,kBAAA;EAGA,sBAAA;EACA,iBAAA;EACA,6BAAA;EACA,6BAAA;ECuFA,wBAAA;EnB4EI,iBAAA;EmB1EJ,gBpB6P4B;EOrV1B,qBAAA;ESFE,qIGGJ;AvB2qEF;AoB1qEM;EGdN;IHeQ,gBAAA;EpB6qEN;AACF;AMvrEE;EiBUE,cnB6DO;EmB5DP,qBAAA;AvBgrEJ;AuB7qEE;EAEE,UAAA;EACA,kDnBgb0B;AJ8vD9B;AuB1qEE;EAEE,anBmd0B;AJwtD9B;AuBvqEE;EACE,eAAA;AvByqEJ;AuB3pEA;;EAEE,oBAAA;AvB6pEF;;AuBppEE;EC3DA,WAAA;EFAE,yBGsEW;EDpEb,qBCoEa;AzB+oEf;AM/sEE;EkBAE,WAAA;EFNA,mEED2D;EAS3D,+DATqG;AxB2tEzG;AwB/sEE;EAEE,WAAA;EFbA,mEED2D;EAgB3D,+DAhBqG;EAqBnG,yDAAA;AxB4sEN;AwBvsEE;EAEE,WAAA;EACA,yBC0CW;EDzCX,qBCyCW;AzB+pEf;AwBjsEE;EAGE,WAAA;EACA,mEAzC+I;EA6C/I,+DA7CyL;AxB2uE7L;AwB5rEI;EAKI,yDAAA;AxB0rER;;AuBlrEE;EC3DA,WAAA;EFAE,yBGsEW;EDpEb,qBCoEa;AzB6qEf;AM7uEE;EkBAE,WAAA;EFNA,kEED2D;EAS3D,8DATqG;AxByvEzG;AwB7uEE;EAEE,WAAA;EFbA,kEED2D;EAgB3D,8DAhBqG;EAqBnG,sDAAA;AxB0uEN;AwBruEE;EAEE,WAAA;EACA,yBC0CW;EDzCX,qBCyCW;AzB6rEf;AwB/tEE;EAGE,WAAA;EACA,kEAzC+I;EA6C/I,8DA7CyL;AxBywE7L;AwB1tEI;EAKI,sDAAA;AxBwtER;;AuBhtEE;EC3DA,cAAA;EFAE,yBGsEW;EDpEb,qBCoEa;AzB2sEf;AM3wEE;EkBAE,WAAA;EFNA,oEED2D;EAS3D,gEATqG;AxBuxEzG;AwB3wEE;EAEE,WAAA;EFbA,oEED2D;EAgB3D,gEAhBqG;EAqBnG,wDAAA;AxBwwEN;AwBnwEE;EAEE,cAAA;EACA,yBC0CW;EDzCX,qBCyCW;AzB2tEf;AwB7vEE;EAGE,WAAA;EACA,oEAzC+I;EA6C/I,gEA7CyL;AxBuyE7L;AwBxvEI;EAKI,wDAAA;AxBsvER;;AuB9uEE;EC3DA,cAAA;EFAE,yBGsEW;EDpEb,qBCoEa;AzByuEf;AMzyEE;EkBAE,WAAA;EFNA,oEED2D;EAS3D,8DATqG;AxBqzEzG;AwBzyEE;EAEE,WAAA;EFbA,oEED2D;EAgB3D,8DAhBqG;EAqBnG,0DAAA;AxBsyEN;AwBjyEE;EAEE,cAAA;EACA,yBC0CW;EDzCX,qBCyCW;AzByvEf;AwB3xEE;EAGE,WAAA;EACA,kEAzC+I;EA6C/I,gEA7CyL;AxBq0E7L;AwBtxEI;EAKI,0DAAA;AxBoxER;;AuB5wEE;EC3DA,cAAA;EFAE,yBGsEW;EDpEb,qBCoEa;AzBuwEf;AMv0EE;EkBAE,cAAA;EFNA,gDED2D;EAS3D,yCATqG;AxBm1EzG;AwBv0EE;EAEE,cAAA;EFbA,gDED2D;EAgB3D,yCAhBqG;EAqBnG,0DAAA;AxBo0EN;AwB/zEE;EAEE,cAAA;EACA,yBC0CW;EDzCX,qBCyCW;AzBuxEf;AwBzzEE;EAGE,cAAA;EACA,6CAzC+I;EA6C/I,4CA7CyL;AxBm2E7L;AwBpzEI;EAKI,0DAAA;AxBkzER;;AuB1yEE;EC3DA,WAAA;EFAE,yBGsEW;EDpEb,qBCoEa;AzBqyEf;AMr2EE;EkBAE,WAAA;EFNA,gDED2D;EAS3D,yCATqG;AxBi3EzG;AwBr2EE;EAEE,WAAA;EFbA,gDED2D;EAgB3D,yCAhBqG;EAqBnG,uDAAA;AxBk2EN;AwB71EE;EAEE,WAAA;EACA,yBC0CW;EDzCX,qBCyCW;AzBqzEf;AwBv1EE;EAGE,WAAA;EACA,6CAzC+I;EA6C/I,2CA7CyL;AxBi4E7L;AwBl1EI;EAKI,uDAAA;AxBg1ER;;AuBx0EE;EC3DA,WAAA;EFAE,yBGsEW;EDpEb,qBCoEa;AzBm0Ef;AMn4EE;EkBAE,WAAA;EFNA,iEED2D;EAS3D,6DATqG;AxB+4EzG;AwBn4EE;EAEE,WAAA;EFbA,iEED2D;EAgB3D,6DAhBqG;EAqBnG,uDAAA;AxBg4EN;AwB33EE;EAEE,WAAA;EACA,yBC0CW;EDzCX,qBCyCW;AzBm1Ef;AwBr3EE;EAGE,WAAA;EACA,iEAzC+I;EA6C/I,2DA7CyL;AxB+5E7L;AwBh3EI;EAKI,uDAAA;AxB82ER;;AuBt2EE;EC3DA,cAAA;EFAE,yBGsEW;EDpEb,qBCoEa;AzBi2Ef;AMj6EE;EkBAE,cAAA;EFNA,mEED2D;EAS3D,iEATqG;AxB66EzG;AwBj6EE;EAEE,cAAA;EFbA,mEED2D;EAgB3D,iEAhBqG;EAqBnG,sDAAA;AxB85EN;AwBz5EE;EAEE,cAAA;EACA,yBC0CW;EDzCX,qBCyCW;AzBi3Ef;AwBn5EE;EAGE,cAAA;EACA,qEAzC+I;EA6C/I,iEA7CyL;AxB67E7L;AwB94EI;EAKI,sDAAA;AxB44ER;;AuB93EE;ECPA,cCYa;EDXb,qBCWa;AzB83Ef;AM97EE;EkBwDE,WALgD;EAMhD,yBCOW;EDNX,qBCMW;AzBm4Ef;AwBt4EE;EAEE,iDAAA;AxBu4EJ;AwBp4EE;EAEE,cCJW;EDKX,6BAAA;AxBq4EJ;AwBl4EE;EAGE,WAAA;EACA,yBCZW;EDaX,qBCbW;AzB+4Ef;AwBh4EI;EAKI,iDAAA;AxB83ER;;AuBv5EE;ECPA,cCYa;EDXb,qBCWa;AzBu5Ef;AMv9EE;EkBwDE,WALgD;EAMhD,yBCOW;EDNX,qBCMW;AzB45Ef;AwB/5EE;EAEE,+CAAA;AxBg6EJ;AwB75EE;EAEE,cCJW;EDKX,6BAAA;AxB85EJ;AwB35EE;EAGE,WAAA;EACA,yBCZW;EDaX,qBCbW;AzBw6Ef;AwBz5EI;EAKI,+CAAA;AxBu5ER;;AuBh7EE;ECPA,cCYa;EDXb,qBCWa;AzBg7Ef;AMh/EE;EkBwDE,cALgD;EAMhD,yBCOW;EDNX,qBCMW;AzBq7Ef;AwBx7EE;EAEE,iDAAA;AxBy7EJ;AwBt7EE;EAEE,cCJW;EDKX,6BAAA;AxBu7EJ;AwBp7EE;EAGE,cAAA;EACA,yBCZW;EDaX,qBCbW;AzBi8Ef;AwBl7EI;EAKI,iDAAA;AxBg7ER;;AuBz8EE;ECPA,cCYa;EDXb,qBCWa;AzBy8Ef;AMzgFE;EkBwDE,cALgD;EAMhD,yBCOW;EDNX,qBCMW;AzB88Ef;AwBj9EE;EAEE,iDAAA;AxBk9EJ;AwB/8EE;EAEE,cCJW;EDKX,6BAAA;AxBg9EJ;AwB78EE;EAGE,cAAA;EACA,yBCZW;EDaX,qBCbW;AzB09Ef;AwB38EI;EAKI,iDAAA;AxBy8ER;;AuBl+EE;ECPA,cCYa;EDXb,qBCWa;AzBk+Ef;AMliFE;EkBwDE,cALgD;EAMhD,yBCOW;EDNX,qBCMW;AzBu+Ef;AwB1+EE;EAEE,iDAAA;AxB2+EJ;AwBx+EE;EAEE,cCJW;EDKX,6BAAA;AxBy+EJ;AwBt+EE;EAGE,cAAA;EACA,yBCZW;EDaX,qBCbW;AzBm/Ef;AwBp+EI;EAKI,iDAAA;AxBk+ER;;AuB3/EE;ECPA,cCYa;EDXb,qBCWa;AzB2/Ef;AM3jFE;EkBwDE,WALgD;EAMhD,yBCOW;EDNX,qBCMW;AzBggFf;AwBngFE;EAEE,iDAAA;AxBogFJ;AwBjgFE;EAEE,cCJW;EDKX,6BAAA;AxBkgFJ;AwB//EE;EAGE,WAAA;EACA,yBCZW;EDaX,qBCbW;AzB4gFf;AwB7/EI;EAKI,iDAAA;AxB2/ER;;AuBphFE;ECPA,cCYa;EDXb,qBCWa;AzBohFf;AMplFE;EkBwDE,WALgD;EAMhD,yBCOW;EDNX,qBCMW;AzByhFf;AwB5hFE;EAEE,+CAAA;AxB6hFJ;AwB1hFE;EAEE,cCJW;EDKX,6BAAA;AxB2hFJ;AwBxhFE;EAGE,WAAA;EACA,yBCZW;EDaX,qBCbW;AzBqiFf;AwBthFI;EAKI,+CAAA;AxBohFR;;AuB7iFE;ECPA,cCYa;EDXb,qBCWa;AzB6iFf;AM7mFE;EkBwDE,cALgD;EAMhD,yBCOW;EDNX,qBCMW;AzBkjFf;AwBrjFE;EAEE,kDAAA;AxBsjFJ;AwBnjFE;EAEE,cCJW;EDKX,6BAAA;AxBojFJ;AwBjjFE;EAGE,cAAA;EACA,yBCZW;EDaX,qBCbW;AzB8jFf;AwB/iFI;EAKI,kDAAA;AxB6iFR;;AuB3jFA;EACE,gBnB+Q4B;EmB9Q5B,cnB4JwC;EmB3JxC,qBnB4JwC;AJk6E1C;AMvoFE;EiB4EE,uDnB0JsC;EmBzJtC,0BnB0JsC;AJo6E1C;AuB3jFE;EAEE,0BnBqJsC;AJu6E1C;AuBzjFE;EAEE,cnBjBO;EmBkBP,oBAAA;AvB0jFJ;;AuB/iFA;ECPE,oBAAA;EnB4EI,mBAAA;EmB1EJ,gBpB+L4B;EOvR1B,qBAAA;AXmpFJ;;AuBljFA;ECXE,uBAAA;EnB4EI,oBAAA;EmB1EJ,gBpBgM4B;EOxR1B,qBAAA;AX0pFJ;;AuBhjFA;EACE,cAAA;EACA,WAAA;AvBmjFF;AuBhjFE;EACE,kBnByX0B;AJyrE9B;;AuB1iFE;;;EACE,WAAA;AvB+iFJ;;A0B1rFA;ENgBM,gCMfJ;A1B6rFF;AoB1qFM;EMpBN;INqBQ,gBAAA;EpB6qFN;AACF;A0BhsFE;EACE,UAAA;A1BksFJ;;A0B7rFE;EACE,aAAA;A1BgsFJ;;A0B5rFA;EACE,kBAAA;EACA,SAAA;EACA,gBAAA;ENDI,6BMEJ;A1B+rFF;AoB7rFM;EMNN;INOQ,gBAAA;EpBgsFN;AACF;A0BlsFE;EACE,QAAA;EACA,YAAA;ENNE,4BMOF;A1BosFJ;AoBvsFM;EMAJ;INCM,gBAAA;EpB0sFN;AACF;;A2B/tFA;;;;EAIE,kBAAA;A3BkuFF;;A2B/tFA;EACE,mBAAA;A3BkuFF;;A2B3tFA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,avBwtBkC;EuBvtBlC,aAAA;EACA,WAAA;EACA,gBvB8xBkC;EuB7xBlC,iBAAA;EACA,oBAAA;EtB2JI,iBAAA;EsBzJJ,cvBwDS;EuBvDT,gBAAA;EACA,gBAAA;EACA,yBvBgDS;EuB/CT,4BAAA;EACA,kEAAA;EhBdE,qBAAA;AX6uFJ;;A2BttFI;EACE,WAAA;EACA,OAAA;A3BytFN;;A2BttFI;EACE,QAAA;EACA,UAAA;A3BytFN;;Ae7sFI;EYnBA;IACE,WAAA;IACA,OAAA;E3BouFJ;E2BjuFE;IACE,QAAA;IACA,UAAA;E3BmuFJ;AACF;AextFI;EYnBA;IACE,WAAA;IACA,OAAA;E3B8uFJ;E2B3uFE;IACE,QAAA;IACA,UAAA;E3B6uFJ;AACF;AeluFI;EYnBA;IACE,WAAA;IACA,OAAA;E3BwvFJ;E2BrvFE;IACE,QAAA;IACA,UAAA;E3BuvFJ;AACF;Ae5uFI;EYnBA;IACE,WAAA;IACA,OAAA;E3BkwFJ;E2B/vFE;IACE,QAAA;IACA,UAAA;E3BiwFJ;AACF;A2B1vFE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,uBvB2vBgC;AJigEpC;A2BnvFE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,qBvB6uBgC;AJwgEpC;A2BhvFI;EACE,iBAAA;A3BkvFN;;A2B5uFE;EACE,MAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,sBvB4tBgC;AJmhEpC;A2B1uFI;EACE,iBAAA;A3B4uFN;;A2BpuFE;EAIE,WAAA;EACA,YAAA;A3BouFJ;;A2B/tFA;EC9GE,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;A5Bi1FF;;A2B/tFA;EACE,cAAA;EACA,WAAA;EACA,uBAAA;EACA,WAAA;EACA,gBvBmO4B;EuBlO5B,cvB3CS;EuB4CT,mBAAA;EAEA,mBAAA;EACA,6BAAA;EACA,SAAA;A3BiuFF;AMt1FE;EqBoIE,0DvBgrBgC;EuB/qBhC,qBAAA;EL/IA,yBlByEO;AJ4xFX;A2BltFE;EAEE,0DvB4qBgC;EuB3qBhC,qBAAA;ELtJA,yBlByEO;AJiyFX;A2BhtFE;EAEE,cvBhFO;EuBiFP,oBAAA;EACA,6BAAA;A3BitFJ;;A2BzsFA;EACE,cAAA;A3B4sFF;;A2BxsFA;EACE,cAAA;EACA,sBFimBkC;EEhmBlC,gBAAA;EtBAI,oBAAA;EsBEJ,cvBpGS;EuBqGT,mBAAA;A3B2sFF;;A2BvsFA;EACE,cAAA;EACA,uBAAA;EACA,cvBzGS;AJmzFX;;A6Br4FA;;EAEE,kBAAA;EACA,oBAAA;EACA,sBAAA;A7Bw4FF;A6Bt4FE;;EACE,kBAAA;EACA,cAAA;A7By4FJ;AMx4FE;;EuBII,UAAA;A7Bw4FN;A6Bt4FI;;;;EAGE,UAAA;A7By4FN;;A6Bn4FA;EACE,aAAA;EACA,eAAA;EACA,2BAAA;A7Bs4FF;A6Bp4FE;EACE,WAAA;A7Bs4FJ;;A6Bh4FE;;EAEE,iBAAA;A7Bm4FJ;A6B/3FE;;ElBXE,0BAAA;EACA,6BAAA;AX84FJ;A6B/3FE;;ElBFE,yBAAA;EACA,4BAAA;AXq4FJ;;A6Bl3FA;EACE,wBAAA;EACA,uBAAA;A7Bq3FF;A6Bn3FE;EAGE,cAAA;A7Bm3FJ;A6Bh3FE;EACE,eAAA;A7Bk3FJ;;A6B92FA;EACE,uBAAA;EACA,sBAAA;A7Bi3FF;;A6B92FA;EACE,sBAAA;EACA,qBAAA;A7Bi3FF;;A6B71FA;EACE,sBAAA;EACA,uBAAA;EACA,uBAAA;A7Bg2FF;A6B91FE;;EAEE,WAAA;A7Bg2FJ;A6B71FE;;EAEE,gBAAA;A7B+1FJ;A6B31FE;;ElBrFE,6BAAA;EACA,4BAAA;AXo7FJ;A6B31FE;;ElBxGE,yBAAA;EACA,0BAAA;AXu8FJ;;A6B50FE;;EAEE,gBAAA;A7B+0FJ;A6B70FI;;;;EAEE,kBAAA;EACA,sBAAA;EACA,oBAAA;A7Bi1FN;;A8B1+FA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;EACA,WAAA;A9B6+FF;A8B3+FE;;;;EAIE,kBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;EACA,gBAAA;A9B6+FJ;A8B3+FI;;;;;;;;;;;;EAGE,iBAAA;A9Bs/FN;A8Bj/FE;;;EAGE,UAAA;A9Bm/FJ;A8B/+FE;EACE,UAAA;A9Bi/FJ;A8B5+FI;;EnBIA,yBAAA;EACA,4BAAA;AX4+FJ;A8B5+FE;EACE,aAAA;EACA,mBAAA;A9B8+FJ;A8B5+FI;EnBnBA,0BAAA;EACA,6BAAA;AXkgGJ;A8B9+FI;EnBPA,yBAAA;EACA,4BAAA;AXw/FJ;A8B9+FI;;;;EnBzBA,0BAAA;EACA,6BAAA;AX6gGJ;A8B5+FI;;;;EnBlCA,0BAAA;EACA,6BAAA;AXohGJ;;A8Bn+FA;;EAEE,aAAA;A9Bs+FF;A8Bj+FE;;EACE,kBAAA;EACA,UAAA;A9Bo+FJ;A8Bl+FI;;EACE,UAAA;A9Bq+FN;A8Bj+FE;;;;;;;;EAIE,iBAAA;A9Bu+FJ;;A8Bn+FA;EAAuB,kBAAA;A9Bu+FvB;;A8Bt+FA;EAAsB,iBAAA;A9B0+FtB;;A8Bl+FA;EACE,aAAA;EACA,mBAAA;EACA,wBAAA;EACA,gBAAA;EzB2DI,iBAAA;EyBzDJ,gB1BuO4B;E0BtO5B,gB1B2O4B;E0B1O5B,c1B1CS;E0B2CT,kBAAA;EACA,mBAAA;EACA,yB1BjDS;E0BkDT,yBAAA;EnB/GE,qBAAA;AXqlGJ;A8Bl+FE;;EAEE,aAAA;A9Bo+FJ;;A8B19FA;;EAEE,gC1BoasC;AJyjFxC;;A8B19FA;;;;;;EAME,oBAAA;EzBwBI,mBAAA;EyBtBJ,gB1B2I4B;EOvR1B,qBAAA;AX0mGJ;;A8B19FA;;EAEE,kC1BkZsC;AJ2kFxC;;A8B19FA;;;;;;EAME,uBAAA;EzBOI,oBAAA;EyBLJ,gB1B2H4B;EOxR1B,qBAAA;AX2nGJ;;A8B19FA;;EAEE,sBAAA;A9B69FF;;A8Bl9FA;;;;;;;;EnB9JI,0BAAA;EACA,6BAAA;AX2nGJ;;A8Bn9FA;;;;;;EnB3JI,yBAAA;EACA,4BAAA;AXunGJ;;A+B/pGA;EACE,kBAAA;EACA,UAAA;EACA,cAAA;EACA,mBAAA;EACA,oBAAA;EACA,yBAAA;A/BkqGF;;A+B/pGA;EACE,oBAAA;EACA,kB3B0jBsC;AJwmFxC;;A+B/pGA;EACE,kBAAA;EACA,OAAA;EACA,WAAA;EACA,W3BqjBsC;E2BpjBtC,gBAAA;EACA,UAAA;A/BkqGF;A+BhqGE;EACE,WNzBO;EM0BP,qB3BwEM;EkBnGN,yBlBmGM;AJ2lGV;A+B9pGE;EAKI,gB3B+fkC;AJ6pFxC;A+BxpGE;EACE,8D3BufoC;AJmqFxC;A+BvpGE;EACE,WN7CO;EM8CP,qE3BgjB4C;E2B/iB5C,iE3B+iB4C;AJ0mFhD;A+BlpGI;EACE,c3BoBK;AJgoGX;A+BlpGM;EACE,kE3B0dgC;AJ0rFxC;;A+B1oGA;EACE,kBAAA;EACA,gBAAA;EAEA,mBAAA;A/B4oGF;A+BxoGE;EACE,kBAAA;EACA,aAAA;EACA,aAAA;EACA,cAAA;EACA,W3BwfoC;E2BvfpC,Y3BufoC;E2BtfpC,oBAAA;EACA,WAAA;EACA,kE3B8boC;E2B7bpC,yBAAA;A/B0oGJ;A+BroGE;EACE,kBAAA;EACA,aAAA;EACA,aAAA;EACA,cAAA;EACA,W3ByeoC;E2BxepC,Y3BweoC;E2BvepC,WAAA;EACA,iCAAA;A/BuoGJ;;A+B7nGE;EpBlGE,qBAAA;AXmuGJ;A+B5nGI;EACE,yDAAA;A/B8nGN;A+BznGI;EACE,qB3BvBI;EkBnGN,yBlBmGM;AJmpGV;A+BxnGI;EACE,yDAAA;A/B0nGN;A+BrnGI;ETpIA,yClBulB4C;AJqqFhD;A+BrnGI;ETvIA,yClBulB4C;AJwqFhD;;A+B7mGE;EAEE,kB3Bwd4C;AJupFhD;A+B3mGI;EACE,yDAAA;A/B6mGN;A+BxmGI;ET9JA,yClBulB4C;AJkrFhD;;A+BhmGA;EACE,qBAAA;A/BmmGF;A+BhmGI;EACE,cAAA;EACA,c3Bgc0C;E2B/b1C,mBAAA;EAEA,qB3B8b0C;AJmqFhD;A+B9lGI;EACE,yBAAA;EACA,0BAAA;EACA,uB3Byb0C;E2Bxb1C,wB3Bwb0C;E2Bvb1C,yB3BjHK;E2BmHL,qB3Bob0C;EgBtmB1C,yIWmLA;A/B+lGN;AoB9wGM;EWuKF;IXtKI,gBAAA;EpBixGN;AACF;A+B/lGI;EACE,kE3BiVkC;E2BhVlC,8BAAA;A/BimGN;A+B5lGI;ETzMA,yClBulB4C;AJitFhD;;A+BllGA;EACE,qBAAA;EACA,WAAA;EACA,mC3BsVsC;E2BrVtC,wCAAA;E1B5CI,iBAAA;E0B+CJ,gB3B+H4B;E2B9H5B,gB3BmI4B;E2BlI5B,c3BlJS;E2BmJT,sBAAA;EACA,4IAAA;EACA,yBAAA;EpBtNE,qBAAA;EoByNF,gBAAA;A/BmlGF;A+BjlGE;EACE,8D3ByToC;E2BxTpC,UAAA;EAKE,kD3Bia8B;AJ8qFpC;A+B5kGI;EAME,c3B1KK;E2B2KL,kE3B4RkC;AJ6yFxC;A+BrkGE;EAEE,YAAA;EACA,sB3BiM0B;E2BhM1B,sBAAA;A/BskGJ;A+BnkGE;EACE,c3BxLO;E2ByLP,yB3B7LO;AJkwGX;A+BjkGE;EACE,aAAA;A/BmkGJ;A+B/jGE;EACE,kBAAA;EACA,0BAAA;A/BikGJ;;A+B7jGA;EACE,kC3B2RsC;E2B1RtC,oB3BmL4B;E2BlL5B,uB3BkL4B;E2BjL5B,oB3BkL4B;EC5RxB,oBAAA;AL2qGN;;A+B7jGA;EACE,gC3BoRsC;E2BnRtC,mB3BgL4B;E2B/K5B,sB3B+K4B;E2B9K5B,kB3B+K4B;ECjSxB,mBAAA;ALmrGN;;A+BxjGA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,mC3BkQsC;E2BjQtC,gBAAA;A/B2jGF;;A+BxjGA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,mC3B0PsC;E2BzPtC,SAAA;EACA,gBAAA;EACA,UAAA;A/B2jGF;A+BzjGE;EACE,8D3BsOoC;E2BrOpC,gB3BwOoC;AJm1FxC;A+BvjGE;EAEE,kE3BmNoC;AJq2FxC;A+BpjGI;EACE,iB3ByXa;AJ6rFnB;A+BljGE;EACE,0BAAA;A/BojGJ;;A+BhjGA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,UAAA;EACA,mC3ByNsC;E2BxNtC,wBAAA;EACA,gBAAA;EAEA,gB3BE4B;E2BD5B,gB3BM4B;E2BL5B,c3B/QS;E2BgRT,kE3BuLsC;E2BtLtC,yBAAA;EpBlVE,qBAAA;AXq4GJ;A+B/iGE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,cAAA;EACA,6B3BkMoC;E2BjMpC,wBAAA;EACA,gB3BV0B;E2BW1B,c3B/RO;E2BgSP,iBAAA;ET7WA,yBlByEO;E2BsSP,oBAAA;EpBnWA,gCAAA;AXq5GJ;;A+BviGA;EACE,WAAA;EACA,cAAA;EACA,UAAA;EACA,6BAAA;EACA,gBAAA;A/B0iGF;A+BxiGE;EACE,UAAA;A/B0iGJ;A+BtiGI;EAA0B,mC3BkSe;AJuwF7C;A+BxiGI;EAA0B,mC3BiSe;AJ0wF7C;A+B1iGI;EAA0B,mC3BgSe;AJ6wF7C;A+B1iGE;EACE,SAAA;A/B4iGJ;A+BziGE;EACE,W3BkRyC;E2BjRzC,Y3BiRyC;E2BhRzC,oBAAA;ETlZA,yBlBmGM;E2BiTN,S3BiRyC;EOzpBzC,mBAAA;ESFE,4GW6YF;A/B0iGJ;AoBn7GM;EWiYJ;IXhYM,gBAAA;EpBs7GN;AACF;A+BvjGE;EASE,gBAAA;A/BijGJ;A+B/iGI;ET1ZA,qElB0qByC;AJkyF7C;A+B7iGE;EACE,W3B2PgC;E2B1PhC,c3B2PgC;E2B1PhC,kBAAA;EACA,e3B0PgC;E2BzPhC,yB3B3VO;E2B4VP,yBAAA;EpBzZA,mBAAA;AXy8GJ;A+B3iGE;EACE,W3BuPyC;E2BtPzC,Y3BsPyC;EkBlqBzC,yBlBmGM;E2B2UN,S3BuPyC;EOzpBzC,mBAAA;ESFE,4GWuaF;A/B4iGJ;AoB/8GM;EW4ZJ;IX3ZM,gBAAA;EpBk9GN;AACF;A+BxjGE;EAQE,gBAAA;A/BmjGJ;A+BjjGI;ETpbA,qElB0qByC;AJ8zF7C;A+B/iGE;EACE,W3BiOgC;E2BhOhC,c3BiOgC;E2BhOhC,kBAAA;EACA,e3BgOgC;E2B/NhC,yB3BrXO;E2BsXP,yBAAA;EpBnbA,mBAAA;AXq+GJ;A+B7iGE;EACE,W3B6NyC;E2B5NzC,Y3B4NyC;E2B3NzC,aAAA;EACA,qB3BH0B;E2BI1B,oB3BJ0B;EkBrc1B,yBlBmGM;E2BwWN,S3B0NyC;EOzpBzC,mBAAA;ESFE,4GWocF;A/B8iGJ;AoB9+GM;EWsbJ;IXrbM,gBAAA;EpBi/GN;AACF;A+B7jGE;EAWE,gBAAA;A/BqjGJ;A+BnjGI;ETjdA,qElB0qByC;AJ61F7C;A+BjjGE;EACE,W3BoMgC;E2BnMhC,c3BoMgC;E2BnMhC,kBAAA;EACA,e3BmMgC;E2BlMhC,6BAAA;EACA,yBAAA;EACA,oBAAA;A/BmjGJ;A+B/iGE;EACE,yB3BzZO;EO7DP,mBAAA;AXwgHJ;A+B9iGE;EACE,kBAAA;EACA,yB3B/ZO;EO7DP,mBAAA;AX6gHJ;A+B5iGI;EACE,yB3BnaK;AJi9GX;A+B3iGI;EACE,eAAA;A/B6iGN;A+B1iGI;EACE,yB3B3aK;AJu9GX;A+BziGI;EACE,eAAA;A/B2iGN;A+BxiGI;EACE,yB3BnbK;AJ69GX;;A+BriGA;;;EXzfM,4GW4fJ;A/BwiGF;AoBhiHM;EWqfN;;;IXpfQ,gBAAA;EpBqiHN;AACF;;AgCtjHA;EACE,aAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AhCyjHF;;AgCtjHA;EACE,cAAA;EACA,oBAAA;AhCyjHF;AMxjHE;E0BGE,qBAAA;AhCwjHJ;AgCpjHE;EACE,c5B0DO;E4BzDP,oBAAA;EACA,eAAA;AhCsjHJ;;AgC9iHA;EACE,gCAAA;AhCijHF;AgC/iHE;EACE,mBAAA;EACA,6BAAA;EACA,6BAAA;ErBbA,8BAAA;EACA,+BAAA;AX+jHJ;AM3kHE;E0B6BI,kBAAA;EACA,qC5BgtB8B;AJi2FpC;AgC9iHI;EACE,c5BgCK;E4B/BL,6BAAA;EACA,yBAAA;AhCgjHN;AgC5iHE;;EAEE,c5ByBO;E4BxBP,yB5BmBO;E4BlBP,qC5BqsBgC;AJy2FpC;AgC3iHE;EAEE,gBAAA;ErBtCA,yBAAA;EACA,0BAAA;AXmlHJ;;AgCliHE;EACE,gBAAA;EACA,SAAA;ErB7DA,qBAAA;AXmmHJ;AgCliHE;;EAEE,WP9EO;EO+EP,yB5BmBM;AJihHV;;AgC1hHE;;EAEE,cAAA;EACA,kBAAA;AhC6hHJ;;AgCxhHE;;EAEE,aAAA;EACA,YAAA;EACA,kBAAA;AhC2hHJ;;AgCjhHE;EACE,aAAA;AhCohHJ;AgClhHE;EACE,cAAA;AhCohHJ;;AiC7nHA;EACE,kBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,oBAAA;AjCgoHF;AiC5nHE;;;;;;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;AjCmoHJ;AiC/mHA;EACE,qBAAA;EACA,uB7BiuBkC;E6BhuBlC,0B7BguBkC;E6B/tBlC,kB7B+IO;EClBH,mBAAA;E4B3HJ,oBAAA;EACA,mBAAA;AjCinHF;AM3pHE;E2B6CE,qBAAA;AjCinHJ;;AiCxmHA;EACE,aAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AjC2mHF;AiCzmHE;EACE,gBAAA;EACA,eAAA;AjC2mHJ;AiCxmHE;EACE,gBAAA;EACA,WAAA;AjC0mHJ;;AiCjmHA;EACE,qBAAA;EACA,mB7BwpBkC;E6BvpBlC,sB7BupBkC;AJ68FpC;;AiCxlHA;EACE,gBAAA;EACA,YAAA;EAGA,mBAAA;AjCylHF;;AiCrlHA;EACE,wBAAA;E5B8DI,mBAAA;E4B5DJ,cAAA;EACA,6BAAA;EACA,6BAAA;EtBxGE,qBAAA;AXisHJ;AMnsHE;E2B8GE,qBAAA;AjCwlHJ;;AiCllHA;EACE,qBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,mCAAA;AjCqlHF;;AiCllHA;EACE,gBRglBkC;EQ/kBlC,gBAAA;AjCqlHF;;Ae3pHI;EkBkFI;;;;;;IACE,gBAAA;IACA,eAAA;EjCklHR;AACF;AeprHI;EkB6FA;IAoBI,qBAAA;IACA,2BAAA;EjCukHN;EiCrkHM;IACE,mBAAA;EjCukHR;EiCrkHQ;IACE,kBAAA;EjCukHV;EiCpkHQ;IACE,qB7BwlBwB;I6BvlBxB,oB7BulBwB;EJ++FlC;EiCjkHM;;;;;;IACE,iBAAA;EjCwkHR;EiC1jHM;IACE,iBAAA;EjC4jHR;EiCzjHM;IACE,wBAAA;IAGA,gBAAA;EjCyjHR;EiCtjHM;IACE,aAAA;EjCwjHR;AACF;AezsHI;EkBkFI;;;;;;IACE,gBAAA;IACA,eAAA;EjC+nHR;AACF;AejuHI;EkB6FA;IAoBI,qBAAA;IACA,2BAAA;EjConHN;EiClnHM;IACE,mBAAA;EjConHR;EiClnHQ;IACE,kBAAA;EjConHV;EiCjnHQ;IACE,qB7BwlBwB;I6BvlBxB,oB7BulBwB;EJ4hGlC;EiC9mHM;;;;;;IACE,iBAAA;EjCqnHR;EiCvmHM;IACE,iBAAA;EjCymHR;EiCtmHM;IACE,wBAAA;IAGA,gBAAA;EjCsmHR;EiCnmHM;IACE,aAAA;EjCqmHR;AACF;AetvHI;EkBkFI;;;;;;IACE,gBAAA;IACA,eAAA;EjC4qHR;AACF;Ae9wHI;EkB6FA;IAoBI,qBAAA;IACA,2BAAA;EjCiqHN;EiC/pHM;IACE,mBAAA;EjCiqHR;EiC/pHQ;IACE,kBAAA;EjCiqHV;EiC9pHQ;IACE,qB7BwlBwB;I6BvlBxB,oB7BulBwB;EJykGlC;EiC3pHM;;;;;;IACE,iBAAA;EjCkqHR;EiCppHM;IACE,iBAAA;EjCspHR;EiCnpHM;IACE,wBAAA;IAGA,gBAAA;EjCmpHR;EiChpHM;IACE,aAAA;EjCkpHR;AACF;AenyHI;EkBkFI;;;;;;IACE,gBAAA;IACA,eAAA;EjCytHR;AACF;Ae3zHI;EkB6FA;IAoBI,qBAAA;IACA,2BAAA;EjC8sHN;EiC5sHM;IACE,mBAAA;EjC8sHR;EiC5sHQ;IACE,kBAAA;EjC8sHV;EiC3sHQ;IACE,qB7BwlBwB;I6BvlBxB,oB7BulBwB;EJsnGlC;EiCxsHM;;;;;;IACE,iBAAA;EjC+sHR;EiCjsHM;IACE,iBAAA;EjCmsHR;EiChsHM;IACE,wBAAA;IAGA,gBAAA;EjCgsHR;EiC7rHM;IACE,aAAA;EjC+rHR;AACF;AiC9vHQ;;;;;;EACE,gBAAA;EACA,eAAA;AjCqwHV;AiCzwHI;EAoBI,qBAAA;EACA,2BAAA;AjCwvHR;AiCtvHQ;EACE,mBAAA;AjCwvHV;AiCtvHU;EACE,kBAAA;AjCwvHZ;AiCrvHU;EACE,qB7BwlBwB;E6BvlBxB,oB7BulBwB;AJgqGpC;AiClvHQ;;;;;;EACE,iBAAA;AjCyvHV;AiC3uHQ;EACE,iBAAA;AjC6uHV;AiC1uHQ;EACE,wBAAA;EAGA,gBAAA;AjC0uHV;AiCvuHQ;EACE,aAAA;AjCyuHV;;AiC3tHE;EACE,yB7B8jBgC;AJgqGpC;AMt7HE;E2B2NI,yB7B2jB8B;AJmqGpC;AiCztHI;EACE,yB7BmjB8B;AJwqGpC;AM57HE;E2BoOM,yB7BijB4B;AJ0qGpC;AiCxtHM;EACE,yB7B+iB4B;AJ2qGpC;AiCttHI;;;;EAIE,yB7BsiB8B;AJkrGpC;AiCptHE;EACE,yB7B+hBgC;E6B9hBhC,gC7BmiBgC;AJmrGpC;AiCntHE;EACE,yDAAA;AjCqtHJ;AiCltHE;EACE,yB7BshBgC;AJ8rGpC;AiCntHI;EACE,yB7BshB8B;AJ+rGpC;AMr9HE;E2BmQM,yB7BmhB4B;AJksGpC;;AiC7sHE;EACE,W7BhNO;AJg6HX;AM59HE;E2B+QI,W7BnNK;AJm6HX;AiC3sHI;EACE,+B7Bwf8B;AJqtGpC;AMl+HE;E2BwRM,gC7Bsf4B;AJutGpC;AiC1sHM;EACE,gC7Bof4B;AJwtGpC;AiCxsHI;;;;EAIE,W7BxOK;AJk7HX;AiCtsHE;EACE,+B7BoegC;E6BnehC,sC7BwegC;AJguGpC;AiCrsHE;EACE,yDAAA;AjCusHJ;AiCpsHE;EACE,+B7B2dgC;AJ2uGpC;AiCrsHI;EACE,W7BxPK;AJ+7HX;AM3/HE;E2BuTM,W7B3PG;AJk8HX;;AkC1gIA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EAEA,qBAAA;EACA,yB9Bw3BkC;E8Bv3BlC,2BAAA;EACA,oCAAA;EvBKE,qBAAA;AXwgIJ;AkC1gIE;EACE,eAAA;EACA,cAAA;AlC4gIJ;AkCzgIE;EACE,mBAAA;EACA,sBAAA;AlC2gIJ;AkCzgII;EACE,mBAAA;EvBCF,wCAAA;EACA,yCAAA;AX2gIJ;AkCzgII;EACE,sBAAA;EvBUF,4CAAA;EACA,2CAAA;AXkgIJ;AkCtgIE;;EAEE,aAAA;AlCwgIJ;;AkCpgIA;EAGE,cAAA;EAGA,eAAA;EACA,gB9Bw0BkC;AJ2rGpC;;AkC//HA;EACE,sB9Bk0BkC;AJgsGpC;;AkC//HA;EACE,qBAAA;EACA,gBAAA;AlCkgIF;;AkC//HA;EACE,gBAAA;AlCkgIF;;AMvjIE;E4B0DE,qBAAA;AlCigIJ;AkC9/HE;EACE,oB9BizBgC;AJ+sGpC;;AkCx/HA;EACE,wBAAA;EACA,gBAAA;EAEA,yB9BPS;E8BQT,2CAAA;AlC0/HF;AkCx/HE;EvBvEE,oDAAA;AXkkIJ;;AkCt/HA;EACE,wBAAA;EAEA,yB9BlBS;E8BmBT,wCAAA;AlCw/HF;AkCt/HE;EvBlFE,oDAAA;AX2kIJ;;AkC/+HA;EACE,uBAAA;EACA,uBAAA;EACA,sBAAA;EACA,gBAAA;AlCk/HF;;AkC/+HA;EACE,uBAAA;EACA,sBAAA;AlCk/HF;;AkC9+HA;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,gB9BowBkC;EOn3BhC,+BAAA;AXimIJ;;AkC9+HA;;;EAGE,cAAA;EACA,WAAA;AlCi/HF;;AkC9+HA;;EvBjHI,wCAAA;EACA,yCAAA;AXomIJ;;AkC/+HA;;EvBxGI,4CAAA;EACA,2CAAA;AX4lIJ;;AkC5+HE;EACE,mB9B4uBgC;AJmwGpC;Ae9kII;EmB6FJ;IAMI,aAAA;IACA,mBAAA;IACA,mBAAA;IACA,kBAAA;ElC++HF;EkC7+HE;IAEE,YAAA;IACA,kB9BguB8B;I8B/tB9B,gBAAA;IACA,iB9B8tB8B;EJgxGlC;AACF;;AkCl+HE;EACE,mB9BgtBgC;AJqxGpC;AehmII;EmBuHJ;IAQI,aAAA;IACA,mBAAA;ElCq+HF;EkCl+HE;IAEE,YAAA;IACA,gBAAA;ElCm+HJ;EkCj+HI;IACE,cAAA;IACA,cAAA;ElCm+HN;EkC99HM;IvBzKJ,0BAAA;IACA,6BAAA;EX0oIF;EkC/9HQ;;IAGE,0BAAA;ElCg+HV;EkC99HQ;;IAGE,6BAAA;ElC+9HV;EkC39HM;IvB1KJ,yBAAA;IACA,4BAAA;EXwoIF;EkC59HQ;;IAGE,yBAAA;ElC69HV;EkC39HQ;;IAGE,4BAAA;ElC49HV;AACF;;AkC/8HE;EACE,sB9BsoBgC;AJ40GpC;Ae1oII;EmBsLJ;IAMI,e9BkpBgC;I8BjpBhC,mB9BkpBgC;I8BjpBhC,UAAA;IACA,SAAA;ElCk9HF;EkCh9HE;IACE,qBAAA;IACA,WAAA;ElCk9HJ;AACF;;AkCz8HA;EACE,qBAAA;AlC48HF;AkC18HE;EACE,gBAAA;AlC48HJ;AkC18HI;EACE,gBAAA;EvBvOF,6BAAA;EACA,4BAAA;AXorIJ;AkC18HI;EvBzPA,yBAAA;EACA,0BAAA;AXssIJ;AkC18HI;EvBtQA,gBAAA;EuBwQE,gBAAA;AlC48HN;;AmCtuIA;EACE,aAAA;EACA,eAAA;EACA,qBAAA;EACA,mB/BolCkC;E+BllClC,gBAAA;EACA,yB/BuES;EO5DP,qBAAA;AX8tIJ;;AmCnuIE;EACE,oB/BwkCgC;AJ8pGpC;AmCpuII;EACE,WAAA;EACA,qB/BokC8B;E+BnkC9B,c/B+DK;E+B9DL,YAAA;AnCsuIN;AmC5tIE;EACE,0BAAA;AnC8tIJ;AmC3tIE;EACE,qBAAA;AnC6tIJ;AmC1tIE;EACE,c/B2CO;AJirIX;;AoCnwIA;EACE,aAAA;E5BGA,eAAA;EACA,gBAAA;EGaE,qBAAA;AXwvIJ;;AoCpwIA;EACE,kBAAA;EACA,cAAA;EACA,uBAAA;EACA,iBAAA;EACA,iBhC+0BkC;EgC90BlC,chCqES;EgCnET,yBhCgES;EgC/DT,yBAAA;ApCswIF;AoCpwIE;EACE,UAAA;EACA,chC8DO;EgC7DP,qBAAA;EACA,yBhCyDO;EgCxDP,qBhCyDO;AJ6sIX;AoCnwIE;EACE,UAAA;EACA,UhCu0BgC;EgCt0BhC,kDhCib0B;AJo1H9B;;AoC/vII;EACE,cAAA;EzBaF,8BAAA;EACA,iCAAA;AXsvIJ;AoC/vII;EzBNA,+BAAA;EACA,kCAAA;AXwwIJ;AoC9vIE;EACE,UAAA;EACA,WXxCO;EWyCP,yBhCyDM;EgCxDN,qBhCwDM;AJwsIV;AoC7vIE;EACE,chC6BO;EgC5BP,oBAAA;EAEA,YAAA;EACA,yBhCqBO;EgCpBP,qBhCqBO;AJyuIX;;AqCrzIE;EACE,uBAAA;EhCgLE,mBAAA;EgC9KF,gBjCmS0B;AJqhI9B;AqCnzIM;E1BqCF,8BAAA;EACA,iCAAA;AXixIJ;AqClzIM;E1BkBF,+BAAA;EACA,kCAAA;AXmyIJ;;AqCn0IE;EACE,uBAAA;EhCgLE,oBAAA;EgC9KF,gBjCoS0B;AJkiI9B;AqCj0IM;E1BqCF,8BAAA;EACA,iCAAA;AX+xIJ;AqCh0IM;E1BkBF,+BAAA;EACA,kCAAA;AXizIJ;;AsC/0IA;EACE,qBAAA;EACA,qBAAA;EjC6JE,cAAA;EiC3JF,gBlCgDqB;EkC/CrB,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;E3BKE,qBAAA;ESFE,qIkBDJ;AtCk1IF;AoB70IM;EkBfN;IlBgBQ,gBAAA;EpBg1IN;AACF;AMt1IE;EgCGI,qBAAA;AtCs1IN;;AsCj1IE;EACE,aAAA;AtCo1IJ;;AsC/0IA;EACE,kBAAA;EACA,SAAA;AtCk1IF;;AsC30IA;EACE,oBlCu7BkC;EkCt7BlC,mBlCs7BkC;EO78BhC,oBAAA;AXs2IJ;;AsCt0IE;ECjDA,WAAA;EACA,yBd0Ea;AzBizIf;AM72IE;EiCVI,WAAA;EACA,mEAAA;AvC03IN;AuCv3II;EAEE,UAAA;EACA,iDAAA;AvCw3IN;;AsCn1IE;ECjDA,WAAA;EACA,yBd0Ea;AzB8zIf;AM13IE;EiCVI,WAAA;EACA,kEAAA;AvCu4IN;AuCp4II;EAEE,UAAA;EACA,+CAAA;AvCq4IN;;AsCh2IE;ECjDA,cAAA;EACA,yBd0Ea;AzB20If;AMv4IE;EiCVI,cAAA;EACA,oEAAA;AvCo5IN;AuCj5II;EAEE,UAAA;EACA,iDAAA;AvCk5IN;;AsC72IE;ECjDA,cAAA;EACA,yBd0Ea;AzBw1If;AMp5IE;EiCVI,cAAA;EACA,kEAAA;AvCi6IN;AuC95II;EAEE,UAAA;EACA,iDAAA;AvC+5IN;;AsC13IE;ECjDA,cAAA;EACA,yBd0Ea;AzBq2If;AMj6IE;EiCVI,cAAA;EACA,6CAAA;AvC86IN;AuC36II;EAEE,UAAA;EACA,iDAAA;AvC46IN;;AsCv4IE;ECjDA,WAAA;EACA,yBd0Ea;AzBk3If;AM96IE;EiCVI,WAAA;EACA,6CAAA;AvC27IN;AuCx7II;EAEE,UAAA;EACA,iDAAA;AvCy7IN;;AsCp5IE;ECjDA,WAAA;EACA,yBd0Ea;AzB+3If;AM37IE;EiCVI,WAAA;EACA,iEAAA;AvCw8IN;AuCr8II;EAEE,UAAA;EACA,+CAAA;AvCs8IN;;AsCj6IE;ECjDA,cAAA;EACA,yBd0Ea;AzB44If;AMx8IE;EiCVI,cAAA;EACA,qEAAA;AvCq9IN;AuCl9II;EAEE,UAAA;EACA,kDAAA;AvCm9IN;;AwCh+IA;EACE,kBAAA;EACA,mBpCi3BkC;EoC/2BlC,yBpC0ES;EO5DP,qBAAA;AXq9IJ;Ae36II;EyB5DJ;IAQI,kBAAA;ExCm+IF;AACF;;AwCh+IA;EACE,gBAAA;EACA,eAAA;E7BIE,gBAAA;AXg+IJ;;AyC9+IA;EACE,kBAAA;EACA,wBAAA;EACA,mBrC0gCkC;EqCzgClC,6BAAA;E9BUE,qBAAA;AXw+IJ;;AyC7+IA;EAEE,cAAA;AzC++IF;;AyC3+IA;EACE,gBrC+U4B;AJ+pI9B;;AyCt+IA;EACE,sBAAA;AzCy+IF;AyCt+IE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,wBAAA;EACA,cAAA;AzCw+IJ;;AyC99IE;EC/CA,+BDgDqH;EnB3CnH,yBmB2CuB;EC9CzB,qBD8CqE;AzCm+IvE;A0C/gJE;EACE,mEAAA;A1CihJJ;A0C9gJE;EACE,uDAAA;A1CghJJ;;AyC1+IE;EC/CA,8BDgDqH;EnB3CnH,yBmB2CuB;EC9CzB,qBD8CqE;AzC++IvE;A0C3hJE;EACE,kEAAA;A1C6hJJ;A0C1hJE;EACE,YAAA;A1C4hJJ;;AyCt/IE;EC/CA,gCDgDqH;EnB3CnH,yBmB2CuB;EC9CzB,qBD8CqE;AzC2/IvE;A0CviJE;EACE,oEAAA;A1CyiJJ;A0CtiJE;EACE,uDAAA;A1CwiJJ;;AyClgJE;EC/CA,iCDgDqH;EnB3CnH,yBmB2CuB;EC9CzB,qBD8CqE;AzCugJvE;A0CnjJE;EACE,oEAAA;A1CqjJJ;A0CljJE;EACE,uDAAA;A1CojJJ;;AyC9gJE;EC/CA,6BDgDqH;EnB3CnH,yBmB2CuB;EC9CzB,qBD8CqE;AzCmhJvE;A0C/jJE;EACE,+CAAA;A1CikJJ;A0C9jJE;EACE,sDAAA;A1CgkJJ;;AyC1hJE;EC/CA,+BDgDqH;EnB3CnH,yBmB2CuB;EC9CzB,qBD8CqE;AzC+hJvE;A0C3kJE;EACE,+CAAA;A1C6kJJ;A0C1kJE;EACE,uDAAA;A1C4kJJ;;AyCtiJE;EC/CA,8BDgDqH;EnB3CnH,yBmB2CuB;EC9CzB,qBD8CqE;AzC2iJvE;A0CvlJE;EACE,iEAAA;A1CylJJ;A0CtlJE;EACE,oDAAA;A1CwlJJ;;AyCljJE;EC/CA,iCDgDqH;EnB3CnH,yBmB2CuB;EC9CzB,qBD8CqE;AzCujJvE;A0CnmJE;EACE,qEAAA;A1CqmJJ;A0ClmJE;EACE,uDAAA;A1ComJJ;;A2C5mJE;EACE;IAAO,8BAAA;E3CgnJT;E2C/mJE;IAAK,wBAAA;E3CknJP;AACF;A2C/mJA;EACE,aAAA;EACA,evCmhCkC;EuClhClC,gBAAA;EACA,cAAA;EtCwKI,mBAAA;EsCtKJ,yBvCiES;EO7DP,qBAAA;AX8mJJ;;A2C7mJA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;EACA,WvCoDS;EuCnDT,kBAAA;EACA,mBAAA;EACA,yBvCwgCkC;EgBnhC9B,2BuBYJ;A3CgnJF;AoBxnJM;EuBDN;IvBEQ,gBAAA;EpB2nJN;AACF;;A2ClnJA;ErBYE,qMAAA;EqBVA,gCAAA;A3CqnJF;;A2CjnJE;EACE,kDAAA;A3ConJJ;A2CjnJM;EAJJ;IAKM,eAAA;E3ConJN;AACF;;A4C/pJA;EACE,aAAA;EACA,uBAAA;A5CkqJF;;A4C/pJA;EACE,OAAA;A5CkqJF;;A6CpqJA;EACE,aAAA;EACA,sBAAA;EAGA,eAAA;EACA,gBAAA;ElCQE,qBAAA;AX8pJJ;;A6C5pJA;EACE,WAAA;EACA,czC6DS;EyC5DT,mBAAA;A7C+pJF;AMtqJE;EuCWE,UAAA;EACA,czCuDO;EyCtDP,qBAAA;EACA,yBzC+CO;AJ+mJX;A6C3pJE;EACE,czCiDO;EyChDP,yBzC2CO;AJknJX;;A6CppJA;EACE,kBAAA;EACA,cAAA;EACA,wBAAA;EAGA,yBzC4BS;EyC3BT,yBAAA;A7CqpJF;A6CnpJE;ElC1BE,+BAAA;EACA,gCAAA;AXgrJJ;A6CnpJE;ElChBE,mCAAA;EACA,kCAAA;AXsqJJ;A6CnpJE;EAEE,czCmBO;EyClBP,oBAAA;EACA,yBzCaO;AJuoJX;A6ChpJE;EACE,UAAA;EACA,WpBhEO;EoBiEP,yBzCiCM;EyChCN,qBzCgCM;AJknJV;A6C/oJE;EACE,mBAAA;A7CipJJ;A6C/oJI;EACE,gBAAA;EACA,qBzC2NwB;AJs7I9B;;A6CnoJI;EACE,mBAAA;A7CsoJN;A6CnoJQ;ElC1BJ,iCAAA;EAZA,0BAAA;AX6qJJ;A6CloJQ;ElC3CJ,+BAAA;EAYA,4BAAA;AXqqJJ;A6CjoJQ;EACE,aAAA;A7CmoJV;A6ChoJQ;EACE,qBzC0LoB;EyCzLpB,oBAAA;A7CkoJV;A6ChoJU;EACE,iBAAA;EACA,sBzCqLkB;AJ68I9B;;Ae7rJI;E8BmCA;IACE,mBAAA;E7C8pJJ;E6C3pJM;IlC1BJ,iCAAA;IAZA,0BAAA;EXqsJF;E6C1pJM;IlC3CJ,+BAAA;IAYA,4BAAA;EX6rJF;E6CzpJM;IACE,aAAA;E7C2pJR;E6CxpJM;IACE,qBzC0LoB;IyCzLpB,oBAAA;E7C0pJR;E6CxpJQ;IACE,iBAAA;IACA,sBzCqLkB;EJq+I5B;AACF;AettJI;E8BmCA;IACE,mBAAA;E7CsrJJ;E6CnrJM;IlC1BJ,iCAAA;IAZA,0BAAA;EX6tJF;E6ClrJM;IlC3CJ,+BAAA;IAYA,4BAAA;EXqtJF;E6CjrJM;IACE,aAAA;E7CmrJR;E6ChrJM;IACE,qBzC0LoB;IyCzLpB,oBAAA;E7CkrJR;E6ChrJQ;IACE,iBAAA;IACA,sBzCqLkB;EJ6/I5B;AACF;Ae9uJI;E8BmCA;IACE,mBAAA;E7C8sJJ;E6C3sJM;IlC1BJ,iCAAA;IAZA,0BAAA;EXqvJF;E6C1sJM;IlC3CJ,+BAAA;IAYA,4BAAA;EX6uJF;E6CzsJM;IACE,aAAA;E7C2sJR;E6CxsJM;IACE,qBzC0LoB;IyCzLpB,oBAAA;E7C0sJR;E6CxsJQ;IACE,iBAAA;IACA,sBzCqLkB;EJqhJ5B;AACF;AetwJI;E8BmCA;IACE,mBAAA;E7CsuJJ;E6CnuJM;IlC1BJ,iCAAA;IAZA,0BAAA;EX6wJF;E6CluJM;IlC3CJ,+BAAA;IAYA,4BAAA;EXqwJF;E6CjuJM;IACE,aAAA;E7CmuJR;E6ChuJM;IACE,qBzC0LoB;IyCzLpB,oBAAA;E7CkuJR;E6ChuJQ;IACE,iBAAA;IACA,sBzCqLkB;EJ6iJ5B;AACF;A6CrtJA;ElCnHI,gBAAA;AX20JJ;A6CrtJE;EACE,qBAAA;A7CutJJ;A6CrtJI;EACE,sBAAA;A7CutJN;;A8Ch2JE;EACE,+BDoJsE;ECnJtE,0CDmJuC;A7CgtJ3C;AMx1JE;EwCPM,+BD+IkE;EC9IlE,qEAAA;A9Ck2JR;A8C/1JM;EACE,W1C8DG;E0C7DH,0CDyIkE;ECxIlE,sCDwIkE;A7CytJ1E;;A8C92JE;EACE,8BDoJsE;ECnJtE,4CDmJuC;A7C8tJ3C;AMt2JE;EwCPM,8BD+IkE;EC9IlE,qEAAA;A9Cg3JR;A8C72JM;EACE,W1C8DG;E0C7DH,yCDyIkE;ECxIlE,qCDwIkE;A7CuuJ1E;;A8C53JE;EACE,gCDoJsE;ECnJtE,6CDmJuC;A7C4uJ3C;AMp3JE;EwCPM,gCD+IkE;EC9IlE,oEAAA;A9C83JR;A8C33JM;EACE,W1C8DG;E0C7DH,2CDyIkE;ECxIlE,uCDwIkE;A7CqvJ1E;;A8C14JE;EACE,iCDoJsE;ECnJtE,6CDmJuC;A7C0vJ3C;AMl4JE;EwCPM,iCD+IkE;EC9IlE,qEAAA;A9C44JR;A8Cz4JM;EACE,W1C8DG;E0C7DH,4CDyIkE;ECxIlE,wCDwIkE;A7CmwJ1E;;A8Cx5JE;EACE,6BDoJsE;ECnJtE,yCDmJuC;A7CwwJ3C;AMh5JE;EwCPM,6BD+IkE;EC9IlE,kDAAA;A9C05JR;A8Cv5JM;EACE,W1C8DG;E0C7DH,wCDyIkE;ECxIlE,oCDwIkE;A7CixJ1E;;A8Ct6JE;EACE,+BDoJsE;ECnJtE,0CDmJuC;A7CsxJ3C;AM95JE;EwCPM,+BD+IkE;EC9IlE,kDAAA;A9Cw6JR;A8Cr6JM;EACE,W1C8DG;E0C7DH,0CDyIkE;ECxIlE,sCDwIkE;A7C+xJ1E;;A8Cp7JE;EACE,8BDoJsE;ECnJtE,4CDmJuC;A7CoyJ3C;AM56JE;EwCPM,8BD+IkE;EC9IlE,mEAAA;A9Cs7JR;A8Cn7JM;EACE,W1C8DG;E0C7DH,yCDyIkE;ECxIlE,qCDwIkE;A7C6yJ1E;;A8Cl8JE;EACE,iCDoJsE;ECnJtE,6CDmJuC;A7CkzJ3C;AM17JE;EwCPM,iCD+IkE;EC9IlE,qEAAA;A9Co8JR;A8Cj8JM;EACE,W1C8DG;E0C7DH,4CDyIkE;ECxIlE,wCDwIkE;A7C2zJ1E;;A+Cn9JA;EACE,YAAA;E1CmLI,kBAAA;E0CjLJ,gB3CgW4B;E2C/V5B,cAAA;EACA,W3CiFS;E2ChFT,yB3CuoCkC;E2CtoClC,YAAA;A/Cs9JF;AMj9JE;EyCDE,W3C2EO;E2C1EP,qBAAA;A/Cq9JJ;AMj9JE;EyCCI,aAAA;A/Cm9JN;;A+Cx8JA;EACE,UAAA;EACA,6BAAA;EACA,SAAA;A/C28JF;;A+Cr8JA;EACE,oBAAA;A/Cw8JF;;AgD9+JA;EAGE,iB5Ci8BkC;E4Ch8BlC,gB5Cg8BkC;EChxB9B,mBAAA;E2C7KJ,yB5CwES;E4CvET,4BAAA;EACA,oCAAA;EACA,gD5Cm8BkC;E4Cl8BlC,UAAA;ErCOE,sBAAA;AXw+JJ;AgD5+JE;EACE,sB5Cs7BgC;AJwjIpC;AgD3+JE;EACE,UAAA;AhD6+JJ;AgD1+JE;EACE,cAAA;EACA,UAAA;AhD4+JJ;AgDz+JE;EACE,aAAA;AhD2+JJ;;AgDv+JA;EACE,aAAA;EACA,mBAAA;EACA,wBAAA;EACA,c5C8CS;E4C7CT,gE5C26BkC;E4C16BlC,4BAAA;EACA,4CAAA;ErCZE,2CAAA;EACA,4CAAA;AXu/JJ;;AgDx+JA;EACE,gB5Cy5BkC;AJklIpC;;AiDjhKA;EAEE,gBAAA;AjDmhKF;AiDjhKE;EACE,kBAAA;EACA,gBAAA;AjDmhKJ;;AiD9gKA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a7C2tBkC;E6C1tBlC,aAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EAGA,UAAA;AjD+gKF;;AiDxgKA;EACE,kBAAA;EACA,WAAA;EACA,c7Co8BkC;E6Cl8BlC,oBAAA;AjD0gKF;AiDvgKE;E7B3BI,mC6B4BF;AjDygKJ;AoBjiKM;E6BuBJ;I7BtBM,gBAAA;EpBoiKN;AACF;AiD/gKE;EAEE,8B7Cy9BgC;AJujIpC;AiD9gKE;EACE,e7Cu9BgC;AJyjIpC;AiD5gKE;EACE,sBxBk6BgC;AzB4mIpC;;AiD1gKA;EACE,aAAA;EACA,6BAAA;AjD6gKF;AiD3gKE;EACE,8BAAA;EACA,gBAAA;AjD6gKJ;AiD1gKE;;EAEE,cAAA;AjD4gKJ;AiDzgKE;EACE,gBAAA;AjD2gKJ;;AiDvgKA;EACE,aAAA;EACA,mBAAA;EACA,6BAAA;AjD0gKF;AiDvgKE;EACE,cAAA;EACA,0BAAA;EACA,mBAAA;EACA,WAAA;AjDygKJ;AiDrgKE;EACE,sBAAA;EACA,uBAAA;EACA,YAAA;AjDugKJ;AiDrgKI;EACE,gBAAA;AjDugKN;AiDpgKI;EACE,aAAA;AjDsgKN;;AiDhgKA;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EAGA,oBAAA;EACA,yB7CpCS;E6CqCT,4BAAA;EACA,oCAAA;EtClGE,qBAAA;EsCsGF,UAAA;AjD+/JF;;AiD3/JA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,a7C+mBkC;E6C9mBlC,YAAA;EACA,aAAA;EACA,sB7C7CS;AJ2iKX;AiD3/JE;EAAS,UAAA;AjD8/JX;AiD7/JE;EAAS,Y7Ci3ByB;AJ+oIpC;;AiD3/JA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,kB7C+2BkC;E6C92BlC,gCAAA;EtCtHE,0CAAA;EACA,2CAAA;AXqnKJ;AiD7/JE;EACE,kB7C02BgC;E6Cx2BhC,8BAAA;AjD8/JJ;;AiDz/JA;EACE,gBAAA;EACA,gB7CyM4B;AJmzJ9B;;AiDv/JA;EACE,kBAAA;EAGA,cAAA;EACA,a7Cg0BkC;AJwrIpC;;AiDp/JA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,6BAAA;EtCzIE,8CAAA;EACA,6CAAA;AXioKJ;AiDn/JE;EACE,eAAA;AjDq/JJ;;AiDh/JA;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AjDm/JF;;Ae1nKI;EkC6IF;IACE,gB7CyzBgC;I6CxzBhC,oBAAA;EjDi/JF;EiD9+JA;IACE,+BAAA;EjDg/JF;EiD9+JE;IACE,gCAAA;EjDg/JJ;EiD5+JA;IACE,+BAAA;EjD8+JF;EiD5+JE;IACE,4BAAA;IACA,mBAAA;EjD8+JJ;EiDt+JA;IAAY,gB7CiyBsB;EJwsIlC;AACF;AejpKI;EkC2KF;;IAEE,gB7CyxBgC;EJgtIlC;AACF;AevpKI;EkCkLF;IAAY,iB7CmxBsB;EJstIlC;AACF;AkDvtKA;EACE,kBAAA;EACA,a9C+uBkC;E8C9uBlC,cAAA;EACA,S9Co5BkC;E+Cx5BlC,sC/CoV4B;E+ClV5B,kBAAA;EACA,gB/C8V4B;E+C7V5B,gB/CkW4B;E+CjW5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;E9CqKI,oBAAA;E6CzKJ,qBAAA;EACA,UAAA;AlDmuKF;AkDjuKE;EAAS,Y9Cw4ByB;AJ41IpC;AkDluKE;EACE,kBAAA;EACA,cAAA;EACA,a9Cw4BgC;E8Cv4BhC,c9Cw4BgC;AJ41IpC;AkDluKI;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;AlDouKN;;AkD/tKA;EACE,iBAAA;AlDkuKF;AkDhuKE;EACE,SAAA;AlDkuKJ;AkDhuKI;EACE,MAAA;EACA,6BAAA;EACA,yB9C6CK;AJqrKX;;AkD7tKA;EACE,iBAAA;AlDguKF;AkD9tKE;EACE,OAAA;EACA,a9C02BgC;E8Cz2BhC,c9Cw2BgC;AJw3IpC;AkD9tKI;EACE,QAAA;EACA,oCAAA;EACA,2B9C6BK;AJmsKX;;AkD3tKA;EACE,iBAAA;AlD8tKF;AkD5tKE;EACE,MAAA;AlD8tKJ;AkD5tKI;EACE,SAAA;EACA,6BAAA;EACA,4B9CeK;AJ+sKX;;AkDztKA;EACE,iBAAA;AlD4tKF;AkD1tKE;EACE,QAAA;EACA,a9C40BgC;E8C30BhC,c9C00BgC;AJk5IpC;AkD1tKI;EACE,OAAA;EACA,oCAAA;EACA,0B9CDK;AJ6tKX;;AkDvsKA;EACE,gB9CsyBkC;E8CryBlC,uBAAA;EACA,c9C/BS;E8CgCT,kBAAA;EACA,yB9C3BS;EOnEP,qBAAA;AXyyKJ;;AoD3zKA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,ahD6uBkC;EgD5uBlC,cAAA;EACA,gBhDs6BkC;E+C36BlC,sC/CoV4B;E+ClV5B,kBAAA;EACA,gB/C8V4B;E+C7V5B,gB/CkW4B;E+CjW5B,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;E9CqKI,oBAAA;E+CxKJ,qBAAA;EACA,yBhDwES;EgDvET,4BAAA;EACA,qEAAA;EzCGE,qBAAA;AXs0KJ;AoDr0KE;EACE,kBAAA;EACA,cAAA;EACA,WhDq6BgC;EgDp6BhC,chDq6BgC;EgDp6BhC,gBAAA;ApDu0KJ;AoDr0KI;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;ApDs0KN;;AoDj0KA;EACE,qBhDs5BkC;AJ86IpC;AoDl0KE;EACE,2BAAA;ApDo0KJ;AoDl0KI;EACE,SAAA;EACA,6BAAA;EACA,qEhDi5B8B;AJm7IpC;AoDj0KI;EACE,WhD0PwB;EgDzPxB,6BAAA;EACA,yBhDiCK;AJkyKX;;AoD9zKA;EACE,mBhDk4BkC;AJ+7IpC;AoD/zKE;EACE,yBAAA;EACA,ahD83BgC;EgD73BhC,YhD43BgC;EgD33BhC,gBAAA;ApDi0KJ;AoD/zKI;EACE,OAAA;EACA,oCAAA;EACA,uEhD03B8B;AJu8IpC;AoD9zKI;EACE,ShDmOwB;EgDlOxB,oCAAA;EACA,2BhDUK;AJszKX;;AoD3zKA;EACE,kBhD22BkC;AJm9IpC;AoD5zKE;EACE,wBAAA;ApD8zKJ;AoD5zKI;EACE,MAAA;EACA,oCAAA;EACA,wEhDs2B8B;AJw9IpC;AoD3zKI;EACE,QhD+MwB;EgD9MxB,oCAAA;EACA,4BhDVK;AJu0KX;AoDxzKE;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,cAAA;EACA,WhDk1BgC;EgDj1BhC,oBAAA;EACA,WAAA;EACA,yDAAA;ApD0zKJ;;AoDtzKA;EACE,oBhD20BkC;AJ8+IpC;AoDvzKE;EACE,0BAAA;EACA,ahDu0BgC;EgDt0BhC,YhDq0BgC;EgDp0BhC,gBAAA;ApDyzKJ;AoDvzKI;EACE,QAAA;EACA,oCAAA;EACA,sEhDm0B8B;AJs/IpC;AoDtzKI;EACE,UhD4KwB;EgD3KxB,oCAAA;EACA,0BhD7CK;AJq2KX;;AoDlyKA;EACE,uBAAA;EACA,gBAAA;E/C0BI,iBAAA;E+CxBJ,chD9ES;EgD+ET,kDhDqxBkC;EgDpxBlC,4EAAA;EzCnIE,0CAAA;EACA,2CAAA;AXy6KJ;AoDpyKE;EACE,aAAA;ApDsyKJ;;AoDlyKA;EACE,uBAAA;EACA,chD1FS;AJ+3KX;;AqDh8KA;EACE,kBAAA;ArDm8KF;;AqDh8KA;EACE,mBAAA;ArDm8KF;;AqDh8KA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;ArDm8KF;AsD19KE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AtD49KJ;;AqDp8KA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,2BAAA;EjClBI,sCiCmBJ;ArDu8KF;AoBt9KM;EiCQN;IjCPQ,gBAAA;EpBy9KN;AACF;;AqDz8KA;;;EAGE,cAAA;ArD48KF;;AqDz8KA;;EAEE,2BAAA;ArD48KF;;AqDz8KA;;EAEE,4BAAA;ArD48KF;;AqDn8KE;EACE,UAAA;EACA,4BAAA;EACA,eAAA;ArDs8KJ;AqDn8KE;;;EAGE,UAAA;EACA,UAAA;ArDq8KJ;AqDl8KE;;EAEE,UAAA;EACA,UAAA;EjC5DE,2BiC6DF;ArDo8KJ;AoB7/KM;EiCqDJ;;IjCpDM,gBAAA;EpBigLN;AACF;;AqDj8KA;;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UjDqgCmC;EiDpgCnC,UAAA;EACA,WjDtBS;EiDuBT,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,YjDggCmC;EgBtlC/B,8BiCuFJ;ArDm8KF;AoBthLM;EiCkEN;;IjCjEQ,gBAAA;EpB0hLN;AACF;AMhiLE;;;E+C2FE,WjD/BO;EiDgCP,qBAAA;EACA,UAAA;EACA,YjDy/BiC;AJi9IrC;;AqDv8KA;EACE,OAAA;ArD08KF;;AqDr8KA;EACE,QAAA;ArDw8KF;;AqDj8KA;;EAEE,qBAAA;EACA,WjDk/BmC;EiDj/BnC,YjDi/BmC;EiDh/BnC,mCAAA;ArDo8KF;;AqDl8KA;EACE,yDAAA;ArDq8KF;;AqDn8KA;EACE,yDAAA;ArDs8KF;;AqD77KA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;EAEA,iBjDw8BmC;EiDv8BnC,gBjDu8BmC;EiDt8BnC,gBAAA;ArD+7KF;AqD77KE;EACE,uBAAA;EACA,cAAA;EACA,WjDs8BiC;EiDr8BjC,WjDs8BiC;EiDr8BjC,iBjDu8BiC;EiDt8BjC,gBjDs8BiC;EiDr8BjC,mBAAA;EACA,eAAA;EACA,sBjD9FO;EiD+FP,4BAAA;EAEA,kCAAA;EACA,qCAAA;EACA,YAAA;EjC/JE,6BiCgKF;ArD87KJ;AoB1lLM;EiC6IJ;IjC5IM,gBAAA;EpB6lLN;AACF;AqDh8KE;EACE,UAAA;ArDk8KJ;;AqDz7KA;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,iBAAA;EACA,oBAAA;EACA,WjDzHS;EiD0HT,kBAAA;ArD47KF;;AuD9nLA;EACE;IAAK,yBAAA;EvDkoLL;AACF;AuDhoLA;EACE,qBAAA;EACA,WnDqnCsB;EmDpnCtB,YnDonCsB;EmDnnCtB,wB9BskCwB;E8BrkCxB,iCAAA;EACA,+BAAA;EAEA,kBAAA;EACA,+CAAA;AvDioLF;;AuD9nLA;EACE,WnD8mCwB;EmD7mCxB,YnD6mCwB;EmD5mCxB,mBnD8mCwB;AJmhJ1B;;AuD1nLA;EACE;IACE,mBAAA;EvD6nLF;EuD3nLA;IACE,UAAA;IACA,eAAA;EvD6nLF;AACF;AuD1nLA;EACE,qBAAA;EACA,WnDqlCsB;EmDplCtB,YnDolCsB;EmDnlCtB,wB9BsiCwB;E8BriCxB,8BAAA;EAEA,kBAAA;EACA,UAAA;EACA,6CAAA;AvD2nLF;;AuDxnLA;EACE,WnD8kCwB;EmD7kCxB,YnD6kCwB;AJ8iJ1B;;AuDvnLE;EACE;;IAEE,wBAAA;EvD0nLJ;AACF;AwDtrLA;EAAqB,mCAAA;AxDyrLrB;;AwDxrLA;EAAqB,8BAAA;AxD4rLrB;;AwD3rLA;EAAqB,iCAAA;AxD+rLrB;;AwD9rLA;EAAqB,iCAAA;AxDksLrB;;AwDjsLA;EAAqB,sCAAA;AxDqsLrB;;AwDpsLA;EAAqB,mCAAA;AxDwsLrB;;AyD1sLE;EACE,oCAAA;AzD6sLJ;;AMnsLE;;;EmDLI,8EAAA;AzD8sLN;;AyDptLE;EACE,oCAAA;AzDutLJ;;AM7sLE;;;EmDLI,6EAAA;AzDwtLN;;AyD9tLE;EACE,oCAAA;AzDiuLJ;;AMvtLE;;;EmDLI,+EAAA;AzDkuLN;;AyDxuLE;EACE,oCAAA;AzD2uLJ;;AMjuLE;;;EmDLI,6EAAA;AzD4uLN;;AyDlvLE;EACE,oCAAA;AzDqvLJ;;AM3uLE;;;EmDLI,wDAAA;AzDsvLN;;AyD5vLE;EACE,oCAAA;AzD+vLJ;;AMrvLE;;;EmDLI,wDAAA;AzDgwLN;;AyDtwLE;EACE,oCAAA;AzDywLJ;;AM/vLE;;;EmDLI,4EAAA;AzD0wLN;;AyDhxLE;EACE,oCAAA;AzDmxLJ;;AMzwLE;;;EmDLI,gFAAA;AzDoxLN;;A0DnxLA;EACE,iCAAA;A1DsxLF;;A0DnxLA;EACE,wCAAA;A1DsxLF;;A2DjyLA;EAAkB,oCAAA;A3DqyLlB;;A2DpyLA;EAAkB,wCAAA;A3DwyLlB;;A2DvyLA;EAAkB,0CAAA;A3D2yLlB;;A2D1yLA;EAAkB,2CAAA;A3D8yLlB;;A2D7yLA;EAAkB,yCAAA;A3DizLlB;;A2D/yLA;EAAmB,oBAAA;A3DmzLnB;;A2DlzLA;EAAmB,wBAAA;A3DszLnB;;A2DrzLA;EAAmB,0BAAA;A3DyzLnB;;A2DxzLA;EAAmB,2BAAA;A3D4zLnB;;A2D3zLA;EAAmB,yBAAA;A3D+zLnB;;A2D5zLE;EACE,gCAAA;A3D+zLJ;;A2Dh0LE;EACE,gCAAA;A3Dm0LJ;;A2Dp0LE;EACE,gCAAA;A3Du0LJ;;A2Dx0LE;EACE,gCAAA;A3D20LJ;;A2D50LE;EACE,gCAAA;A3D+0LJ;;A2Dh1LE;EACE,gCAAA;A3Dm1LJ;;A2Dp1LE;EACE,gCAAA;A3Du1LJ;;A2Dx1LE;EACE,gCAAA;A3D21LJ;;A2Dv1LA;EACE,6BAAA;A3D01LF;;A2Dn1LA;EACE,gCAAA;A3Ds1LF;;A2Dn1LA;EACE,gCAAA;A3Ds1LF;;A2Dn1LA;EACE,yCAAA;EACA,0CAAA;A3Ds1LF;;A2Dn1LA;EACE,0CAAA;EACA,6CAAA;A3Ds1LF;;A2Dn1LA;EACE,6CAAA;EACA,4CAAA;A3Ds1LF;;A2Dn1LA;EACE,yCAAA;EACA,4CAAA;A3Ds1LF;;A2Dn1LA;EACE,gCAAA;A3Ds1LF;;A2Dn1LA;EACE,6BAAA;A3Ds1LF;;A2Dn1LA;EACE,+BAAA;A3Ds1LF;;A2Dn1LA;EACE,2BAAA;A3Ds1LF;;AsD95LE;EACE,cAAA;EACA,WAAA;EACA,WAAA;AtDi6LJ;;A4D15LM;EAAwB,wBAAA;A5D85L9B;;A4D95LM;EAAwB,0BAAA;A5Dk6L9B;;A4Dl6LM;EAAwB,gCAAA;A5Ds6L9B;;A4Dt6LM;EAAwB,yBAAA;A5D06L9B;;A4D16LM;EAAwB,yBAAA;A5D86L9B;;A4D96LM;EAAwB,6BAAA;A5Dk7L9B;;A4Dl7LM;EAAwB,8BAAA;A5Ds7L9B;;A4Dt7LM;EAAwB,wBAAA;A5D07L9B;;A4D17LM;EAAwB,+BAAA;A5D87L9B;;Ae74LI;E6CjDE;IAAwB,wBAAA;E5Dm8L5B;E4Dn8LI;IAAwB,0BAAA;E5Ds8L5B;E4Dt8LI;IAAwB,gCAAA;E5Dy8L5B;E4Dz8LI;IAAwB,yBAAA;E5D48L5B;E4D58LI;IAAwB,yBAAA;E5D+8L5B;E4D/8LI;IAAwB,6BAAA;E5Dk9L5B;E4Dl9LI;IAAwB,8BAAA;E5Dq9L5B;E4Dr9LI;IAAwB,wBAAA;E5Dw9L5B;E4Dx9LI;IAAwB,+BAAA;E5D29L5B;AACF;Ae36LI;E6CjDE;IAAwB,wBAAA;E5Dg+L5B;E4Dh+LI;IAAwB,0BAAA;E5Dm+L5B;E4Dn+LI;IAAwB,gCAAA;E5Ds+L5B;E4Dt+LI;IAAwB,yBAAA;E5Dy+L5B;E4Dz+LI;IAAwB,yBAAA;E5D4+L5B;E4D5+LI;IAAwB,6BAAA;E5D++L5B;E4D/+LI;IAAwB,8BAAA;E5Dk/L5B;E4Dl/LI;IAAwB,wBAAA;E5Dq/L5B;E4Dr/LI;IAAwB,+BAAA;E5Dw/L5B;AACF;Aex8LI;E6CjDE;IAAwB,wBAAA;E5D6/L5B;E4D7/LI;IAAwB,0BAAA;E5DggM5B;E4DhgMI;IAAwB,gCAAA;E5DmgM5B;E4DngMI;IAAwB,yBAAA;E5DsgM5B;E4DtgMI;IAAwB,yBAAA;E5DygM5B;E4DzgMI;IAAwB,6BAAA;E5D4gM5B;E4D5gMI;IAAwB,8BAAA;E5D+gM5B;E4D/gMI;IAAwB,wBAAA;E5DkhM5B;E4DlhMI;IAAwB,+BAAA;E5DqhM5B;AACF;Aer+LI;E6CjDE;IAAwB,wBAAA;E5D0hM5B;E4D1hMI;IAAwB,0BAAA;E5D6hM5B;E4D7hMI;IAAwB,gCAAA;E5DgiM5B;E4DhiMI;IAAwB,yBAAA;E5DmiM5B;E4DniMI;IAAwB,yBAAA;E5DsiM5B;E4DtiMI;IAAwB,6BAAA;E5DyiM5B;E4DziMI;IAAwB,8BAAA;E5D4iM5B;E4D5iMI;IAAwB,wBAAA;E5D+iM5B;E4D/iMI;IAAwB,+BAAA;E5DkjM5B;AACF;A4DziMA;EAEI;IAAqB,wBAAA;E5D2iMvB;E4D3iME;IAAqB,0BAAA;E5D8iMvB;E4D9iME;IAAqB,gCAAA;E5DijMvB;E4DjjME;IAAqB,yBAAA;E5DojMvB;E4DpjME;IAAqB,yBAAA;E5DujMvB;E4DvjME;IAAqB,6BAAA;E5D0jMvB;E4D1jME;IAAqB,8BAAA;E5D6jMvB;E4D7jME;IAAqB,wBAAA;E5DgkMvB;E4DhkME;IAAqB,+BAAA;E5DmkMvB;AACF;A6DzlMA;EACE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,UAAA;EACA,gBAAA;A7D2lMF;A6DzlME;EACE,cAAA;EACA,WAAA;A7D2lMJ;A6DxlME;;;;;EAKE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;A7D0lMJ;;A6DjlMI;EACE,yBAAA;A7DolMN;;A6DrlMI;EACE,mBAAA;A7DwlMN;;A6DzlMI;EACE,gBAAA;A7D4lMN;;A6D7lMI;EACE,iBAAA;A7DgmMN;;A6DjmMI;EACE,yBAAA;A7DomMN;;A6DrmMI;EACE,mBAAA;A7DwmMN;;A6DzmMI;EACE,gBAAA;A7D4mMN;;A6D7mMI;EACE,iBAAA;A7DgnMN;;A8DzoMI;EAAgC,8BAAA;A9D6oMpC;;A8D5oMI;EAAgC,iCAAA;A9DgpMpC;;A8D/oMI;EAAgC,sCAAA;A9DmpMpC;;A8DlpMI;EAAgC,yCAAA;A9DspMpC;;A8DppMI;EAA8B,0BAAA;A9DwpMlC;;A8DvpMI;EAA8B,4BAAA;A9D2pMlC;;A8D1pMI;EAA8B,kCAAA;A9D8pMlC;;A8D7pMI;EAA8B,yBAAA;A9DiqMlC;;A8DhqMI;EAA8B,uBAAA;A9DoqMlC;;A8DnqMI;EAA8B,uBAAA;A9DuqMlC;;A8DtqMI;EAA8B,yBAAA;A9D0qMlC;;A8DzqMI;EAA8B,yBAAA;A9D6qMlC;;A8D3qMI;EAAoC,sCAAA;A9D+qMxC;;A8D9qMI;EAAoC,oCAAA;A9DkrMxC;;A8DjrMI;EAAoC,kCAAA;A9DqrMxC;;A8DprMI;EAAoC,yCAAA;A9DwrMxC;;A8DvrMI;EAAoC,wCAAA;A9D2rMxC;;A8DzrMI;EAAiC,kCAAA;A9D6rMrC;;A8D5rMI;EAAiC,gCAAA;A9DgsMrC;;A8D/rMI;EAAiC,8BAAA;A9DmsMrC;;A8DlsMI;EAAiC,gCAAA;A9DssMrC;;A8DrsMI;EAAiC,+BAAA;A9DysMrC;;A8DvsMI;EAAkC,oCAAA;A9D2sMtC;;A8D1sMI;EAAkC,kCAAA;A9D8sMtC;;A8D7sMI;EAAkC,gCAAA;A9DitMtC;;A8DhtMI;EAAkC,uCAAA;A9DotMtC;;A8DntMI;EAAkC,sCAAA;A9DutMtC;;A8DttMI;EAAkC,iCAAA;A9D0tMtC;;A8DxtMI;EAAgC,2BAAA;A9D4tMpC;;A8D3tMI;EAAgC,iCAAA;A9D+tMpC;;A8D9tMI;EAAgC,+BAAA;A9DkuMpC;;A8DjuMI;EAAgC,6BAAA;A9DquMpC;;A8DpuMI;EAAgC,+BAAA;A9DwuMpC;;A8DvuMI;EAAgC,8BAAA;A9D2uMpC;;Ae/tMI;E+ClDA;IAAgC,8BAAA;E9DsxMlC;E8DrxME;IAAgC,iCAAA;E9DwxMlC;E8DvxME;IAAgC,sCAAA;E9D0xMlC;E8DzxME;IAAgC,yCAAA;E9D4xMlC;E8D1xME;IAA8B,0BAAA;E9D6xMhC;E8D5xME;IAA8B,4BAAA;E9D+xMhC;E8D9xME;IAA8B,kCAAA;E9DiyMhC;E8DhyME;IAA8B,yBAAA;E9DmyMhC;E8DlyME;IAA8B,uBAAA;E9DqyMhC;E8DpyME;IAA8B,uBAAA;E9DuyMhC;E8DtyME;IAA8B,yBAAA;E9DyyMhC;E8DxyME;IAA8B,yBAAA;E9D2yMhC;E8DzyME;IAAoC,sCAAA;E9D4yMtC;E8D3yME;IAAoC,oCAAA;E9D8yMtC;E8D7yME;IAAoC,kCAAA;E9DgzMtC;E8D/yME;IAAoC,yCAAA;E9DkzMtC;E8DjzME;IAAoC,wCAAA;E9DozMtC;E8DlzME;IAAiC,kCAAA;E9DqzMnC;E8DpzME;IAAiC,gCAAA;E9DuzMnC;E8DtzME;IAAiC,8BAAA;E9DyzMnC;E8DxzME;IAAiC,gCAAA;E9D2zMnC;E8D1zME;IAAiC,+BAAA;E9D6zMnC;E8D3zME;IAAkC,oCAAA;E9D8zMpC;E8D7zME;IAAkC,kCAAA;E9Dg0MpC;E8D/zME;IAAkC,gCAAA;E9Dk0MpC;E8Dj0ME;IAAkC,uCAAA;E9Do0MpC;E8Dn0ME;IAAkC,sCAAA;E9Ds0MpC;E8Dr0ME;IAAkC,iCAAA;E9Dw0MpC;E8Dt0ME;IAAgC,2BAAA;E9Dy0MlC;E8Dx0ME;IAAgC,iCAAA;E9D20MlC;E8D10ME;IAAgC,+BAAA;E9D60MlC;E8D50ME;IAAgC,6BAAA;E9D+0MlC;E8D90ME;IAAgC,+BAAA;E9Di1MlC;E8Dh1ME;IAAgC,8BAAA;E9Dm1MlC;AACF;Aex0MI;E+ClDA;IAAgC,8BAAA;E9D83MlC;E8D73ME;IAAgC,iCAAA;E9Dg4MlC;E8D/3ME;IAAgC,sCAAA;E9Dk4MlC;E8Dj4ME;IAAgC,yCAAA;E9Do4MlC;E8Dl4ME;IAA8B,0BAAA;E9Dq4MhC;E8Dp4ME;IAA8B,4BAAA;E9Du4MhC;E8Dt4ME;IAA8B,kCAAA;E9Dy4MhC;E8Dx4ME;IAA8B,yBAAA;E9D24MhC;E8D14ME;IAA8B,uBAAA;E9D64MhC;E8D54ME;IAA8B,uBAAA;E9D+4MhC;E8D94ME;IAA8B,yBAAA;E9Di5MhC;E8Dh5ME;IAA8B,yBAAA;E9Dm5MhC;E8Dj5ME;IAAoC,sCAAA;E9Do5MtC;E8Dn5ME;IAAoC,oCAAA;E9Ds5MtC;E8Dr5ME;IAAoC,kCAAA;E9Dw5MtC;E8Dv5ME;IAAoC,yCAAA;E9D05MtC;E8Dz5ME;IAAoC,wCAAA;E9D45MtC;E8D15ME;IAAiC,kCAAA;E9D65MnC;E8D55ME;IAAiC,gCAAA;E9D+5MnC;E8D95ME;IAAiC,8BAAA;E9Di6MnC;E8Dh6ME;IAAiC,gCAAA;E9Dm6MnC;E8Dl6ME;IAAiC,+BAAA;E9Dq6MnC;E8Dn6ME;IAAkC,oCAAA;E9Ds6MpC;E8Dr6ME;IAAkC,kCAAA;E9Dw6MpC;E8Dv6ME;IAAkC,gCAAA;E9D06MpC;E8Dz6ME;IAAkC,uCAAA;E9D46MpC;E8D36ME;IAAkC,sCAAA;E9D86MpC;E8D76ME;IAAkC,iCAAA;E9Dg7MpC;E8D96ME;IAAgC,2BAAA;E9Di7MlC;E8Dh7ME;IAAgC,iCAAA;E9Dm7MlC;E8Dl7ME;IAAgC,+BAAA;E9Dq7MlC;E8Dp7ME;IAAgC,6BAAA;E9Du7MlC;E8Dt7ME;IAAgC,+BAAA;E9Dy7MlC;E8Dx7ME;IAAgC,8BAAA;E9D27MlC;AACF;Aeh7MI;E+ClDA;IAAgC,8BAAA;E9Ds+MlC;E8Dr+ME;IAAgC,iCAAA;E9Dw+MlC;E8Dv+ME;IAAgC,sCAAA;E9D0+MlC;E8Dz+ME;IAAgC,yCAAA;E9D4+MlC;E8D1+ME;IAA8B,0BAAA;E9D6+MhC;E8D5+ME;IAA8B,4BAAA;E9D++MhC;E8D9+ME;IAA8B,kCAAA;E9Di/MhC;E8Dh/ME;IAA8B,yBAAA;E9Dm/MhC;E8Dl/ME;IAA8B,uBAAA;E9Dq/MhC;E8Dp/ME;IAA8B,uBAAA;E9Du/MhC;E8Dt/ME;IAA8B,yBAAA;E9Dy/MhC;E8Dx/ME;IAA8B,yBAAA;E9D2/MhC;E8Dz/ME;IAAoC,sCAAA;E9D4/MtC;E8D3/ME;IAAoC,oCAAA;E9D8/MtC;E8D7/ME;IAAoC,kCAAA;E9DggNtC;E8D//ME;IAAoC,yCAAA;E9DkgNtC;E8DjgNE;IAAoC,wCAAA;E9DogNtC;E8DlgNE;IAAiC,kCAAA;E9DqgNnC;E8DpgNE;IAAiC,gCAAA;E9DugNnC;E8DtgNE;IAAiC,8BAAA;E9DygNnC;E8DxgNE;IAAiC,gCAAA;E9D2gNnC;E8D1gNE;IAAiC,+BAAA;E9D6gNnC;E8D3gNE;IAAkC,oCAAA;E9D8gNpC;E8D7gNE;IAAkC,kCAAA;E9DghNpC;E8D/gNE;IAAkC,gCAAA;E9DkhNpC;E8DjhNE;IAAkC,uCAAA;E9DohNpC;E8DnhNE;IAAkC,sCAAA;E9DshNpC;E8DrhNE;IAAkC,iCAAA;E9DwhNpC;E8DthNE;IAAgC,2BAAA;E9DyhNlC;E8DxhNE;IAAgC,iCAAA;E9D2hNlC;E8D1hNE;IAAgC,+BAAA;E9D6hNlC;E8D5hNE;IAAgC,6BAAA;E9D+hNlC;E8D9hNE;IAAgC,+BAAA;E9DiiNlC;E8DhiNE;IAAgC,8BAAA;E9DmiNlC;AACF;AexhNI;E+ClDA;IAAgC,8BAAA;E9D8kNlC;E8D7kNE;IAAgC,iCAAA;E9DglNlC;E8D/kNE;IAAgC,sCAAA;E9DklNlC;E8DjlNE;IAAgC,yCAAA;E9DolNlC;E8DllNE;IAA8B,0BAAA;E9DqlNhC;E8DplNE;IAA8B,4BAAA;E9DulNhC;E8DtlNE;IAA8B,kCAAA;E9DylNhC;E8DxlNE;IAA8B,yBAAA;E9D2lNhC;E8D1lNE;IAA8B,uBAAA;E9D6lNhC;E8D5lNE;IAA8B,uBAAA;E9D+lNhC;E8D9lNE;IAA8B,yBAAA;E9DimNhC;E8DhmNE;IAA8B,yBAAA;E9DmmNhC;E8DjmNE;IAAoC,sCAAA;E9DomNtC;E8DnmNE;IAAoC,oCAAA;E9DsmNtC;E8DrmNE;IAAoC,kCAAA;E9DwmNtC;E8DvmNE;IAAoC,yCAAA;E9D0mNtC;E8DzmNE;IAAoC,wCAAA;E9D4mNtC;E8D1mNE;IAAiC,kCAAA;E9D6mNnC;E8D5mNE;IAAiC,gCAAA;E9D+mNnC;E8D9mNE;IAAiC,8BAAA;E9DinNnC;E8DhnNE;IAAiC,gCAAA;E9DmnNnC;E8DlnNE;IAAiC,+BAAA;E9DqnNnC;E8DnnNE;IAAkC,oCAAA;E9DsnNpC;E8DrnNE;IAAkC,kCAAA;E9DwnNpC;E8DvnNE;IAAkC,gCAAA;E9D0nNpC;E8DznNE;IAAkC,uCAAA;E9D4nNpC;E8D3nNE;IAAkC,sCAAA;E9D8nNpC;E8D7nNE;IAAkC,iCAAA;E9DgoNpC;E8D9nNE;IAAgC,2BAAA;E9DioNlC;E8DhoNE;IAAgC,iCAAA;E9DmoNlC;E8DloNE;IAAgC,+BAAA;E9DqoNlC;E8DpoNE;IAAgC,6BAAA;E9DuoNlC;E8DtoNE;IAAgC,+BAAA;E9DyoNlC;E8DxoNE;IAAgC,8BAAA;E9D2oNlC;AACF;A+DtrNI;EAAwB,sBAAA;A/DyrN5B;;A+DxrNI;EAAwB,uBAAA;A/D4rN5B;;A+D3rNI;EAAwB,sBAAA;A/D+rN5B;;Ae3oNI;EgDtDA;IAAwB,sBAAA;E/DssN1B;E+DrsNE;IAAwB,uBAAA;E/DwsN1B;E+DvsNE;IAAwB,sBAAA;E/D0sN1B;AACF;AevpNI;EgDtDA;IAAwB,sBAAA;E/DitN1B;E+DhtNE;IAAwB,uBAAA;E/DmtN1B;E+DltNE;IAAwB,sBAAA;E/DqtN1B;AACF;AelqNI;EgDtDA;IAAwB,sBAAA;E/D4tN1B;E+D3tNE;IAAwB,uBAAA;E/D8tN1B;E+D7tNE;IAAwB,sBAAA;E/DguN1B;AACF;Ae7qNI;EgDtDA;IAAwB,sBAAA;E/DuuN1B;E+DtuNE;IAAwB,uBAAA;E/DyuN1B;E+DxuNE;IAAwB,sBAAA;E/D2uN1B;AACF;AgEjvNE;EAAyB,2BAAA;AhEovN3B;;AgEpvNE;EAAyB,4BAAA;AhEwvN3B;;AgExvNE;EAAyB,4BAAA;AhE4vN3B;;AiE5vNE;EAAsB,yBAAA;AjEgwNxB;;AiEhwNE;EAAsB,2BAAA;AjEowNxB;;AkEnwNE;EAAyB,2BAAA;AlEuwN3B;;AkEvwNE;EAAyB,6BAAA;AlE2wN3B;;AkE3wNE;EAAyB,6BAAA;AlE+wN3B;;AkE/wNE;EAAyB,0BAAA;AlEmxN3B;;AkEnxNE;EAAyB,2BAAA;AlEuxN3B;;AkElxNA;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,a9DguBkC;AJqjMpC;;AkElxNA;EACE,eAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,a9DwtBkC;AJ6jMpC;;AkEjxNE;EADF;IAEI,gBAAA;IACA,MAAA;IACA,a9DgtBgC;EJqkMlC;AACF;;AmE/yNA;ECEE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;ApEizNF;;AoEvyNE;EAEE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,UAAA;EACA,mBAAA;ApEyyNJ;;AqEt0NA;EAAa,mEAAA;ArE00Nb;;AqEz0NA;EAAU,wDAAA;ArE60NV;;AqE50NA;EAAa,uDAAA;ArEg1Nb;;AqE/0NA;EAAe,2BAAA;ArEm1Nf;;AsEl1NI;EAAuB,qBAAA;AtEs1N3B;;AsEt1NI;EAAuB,qBAAA;AtE01N3B;;AsE11NI;EAAuB,qBAAA;AtE81N3B;;AsE91NI;EAAuB,sBAAA;AtEk2N3B;;AsEl2NI;EAAuB,sBAAA;AtEs2N3B;;AsEt2NI;EAAuB,sBAAA;AtE02N3B;;AsE12NI;EAAuB,sBAAA;AtE82N3B;;AsE92NI;EAAuB,sBAAA;AtEk3N3B;;AsEl3NI;EAAuB,uBAAA;AtEs3N3B;;AsEt3NI;EAAuB,uBAAA;AtE03N3B;;AsEt3NA;EAAU,0BAAA;AtE03NV;;AsEz3NA;EAAU,2BAAA;AtE63NV;;AsEz3NA;EAAc,2BAAA;AtE63Nd;;AsE53NA;EAAc,4BAAA;AtEg4Nd;;AsE93NA;EAAU,uBAAA;AtEk4NV;;AsEj4NA;EAAU,wBAAA;AtEq4NV;;AuE94NQ;EAAgC,oBAAA;AvEk5NxC;;AuEj5NQ;;EAEE,wBAAA;AvEo5NV;;AuEl5NQ;;EAEE,0BAAA;AvEq5NV;;AuEn5NQ;;EAEE,2BAAA;AvEs5NV;;AuEp5NQ;;EAEE,yBAAA;AvEu5NV;;AuEt6NQ;EAAgC,0BAAA;AvE06NxC;;AuEz6NQ;;EAEE,8BAAA;AvE46NV;;AuE16NQ;;EAEE,gCAAA;AvE66NV;;AuE36NQ;;EAEE,iCAAA;AvE86NV;;AuE56NQ;;EAEE,+BAAA;AvE+6NV;;AuE97NQ;EAAgC,yBAAA;AvEk8NxC;;AuEj8NQ;;EAEE,6BAAA;AvEo8NV;;AuEl8NQ;;EAEE,+BAAA;AvEq8NV;;AuEn8NQ;;EAEE,gCAAA;AvEs8NV;;AuEp8NQ;;EAEE,8BAAA;AvEu8NV;;AuEt9NQ;EAAgC,uBAAA;AvE09NxC;;AuEz9NQ;;EAEE,2BAAA;AvE49NV;;AuE19NQ;;EAEE,6BAAA;AvE69NV;;AuE39NQ;;EAEE,8BAAA;AvE89NV;;AuE59NQ;;EAEE,4BAAA;AvE+9NV;;AuE9+NQ;EAAgC,yBAAA;AvEk/NxC;;AuEj/NQ;;EAEE,6BAAA;AvEo/NV;;AuEl/NQ;;EAEE,+BAAA;AvEq/NV;;AuEn/NQ;;EAEE,gCAAA;AvEs/NV;;AuEp/NQ;;EAEE,8BAAA;AvEu/NV;;AuEtgOQ;EAAgC,uBAAA;AvE0gOxC;;AuEzgOQ;;EAEE,2BAAA;AvE4gOV;;AuE1gOQ;;EAEE,6BAAA;AvE6gOV;;AuE3gOQ;;EAEE,8BAAA;AvE8gOV;;AuE5gOQ;;EAEE,4BAAA;AvE+gOV;;AuE9hOQ;EAAgC,qBAAA;AvEkiOxC;;AuEjiOQ;;EAEE,yBAAA;AvEoiOV;;AuEliOQ;;EAEE,2BAAA;AvEqiOV;;AuEniOQ;;EAEE,4BAAA;AvEsiOV;;AuEpiOQ;;EAEE,0BAAA;AvEuiOV;;AuEtjOQ;EAAgC,2BAAA;AvE0jOxC;;AuEzjOQ;;EAEE,+BAAA;AvE4jOV;;AuE1jOQ;;EAEE,iCAAA;AvE6jOV;;AuE3jOQ;;EAEE,kCAAA;AvE8jOV;;AuE5jOQ;;EAEE,gCAAA;AvE+jOV;;AuE9kOQ;EAAgC,0BAAA;AvEklOxC;;AuEjlOQ;;EAEE,8BAAA;AvEolOV;;AuEllOQ;;EAEE,gCAAA;AvEqlOV;;AuEnlOQ;;EAEE,iCAAA;AvEslOV;;AuEplOQ;;EAEE,+BAAA;AvEulOV;;AuEtmOQ;EAAgC,wBAAA;AvE0mOxC;;AuEzmOQ;;EAEE,4BAAA;AvE4mOV;;AuE1mOQ;;EAEE,8BAAA;AvE6mOV;;AuE3mOQ;;EAEE,+BAAA;AvE8mOV;;AuE5mOQ;;EAEE,6BAAA;AvE+mOV;;AuE9nOQ;EAAgC,0BAAA;AvEkoOxC;;AuEjoOQ;;EAEE,8BAAA;AvEooOV;;AuEloOQ;;EAEE,gCAAA;AvEqoOV;;AuEnoOQ;;EAEE,iCAAA;AvEsoOV;;AuEpoOQ;;EAEE,+BAAA;AvEuoOV;;AuEtpOQ;EAAgC,wBAAA;AvE0pOxC;;AuEzpOQ;;EAEE,4BAAA;AvE4pOV;;AuE1pOQ;;EAEE,8BAAA;AvE6pOV;;AuE3pOQ;;EAEE,+BAAA;AvE8pOV;;AuE5pOQ;;EAEE,6BAAA;AvE+pOV;;AuEvpOQ;EAAwB,2BAAA;AvE2pOhC;;AuE1pOQ;;EAEE,+BAAA;AvE6pOV;;AuE3pOQ;;EAEE,iCAAA;AvE8pOV;;AuE5pOQ;;EAEE,kCAAA;AvE+pOV;;AuE7pOQ;;EAEE,gCAAA;AvEgqOV;;AuE/qOQ;EAAwB,0BAAA;AvEmrOhC;;AuElrOQ;;EAEE,8BAAA;AvEqrOV;;AuEnrOQ;;EAEE,gCAAA;AvEsrOV;;AuEprOQ;;EAEE,iCAAA;AvEurOV;;AuErrOQ;;EAEE,+BAAA;AvEwrOV;;AuEvsOQ;EAAwB,wBAAA;AvE2sOhC;;AuE1sOQ;;EAEE,4BAAA;AvE6sOV;;AuE3sOQ;;EAEE,8BAAA;AvE8sOV;;AuE5sOQ;;EAEE,+BAAA;AvE+sOV;;AuE7sOQ;;EAEE,6BAAA;AvEgtOV;;AuE/tOQ;EAAwB,0BAAA;AvEmuOhC;;AuEluOQ;;EAEE,8BAAA;AvEquOV;;AuEnuOQ;;EAEE,gCAAA;AvEsuOV;;AuEpuOQ;;EAEE,iCAAA;AvEuuOV;;AuEruOQ;;EAEE,+BAAA;AvEwuOV;;AuEvvOQ;EAAwB,wBAAA;AvE2vOhC;;AuE1vOQ;;EAEE,4BAAA;AvE6vOV;;AuE3vOQ;;EAEE,8BAAA;AvE8vOV;;AuE5vOQ;;EAEE,+BAAA;AvE+vOV;;AuE7vOQ;;EAEE,6BAAA;AvEgwOV;;AuE1vOI;EAAmB,uBAAA;AvE8vOvB;;AuE7vOI;;EAEE,2BAAA;AvEgwON;;AuE9vOI;;EAEE,6BAAA;AvEiwON;;AuE/vOI;;EAEE,8BAAA;AvEkwON;;AuEhwOI;;EAEE,4BAAA;AvEmwON;;Ae5wOI;EwDlDI;IAAgC,oBAAA;EvEm0OtC;EuEl0OM;;IAEE,wBAAA;EvEo0OR;EuEl0OM;;IAEE,0BAAA;EvEo0OR;EuEl0OM;;IAEE,2BAAA;EvEo0OR;EuEl0OM;;IAEE,yBAAA;EvEo0OR;EuEn1OM;IAAgC,0BAAA;EvEs1OtC;EuEr1OM;;IAEE,8BAAA;EvEu1OR;EuEr1OM;;IAEE,gCAAA;EvEu1OR;EuEr1OM;;IAEE,iCAAA;EvEu1OR;EuEr1OM;;IAEE,+BAAA;EvEu1OR;EuEt2OM;IAAgC,yBAAA;EvEy2OtC;EuEx2OM;;IAEE,6BAAA;EvE02OR;EuEx2OM;;IAEE,+BAAA;EvE02OR;EuEx2OM;;IAEE,gCAAA;EvE02OR;EuEx2OM;;IAEE,8BAAA;EvE02OR;EuEz3OM;IAAgC,uBAAA;EvE43OtC;EuE33OM;;IAEE,2BAAA;EvE63OR;EuE33OM;;IAEE,6BAAA;EvE63OR;EuE33OM;;IAEE,8BAAA;EvE63OR;EuE33OM;;IAEE,4BAAA;EvE63OR;EuE54OM;IAAgC,yBAAA;EvE+4OtC;EuE94OM;;IAEE,6BAAA;EvEg5OR;EuE94OM;;IAEE,+BAAA;EvEg5OR;EuE94OM;;IAEE,gCAAA;EvEg5OR;EuE94OM;;IAEE,8BAAA;EvEg5OR;EuE/5OM;IAAgC,uBAAA;EvEk6OtC;EuEj6OM;;IAEE,2BAAA;EvEm6OR;EuEj6OM;;IAEE,6BAAA;EvEm6OR;EuEj6OM;;IAEE,8BAAA;EvEm6OR;EuEj6OM;;IAEE,4BAAA;EvEm6OR;EuEl7OM;IAAgC,qBAAA;EvEq7OtC;EuEp7OM;;IAEE,yBAAA;EvEs7OR;EuEp7OM;;IAEE,2BAAA;EvEs7OR;EuEp7OM;;IAEE,4BAAA;EvEs7OR;EuEp7OM;;IAEE,0BAAA;EvEs7OR;EuEr8OM;IAAgC,2BAAA;EvEw8OtC;EuEv8OM;;IAEE,+BAAA;EvEy8OR;EuEv8OM;;IAEE,iCAAA;EvEy8OR;EuEv8OM;;IAEE,kCAAA;EvEy8OR;EuEv8OM;;IAEE,gCAAA;EvEy8OR;EuEx9OM;IAAgC,0BAAA;EvE29OtC;EuE19OM;;IAEE,8BAAA;EvE49OR;EuE19OM;;IAEE,gCAAA;EvE49OR;EuE19OM;;IAEE,iCAAA;EvE49OR;EuE19OM;;IAEE,+BAAA;EvE49OR;EuE3+OM;IAAgC,wBAAA;EvE8+OtC;EuE7+OM;;IAEE,4BAAA;EvE++OR;EuE7+OM;;IAEE,8BAAA;EvE++OR;EuE7+OM;;IAEE,+BAAA;EvE++OR;EuE7+OM;;IAEE,6BAAA;EvE++OR;EuE9/OM;IAAgC,0BAAA;EvEigPtC;EuEhgPM;;IAEE,8BAAA;EvEkgPR;EuEhgPM;;IAEE,gCAAA;EvEkgPR;EuEhgPM;;IAEE,iCAAA;EvEkgPR;EuEhgPM;;IAEE,+BAAA;EvEkgPR;EuEjhPM;IAAgC,wBAAA;EvEohPtC;EuEnhPM;;IAEE,4BAAA;EvEqhPR;EuEnhPM;;IAEE,8BAAA;EvEqhPR;EuEnhPM;;IAEE,+BAAA;EvEqhPR;EuEnhPM;;IAEE,6BAAA;EvEqhPR;EuE7gPM;IAAwB,2BAAA;EvEghP9B;EuE/gPM;;IAEE,+BAAA;EvEihPR;EuE/gPM;;IAEE,iCAAA;EvEihPR;EuE/gPM;;IAEE,kCAAA;EvEihPR;EuE/gPM;;IAEE,gCAAA;EvEihPR;EuEhiPM;IAAwB,0BAAA;EvEmiP9B;EuEliPM;;IAEE,8BAAA;EvEoiPR;EuEliPM;;IAEE,gCAAA;EvEoiPR;EuEliPM;;IAEE,iCAAA;EvEoiPR;EuEliPM;;IAEE,+BAAA;EvEoiPR;EuEnjPM;IAAwB,wBAAA;EvEsjP9B;EuErjPM;;IAEE,4BAAA;EvEujPR;EuErjPM;;IAEE,8BAAA;EvEujPR;EuErjPM;;IAEE,+BAAA;EvEujPR;EuErjPM;;IAEE,6BAAA;EvEujPR;EuEtkPM;IAAwB,0BAAA;EvEykP9B;EuExkPM;;IAEE,8BAAA;EvE0kPR;EuExkPM;;IAEE,gCAAA;EvE0kPR;EuExkPM;;IAEE,iCAAA;EvE0kPR;EuExkPM;;IAEE,+BAAA;EvE0kPR;EuEzlPM;IAAwB,wBAAA;EvE4lP9B;EuE3lPM;;IAEE,4BAAA;EvE6lPR;EuE3lPM;;IAEE,8BAAA;EvE6lPR;EuE3lPM;;IAEE,+BAAA;EvE6lPR;EuE3lPM;;IAEE,6BAAA;EvE6lPR;EuEvlPE;IAAmB,uBAAA;EvE0lPrB;EuEzlPE;;IAEE,2BAAA;EvE2lPJ;EuEzlPE;;IAEE,6BAAA;EvE2lPJ;EuEzlPE;;IAEE,8BAAA;EvE2lPJ;EuEzlPE;;IAEE,4BAAA;EvE2lPJ;AACF;AermPI;EwDlDI;IAAgC,oBAAA;EvE2pPtC;EuE1pPM;;IAEE,wBAAA;EvE4pPR;EuE1pPM;;IAEE,0BAAA;EvE4pPR;EuE1pPM;;IAEE,2BAAA;EvE4pPR;EuE1pPM;;IAEE,yBAAA;EvE4pPR;EuE3qPM;IAAgC,0BAAA;EvE8qPtC;EuE7qPM;;IAEE,8BAAA;EvE+qPR;EuE7qPM;;IAEE,gCAAA;EvE+qPR;EuE7qPM;;IAEE,iCAAA;EvE+qPR;EuE7qPM;;IAEE,+BAAA;EvE+qPR;EuE9rPM;IAAgC,yBAAA;EvEisPtC;EuEhsPM;;IAEE,6BAAA;EvEksPR;EuEhsPM;;IAEE,+BAAA;EvEksPR;EuEhsPM;;IAEE,gCAAA;EvEksPR;EuEhsPM;;IAEE,8BAAA;EvEksPR;EuEjtPM;IAAgC,uBAAA;EvEotPtC;EuEntPM;;IAEE,2BAAA;EvEqtPR;EuEntPM;;IAEE,6BAAA;EvEqtPR;EuEntPM;;IAEE,8BAAA;EvEqtPR;EuEntPM;;IAEE,4BAAA;EvEqtPR;EuEpuPM;IAAgC,yBAAA;EvEuuPtC;EuEtuPM;;IAEE,6BAAA;EvEwuPR;EuEtuPM;;IAEE,+BAAA;EvEwuPR;EuEtuPM;;IAEE,gCAAA;EvEwuPR;EuEtuPM;;IAEE,8BAAA;EvEwuPR;EuEvvPM;IAAgC,uBAAA;EvE0vPtC;EuEzvPM;;IAEE,2BAAA;EvE2vPR;EuEzvPM;;IAEE,6BAAA;EvE2vPR;EuEzvPM;;IAEE,8BAAA;EvE2vPR;EuEzvPM;;IAEE,4BAAA;EvE2vPR;EuE1wPM;IAAgC,qBAAA;EvE6wPtC;EuE5wPM;;IAEE,yBAAA;EvE8wPR;EuE5wPM;;IAEE,2BAAA;EvE8wPR;EuE5wPM;;IAEE,4BAAA;EvE8wPR;EuE5wPM;;IAEE,0BAAA;EvE8wPR;EuE7xPM;IAAgC,2BAAA;EvEgyPtC;EuE/xPM;;IAEE,+BAAA;EvEiyPR;EuE/xPM;;IAEE,iCAAA;EvEiyPR;EuE/xPM;;IAEE,kCAAA;EvEiyPR;EuE/xPM;;IAEE,gCAAA;EvEiyPR;EuEhzPM;IAAgC,0BAAA;EvEmzPtC;EuElzPM;;IAEE,8BAAA;EvEozPR;EuElzPM;;IAEE,gCAAA;EvEozPR;EuElzPM;;IAEE,iCAAA;EvEozPR;EuElzPM;;IAEE,+BAAA;EvEozPR;EuEn0PM;IAAgC,wBAAA;EvEs0PtC;EuEr0PM;;IAEE,4BAAA;EvEu0PR;EuEr0PM;;IAEE,8BAAA;EvEu0PR;EuEr0PM;;IAEE,+BAAA;EvEu0PR;EuEr0PM;;IAEE,6BAAA;EvEu0PR;EuEt1PM;IAAgC,0BAAA;EvEy1PtC;EuEx1PM;;IAEE,8BAAA;EvE01PR;EuEx1PM;;IAEE,gCAAA;EvE01PR;EuEx1PM;;IAEE,iCAAA;EvE01PR;EuEx1PM;;IAEE,+BAAA;EvE01PR;EuEz2PM;IAAgC,wBAAA;EvE42PtC;EuE32PM;;IAEE,4BAAA;EvE62PR;EuE32PM;;IAEE,8BAAA;EvE62PR;EuE32PM;;IAEE,+BAAA;EvE62PR;EuE32PM;;IAEE,6BAAA;EvE62PR;EuEr2PM;IAAwB,2BAAA;EvEw2P9B;EuEv2PM;;IAEE,+BAAA;EvEy2PR;EuEv2PM;;IAEE,iCAAA;EvEy2PR;EuEv2PM;;IAEE,kCAAA;EvEy2PR;EuEv2PM;;IAEE,gCAAA;EvEy2PR;EuEx3PM;IAAwB,0BAAA;EvE23P9B;EuE13PM;;IAEE,8BAAA;EvE43PR;EuE13PM;;IAEE,gCAAA;EvE43PR;EuE13PM;;IAEE,iCAAA;EvE43PR;EuE13PM;;IAEE,+BAAA;EvE43PR;EuE34PM;IAAwB,wBAAA;EvE84P9B;EuE74PM;;IAEE,4BAAA;EvE+4PR;EuE74PM;;IAEE,8BAAA;EvE+4PR;EuE74PM;;IAEE,+BAAA;EvE+4PR;EuE74PM;;IAEE,6BAAA;EvE+4PR;EuE95PM;IAAwB,0BAAA;EvEi6P9B;EuEh6PM;;IAEE,8BAAA;EvEk6PR;EuEh6PM;;IAEE,gCAAA;EvEk6PR;EuEh6PM;;IAEE,iCAAA;EvEk6PR;EuEh6PM;;IAEE,+BAAA;EvEk6PR;EuEj7PM;IAAwB,wBAAA;EvEo7P9B;EuEn7PM;;IAEE,4BAAA;EvEq7PR;EuEn7PM;;IAEE,8BAAA;EvEq7PR;EuEn7PM;;IAEE,+BAAA;EvEq7PR;EuEn7PM;;IAEE,6BAAA;EvEq7PR;EuE/6PE;IAAmB,uBAAA;EvEk7PrB;EuEj7PE;;IAEE,2BAAA;EvEm7PJ;EuEj7PE;;IAEE,6BAAA;EvEm7PJ;EuEj7PE;;IAEE,8BAAA;EvEm7PJ;EuEj7PE;;IAEE,4BAAA;EvEm7PJ;AACF;Ae77PI;EwDlDI;IAAgC,oBAAA;EvEm/PtC;EuEl/PM;;IAEE,wBAAA;EvEo/PR;EuEl/PM;;IAEE,0BAAA;EvEo/PR;EuEl/PM;;IAEE,2BAAA;EvEo/PR;EuEl/PM;;IAEE,yBAAA;EvEo/PR;EuEngQM;IAAgC,0BAAA;EvEsgQtC;EuErgQM;;IAEE,8BAAA;EvEugQR;EuErgQM;;IAEE,gCAAA;EvEugQR;EuErgQM;;IAEE,iCAAA;EvEugQR;EuErgQM;;IAEE,+BAAA;EvEugQR;EuEthQM;IAAgC,yBAAA;EvEyhQtC;EuExhQM;;IAEE,6BAAA;EvE0hQR;EuExhQM;;IAEE,+BAAA;EvE0hQR;EuExhQM;;IAEE,gCAAA;EvE0hQR;EuExhQM;;IAEE,8BAAA;EvE0hQR;EuEziQM;IAAgC,uBAAA;EvE4iQtC;EuE3iQM;;IAEE,2BAAA;EvE6iQR;EuE3iQM;;IAEE,6BAAA;EvE6iQR;EuE3iQM;;IAEE,8BAAA;EvE6iQR;EuE3iQM;;IAEE,4BAAA;EvE6iQR;EuE5jQM;IAAgC,yBAAA;EvE+jQtC;EuE9jQM;;IAEE,6BAAA;EvEgkQR;EuE9jQM;;IAEE,+BAAA;EvEgkQR;EuE9jQM;;IAEE,gCAAA;EvEgkQR;EuE9jQM;;IAEE,8BAAA;EvEgkQR;EuE/kQM;IAAgC,uBAAA;EvEklQtC;EuEjlQM;;IAEE,2BAAA;EvEmlQR;EuEjlQM;;IAEE,6BAAA;EvEmlQR;EuEjlQM;;IAEE,8BAAA;EvEmlQR;EuEjlQM;;IAEE,4BAAA;EvEmlQR;EuElmQM;IAAgC,qBAAA;EvEqmQtC;EuEpmQM;;IAEE,yBAAA;EvEsmQR;EuEpmQM;;IAEE,2BAAA;EvEsmQR;EuEpmQM;;IAEE,4BAAA;EvEsmQR;EuEpmQM;;IAEE,0BAAA;EvEsmQR;EuErnQM;IAAgC,2BAAA;EvEwnQtC;EuEvnQM;;IAEE,+BAAA;EvEynQR;EuEvnQM;;IAEE,iCAAA;EvEynQR;EuEvnQM;;IAEE,kCAAA;EvEynQR;EuEvnQM;;IAEE,gCAAA;EvEynQR;EuExoQM;IAAgC,0BAAA;EvE2oQtC;EuE1oQM;;IAEE,8BAAA;EvE4oQR;EuE1oQM;;IAEE,gCAAA;EvE4oQR;EuE1oQM;;IAEE,iCAAA;EvE4oQR;EuE1oQM;;IAEE,+BAAA;EvE4oQR;EuE3pQM;IAAgC,wBAAA;EvE8pQtC;EuE7pQM;;IAEE,4BAAA;EvE+pQR;EuE7pQM;;IAEE,8BAAA;EvE+pQR;EuE7pQM;;IAEE,+BAAA;EvE+pQR;EuE7pQM;;IAEE,6BAAA;EvE+pQR;EuE9qQM;IAAgC,0BAAA;EvEirQtC;EuEhrQM;;IAEE,8BAAA;EvEkrQR;EuEhrQM;;IAEE,gCAAA;EvEkrQR;EuEhrQM;;IAEE,iCAAA;EvEkrQR;EuEhrQM;;IAEE,+BAAA;EvEkrQR;EuEjsQM;IAAgC,wBAAA;EvEosQtC;EuEnsQM;;IAEE,4BAAA;EvEqsQR;EuEnsQM;;IAEE,8BAAA;EvEqsQR;EuEnsQM;;IAEE,+BAAA;EvEqsQR;EuEnsQM;;IAEE,6BAAA;EvEqsQR;EuE7rQM;IAAwB,2BAAA;EvEgsQ9B;EuE/rQM;;IAEE,+BAAA;EvEisQR;EuE/rQM;;IAEE,iCAAA;EvEisQR;EuE/rQM;;IAEE,kCAAA;EvEisQR;EuE/rQM;;IAEE,gCAAA;EvEisQR;EuEhtQM;IAAwB,0BAAA;EvEmtQ9B;EuEltQM;;IAEE,8BAAA;EvEotQR;EuEltQM;;IAEE,gCAAA;EvEotQR;EuEltQM;;IAEE,iCAAA;EvEotQR;EuEltQM;;IAEE,+BAAA;EvEotQR;EuEnuQM;IAAwB,wBAAA;EvEsuQ9B;EuEruQM;;IAEE,4BAAA;EvEuuQR;EuEruQM;;IAEE,8BAAA;EvEuuQR;EuEruQM;;IAEE,+BAAA;EvEuuQR;EuEruQM;;IAEE,6BAAA;EvEuuQR;EuEtvQM;IAAwB,0BAAA;EvEyvQ9B;EuExvQM;;IAEE,8BAAA;EvE0vQR;EuExvQM;;IAEE,gCAAA;EvE0vQR;EuExvQM;;IAEE,iCAAA;EvE0vQR;EuExvQM;;IAEE,+BAAA;EvE0vQR;EuEzwQM;IAAwB,wBAAA;EvE4wQ9B;EuE3wQM;;IAEE,4BAAA;EvE6wQR;EuE3wQM;;IAEE,8BAAA;EvE6wQR;EuE3wQM;;IAEE,+BAAA;EvE6wQR;EuE3wQM;;IAEE,6BAAA;EvE6wQR;EuEvwQE;IAAmB,uBAAA;EvE0wQrB;EuEzwQE;;IAEE,2BAAA;EvE2wQJ;EuEzwQE;;IAEE,6BAAA;EvE2wQJ;EuEzwQE;;IAEE,8BAAA;EvE2wQJ;EuEzwQE;;IAEE,4BAAA;EvE2wQJ;AACF;AerxQI;EwDlDI;IAAgC,oBAAA;EvE20QtC;EuE10QM;;IAEE,wBAAA;EvE40QR;EuE10QM;;IAEE,0BAAA;EvE40QR;EuE10QM;;IAEE,2BAAA;EvE40QR;EuE10QM;;IAEE,yBAAA;EvE40QR;EuE31QM;IAAgC,0BAAA;EvE81QtC;EuE71QM;;IAEE,8BAAA;EvE+1QR;EuE71QM;;IAEE,gCAAA;EvE+1QR;EuE71QM;;IAEE,iCAAA;EvE+1QR;EuE71QM;;IAEE,+BAAA;EvE+1QR;EuE92QM;IAAgC,yBAAA;EvEi3QtC;EuEh3QM;;IAEE,6BAAA;EvEk3QR;EuEh3QM;;IAEE,+BAAA;EvEk3QR;EuEh3QM;;IAEE,gCAAA;EvEk3QR;EuEh3QM;;IAEE,8BAAA;EvEk3QR;EuEj4QM;IAAgC,uBAAA;EvEo4QtC;EuEn4QM;;IAEE,2BAAA;EvEq4QR;EuEn4QM;;IAEE,6BAAA;EvEq4QR;EuEn4QM;;IAEE,8BAAA;EvEq4QR;EuEn4QM;;IAEE,4BAAA;EvEq4QR;EuEp5QM;IAAgC,yBAAA;EvEu5QtC;EuEt5QM;;IAEE,6BAAA;EvEw5QR;EuEt5QM;;IAEE,+BAAA;EvEw5QR;EuEt5QM;;IAEE,gCAAA;EvEw5QR;EuEt5QM;;IAEE,8BAAA;EvEw5QR;EuEv6QM;IAAgC,uBAAA;EvE06QtC;EuEz6QM;;IAEE,2BAAA;EvE26QR;EuEz6QM;;IAEE,6BAAA;EvE26QR;EuEz6QM;;IAEE,8BAAA;EvE26QR;EuEz6QM;;IAEE,4BAAA;EvE26QR;EuE17QM;IAAgC,qBAAA;EvE67QtC;EuE57QM;;IAEE,yBAAA;EvE87QR;EuE57QM;;IAEE,2BAAA;EvE87QR;EuE57QM;;IAEE,4BAAA;EvE87QR;EuE57QM;;IAEE,0BAAA;EvE87QR;EuE78QM;IAAgC,2BAAA;EvEg9QtC;EuE/8QM;;IAEE,+BAAA;EvEi9QR;EuE/8QM;;IAEE,iCAAA;EvEi9QR;EuE/8QM;;IAEE,kCAAA;EvEi9QR;EuE/8QM;;IAEE,gCAAA;EvEi9QR;EuEh+QM;IAAgC,0BAAA;EvEm+QtC;EuEl+QM;;IAEE,8BAAA;EvEo+QR;EuEl+QM;;IAEE,gCAAA;EvEo+QR;EuEl+QM;;IAEE,iCAAA;EvEo+QR;EuEl+QM;;IAEE,+BAAA;EvEo+QR;EuEn/QM;IAAgC,wBAAA;EvEs/QtC;EuEr/QM;;IAEE,4BAAA;EvEu/QR;EuEr/QM;;IAEE,8BAAA;EvEu/QR;EuEr/QM;;IAEE,+BAAA;EvEu/QR;EuEr/QM;;IAEE,6BAAA;EvEu/QR;EuEtgRM;IAAgC,0BAAA;EvEygRtC;EuExgRM;;IAEE,8BAAA;EvE0gRR;EuExgRM;;IAEE,gCAAA;EvE0gRR;EuExgRM;;IAEE,iCAAA;EvE0gRR;EuExgRM;;IAEE,+BAAA;EvE0gRR;EuEzhRM;IAAgC,wBAAA;EvE4hRtC;EuE3hRM;;IAEE,4BAAA;EvE6hRR;EuE3hRM;;IAEE,8BAAA;EvE6hRR;EuE3hRM;;IAEE,+BAAA;EvE6hRR;EuE3hRM;;IAEE,6BAAA;EvE6hRR;EuErhRM;IAAwB,2BAAA;EvEwhR9B;EuEvhRM;;IAEE,+BAAA;EvEyhRR;EuEvhRM;;IAEE,iCAAA;EvEyhRR;EuEvhRM;;IAEE,kCAAA;EvEyhRR;EuEvhRM;;IAEE,gCAAA;EvEyhRR;EuExiRM;IAAwB,0BAAA;EvE2iR9B;EuE1iRM;;IAEE,8BAAA;EvE4iRR;EuE1iRM;;IAEE,gCAAA;EvE4iRR;EuE1iRM;;IAEE,iCAAA;EvE4iRR;EuE1iRM;;IAEE,+BAAA;EvE4iRR;EuE3jRM;IAAwB,wBAAA;EvE8jR9B;EuE7jRM;;IAEE,4BAAA;EvE+jRR;EuE7jRM;;IAEE,8BAAA;EvE+jRR;EuE7jRM;;IAEE,+BAAA;EvE+jRR;EuE7jRM;;IAEE,6BAAA;EvE+jRR;EuE9kRM;IAAwB,0BAAA;EvEilR9B;EuEhlRM;;IAEE,8BAAA;EvEklRR;EuEhlRM;;IAEE,gCAAA;EvEklRR;EuEhlRM;;IAEE,iCAAA;EvEklRR;EuEhlRM;;IAEE,+BAAA;EvEklRR;EuEjmRM;IAAwB,wBAAA;EvEomR9B;EuEnmRM;;IAEE,4BAAA;EvEqmRR;EuEnmRM;;IAEE,8BAAA;EvEqmRR;EuEnmRM;;IAEE,+BAAA;EvEqmRR;EuEnmRM;;IAEE,6BAAA;EvEqmRR;EuE/lRE;IAAmB,uBAAA;EvEkmRrB;EuEjmRE;;IAEE,2BAAA;EvEmmRJ;EuEjmRE;;IAEE,6BAAA;EvEmmRJ;EuEjmRE;;IAEE,8BAAA;EvEmmRJ;EuEjmRE;;IAEE,4BAAA;EvEmmRJ;AACF;AwEpqRE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EAEA,oBAAA;EACA,WAAA;EAEA,kCAAA;AxEoqRJ;;AyE9qRA;EAAkB,4GAAA;AzEkrRlB;;AyE9qRA;EAAiB,8BAAA;AzEkrRjB;;AyEjrRA;EAAiB,8BAAA;AzEqrRjB;;AyEprRA;EAAiB,8BAAA;AzEwrRjB;;AyEvrRA;ECTE,gBAAA;EACA,uBAAA;EACA,mBAAA;A1EosRF;;AyErrRI;EAAwB,2BAAA;AzEyrR5B;;AyExrRI;EAAwB,4BAAA;AzE4rR5B;;AyE3rRI;EAAwB,6BAAA;AzE+rR5B;;Ae1pRI;E0DvCA;IAAwB,2BAAA;EzEssR1B;EyErsRE;IAAwB,4BAAA;EzEwsR1B;EyEvsRE;IAAwB,6BAAA;EzE0sR1B;AACF;AetqRI;E0DvCA;IAAwB,2BAAA;EzEitR1B;EyEhtRE;IAAwB,4BAAA;EzEmtR1B;EyEltRE;IAAwB,6BAAA;EzEqtR1B;AACF;AejrRI;E0DvCA;IAAwB,2BAAA;EzE4tR1B;EyE3tRE;IAAwB,4BAAA;EzE8tR1B;EyE7tRE;IAAwB,6BAAA;EzEguR1B;AACF;Ae5rRI;E0DvCA;IAAwB,2BAAA;EzEuuR1B;EyEtuRE;IAAwB,4BAAA;EzEyuR1B;EyExuRE;IAAwB,6BAAA;EzE2uR1B;AACF;AyEtuRA;EAAmB,oCAAA;AzEyuRnB;;AyExuRA;EAAmB,oCAAA;AzE4uRnB;;AyE3uRA;EAAmB,qCAAA;AzE+uRnB;;AyE3uRA;EAAuB,2BAAA;AzE+uRvB;;AyE9uRA;EAAuB,+BAAA;AzEkvRvB;;AyEjvRA;EAAuB,2BAAA;AzEqvRvB;;AyEpvRA;EAAuB,2BAAA;AzEwvRvB;;AyEvvRA;EAAuB,8BAAA;AzE2vRvB;;AyE1vRA;EAAuB,6BAAA;AzE8vRvB;;AyE1vRA;EAAc,sBAAA;AzE8vRd;;A2EryRE;EACE,yBAAA;A3EwyRJ;;AM9xRE;EqELM,kEAAA;A3EuyRR;;A2E7yRE;EACE,yBAAA;A3EgzRJ;;AMtyRE;EqELM,gEAAA;A3E+yRR;;A2ErzRE;EACE,yBAAA;A3EwzRJ;;AM9yRE;EqELM,oEAAA;A3EuzRR;;A2E7zRE;EACE,yBAAA;A3Eg0RJ;;AMtzRE;EqELM,mEAAA;A3E+zRR;;A2Er0RE;EACE,yBAAA;A3Ew0RJ;;AM9zRE;EqELM,8CAAA;A3Eu0RR;;A2E70RE;EACE,yBAAA;A3Eg1RJ;;AMt0RE;EqELM,+CAAA;A3E+0RR;;A2Er1RE;EACE,yBAAA;A3Ew1RJ;;AM90RE;EqELM,iEAAA;A3Eu1RR;;A2E71RE;EACE,yBAAA;A3Eg2RJ;;AMt1RE;EqELM,mEAAA;A3E+1RR;;AyExzRA;EAAa,yBAAA;AzE4zRb;;AyE3zRA;EAAc,yBAAA;AzE+zRd;;AyE7zRA;EAAiB,oCAAA;AzEi0RjB;;AyEh0RA;EAAiB,0CAAA;AzEo0RjB;;AyEh0RA;EGvDE,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,6BAAA;EACA,SAAA;A5E23RF;;AyEp0RA;EAAwB,gCAAA;AzEw0RxB;;AyEt0RA;EACE,iCAAA;EACA,gCAAA;AzEy0RF;;AyEp0RA;EAAc,yBAAA;AzEw0Rd;;A6Ez4RA;EACE,8BAAA;A7E44RF;;A6Ez4RA;EACE,6BAAA;A7E44RF;;A8E54RE;EACE;;;IAKE,4BAAA;IAEA,2BAAA;E9E44RJ;E8Ex4RI;IACE,0BAAA;E9E04RN;E8Ej4RE;IACE,6BAAA;E9Em4RJ;E8Er3RE;IACE,gCAAA;E9Eu3RJ;E8Er3RE;;IAEE,yBAAA;IACA,wBAAA;E9Eu3RJ;E8Ep3RE;;IAEE,wBAAA;E9Es3RJ;E8En3RE;;;IAGE,UAAA;IACA,SAAA;E9Eq3RJ;E8El3RE;;IAEE,uBAAA;E9Eo3RJ;E8E52RE;IACE,Q1EwlC8B;EJsxPlC;E8E52RE;IACE,2BAAA;E9E82RJ;E8E52RE;IACE,2BAAA;E9E82RJ;E8E12RE;IACE,aAAA;E9E42RJ;E8E12RE;IACE,sBAAA;E9E42RJ;E8Ez2RE;IACE,oCAAA;E9E22RJ;E8Ez2RI;;IAEE,iCAAA;E9E22RN;E8Et2RI;;IAEE,oCAAA;E9Ew2RN;E8Ep2RE;IACE,cAAA;E9Es2RJ;E8Ep2RI;;;;IAIE,qB1EzCG;EJ+4RT;E8El2RE;IACE,cAAA;IACA,qB1E/CK;EJm5RT;AACF;A+E79RQ;EACI,kBAAA;A/E+9RZ;A+E79RQ;EACI,6BAAA;A/E+9RZ;A+E39RI;EACI,iBAAA;A/E69RR;A+Ev9RgB;EACI,gBAAA;A/Ey9RpB;;A+E/8RI;EACI,iBAAA;EACA,oCAAA;EACA,0CAAA;EACA,gBAAA;EACA,kBAAA;A/Ek9RR;A+Eh9RQ;EACI,6BAAA;A/Ek9RZ;A+Eh9RY;EACI,WAAA;EACA,kBAAA;EACA,SAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,mB3E8BL;AJo7RX;A+E98RQ;EACI,kBAAA;EACA,WAAA;EACA,SAAA;A/Eg9RZ;;AgFrgSA;EACI,c5EgFO;AJw7RX;;AgF7/RI;EALA,yCAAA;EACA,yBAAA;AhFsgSJ;;AgFlgSI;EALA,uCAAA;EACA,yBAAA;AhF2gSJ;;AgFvgSI;EALA,yCAAA;EACA,yBAAA;AhFghSJ;;AgF5gSI;EALA,yCAAA;EACA,yBAAA;AhFqhSJ;;AgFjhSI;EALA,yCAAA;EACA,yBAAA;AhF0hSJ;;AgFthSI;EALA,yCAAA;EACA,yBAAA;AhF+hSJ;;AgF3hSI;EALA,uCAAA;EACA,yBAAA;AhFoiSJ;;AgFhiSI;EALA,0CAAA;EACA,yBAAA;AhFyiSJ;;AiF7iSI;EACI,qDAAA;AjFgjSR;;AiFjjSI;EACI,mDAAA;AjFojSR;;AiFrjSI;EACI,qDAAA;AjFwjSR;;AiFzjSI;EACI,qDAAA;AjF4jSR;;AiF7jSI;EACI,qDAAA;AjFgkSR;;AiFjkSI;EACI,qDAAA;AjFokSR;;AiFrkSI;EACI,mDAAA;AjFwkSR;;AiFzkSI;EACI,sDAAA;AjF4kSR;;AiFvkSA;EACI,wD7EgCwB;AJ0iS5B;;AkF/kSQ;EACI,sBAAA;AlFklSZ;;AmFxlSA;EACI,W/EuEO;AJohSX;AmFxlSI;EACI,gBAAA;AnF0lSR;AmFtlSQ;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;AnFwlSZ;;AmFnlSA;EACI,kBAAA;AnFslSJ;;AmFhlSA;EACI,c/EuDO;AJ4hSX;;AmFhlSA;EACI,qB/E6CO;AJsiSX;AMrmSE;E6EqBM,yB/E0CG;E+EzCH,qB/E0CG;AJyiSX;;AmF5kSA;EACI,gB/EoT0B;E+EnT1B,c/EiMsC;E+EhMtC,6BAAA;AnF+kSJ;AMnnSE;E6EsCM,uD/EgMkC;E+E/LlC,0B/EgMkC;E+E/LlC,6BAAA;EACA,yBAAA;AnFglSR;AmF9kSI;EAEI,0B/E0LkC;E+EzLlC,yBAAA;EACA,gBAAA;AnF+kSR;AmF7kSI;EAEI,c/EmBG;E+ElBH,oBAAA;AnF8kSR;;AmFrkSA;EACI,sBAAA;EACA,kBAAA;EACA,sBAAA;AnFwkSJ;;AmFpjSI;EAfA,yCAAA;EACA,c1DNW;E0DOX,qCAAA;AnFukSJ;AmFrkSI;EACI,gBAAA;AnFukSR;AM7oSE;E6E0EM,0CAAA;EACA,c1DfO;AzBqlSf;;AmFjkSI;EAfA,uCAAA;EACA,c1DNW;E0DOX,mCAAA;AnFolSJ;AmFllSI;EACI,gBAAA;AnFolSR;AM1pSE;E6E0EM,wCAAA;EACA,c1DfO;AzBkmSf;;AmF9kSI;EAfA,yCAAA;EACA,c1DNW;E0DOX,qCAAA;AnFimSJ;AmF/lSI;EACI,gBAAA;AnFimSR;AMvqSE;E6E0EM,0CAAA;EACA,c1DfO;AzB+mSf;;AmF3lSI;EAfA,yCAAA;EACA,c1DNW;E0DOX,qCAAA;AnF8mSJ;AmF5mSI;EACI,gBAAA;AnF8mSR;AMprSE;E6E0EM,0CAAA;EACA,c1DfO;AzB4nSf;;AmFxmSI;EAfA,yCAAA;EACA,c1DNW;E0DOX,qCAAA;AnF2nSJ;AmFznSI;EACI,gBAAA;AnF2nSR;AMjsSE;E6E0EM,0CAAA;EACA,c1DfO;AzByoSf;;AmFrnSI;EAfA,yCAAA;EACA,c1DNW;E0DOX,qCAAA;AnFwoSJ;AmFtoSI;EACI,gBAAA;AnFwoSR;AM9sSE;E6E0EM,0CAAA;EACA,c1DfO;AzBspSf;;AmFloSI;EAfA,uCAAA;EACA,c1DNW;E0DOX,mCAAA;AnFqpSJ;AmFnpSI;EACI,gBAAA;AnFqpSR;AM3tSE;E6E0EM,wCAAA;EACA,c1DfO;AzBmqSf;;AmF/oSI;EAfA,0CAAA;EACA,c1DNW;E0DOX,sCAAA;AnFkqSJ;AmFhqSI;EACI,gBAAA;AnFkqSR;AMxuSE;E6E0EM,2CAAA;EACA,c1DfO;AzBgrSf;;AmFlpSI;E3D1CF,cCYa;EDXb,qBCWa;AzBqrSf;AMrvSE;EkBwDE,WALgD;EAMhD,yBCOW;EDNX,qBCMW;AzB0rSf;AwB7rSE;EAEE,iDAAA;AxB8rSJ;AwB3rSE;EAEE,cCJW;EDKX,6BAAA;AxB4rSJ;AwBzrSE;EAGE,WAAA;EACA,yBCZW;EDaX,qBCbW;AzBssSf;AwBvrSI;EAKI,iDAAA;AxBqrSR;AmFzqSQ;EACI,gBAAA;AnF2qSZ;;AmF9qSI;E3D1CF,cCYa;EDXb,qBCWa;AzBitSf;AMjxSE;EkBwDE,WALgD;EAMhD,yBCOW;EDNX,qBCMW;AzBstSf;AwBztSE;EAEE,+CAAA;AxB0tSJ;AwBvtSE;EAEE,cCJW;EDKX,6BAAA;AxBwtSJ;AwBrtSE;EAGE,WAAA;EACA,yBCZW;EDaX,qBCbW;AzBkuSf;AwBntSI;EAKI,+CAAA;AxBitSR;AmFrsSQ;EACI,gBAAA;AnFusSZ;;AmF1sSI;E3D1CF,cCYa;EDXb,qBCWa;AzB6uSf;AM7ySE;EkBwDE,cALgD;EAMhD,yBCOW;EDNX,qBCMW;AzBkvSf;AwBrvSE;EAEE,iDAAA;AxBsvSJ;AwBnvSE;EAEE,cCJW;EDKX,6BAAA;AxBovSJ;AwBjvSE;EAGE,cAAA;EACA,yBCZW;EDaX,qBCbW;AzB8vSf;AwB/uSI;EAKI,iDAAA;AxB6uSR;AmFjuSQ;EACI,gBAAA;AnFmuSZ;;AmFtuSI;E3D1CF,cCYa;EDXb,qBCWa;AzBywSf;AMz0SE;EkBwDE,cALgD;EAMhD,yBCOW;EDNX,qBCMW;AzB8wSf;AwBjxSE;EAEE,iDAAA;AxBkxSJ;AwB/wSE;EAEE,cCJW;EDKX,6BAAA;AxBgxSJ;AwB7wSE;EAGE,cAAA;EACA,yBCZW;EDaX,qBCbW;AzB0xSf;AwB3wSI;EAKI,iDAAA;AxBywSR;AmF7vSQ;EACI,gBAAA;AnF+vSZ;;AmFlwSI;E3D1CF,cCYa;EDXb,qBCWa;AzBqySf;AMr2SE;EkBwDE,cALgD;EAMhD,yBCOW;EDNX,qBCMW;AzB0ySf;AwB7ySE;EAEE,iDAAA;AxB8ySJ;AwB3ySE;EAEE,cCJW;EDKX,6BAAA;AxB4ySJ;AwBzySE;EAGE,cAAA;EACA,yBCZW;EDaX,qBCbW;AzBszSf;AwBvySI;EAKI,iDAAA;AxBqySR;AmFzxSQ;EACI,gBAAA;AnF2xSZ;;AmF9xSI;E3D1CF,cCYa;EDXb,qBCWa;AzBi0Sf;AMj4SE;EkBwDE,WALgD;EAMhD,yBCOW;EDNX,qBCMW;AzBs0Sf;AwBz0SE;EAEE,iDAAA;AxB00SJ;AwBv0SE;EAEE,cCJW;EDKX,6BAAA;AxBw0SJ;AwBr0SE;EAGE,WAAA;EACA,yBCZW;EDaX,qBCbW;AzBk1Sf;AwBn0SI;EAKI,iDAAA;AxBi0SR;AmFrzSQ;EACI,gBAAA;AnFuzSZ;;AmF1zSI;E3D1CF,cCYa;EDXb,qBCWa;AzB61Sf;AM75SE;EkBwDE,WALgD;EAMhD,yBCOW;EDNX,qBCMW;AzBk2Sf;AwBr2SE;EAEE,+CAAA;AxBs2SJ;AwBn2SE;EAEE,cCJW;EDKX,6BAAA;AxBo2SJ;AwBj2SE;EAGE,WAAA;EACA,yBCZW;EDaX,qBCbW;AzB82Sf;AwB/1SI;EAKI,+CAAA;AxB61SR;AmFj1SQ;EACI,gBAAA;AnFm1SZ;;AmFt1SI;E3D1CF,cCYa;EDXb,qBCWa;AzBy3Sf;AMz7SE;EkBwDE,cALgD;EAMhD,yBCOW;EDNX,qBCMW;AzB83Sf;AwBj4SE;EAEE,kDAAA;AxBk4SJ;AwB/3SE;EAEE,cCJW;EDKX,6BAAA;AxBg4SJ;AwB73SE;EAGE,cAAA;EACA,yBCZW;EDaX,qBCbW;AzB04Sf;AwB33SI;EAKI,kDAAA;AxBy3SR;AmF72SQ;EACI,gBAAA;AnF+2SZ;;AoFx9SA;EACI,mBhF6R0B;EgF5R1B,wDhF+S0B;EgF9S1B,mBAAA;EACA,yBhF23BgC;AJgmRpC;;AoFx9SA;EACI,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;ApF29SJ;AoF19SI;EACI,yBhFwDG;EgFvDH,chF6DG;AJ+5SX;;AoFt9SA;;EAEI,aAAA;ApFy9SJ;;AoFt9SA;EACI,iBAAA;ApFy9SJ;;AoFr9SA;EACI,yBhF21BgC;EgF11BhC,gBhFk1BgC;EgFj1BhC,wDhF2Q0B;EgF1Q1B,mBhFuP0B;EOhR1B,qBAAA;AXk/SJ;;AoFr9SA;EACI,kBAAA;EACA,gBAAA;ApFw9SJ;;AoFr9SA;EACI,mBhF6O0B;EgF5O1B,chF4BO;AJ47SX;;AqF1gTA;EACI,6CjFiT0B;EiFhT1B,6BAAA;EACA,wBAAA;EACA,yBAAA;EACA,SAAA;EACA,iBjFkV0B;EiFjV1B,kBAAA;EACA,aAAA;ArF6gTJ;AqF3gTI;EACI,oBAAA;ArF6gTR;;AqFzgTA;EACI,mBAAA;EACA,qBAAA;ArF4gTJ;;AqFzgTA;EACI,oBAAA;EACA,0BAAA;ArF4gTJ;;AqFzgTA;EACI;IACI,gCAAA;IACA,wBAAA;ErF4gTN;EqF1gTE;IACI,oCAAA;IACA,4BAAA;ErF4gTN;AACF;AqFvgTA;EACI,YjFiBmB;AJw/SvB;;Ae3+SI;EsE1BA;IACI,uBAAA;ErFygTN;AACF;AqFrgTI;EACI,iBAAA;EACA,0BAAA;ArFugTR;;AsFzjTA;EACI,yBlFuEO;EkFtEP,qBlFsEO;AJs/SX;;AsFvjTA;;EAEI,gBAAA;AtF0jTJ;;AsFnjTI;;EACI,2BAAA;AtFujTR;;AsFjjTI;EACI,qBlFkDG;EkFjDH,gCAAA;AtFojTR;AsFljTI;EACI,yBlF4CG;EkF3CH,aAAA;EACA,yBAAA;EACA,gBAAA;EACA,gCAAA;AtFojTR;;AsF9iTI;EACI,aAAA;AtFijTR;;AuFvlTA;EACI,aAAA;AvF0lTJ;;AuFtlTA;EACI,UAAA;EACA,eAAA;AvFylTJ;;AuFrlTA;EACI,sBnF0DO;EmFzDP,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;AvFwlTJ;AuFvlTI;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,cnFoDG;AJqiTX;;AuFrlTA;EACI;IACI,qBAAA;EvFwlTN;AACF;AuFrlTA;EACI,4BAAA;EACA,iBAAA;EACA,eAAA;EACA,yBnF2CO;EmF1CP,WnFkCO;EmFjCP,gBAAA;EACA,SAAA;AvFulTJ;;AuFplTA;EACI,aAAA;AvFulTJ;;AuFplTA;EACI,gBAAA;AvFulTJ;;AuFllTI;;EACI,SAAA;EACA,aAAA;AvFslTR;;AwF1oTA;EACI,iDAAA;AxF6oTJ;AwF3oTI;EACI,mBAAA;AxF6oTR;AwFzoTQ;EACI,oCAAA;EACA,yBAAA;AxF2oTZ;AwFzoTQ;EACI,2CAAA;AxF2oTZ;;AwFnoTQ;EACI,cpFsDD;EoFrDC,gBpFqUkB;AJi0S9B;;AwFjoTA;EACI,mBpFoMwB;EoFnMxB,qBpF0Q0B;EoFzQ1B,gBAAA;AxFooTJ;AwFloTI;EACI,6BAAA;EACA,cpFyCG;AJ2lTX;AwFjoTI;;EAEI,cpFoCG;EoFnCH,yBpFm1B4B;EoFl1B5B,wDpFoQsB;AJ+3S9B;;AwF3nTQ;EACI,yBpFqBD;EoFpBC,aAAA;AxF8nTZ;;AyFlrTE;EACE,8BAAA;EACA,aAAA;EACA,YAAA;AzFqrTJ;;A0F3rTA;EACI,aAAA;A1F8rTJ;;A2F5rTA;EACE,WAAA;A3F+rTF;;A2F1rTA;EACE,WAAA;A3F6rTF;;A2FxrTA;EACE,YAAA;A3F2rTF;;A2FvrTA;EACE,YAAA;A3F0rTF;;A2FtrTA;EACE,YAAA;A3FyrTF;;A2FrrTA,yBAAA;AACA;EACE,iBAAA;EACA,aAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;A3FwrTF;A2FtrTE;EACE,WAAA;A3FwrTJ;A2FrrTE;EACE,WAAA;A3FurTJ;A2FprTE;EACE,WAAA;A3FsrTJ;A2FnrTE;EACE,UAAA;A3FqrTJ;A2FlrTE;EACE,UAAA;A3ForTJ;;A2FhrTA;EACE,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;A3FmrTF;A2FjrTE;EACE,WAAA;EACA,SAAA;EACA,kBAAA;A3FmrTJ;A2FhrTE;EACE,WAAA;A3FkrTJ;A2F/qTE;EACE,WAAA;A3FirTJ;A2F9qTE;EACE,UAAA;A3FgrTJ;A2F7qTE;EACE,UAAA;A3F+qTJ;;A2FzqTA;EACE,gBAAA;EACA,mBAAA;A3F4qTF;A2F1qTE;EACE,UAAA;EACA,WAAA;EACA,eAAA;A3F4qTJ;A2FzqTE;EACE,UAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;A3F2qTJ;;A4FrxTA;EACE,gCAAA;A5FwxTF;A4FtxTE;EACE,aAAA;A5FwxTJ;;A4FnxTA;EACE,gBxFwCqB;AJ8uTvB;;A4FlxTA;EACE,aAAA;A5FqxTF;;A4FhxTA;EACE,kBAAA;EACA,mBAAA;EACA,8BAAA;A5FmxTF;A4FjxTE;EACE,cAAA;EACA,+BAAA;EACA,iBAAA;A5FmxTJ;;A4F7wTA;EACE,cxFwCS;EwFvCT,+BAAA;A5FgxTF;;A4F5wTE;EACE,cnE4BW;EmE3BX,8BAAA;A5F+wTJ;;A4FjxTE;EACE,cnE4BW;EmE3BX,4BAAA;A5FoxTJ;;A4FtxTE;EACE,cnE4BW;EmE3BX,8BAAA;A5FyxTJ;;A4F3xTE;EACE,cnE4BW;EmE3BX,8BAAA;A5F8xTJ;;A4FhyTE;EACE,cnE4BW;EmE3BX,8BAAA;A5FmyTJ;;A4FryTE;EACE,cnE4BW;EmE3BX,8BAAA;A5FwyTJ;;A4F1yTE;EACE,cnE4BW;EmE3BX,4BAAA;A5F6yTJ;;A4F/yTE;EACE,cnE4BW;EmE3BX,+BAAA;A5FkzTJ;;A4F9yTA;EACE,YAAA;EACA,WAAA;A5FizTF;;A4F9yTA;EACE,YAAA;EACA,WAAA;A5FizTF;;A4F9yTA;EACE,YAAA;EACA,WAAA;A5FizTF;;A4F9yTA;EACE,YAAA;EACA,WAAA;A5FizTF;;A6Fh3TI;EACI,iCAAA;A7Fm3TR;;A6F52TI;EACI,gBzFmVsB;AJ4hT9B;A6F52TQ;EACI,YAAA;EACA,WAAA;A7F82TZ;;A6Fz2TA;EACI,czFuDO;EyFtDP,iBAAA;EACA,qBAAA;EACA,cAAA;A7F42TJ;A6F12TI;EACI,czFkDG;AJ0zTX;;A6Ft2TI;EACE,mBAAA;A7Fy2TN;;A8F74TA;;;;;;;;;;;;EAYI,cAAA;EACA,sC1FwU0B;E0FvU1B,c1FiEO;E0FhEP,gB1FsCmB;AJ02TvB;;A8F74TA;EACI,gBAAA;A9Fg5TJ;;A8F54TA;EACI,0BAAA;A9F+4TJ;;A8F54TA;EACI,0BAAA;A9F+4TJ;;A8F54TA;EACI,0BAAA;A9F+4TJ;;A8F54TA;EACI,0BAAA;A9F+4TJ;;A8F54TA;EACI,0BAAA;A9F+4TJ;;A8F54TA;EACI,0BAAA;A9F+4TJ;;A8F54TA;EACI,0BAAA;A9F+4TJ;;A8F54TA;EACI,0BAAA;A9F+4TJ;;A8F54TA;EACI,0BAAA;A9F+4TJ;;A8F54TA;EACI,0BAAA;A9F+4TJ;;A8F54TA;EACI,0BAAA;A9F+4TJ;;A8F54TA;EACI,0BAAA;A9F+4TJ;;A8F34TA;EACI,4CAAA;EACA,mBAAA;A9F84TJ;;A+F59TA;EACE,sBAAA;EACA,6CAAA;EACA,iTAAA;EAKA,mBAAA;EACA,kBAAA;A/F29TF;A+Fx9TA,gGAAA;AACA,2FAAA;AACA;;;;;;;CAAA;AASA;EACE,oBAAA;A/Fy9TF;;A+Ft9TA;EACE,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EAEA,qBAAA;EACA,wBAAA;EACA,UAAA;EAEA,kBAAA;EACA,iBAAA;EAEA,gEAAA;EACA,oBAAA;EACA,oBAAA;EAEA,8CAAA;EACA,gBAAA;EAEA,gEAAA;EACA,yBAAA;EAGA,0DAAA;EACA,eAAA;EAEA,6CAAA;EACA,mCAAA;EACA,kCAAA;EAEA,4BAAA;EACA,uDAAA;A/Fg9TF;;A+F78TA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AACA;EACE,gBAAA;A/Fg9TF;;A+F78TA,QAAA;AC3/KA;EACE,aAAA;AhG48eF;;AiGh9eA;;;;;;;;;;;;;;;;;;;;;;;;;4BAAA;AA8BA,aAAA;AAUA,eAAA;ACrCA;EACE,kBAAA;EACA,gBAAA;AlG4+eF;;AkGz+eA;EACE,oBAAA;EACA,kBAAA;EACA,mB9F4N0B;AJgxe5B;;AkGz+eA;EACE,oBAAA;EACA,uBAAA;EACA,YAAA;AlG4+eF;;AkGz+eA;EACE,uBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;AlG4+eF;AkG1+eE;EACE,kBAAA;AlG4+eJ;;AkGx+eA;EACE,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,6BAAA;EACA,gBAAA;AlG2+eF;;AiGx+eA,iBAAA;AEvCA;EACE,yBAAA,EAAA,UAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,qBAAA;EACA,qBAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;EACA,eAAA;AnGmhfF;;AmGjhfA;EACE,uBAAA;EACA,YAAA;EACA,yBAAA;AnGohfF;;AmGjhfA;EAAgB,yBAAA;AnGqhfhB;;AmGnhfA;EACE,uBAAA;EACA,YAAA;EACA,yBAAA;AnGshfF;;AmGnhfA;EACE,yBAAA;EACA,YAAA;AnGshfF;;AmG/gfQ;;EACI,iBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,oBAAA;AnGmhfZ;AmGlhfY;;;EAEI,yBAAA;AnGqhfhB;AmGlhfQ;;EACG,yBAAA;AnGqhfX;;AmG7gfQ;;EACI,iBAAA;EACA,c/FjCa;E+FkCb,cAAA;EACA,kBAAA;EACA,oBAAA;AnGihfZ;AmGhhfY;;;EAEI,c/FtCS;AJyjfzB;AmGhhfQ;;EACI,c/FzCa;AJ4jfzB;;AmG3gfA;EACI,YAAA;EACA,gBAAA;EACA,WAAA;AnG8gfJ;;AmG1gfA;EACI,kB/F7EwB;E+F8ExB,gBAAA;EACA,8BAAA;EACA,gBAAA;EACA,gB/F3CY;AJwjfhB;;AmG1gfA;EACI,aAAA;EACA,6BAAA;EACA,gBAAA;AnG6gfJ;;AmGxgfA;EACI,Y/F7FwB;E+F8FxB,mBAAA;EAEA,SAAA;EAEA,mBAAA;EACA,eAAA;EACA,S/F9DY;E+F+DZ,yBAAA;EACA,uDAAA;EACA,WAAA;AnGygfJ;AmGvgfI;EACI,YAAA;EACA,oBAAA;AnGygfR;;AmGtgfA;EACI,Y/F/GwB;E+FiHxB,mB/FrH0B;E+FsH1B,SAAA;EAEA,mBAAA;EACA,eAAA;EACA,S/FhFY;E+FiFZ,yBAAA;EACA,uDAAA;EACA,WAAA;AnGugfJ;AmGrgfI;EACI,YAAA;EACA,oBAAA;AnGugfR;;AmGhgfA;EACI,oBAAA;AnGmgfJ;AmG//egB;EACI,8BAAA;EACA,c/FvHK;E+FwHL,0C/FvHC;AJwnfrB;AmGhgfoB;EACI,c/F1HC;E+F2HD,6BAAA;AnGkgfxB;AmG9/eY;EACI,c/FlIS;E+FmIT,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,kCAAA;AnGggfhB;AmG9/egB;EACI,qBAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,c/FhJK;E+FiJL,8BAAA;AnGggfpB;AmG7/egB;EAGI,c/FtJK;E+FuJL,qBAAA;EACA,0C/FtJC;AJmpfrB;AmG3/eoB;EACI,c/F1JC;E+F2JD,6BAAA;AnG6/exB;AmG1/egB;EACI,sBAAA;AnG4/epB;AmGz/egB;EACI,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;AnG2/epB;AmGx/egB;EACI,8BAAA;EACA,c/F7KK;E+F8KL,0C/F7KC;AJuqfrB;AmGx/eoB;EACI,c/FjLC;E+FkLD,6BAAA;AnG0/exB;AmGn/eY;EACI,kBAAA;AnGq/ehB;AmGn/egB;EACI,kBAAA;AnGq/epB;AmGh/eI;EACI,2BAAA;EACA,kBAAA;EACA,WAAA;EACA,qBAAA;EACA,sBAAA;EACA,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,0BAAA;EACA,SAAA;AnGk/eR;AmGj/eQ;EACI,gBAAA;AnGm/eZ;AmG/+eI;EACI,eAAA;AnGi/eR;AmG5+eY;EACI,QAAA;AnG8+ehB;AmGv+eY;EACI,wBAAA;AnGy+ehB;AmGp+eI;EACI,4BAAA;EACA,sBAAA;EACA,oBAAA;EACA,eAAA;EACA,oBAAA;EACA,yBAAA;EACA,c/F/OiB;AJqtfzB;;AmGn+eA;EACI,oBAAA;AnGs+eJ;AmGl+egB;EACI,8BAAA;EACC,yBAAA;AnGo+erB;AmGl+eoB;EACI,c/F1PC;E+F2PD,6BAAA;AnGo+exB;AmGh+eY;EACI,cAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,kCAAA;AnGk+ehB;AmGh+egB;EACI,qBAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EAEA,8BAAA;AnGi+epB;AmG99egB;EAGK,cAAA;EACD,qBAAA;AnG89epB;AmG39eoB;EACI,c/F1RC;E+F2RD,6BAAA;AnG69exB;AmG19egB;EACI,sBAAA;AnG49epB;AmGz9egB;EACI,qBAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;AnG29epB;AmGx9egB;EACI,8BAAA;EACA,cAAA;AnG09epB;AmGx9eoB;EAEI,6BAAA;AnGy9exB;AmGl9eY;EACI,kBAAA;AnGo9ehB;AmGl9egB;EACI,kBAAA;AnGo9epB;AmG/8eI;EACI,2BAAA;EACA,kBAAA;EACA,WAAA;EACA,qBAAA;EACA,sBAAA;EACA,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,0BAAA;EACA,SAAA;AnGi9eR;AmGh9eQ;EACI,gBAAA;AnGk9eZ;AmG98eI;EACI,eAAA;AnGg9eR;AmG38eY;EACI,QAAA;AnG68ehB;AmGt8eY;EACI,wBAAA;AnGw8ehB;AmGn8eI;EACI,4BAAA;EACA,sBAAA;EACA,oBAAA;EACA,eAAA;EACA,oBAAA;EACA,yBAAA;EACA,c/F9WiB;AJmzfzB;;AmGj8eA;EACI,4BAAA;AnGo8eJ;AmGl8eI;EACI,aAAA;AnGo8eR;AmGj8eI;EACI,c/F1XiB;E+F2XjB,gB/F/Ve;AJkyfvB;AmGh8eI;EACI,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;AnGk8eR;AmG97eQ;EACI,WAAA;EACA,YAAA;EACA,c/FzYa;E+F0Yb,yCAAA;EACA,kBAAA;AnGg8eZ;;AmG57eA;EACI,4BAAA;AnG+7eJ;AmG77eI;EACI,aAAA;AnG+7eR;AmG57eI;EACK,yBAAA;EACD,gB/F5Xe;AJ0zfvB;AmG37eI;EACI,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACC,yBAAA;AnG67eT;AmGz7eQ;EACI,WAAA;EACA,YAAA;EACF,yBAAA;EACE,yCAAA;EACA,kBAAA;AnG27eZ;;AmGr7eI;EACI,sBAAA;EACA,kBAAA;AnGw7eR;AmGt7eY;EACI,aAAA;AnGw7ehB;AmGt7eY;EACI,yBAAA;AnGw7ehB;AmGl7eI;EACI,kBAAA;EACA,kBAAA;AnGo7eR;AmGn7eQ;EACI,yBAAA;AnGq7eZ;AmGh7eI;EACI,kBAAA;EACA,sBAAA;EACA,UAAA;AnGk7eR;AmGh7eQ;;EAEI,4BAAA;EACA,uBAAA;AnGk7eZ;AmGh7eQ;EACI,kBAAA;AnGk7eZ;AmG/6eQ;EACI,YAAA;AnGi7eZ;AmG56eY;;;;EAII,wBAAA;AnG86ehB;AmG16egB;EACI,kBAAA;EACA,mBAAA;AnG46epB;AmG16eoB;EACI,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;AnG46exB;AmG16ewB;EAGU,c/F9eT;AJw5fzB;AmGv6ewB;EACI,WAAA;AnGy6e5B;AmGt6ewB;EACI,aAAA;EACA,kBAAA;EACA,wBAAA;AnGw6e5B;AmGt6ewB;EACI,0C/FzfP;AJi6frB;AmGl6ewB;EACI,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,0C/FngBP;E+FogBO,gBAAA;AnGo6e5B;AmGl6e4B;EACI,eAAA;AnGo6ehC;AmG/5e4B;EACI,aAAA;AnGi6ehC;AmG75ewB;EACI,cAAA;EACA,U/FviBA;E+FwiBA,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,wD/FlQE;AJiqf9B;AmG75e4B;EACI,wD/FrQF;AJoqf9B;AmG75e4B;EACI,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;AnG+5ehC;AmG95egC;EACI,c/FriBX;AJq8fzB;AmGz5egB;EACI,cAAA;EACA,aAAA;EACA,aAAA;EACA,yB/FvkBU;AJk+f9B;AmGv5e4B;EACI,cAAA;EACA,WAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;AnGy5ehC;AmGp5e4B;EACI,kBAAA;EACA,WAAA;EACA,SAAA;EACA,yBAAA;AnGs5ehC;AmGj5ewB;EACI,c/F9kBE;AJi+f9B;AmG34eI;EACI,aAAA;AnG64eR;AmG34eQ;EACI,aAAA;AnG64eZ;AmG14eQ;EACI,cAAA;AnG44eZ;AmGz4eQ;;EAEI,aAAA;AnG24eZ;AmGt4egB;EACI,6BAAA;AnGw4epB;AmGj4eI;EACI,4BAAA;AnGm4eR;AmG/3eI;EACI,qBAAA;AnGi4eR;AmG73eI;EACI,aAAA;AnG+3eR;;AmGz3eA;EACI;IACI,kBAAA;EnG43eN;AACF;AmGz3eA;EACI;IACI,S/FjnBQ;I+FknBR,eAAA;EnG23eN;EmGv3eM;IACI,iBAAA;EnGy3eV;AACF;Aez9fI;EoFsmBA;IACI,kBAAA;EnGs3eN;EmGp3eE;IACI,aAAA;IACA,sBAAA;IACA,S/FpoBQ;EJ0/fd;EmGn3eM;IACI,cAAA;EnGq3eV;EmGl3eE;IACI,yBAAA;IACA,eAAA;EnGo3eN;EmGl3eE;IACI,aAAA;EnGo3eN;EmGl3eE;IACI,aAAA;EnGo3eN;AACF;AiG5ggBA,cAAA;AGxCA;EACI,uBAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,YhGsCY;EgGrCZ,YAAA;EACA,yBhG4BqB;EgG3BrB,wDhGuS0B;AJgxf9B;AoGpjgBQ;EACI,WAAA;ApGsjgBZ;AoGpjgBQ;EACI,eAAA;EACA,chGOa;EgGNb,eAAA;EACA,cAAA;EACA,iBhGwBI;EgGvBJ,kBAAA;EACA,gBhGsBI;EgGrBJ,eAAA;ApGsjgBZ;AoGpjgBY;EACI,YAAA;EACA,WAAA;EACA,chGJS;EgGKT,8BAAA;ApGsjgBhB;AoGhjgBgB;EACI,chGVK;EgGWL,6BAAA;ApGkjgBpB;AoG5igBQ;EACI,2CAAA;ApG8igBZ;AoG1igBI;EACI,gBAAA;ApG4igBR;AoG7lgBA;EAoDI,WAAA;ApG4igBJ;AoG3igBI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;ApG6igBR;AoG5igBQ;EACI,gBAAA;ApG8igBZ;AoG5igBQ;EACI,6BAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACC,2BAAA;EACA,kBAAA;ApG8igBb;AoG7igBY;EACI,sBhGEL;EgGDK,yBAAA;ApG+igBhB;AoG3igBQ;EACI,kBAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;ApG6igBZ;AoGxigBI;EACI,YAAA;EACA,chGdG;EgGeH,cAAA;EACA,YhGhDQ;EgGiDR,iBhGjDQ;EgGkDR,WAAA;EACA,6BAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;ApG0igBR;AoGxigBQ;EACI,aAAA;ApG0igBZ;AoGvigBQ;EACI,qBAAA;ApGyigBZ;AoGvigBQ;EACI,aAAA;ApGyigBZ;AoGrigBY;EACI,aAAA;ApGuigBhB;AoGrigBY;EACI,qBAAA;ApGuigBhB;AoG9hgBQ;EACI,aAAA;ApGgigBZ;;AoG3hgBA;EACI,yBAAA;EACA,gBAAA;EACA,mBAAA;ApG8hgBJ;;AoG3hgBA,iBAAA;AACA;EACI;IACE,UAAA;EpG8hgBJ;AACF;AoG3hgBA;EACI,iBAAA;ApG6hgBJ;;AoG1hgBA;EACI,cAAA;ApG6hgBJ;AoG3hgBI;EACI,6BAAA;EACA,sBAAA;ApG6hgBR;AoG1hgBI;EACI,eAAA;EACA,sBAAA;ApG4hgBR;AoGzhgBI;EACI,qBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,yBhGhEE;EgGiEF,yBAAA;EACA,kBAAA;EACA,4ChGuIsB;EgGtItB,qCAAA;EACA,4BAAA;ApG2hgBR;AoGxhgBI;EACI,kBAAA;ApG0hgBR;AoGxhgBQ;EACI,WAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WhGrHD;AJ+ogBX;AoGvhgBQ;EACI,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,chGtHD;EgGuHC,gBAAA;ApGyhgBZ;AoGvhgBY;EACI,gBAAA;ApGyhgBhB;AoGvhgBY;EACI,cAAA;ApGyhgBhB;AoGvhgBY;EACI,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;ApGyhgBhB;AoGrhgBQ;EACI,iBAAA;EACA,mBAAA;EACA,iBAAA;ApGuhgBZ;AoGnhgBQ;EACI,uBAAA;ApGqhgBZ;;AoGhhgBA;EACI,aAAA;ApGmhgBJ;;AoGhhgBA;EACI,YAAA;ApGmhgBJ;AoGlhgBI;EACI,sBAAA;EACA,iBAAA;ApGohgBR;;AoGhhgBA;EACI,0BAAA;ApGmhgBJ;AoGlhgBI;EACI,YAAA;EACA,WAAA;ApGohgBR;;AoG/ggBA;EACI;IACI,OAAA;IACA,eAAA;IACA,WAAA;EpGkhgBN;EoGjhgBM;IACI,cAAA;EpGmhgBV;EoG/ggBM;IACI,aAAA;EpGihgBV;AACF;AeltgBI;EqFuMI;IACI,aAAA;EpG8ggBV;AACF;AiGjvgBA,iBAAA;AI3CA;EACI,eAAA;EACA,SAAA;EACA,iBjG0CY;AJqvgBhB;;AqG3xgBI;EACI,6BAAA;EACA,UAAA;EACA,gBAAA;ArG8xgBR;AqG3xgBI;EACI,eAAA;ArG6xgBR;;AiG9vgBA,cAAA;AK7CA;EACI,SAAA;EACA,uBAAA;EACA,kBAAA;EACA,QAAA;EACA,clGyEO;EkGxEP,WlGCwB;AJ8ygB5B;AsG7ygBQ;EACI,clGqED;EkGpEC,mBAAA;EACA,oBAAA;AtG+ygBZ;AsG9ygBY;EACI,clGoEL;AJ4ugBX;AsG9ygBY;EACI,cAAA;AtGgzgBhB;;AsG1ygBA;EACI,kBAAA;EACA,kBAAA;EACA,6BAAA;AtG6ygBJ;;AejwgBI;EuFxCA;IACI,kBAAA;IACA,kBAAA;EtG6ygBN;AACF;AiG9xgBA,sBAAA;AM9CI;EACI,mBnG4RsB;EmG3RtB,kBnG2RsB;AJojgB9B;AuG50gBI;EACI,kBAAA;EACA,YAAA;AvG80gBR;AuGx0gBoB;EACI,cnGUC;AJg0gBzB;AuGn0gBI;EACI,eAAA;EACA,2BAAA;EACA,sBAAA;AvGq0gBR;AuGl0gBI;EACI,OAAA;AvGo0gBR;AuGj0gBI;EACI,iBAAA;AvGm0gBR;AuGh0gBI;EACI,cAAA;AvGk0gBR;AuG/zgBI;EACI;IACI,aAAA;EvGi0gBV;AACF;AuG9zgBI;EACI;IACI,cAAA;EvGg0gBV;AACF;;AuG3zgBA;EACI,mBnGQU;AJszgBd;;AuG3zgBA;EACI,SAAA;EACA,UAAA;AvG8zgBJ;AuG5zgBI;EACI,aAAA;AvG8zgBR;AuG3zgBI;EACI,aAAA;EACA,sBAAA;EACA,SAAA;AvG6zgBR;AuG1zgBY;EACI,YAAA;EACA,aAAA;EACA,WAAA;EACA,2CAAA;AvG4zgBhB;AuGxzgBQ;EACI,aAAA;AvG0zgBZ;AuGtzgBY;EAGI,cnG9DS;EmG+DT,qBAAA;AvGszgBhB;AuGpzgBgB;EACI,cnGjEK;EmGkEL,6BAAA;AvGszgBpB;AuGlzgBY;EACI,cnGzES;EmG0ET,eAAA;EACA,kBAAA;EACA,aAAA;EACA,cAAA;AvGozgBhB;AuGlzgBgB;EACI,qBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cnGpFK;EmGqFL,8BAAA;AvGozgBpB;AuGjzgBgB;EACI,sBAAA;AvGmzgBpB;AuGhzgBgB;EAGI,cnG9FK;EmG+FL,qBAAA;AvGgzgBpB;AuG9ygBoB;EACI,cnGjGC;EmGkGD,6BAAA;AvGgzgBxB;AuG1ygBgB;EACI,iBAAA;AvG4ygBpB;AuGxygBY;EACI,2BAAA;EACA,qBAAA;EACA,sBAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,0BAAA;EACA,sBAAA;EACA,gBAAA;AvG0ygBhB;AuGzygBgB;EACI,gBAAA;AvG2ygBpB;AuGtygBgB;EACI,cnG9HK;AJs6gBzB;AuGvygBoB;EACI,cnGhIC;EmGiID,6BAAA;AvGyygBxB;AuGtygBoB;EACI,yBAAA;AvGwygBxB;AuGlygBgB;EACI,cnG5IK;AJg7gBzB;AuGnygBoB;EACI,cnG9IC;EmG+ID,6BAAA;AvGqygBxB;AuGhygBY;EACI,cnGvJS;EmGwJT,yBnGlHF;EmGmHE,4BAAA;EACA,gCAAA;EACA,+BAAA;ElGpBZ,iCAAA;EkGsBY,8CnGuoBoB;EmGtoBpB,iBAAA;AvGkygBhB;AuG/xgBoB;EAGI,cnGnKC;EmGoKD,qBAAA;AvG+xgBxB;AuG7xgBoB;EACI,mBnGinBY;AJ8qfpC;AuG5xgBoB;EACI,sBnG6mBY;AJirfpC;AuG1xgBgB;EACI,cAAA;EACA,WAAA;EACA,kCAAA;EACA,WAAA;EACA,iBnG0IU;EmGzIV,gBnG+IU;EmG9IV,gBnGmJU;EmGlJV,mBAAA;EACA,6BAAA;EACA,SAAA;AvG4xgBpB;AMn+gBE;EiG0MsB,0DnG0mBY;EmGzmBZ,qBAAA;EjFrNpB,yBlByEO;AJy6gBX;AuGvxgBoB;EACI,gBAAA;AvGyxgBxB;AuGtxgBgB;EACI,YAAA;AvGwxgBpB;AuGpxgBY;EACI,cnG9MS;EmG+MT,+BAAA;AvGsxgBhB;AuGnxgBoB;EAGI,cnGpNC;EmGqND,qBAAA;AvGmxgBxB;AuGjxgBoB;EACI,mBnGgkBY;AJmtfpC;AuGhxgBoB;EACI,sBnG4jBY;AJstfpC;AuG9wgBgB;EACI,cAAA;EACA,WAAA;EACA,kCAAA;EACA,WAAA;EACA,iBnGyFU;EmGxFV,gBnG8FU;EmG7FV,gBnGkGU;EmGjGV,mBAAA;EACA,6BAAA;EACA,SAAA;EACA,+BAAA;AvGgxgBpB;AMzghBE;EiG4PsB,0DnGwjBY;EmGvjBZ,qBAAA;EjFvQpB,yBlByEO;AJ+8gBX;AuG3wgBoB;EACI,gBAAA;AvG6wgBxB;AuG1wgBgB;EACI,YAAA;AvG4wgBpB;;Aex+gBI;EwFsOI;IACI,cAAA;EvGswgBV;EuGlwgBU;IACI,cAAA;EvGowgBd;EuGlwgBkB;IACI,wBAAA;EvGowgBtB;EuGlwgBkB;IACI,cAAA;EvGowgBtB;EuG7vgBc;IACI,wBAAA;EvG+vgBlB;EuGzvgBU;IACI,cAAA;EvG2vgBd;EuGpvgBM;IAEI,mBAAA;EvGqvgBV;EuGnvgBU;IACI,sBAAA;EvGqvgBd;EuGnvgBc;IACI,kBAAA;IACA,aAAA;EvGqvgBlB;EuG9ugBkB;IACI,eAAA;EvGgvgBtB;EuGvugBE;IACI,aAAA;EvGyugBN;AACF;AehghBI;EwF6RQ;IACI,mBAAA;IACA,kBAAA;EvGsugBd;EuGlugBE;IACI,cAAA;EvGougBN;EuGlugBE;IACI,iBAAA;EvGougBN;EuGjugBc;IACI,iBAAA;EvGmugBlB;EuGhugBc;IACI,gBAAA;IACA,gBAAA;EvGkugBlB;EuGjugBkB;IACI,UAAA;EvGmugBtB;EuGjugBkB;IACI,6BAAA;EvGmugBtB;EuGlugBsB;IACI,6BAAA;EvGougB1B;EuG/tgBc;IACI,YAAA;IACA,eAAA;EvGiugBlB;AACF;AuG1tgBA;EAIgB;IACI,aAAA;EvGytgBlB;AACF;AiGzjhBA,qBAAA;AOjDA;EACI,yBpGiCsB;EoGhCtB,yEAAA;EACA,cAAA;EACA,eAAA;EACA,8BAAA;EACA,YpGyBuB;EoGxBvB,aAAA;EACA,uBAAA;EACA,aAAA;EACA,MAAA;EACA,SAAA;EACA,oBAAA;AxG6mhBJ;AwG3mhBI;EAEI,kBAAA;AxG4mhBR;AwG1mhBI;EACI,YAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AxG4mhBR;AwG1mhBI;EACI,aAAA;AxG4mhBR;;AwGvmhBA;EACI,2CAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,aAAA;EACA,aAAA;EACA,6BAAA;AxG0mhBJ;;AwGtmhBI;EACI,QAAA;AxGymhBR;AwGvmhBI;EACI,cAAA;AxGymhBR;;AerlhBI;EyFfA;IACI,cAAA;ExGwmhBN;EwGvmhBM;IACI,uBAAA;ExGymhBV;AACF;AwGnmhBI;EACI,gCAAA;EACA,iBAAA;AxGqmhBR;AwGpmhBQ;EACI,YAAA;AxGsmhBZ;;AwGhmhBI;EACI,kBAAA;EACA,YAAA;AxGmmhBR;;AiG5nhBA,eAAA;AlFKI;E0FrDJ;IACI,iBAAA;EzGirhBF;EyGhrhBE;IACI,aAAA;EzGkrhBN;EyG/qhBE;IACI,kBAAA;IACA,gBAAA;IACA,iBAAA;EzGirhBN;EyG9qhBE;IACI,kBAAA;EzGgrhBN;EyG7qhBE;IACI,cAAA;IACA,WAAA;IACA,oBAAA;EzG+qhBN;EyG3qhBM;IACI,eAAA;EzG6qhBV;EyG3qhBM;IACI,2BAAA;EzG6qhBV;AACF;AyGrqhBA;EACI,6DAAA;AzGuqhBJ;AyGrqhBI;EACI,iBrG7Bc;EqG8Bd,cAAA;EACA,6CrGqQsB;EqGpQtB,mBrGsLoB;AJi/gB5B;AyGpqhBI;EACI,iBrGpCc;EqGqCd,cAAA;AzGsqhBR;AyGnqhBI;EACI,cAAA;EACA,+BAAA;EACA,mBrG2KoB;AJ0/gB5B;AyGlqhBI;EACI,gBAAA;AzGoqhBR;AyGnqhBQ;EACI,8BAAA;AzGqqhBZ;;AiG7qhBA,eAAA;ASrDA;EACE,eAAA;A1GsuhBF;;A0GnuhBA;EACE,eAAA;A1GsuhBF;;A0GnuhBA;EACE,gBAAA;A1GsuhBF;;A0GnuhBA;EACE,gBAAA;A1GsuhBF;;A0GnuhBA;EACE,gBAAA;A1GsuhBF;;A0GjuhBA;EACE,sCtG4T4B;AJw6gB9B;;A0GhuhBA;EACE,cAAA;EACA,aAAA;A1GmuhBF;;A0GhuhBA;EACE,eAAA;EACA,cAAA;A1GmuhBF;;A0GhuhBA;EACE,YAAA;EACA,WAAA;A1GmuhBF;;A0GhuhBA;EACE,cAAA;EACA,aAAA;A1GmuhBF;;A0GhuhBA;EACE,cAAA;EACA,aAAA;A1GmuhBF;;A0GhuhBA;EACE,YAAA;EACA,WAAA;A1GmuhBF;;A0GhuhBA;EACE,cAAA;EACA,aAAA;A1GmuhBF;;A0GhuhBA;EACE,mBAAA;EACA,WtGMS;EsGLT,aAAA;EACA,YAAA;EACA,uBAAA;EACA,WAAA;A1GmuhBF;;A0GhuhBA;EACE,kBAAA;A1GmuhBF;A0GluhBE;EACE,sBAAA;EACA,qBAAA;EACA,sBAAA;EACA,kBAAA;A1GouhBJ;;A0G7thBA;EACE,gBAAA;A1GguhBF;;A0G7thBA;EACE,gBAAA;A1GguhBF;;A0G1thBA;;;;EAIE,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,4BAAA;A1G6thBF;;A0G1thBA;EACE,qBAAA;A1G6thBF;;A0G1thBA;EACE,qBAAA;A1G6thBF;;A0GzthBA;EACE,qBAAA;A1G4thBF;;A0GzthBA;EACE,qBAAA;A1G4thBF;;A0GvthBA;EACE,qBAAA;EACA,sBAAA;A1G0thBF;;AiGjyhBA,eAAA;AUxDA;EACI,YAAA;EACA,WAAA;EACA,6BAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,cvGqEO;AJwxhBX;;AiG1yhBA,gBAAA;AWzDA;EACI,kBAAA;EACA,gBAAA;A5Gu2hBJ;A4Gr2hBI;EACI,eAAA;A5Gu2hBR;;A4Gn2hBA,gBAAA;AAEA;EACI,gBAAA;EACA,aAAA;EACA,cAAA;A5Gq2hBJ;A4Gn2hBI;EACI,mBAAA;A5Gq2hBR;A4Gl2hBI;EACI,WAAA;EACA,kBAAA;EACA,WAAA;A5Go2hBR;A4Gl2hBQ;EACI,mBAAA;EACA,WAAA;A5Go2hBZ;A4Gj2hBQ;EACI,eAAA;EACA,kBAAA;A5Gm2hBZ;A4G/1hBI;EACI,6DAAA;EACA,cxG6DE;EwG5DF,qBxGkQsB;EwGjQtB,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;A5Gi2hBR;A4G/1hBQ;EACI,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBxG4SkB;EwG3SlB,kBAAA;A5Gi2hBZ;A4G91hBQ;EACI,SAAA;EACA,gBAAA;A5Gg2hBZ;A4G71hBQ;EACI,UAAA;EACA,MAAA;EACA,yBAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,oBAAA;EACA,mEAAA;EACA,iBAAA;EACA,iBAAA;EACA,qEAAA;A5G+1hBZ;A4G31hBI;EACI,WAAA;EACA,eAAA;EACA,iBAAA;EACA,UAAA;A5G61hBR;A4Gz1hBQ;EACI,uBAAA;A5G21hBZ;A4Gx1hBQ;EACI,uBAAA;EACA,kBAAA;EACA,iBAAA;EACA,qBAAA;A5G01hBZ;A4Gv1hBQ;EACI,yBxGrBD;EwGsBC,cxGlBD;AJ22hBX;A4Gx1hBY;EACI,yBAAA;EACA,0BxGzBL;EwG0BK,yBxG1BL;EwG2BK,oBAAA;A5G01hBhB;;A4Gp1hBA,oBAAA;AACA;EACI,kBAAA;A5Gu1hBJ;A4Gr1hBI;EACI,kBAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;A5Gu1hBR;A4Gp1hBI;EACI,iBAAA;A5Gs1hBR;A4Gn1hBI;EACI,mBAAA;A5Gq1hBR;;A4Gh1hBI;EACI,gBAAA;EACA,oCAAA;A5Gm1hBR;A4Gj1hBI;EACI,aAAA;A5Gm1hBR;;AiG55hBA,wBAAA;AY5DI;EACI,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;A7G49hBR;A6G39hBQ;EACI,yBzGmED;EyGlEC,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,qBAAA;EACA,YAAA;EACA,OAAA;EACA,kBAAA;EACA,kBAAA;EACA,4BAAA;EACA,WAAA;EACA,wBAAA;EACA,QAAA;A7G69hBZ;A6G39hBQ;EACI,czGwDD;EyGvDC,qBAAA;EACA,eAAA;EACA,YAAA;EACA,OAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;A7G69hBZ;A6G19hBI;EACI,eAAA;EACA,UAAA;EACA,UAAA;EACA,wBAAA;A7G49hBR;A6G39hBQ;EACI,aAAA;A7G69hBZ;A6Gz9hBQ;EACI,oBAAA;EACA,aAAA;A7G29hBZ;A6Gv9hBQ;EACI,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gCAAA;EACA,4BAAA;EACA,2BAAA;EACA,wBAAA;A7Gy9hBZ;A6Gr9hBQ;EACI,yBzGID;EyGHC,mBAAA;A7Gu9hBZ;;A6Gh9hBQ;EACI,kBAAA;A7Gm9hBZ;;A6G98hBA;EACI,aAAA;A7Gi9hBJ;;A6G78hBI;EACI,YAAA;EACA,WAAA;EACA,kBAAA;A7Gg9hBR;A6G98hBI;EACI,YAAA;EACA,WAAA;A7Gg9hBR;A6G/8hBQ;EACI,cAAA;A7Gi9hBZ;A6G/8hBQ;EACI,cAAA;A7Gi9hBZ;;A6Gx8hBY;EACI,yBzGgCD;EyG/BC,qBzG+BD;AJ46hBf;A6Gz8hBY;EACI,kBzG5CL;AJu/hBX;;A6Gh9hBY;EACI,yBzGgCD;EyG/BC,qBzG+BD;AJo7hBf;A6Gj9hBY;EACI,kBzG5CL;AJ+/hBX;;A6Gx9hBY;EACI,yBzGgCD;EyG/BC,qBzG+BD;AJ47hBf;A6Gz9hBY;EACI,kBzG5CL;AJugiBX;;A6Gh+hBY;EACI,yBzGgCD;EyG/BC,qBzG+BD;AJo8hBf;A6Gj+hBY;EACI,kBzG5CL;AJ+giBX;;A6Gx+hBY;EACI,yBzGgCD;EyG/BC,qBzG+BD;AJ48hBf;A6Gz+hBY;EACI,kBzG5CL;AJuhiBX;;A6Gh/hBY;EACI,yBzGgCD;EyG/BC,qBzG+BD;AJo9hBf;A6Gj/hBY;EACI,kBzG5CL;AJ+hiBX;;A6Gx/hBY;EACI,yBzGgCD;EyG/BC,qBzG+BD;AJ49hBf;A6Gz/hBY;EACI,kBzG5CL;AJuiiBX;;A6GhgiBY;EACI,yBzGgCD;EyG/BC,qBzG+BD;AJo+hBf;A6GjgiBY;EACI,kBzG5CL;AJ+iiBX;;AiGxjiBA,qBAAA;Aa9DI;EACI,qBAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;A9G0niBR;A8GzniBQ;EACI,sCAAA;EACA,2CAAA;EACA,sB1G8DD;E0G7DC,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,qBAAA;EACA,YAAA;EACA,OAAA;EACA,kBAAA;EACA,kBAAA;EACA,mCAAA;EACA,WAAA;EACA,wBAAA;A9G2niBZ;A8GzniBQ;EACI,wEAAA;EACA,0BAAA;EACA,yBAAA;EACA,oEAAA;EACA,8BAAA;EACA,8EAAA;EACA,yB1GiDD;E0GhDC,kBAAA;EACA,YAAA;EACA,qBAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,sBAAA;EACA,8DAAA;EACA,WAAA;A9G2niBZ;A8GxniBI;EACI,eAAA;EACA,UAAA;EACA,UAAA;EACA,wBAAA;A9G0niBR;A8GzniBQ;EACI,aAAA;A9G2niBZ;A8GvniBQ;EACI,oBAAA;EACA,0CAAA;EACA,oBAAA;A9GyniBZ;A8GrniBQ;EACI,0BAAA;EACA,yBAAA;EACA,8BAAA;EACA,sBAAA;A9GuniBZ;A8GnniBQ;EACI,mBAAA;A9GqniBZ;;A8GhniBA;EACI,aAAA;A9GmniBJ;;A8G/miBI;EACI,YAAA;A9GkniBR;;A8G1miBY;EACI,yB1GsDD;AJujiBf;A8GzmiBY;EACI,qB1GiDD;AJ0jiBf;A8GzmiBY;EACI,yB1G8CD;AJ6jiBf;;A8GpniBY;EACI,yB1GsDD;AJikiBf;A8GnniBY;EACI,qB1GiDD;AJokiBf;A8GnniBY;EACI,yB1G8CD;AJukiBf;;A8G9niBY;EACI,yB1GsDD;AJ2kiBf;A8G7niBY;EACI,qB1GiDD;AJ8kiBf;A8G7niBY;EACI,yB1G8CD;AJiliBf;;A8GxoiBY;EACI,yB1GsDD;AJqliBf;A8GvoiBY;EACI,qB1GiDD;AJwliBf;A8GvoiBY;EACI,yB1G8CD;AJ2liBf;;A8GlpiBY;EACI,yB1GsDD;AJ+liBf;A8GjpiBY;EACI,qB1GiDD;AJkmiBf;A8GjpiBY;EACI,yB1G8CD;AJqmiBf;;A8G5piBY;EACI,yB1GsDD;AJymiBf;A8G3piBY;EACI,qB1GiDD;AJ4miBf;A8G3piBY;EACI,yB1G8CD;AJ+miBf;;A8GtqiBY;EACI,yB1GsDD;AJmniBf;A8GrqiBY;EACI,qB1GiDD;AJsniBf;A8GrqiBY;EACI,yB1G8CD;AJyniBf;;A8GhriBY;EACI,yB1GsDD;AJ6niBf;A8G/qiBY;EACI,qB1GiDD;AJgoiBf;A8G/qiBY;EACI,yB1G8CD;AJmoiBf;;AiGltiBA,cAAA;AchEA;EACI;;;;;IAKI,aAAA;E/GsxiBN;E+GpxiBE;;;;;IAKI,UAAA;IACA,SAAA;E/GsxiBN;AACF;AiGnuiBA,kBAAA;AenEA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,2CAAA;EACA,aAAA;AhHyyiBJ;;AgHtyiBA;EACI,YAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,uBAAA;AhHyyiBJ;;AgHryiBI;EACI,qBAAA;EACA,WAAA;EACA,YAAA;EACA,gB5GiDG;E4GhDH,yBAAA;EACA,kBAAA;EACA,qDAAA;EACA,eAAA;AhHwyiBR;AgHtyiBI;EACI,uBAAA;AhHwyiBR;AgHtyiBI;EACI,uBAAA;AhHwyiBR;;AgHnyiBA;EACI;IACI,qBAAA;EhHsyiBN;EgHryiBI;IACE,mBAAA;EhHuyiBN;AACF;AiG3wiBA,gBAAA;AgBvEA;EACI,uBAAA;AjHq1iBJ;;AiHl1iBA;EACI,kCAAA;AjHq1iBJ;AiHn1iBI;EACI,kCAAA;AjHq1iBR;;AiHj1iBA;EACI,qBAAA;EACA,mBAAA;AjHo1iBJ;;AiHj1iBA;;;EAGI,qBAAA;EACA,mBAAA;AjHo1iBJ;;AkH12iBA;EACI,2BAAA;AlH62iBJ;AkH32iBI;EACI,iDAAA;EACA,a9G2EG;AJkyiBX;AkH12iBI;EACI,cAAA;AlH42iBR;;AkHx2iBA;;EAEI,iDAAA;AlH22iBJ;;AkHx2iBA;EACI,gBAAA;AlH22iBJ;;AkHx2iBA;EACI,oBAAA;EACA,e9GqCc;AJs0iBlB;;AkHx2iBA;EACI,yBAAA;EACA,iDAAA;EACA,0BAAA;AlH22iBJ;;AkHx2iBA;EACI,qBAAA;AlH22iBJ;;AkHt2iBI;;EACI,iDAAA;EACA,a9GqCG;AJq0iBX;;AkHn2iBI;;;EACI,U9GwBG;AJg1iBX;;AkHn2iBI;EACI,iBAAA;EACA,e9GoBG;AJk1iBX;AkHn2iBI;EACI,e9GgBG;AJq1iBX;;AkHj2iBA;;;;EAII,qBAAA;AlHo2iBJ;;AmHl6iBA;EACI,WAAA;EACA,gBAAA;AnHq6iBJ;;AmHl6iBA;EACI,gBAAA;AnHq6iBJ;;AmHj6iBI;EACI,gBAAA;AnHo6iBR;;AmHh6iBA;EACI,oBAAA;AnHm6iBJ;AmHj6iBI;EACI,kBAAA;EACA,qBAAA;EACA,yBAAA;AnHm6iBR;;AmH95iBI;EACI,gB/GoBa;AJ64iBrB;;AmH75iBA;EACI,iBAAA;AnHg6iBJ;;AmH75iBA;EACI,uBAAA;AnHg6iBJ;;AmH35iBI;;;;;EAKI,UAAA;AnH85iBR;;AmHz5iBI;EACI,mB/GkBG;E+GjBH,eAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,gB/GVa;AJs6iBrB;;AmHt5iBI;;;;;;;EAOI,qBAAA;AnHy5iBR;AmHt5iBI;;EAEI,mB/GLG;AJ65iBX;;AmHn5iBA;EACI,mB/GXO;E+GYP,YAAA;EACA,c/GTO;E+GUP,0BAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,YAAA;AnHs5iBJ;;AmHn5iBA;EACI,oBAAA;EACA,eAAA;AnHs5iBJ;;AmHn5iBA;EACI,mB/G5BO;AJk7iBX;;AmHn5iBA;EACI,mB/GhCO;AJs7iBX;;AmHn5iBA;;;EAGI,yB/GZM;E+GaN,W/G1CO;E+G2CP,iBAAA;AnHs5iBJ;;AmHn5iBA;EACI,mB/G5CO;AJk8iBX;;AmHl5iBI;EACI,gB/GpDG;AJy8iBX;;AmHj5iBA;EACI,6BAAA;EACA,uBAAA;EACA,oCAAA;EACA,YAAA;EACA,+BAAA;EACA,0BAAA;EACA,2BAAA;EACA,6BAAA;AnHo5iBJ;;AmHj5iBA;EACI,YAAA;EACA,cAAA;EACA,iBAAA;EACA,W/GvEO;E+GwEP,kBAAA;AnHo5iBJ;;AmH/4iBQ;EACI,kBAAA;AnHk5iBZ;AmH94iBI;EACI,kBAAA;AnHg5iBR;AmH74iBI;EACI,W/GvFG;AJs+iBX;;AmH14iBI;EACI,W/G7FG;AJ0+iBX;;Ae7+iBI;EoGqGA;IACI,cAAA;EnH44iBN;EmH14iBM;;;IAGI,WAAA;IACA,cAAA;IACA,WAAA;IACA,cAAA;EnH44iBV;EmHr4iBc;IACI,WAAA;EnHu4iBlB;EmHj4iBE;IACI,aAAA;EnHm4iBN;AACF;AmH93iBI;E3FpGF,uBAAA;EnB4EI,oBAAA;EmB1EJ,gBpBgM4B;EOxR1B,qBAAA;AX8jjBJ;;AoH3kjBI;EACI,yBAAA;EACA,6BAAA;ApH8kjBR;AoH5kjBQ;EACI,yBAAA;ApH8kjBZ;AoH1kjBI;EACI,chHoEG;AJwgjBX;;AoHxkjBA;EACI,oDAAA;EACA,yBAAA;ApH2kjBJ;;AoHxkjBA;EACI,2BAAA;EACA,6EAAA;EACA,yEAAA;ApH2kjBJ;;AoHxkjBA;EACI,yEAAA;EACA,2BAAA;ApH2kjBJ;;AoHxkjBA;EACI,aAAA;ApH2kjBJ;;AoHxkjBA;EACI,chH0CO;AJiijBX;;AoHxkjBA;EACI,oCAAA;EACA,wDAAA;EACA,uBAAA;EACA,gCAAA;EACA,wBAAA;ApH2kjBJ;;AoHxkjBA;EACI,6EAAA;EACA,gCAAA;ApH2kjBJ;;AoHxkjBA;EACI,kCAAA;EACA,yBAAA;ApH2kjBJ;AoHzkjBI;EACI,qEAAA;EACA,oCAAA;ApH2kjBR;;AoHvkjBA;;EAEI,qEAAA;EACA,oCAAA;ApH0kjBJ;;AoHvkjBA;EACI,oDAAA;EACA,yBAAA;ApH0kjBJ;AoHxkjBI;EACI,chH4BE;AJ8ijBV;AoHtkjBQ;EACI,oDAAA;EACA,yBAAA;ApHwkjBZ;;AqHvpjBA;EACI,kFAAA;EACA,WAAA;EACA,gBAAA;ArH0pjBJ;AqHxpjBI;EACI,gBAAA;EACA,yBAAA;ArH0pjBR;AqHxpjBQ;EACI,gBAAA;EACA,kEAAA;ArH0pjBZ;AqHvpjBI;EACI,kEjHugBgC;AJkpiBxC;AqHvpjBY;EACI,YAAA;EACA,iBAAA;EACA,cjH0DL;AJ+ljBX;AqHvpjBY;EACI,yBjH8EN;EiH7EM,WjHgDL;AJymjBX;AqHrpjBI;EACI,kEjHyfgC;AJ8piBxC;AqHrpjBY;EACI,YAAA;EACA,iBAAA;EACA,cjH4CL;AJ2mjBX;AqHrpjBY;EACI,yBjHgEN;EiH/DM,WjHkCL;AJqnjBX;;AqHjpjBA;EACI,gBAAA;EACA,wBAAA;ArHopjBJ;;AqHjpjBA;EACI,gBjHEiB;EiHDjB,sCjHkS0B;EiHjS1B,yBAAA;EACA,eAAA;ArHopjBJ;;AsH3sjBA;EACE,gBAAA;EACA,yBlH+3BkC;EkH93BlC,gBAAA;EACA,yBAAA;AtH8sjBF;AsH5sjBE;EACE,uBAAA;AtH8sjBJ;AsH5sjBI;;EAEE,clHqEK;AJyojBX;AsH5sjBM;;;EAEE,mBlH8DG;AJipjBX;;AsHzsjBA;EACE,clH0DS;AJkpjBX;AsH1sjBE;EAkBE,8BAAA;EACA,gCAAA;AtH2rjBJ;AsHxrjBE;EAGE,wCAAA;AtHwrjBJ;AsHrrjBE;EACE,gCAAA;AtHurjBJ;AsHprjBE;EACE,uEAAA;EACA,yEAAA;EACA,iFAAA;AtHsrjBJ;AsHprjBI;EACE,uEAAA;EACA,yEAAA;AtHsrjBN;AsHlrjBE;EAOE,+BAAA;AtH8qjBJ;AsH3qjBE;EAaE,8BAAA;EACA,gCAAA;EACA,clHZO;AJ6qjBX;;AsH3pjBE;;;;EAIE,8BAAA;AtH8pjBJ;;AsHvpjBE;EACE,uBAAA;AtH0pjBJ;AsHvpjBE;;EAEE,wBAAA;AtHypjBJ;;AsHrpjBA;EACE,clHvCS;EkHwCT,0BAAA;EACA,6BAAA;AtHwpjBF;AsHrpjBI;EACE,clH7CK;AJosjBX;;AsHlpjBA;EACE,8BAAA;EACA,aAAA;AtHqpjBF;;AsHlpjBA;EACE,0CAAA;AtHqpjBF;;AuH1xjBQ;EACI,UAAA;EACA,YAAA;EACA,6BAAA;EACA,cAAA;AvH6xjBZ;;AwHnyjBA;EACE,SAAA;EACA,UAAA;AxHsyjBF;AwHpyjBE;EACE,gBAAA;EACA,cpHmGM;EoHlGN,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,qBAAA;EACA,yCAAA;EACA,kBAAA;AxHsyjBJ;AwHpyjBI;EACE,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;AxHsyjBN;AwHpyjBI;EACE,WAAA;EACA,6BAAA;EACA,4CAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;AxHsyjBN;;AwHjyjBA;EACE,qBpHwEQ;AJ4tjBV;;AwHjyjBA;EACE,qBpHuEQ;AJ6tjBV;;AyHz0jBA;EACI,gBAAA;EACA,kEAAA;AzH40jBJ;AyH10jBI;EACI,uBAAA;EACA,aAAA;AzH40jBR;AyH10jBI;EACI,wCAAA;AzH40jBR;;AyHr0jBI;EACI,6BAAA;AzHw0jBR;AyHn0jBY;EACI,crHuDL;AJ8wjBX;AyHp0jBgB;EACI,crHqDT;AJixjBX;AyHp0jBgB;EACI,mBrHyEV;AJ6vjBV;AyHl0jBgB;EACI,yBAAA;AzHo0jBpB;AyHh0jBgB;EACI,yBAAA;AzHk0jBpB;AyHj0jBoB;EACI,mBrHoEd;AJ+vjBV;;AyHxzjBI;EACI,mBrHuBG;EqHtBH,4BrHsBG;AJqyjBX;AyHxzjBY;EACI,mBrHkBL;EqHjBK,crHoBL;AJsyjBX;AyHtzjBgB;EACI,qCAAA;AzHwzjBpB;AyHtzjBgB;EACI,qCAAA;AzHwzjBpB;AyHpzjBgB;EACI,8BAAA;EACA,gCAAA;AzHszjBpB;AyHrzjBoB;EACI,qCAAA;AzHuzjBxB;AyHjzjBgB;EACI,0EAAA;EACA,4EAAA;AzHmzjBpB;AyHlzjBoB;EACI,iFAAA;AzHozjBxB;AyHlzjBoB;EACI,qCAAA;AzHozjBxB;;AyHzyjBI;EACI,gBAAA;EACA,6BAAA;AzH4yjBR;AyH3yjBQ;EACI,yBrH3BD;AJw0jBX;AyHzyjBY;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,yBrHpCL;EqHqCK,gCAAA;EACA,2BAAA;AzH2yjBhB;AyH1yjBgB;EACI,yBrHxCT;AJo1jBX;AyHxyjBgB;EACI,aAAA;EACA,WAAA;AzH0yjBpB;AyHtyjBY;EACI,crHhDL;AJw1jBX;AyHvyjBgB;EACI,crHlDT;AJ21jBX;AyHryjBgB;EACI,8BAAA;EACA,gCAAA;EACA,sBAAA;AzHuyjBpB;AyHtyjBoB;EACI,crHpCd;AJ40jBV;AyHlyjBgB;EACI,8BAAA;EACA,gCAAA;EACA,sBAAA;AzHoyjBpB;AyHnyjBoB;EACI,crHxCd;AJ60jBV;;AyH1xjBI;EACI,6BAAA;AzH6xjBR;AyH5xjBQ;EACI,yBrHvFD;AJq3jBX;AyH1xjBgB;EACI,YAAA;EACA,mBrH7FT;AJy3jBX;AyHzxjBgB;EACI,SAAA;EACA,YAAA;EACA,mBrHlGT;AJ63jBX;AyHxxjBY;EACI,crHpGL;AJ83jBX;AyHvxjBgB;EACI,crHjFV;AJ02jBV;AyHxxjBoB;EACI,mBrHnFd;AJ62jBV;AyHrxjBgB;EACI,crHlFV;AJy2jBV;AyHtxjBoB;EACI,mBrHpFd;AJ42jBV;;AyH5wjBA;EAGY;IACI,cAAA;IACA,WAAA;EzH6wjBd;EyHtwjBc;IACI,YAAA;IACA,UAAA;EzHwwjBlB;EyHhwjBc;IACI,UAAA;IACA,sBAAA;EzHkwjBlB;AACF;A0Hv+jBA,qBAAA;AACA;EACE,yBAAA;EACA,sBAAA;EACA,iBAAA;A1Hy+jBF;A0Hv+jBE;EACE,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,ctHoEO;AJq6jBX;A0Ht+jBE;EACE,gBAAA;EACA,yBAAA;EACA,sBAAA;A1Hw+jBJ;;A0Hp+jBA;EACE,wBAAA;A1Hu+jBF;;Aex7jBI;E2G3CF;IACE,iBAAA;E1Hu+jBF;AACF;A0Hp+jBA;EACE,kCAAA;EACA,ctH8CS;EsH7CT,oCAAA;A1Hs+jBF;A0Hp+jBE;EACE,kCAAA;EACA,oCAAA;A1Hs+jBJ;A0Hp+jBI;EACE,2BAAA;A1Hs+jBN;;A2H/gkBA;EACE,2CAAA;EACA,4DAAA;EACA,kBAAA;A3HkhkBF;;A4HphkBA;EACI,yBAAA;A5HuhkBJ;;A4HnhkBI;EACI,kBAAA;A5HshkBR;;Aex9jBI;E6GzDA;IACI,gBAAA;IACA,2BAAA;E5HqhkBN;AACF;A4HjhkBI;EACI,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;A5HmhkBR;;A6HtikBM;EACE,uBAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,aAAA;A7HyikBR;A6HtikBQ;EACE,yBzHwFA;EyHvFA,WzH0DC;AJ8+jBX;;A6HhikBE;EACE,2FzH6mBgC;AJs7iBpC;;A6H9hkBE;EACE,aAAA;A7HiikBJ;;A8H9jkBA;EACI,gBAAA;EACA,gBAAA;A9HikkBJ;A8HhkkBI;EACE,yB1H23B8B;E0H13B9B,wD1H4SwB;E0H3SxB,aAAA;EACA,mBAAA;EACA,kBAAA;A9HkkkBN;A8HjkkBM;EACE,gBAAA;A9HmkkBR;A8HlkkBQ;EACE,gBAAA;EACA,eAAA;A9HokkBV;;A8H3jkBA;EACE,qCAAA;EACA,oCAAA;EACA,aAAA;EACA,2BAAA;A9H8jkBF;;A+H5lkBA;;;;;;;CAAA;AASA;EACE,qCAAA;EACA,iCAAA;A/H8lkBF;;A+H3lkBA;EACE,aAAA;A/H8lkBF;;A+H3lkBA;EACE,kBAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,uFAAA;A/H8lkBF;;A+H3lkBA;EACE,kBAAA;A/H8lkBF;;A+H3lkBA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,qBAAA;EACA,qBAAA;EACA,2CAAA;EACA,qBAAA;EACA,QAAA;EACA,0FAAA;A/H8lkBF;;A+H3lkBA;EACE,6CAAA;A/H8lkBF;;A+H3lkBA;;EAEE,4CAAA;A/H8lkBF;;A+H3lkBA;EACE;;IAEE,iCAAA;E/H8lkBF;AACF;AgIrpkBA;EACI,UAAA;AhIupkBJ;AgIrpkBI;EACI,gBAAA;AhIupkBR;AgIppkBY;EACI,yBAAA;AhIspkBhB;AgIjpkBI;EACI,UAAA;AhImpkBR;AgIjpkBQ;EACI,WAAA;AhImpkBZ;AgI/okBI;EACI,aAAA;AhIipkBR;AgI9okBI;EACI,kBAAA;EACA,SAAA;EACA,gBAAA;EACA,gCAAA;EACA,0BAAA;EACA,uCAAA;AhIgpkBR;;AiI/qkBE;EACE,UAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;AjIkrkBJ;AiI/qkBE;EACE,UAAA;EACA,SAAA;EACA,YAAA;AjIirkBJ;;AkI9rkBA;EACI,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;AlIiskBJ;;AkI/rkBA;EACI,sBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AlIkskBJ;;AkIhskBA;EACI,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,eAAA;AlImskBJ;;AkIjskBA;EACI,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,YAAA;AlIoskBJ;;AkIlskBA;EACI,aAAA;AlIqskBJ;;AkInskBA;EACI,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AlIsskBJ;;AkIpskBA;EACI,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;AlIuskBJ;;AkIrskBA;EACI,uBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AlIwskBJ;;AkItskBA;EACI,yBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AlIyskBJ;;AkIvskBA;EACI,yBAAA;AlI0skBJ;;AkIxskBA;EACI,yBAAA;AlI2skBJ;;AkIzskBA;EACI,sBAAA;AlI4skBJ;;AkI1skBA;EACI,eAAA;EACA,sBAAA;AlI6skBJ;;AkI3skBA;EACI,eAAA;EACA,sBAAA;AlI8skBJ;;AkI5skBA;EACI,yBAAA;EACA,YAAA;EACA,mDAAA;EACA,WAAA;AlI+skBJ;;AkI5skBA;EACI,yBAAA;EACA,YAAA;EACA,yBAAA;EACA,WAAA;AlI+skBJ;;AkI5skBA;EACI,gBAAA;AlI+skBJ;;AkI7skBA;EACI,eAAA;EACA,cAAA;EACA,kBAAA;AlIgtkBJ;;AkI9skBA;EACI,cAAA;AlIitkBJ;;AkI9skBA;EACI,eAAA;EACA,cAAA;EACA,kBAAA;AlIitkBJ;;AkI/skBA;EACI,YAAA;AlIktkBJ;;AkI/skBA;EACI,2BAAA;EACE,yBAAA;EACA,8BAAA;EACF,uBAAA;AlIktkBJ;;AkI9skBA;EACI,6BAAA;EACA,2BAAA;EACE,yBAAA;EACA,mBAAA;EACF,6BAAA;AlIitkBJ;;AkI7skBA;EACI,2BAAA;EACE,yBAAA;EACA,8BAAA;EACF,mDAAA;EACA,uBAAA;AlIgtkBJ;;AkI5skBA;EACI,6BAAA;AlI+skBJ;;AkI7skBA;EACI,2BAAA;EACE,yBAAA;EACA,8BAAA;EACF,yBAAA;EACA,yBAAA;AlIgtkBJ;;AkI5skBA;EACI,eAAA;AlI+skBJ;;AkI7skBA;EACI,eAAA;AlIgtkBJ;;AkI9skBA;EACI,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,yDAAA;EACA,iDAAA;AlIitkBJ;;AkI/skBA;EACI,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,oCAAA;EACA,yBAAA;EACA,kBAAA;EACA,yDAAA;EACA,iDAAA;AlIktkBJ;;AkIhtkBA;EACI;IACI,eAAA;IACA,cAAA;IACA,kBAAA;ElImtkBN;AACF;AkIjtkBA;EACI;IACI,eAAA;IACA,cAAA;IACA,kBAAA;ElImtkBN;AACF;AmIx5kBA;EACE,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,iCAAA;AnI05kBF;AmIx5kBE;;EAEE,kBAAA;EACA,mBAAA;AnI05kBJ;AmIv5kBE;EACE,kBAAA;AnIy5kBJ;AmIt5kBE;EACE,oBAAA;AnIw5kBJ;;AoIr6kBA;EACI,sBAAA;ApIw6kBJ;AoIt6kBI;EACI,sBAAA;ApIw6kBR;AoIt6kBQ;EACI,sBAAA;ApIw6kBZ;AoIt6kBY;EACI,sBAAA;ApIw6kBhB;AoIn6kBI;EACI,YAAA;ApIq6kBR;;AoIj6kBA;EACI,yBAAA;ApIo6kBJ;;AoIj6kBA;EACI,gBAAA;ApIo6kBJ;;AoIj6kBA;EACI,yBAAA;ApIo6kBJ;;AoIj6kBA;EACI,WAAA;EACA,mBAAA;EACA,YAAA;ApIo6kBJ;;AoIj6kBA;EACI,yBAAA;ApIo6kBJ;;AoIj6kBA;;EAEI,sBAAA;EACA,oCAAA;EACA,gCAAA;ApIo6kBJ;;AoIj6kBA;EACI,UAAA;EACA,WAAA;EACA,oCAAA;EACA,gCAAA;ApIo6kBJ;;AoIj6kBA;EACI,iBAAA;EACA,uBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,uDAAA;ApIo6kBJ;;AoIj6kBA;EACI,4CAAA;EACA,oCAAA;EACA,6BAAA;ApIo6kBJ;;AoIj6kBA;EACI,yBAAA;EACA,uBAAA;EACA,2CAAA;EACA,6BAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,oBAAA;EACA,iBAAA;ApIo6kBJ;;AoIj6kBA;EACI,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,oBAAA;EACA,iBAAA;ApIo6kBJ;;AoIj6kBA;EACI,yBAAA;ApIo6kBJ;;AoIj6kBA;EACI,yBAAA;ApIo6kBJ;;AoIj6kBA;EACI,YAAA;EACA,eAAA;EACA,UAAA;EACA,oBAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;ApIo6kBJ;;AoIj6kBA;EACI,kCAAA;EACA,uBAAA;EACA,2BAAA;EACA,oCAAA;EACA,6BAAA;EACA,0BAAA;EACA,4BAAA;EACA,6BAAA;ApIo6kBJ;;AoIj6kBA;EACI,kCAAA;EACA,uBAAA;EACA,2BAAA;EACA,oCAAA;EACA,6BAAA;EACA,0BAAA;EACA,4BAAA;EACA,6BAAA;EACA,uBAAA;ApIo6kBJ;;AoIj6kBA;EACI,oCAAA;ApIo6kBJ;;AoIj6kBA;EACI,oCAAA;EACA,uBAAA;ApIo6kBJ;;AoIj6kBA;EACI,yBAAA;EACA,6BAAA;EACA,0BAAA;EACA,uBAAA;EACA,sBAAA;ApIo6kBJ;;AoIj6kBA;EACI,YAAA;ApIo6kBJ;;AoIj6kBA;EACI,kBAAA;ApIo6kBJ;;AoIj6kBA;EACI,eAAA;EACA,iBAAA;EACA,gBAAA;ApIo6kBJ;;AoIj6kBA;EACI,YAAA;ApIo6kBJ;;AoIj6kBA;EACI,YAAA;ApIo6kBJ;;AoIj6kBA;EACI,wBAAA;ApIo6kBJ;;AoIj6kBA;EACI,eAAA;EACA,2BAAA;EACA,mBAAA;ApIo6kBJ;;AoIj6kBA;EACI,8BAAA;ApIo6kBJ;;AoIj6kBA;EACI,mBAAA;EACA,cAAA;ApIo6kBJ;;AoIj6kBA;EACI,WAAA;EACA,0BAAA;EACA,YAAA;ApIo6kBJ;;AoIj6kBA;EACI,eAAA;EACA,kBAAA;ApIo6kBJ;;AoIj6kBA;EACI,aAAA;EACA,8BAAA;ApIo6kBJ;;AoIj6kBA;EACI,uBAAA;ApIo6kBJ;;AoIj6kBA;EACI,oCAAA;ApIo6kBJ;;AoIj6kBA;EACI,WAAA;EACA,yBAAA;EACA,YAAA;ApIo6kBJ;;AoIj6kBA;EACI,WAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;ApIo6kBJ;;AoIj6kBA;EACI,WAAA;EACA,yBAAA;EACA,YAAA;ApIo6kBJ;;AoIj6kBA;EACI,YAAA;ApIo6kBJ;;AoIj6kBA;EACI,uBAAA;ApIo6kBJ;;AoIj6kBA;EACI,yBAAA;ApIo6kBJ;;AoIj6kBA;EACI,aAAA;EACA,2BAAA;ApIo6kBJ;;AoIj6kBA;EACI,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,6BAAA;EACA,iBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;ApIo6kBJ;;AoI75kBA;EACI,mBAAA;EACA,uBAAA;EACA,yBAAA;ApIg6kBJ;;AoIz5kBA;EACI,mBAAA;EACA,uBAAA;EACA,uBAAA;ApI45kBJ;;AoIz5kBA;EACI,eAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;ApI45kBJ;;AoIz5kBA;EACI,YAAA;EACA,yBAAA;ApI45kBJ;;AoIz5kBA;EACI,YAAA;EACA,yBAAA;ApI45kBJ;;AoIz5kBA;EACI,aAAA;EACA,sBAAA;ApI45kBJ;;AoIx5kBA;EACI,YAAA;ApI25kBJ;;AoIt5kBA;EACI,6BAAA;EACA,kBAAA;EACA,iEAAA;EACA,yEAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;ApIy5kBJ;;AoIt5kBA;EACI,6BAAA;EACA,kBAAA;EACA,iEAAA;EACA,yEAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;ApIy5kBJ;;AoIt5kBA;EACI,4BAAA;EACA,gBAAA;EACA,6BAAA;EACA,8BAAA;ApIy5kBJ;AoIv5kBI;EACI;IACI,iBAAA;EpIy5kBV;EoIt5kBM;IACI,eAAA;EpIw5kBV;AACF;;AoIp5kBA;EACI,iBAAA;ApIu5kBJ;;AoIp5kBA;EACI,6BAAA;ApIu5kBJ;;AoIp5kBA;EACI,cAAA;EACA,cAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,kCAAA;EACA,kBAAA;ApIu5kBJ;;AoIp5kBA;EACI,qBAAA;EACA,WAAA;EACA,YAAA;EACA,oBAAA;EACA,cAAA;EACA,+BAAA;ApIu5kBJ;;AoIp5kBA;EACI,uCAAA;ApIu5kBJ;;AoIp5kBA;EACI,sBAAA;EACA,iBAAA;ApIu5kBJ;;AoIp5kBA;EACI,OAAA;EACA,gBAAA;ApIu5kBJ;;AoIp5kBA;EACI,2BAAA;EACA,kBAAA;EACA,WAAA;EACA,qBAAA;EACA,sBAAA;EACA,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,0BAAA;EACA,SAAA;EACA,eAAA;EACA,kBAAA;ApIu5kBJ;;AoIp5kBA;;EAEI,iBAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;EACA,oBAAA;ApIu5kBJ;;AoIp5kBA;EACI,oBAAA;ApIu5kBJ;;AoIp5kBA;EACI,SAAA;EACA,uBAAA;EACA,kBAAA;EACA,QAAA;EACA,cAAA;EACA,WAAA;ApIu5kBJ;;AoIp5kBA;EACI,eAAA;EACA,2BAAA;EACA,UAAA;EACA,QAAA;EACA,OAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;ApIu5kBJ;;AoIp5kBA;EACI,WAAA;ApIu5kBJ;;AoIn5kBA;EACI,uBAAA;ApIs5kBJ;;AoIl5kBA;EACI,yBAAA;EACA,qBAAA;EACA,eAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;ApIq5kBJ;;AoIl5kBA;EACI,cAAA;ApIq5kBJ;;AoIl5kBA;EACI,kBAAA;EACA,MAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;ApIq5kBJ;;AoIl5kBA;;EAEI,sBAAA;ApIq5kBJ;;AoIl5kBA;EACI,mBAAA;ApIq5kBJ;;AoIl5kBA;EACI,wBAAA;ApIq5kBJ;;AoIl5kBA;EACI,uBAAA;EACA,0BAAA;EACA,YAAA;ApIq5kBJ;;AoIj5kBI;EACI,gBAAA;EACA,cAAA;EACA,WAAA;ApIo5kBR;;AoIh5kBA;EACI,gBAAA;ApIm5kBJ;;AoIh5kBA;EACI,YAAA;EACA,aAAA;EACA,mBAAA;EACA,UAAA;ApIm5kBJ;;AoIh5kBA;EACI,2BAAA;EACA,0BAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;ApIm5kBJ;;AoIh5kBA;EACI,uBAAA;ApIm5kBJ;;AoIh5kBA;EACI,yBAAA;ApIm5kBJ;;AoIh5kBA;EACI,eAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;ApIm5kBJ;;AoIh5kBA;EACI,gBAAA;EACA,YAAA;ApIm5kBJ;;AoI/4kBI;EACI,YAAA;ApIk5kBR;AoI/4kBI;EACI,UAAA;ApIi5kBR;AoI94kBI;EACI,UAAA;ApIg5kBR;AoI74kBI;EACI,UAAA;ApI+4kBR;AoI54kBI;EACI,UAAA;ApI84kBR;;AoI14kBA;EACI,WAAA;ApI64kBJ;AoI34kBI;EACI,6BAAA;ApI64kBR;;AoIz4kBA;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;ApI44kBJ;;AoIn4kBA;EACI,8BAAA;EACA,4BAAA;EACA,oBAAA;EACA,mBAAA;ApIs4kBJ;;AoIn4kBA;EACI,6BAAA;EACA,4BAAA;ApIs4kBJ;;AoIn4kBA;EACI,kCAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,6BAAA;EACA,gBAAA;ApIs4kBJ;;AoIn4kBA;EACI,uBAAA;EACA,yBAAA;EACA,kCAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;ApIs4kBJ;;AoIn4kBA;EACI,kBAAA;ApIs4kBJ;;AoIn4kBA;EACI,8BAAA;ApIs4kBJ;;AoIn4kBA;;EAEI,gBAAA;EACA,mBAAA;EACA,0BAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;ApIs4kBJ;;AoIn4kBA;EACI,iBAAA;ApIs4kBJ;;AoIn4kBA;EACI,sBAAA;EACA,wBAAA;ApIs4kBJ;;AoIn4kBA;EACI,iBAAA;EACA,gBAAA;ApIs4kBJ;;AoIn4kBA;EACI,kBAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;ApIs4kBJ;;AoIn4kBA;EACI,aAAA;EACA,8BAAA;ApIs4kBJ;;AoIn4kBA;EACI,gBAAA;EACA,4BAAA;ApIs4kBJ;;AoIn4kBA;EACI,YAAA;ApIs4kBJ;;AoIn4kBA;EACI,yCAAA;ApIs4kBJ;;AoIn4kBA;EACI,4BAAA;ApIs4kBJ;;AoIn4kBA;EACI,yBAAA;ApIs4kBJ;;AoIn4kBA;EACI,cAAA;EACA,iBAAA;ApIs4kBJ;;AoIn4kBA;EACI,8BAAA;ApIs4kBJ;;AoIn4kBA;EACI,6BAAA;ApIs4kBJ;;AoIn4kBA;EACI,gBAAA;ApIs4kBJ;;AoIn4kBA;EACI,YAAA;ApIs4kBJ;;AoIn4kBA;EACI,wBAAA;EACA,yCAAA;ApIs4kBJ;;AoIn4kBA;EACI,eAAA;EACA,wBAAA;EACA,kCAAA;ApIs4kBJ;;AoIn4kBA;EACI,YAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;ApIs4kBJ;;AoIn4kBA;EACI,uBAAA;EACA,0BAAA;ApIs4kBJ;;AoIn4kBA;EACI,uBAAA;EACA,2BAAA;ApIs4kBJ;;AoIn4kBA;EACI,2BAAA;ApIs4kBJ;;AoIn4kBA;EAEI,0BAAA;EACA,6BAAA;EACA,YAAA;ApIq4kBJ;;AoIl4kBA;EACI,WAAA;EACA,WAAA;EACA,UAAA;ApIq4kBJ;;AoIl4kBA;EACI,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,8BAAA;EACA,eAAA;EACA,gBAAA;ApIq4kBJ;;AoIl4kBA;EACI,kBAAA;EACA,YAAA;ApIq4kBJ;;AoIl4kBA;EACI,qCAAA;EACA,YAAA;ApIq4kBJ;;AoIl4kBA;EACI,qCAAA;EACA,YAAA;ApIq4kBJ;;AoIl4kBA;EACI,oCAAA;EACA,YAAA;ApIq4kBJ;;AoIl4kBA;EACI,oCAAA;EACA,YAAA;ApIq4kBJ;;AoIl4kBA;EACI,8BAAA;EACA,YAAA;ApIq4kBJ;;AoIl4kBA;EACI,gBAAA;EACA,YAAA;EACA,aAAA;EACA,6BAAA;ApIq4kBJ;;AoIl4kBA;EACI,YAAA;ApIq4kBJ;;AoIl4kBA;EACI,eAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;ApIq4kBJ;;AoIl4kBA;EACI,YAAA;EACA,kBAAA;ApIq4kBJ;;AoI33kBA;EACI,WAAA;ApI83kBJ;;AoI33kBA;EACI,mBAAA;EACA,aAAA;EACA,wCAAA;ApI83kBJ;;AoI33kBA;EACI,wBAAA;EACA,aAAA;EACA,wCAAA;ApI83kBJ;;AoI33kBA;EACI,iBAAA;EACA,eAAA;ApI83kBJ;;AoIz3kBA;EACI,QAAA;EACA,SAAA;EACA,gCAAA;EACA,kBAAA;EACA,uBAAA;ApI43kBJ;;AoIz3kBA;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;EACA,+BAAA;EACA,6BAAA;EACA,4BAAA;EACA,wDAAA;EACA,sCAAA;ApI43kBJ;;AoIz3kBA;EACI,qBAAA;ApI43kBJ;;AoIz3kBA;EACI,qBAAA;ApI43kBJ;;AoIz3kBA;EACI,qBAAA;ApI43kBJ;;AoIz3kBA;EACI,qBAAA;ApI43kBJ;;AoIz3kBA;EACI,qBAAA;ApI43kBJ;;AoIz3kBA;EACI,qBAAA;ApI43kBJ;;AoIz3kBA;EACI,qBAAA;ApI43kBJ;;AoIz3kBA;EACI,qBAAA;ApI43kBJ;;AoIz3kBA;EACI;IACI,sBAAA;IACA,eAAA;EpI43kBN;EoIz3kBE;IACI,oBAAA;IACA,uBAAA;EpI23kBN;EoIx3kBE;IACI,sBAAA;IACA,uBAAA;EpI03kBN;AACF;AoIv3kBA,kBAAA;AACA;EACI,YAAA;EACA,gBAAA;EACA,yBAAA;ApIy3kBJ;;AoIn3kBA;EACI,YAAA;EACA,gBAAA;EACA,yBAAA;ApIs3kBJ;;AoI/2kBA;EACI,YAAA;EACA,gBAAA;EACA,yBAAA;ApIk3kBJ;;AoI52kBA;EACI,YAAA;EACA,gBAAA;EACA,yBAAA;ApI+2kBJ;;AoIz2kBA,4DAAA;AACA;EACI,yBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;ApI42kBJ;;AoIz2kBA;EACI,yBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;ApI42kBJ;;AoIz2kBA,gDAAA;AACA;EACI,uBAAA;ApI42kBJ;;AoIz2kBA;EACI,yBAAA;ApI42kBJ;;AoIz2kBA,2CAAA;AACA;EACI,2BAAA;EACA,yBAAA;EACA,8BAAA;EACA,sBAAA;ApI42kBJ;;AoIz2kBA;EACI,2BAAA;EACA,yBAAA;EACA,8BAAA;EACA,sBAAA;ApI42kBJ;;AoIz2kBA;+DAAA;AAEA;;EAEI,yBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;ApI42kBJ;;AoIz2kBA;EACI,YAAA;ApI42kBJ;;AoIz2kBA;EACI,uBAAA;ApI42kBJ;;AoIz2kBA;EACI,yBAAA;ApI42kBJ;;AoIz2kBA;;EAEI,2BAAA;EACA,yBAAA;EACA,8BAAA;EACA,sBAAA;ApI42kBJ;;AoIz2kBA;EACI,qBAAA;ApI42kBJ;;AoIz2kBA;EACI,qBAAA;ApI42kBJ;;AoIz2kBA;EACI,oCAAA;EACA,cAAA;ApI42kBJ;;AoIz2kBA;EACI,WAAA;ApI42kBJ;;AoIz2kBA;EACI,wCAAA;ApI42kBJ;;AoIz2kBA;EACI,wCAAA;ApI42kBJ;;AoIz2kBA;EACI,wCAAA;ApI42kBJ;;AoIz2kBA;EACI,8BAAA;EACA,4BAAA;EACA,uBAAA;EACA,iCAAA;EACA,2DAAA;EACA,qCAAA;EACA,sCAAA;EACA,sCAAA;EACA,gDAAA;EACA,iDAAA;EACA,4CAAA;EACA,qCAAA;EACA,6CAAA;EACA,mHAAA;EACA,sCAAA;EACA,wDAAA;EACA,qDAAA;EACA,0DAAA;EACA,+DAAA;ApI42kBJ;;AoIz2kBA;EACI,eAAA;EACA,WAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;ApI42kBJ;;AoIj2kBA;EACI,0BAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EAEA,kBAAA;ApIm2kBJ;;AoI91kBA;EACI,qBAAA;ApIi2kBJ;;AoIz1kBA;EACI,kBAAA;ApI41kBJ;AoI11kBI;EACI,WAAA;EACA,8BAAA;EACA,yBAAA;EACA,YAXI;EAYJ,WAZI;EAaJ,mBAZI;EAaJ,kBAAA;EACA,OAAA;EACA,MAAA;EACA,kBAAA;ApI41kBR;AoI11kBQ;EACI,qBAAA;EACA,iBAAA;ApI41kBZ;AoIz1kBQ;EACI,qBAAA;EACA,iBAAA;ApI21kBZ;;AoIt1kBA;EACI;IACI,YAAA;EpIy1kBN;EoIt1kBE;IACI,UAAA;EpIw1kBN;EoIr1kBE;IACI,YAAA;EpIu1kBN;AACF;AoIl1kBA;EACI,eAAA;EACA,UAAA;EACA,YAAA;EACA,qBAAA;EACA,WAAA;EACA,qBAAA;EAEA,YAAA;EACA,iBAAA;EACA,8BAAA;EACA,WAAA;EACA,qBAAA;EACA,YAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,+BAAA;EACA,eAAA;EACA,aAAA;EACA,6CAAA;ApIm1kBJ;;AoI/0kBA;EACI,kBAAA;EACA,kBAAA;ApIk1kBJ;;AoI/0kBA;EACI,WAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,yBAAA;ApIk1kBJ;;AoI/0kBA;EACI,yBAAA;EACA,kBAAA;EACA,aAAA;ApIk1kBJ;;AoI/0kBA;EACI,qCAAA;EACA,eAAA;ApIk1kBJ;;AoI/0kBA;EACI,0BAAA;ApIk1kBJ;;AiGx7mBA,wBAAA;AoC3FA;EACI,iBAAA;EACA,oBAAA;ArIuhnBJ;AqIrhnBI;EACI,mBAAA;EACA,gBAAA;ArIuhnBR;;AqIhhnBI;EACI,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,cjIyDG;AJ09mBX;AqIlhnBQ;EACI,gBAAA;EACA,oBAAA;ArIohnBZ;AqIjhnBI;EACI,kBAAA;EACA,sBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,qBAAA;EACA,oBAAA;ArImhnBR;AqIjhnBI;EACI,kBAAA;EACA,4BAAA;EACA,gBAAA;ArImhnBR;AqIhhnBY;EACI,yBjIuDN;EiItDM,WjIyBL;EiIxBK,6CAAA;ArIkhnBhB;;AqI3gnBI;EACI,eAAA;EACA,cjIqBG;AJy/mBX;AqI7gnBQ;EACI,kBAAA;ArI+gnBZ;AqI5gnBQ;EACI,iBAAA;EACA,qBAAA;EACA,sBAAA;ArI8gnBZ;;AiGj/mBA,cAAA;AqC9FA;EACI,cAAA;EACA,mBAAA;EACA,gBAAA;AtImlnBJ;;AsIhlnBA;EACI,qBAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBlImR0B;EkIlR1B,yBlIm3BgC;EOj3BhC,qBAAA;AXklnBJ;AsIjlnBI;EACI,qBAAA;AtImlnBR;AsIhlnBI;EACI,mBAAA;EACA,gBAAA;AtIklnBR;AsI/knBI;EACI,yBlIs2B4B;EkIr2B5B,aAAA;EACA,eAAA;E3HbJ,qBAAA;AX+lnBJ;;AsI7knBA;EACI,iBAAA;EACA,kBAAA;AtIglnBJ;AsI9knBI;EACI,eAAA;AtIglnBR;AsI7knBI;EACI,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;AtI+knBR;;AsIxknBI;EACI,6EAAA;EACA,yEAAA;AtI2knBR;;AsItknBA;EACI,gBAAA;AtIyknBJ;;AsIpknBI;EACI,kBAAA;EACA,WAAA;AtIuknBR;AsIrknBI;EACI,WAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;AtIuknBR;;AsInknBA;EACI,eAAA;AtIsknBJ;;AiGrjnBA,cAAA;AsChGA;EACI,mBnI6R0B;EmI5R1B,yBnI63BgC;AJ4xlBpC;AuIxpnBI;EACI,gBnIm3B4B;EmIl3B5B,YAAA;EACA,WAAA;EAEA,qBAAA;EACA,qBAAA;AvIypnBR;AuItpnBI;EACI,kBAAA;EACA,8BAAA;EACA,wBAAA;AvIwpnBR;;AuIlpnBA;EACI,cAAA;EACA,eAAA;AvIqpnBJ;AuInpnBI;EACI,kBAAA;EACA,cAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,yBAAA;EACA,mBnI+1B4B;EmI91B5B,kBAAA;EACA,wDnI+QsB;AJs4mB9B;AuInpnBQ;EACI,cnI0CD;AJ2mnBX;AuIlpnBQ;EACI,6CnIyQkB;EmIxQlB,0BAAA;AvIopnBZ;AuIjpnBQ;EACI,WAAA;EACA,kBAAA;AvImpnBZ;AuIhpnBQ;EACI,YAAA;AvIkpnBZ;AuIhpnBY;;;EAGI,cAAA;EACA,WAAA;AvIkpnBhB;AuI/onBY;EACI,6BAAA;EACA,oBAAA;EACA,mBAAA;EACA,SAAA;EACA,QAAA;EACA,cAAA;EACA,YAAA;AvIipnBhB;AuI9onBY;EACI,wBAAA;AvIgpnBhB;AuI7onBY;EACI,cnIEL;EmIDK,iBAAA;AvI+onBhB;AuI5onBY;EACI,kBAAA;EACA,MAAA;EACA,WAAA;EACA,QAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;AvI8onBhB;AuI1onBQ;EACI,kBAAA;EACA,MAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;AvI4onBZ;AuI1onBY;;EAEI,kBAAA;EACA,MAAA;AvI4onBhB;AuIzonBY;EACI,OAAA;EACA,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;AvI2onBhB;AuIxonBY;EACI,QAAA;EACA,YAAA;EACA,kBAAA;AvI0onBhB;AuIronBI;;EAEI,mBnIlDG;EmImDH,0BAAA;AvIuonBR;AuIponBI;;EAEI,iCAAA;AvIsonBR;AuInonBI;EAEI,0DAAA;AvIoonBR;AuIjonBI;EACI,eAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,mCAAA;EACA,kBAAA;AvImonBR;AuIjonBQ;EACI,UAAA;EACA,eAAA;AvImonBZ;AuIhonBQ;EACI,UAAA;AvIkonBZ;AuI/nnBQ;EACI,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;EACA,mBnIpFD;EmIqFC,UAAA;EACA,2BAAA;EACA,0BAAA;AvIionBZ;AuI9nnBQ;EACI,mBAAA;AvIgonBZ;;AuI1nnBI;EACI,cnIjGG;EmIkGH,iBAAA;EACA,cAAA;AvI6nnBR;;AuIznnBA;EACI,yBAAA;AvI4nnBJ;;AuIznnBA;EAEQ;IACQ,WAAA;IACA,WAAA;IACA,mBAAA;IACA,uBAAA;EvI2nnBd;EuIxnnBM;IACI,cAAA;IACA,SAAA;IACA,eAAA;EvI0nnBV;AACF;AuIrnnBA;EAEQ;IACI,mBAAA;EvIsnnBV;EuIjnnBM;IACI,YAAA;EvImnnBV;EuIjnnBU;IACI,UAAA;EvImnnBd;EuI/mnBM;IACI,WAAA;EvIinnBV;EuI/mnBU;IACI,iBAAA;IACA,mBAAA;IACA,kBAAA;EvIinnBd;AACF;AuI5mnBA;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,yBnIkpBgC;EmIjpBhC,qBnI6D0B;EmI5D1B,6CnImE0B;EmIlE1B,WAAA;AvI8mnBJ;AuI3mnBQ;EACI,mBAAA;AvI6mnBZ;AuIzmnBI;EACI,kBAAA;EACA,UAAA;EACA,SAAA;AvI2mnBR;;AiGpwnBA,iBAAA;AuClGA,kDAAA;AAGI;EACI,8BAAA;EACA,kBAAA;AxIw2nBR;AwIv2nBQ;EACI,kBAAA;AxIy2nBZ;AwIx2nBY;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,yBpIsFN;EoIrFM,kBAAA;EACA,yBAAA;EACA,UAAA;AxI02nBhB;AwIx2nBY;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,yBpIgDL;AJ0znBX;AwIp2nBQ;EACI,YAAA;EACA,WAAA;EACA,kBAAA;AxIs2nBZ;;AwI71nBA;EACI,mBAAA;EACA,kBAAA;AxIg2nBJ;AwI/1nBI;EACI,yBpI0BG;EoIzBH,SAAA;EACA,WAAA;EACA,SAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;AxIi2nBR;AwI/1nBI;EACI,mBAAA;EACA,gBAAA;EACA,kBAAA;AxIi2nBR;AwI/1nBI;EACI,cAAA;EACA,kBAAA;EACA,aAAA;AxIi2nBR;AwI/1nBI;EACI,gBAAA;AxIi2nBR;AwIh2nBQ;EACI,qBAAA;EACA,iBAAA;AxIk2nBZ;AwIh2nBQ;EACI,YAAA;EACA,WAAA;EACA,kBAAA;AxIk2nBZ;;Aev3nBI;EyH4BI;IACI,WAAA;IACA,iBAAA;ExI+1nBV;EwI71nBM;IACI,iBAAA;ExI+1nBV;EwI71nBM;IACI,mBpISF;IoIRE,kBAAA;IACA,cAAA;IACA,YAAA;IACA,WAAA;IACA,iBAAA;IACA,kBAAA;IACA,kBAAA;IACA,QAAA;IACA,WAAA;IACA,yBAAA;IACA,UAAA;ExI+1nBV;EwI91nBU;IACI,WAAA;IACA,kBAAA;IACA,WAAA;IACA,WAAA;IACA,yBpIlCL;IoImCK,UAAA;IACA,QAAA;ExIg2nBd;EwI71nBM;IACI,mBAAA;IACA,mBAAA;IACA,UAAA;ExI+1nBV;EwI51nBE;IACI,aAAA;ExI81nBN;EwI71nBM;IACI,WAAA;IACA,cAAA;IACA,UAAA;ExI+1nBV;EwI31nBU;IACI,WAAA;IACA,cAAA;IACA,UAAA;ExI61nBd;EwI11nBc;IACI,YAAA;IACA,gBAAA;ExI41nBlB;EwI31nBkB;IACI,YAAA;IACA,gBAAA;ExI61nBtB;EwIz1nBU;IACI,UAAA;IACA,YAAA;ExI21nBd;EwI11nBc;IACI,UAAA;IACA,WAAA;ExI41nBlB;EwIz1nBU;IACI,aAAA;ExI21nBd;EwIz1nBU;IACI,kBAAA;IACA,cAAA;IACA,iBAAA;ExI21nBd;AACF;Aer7nBI;EyHiGI;IACI,kBAAA;IACA,kBAAA;ExIu1nBV;EwIr1nBM;IACI,sBAAA;IACA,oBAAA;IACA,yBAAA;ExIu1nBV;EwIr1nBM;IACI,aAAA;ExIu1nBV;AACF;AiGp6nBA,oBAAA;AwChGQ;EACI,aAAA;AzIugoBZ;AyItgoBY;EACI,crI8FN;AJ06nBV;;AiGz6nBA,uBAAA;AyCpGI;EACI,sBAAA;EACA,4BAAA;EACA,iBAAA;A1IihoBR;;A0I1goBQ;EACI,6BAAA;A1I6goBZ;A0I3goBY;EACI,YAAA;EACA,WAAA;A1I6goBhB;;A0IvgoBA;EACI,cAAA;A1I0goBJ;;A0IvgoBA;EACI,cAAA;A1I0goBJ;;A0IvgoBA;EACI,UAAA;EACA,0DAAA;EACA,4BAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;A1I0goBJ;A0IxgoBI;EACI,OAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,oCAAA;A1I0goBR;A0IvgoBI;EACI,kBAAA;EACA,WtIqBG;EsIpBH,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;A1IygoBR;;AmItkoBA;EACE,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,iCAAA;AnIykoBF;AmIvkoBE;;EAEE,kBAAA;EACA,mBAAA;AnIykoBJ;AmItkoBE;EACE,kBAAA;AnIwkoBJ;AmIrkoBE;EACE,oBAAA;AnIukoBJ","sourcesContent":["@import 'bootstrap-dark';\n@import 'icons';\n@import 'app-dark';\n@import '~react-datepicker/dist/react-datepicker.css';\n@import \"~react-querybuilder/dist/query-builder.scss\";\n@import \"~react-modern-drawer/dist/index.css\";","/*!\n * Bootstrap v4.6.2 (https://getbootstrap.com/)\n * Copyright 2011-2022 The Bootstrap Authors\n * Copyright 2011-2022 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n */\n\n@import \"functions\";\n@import \"variables\";\n@import \"mixins\";\n@import \"root\";\n@import \"reboot\";\n@import \"type\";\n@import \"images\";\n@import \"code\";\n@import \"grid\";\n@import \"tables\";\n@import \"forms\";\n@import \"buttons\";\n@import \"transitions\";\n@import \"dropdown\";\n@import \"button-group\";\n@import \"input-group\";\n@import \"custom-forms\";\n@import \"nav\";\n@import \"navbar\";\n@import \"card\";\n@import \"breadcrumb\";\n@import \"pagination\";\n@import \"badge\";\n@import \"jumbotron\";\n@import \"alert\";\n@import \"progress\";\n@import \"media\";\n@import \"list-group\";\n@import \"close\";\n@import \"toasts\";\n@import \"modal\";\n@import \"tooltip\";\n@import \"popover\";\n@import \"carousel\";\n@import \"spinners\";\n@import \"utilities\";\n@import \"print\";\n",":root {\n  // Custom variable values only support SassScript inside `#{}`.\n  @each $color, $value in $colors {\n    --#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$color}: #{$value};\n  }\n\n  @each $bp, $value in $grid-breakpoints {\n    --breakpoint-#{$bp}: #{$value};\n  }\n\n  // Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --font-family-sans-serif: #{inspect($font-family-sans-serif)};\n  --font-family-monospace: #{inspect($font-family-monospace)};\n}\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// 1. Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n// 2. Change the default font family in all browsers.\n// 3. Correct the line height in all browsers.\n// 4. Prevent adjustments of font size after orientation changes in IE on Windows Phone and in iOS.\n// 5. Change the default tap highlight to be completely transparent in iOS.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box; // 1\n}\n\nhtml {\n  font-family: sans-serif; // 2\n  line-height: 1.15; // 3\n  -webkit-text-size-adjust: 100%; // 4\n  -webkit-tap-highlight-color: rgba($black, 0); // 5\n}\n\n// Shim for \"new\" HTML5 structural elements to display correctly (IE10, older browsers)\n// TODO: remove in v5\n// stylelint-disable-next-line selector-list-comma-newline-after\narticle, aside, figcaption, figure, footer, header, hgroup, main, nav, section {\n  display: block;\n}\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Set an explicit initial text-align value so that we can later use\n//    the `inherit` value on things like `<th>` elements.\n\nbody {\n  margin: 0; // 1\n  font-family: $font-family-base;\n  @include font-size($font-size-base);\n  font-weight: $font-weight-base;\n  line-height: $line-height-base;\n  color: $body-color;\n  text-align: left; // 3\n  background-color: $body-bg; // 2\n}\n\n// Future-proof rule: in browsers that support :focus-visible, suppress the focus outline\n// on elements that programmatically receive focus but wouldn't normally show a visible\n// focus outline. In general, this would mean that the outline is only applied if the\n// interaction that led to the element receiving programmatic focus was a keyboard interaction,\n// or the browser has somehow determined that the user is primarily a keyboard user and/or\n// wants focus outlines to always be presented.\n//\n// See https://developer.mozilla.org/en-US/docs/Web/CSS/:focus-visible\n// and https://developer.paciellogroup.com/blog/2018/03/focus-visible-and-backwards-compatibility/\n[tabindex=\"-1\"]:focus:not(:focus-visible) {\n  outline: 0 !important;\n}\n\n\n// Content grouping\n//\n// 1. Add the correct box sizing in Firefox.\n// 2. Show the overflow in Edge and IE.\n\nhr {\n  box-sizing: content-box; // 1\n  height: 0; // 1\n  overflow: visible; // 2\n}\n\n\n//\n// Typography\n//\n\n// Remove top margins from headings\n//\n// By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n// margin for easier control within type scales as it avoids margin collapsing.\n// stylelint-disable-next-line selector-list-comma-newline-after\nh1, h2, h3, h4, h5, h6 {\n  margin-top: 0;\n  margin-bottom: $headings-margin-bottom;\n}\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n// Abbreviations\n//\n// 1. Duplicate behavior to the data-* attribute for our tooltip plugin\n// 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.\n// 3. Add explicit cursor to indicate changed behavior.\n// 4. Remove the bottom border in Firefox 39-.\n// 5. Prevent the text-decoration to be skipped.\n\nabbr[title],\nabbr[data-original-title] { // 1\n  text-decoration: underline; // 2\n  text-decoration: underline dotted; // 2\n  cursor: help; // 3\n  border-bottom: 0; // 4\n  text-decoration-skip-ink: none; // 5\n}\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // Undo browser default\n}\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\nb,\nstrong {\n  font-weight: $font-weight-bolder; // Add the correct font weight in Chrome, Edge, and Safari\n}\n\nsmall {\n  @include font-size(80%); // Add the correct font size in all browsers\n}\n\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n//\n\nsub,\nsup {\n  position: relative;\n  @include font-size(75%);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n//\n// Links\n//\n\na {\n  color: $link-color;\n  text-decoration: $link-decoration;\n  background-color: transparent; // Remove the gray background on active links in IE 10.\n\n  @include hover() {\n    color: $link-hover-color;\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  color: inherit;\n  text-decoration: none;\n\n  @include hover() {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n//\n// Code\n//\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-monospace;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\npre {\n  // Remove browser default top margin\n  margin-top: 0;\n  // Reset browser default of `1em` to use `rem`s\n  margin-bottom: 1rem;\n  // Don't allow content to break outside\n  overflow: auto;\n  // Disable auto-hiding scrollbar in IE & legacy Edge to avoid overlap,\n  // making it impossible to interact with the content\n  -ms-overflow-style: scrollbar;\n}\n\n\n//\n// Figures\n//\n\nfigure {\n  // Apply a consistent margin strategy (matches our type styles).\n  margin: 0 0 1rem;\n}\n\n\n//\n// Images and content\n//\n\nimg {\n  vertical-align: middle;\n  border-style: none; // Remove the border on images inside links in IE 10-.\n}\n\nsvg {\n  // Workaround for the SVG overflow bug in IE10/11 is still required.\n  // See https://github.com/twbs/bootstrap/issues/26878\n  overflow: hidden;\n  vertical-align: middle;\n}\n\n\n//\n// Tables\n//\n\ntable {\n  border-collapse: collapse; // Prevent double borders\n}\n\ncaption {\n  padding-top: $table-cell-padding;\n  padding-bottom: $table-cell-padding;\n  color: $table-caption-color;\n  text-align: left;\n  caption-side: bottom;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\n\n//\n// Forms\n//\n\nlabel {\n  // Allow labels to use `margin` for spacing.\n  display: inline-block;\n  margin-bottom: $label-margin-bottom;\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n//\n// Details at https://github.com/twbs/bootstrap/issues/24093\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // Remove the margin in Firefox and Safari\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\nbutton,\ninput {\n  overflow: visible; // Show the overflow in Edge\n}\n\nbutton,\nselect {\n  text-transform: none; // Remove the inheritance of text transform in Firefox\n}\n\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\n// Remove the inheritance of word-wrap in Safari.\n//\n// Details at https://github.com/twbs/bootstrap/issues/24990\nselect {\n  word-wrap: normal;\n}\n\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n}\n\n// Opinionated: add \"hand\" cursor to non-disabled button elements.\n@if $enable-pointer-cursor-for-buttons {\n  button,\n  [type=\"button\"],\n  [type=\"reset\"],\n  [type=\"submit\"] {\n    &:not(:disabled) {\n      cursor: pointer;\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\nbutton::-moz-focus-inner,\n[type=\"button\"]::-moz-focus-inner,\n[type=\"reset\"]::-moz-focus-inner,\n[type=\"submit\"]::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\ninput[type=\"radio\"],\ninput[type=\"checkbox\"] {\n  box-sizing: border-box; // 1. Add the correct box sizing in IE 10-\n  padding: 0; // 2. Remove the padding in IE 10-\n}\n\n\ntextarea {\n  overflow: auto; // Remove the default vertical scrollbar in IE.\n  // Textareas should really only resize vertically so they don't break their (horizontal) containers.\n  resize: vertical;\n}\n\nfieldset {\n  // Browsers set a default `min-width: min-content;` on fieldsets,\n  // unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n  // So we reset that to ensure fieldsets behave more like a standard block element.\n  // See https://github.com/twbs/bootstrap/issues/12359\n  // and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n  min-width: 0;\n  // Reset the default outline behavior of fieldsets so they don't affect page layout.\n  padding: 0;\n  margin: 0;\n  border: 0;\n}\n\n// 1. Correct the text wrapping in Edge and IE.\n// 2. Correct the color inheritance from `fieldset` elements in IE.\nlegend {\n  display: block;\n  width: 100%;\n  max-width: 100%; // 1\n  padding: 0;\n  margin-bottom: .5rem;\n  @include font-size(1.5rem);\n  line-height: inherit;\n  color: inherit; // 2\n  white-space: normal; // 1\n}\n\nprogress {\n  vertical-align: baseline; // Add the correct vertical alignment in Chrome, Firefox, and Opera.\n}\n\n// Correct the cursor style of increment and decrement buttons in Chrome.\n[type=\"number\"]::-webkit-inner-spin-button,\n[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}\n\n[type=\"search\"] {\n  // This overrides the extra rounded corners on search inputs in iOS so that our\n  // `.form-control` class can properly style them. Note that this cannot simply\n  // be added to `.form-control` as it's not specific enough. For details, see\n  // https://github.com/twbs/bootstrap/issues/11586.\n  outline-offset: -2px; // 2. Correct the outline style in Safari.\n  -webkit-appearance: none;\n}\n\n//\n// Remove the inner padding in Chrome and Safari on macOS.\n//\n\n[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n//\n// 1. Correct the inability to style clickable types in iOS and Safari.\n// 2. Change font properties to `inherit` in Safari.\n//\n\n::-webkit-file-upload-button {\n  font: inherit; // 2\n  -webkit-appearance: button; // 1\n}\n\n//\n// Correct element displays\n//\n\noutput {\n  display: inline-block;\n}\n\nsummary {\n  display: list-item; // Add the correct display in all browsers\n  cursor: pointer;\n}\n\ntemplate {\n  display: none; // Add the correct display in IE\n}\n\n// Always hide an element with the `hidden` HTML attribute (from PureCSS).\n// Needed for proper display in IE 10-.\n[hidden] {\n  display: none !important;\n}\n","// Variables\n\n//\n// custom-variables\n//\n\n//Background left-sidebar\n$bg-leftbar-light:            #323742;\n$bg-leftbar-dark:             #f5f5fb;\n\n// Leftbar width\n$leftbar-width:             250px;\n$leftbar-width-collapsed:   70px;\n\n// Small Leftbar Width\n$leftbar-width-sm:    160px;\n\n// Boxed layout width\n$boxed-layout-width:  1300px;\n\n// Logo box \n$logo-box-background: #323742;\n\n// Dark leftbar menu color\n$menu-item-color-dark:        #9097a7;\n$menu-item-hover-color-dark:  #564ab1;\n$menu-item-active-color-dark: #564ab1;\n\n//Menu item colors\n$menu-item:              #4BB3BC ;\n$menu-item-hover:        #4BB3BC ;\n$menu-item-active:       #4BB3BC ;\n$menu-item-bg-hover: rgba(22, 191, 199, 0.05);\n\n//Rightbar Width\n$rightbar-width:           260px;\n\n//Rightbar Width\n$bg-rightbar:             #323742;\n\n//Topbar Background----------------------------------------------------------------------------------------------------------------------\n$bg-topbar-light:        #262939; \n$bg-topbar-dark:          #ffffff;\n\n// Gradient Background\n\n$bg-gradient:               linear-gradient(to bottom, #564ab1, #746dad);\n\n// Topbar Height\n$topbar-height: 55px;\n\n\n// Secondary font\n$font-family-secondary: \"Cerebri Sans,sans-serif\";\n\n// Font weight\n$font-weight-medium: 500;\n$font-weight-semibold: 600;\n\n// Dropdown Large\n$dropdown-lg-width:    320px;\n\n// apex charts\n\n$apex-grid-color: #3b414e;\n\n// horizontal\n$bg-topnav:   #323742;\n\n// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n$white:    #fff;\n$gray-100: #212529;\n$gray-200: #323742;\n$gray-300: #3b414e;\n$gray-400: #576073;\n$gray-500: #6b768d;\n$gray-600: #8790a4;\n$gray-700: #a1a8b8;\n$gray-800: #bcc1cc;\n$gray-900: #d6d9e0;\n$black:    #000;\n\n$grays: ();\n// stylelint-disable-next-line scss/dollar-variable-default\n$grays: map-merge(\n  (\n    \"100\": $gray-100,\n    \"200\": $gray-200,\n    \"300\": $gray-300,\n    \"400\": $gray-400,\n    \"500\": $gray-500,\n    \"600\": $gray-600,\n    \"700\": $gray-700,\n    \"800\": $gray-800,\n    \"900\": $gray-900\n  ),\n  $grays\n);\n\n$blue:    #5369f8;\n$indigo:  #564ab1;\n$purple:  #6f42c1;\n$pink:    #e83e8c;\n$red:     #ff5c75;\n$orange:  #f77e53;\n$yellow:  #ffbe0b;\n$green:   #43d39e;\n$teal:    #1ce1ac;\n$cyan:    #25c2e3;\n\n$colors: ();\n// stylelint-disable-next-line scss/dollar-variable-default\n$colors: map-merge(\n  (\n    \"blue\":       $blue,\n    \"indigo\":     $indigo,\n    \"purple\":     $purple,\n    \"pink\":       $pink,\n    \"red\":        $red,\n    \"orange\":     $orange,\n    \"yellow\":     $yellow,\n    \"green\":      $green,\n    \"teal\":       $teal,\n    \"cyan\":       $cyan,\n    \"white\":      $white,\n    \"gray\":       $gray-600,\n    \"gray-dark\":  $gray-800\n  ),\n  $colors\n);\n\n$primary:       $blue;\n$secondary:     #292d36;\n$success:       $green;\n$info:          $cyan;\n$warning:       $yellow;\n$danger:        $red;\n$light:         $gray-300;\n$dark:          $gray-800;\n\n$theme-colors: ();\n// stylelint-disable-next-line scss/dollar-variable-default\n$theme-colors: map-merge(\n  (\n    \"primary\":    $primary,\n    \"secondary\":  $secondary,\n    \"success\":    $success,\n    \"info\":       $info,\n    \"warning\":    $warning,\n    \"danger\":     $danger,\n    \"light\":      $light,\n    \"dark\":       $dark\n  ),\n  $theme-colors\n);\n\n// Set a specific jump point for requesting color jumps\n$theme-color-interval:      8%;\n\n// The yiq lightness value that determines when the lightness of color changes from \"dark\" to \"light\". Acceptable values are between 0 and 255.\n$yiq-contrasted-threshold:  150;\n\n// Customize the light and dark text colors for use in our YIQ color contrast function.\n$yiq-text-dark:             $gray-900;\n$yiq-text-light:            $white;\n\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                                false;\n$enable-rounded:                              true;\n$enable-shadows:                              false;\n$enable-gradients:                            false;\n$enable-transitions:                          true;\n$enable-prefers-reduced-motion-media-query:   true;\n$enable-hover-media-query:                    false; // Deprecated, no longer affects any compiled CSS\n$enable-grid-classes:                         true;\n$enable-pointer-cursor-for-buttons:           true;\n$enable-print-styles:                         true;\n$enable-responsive-font-sizes:                false;\n$enable-validation-icons:                     true;\n$enable-deprecation-messages:                 true;\n\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n$spacer: 1rem;\n$spacers: ();\n// stylelint-disable-next-line scss/dollar-variable-default\n$spacers: map-merge(\n  (\n    0: 0,\n    1: ($spacer * .25),\n    2: ($spacer * .5),\n    3: $spacer,\n    4: ($spacer * 1.5),\n    5: ($spacer * 3)\n  ),\n  $spacers\n);\n\n// This variable affects the `.h-*` and `.w-*` classes.\n$sizes: ();\n// stylelint-disable-next-line scss/dollar-variable-default\n$sizes: map-merge(\n  (\n    25: 25%,\n    50: 50%,\n    75: 75%,\n    100: 100%,\n    auto: auto\n  ),\n  $sizes\n);\n\n\n// Body\n//\n// Settings for the `<body>` element.------------------------------------------------------------------------------------------------------------\n\n$body-bg:                   #64687C;\n$body-color:                $gray-700;\n\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              theme-color(\"primary\");\n$link-decoration:                         none;\n$link-hover-color:                        darken($link-color, 15%);\n$link-hover-decoration:                   underline;\n// Darken percentage for links with `.text-*` class (e.g. `.text-success`)\n$emphasized-link-hover-darken-percentage: 15%;\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px\n);\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px\n);\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12;\n$grid-gutter-width:           24px;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n$line-height-lg:              1.5;\n$line-height-sm:              1.5;\n\n$border-width:                1px;\n$border-color:                $gray-300;\n\n$border-radius:               .3rem;\n$border-radius-lg:            .5rem;\n$border-radius-sm:            .2rem;\n\n$rounded-pill:                50rem;\n\n$box-shadow-sm:               0 .05rem .01rem rgba($gray-700, .075);\n$box-shadow:                  0 .5rem 1rem rgba($black, .15);\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175);\n\n\n$component-active-bg:         $primary;\n\n$caret-width:                 .3em;\n$caret-vertical-align:        $caret-width * .85;\n$caret-spacing:               $caret-width * .85;\n\n$transition-base:             all .2s ease-in-out;\n$transition-fade:             opacity .15s linear;\n$transition-collapse:         height .35s ease;\n\n$embed-responsive-aspect-ratios: ();\n// stylelint-disable-next-line scss/dollar-variable-default\n$embed-responsive-aspect-ratios: join(\n  (\n    (21 9),\n    (16 9),\n    (4 3),\n    (1 1),\n  ),\n  $embed-responsive-aspect-ratios\n);\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      'Nunito Sans', sans-serif;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n$font-family-base:            $font-family-sans-serif;\n// Secondary font\n$font-family-secondary:       'Nunito Sans', sans-serif;\n// stylelint-enable value-keyword-case\n\n$font-size-base:              0.9rem;\n$font-size-lg:                $font-size-base * 1.25;\n$font-size-sm:                $font-size-base * .875;\n\n$font-weight-lighter:         lighter;\n$font-weight-light:           300;\n$font-weight-normal:          400;\n$font-weight-bold:            700;\n$font-weight-bolder:          bolder;\n\n$font-weight-base:            $font-weight-normal;\n$line-height-base:            1.5;\n\n$h1-font-size:                $font-size-base * 2.5;\n$h2-font-size:                $font-size-base * 2;\n$h3-font-size:                $font-size-base * 1.75;\n$h4-font-size:                $font-size-base * 1.5;\n$h5-font-size:                $font-size-base * 1.25;\n$h6-font-size:                $font-size-base;\n\n$headings-margin-bottom:      calc($spacer / 2);\n$headings-font-family:        null;\n$headings-font-weight:        500;\n$headings-line-height:        1.2;\n$headings-color:              null;\n\n$display1-size:               6rem;\n$display2-size:               5.5rem;\n$display3-size:               4.5rem;\n$display4-size:               3.5rem;\n\n$display1-weight:             300;\n$display2-weight:             300;\n$display3-weight:             300;\n$display4-weight:             300;\n$display-line-height:         $headings-line-height;\n\n$lead-font-size:              $font-size-base * 1.25;\n$lead-font-weight:            300;\n\n$small-font-size:             80%;\n\n$text-muted:                  $gray-500;\n\n$blockquote-small-color:      $gray-600;\n$blockquote-small-font-size:  $small-font-size;\n$blockquote-font-size:        $font-size-base * 1.25;\n\n$hr-border-color:             $gray-300;\n$hr-border-width:             $border-width;\n\n$mark-padding:                .2em;\n\n$dt-font-weight:              $font-weight-bold;\n\n$kbd-box-shadow:              inset 0 -.1rem 0 rgba($black, .25);\n$nested-kbd-font-weight:      $font-weight-bold;\n\n$list-inline-padding:         .5rem;\n\n$mark-bg:                     #fcf8e3;\n\n$hr-margin-y:                 $spacer;\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n$table-cell-padding:          .75rem;\n$table-cell-padding-sm:       .3rem;\n\n$table-color:                 $body-color;\n$table-bg:                    null;\n$table-accent-bg:             $gray-300;\n$table-hover-color:           $table-color;\n$table-hover-bg:              $gray-300;\n$table-active-bg:             $table-hover-bg;\n\n$table-border-width:          $border-width;\n$table-border-color:          $border-color;\n\n$table-head-bg:               $gray-300;\n$table-head-color:            $gray-700;\n\n$table-dark-color:            $white;\n$table-dark-bg:               $gray-300;\n$table-dark-accent-bg:        rgba($white, .05);\n$table-dark-hover-color:      $table-dark-color;\n$table-dark-hover-bg:         rgba($white, .075);\n$table-dark-border-color:     lighten($table-dark-bg, 7.5%);\n$table-dark-color:            $white;\n\n$table-striped-order:         odd;\n\n$table-caption-color:         $text-muted;\n\n$table-bg-level:              -9;\n$table-border-level:          -6;\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n$input-btn-padding-y:         .47rem;\n$input-btn-padding-x:         .75rem;\n$input-btn-font-family:       null;\n$input-btn-font-size:         $font-size-base;\n$input-btn-line-height:       $line-height-base;\n\n$input-btn-focus-width:       .15rem;\n$input-btn-focus-color:       rgba($component-active-bg, .25);\n$input-btn-focus-box-shadow:  0 0 0 $input-btn-focus-width $input-btn-focus-color;\n\n$input-btn-padding-y-sm:      .25rem;\n$input-btn-padding-x-sm:      .5rem;\n$input-btn-font-size-sm:      $font-size-sm;\n$input-btn-line-height-sm:    $line-height-sm;\n\n$input-btn-padding-y-lg:      .5rem;\n$input-btn-padding-x-lg:      1rem;\n$input-btn-font-size-lg:      $font-size-lg;\n$input-btn-line-height-lg:    $line-height-lg;\n\n$input-btn-border-width:      $border-width;\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n$btn-padding-y:               $input-btn-padding-y;\n$btn-padding-x:               $input-btn-padding-x;\n$btn-font-family:             $input-btn-font-family;\n$btn-font-size:               $input-btn-font-size;\n$btn-line-height:             $input-btn-line-height;\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm;\n$btn-padding-x-sm:            $input-btn-padding-x-sm;\n$btn-font-size-sm:            $input-btn-font-size-sm;\n$btn-line-height-sm:          $input-btn-line-height-sm;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg;\n$btn-padding-x-lg:            $input-btn-padding-x-lg;\n$btn-font-size-lg:            $input-btn-font-size-lg;\n$btn-line-height-lg:          $input-btn-line-height-lg;\n\n$btn-border-width:            $input-btn-border-width;\n\n$btn-font-weight:             $font-weight-normal;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075);\n$btn-focus-width:             $input-btn-focus-width;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow;\n$btn-disabled-opacity:        .65;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125);\n\n$btn-link-disabled-color:     $gray-600;\n\n$btn-block-spacing-y:         .5rem;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           $border-radius;\n$btn-border-radius-lg:        $border-radius-lg;\n$btn-border-radius-sm:        $border-radius-sm;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n\n\n// Forms\n\n$label-margin-bottom:                   .5rem;\n\n$input-padding-y:                       $input-btn-padding-y;\n$input-padding-x:                       $input-btn-padding-x;\n$input-font-family:                     $input-btn-font-family;\n$input-font-size:                       $input-btn-font-size;\n$input-font-weight:                     $font-weight-base;\n$input-line-height:                     $input-btn-line-height;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm;\n$input-padding-x-sm:                    $input-btn-padding-x-sm;\n$input-font-size-sm:                    $input-btn-font-size-sm;\n$input-line-height-sm:                  $input-btn-line-height-sm;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg;\n$input-padding-x-lg:                    $input-btn-padding-x-lg;\n$input-font-size-lg:                    $input-btn-font-size-lg;\n$input-line-height-lg:                  $input-btn-line-height-lg;\n\n$input-bg:                              lighten($gray-200, 2%);\n$input-disabled-bg:                     lighten($gray-200, 1%);\n\n$input-color:                           $gray-700;\n$input-border-color:                    $gray-300;\n$input-border-width:                    $input-btn-border-width;\n$input-box-shadow:                      inset 0 1px 1px rgba($black, .075);\n\n$input-border-radius:                   $border-radius;\n$input-border-radius-lg:                $border-radius-lg;\n$input-border-radius-sm:                $border-radius-sm;\n\n$input-focus-bg:                        lighten($input-bg, 1%);\n$input-focus-border-color:              lighten($input-border-color, 2%);\n$input-focus-color:                     $input-color;\n$input-focus-width:                     $input-btn-focus-width;\n$input-focus-box-shadow:                none;\n\n$input-placeholder-color:               $gray-600;\n$input-plaintext-color:                 $body-color;\n\n$input-height-border:                   $input-border-width * 2;\n\n$input-height-inner:                    calc(#{$input-line-height * 1em} + #{$input-padding-y * 2});\n$input-height-inner-half:               calc(#{$input-line-height * .5em} + #{$input-padding-y});\n$input-height-inner-quarter:            calc(#{$input-line-height * .25em} + #{calc($input-padding-y / 2)});\n\n$input-height:                          calc(#{$input-line-height * 1em} + #{$input-padding-y * 2} + #{$input-height-border});\n$input-height-sm:                       calc(#{$input-line-height-sm * 1em} + #{$input-btn-padding-y-sm * 2} + #{$input-height-border});\n$input-height-lg:                       calc(#{$input-line-height-lg * 1em} + #{$input-btn-padding-y-lg * 2} + #{$input-height-border});\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n\n$form-text-margin-top:                  .25rem;\n\n$form-check-input-gutter:               1.25rem;\n$form-check-input-margin-y:             .3rem;\n$form-check-input-margin-x:             .25rem;\n\n$form-check-inline-margin-x:            .75rem;\n$form-check-inline-input-margin-x:      .3125rem;\n\n$form-grid-gutter-width:                10px;\n$form-group-margin-bottom:              1rem;\n\n$input-group-addon-color:               $input-color;\n$input-group-addon-bg:                  $gray-300;\n$input-group-addon-border-color:        $input-border-color;\n\n$custom-forms-transition:               background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n\n$custom-control-gutter:                 .5rem;\n$custom-control-spacer-x:               1rem;\n\n$custom-control-indicator-size:         1rem;\n$custom-control-indicator-bg:           $input-bg;\n\n$custom-control-indicator-bg-size:      50% 50%;\n$custom-control-indicator-box-shadow:   $input-box-shadow;\n$custom-control-indicator-border-color: $gray-300;\n$custom-control-indicator-border-width: $input-border-width;\n\n$custom-control-indicator-disabled-bg:          $input-disabled-bg;\n$custom-control-label-disabled-color:           $gray-600;\n\n$custom-control-indicator-checked-color:        $component-active-color;\n$custom-control-indicator-checked-bg:           $primary;\n$custom-control-indicator-checked-disabled-bg:  rgba(theme-color(\"primary\"), .5);\n$custom-control-indicator-checked-box-shadow:   none;\n$custom-control-indicator-checked-border-color: $custom-control-indicator-checked-bg;\n\n$custom-control-indicator-focus-box-shadow:     $input-focus-box-shadow;\n$custom-control-indicator-focus-border-color:   $input-focus-border-color;\n\n$custom-control-indicator-active-color:         $component-active-color;\n$custom-control-indicator-active-bg:            lighten($component-active-bg, 35%);\n$custom-control-indicator-active-box-shadow:    none;\n$custom-control-indicator-active-border-color:  $custom-control-indicator-active-bg;\n\n$custom-checkbox-indicator-border-radius:       $border-radius;\n$custom-checkbox-indicator-icon-checked:        str-replace(url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='#{$custom-control-indicator-checked-color}' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3e%3c/svg%3e\"), \"#\", \"%23\");\n\n$custom-checkbox-indicator-indeterminate-bg:           $component-active-bg;\n$custom-checkbox-indicator-indeterminate-color:        $custom-control-indicator-checked-color;\n$custom-checkbox-indicator-icon-indeterminate:         str-replace(url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 4'%3e%3cpath stroke='#{$custom-checkbox-indicator-indeterminate-color}' d='M0 2h4'/%3e%3c/svg%3e\"), \"#\", \"%23\");\n$custom-checkbox-indicator-indeterminate-box-shadow:   none;\n$custom-checkbox-indicator-indeterminate-border-color: $custom-checkbox-indicator-indeterminate-bg;\n\n$custom-radio-indicator-border-radius:          50%;\n$custom-radio-indicator-icon-checked:           str-replace(url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='#{$custom-control-indicator-checked-color}'/%3e%3c/svg%3e\"), \"#\", \"%23\");\n\n$custom-switch-width:                           $custom-control-indicator-size * 1.75;\n$custom-switch-indicator-border-radius:         calc($custom-control-indicator-size / 2);\n$custom-switch-indicator-size:                  calc(#{$custom-control-indicator-size} - #{$custom-control-indicator-border-width * 4});\n\n$custom-select-padding-y:           $input-padding-y;\n$custom-select-padding-x:           $input-padding-x;\n$custom-select-font-family:         $input-font-family;\n$custom-select-font-size:           $input-font-size;\n$custom-select-height:              $input-height;\n$custom-select-indicator-padding:   1rem; // Extra padding to account for the presence of the background-image based indicator\n$custom-select-font-weight:         $input-font-weight;\n$custom-select-line-height:         $input-line-height;\n$custom-select-color:               $input-color;\n$custom-select-disabled-color:      $gray-600;\n$custom-select-bg:                  $input-bg;\n$custom-select-disabled-bg:         $gray-200;\n$custom-select-bg-size:             8px 10px; // In pixels because image dimensions\n$custom-select-indicator-color:     $gray-800;\n$custom-select-indicator:           str-replace(url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='#{$custom-select-indicator-color}' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e\"), \"#\", \"%23\");\n$custom-select-background:          $custom-select-indicator no-repeat right $custom-select-padding-x center / $custom-select-bg-size; // Used so we can have multiple background elements (e.g., arrow and feedback icon)\n\n$custom-select-feedback-icon-padding-right: calc((1em + #{2 * $custom-select-padding-y}) * 3 / 4 + #{$custom-select-padding-x + $custom-select-indicator-padding});\n$custom-select-feedback-icon-position:      center right ($custom-select-padding-x + $custom-select-indicator-padding);\n$custom-select-feedback-icon-size:          $input-height-inner-half $input-height-inner-half;\n\n$custom-select-border-width:        $input-border-width;\n$custom-select-border-color:        $input-border-color;\n$custom-select-border-radius:       $border-radius;\n$custom-select-box-shadow:          inset 0 1px 2px rgba($black, .075);\n\n$custom-select-focus-border-color:  $input-focus-border-color;\n$custom-select-focus-width:         $input-focus-width;\n$custom-select-focus-box-shadow:    0 0 0 $custom-select-focus-width $input-btn-focus-color;\n\n$custom-select-padding-y-sm:        $input-padding-y-sm;\n$custom-select-padding-x-sm:        $input-padding-x-sm;\n$custom-select-font-size-sm:        $input-font-size-sm;\n$custom-select-height-sm:           $input-height-sm;\n\n$custom-select-padding-y-lg:        $input-padding-y-lg;\n$custom-select-padding-x-lg:        $input-padding-x-lg;\n$custom-select-font-size-lg:        $input-font-size-lg;\n$custom-select-height-lg:           $input-height-lg;\n\n$custom-range-track-width:          100%;\n$custom-range-track-height:         .5rem;\n$custom-range-track-cursor:         pointer;\n$custom-range-track-bg:             $gray-300;\n$custom-range-track-border-radius:  1rem;\n$custom-range-track-box-shadow:     inset 0 .25rem .25rem rgba($black, .1);\n\n$custom-range-thumb-width:                   1rem;\n$custom-range-thumb-height:                  $custom-range-thumb-width;\n$custom-range-thumb-bg:                      $component-active-bg;\n$custom-range-thumb-border:                  0;\n$custom-range-thumb-border-radius:           1rem;\n$custom-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1);\n$custom-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow;\n$custom-range-thumb-focus-box-shadow-width:  $input-focus-width; // For focus box shadow issue in IE/Edge\n$custom-range-thumb-active-bg:               lighten($component-active-bg, 35%);\n$custom-range-thumb-disabled-bg:             $gray-500;\n\n$custom-file-height:                $input-height;\n$custom-file-height-inner:          $input-height-inner;\n$custom-file-focus-border-color:    $input-focus-border-color;\n$custom-file-focus-box-shadow:      $input-focus-box-shadow;\n$custom-file-disabled-bg:           $input-disabled-bg;\n\n$custom-file-padding-y:             $input-padding-y;\n$custom-file-padding-x:             $input-padding-x;\n$custom-file-line-height:           $input-line-height;\n$custom-file-font-family:           $input-font-family;\n$custom-file-font-weight:           $input-font-weight;\n$custom-file-color:                 $input-color;\n$custom-file-bg:                    $input-bg;\n$custom-file-border-width:          $input-border-width;\n$custom-file-border-color:          $input-border-color;\n$custom-file-border-radius:         $input-border-radius;\n$custom-file-box-shadow:            $input-box-shadow;\n$custom-file-button-color:          $custom-file-color;\n$custom-file-button-bg:             $input-group-addon-bg;\n$custom-file-text: (\n  en: \"Browse\"\n);\n\n\n// Form validation\n\n$form-feedback-margin-top:          $form-text-margin-top;\n$form-feedback-font-size:           $small-font-size;\n$form-feedback-valid-color:         theme-color(\"success\");\n$form-feedback-invalid-color:       theme-color(\"danger\");\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color;\n$form-feedback-icon-valid:          str-replace(url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\"), \"#\", \"%23\");\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color;\n$form-feedback-icon-invalid:        str-replace(url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='#{$form-feedback-icon-invalid-color}' viewBox='-2 -2 7 7'%3e%3cpath stroke='#{$form-feedback-icon-invalid-color}' d='M0 0l3 3m0-3L0 3'/%3e%3ccircle r='.5'/%3e%3ccircle cx='3' r='.5'/%3e%3ccircle cy='3' r='.5'/%3e%3ccircle cx='3' cy='3' r='.5'/%3e%3c/svg%3E\"), \"#\", \"%23\");\n\n$form-validation-states: ();\n// stylelint-disable-next-line scss/dollar-variable-default\n$form-validation-states: map-merge(\n  (\n    \"valid\": (\n      \"color\": $form-feedback-valid-color,\n      \"icon\": $form-feedback-icon-valid\n    ),\n    \"invalid\": (\n      \"color\": $form-feedback-invalid-color,\n      \"icon\": $form-feedback-icon-invalid\n    ),\n  ),\n  $form-validation-states\n);\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n$zindex-dropdown:                   1000;\n$zindex-sticky:                     1020;\n$zindex-fixed:                      1030;\n$zindex-modal-backdrop:             1040;\n$zindex-modal:                      1050;\n$zindex-popover:                    1060;\n$zindex-tooltip:                    1070;\n\n\n// Navs\n\n$nav-link-padding-y:                .5rem;\n$nav-link-padding-x:                1rem;\n$nav-link-disabled-color:           $gray-600;\n\n$nav-tabs-border-color:             $gray-300;\n$nav-tabs-border-width:             $border-width;\n$nav-tabs-border-radius:            $border-radius;\n$nav-tabs-link-hover-border-color:  $gray-200 $gray-200 $nav-tabs-border-color;\n$nav-tabs-link-active-color:        $gray-700;\n$nav-tabs-link-active-bg:           $gray-200;\n$nav-tabs-link-active-border-color: $gray-300 $gray-300 $nav-tabs-link-active-bg;\n\n$nav-pills-border-radius:           $border-radius;\n$nav-pills-link-active-color:       $component-active-color;\n$nav-pills-link-active-bg:          $component-active-bg;\n\n$nav-divider-color:                 $gray-200;\n$nav-divider-margin-y:              calc($spacer / 2);\n\n\n// Navbar\n\n$navbar-padding-y:                  calc($spacer / 2);\n$navbar-padding-x:                  $spacer;\n\n$navbar-nav-link-padding-x:         .5rem;\n\n$navbar-brand-font-size:            $font-size-lg;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base;\n$navbar-brand-padding-y:            calc(($nav-link-height - $navbar-brand-height) / 2);\n\n$navbar-toggler-padding-y:          .25rem;\n$navbar-toggler-padding-x:          .75rem;\n$navbar-toggler-font-size:          $font-size-lg;\n$navbar-toggler-border-radius:      $btn-border-radius;\n\n$navbar-dark-color:                 rgba($white, .5);\n$navbar-dark-hover-color:           rgba($white, .75);\n$navbar-dark-active-color:          $white;\n$navbar-dark-disabled-color:        rgba($white, .25);\n$navbar-dark-toggler-icon-bg:       str-replace(url(\"data:image/svg+xml,%3csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3e%3cpath stroke='#{$navbar-dark-color}' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\"), \"#\", \"%23\");\n$navbar-dark-toggler-border-color:  rgba($white, .1);\n\n$navbar-light-color:                rgba($black, .5);\n$navbar-light-hover-color:          rgba($black, .7);\n$navbar-light-active-color:         rgba($black, .9);\n$navbar-light-disabled-color:       rgba($black, .3);\n$navbar-light-toggler-icon-bg:      str-replace(url(\"data:image/svg+xml,%3csvg viewBox='0 0 30 30' xmlns='http://www.w3.org/2000/svg'%3e%3cpath stroke='#{$navbar-light-color}' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\"), \"#\", \"%23\");\n$navbar-light-toggler-border-color: rgba($black, .1);\n\n$navbar-light-brand-color:                $navbar-light-active-color;\n$navbar-light-brand-hover-color:          $navbar-light-active-color;\n$navbar-dark-brand-color:                 $navbar-dark-active-color;\n$navbar-dark-brand-hover-color:           $navbar-dark-active-color;\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n$dropdown-min-width:                10rem;\n$dropdown-padding-y:                .5rem;\n$dropdown-spacer:                   .125rem;\n$dropdown-font-size:                $font-size-base;\n$dropdown-color:                    $body-color;\n$dropdown-bg:                       $gray-200;\n$dropdown-border-color:             lighten($gray-200, 4%);\n$dropdown-border-radius:            $border-radius;\n$dropdown-border-width:             $border-width;\n$dropdown-inner-border-radius:      calc(#{$dropdown-border-radius} - #{$dropdown-border-width});\n$dropdown-divider-bg:               $gray-200;\n$dropdown-divider-margin-y:         $nav-divider-margin-y;\n$dropdown-box-shadow:               0 .5rem 1rem rgba($black, .175);\n\n$dropdown-link-color:               $gray-900;\n$dropdown-link-hover-color:         lighten($gray-900, 5%);\n$dropdown-link-hover-bg:            $gray-300;\n\n$dropdown-link-active-color:        lighten($gray-900, 5%);\n$dropdown-link-active-bg:           $gray-300;\n\n$dropdown-link-disabled-color:      $gray-600;\n\n$dropdown-item-padding-y:           .35rem;\n$dropdown-item-padding-x:           1.5rem;\n\n$dropdown-header-color:             $gray-600;\n\n\n// Pagination\n\n$pagination-padding-y:              .5rem;\n$pagination-padding-x:              .75rem;\n$pagination-padding-y-sm:           .25rem;\n$pagination-padding-x-sm:           .5rem;\n$pagination-padding-y-lg:           .75rem;\n$pagination-padding-x-lg:           1.5rem;\n$pagination-line-height:            1.25;\n\n$pagination-color:                  $gray-500;\n$pagination-bg:                     $gray-200;\n$pagination-border-width:           $border-width;\n$pagination-border-color:           $gray-300;\n\n$pagination-focus-box-shadow:       $input-btn-focus-box-shadow;\n$pagination-focus-outline:          0;\n\n$pagination-hover-color:            $gray-500;\n$pagination-hover-bg:               $gray-200;\n$pagination-hover-border-color:     $gray-300;\n\n$pagination-active-color:           $component-active-color;\n$pagination-active-bg:              $component-active-bg;\n$pagination-active-border-color:    $pagination-active-bg;\n\n$pagination-disabled-color:         $gray-600;\n$pagination-disabled-bg:            $gray-200;\n$pagination-disabled-border-color:  $gray-300;\n\n\n// Jumbotron\n\n$jumbotron-padding:                 2rem;\n$jumbotron-color:                   null;\n$jumbotron-bg:                      $gray-200;\n\n\n// Cards\n\n$card-spacer-y:                     .75rem;\n$card-spacer-x:                     1.25rem;\n$card-border-width:                 0;\n$card-border-radius:                $border-radius-lg;\n$card-border-color:                 rgba($black, .125);\n$card-inner-border-radius:          calc(#{$card-border-radius} - #{$card-border-width});\n$card-cap-bg:                       $gray-300;\n$card-cap-color:                    null;\n$card-color:                        null;\n$card-bg:                           #494E67;\n\n$card-img-overlay-padding:          1.25rem;\n\n$card-group-margin:                 calc($grid-gutter-width / 2);\n$card-deck-margin:                  $card-group-margin;\n\n$card-columns-count:                3;\n$card-columns-gap:                  1.25rem;\n$card-columns-margin:               $card-spacer-y;\n\n\n// Tooltips\n\n$tooltip-font-size:                 $font-size-sm;\n$tooltip-max-width:                 200px;\n$tooltip-color:                     $gray-300;\n$tooltip-bg:                        $gray-900;\n$tooltip-border-radius:             $border-radius;\n$tooltip-opacity:                   .9;\n$tooltip-padding-y:                 .25rem;\n$tooltip-padding-x:                 .5rem;\n$tooltip-margin:                    0;\n\n$tooltip-arrow-width:               .8rem;\n$tooltip-arrow-height:              .4rem;\n$tooltip-arrow-color:               $tooltip-bg;\n\n// Form tooltips must come after regular tooltips\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x;\n$form-feedback-tooltip-font-size:     $tooltip-font-size;\n$form-feedback-tooltip-line-height:   $line-height-base;\n$form-feedback-tooltip-opacity:       $tooltip-opacity;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius;\n\n\n// Popovers\n\n$popover-font-size:                 $font-size-sm;\n$popover-bg:                        $gray-900;\n$popover-max-width:                 276px;\n$popover-border-width:              $border-width;\n$popover-border-color:              darken($popover-bg, 5%);\n$popover-border-radius:             $border-radius-lg;\n$popover-box-shadow:                0 .25rem .5rem rgba($black, .2);\n\n$popover-header-bg:                 darken($popover-bg, 3%);\n$popover-header-color:              $gray-200;\n$popover-header-padding-y:          .5rem;\n$popover-header-padding-x:          .75rem;\n\n$popover-body-color:                $gray-200;\n$popover-body-padding-y:            $popover-header-padding-y;\n$popover-body-padding-x:            $popover-header-padding-x;\n\n$popover-arrow-width:               1rem;\n$popover-arrow-height:              .5rem;\n$popover-arrow-color:               $popover-bg;\n\n$popover-arrow-outer-color:         fade-in($popover-border-color, .05);\n\n\n// Toasts\n\n$toast-max-width:                   350px;\n$toast-padding-x:                   .75rem;\n$toast-padding-y:                   .25rem;\n$toast-font-size:                   .875rem;\n$toast-color:                       null;\n$toast-background-color:            $gray-300;\n$toast-border-width:                1px;\n$toast-border-color:                rgba(0, 0, 0, .1);\n$toast-border-radius:               .25rem;\n$toast-box-shadow:                  0 .25rem .75rem rgba($black, .1);\n\n$toast-header-color:                $gray-600;\n$toast-header-background-color:     darken($gray-300, 1%);\n$toast-header-border-color:         rgba(0, 0, 0, .05);\n\n\n// Badges\n\n$badge-font-size:                   75%;\n$badge-font-weight:                 $font-weight-semibold;\n$badge-padding-y:                   .25em;\n$badge-padding-x:                   .4em;\n$badge-border-radius:               $border-radius;\n\n$badge-transition:                  $btn-transition;\n$badge-focus-width:                 $input-btn-focus-width;\n\n$badge-pill-padding-x:              .6em;\n// Use a higher than normal value to ensure completely rounded edges when\n// customizing padding or font-size on labels.\n$badge-pill-border-radius:          10rem;\n\n\n// Modals\n\n// Padding applied to the modal body\n$modal-inner-padding:               1rem;\n\n$modal-dialog-margin:               .5rem;\n$modal-dialog-margin-y-sm-up:       1.75rem;\n\n$modal-title-line-height:           $line-height-base;\n\n$modal-content-color:               null;\n$modal-content-bg:                  $gray-200;\n$modal-content-border-color:        rgba($black, .2);\n$modal-content-border-width:        $border-width;\n$modal-content-border-radius:       $border-radius-lg;\n$modal-content-box-shadow-xs:       0 .25rem .5rem rgba($black, .5);\n$modal-content-box-shadow-sm-up:    0 .5rem 1rem rgba($black, .5);\n\n$modal-backdrop-bg:                 $black;\n$modal-backdrop-opacity:            .5;\n$modal-header-border-color:         $border-color;\n$modal-footer-border-color:         $modal-header-border-color;\n$modal-header-border-width:         $modal-content-border-width;\n$modal-footer-border-width:         $modal-header-border-width;\n$modal-header-padding-y:            1rem;\n$modal-header-padding-x:            1rem;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x; // Keep this for backwards compatibility\n\n$modal-xl:                          1140px;\n$modal-lg:                          800px;\n$modal-md:                          500px;\n$modal-sm:                          300px;\n\n$modal-fade-transform:              translate(0, -50px);\n$modal-show-transform:              none;\n$modal-transition:                  transform .3s ease-out;\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n$alert-padding-y:                   .75rem;\n$alert-padding-x:                   1.25rem;\n$alert-margin-bottom:               1rem;\n$alert-border-radius:               $border-radius;\n$alert-link-font-weight:            $font-weight-bold;\n$alert-border-width:                $border-width;\n\n$alert-bg-level:                    0;\n$alert-border-level:                0;\n$alert-color-level:                 6;\n\n\n// Progress bars\n\n$progress-height:                   .75rem;\n$progress-font-size:                $font-size-base * .75;\n$progress-bg:                       $gray-300;\n$progress-border-radius:            $border-radius;\n$progress-box-shadow:               inset 0 .1rem .1rem rgba($black, .1);\n$progress-bar-color:                $white;\n$progress-bar-bg:                   theme-color(\"primary\");\n$progress-bar-animation-timing:     1s linear infinite;\n$progress-bar-transition:           width .6s ease;\n\n\n// List group\n\n$list-group-color:                  null;\n$list-group-bg:                     $gray-200;\n$list-group-border-color:           $gray-300;\n$list-group-border-width:           $border-width;\n$list-group-border-radius:          $border-radius;\n\n$list-group-item-padding-y:         .75rem;\n$list-group-item-padding-x:         1.25rem;\n\n$list-group-hover-bg:               $gray-100;\n$list-group-active-color:           $component-active-color;\n$list-group-active-bg:              $component-active-bg;\n$list-group-active-border-color:    $list-group-active-bg;\n\n$list-group-disabled-color:         $gray-600;\n$list-group-disabled-bg:            $list-group-bg;\n\n$list-group-action-color:           $gray-700;\n$list-group-action-hover-color:     $list-group-action-color;\n\n$list-group-action-active-color:    $body-color;\n$list-group-action-active-bg:       $gray-200;\n\n\n// Image thumbnails\n\n$thumbnail-padding:                 .25rem;\n$thumbnail-bg:                      $gray-300;\n$thumbnail-border-width:            $border-width;\n$thumbnail-border-color:            $gray-300;\n$thumbnail-border-radius:           $border-radius;\n$thumbnail-box-shadow:              0 1px 2px rgba($black, .075);\n\n\n// Figures\n\n$figure-caption-font-size:          90%;\n$figure-caption-color:              $gray-600;\n\n\n// Breadcrumbs\n\n$breadcrumb-padding-y:              .75rem;\n$breadcrumb-padding-x:              1rem;\n$breadcrumb-item-padding:           .5rem;\n\n$breadcrumb-margin-bottom:          1rem;\n\n$breadcrumb-bg:                     $gray-200;\n$breadcrumb-divider-color:          $gray-600;\n$breadcrumb-active-color:           $gray-600;\n$breadcrumb-divider:                quote(\"/\");\n\n$breadcrumb-border-radius:          $border-radius;\n\n\n// Carousel\n\n$carousel-control-color:             $white;\n$carousel-control-width:             15%;\n$carousel-control-opacity:           .5;\n$carousel-control-hover-opacity:     .9;\n$carousel-control-transition:        opacity .15s ease;\n\n$carousel-indicator-width:           30px;\n$carousel-indicator-height:          3px;\n$carousel-indicator-hit-area-height: 10px;\n$carousel-indicator-spacer:          3px;\n$carousel-indicator-active-bg:       $white;\n$carousel-indicator-transition:      opacity .6s ease;\n\n$carousel-caption-width:             70%;\n$carousel-caption-color:             $white;\n\n$carousel-control-icon-width:        20px;\n\n$carousel-control-prev-icon-bg:      str-replace(url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='#{$carousel-control-color}' viewBox='0 0 8 8'%3e%3cpath d='M5.25 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z'/%3e%3c/svg%3e\"), \"#\", \"%23\");\n$carousel-control-next-icon-bg:      str-replace(url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='#{$carousel-control-color}' viewBox='0 0 8 8'%3e%3cpath d='M2.75 0l-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 4-4-4-4z'/%3e%3c/svg%3e\"), \"#\", \"%23\");\n\n$carousel-transition-duration:       .6s;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n\n\n// Spinners\n\n$spinner-width:         2rem;\n$spinner-height:        $spinner-width;\n$spinner-border-width:  .25em;\n\n$spinner-width-sm:        1rem;\n$spinner-height-sm:       $spinner-width-sm;\n$spinner-border-width-sm: .2em;\n\n\n// Close\n\n$close-font-size:                   $font-size-base * 1.5;\n$close-font-weight:                 $font-weight-bold;\n$close-color:                       $black;\n$close-text-shadow:                 0 1px 0 $white;\n\n\n// Code\n\n$code-font-size:                    87.5%;\n$code-color:                        $pink;\n\n$kbd-padding-y:                     .2rem;\n$kbd-padding-x:                     .4rem;\n$kbd-font-size:                     $code-font-size;\n$kbd-color:                         $white;\n$kbd-bg:                            $gray-900;\n\n$pre-color:                         $gray-900;\n$pre-scrollable-max-height:         340px;\n\n\n// Utilities\n\n$displays: none, inline, inline-block, block, table, table-row, table-cell, flex, inline-flex;\n$overflows: auto, hidden;\n$positions: static, relative, absolute, fixed, sticky;\n\n\n// Printing\n\n$print-page-size:                   a3;\n$print-body-min-width:              map-get($grid-breakpoints, \"lg\");\n\n// button\n$btn-soft-bg-opacity:  0.5;\n\n","// stylelint-disable property-blacklist, scss/dollar-variable-default\n\n// SCSS RFS mixin\n//\n// Automated responsive font sizes\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/v8.x/LICENSE)\n\n// Configuration\n\n// Base font size\n$rfs-base-font-size: 1.25rem !default;\n$rfs-font-size-unit: rem !default;\n\n@if $rfs-font-size-unit != rem and $rfs-font-size-unit != px {\n  @error \"`#{$rfs-font-size-unit}` is not a valid unit for $rfs-font-size-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where font-size starts decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize font size based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != \"number\" or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-responsive-font-sizes to false\n$enable-responsive-font-sizes: true !default;\n\n// Cache $rfs-base-font-size unit\n$rfs-base-font-size-unit: unit($rfs-base-font-size);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-font-size for calculations\n@if $rfs-base-font-size-unit == \"px\" {\n  $rfs-base-font-size: divide($rfs-base-font-size, $rfs-base-font-size * 0 + 1);\n}\n@else if $rfs-base-font-size-unit == \"rem\" {\n  $rfs-base-font-size: divide($rfs-base-font-size, divide($rfs-base-font-size * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == \"px\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == \"rem\" or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-disable-class {\n  @if $rfs-class == \"disable\" {\n    // Adding an extra class increases specificity, which prevents the media query to override the font size\n    &,\n    .disable-responsive-font-size &,\n    &.disable-responsive-font-size {\n      @content;\n    }\n  }\n  @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-enable-class {\n  @if $rfs-class == \"enable\" {\n    .enable-responsive-font-size &,\n    &.enable-responsive-font-size {\n      @content;\n    }\n  }\n  @else {\n    @content;\n  }\n}\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query($mq-value) {\n  @if $rfs-two-dimensional {\n    @media (max-width: #{$mq-value}), (max-height: #{$mq-value}) {\n      @content;\n    }\n  }\n  @else {\n    @media (max-width: #{$mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Responsive font size mixin\n@mixin rfs($fs, $important: false) {\n  // Cache $fs unit\n  $fs-unit: if(type-of($fs) == \"number\", unit($fs), false);\n\n  // Add !important suffix if needed\n  $rfs-suffix: if($important, \" !important\", \"\");\n\n  // If $fs isn't a number (like inherit) or $fs has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n  @if not $fs-unit or $fs-unit != \"\" and $fs-unit != \"px\" and $fs-unit != \"rem\" or $fs == 0 {\n    font-size: #{$fs}#{$rfs-suffix};\n  }\n  @else {\n    // Remove unit from $fs for calculations\n    @if $fs-unit == \"px\" {\n      $fs: divide($fs, $fs * 0 + 1);\n    }\n    @else if $fs-unit == \"rem\" {\n      $fs: divide($fs, divide($fs * 0 + 1, $rfs-rem-value));\n    }\n\n    // Set default font size\n    $rfs-static: if($rfs-font-size-unit == rem, #{divide($fs, $rfs-rem-value)}rem, #{$fs}px);\n\n    // Only add the media query if the font size is bigger than the minimum font size\n    @if $fs <= $rfs-base-font-size or not $enable-responsive-font-sizes {\n      font-size: #{$rfs-static}#{$rfs-suffix};\n    }\n    @else {\n      // Calculate the minimum font size for $fs\n      $fs-min: $rfs-base-font-size + divide($fs - $rfs-base-font-size, $rfs-factor);\n\n      // Calculate difference between $fs and the minimum font size\n      $fs-diff: $fs - $fs-min;\n\n      // Base font-size formatting\n      $min-width: if($rfs-font-size-unit == rem, #{divide($fs-min, $rfs-rem-value)}rem, #{$fs-min}px);\n\n      // Use `vmin` if two-dimensional is enabled\n      $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n      // Calculate the variable width between 0 and $rfs-breakpoint\n      $variable-width: #{divide($fs-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n      // Set the calculated font-size\n      $rfs-fluid: calc(#{$min-width} + #{$variable-width}) #{$rfs-suffix};\n\n      // Breakpoint formatting\n      $mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n\n      @include _rfs-disable-class {\n        font-size: #{$rfs-static}#{$rfs-suffix};\n      }\n\n      @include _rfs-media-query($mq-value) {\n        @include _rfs-enable-class {\n          font-size: $rfs-fluid;\n        }\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n    }\n  }\n}\n\n// The font-size & responsive-font-size mixins use RFS to rescale the font size\n@mixin font-size($fs, $important: false) {\n  @include rfs($fs, $important);\n}\n\n@mixin responsive-font-size($fs, $important: false) {\n  @include rfs($fs, $important);\n}\n","// Hover mixin and `$enable-hover-media-query` are deprecated.\n//\n// Originally added during our alphas and maintained during betas, this mixin was\n// designed to prevent `:hover` stickiness on iOS-an issue where hover styles\n// would persist after initial touch.\n//\n// For backward compatibility, we've kept these mixins and updated them to\n// always return their regular pseudo-classes instead of a shimmed media query.\n//\n// Issue: https://github.com/twbs/bootstrap/issues/25195\n\n@mixin hover() {\n  &:hover { @content; }\n}\n\n@mixin hover-focus() {\n  &:hover,\n  &:focus {\n    @content;\n  }\n}\n\n@mixin plain-hover-focus() {\n  &,\n  &:hover,\n  &:focus {\n    @content;\n  }\n}\n\n@mixin hover-focus-active() {\n  &:hover,\n  &:focus,\n  &:active {\n    @content;\n  }\n}\n","// stylelint-disable selector-list-comma-newline-after\n\n//\n// Headings\n//\n\nh1, h2, h3, h4, h5, h6,\n.h1, .h2, .h3, .h4, .h5, .h6 {\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: $headings-color;\n}\n\nh1, .h1 { @include font-size($h1-font-size); }\nh2, .h2 { @include font-size($h2-font-size); }\nh3, .h3 { @include font-size($h3-font-size); }\nh4, .h4 { @include font-size($h4-font-size); }\nh5, .h5 { @include font-size($h5-font-size); }\nh6, .h6 { @include font-size($h6-font-size); }\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n.display-1 {\n  @include font-size($display1-size);\n  font-weight: $display1-weight;\n  line-height: $display-line-height;\n}\n.display-2 {\n  @include font-size($display2-size);\n  font-weight: $display2-weight;\n  line-height: $display-line-height;\n}\n.display-3 {\n  @include font-size($display3-size);\n  font-weight: $display3-weight;\n  line-height: $display-line-height;\n}\n.display-4 {\n  @include font-size($display4-size);\n  font-weight: $display4-weight;\n  line-height: $display-line-height;\n}\n\n\n//\n// Horizontal rules\n//\n\nhr {\n  margin-top: $hr-margin-y;\n  margin-bottom: $hr-margin-y;\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n}\n\n\n//\n// Emphasis\n//\n\nsmall,\n.small {\n  @include font-size($small-font-size);\n  font-weight: $font-weight-normal;\n}\n\nmark,\n.mark {\n  padding: $mark-padding;\n  background-color: $mark-bg;\n}\n\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size(90%);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $spacer;\n  @include font-size($blockquote-font-size);\n}\n\n.blockquote-footer {\n  display: block;\n  @include font-size($blockquote-small-font-size);\n  color: $blockquote-small-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled() {\n  padding-left: 0;\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: $figure-caption-color;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid() {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n\n\n// Retina image\n//\n// Short retina mixin for setting background-image and -size.\n\n@mixin img-retina($file-1x, $file-2x, $width-1x, $height-1x) {\n  background-image: url($file-1x);\n\n  // Autoprefixer takes care of adding -webkit-min-device-pixel-ratio and -o-min-device-pixel-ratio,\n  // but doesn't convert dppx=>dpi.\n  // There's no such thing as unprefixed min-device-pixel-ratio since it's nonstandard.\n  // Compatibility info: https://caniuse.com/css-media-resolution\n  @media only screen and (min-resolution: 192dpi), // IE9-11 don't support dppx\n    only screen and (min-resolution: 2dppx) { // Standardized\n    background-image: url($file-2x);\n    background-size: $width-1x $height-1x;\n  }\n  @include deprecate(\"`img-retina()`\", \"v4.3.0\", \"v5\");\n}\n","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-right-radius($radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-left-radius($radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-left-radius($radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-right-radius($radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-right-radius($radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-left-radius($radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n","// Inline code\ncode {\n  @include font-size($code-font-size);\n  color: $code-color;\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\n// User input typically entered via keyboard\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n  @include box-shadow($kbd-box-shadow);\n\n  kbd {\n    padding: 0;\n    @include font-size(100%);\n    font-weight: $nested-kbd-font-weight;\n    @include box-shadow(none);\n  }\n}\n\n// Blocks of code\npre {\n  display: block;\n  @include font-size($code-font-size);\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\n// Enable scrollable blocks of code\n.pre-scrollable {\n  max-height: $pre-scrollable-max-height;\n  overflow-y: scroll;\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-grid-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Row\n//\n// Rows contain your columns.\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n  }\n\n  // Remove the negative margin from default .row, then the horizontal padding\n  // from all immediate children columns (to prevent runaway style inheritance).\n  .no-gutters {\n    margin-right: 0;\n    margin-left: 0;\n\n    > .col,\n    > [class*=\"col-\"] {\n      padding-right: 0;\n      padding-left: 0;\n    }\n  }\n}\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","/// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-container($gutter: $grid-gutter-width) {\n  width: 100%;\n  padding-right: $gutter * .5;\n  padding-left: $gutter * .5;\n  margin-right: auto;\n  margin-left: auto;\n}\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -$gutter * .5;\n  margin-left: -$gutter * .5;\n}\n\n// For each breakpoint, define the maximum width of the container in a media query\n@mixin make-container-max-widths($max-widths: $container-max-widths, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint, $container-max-width in $max-widths {\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      max-width: $container-max-width;\n    }\n  }\n  @include deprecate(\"The `make-container-max-widths` mixin\", \"v4.5.2\", \"v5\");\n}\n\n@mixin make-col-ready($gutter: $grid-gutter-width) {\n  position: relative;\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we use `flex` values\n  // later on to override this initial width.\n  width: 100%;\n  padding-right: $gutter * .5;\n  padding-left: $gutter * .5;\n}\n\n@mixin make-col($size, $columns: $grid-columns) {\n  flex: 0 0 percentage(divide($size, $columns));\n  // Add a `max-width` to ensure content within each column does not blow out\n  // the width of the column. Applies to IE10+ and Firefox. Chrome and Safari\n  // do not appear to require this.\n  max-width: percentage(divide($size, $columns));\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n  max-width: 100%; // Reset earlier grid tiers\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  margin-left: if($num == 0, 0, percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// numberof columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 divide(100%, $count);\n    max-width: divide(100%, $count);\n  }\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @return if($n != null and $n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width. Null for the largest (last) breakpoint.\n// The maximum value is calculated as the minimum of the next one less 0.02px\n// to work around the limitations of `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $next: breakpoint-next($name, $breakpoints);\n  @return if($next, breakpoint-min($next, $breakpoints) - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  $max: breakpoint-max($name, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($name, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  // Common properties for all breakpoints\n  %grid-column {\n    position: relative;\n    width: 100%;\n    padding-right: $gutter * .5;\n    padding-left: $gutter * .5;\n  }\n\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @if $columns > 0 {\n      // Allow columns to stretch full width below their breakpoints\n      @for $i from 1 through $columns {\n        .col#{$infix}-#{$i} {\n          @extend %grid-column;\n        }\n      }\n    }\n\n    .col#{$infix},\n    .col#{$infix}-auto {\n      @extend %grid-column;\n    }\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex-basis: 0;\n        flex-grow: 1;\n        max-width: 100%;\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n      }\n\n      .order#{$infix}-first { order: -1; }\n\n      .order#{$infix}-last { order: $columns + 1; }\n\n      @for $i from 0 through $columns {\n        .order#{$infix}-#{$i} { order: $i; }\n      }\n\n      @if $columns > 0 {\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  width: 100%;\n  margin-bottom: $spacer;\n  color: $table-color;\n  background-color: $table-bg; // Reset for nesting within parents with `background-color`.\n\n  th,\n  td {\n    padding: $table-cell-padding;\n    vertical-align: top;\n    border-top: $table-border-width solid $table-border-color;\n  }\n\n  thead th {\n    vertical-align: bottom;\n    border-bottom: (2 * $table-border-width) solid $table-border-color;\n  }\n\n  tbody + tbody {\n    border-top: (2 * $table-border-width) solid $table-border-color;\n  }\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  th,\n  td {\n    padding: $table-cell-padding-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n\n.table-bordered {\n  border: $table-border-width solid $table-border-color;\n\n  th,\n  td {\n    border: $table-border-width solid $table-border-color;\n  }\n\n  thead {\n    th,\n    td {\n      border-bottom-width: 2 * $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  th,\n  td,\n  thead th,\n  tbody + tbody {\n    border: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n.table-striped {\n  tbody tr:nth-of-type(#{$table-striped-order}) {\n    background-color: $table-accent-bg;\n  }\n}\n\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  tbody tr {\n    @include hover() {\n      color: $table-hover-color;\n      background-color: $table-hover-bg;\n    }\n  }\n}\n\n\n// Table backgrounds\n//\n// Exact selectors below required to override `.table-striped` and prevent\n// inheritance to nested tables.\n\n@each $color, $value in $theme-colors {\n  @include table-row-variant($color, theme-color-level($color, $table-bg-level), theme-color-level($color, $table-border-level));\n}\n\n@include table-row-variant(active, $table-active-bg);\n\n\n// Dark styles\n//\n// Same table markup, but inverted color scheme: dark background and light text.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.table {\n  .thead-dark {\n    th {\n      color: $table-dark-color;\n      background-color: $table-dark-bg;\n      border-color: $table-dark-border-color;\n    }\n  }\n\n  .thead-light {\n    th {\n      color: $table-head-color;\n      background-color: $table-head-bg;\n      border-color: $table-border-color;\n    }\n  }\n}\n\n.table-dark {\n  color: $table-dark-color;\n  background-color: $table-dark-bg;\n\n  th,\n  td,\n  thead th {\n    border-color: $table-dark-border-color;\n  }\n\n  &.table-bordered {\n    border: 0;\n  }\n\n  &.table-striped {\n    tbody tr:nth-of-type(#{$table-striped-order}) {\n      background-color: $table-dark-accent-bg;\n    }\n  }\n\n  &.table-hover {\n    tbody tr {\n      @include hover() {\n        color: $table-dark-hover-color;\n        background-color: $table-dark-hover-bg;\n      }\n    }\n  }\n}\n\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n.table-responsive {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    &#{$infix} {\n      @include media-breakpoint-down($breakpoint) {\n        display: block;\n        width: 100%;\n        overflow-x: auto;\n        -webkit-overflow-scrolling: touch;\n\n        // Prevent double border on horizontal scroll due to use of `display: block;`\n        > .table-bordered {\n          border: 0;\n        }\n      }\n    }\n  }\n}\n","// Tables\n\n@mixin table-row-variant($state, $background, $border: null) {\n  // Exact selectors below required to override `.table-striped` and prevent\n  // inheritance to nested tables.\n  .table-#{$state} {\n    &,\n    > th,\n    > td {\n      background-color: $background;\n    }\n\n    @if $border != null {\n      th,\n      td,\n      thead th,\n      tbody + tbody {\n        border-color: $border;\n      }\n    }\n  }\n\n  // Hover states for `.table-hover`\n  // Note: this is not available for cells or rows within `thead` or `tfoot`.\n  .table-hover {\n    $hover-background: darken($background, 5%);\n\n    .table-#{$state} {\n      @include hover() {\n        background-color: $hover-background;\n\n        > td,\n        > th {\n          background-color: $hover-background;\n        }\n      }\n    }\n  }\n}\n","// stylelint-disable selector-no-qualifying-type\n\n//\n// Textual form controls\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  height: $input-height;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  // Unstyle the caret on `<select>`s in IE10+.\n  &::-ms-expand {\n    background-color: transparent;\n    border: 0;\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  @include form-control-focus($ignore-warning: true);\n\n  // Placeholder\n  &::placeholder {\n    color: $input-placeholder-color;\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled and read-only inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled,\n  &[readonly] {\n    background-color: $input-disabled-bg;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n}\n\ninput[type=\"date\"],\ninput[type=\"time\"],\ninput[type=\"datetime-local\"],\ninput[type=\"month\"] {\n  &.form-control {\n    appearance: none; // Fix appearance for date inputs in Safari\n  }\n}\n\nselect.form-control {\n  // Remove select outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $input-color;\n  }\n\n  &:focus::-ms-value {\n    // Suppress the nested default white text on blue background highlight given to\n    // the selected option text when the (still closed) <select> receives focus\n    // in IE and (under certain conditions) Edge, as it looks bad and cannot be made to\n    // match the appearance of the native widget.\n    // See https://github.com/twbs/bootstrap/issues/19398.\n    color: $input-color;\n    background-color: $input-bg;\n  }\n}\n\n// Make file inputs better match text inputs by forcing them to new lines.\n.form-control-file,\n.form-control-range {\n  display: block;\n  width: 100%;\n}\n\n\n//\n// Labels\n//\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<label>/<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  line-height: $input-line-height;\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n  line-height: $input-line-height-lg;\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n  line-height: $input-line-height-sm;\n}\n\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  @include font-size($input-font-size);\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  line-height: $input-line-height-sm;\n  @include border-radius($input-border-radius-sm);\n}\n\n.form-control-lg {\n  height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  line-height: $input-line-height-lg;\n  @include border-radius($input-border-radius-lg);\n}\n\n// stylelint-disable-next-line no-duplicate-selectors\nselect.form-control {\n  &[size],\n  &[multiple] {\n    height: auto;\n  }\n}\n\ntextarea.form-control {\n  height: auto;\n}\n\n// Form groups\n//\n// Designed to help with the organization and spacing of vertical forms. For\n// horizontal forms, use the predefined grid classes.\n\n.form-group {\n  margin-bottom: $form-group-margin-bottom;\n}\n\n.form-text {\n  display: block;\n  margin-top: $form-text-margin-top;\n}\n\n\n// Form grid\n//\n// Special replacement for our grid system's `.row` for tighter form layouts.\n\n.form-row {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -$form-grid-gutter-width * .5;\n  margin-left: -$form-grid-gutter-width * .5;\n\n  > .col,\n  > [class*=\"col-\"] {\n    padding-right: $form-grid-gutter-width * .5;\n    padding-left: $form-grid-gutter-width * .5;\n  }\n}\n\n\n// Checkboxes and radios\n//\n// Indent the labels to position radios/checkboxes as hanging controls.\n\n.form-check {\n  position: relative;\n  display: block;\n  padding-left: $form-check-input-gutter;\n}\n\n.form-check-input {\n  position: absolute;\n  margin-top: $form-check-input-margin-y;\n  margin-left: -$form-check-input-gutter;\n\n  // Use [disabled] and :disabled for workaround https://github.com/twbs/bootstrap/issues/28247\n  &[disabled] ~ .form-check-label,\n  &:disabled ~ .form-check-label {\n    color: $text-muted;\n  }\n}\n\n.form-check-label {\n  margin-bottom: 0; // Override default `<label>` bottom margin\n}\n\n.form-check-inline {\n  display: inline-flex;\n  align-items: center;\n  padding-left: 0; // Override base .form-check\n  margin-right: $form-check-inline-margin-x;\n\n  // Undo .form-check-input defaults and add some `margin-right`.\n  .form-check-input {\n    position: static;\n    margin-top: 0;\n    margin-right: $form-check-inline-input-margin-x;\n    margin-left: 0;\n  }\n}\n\n\n// Form validation\n//\n// Provide feedback to users when form field values are valid or invalid. Works\n// primarily for client-side validation via scoped `:invalid` and `:valid`\n// pseudo-classes but also includes `.is-invalid` and `.is-valid` classes for\n// server side validation.\n\n@each $state, $data in $form-validation-states {\n  @include form-validation-state($state, map-get($data, color), map-get($data, icon));\n}\n\n// Inline forms\n//\n// Make forms appear inline(-block) by adding the `.form-inline` class. Inline\n// forms begin stacked on extra small (mobile) devices and then go inline when\n// viewports reach <768px.\n//\n// Requires wrapping inputs and labels with `.form-group` for proper display of\n// default HTML form controls and our custom form controls (e.g., input groups).\n\n.form-inline {\n  display: flex;\n  flex-flow: row wrap;\n  align-items: center; // Prevent shorter elements from growing to same height as others (e.g., small buttons growing to normal sized button height)\n\n  // Because we use flex, the initial sizing of checkboxes is collapsed and\n  // doesn't occupy the full-width (which is what we want for xs grid tier),\n  // so we force that here.\n  .form-check {\n    width: 100%;\n  }\n\n  // Kick in the inline\n  @include media-breakpoint-up(sm) {\n    label {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      margin-bottom: 0;\n    }\n\n    // Inline-block all the things for \"inline\"\n    .form-group {\n      display: flex;\n      flex: 0 0 auto;\n      flex-flow: row wrap;\n      align-items: center;\n      margin-bottom: 0;\n    }\n\n    // Allow folks to *not* use `.form-group`\n    .form-control {\n      display: inline-block;\n      width: auto; // Prevent labels from stacking above inputs in `.form-group`\n      vertical-align: middle;\n    }\n\n    // Make static controls behave like regular ones\n    .form-control-plaintext {\n      display: inline-block;\n    }\n\n    .input-group,\n    .custom-select {\n      width: auto;\n    }\n\n    // Remove default margin on radios/checkboxes that were used for stacking, and\n    // then undo the floating of radios and checkboxes to match.\n    .form-check {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      width: auto;\n      padding-left: 0;\n    }\n    .form-check-input {\n      position: relative;\n      flex-shrink: 0;\n      margin-top: 0;\n      margin-right: $form-check-input-margin-x;\n      margin-left: 0;\n    }\n\n    .custom-control {\n      align-items: center;\n      justify-content: center;\n    }\n    .custom-control-label {\n      margin-bottom: 0;\n    }\n  }\n}\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-prefers-reduced-motion-media-query and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","// Form control focus state\n//\n// Generate a customized focus state and for any input with the specified color,\n// which defaults to the `$input-focus-border-color` variable.\n//\n// We highly encourage you to not customize the default value, but instead use\n// this to tweak colors on an as-needed basis. This aesthetic change is based on\n// WebKit's default styles, but applicable to a wider range of browsers. Its\n// usability and accessibility should be taken into account with any change.\n//\n// Example usage: change the default blue border and shadow to white for better\n// contrast against a dark gray background.\n@mixin form-control-focus($ignore-warning: false) {\n  &:focus {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n  @include deprecate(\"The `form-control-focus()` mixin\", \"v4.4.0\", \"v5\", $ignore-warning);\n}\n\n// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state($state, $color, $icon) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    left: 0;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: color-yiq($color);\n    background-color: rgba($color, $form-feedback-tooltip-opacity);\n    @include border-radius($form-feedback-tooltip-border-radius);\n\n    // See https://github.com/twbs/bootstrap/pull/31557\n    // Align tooltip to form elements\n    .form-row > .col > &,\n    .form-row > [class*=\"col-\"] > & {\n      left: $form-grid-gutter-width * .5;\n    }\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $color;\n\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner !important; // stylelint-disable-line declaration-no-important\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        background-position: right $input-height-inner-quarter center;\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $color;\n        box-shadow: 0 0 0 $input-focus-width rgba($color, .25);\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  select.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-padding-x * 4 !important; // stylelint-disable-line declaration-no-important\n        background-position: right $input-padding-x * 2 center;\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-position: top $input-height-inner-quarter right $input-height-inner-quarter;\n      }\n    }\n  }\n\n  .custom-select {\n    @include form-validation-state-selector($state) {\n      border-color: $color;\n\n      @if $enable-validation-icons {\n        padding-right: $custom-select-feedback-icon-padding-right !important; // stylelint-disable-line declaration-no-important\n        background: $custom-select-background, $custom-select-bg escape-svg($icon) $custom-select-feedback-icon-position / $custom-select-feedback-icon-size no-repeat;\n      }\n\n      &:focus {\n        border-color: $color;\n        box-shadow: 0 0 0 $input-focus-width rgba($color, .25);\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      ~ .form-check-label {\n        color: $color;\n      }\n\n      ~ .#{$state}-feedback,\n      ~ .#{$state}-tooltip {\n        display: block;\n      }\n    }\n  }\n\n  .custom-control-input {\n    @include form-validation-state-selector($state) {\n      ~ .custom-control-label {\n        color: $color;\n\n        &::before {\n          border-color: $color;\n        }\n      }\n\n      &:checked {\n        ~ .custom-control-label::before {\n          border-color: lighten($color, 10%);\n          @include gradient-bg(lighten($color, 10%));\n        }\n      }\n\n      &:focus {\n        ~ .custom-control-label::before {\n          box-shadow: 0 0 0 $input-focus-width rgba($color, .25);\n        }\n\n        &:not(:checked) ~ .custom-control-label::before {\n          border-color: $color;\n        }\n      }\n    }\n  }\n\n  // custom file\n  .custom-file-input {\n    @include form-validation-state-selector($state) {\n      ~ .custom-file-label {\n        border-color: $color;\n      }\n\n      &:focus {\n        ~ .custom-file-label {\n          border-color: $color;\n          box-shadow: 0 0 0 $input-focus-width rgba($color, .25);\n        }\n      }\n    }\n  }\n}\n","// Gradients\n\n@mixin gradient-bg($color) {\n  @if $enable-gradients {\n    background: $color linear-gradient(180deg, mix($body-bg, $color, 15%), $color) repeat-x;\n  } @else {\n    background-color: $color;\n  }\n}\n\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n  background-repeat: repeat-x;\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n  background-repeat: repeat-x;\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n  background-repeat: repeat-x;\n}\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n  background-repeat: no-repeat;\n}\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n  background-repeat: no-repeat;\n}\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n  background-repeat: no-repeat;\n}\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n","// stylelint-disable selector-no-qualifying-type\n\n//\n// Base styles\n//\n\n.btn {\n  display: inline-block;\n  font-family: $btn-font-family;\n  font-weight: $btn-font-weight;\n  color: $body-color;\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  user-select: none;\n  background-color: transparent;\n  border: $btn-border-width solid transparent;\n  @include button-size($btn-padding-y, $btn-padding-x, $btn-font-size, $btn-line-height, $btn-border-radius);\n  @include transition($btn-transition);\n\n  @include hover() {\n    color: $body-color;\n    text-decoration: none;\n  }\n\n  &:focus,\n  &.focus {\n    outline: 0;\n    box-shadow: $btn-focus-box-shadow;\n  }\n\n  // Disabled comes first so active can properly restyle\n  &.disabled,\n  &:disabled {\n    opacity: $btn-disabled-opacity;\n    @include box-shadow(none);\n  }\n\n  &:not(:disabled):not(.disabled) {\n    cursor: if($enable-pointer-cursor-for-buttons, pointer, null);\n\n    &:active,\n    &.active {\n      @include box-shadow($btn-active-box-shadow);\n\n      &:focus {\n        @include box-shadow($btn-focus-box-shadow, $btn-active-box-shadow);\n      }\n    }\n  }\n}\n\n// Future-proof disabling of clicks on `<a>` elements\na.btn.disabled,\nfieldset:disabled a.btn {\n  pointer-events: none;\n}\n\n\n//\n// Alternate buttons\n//\n\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @include button-variant($value, $value);\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  font-weight: $font-weight-normal;\n  color: $link-color;\n  text-decoration: $link-decoration;\n\n  @include hover() {\n    color: $link-hover-color;\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus,\n  &.focus {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:disabled,\n  &.disabled {\n    color: $btn-link-disabled-color;\n    pointer-events: none;\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-line-height-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-line-height-sm, $btn-border-radius-sm);\n}\n\n\n//\n// Block button\n//\n\n.btn-block {\n  display: block;\n  width: 100%;\n\n  // Vertically space out multiple block buttons\n  + .btn-block {\n    margin-top: $btn-block-spacing-y;\n  }\n}\n\n// Specificity overrides\ninput[type=\"submit\"],\ninput[type=\"reset\"],\ninput[type=\"button\"] {\n  &.btn-block {\n    width: 100%;\n  }\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n@mixin button-variant($background, $border, $hover-background: darken($background, 7.5%), $hover-border: darken($border, 10%), $active-background: darken($background, 10%), $active-border: darken($border, 12.5%)) {\n  color: color-yiq($background);\n  @include gradient-bg($background);\n  border-color: $border;\n  @include box-shadow($btn-box-shadow);\n\n  @include hover() {\n    color: color-yiq($hover-background);\n    @include gradient-bg($hover-background);\n    border-color: $hover-border;\n  }\n\n  &:focus,\n  &.focus {\n    color: color-yiq($hover-background);\n    @include gradient-bg($hover-background);\n    border-color: $hover-border;\n    @if $enable-shadows {\n      @include box-shadow($btn-box-shadow, 0 0 0 $btn-focus-width rgba(mix(color-yiq($background), $border, 15%), .5));\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: 0 0 0 $btn-focus-width rgba(mix(color-yiq($background), $border, 15%), .5);\n    }\n  }\n\n  // Disabled comes first so active can properly restyle\n  &.disabled,\n  &:disabled {\n    color: color-yiq($background);\n    background-color: $background;\n    border-color: $border;\n    // Remove CSS gradients if they're enabled\n    @if $enable-gradients {\n      background-image: none;\n    }\n  }\n\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  .show > &.dropdown-toggle {\n    color: color-yiq($active-background);\n    background-color: $active-background;\n    @if $enable-gradients {\n      background-image: none; // Remove the gradient for the pressed/active state\n    }\n    border-color: $active-border;\n\n    &:focus {\n      @if $enable-shadows and $btn-active-box-shadow != none {\n        @include box-shadow($btn-active-box-shadow, 0 0 0 $btn-focus-width rgba(mix(color-yiq($background), $border, 15%), .5));\n      } @else {\n        // Avoid using mixin so we can pass custom focus shadow properly\n        box-shadow: 0 0 0 $btn-focus-width rgba(mix(color-yiq($background), $border, 15%), .5);\n      }\n    }\n  }\n}\n\n@mixin button-outline-variant($color, $color-hover: color-yiq($color), $active-background: $color, $active-border: $color) {\n  color: $color;\n  border-color: $color;\n\n  @include hover() {\n    color: $color-hover;\n    background-color: $active-background;\n    border-color: $active-border;\n  }\n\n  &:focus,\n  &.focus {\n    box-shadow: 0 0 0 $btn-focus-width rgba($color, .5);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: $color;\n    background-color: transparent;\n  }\n\n  &:not(:disabled):not(.disabled):active,\n  &:not(:disabled):not(.disabled).active,\n  .show > &.dropdown-toggle {\n    color: color-yiq($active-background);\n    background-color: $active-background;\n    border-color: $active-border;\n\n    &:focus {\n      @if $enable-shadows and $btn-active-box-shadow != none {\n        @include box-shadow($btn-active-box-shadow, 0 0 0 $btn-focus-width rgba($color, .5));\n      } @else {\n        // Avoid using mixin so we can pass custom focus shadow properly\n        box-shadow: 0 0 0 $btn-focus-width rgba($color, .5);\n      }\n    }\n  }\n}\n\n// Button sizes\n@mixin button-size($padding-y, $padding-x, $font-size, $line-height, $border-radius) {\n  padding: $padding-y $padding-x;\n  @include font-size($font-size);\n  line-height: $line-height;\n  // Manually declare to provide an override to the browser default\n  @include border-radius($border-radius, 0);\n}\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n$white:    #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black:    #000 !default;\n\n$grays: () !default;\n$grays: map-merge(\n  (\n    \"100\": $gray-100,\n    \"200\": $gray-200,\n    \"300\": $gray-300,\n    \"400\": $gray-400,\n    \"500\": $gray-500,\n    \"600\": $gray-600,\n    \"700\": $gray-700,\n    \"800\": $gray-800,\n    \"900\": $gray-900\n  ),\n  $grays\n);\n\n$blue:    #007bff !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #e83e8c !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #28a745 !default;\n$teal:    #20c997 !default;\n$cyan:    #17a2b8 !default;\n\n$colors: () !default;\n$colors: map-merge(\n  (\n    \"blue\":       $blue,\n    \"indigo\":     $indigo,\n    \"purple\":     $purple,\n    \"pink\":       $pink,\n    \"red\":        $red,\n    \"orange\":     $orange,\n    \"yellow\":     $yellow,\n    \"green\":      $green,\n    \"teal\":       $teal,\n    \"cyan\":       $cyan,\n    \"white\":      $white,\n    \"gray\":       $gray-600,\n    \"gray-dark\":  $gray-800\n  ),\n  $colors\n);\n\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-800 !default;\n\n$theme-colors: () !default;\n$theme-colors: map-merge(\n  (\n    \"primary\":    $primary,\n    \"secondary\":  $secondary,\n    \"success\":    $success,\n    \"info\":       $info,\n    \"warning\":    $warning,\n    \"danger\":     $danger,\n    \"light\":      $light,\n    \"dark\":       $dark\n  ),\n  $theme-colors\n);\n\n// Set a specific jump point for requesting color jumps\n$theme-color-interval:      8% !default;\n\n// The yiq lightness value that determines when the lightness of color changes from \"dark\" to \"light\". Acceptable values are between 0 and 255.\n$yiq-contrasted-threshold:  150 !default;\n\n// Customize the light and dark text colors for use in our YIQ color contrast function.\n$yiq-text-dark:             $gray-900 !default;\n$yiq-text-light:            $white !default;\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                                true !default;\n$enable-rounded:                              true !default;\n$enable-shadows:                              false !default;\n$enable-gradients:                            false !default;\n$enable-transitions:                          true !default;\n$enable-prefers-reduced-motion-media-query:   true !default;\n$enable-hover-media-query:                    false !default; // Deprecated, no longer affects any compiled CSS\n$enable-grid-classes:                         true !default;\n$enable-pointer-cursor-for-buttons:           true !default;\n$enable-print-styles:                         true !default;\n$enable-responsive-font-sizes:                false !default;\n$enable-validation-icons:                     true !default;\n$enable-deprecation-messages:                 true !default;\n\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n$spacer: 1rem !default;\n$spacers: () !default;\n$spacers: map-merge(\n  (\n    0: 0,\n    1: ($spacer * .25),\n    2: ($spacer * .5),\n    3: $spacer,\n    4: ($spacer * 1.5),\n    5: ($spacer * 3)\n  ),\n  $spacers\n);\n\n// This variable affects the `.h-*` and `.w-*` classes.\n$sizes: () !default;\n$sizes: map-merge(\n  (\n    25: 25%,\n    50: 50%,\n    75: 75%,\n    100: 100%,\n    auto: auto\n  ),\n  $sizes\n);\n\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-bg:                   $white !default;\n$body-color:                $gray-900 !default;\n\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              theme-color(\"primary\") !default;\n$link-decoration:                         none !default;\n$link-hover-color:                        darken($link-color, 15%) !default;\n$link-hover-decoration:                   underline !default;\n// Darken percentage for links with `.text-*` class (e.g. `.text-success`)\n$emphasized-link-hover-darken-percentage: 15% !default;\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px\n) !default;\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px\n) !default;\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           30px !default;\n$grid-row-columns:            6 !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n$line-height-lg:              1.5 !default;\n$line-height-sm:              1.5 !default;\n\n$border-width:                1px !default;\n$border-color:                $gray-300 !default;\n\n$border-radius:               .25rem !default;\n$border-radius-lg:            .3rem !default;\n$border-radius-sm:            .2rem !default;\n\n$rounded-pill:                50rem !default;\n\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n\n$component-active-color:      $white !default;\n$component-active-bg:         theme-color(\"primary\") !default;\n\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n$transition-collapse:         height .35s ease !default;\n$transition-collapse-width:   width .35s ease !default;\n\n$embed-responsive-aspect-ratios: () !default;\n$embed-responsive-aspect-ratios: join(\n  (\n    (21 9),\n    (16 9),\n    (4 3),\n    (1 1),\n  ),\n  $embed-responsive-aspect-ratios\n);\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", \"Liberation Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n$font-family-base:            $font-family-sans-serif !default;\n// stylelint-enable value-keyword-case\n\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-lg:                $font-size-base * 1.25 !default;\n$font-size-sm:                $font-size-base * .875 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n$line-height-base:            1.5 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              null !default;\n\n$display1-size:               6rem !default;\n$display2-size:               5.5rem !default;\n$display3-size:               4.5rem !default;\n$display4-size:               3.5rem !default;\n\n$display1-weight:             300 !default;\n$display2-weight:             300 !default;\n$display3-weight:             300 !default;\n$display4-weight:             300 !default;\n$display-line-height:         $headings-line-height !default;\n\n$lead-font-size:              $font-size-base * 1.25 !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             .875em !default;\n\n$text-muted:                  $gray-600 !default;\n\n$blockquote-small-color:      $gray-600 !default;\n$blockquote-small-font-size:  $small-font-size !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n\n$hr-border-color:             rgba($black, .1) !default;\n$hr-border-width:             $border-width !default;\n\n$mark-padding:                .2em !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$kbd-box-shadow:              inset 0 -.1rem 0 rgba($black, .25) !default;\n$nested-kbd-font-weight:      $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-bg:                     #fcf8e3 !default;\n\n$hr-margin-y:                 $spacer !default;\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n$table-cell-padding:          .75rem !default;\n$table-cell-padding-sm:       .3rem !default;\n\n$table-color:                 $body-color !default;\n$table-bg:                    null !default;\n$table-accent-bg:             rgba($black, .05) !default;\n$table-hover-color:           $table-color !default;\n$table-hover-bg:              rgba($black, .075) !default;\n$table-active-bg:             $table-hover-bg !default;\n\n$table-border-width:          $border-width !default;\n$table-border-color:          $border-color !default;\n\n$table-head-bg:               $gray-200 !default;\n$table-head-color:            $gray-700 !default;\n$table-th-font-weight:        null !default;\n\n$table-dark-color:            $white !default;\n$table-dark-bg:               $gray-800 !default;\n$table-dark-accent-bg:        rgba($white, .05) !default;\n$table-dark-hover-color:      $table-dark-color !default;\n$table-dark-hover-bg:         rgba($white, .075) !default;\n$table-dark-border-color:     lighten($table-dark-bg, 7.5%) !default;\n\n$table-striped-order:         odd !default;\n\n$table-caption-color:         $text-muted !default;\n\n$table-bg-level:              -9 !default;\n$table-border-level:          -6 !default;\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:       .2rem !default;\n$input-btn-focus-color:       rgba($component-active-bg, .25) !default;\n$input-btn-focus-box-shadow:  0 0 0 $input-btn-focus-width $input-btn-focus-color !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n$input-btn-line-height-sm:    $line-height-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n$input-btn-line-height-lg:    $line-height-lg !default;\n\n$input-btn-border-width:      $border-width !default;\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n$btn-line-height-sm:          $input-btn-line-height-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n$btn-line-height-lg:          $input-btn-line-height-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-disabled-color:     $gray-600 !default;\n\n$btn-block-spacing-y:         .5rem !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           $border-radius !default;\n$btn-border-radius-lg:        $border-radius-lg !default;\n$btn-border-radius-sm:        $border-radius-sm !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n\n// Forms\n\n$label-margin-bottom:                   .5rem !default;\n\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n$input-line-height-sm:                  $input-btn-line-height-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n$input-line-height-lg:                  $input-btn-line-height-lg !default;\n\n$input-bg:                              $white !default;\n$input-disabled-bg:                     $gray-200 !default;\n\n$input-color:                           $gray-700 !default;\n$input-border-color:                    $gray-400 !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      inset 0 1px 1px rgba($black, .075) !default;\n\n$input-border-radius:                   $border-radius !default;\n$input-border-radius-lg:                $border-radius-lg !default;\n$input-border-radius-sm:                $border-radius-sm !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              lighten($component-active-bg, 25%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               $gray-600 !default;\n$input-plaintext-color:                 $body-color !default;\n\n$input-height-border:                   $input-border-width * 2 !default;\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height-sm * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height-lg * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-text-margin-top:                  .25rem !default;\n\n$form-check-input-gutter:               1.25rem !default;\n$form-check-input-margin-y:             .3rem !default;\n$form-check-input-margin-x:             .25rem !default;\n\n$form-check-inline-margin-x:            .75rem !default;\n$form-check-inline-input-margin-x:      .3125rem !default;\n\n$form-grid-gutter-width:                10px !default;\n$form-group-margin-bottom:              1rem !default;\n\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  $gray-200 !default;\n$input-group-addon-border-color:        $input-border-color !default;\n\n$custom-forms-transition:               background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$custom-control-gutter:                 .5rem !default;\n$custom-control-spacer-x:               1rem !default;\n$custom-control-cursor:                 null !default;\n\n$custom-control-indicator-size:         1rem !default;\n$custom-control-indicator-bg:           $input-bg !default;\n\n$custom-control-indicator-bg-size:      50% 50% !default;\n$custom-control-indicator-box-shadow:   $input-box-shadow !default;\n$custom-control-indicator-border-color: $gray-500 !default;\n$custom-control-indicator-border-width: $input-border-width !default;\n\n$custom-control-label-color:            null !default;\n\n$custom-control-indicator-disabled-bg:          $input-disabled-bg !default;\n$custom-control-label-disabled-color:           $gray-600 !default;\n\n$custom-control-indicator-checked-color:        $component-active-color !default;\n$custom-control-indicator-checked-bg:           $component-active-bg !default;\n$custom-control-indicator-checked-disabled-bg:  rgba(theme-color(\"primary\"), .5) !default;\n$custom-control-indicator-checked-box-shadow:   null !default;\n$custom-control-indicator-checked-border-color: $custom-control-indicator-checked-bg !default;\n\n$custom-control-indicator-focus-box-shadow:     $input-focus-box-shadow !default;\n$custom-control-indicator-focus-border-color:   $input-focus-border-color !default;\n\n$custom-control-indicator-active-color:         $component-active-color !default;\n$custom-control-indicator-active-bg:            lighten($component-active-bg, 35%) !default;\n$custom-control-indicator-active-box-shadow:    null !default;\n$custom-control-indicator-active-border-color:  $custom-control-indicator-active-bg !default;\n\n$custom-checkbox-indicator-border-radius:       $border-radius !default;\n$custom-checkbox-indicator-icon-checked:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'><path fill='#{$custom-control-indicator-checked-color}' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/></svg>\") !default;\n\n$custom-checkbox-indicator-indeterminate-bg:           $component-active-bg !default;\n$custom-checkbox-indicator-indeterminate-color:        $custom-control-indicator-checked-color !default;\n$custom-checkbox-indicator-icon-indeterminate:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='4' height='4' viewBox='0 0 4 4'><path stroke='#{$custom-checkbox-indicator-indeterminate-color}' d='M0 2h4'/></svg>\") !default;\n$custom-checkbox-indicator-indeterminate-box-shadow:   null !default;\n$custom-checkbox-indicator-indeterminate-border-color: $custom-checkbox-indicator-indeterminate-bg !default;\n\n$custom-radio-indicator-border-radius:          50% !default;\n$custom-radio-indicator-icon-checked:           url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='-4 -4 8 8'><circle r='3' fill='#{$custom-control-indicator-checked-color}'/></svg>\") !default;\n\n$custom-switch-width:                           $custom-control-indicator-size * 1.75 !default;\n$custom-switch-indicator-border-radius:         $custom-control-indicator-size * .5 !default;\n$custom-switch-indicator-size:                  subtract($custom-control-indicator-size, $custom-control-indicator-border-width * 4) !default;\n\n$custom-select-padding-y:           $input-padding-y !default;\n$custom-select-padding-x:           $input-padding-x !default;\n$custom-select-font-family:         $input-font-family !default;\n$custom-select-font-size:           $input-font-size !default;\n$custom-select-height:              $input-height !default;\n$custom-select-indicator-padding:   1rem !default; // Extra padding to account for the presence of the background-image based indicator\n$custom-select-font-weight:         $input-font-weight !default;\n$custom-select-line-height:         $input-line-height !default;\n$custom-select-color:               $input-color !default;\n$custom-select-disabled-color:      $gray-600 !default;\n$custom-select-bg:                  $input-bg !default;\n$custom-select-disabled-bg:         $gray-200 !default;\n$custom-select-bg-size:             8px 10px !default; // In pixels because image dimensions\n$custom-select-indicator-color:     $gray-800 !default;\n$custom-select-indicator:           url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'><path fill='#{$custom-select-indicator-color}' d='M2 0L0 2h4zm0 5L0 3h4z'/></svg>\") !default;\n$custom-select-background:          escape-svg($custom-select-indicator) right $custom-select-padding-x center / $custom-select-bg-size no-repeat !default; // Used so we can have multiple background elements (e.g., arrow and feedback icon)\n\n$custom-select-feedback-icon-padding-right: add(1em * .75, (2 * $custom-select-padding-y * .75) + $custom-select-padding-x + $custom-select-indicator-padding) !default;\n$custom-select-feedback-icon-position:      center right ($custom-select-padding-x + $custom-select-indicator-padding) !default;\n$custom-select-feedback-icon-size:          $input-height-inner-half $input-height-inner-half !default;\n\n$custom-select-border-width:        $input-border-width !default;\n$custom-select-border-color:        $input-border-color !default;\n$custom-select-border-radius:       $border-radius !default;\n$custom-select-box-shadow:          inset 0 1px 2px rgba($black, .075) !default;\n\n$custom-select-focus-border-color:  $input-focus-border-color !default;\n$custom-select-focus-width:         $input-focus-width !default;\n$custom-select-focus-box-shadow:    0 0 0 $custom-select-focus-width $input-btn-focus-color !default;\n\n$custom-select-padding-y-sm:        $input-padding-y-sm !default;\n$custom-select-padding-x-sm:        $input-padding-x-sm !default;\n$custom-select-font-size-sm:        $input-font-size-sm !default;\n$custom-select-height-sm:           $input-height-sm !default;\n\n$custom-select-padding-y-lg:        $input-padding-y-lg !default;\n$custom-select-padding-x-lg:        $input-padding-x-lg !default;\n$custom-select-font-size-lg:        $input-font-size-lg !default;\n$custom-select-height-lg:           $input-height-lg !default;\n\n$custom-range-track-width:          100% !default;\n$custom-range-track-height:         .5rem !default;\n$custom-range-track-cursor:         pointer !default;\n$custom-range-track-bg:             $gray-300 !default;\n$custom-range-track-border-radius:  1rem !default;\n$custom-range-track-box-shadow:     inset 0 .25rem .25rem rgba($black, .1) !default;\n\n$custom-range-thumb-width:                   1rem !default;\n$custom-range-thumb-height:                  $custom-range-thumb-width !default;\n$custom-range-thumb-bg:                      $component-active-bg !default;\n$custom-range-thumb-border:                  0 !default;\n$custom-range-thumb-border-radius:           1rem !default;\n$custom-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$custom-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$custom-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in IE/Edge\n$custom-range-thumb-active-bg:               lighten($component-active-bg, 35%) !default;\n$custom-range-thumb-disabled-bg:             $gray-500 !default;\n\n$custom-file-height:                $input-height !default;\n$custom-file-height-inner:          $input-height-inner !default;\n$custom-file-focus-border-color:    $input-focus-border-color !default;\n$custom-file-focus-box-shadow:      $input-focus-box-shadow !default;\n$custom-file-disabled-bg:           $input-disabled-bg !default;\n\n$custom-file-padding-y:             $input-padding-y !default;\n$custom-file-padding-x:             $input-padding-x !default;\n$custom-file-line-height:           $input-line-height !default;\n$custom-file-font-family:           $input-font-family !default;\n$custom-file-font-weight:           $input-font-weight !default;\n$custom-file-color:                 $input-color !default;\n$custom-file-bg:                    $input-bg !default;\n$custom-file-border-width:          $input-border-width !default;\n$custom-file-border-color:          $input-border-color !default;\n$custom-file-border-radius:         $input-border-radius !default;\n$custom-file-box-shadow:            $input-box-shadow !default;\n$custom-file-button-color:          $custom-file-color !default;\n$custom-file-button-bg:             $input-group-addon-bg !default;\n$custom-file-text: (\n  en: \"Browse\"\n) !default;\n\n\n// Form validation\n\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $small-font-size !default;\n$form-feedback-valid-color:         theme-color(\"success\") !default;\n$form-feedback-invalid-color:       theme-color(\"danger\") !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}' viewBox='0 0 12 12'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n\n$form-validation-states: () !default;\n$form-validation-states: map-merge(\n  (\n    \"valid\": (\n      \"color\": $form-feedback-valid-color,\n      \"icon\": $form-feedback-icon-valid\n    ),\n    \"invalid\": (\n      \"color\": $form-feedback-invalid-color,\n      \"icon\": $form-feedback-icon-invalid\n    ),\n  ),\n  $form-validation-states\n);\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-modal-backdrop:             1040 !default;\n$zindex-modal:                      1050 !default;\n$zindex-popover:                    1060 !default;\n$zindex-tooltip:                    1070 !default;\n\n\n// Navs\n\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-disabled-color:           $gray-600 !default;\n\n$nav-tabs-border-color:             $gray-300 !default;\n$nav-tabs-border-width:             $border-width !default;\n$nav-tabs-border-radius:            $border-radius !default;\n$nav-tabs-link-hover-border-color:  $gray-200 $gray-200 $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        $gray-700 !default;\n$nav-tabs-link-active-bg:           $body-bg !default;\n$nav-tabs-link-active-border-color: $gray-300 $gray-300 $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           $border-radius !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n\n$nav-divider-color:                 $gray-200 !default;\n$nav-divider-margin-y:              $spacer * .5 !default;\n\n\n// Navbar\n\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  $spacer !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n\n$navbar-nav-scroll-max-height:      75vh !default;\n\n$navbar-dark-color:                 rgba($white, .5) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n\n$navbar-light-color:                rgba($black, .5) !default;\n$navbar-light-hover-color:          rgba($black, .7) !default;\n$navbar-light-active-color:         rgba($black, .9) !default;\n$navbar-light-disabled-color:       rgba($black, .3) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'><path stroke='#{$navbar-light-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba($black, .1) !default;\n\n$navbar-light-brand-color:                $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:          $navbar-light-active-color !default;\n$navbar-dark-brand-color:                 $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:           $navbar-dark-active-color !default;\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    $body-color !default;\n$dropdown-bg:                       $white !default;\n$dropdown-border-color:             rgba($black, .15) !default;\n$dropdown-border-radius:            $border-radius !default;\n$dropdown-border-width:             $border-width !default;\n$dropdown-inner-border-radius:      subtract($dropdown-border-radius, $dropdown-border-width) !default;\n$dropdown-divider-bg:               $gray-200 !default;\n$dropdown-divider-margin-y:         $nav-divider-margin-y !default;\n$dropdown-box-shadow:               0 .5rem 1rem rgba($black, .175) !default;\n\n$dropdown-link-color:               $gray-900 !default;\n$dropdown-link-hover-color:         darken($gray-900, 5%) !default;\n$dropdown-link-hover-bg:            $gray-200 !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      $gray-500 !default;\n\n$dropdown-item-padding-y:           .25rem !default;\n$dropdown-item-padding-x:           1.5rem !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding:           $dropdown-padding-y $dropdown-item-padding-x !default;\n\n\n// Pagination\n\n$pagination-padding-y:              .5rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n$pagination-line-height:            1.25 !default;\n\n$pagination-color:                  $link-color !default;\n$pagination-bg:                     $white !default;\n$pagination-border-width:           $border-width !default;\n$pagination-border-color:           $gray-300 !default;\n\n$pagination-focus-box-shadow:       $input-btn-focus-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            $link-hover-color !default;\n$pagination-hover-bg:               $gray-200 !default;\n$pagination-hover-border-color:     $gray-300 !default;\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $pagination-active-bg !default;\n\n$pagination-disabled-color:         $gray-600 !default;\n$pagination-disabled-bg:            $white !default;\n$pagination-disabled-border-color:  $gray-300 !default;\n\n$pagination-border-radius-sm:       $border-radius-sm !default;\n$pagination-border-radius-lg:       $border-radius-lg !default;\n\n\n// Jumbotron\n\n$jumbotron-padding:                 2rem !default;\n$jumbotron-color:                   null !default;\n$jumbotron-bg:                      $gray-200 !default;\n\n\n// Cards\n\n$card-spacer-y:                     .75rem !default;\n$card-spacer-x:                     1.25rem !default;\n$card-border-width:                 $border-width !default;\n$card-border-radius:                $border-radius !default;\n$card-border-color:                 rgba($black, .125) !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-bg:                       rgba($black, .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           $white !default;\n\n$card-img-overlay-padding:          1.25rem !default;\n\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n$card-deck-margin:                  $card-group-margin !default;\n\n$card-columns-count:                3 !default;\n$card-columns-gap:                  1.25rem !default;\n$card-columns-margin:               $card-spacer-y !default;\n\n\n// Tooltips\n\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     $white !default;\n$tooltip-bg:                        $black !default;\n$tooltip-border-radius:             $border-radius !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 .25rem !default;\n$tooltip-padding-x:                 .5rem !default;\n$tooltip-margin:                    0 !default;\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n$tooltip-arrow-color:               $tooltip-bg !default;\n\n// Form tooltips must come after regular tooltips\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   $line-height-base !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n\n\n// Popovers\n\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        $white !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              $border-width !default;\n$popover-border-color:              rgba($black, .2) !default;\n$popover-border-radius:             $border-radius-lg !default;\n$popover-inner-border-radius:       subtract($popover-border-radius, $popover-border-width) !default;\n$popover-box-shadow:                0 .25rem .5rem rgba($black, .2) !default;\n\n$popover-header-bg:                 darken($popover-bg, 3%) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          .75rem !default;\n\n$popover-body-color:                $body-color !default;\n$popover-body-padding-y:            $popover-header-padding-y !default;\n$popover-body-padding-x:            $popover-header-padding-x !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n$popover-arrow-color:               $popover-bg !default;\n\n$popover-arrow-outer-color:         fade-in($popover-border-color, .05) !default;\n\n\n// Toasts\n\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .25rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba($white, .85) !default;\n$toast-border-width:                1px !default;\n$toast-border-color:                rgba(0, 0, 0, .1) !default;\n$toast-border-radius:               .25rem !default;\n$toast-box-shadow:                  0 .25rem .75rem rgba($black, .1) !default;\n\n$toast-header-color:                $gray-600 !default;\n$toast-header-background-color:     rgba($white, .85) !default;\n$toast-header-border-color:         rgba(0, 0, 0, .05) !default;\n\n\n// Badges\n\n$badge-font-size:                   75% !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-padding-y:                   .25em !default;\n$badge-padding-x:                   .4em !default;\n$badge-border-radius:               $border-radius !default;\n\n$badge-transition:                  $btn-transition !default;\n$badge-focus-width:                 $input-btn-focus-width !default;\n\n$badge-pill-padding-x:              .6em !default;\n// Use a higher than normal value to ensure completely rounded edges when\n// customizing padding or font-size on labels.\n$badge-pill-border-radius:          10rem !default;\n\n\n// Modals\n\n// Padding applied to the modal body\n$modal-inner-padding:               1rem !default;\n\n// Margin between elements in footer, must be lower than or equal to 2 * $modal-inner-padding\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               null !default;\n$modal-content-bg:                  $white !default;\n$modal-content-border-color:        rgba($black, .2) !default;\n$modal-content-border-width:        $border-width !default;\n$modal-content-border-radius:       $border-radius-lg !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       0 .25rem .5rem rgba($black, .5) !default;\n$modal-content-box-shadow-sm-up:    0 .5rem 1rem rgba($black, .5) !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n$modal-header-border-color:         $border-color !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n$modal-header-padding-y:            1rem !default;\n$modal-header-padding-x:            1rem !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-xl:                          1140px !default;\n$modal-lg:                          800px !default;\n$modal-md:                          500px !default;\n$modal-sm:                          300px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n$alert-padding-y:                   .75rem !default;\n$alert-padding-x:                   1.25rem !default;\n$alert-margin-bottom:               1rem !default;\n$alert-border-radius:               $border-radius !default;\n$alert-link-font-weight:            $font-weight-bold !default;\n$alert-border-width:                $border-width !default;\n\n$alert-bg-level:                    -10 !default;\n$alert-border-level:                -9 !default;\n$alert-color-level:                 6 !default;\n\n\n// Progress bars\n\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       $gray-200 !default;\n$progress-border-radius:            $border-radius !default;\n$progress-box-shadow:               inset 0 .1rem .1rem rgba($black, .1) !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   theme-color(\"primary\") !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n\n\n// List group\n\n$list-group-color:                  null !default;\n$list-group-bg:                     $white !default;\n$list-group-border-color:           rgba($black, .125) !default;\n$list-group-border-width:           $border-width !default;\n$list-group-border-radius:          $border-radius !default;\n\n$list-group-item-padding-y:         .75rem !default;\n$list-group-item-padding-x:         1.25rem !default;\n\n$list-group-hover-bg:               $gray-100 !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         $gray-600 !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           $gray-700 !default;\n$list-group-action-hover-color:     $list-group-action-color !default;\n\n$list-group-action-active-color:    $body-color !default;\n$list-group-action-active-bg:       $gray-200 !default;\n\n\n// Image thumbnails\n\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      $body-bg !default;\n$thumbnail-border-width:            $border-width !default;\n$thumbnail-border-color:            $gray-300 !default;\n$thumbnail-border-radius:           $border-radius !default;\n$thumbnail-box-shadow:              0 1px 2px rgba($black, .075) !default;\n\n\n// Figures\n\n$figure-caption-font-size:          90% !default;\n$figure-caption-color:              $gray-600 !default;\n\n\n// Breadcrumbs\n\n$breadcrumb-font-size:              null !default;\n\n$breadcrumb-padding-y:              .75rem !default;\n$breadcrumb-padding-x:              1rem !default;\n$breadcrumb-item-padding:           .5rem !default;\n\n$breadcrumb-margin-bottom:          1rem !default;\n\n$breadcrumb-bg:                     $gray-200 !default;\n$breadcrumb-divider-color:          $gray-600 !default;\n$breadcrumb-active-color:           $gray-600 !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n\n$breadcrumb-border-radius:          $border-radius !default;\n\n\n// Carousel\n\n$carousel-control-color:             $white !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $white !default;\n\n$carousel-control-icon-width:        20px !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' fill='#{$carousel-control-color}' width='8' height='8' viewBox='0 0 8 8'><path d='M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' fill='#{$carousel-control-color}' width='8' height='8' viewBox='0 0 8 8'><path d='M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n\n\n// Spinners\n\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n\n\n// Close\n\n$close-font-size:                   $font-size-base * 1.5 !default;\n$close-font-weight:                 $font-weight-bold !default;\n$close-color:                       $black !default;\n$close-text-shadow:                 0 1px 0 $white !default;\n\n\n// Code\n\n$code-font-size:                    87.5% !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .2rem !default;\n$kbd-padding-x:                     .4rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         $white !default;\n$kbd-bg:                            $gray-900 !default;\n\n$pre-color:                         $gray-900 !default;\n$pre-scrollable-max-height:         340px !default;\n\n\n// Utilities\n\n$displays: none, inline, inline-block, block, table, table-row, table-cell, flex, inline-flex !default;\n$overflows: auto, hidden !default;\n$positions: static, relative, absolute, fixed, sticky !default;\n$user-selects: all, auto, none !default;\n\n\n// Printing\n\n$print-page-size:                   a3 !default;\n$print-body-min-width:              map-get($grid-breakpoints, \"lg\") !default;\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  position: relative;\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.width {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropright,\n.dropdown,\n.dropleft {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: $zindex-dropdown;\n  display: none; // none by default, but block on \"open\" of the menu\n  float: left;\n  min-width: $dropdown-min-width;\n  padding: $dropdown-padding-y $dropdown-padding-x;\n  margin: $dropdown-spacer 0 0; // override default ul\n  @include font-size($dropdown-font-size);\n  color: $dropdown-color;\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: $dropdown-bg;\n  background-clip: padding-box;\n  border: $dropdown-border-width solid $dropdown-border-color;\n  @include border-radius($dropdown-border-radius);\n  @include box-shadow($dropdown-box-shadow);\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-left {\n      right: auto;\n      left: 0;\n    }\n\n    .dropdown-menu#{$infix}-right {\n      right: 0;\n      left: auto;\n    }\n  }\n}\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: $dropdown-spacer;\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropright {\n  .dropdown-menu {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: $dropdown-spacer;\n  }\n\n  .dropdown-toggle {\n    @include caret(right);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropleft {\n  .dropdown-menu {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: $dropdown-spacer;\n  }\n\n  .dropdown-toggle {\n    @include caret(left);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n// When Popper is enabled, reset the basic dropdown position\n// stylelint-disable-next-line no-duplicate-selectors\n.dropdown-menu {\n  &[x-placement^=\"top\"],\n  &[x-placement^=\"right\"],\n  &[x-placement^=\"bottom\"],\n  &[x-placement^=\"left\"] {\n    right: auto;\n    bottom: auto;\n  }\n}\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  @include nav-divider($dropdown-divider-bg, $dropdown-divider-margin-y, true);\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: $dropdown-item-padding-y $dropdown-item-padding-x;\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: $dropdown-link-color;\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n\n  // Prevent dropdown overflow if there's no padding\n  // See https://github.com/twbs/bootstrap/pull/27703\n  @if $dropdown-padding-y == 0 {\n    &:first-child {\n      @include border-top-radius($dropdown-inner-border-radius);\n    }\n\n    &:last-child {\n      @include border-bottom-radius($dropdown-inner-border-radius);\n    }\n  }\n\n  @include hover-focus() {\n    color: $dropdown-link-hover-color;\n    text-decoration: none;\n    @include gradient-bg($dropdown-link-hover-bg);\n  }\n\n  &.active,\n  &:active {\n    color: $dropdown-link-active-color;\n    text-decoration: none;\n    @include gradient-bg($dropdown-link-active-bg);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: $dropdown-link-disabled-color;\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    @if $enable-gradients {\n      background-image: none;\n    }\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: $dropdown-header-padding;\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: $dropdown-header-color;\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: $dropdown-item-padding-y $dropdown-item-padding-x;\n  color: $dropdown-link-color;\n}\n","// Horizontal dividers\n//\n// Dividers (basically an hr) within dropdowns and nav lists\n\n@mixin nav-divider($color: $nav-divider-color, $margin-y: $nav-divider-margin-y, $ignore-warning: false) {\n  height: 0;\n  margin: $margin-y 0;\n  overflow: hidden;\n  border-top: 1px solid $color;\n  @include deprecate(\"The `nav-divider()` mixin\", \"v4.4.0\", \"v5\", $ignore-warning);\n}\n","// stylelint-disable selector-no-qualifying-type\n\n// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n\n    // Bring the hover, focused, and \"active\" buttons to the front to overlay\n    // the borders properly\n    @include hover() {\n      z-index: 1;\n    }\n    &:focus,\n    &:active,\n    &.active {\n      z-index: 1;\n    }\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  // Prevent double borders when buttons are next to each other\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-left: -$btn-border-width;\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-right-radius(0);\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) > .btn {\n    @include border-left-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropright &::after {\n    margin-left: 0;\n  }\n\n  .dropleft &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: -$btn-border-width;\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n\n\n// Checkbox and radio options\n//\n// In order to support the browser's form validation feedback, powered by the\n// `required` attribute, we have to \"hide\" the inputs via `clip`. We cannot use\n// `display: none;` or `visibility: hidden;` as that also hides the popover.\n// Simply visually hiding the inputs via `opacity` would leave them clickable in\n// certain cases which is prevented by using `clip` and `pointer-events`.\n// This way, we ensure a DOM element is visible to position the popover from.\n//\n// See https://github.com/twbs/bootstrap/pull/12794 and\n// https://github.com/twbs/bootstrap/pull/14559 for more information.\n\n.btn-group-toggle {\n  > .btn,\n  > .btn-group > .btn {\n    margin-bottom: 0; // Override default `<label>` value\n\n    input[type=\"radio\"],\n    input[type=\"checkbox\"] {\n      position: absolute;\n      clip: rect(0, 0, 0, 0);\n      pointer-events: none;\n    }\n  }\n}\n","// stylelint-disable selector-no-qualifying-type\n\n//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .custom-select,\n  > .custom-file {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n    margin-bottom: 0;\n\n    + .form-control,\n    + .custom-select,\n    + .custom-file {\n      margin-left: -$input-border-width;\n    }\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .custom-select:focus,\n  > .custom-file .custom-file-input:focus ~ .custom-file-label {\n    z-index: 3;\n  }\n\n  // Bring the custom file input above the label\n  > .custom-file .custom-file-input:focus {\n    z-index: 4;\n  }\n\n  > .form-control,\n  > .custom-select {\n    &:not(:first-child) { @include border-left-radius(0); }\n  }\n\n  // Custom file inputs have more complex markup, thus requiring different\n  // border-radius overrides.\n  > .custom-file {\n    display: flex;\n    align-items: center;\n\n    &:not(:last-child) .custom-file-label,\n    &:not(:last-child) .custom-file-label::after { @include border-right-radius(0); }\n    &:not(:first-child) .custom-file-label { @include border-left-radius(0); }\n  }\n\n  &:not(.has-validation) {\n    > .form-control:not(:last-child),\n    > .custom-select:not(:last-child),\n    > .custom-file:not(:last-child) .custom-file-label,\n    > .custom-file:not(:last-child) .custom-file-label::after {\n      @include border-right-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > .form-control:nth-last-child(n + 3),\n    > .custom-select:nth-last-child(n + 3),\n    > .custom-file:nth-last-child(n + 3) .custom-file-label,\n    > .custom-file:nth-last-child(n + 3) .custom-file-label::after {\n      @include border-right-radius(0);\n    }\n  }\n}\n\n\n// Prepend and append\n//\n// While it requires one extra layer of HTML for each, dedicated prepend and\n// append elements allow us to 1) be less clever, 2) simplify our selectors, and\n// 3) support HTML5 form validation.\n\n.input-group-prepend,\n.input-group-append {\n  display: flex;\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 3;\n    }\n  }\n\n  .btn + .btn,\n  .btn + .input-group-text,\n  .input-group-text + .input-group-text,\n  .input-group-text + .btn {\n    margin-left: -$input-border-width;\n  }\n}\n\n.input-group-prepend { margin-right: -$input-border-width; }\n.input-group-append { margin-left: -$input-border-width; }\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-padding-y $input-padding-x;\n  margin-bottom: 0; // Allow use of <label> elements by overriding our default margin-bottom\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $font-weight-normal;\n  line-height: $input-line-height;\n  color: $input-group-addon-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $input-group-addon-bg;\n  border: $input-border-width solid $input-group-addon-border-color;\n  @include border-radius($input-border-radius);\n\n  // Nuke default margins from checkboxes and radios to vertically center within.\n  input[type=\"radio\"],\n  input[type=\"checkbox\"] {\n    margin-top: 0;\n  }\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control:not(textarea),\n.input-group-lg > .custom-select {\n  height: $input-height-lg;\n}\n\n.input-group-lg > .form-control,\n.input-group-lg > .custom-select,\n.input-group-lg > .input-group-prepend > .input-group-text,\n.input-group-lg > .input-group-append > .input-group-text,\n.input-group-lg > .input-group-prepend > .btn,\n.input-group-lg > .input-group-append > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  line-height: $input-line-height-lg;\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control:not(textarea),\n.input-group-sm > .custom-select {\n  height: $input-height-sm;\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .custom-select,\n.input-group-sm > .input-group-prepend > .input-group-text,\n.input-group-sm > .input-group-append > .input-group-text,\n.input-group-sm > .input-group-prepend > .btn,\n.input-group-sm > .input-group-append > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  line-height: $input-line-height-sm;\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .custom-select,\n.input-group-sm > .custom-select {\n  padding-right: $custom-select-padding-x + $custom-select-indicator-padding;\n}\n\n\n// Prepend and append rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n\n.input-group > .input-group-prepend > .btn,\n.input-group > .input-group-prepend > .input-group-text,\n.input-group:not(.has-validation) > .input-group-append:not(:last-child) > .btn,\n.input-group:not(.has-validation) > .input-group-append:not(:last-child) > .input-group-text,\n.input-group.has-validation > .input-group-append:nth-last-child(n + 3) > .btn,\n.input-group.has-validation > .input-group-append:nth-last-child(n + 3) > .input-group-text,\n.input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),\n.input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {\n  @include border-right-radius(0);\n}\n\n.input-group > .input-group-append > .btn,\n.input-group > .input-group-append > .input-group-text,\n.input-group > .input-group-prepend:not(:first-child) > .btn,\n.input-group > .input-group-prepend:not(:first-child) > .input-group-text,\n.input-group > .input-group-prepend:first-child > .btn:not(:first-child),\n.input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {\n  @include border-left-radius(0);\n}\n","// Embedded icons from Open Iconic.\n// Released under MIT and copyright 2014 Waybury.\n// https://useiconic.com/open\n\n\n// Checkboxes and radios\n//\n// Base class takes care of all the key behavioral aspects.\n\n.custom-control {\n  position: relative;\n  z-index: 1;\n  display: block;\n  min-height: $font-size-base * $line-height-base;\n  padding-left: $custom-control-gutter + $custom-control-indicator-size;\n  print-color-adjust: exact; // Keep themed appearance for print\n}\n\n.custom-control-inline {\n  display: inline-flex;\n  margin-right: $custom-control-spacer-x;\n}\n\n.custom-control-input {\n  position: absolute;\n  left: 0;\n  z-index: -1; // Put the input behind the label so it doesn't overlay text\n  width: $custom-control-indicator-size;\n  height: ($font-size-base * $line-height-base + $custom-control-indicator-size) * .5;\n  opacity: 0;\n\n  &:checked ~ .custom-control-label::before {\n    color: $custom-control-indicator-checked-color;\n    border-color: $custom-control-indicator-checked-border-color;\n    @include gradient-bg($custom-control-indicator-checked-bg);\n    @include box-shadow($custom-control-indicator-checked-box-shadow);\n  }\n\n  &:focus ~ .custom-control-label::before {\n    // the mixin is not used here to make sure there is feedback\n    @if $enable-shadows {\n      box-shadow: $input-box-shadow, $custom-control-indicator-focus-box-shadow;\n    } @else {\n      box-shadow: $custom-control-indicator-focus-box-shadow;\n    }\n  }\n\n  &:focus:not(:checked) ~ .custom-control-label::before {\n    border-color: $custom-control-indicator-focus-border-color;\n  }\n\n  &:not(:disabled):active ~ .custom-control-label::before {\n    color: $custom-control-indicator-active-color;\n    background-color: $custom-control-indicator-active-bg;\n    border-color: $custom-control-indicator-active-border-color;\n    @include box-shadow($custom-control-indicator-active-box-shadow);\n  }\n\n  // Use [disabled] and :disabled to work around https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .custom-control-label {\n      color: $custom-control-label-disabled-color;\n\n      &::before {\n        background-color: $custom-control-indicator-disabled-bg;\n      }\n    }\n  }\n}\n\n// Custom control indicators\n//\n// Build the custom controls out of pseudo-elements.\n\n.custom-control-label {\n  position: relative;\n  margin-bottom: 0;\n  color: $custom-control-label-color;\n  vertical-align: top;\n  cursor: $custom-control-cursor;\n\n  // Background-color and (when enabled) gradient\n  &::before {\n    position: absolute;\n    top: ($font-size-base * $line-height-base - $custom-control-indicator-size) * .5;\n    left: -($custom-control-gutter + $custom-control-indicator-size);\n    display: block;\n    width: $custom-control-indicator-size;\n    height: $custom-control-indicator-size;\n    pointer-events: none;\n    content: \"\";\n    background-color: $custom-control-indicator-bg;\n    border: $custom-control-indicator-border-width solid $custom-control-indicator-border-color;\n    @include box-shadow($custom-control-indicator-box-shadow);\n  }\n\n  // Foreground (icon)\n  &::after {\n    position: absolute;\n    top: ($font-size-base * $line-height-base - $custom-control-indicator-size) * .5;\n    left: -($custom-control-gutter + $custom-control-indicator-size);\n    display: block;\n    width: $custom-control-indicator-size;\n    height: $custom-control-indicator-size;\n    content: \"\";\n    background: 50% / #{$custom-control-indicator-bg-size} no-repeat;\n  }\n}\n\n\n// Checkboxes\n//\n// Tweak just a few things for checkboxes.\n\n.custom-checkbox {\n  .custom-control-label::before {\n    @include border-radius($custom-checkbox-indicator-border-radius);\n  }\n\n  .custom-control-input:checked ~ .custom-control-label {\n    &::after {\n      background-image: escape-svg($custom-checkbox-indicator-icon-checked);\n    }\n  }\n\n  .custom-control-input:indeterminate ~ .custom-control-label {\n    &::before {\n      border-color: $custom-checkbox-indicator-indeterminate-border-color;\n      @include gradient-bg($custom-checkbox-indicator-indeterminate-bg);\n      @include box-shadow($custom-checkbox-indicator-indeterminate-box-shadow);\n    }\n    &::after {\n      background-image: escape-svg($custom-checkbox-indicator-icon-indeterminate);\n    }\n  }\n\n  .custom-control-input:disabled {\n    &:checked ~ .custom-control-label::before {\n      @include gradient-bg($custom-control-indicator-checked-disabled-bg);\n    }\n    &:indeterminate ~ .custom-control-label::before {\n      @include gradient-bg($custom-control-indicator-checked-disabled-bg);\n    }\n  }\n}\n\n// Radios\n//\n// Tweak just a few things for radios.\n\n.custom-radio {\n  .custom-control-label::before {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $custom-radio-indicator-border-radius;\n  }\n\n  .custom-control-input:checked ~ .custom-control-label {\n    &::after {\n      background-image: escape-svg($custom-radio-indicator-icon-checked);\n    }\n  }\n\n  .custom-control-input:disabled {\n    &:checked ~ .custom-control-label::before {\n      @include gradient-bg($custom-control-indicator-checked-disabled-bg);\n    }\n  }\n}\n\n\n// switches\n//\n// Tweak a few things for switches\n\n.custom-switch {\n  padding-left: $custom-switch-width + $custom-control-gutter;\n\n  .custom-control-label {\n    &::before {\n      left: -($custom-switch-width + $custom-control-gutter);\n      width: $custom-switch-width;\n      pointer-events: all;\n      // stylelint-disable-next-line property-disallowed-list\n      border-radius: $custom-switch-indicator-border-radius;\n    }\n\n    &::after {\n      top: add(($font-size-base * $line-height-base - $custom-control-indicator-size) * .5, $custom-control-indicator-border-width * 2);\n      left: add(-($custom-switch-width + $custom-control-gutter), $custom-control-indicator-border-width * 2);\n      width: $custom-switch-indicator-size;\n      height: $custom-switch-indicator-size;\n      background-color: $custom-control-indicator-border-color;\n      // stylelint-disable-next-line property-disallowed-list\n      border-radius: $custom-switch-indicator-border-radius;\n      @include transition(transform .15s ease-in-out, $custom-forms-transition);\n    }\n  }\n\n  .custom-control-input:checked ~ .custom-control-label {\n    &::after {\n      background-color: $custom-control-indicator-bg;\n      transform: translateX($custom-switch-width - $custom-control-indicator-size);\n    }\n  }\n\n  .custom-control-input:disabled {\n    &:checked ~ .custom-control-label::before {\n      @include gradient-bg($custom-control-indicator-checked-disabled-bg);\n    }\n  }\n}\n\n\n// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n//\n\n.custom-select {\n  display: inline-block;\n  width: 100%;\n  height: $custom-select-height;\n  padding: $custom-select-padding-y ($custom-select-padding-x + $custom-select-indicator-padding) $custom-select-padding-y $custom-select-padding-x;\n  font-family: $custom-select-font-family;\n  @include font-size($custom-select-font-size);\n  font-weight: $custom-select-font-weight;\n  line-height: $custom-select-line-height;\n  color: $custom-select-color;\n  vertical-align: middle;\n  background: $custom-select-bg $custom-select-background;\n  border: $custom-select-border-width solid $custom-select-border-color;\n  @include border-radius($custom-select-border-radius, 0);\n  @include box-shadow($custom-select-box-shadow);\n  appearance: none;\n\n  &:focus {\n    border-color: $custom-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($custom-select-box-shadow, $custom-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $custom-select-focus-box-shadow;\n    }\n\n    &::-ms-value {\n      // For visual consistency with other platforms/browsers,\n      // suppress the default white text on blue background highlight given to\n      // the selected option text when the (still closed) <select> receives focus\n      // in IE and (under certain conditions) Edge.\n      // See https://github.com/twbs/bootstrap/issues/19398.\n      color: $input-color;\n      background-color: $input-bg;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    height: auto;\n    padding-right: $custom-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $custom-select-disabled-color;\n    background-color: $custom-select-disabled-bg;\n  }\n\n  // Hides the default caret in IE11\n  &::-ms-expand {\n    display: none;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $custom-select-color;\n  }\n}\n\n.custom-select-sm {\n  height: $custom-select-height-sm;\n  padding-top: $custom-select-padding-y-sm;\n  padding-bottom: $custom-select-padding-y-sm;\n  padding-left: $custom-select-padding-x-sm;\n  @include font-size($custom-select-font-size-sm);\n}\n\n.custom-select-lg {\n  height: $custom-select-height-lg;\n  padding-top: $custom-select-padding-y-lg;\n  padding-bottom: $custom-select-padding-y-lg;\n  padding-left: $custom-select-padding-x-lg;\n  @include font-size($custom-select-font-size-lg);\n}\n\n\n// File\n//\n// Custom file input.\n\n.custom-file {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  height: $custom-file-height;\n  margin-bottom: 0;\n}\n\n.custom-file-input {\n  position: relative;\n  z-index: 2;\n  width: 100%;\n  height: $custom-file-height;\n  margin: 0;\n  overflow: hidden;\n  opacity: 0;\n\n  &:focus ~ .custom-file-label {\n    border-color: $custom-file-focus-border-color;\n    box-shadow: $custom-file-focus-box-shadow;\n  }\n\n  // Use [disabled] and :disabled to work around https://github.com/twbs/bootstrap/issues/28247\n  &[disabled] ~ .custom-file-label,\n  &:disabled ~ .custom-file-label {\n    background-color: $custom-file-disabled-bg;\n  }\n\n  @each $lang, $value in $custom-file-text {\n    &:lang(#{$lang}) ~ .custom-file-label::after {\n      content: $value;\n    }\n  }\n\n  ~ .custom-file-label[data-browse]::after {\n    content: attr(data-browse);\n  }\n}\n\n.custom-file-label {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1;\n  height: $custom-file-height;\n  padding: $custom-file-padding-y $custom-file-padding-x;\n  overflow: hidden;\n  font-family: $custom-file-font-family;\n  font-weight: $custom-file-font-weight;\n  line-height: $custom-file-line-height;\n  color: $custom-file-color;\n  background-color: $custom-file-bg;\n  border: $custom-file-border-width solid $custom-file-border-color;\n  @include border-radius($custom-file-border-radius);\n  @include box-shadow($custom-file-box-shadow);\n\n  &::after {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 3;\n    display: block;\n    height: $custom-file-height-inner;\n    padding: $custom-file-padding-y $custom-file-padding-x;\n    line-height: $custom-file-line-height;\n    color: $custom-file-button-color;\n    content: \"Browse\";\n    @include gradient-bg($custom-file-button-bg);\n    border-left: inherit;\n    @include border-radius(0 $custom-file-border-radius $custom-file-border-radius 0);\n  }\n}\n\n// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.custom-range {\n  width: 100%;\n  height: add($custom-range-thumb-height, $custom-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  background-color: transparent;\n  appearance: none;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $custom-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $custom-range-thumb-focus-box-shadow; }\n    &::-ms-thumb            { box-shadow: $custom-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $custom-range-thumb-width;\n    height: $custom-range-thumb-height;\n    margin-top: ($custom-range-track-height - $custom-range-thumb-height) * .5; // Webkit specific\n    @include gradient-bg($custom-range-thumb-bg);\n    border: $custom-range-thumb-border;\n    @include border-radius($custom-range-thumb-border-radius);\n    @include box-shadow($custom-range-thumb-box-shadow);\n    @include transition($custom-forms-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($custom-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $custom-range-track-width;\n    height: $custom-range-track-height;\n    color: transparent; // Why?\n    cursor: $custom-range-track-cursor;\n    background-color: $custom-range-track-bg;\n    border-color: transparent;\n    @include border-radius($custom-range-track-border-radius);\n    @include box-shadow($custom-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $custom-range-thumb-width;\n    height: $custom-range-thumb-height;\n    @include gradient-bg($custom-range-thumb-bg);\n    border: $custom-range-thumb-border;\n    @include border-radius($custom-range-thumb-border-radius);\n    @include box-shadow($custom-range-thumb-box-shadow);\n    @include transition($custom-forms-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($custom-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $custom-range-track-width;\n    height: $custom-range-track-height;\n    color: transparent;\n    cursor: $custom-range-track-cursor;\n    background-color: $custom-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($custom-range-track-border-radius);\n    @include box-shadow($custom-range-track-box-shadow);\n  }\n\n  &::-ms-thumb {\n    width: $custom-range-thumb-width;\n    height: $custom-range-thumb-height;\n    margin-top: 0; // Edge specific\n    margin-right: $custom-range-thumb-focus-box-shadow-width; // Workaround that overflowed box-shadow is hidden.\n    margin-left: $custom-range-thumb-focus-box-shadow-width;  // Workaround that overflowed box-shadow is hidden.\n    @include gradient-bg($custom-range-thumb-bg);\n    border: $custom-range-thumb-border;\n    @include border-radius($custom-range-thumb-border-radius);\n    @include box-shadow($custom-range-thumb-box-shadow);\n    @include transition($custom-forms-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($custom-range-thumb-active-bg);\n    }\n  }\n\n  &::-ms-track {\n    width: $custom-range-track-width;\n    height: $custom-range-track-height;\n    color: transparent;\n    cursor: $custom-range-track-cursor;\n    background-color: transparent;\n    border-color: transparent;\n    border-width: $custom-range-thumb-height * .5;\n    @include box-shadow($custom-range-track-box-shadow);\n  }\n\n  &::-ms-fill-lower {\n    background-color: $custom-range-track-bg;\n    @include border-radius($custom-range-track-border-radius);\n  }\n\n  &::-ms-fill-upper {\n    margin-right: 15px; // arbitrary?\n    background-color: $custom-range-track-bg;\n    @include border-radius($custom-range-track-border-radius);\n  }\n\n  &:disabled {\n    &::-webkit-slider-thumb {\n      background-color: $custom-range-thumb-disabled-bg;\n    }\n\n    &::-webkit-slider-runnable-track {\n      cursor: default;\n    }\n\n    &::-moz-range-thumb {\n      background-color: $custom-range-thumb-disabled-bg;\n    }\n\n    &::-moz-range-track {\n      cursor: default;\n    }\n\n    &::-ms-thumb {\n      background-color: $custom-range-thumb-disabled-bg;\n    }\n  }\n}\n\n.custom-control-label::before,\n.custom-file-label,\n.custom-select {\n  @include transition($custom-forms-transition);\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: $nav-link-padding-y $nav-link-padding-x;\n  text-decoration: if($link-decoration == none, null, none);\n\n  @include hover-focus() {\n    text-decoration: none;\n  }\n\n  // Disabled state lightens text\n  &.disabled {\n    color: $nav-link-disabled-color;\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  border-bottom: $nav-tabs-border-width solid $nav-tabs-border-color;\n\n  .nav-link {\n    margin-bottom: -$nav-tabs-border-width;\n    background-color: transparent;\n    border: $nav-tabs-border-width solid transparent;\n    @include border-top-radius($nav-tabs-border-radius);\n\n    @include hover-focus() {\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n      border-color: $nav-tabs-link-hover-border-color;\n    }\n\n    &.disabled {\n      color: $nav-link-disabled-color;\n      background-color: transparent;\n      border-color: transparent;\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: $nav-tabs-link-active-color;\n    background-color: $nav-tabs-link-active-bg;\n    border-color: $nav-tabs-link-active-border-color;\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: -$nav-tabs-border-width;\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  .nav-link {\n    background: none;\n    border: 0;\n    @include border-radius($nav-pills-border-radius);\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: $nav-pills-link-active-color;\n    background-color: $nav-pills-link-active-bg;\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-basis: 0;\n    flex-grow: 1;\n    text-align: center;\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Contents\n//\n// Navbar\n// Navbar brand\n// Navbar nav\n// Navbar text\n// Navbar divider\n// Responsive navbar\n// Navbar position\n// Navbar themes\n\n\n// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: $navbar-padding-y $navbar-padding-x;\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  .container,\n  .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  display: inline-block;\n  padding-top: $navbar-brand-padding-y;\n  padding-bottom: $navbar-brand-padding-y;\n  margin-right: $navbar-padding-x;\n  @include font-size($navbar-brand-font-size);\n  line-height: inherit;\n  white-space: nowrap;\n\n  @include hover-focus() {\n    text-decoration: none;\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .nav-link {\n    padding-right: 0;\n    padding-left: 0;\n  }\n\n  .dropdown-menu {\n    position: static;\n    float: none;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  display: inline-block;\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: $navbar-toggler-padding-y $navbar-toggler-padding-x;\n  @include font-size($navbar-toggler-font-size);\n  line-height: 1;\n  background-color: transparent; // remove default button style\n  border: $border-width solid transparent; // remove default button style\n  @include border-radius($navbar-toggler-border-radius);\n\n  @include hover-focus() {\n    text-decoration: none;\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  content: \"\";\n  background: 50% / 100% 100% no-repeat;\n}\n\n.navbar-nav-scroll {\n  max-height: $navbar-nav-scroll-max-height;\n  overflow-y: auto;\n}\n\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    &#{$infix} {\n      @include media-breakpoint-down($breakpoint) {\n        %container-navbar-expand-#{$breakpoint} {\n          padding-right: 0;\n          padding-left: 0;\n        }\n\n        > .container,\n        > .container-fluid {\n          @extend %container-navbar-expand-#{$breakpoint};\n        }\n\n        @each $size, $container-max-width in $container-max-widths {\n          > .container#{breakpoint-infix($size, $container-max-widths)} {\n            @extend %container-navbar-expand-#{$breakpoint};\n          }\n        }\n      }\n\n      @include media-breakpoint-up($next) {\n        flex-flow: row nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: $navbar-nav-link-padding-x;\n            padding-left: $navbar-nav-link-padding-x;\n          }\n        }\n\n        // For nesting containers, have to redeclare for alignment purposes\n        %container-nesting-#{$breakpoint} {\n          flex-wrap: nowrap;\n        }\n\n        > .container,\n        > .container-fluid {\n          @extend %container-nesting-#{$breakpoint};\n        }\n\n        @each $size, $container-max-width in $container-max-widths {\n          > .container#{breakpoint-infix($size, $container-max-widths)} {\n            @extend %container-nesting-#{$breakpoint};\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n\n          // Changes flex-bases to auto because of an IE10 bug\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n      }\n    }\n  }\n}\n\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n// Dark links against a light background\n.navbar-light {\n  .navbar-brand {\n    color: $navbar-light-brand-color;\n\n    @include hover-focus() {\n      color: $navbar-light-brand-hover-color;\n    }\n  }\n\n  .navbar-nav {\n    .nav-link {\n      color: $navbar-light-color;\n\n      @include hover-focus() {\n        color: $navbar-light-hover-color;\n      }\n\n      &.disabled {\n        color: $navbar-light-disabled-color;\n      }\n    }\n\n    .show > .nav-link,\n    .active > .nav-link,\n    .nav-link.show,\n    .nav-link.active {\n      color: $navbar-light-active-color;\n    }\n  }\n\n  .navbar-toggler {\n    color: $navbar-light-color;\n    border-color: $navbar-light-toggler-border-color;\n  }\n\n  .navbar-toggler-icon {\n    background-image: escape-svg($navbar-light-toggler-icon-bg);\n  }\n\n  .navbar-text {\n    color: $navbar-light-color;\n    a {\n      color: $navbar-light-active-color;\n\n      @include hover-focus() {\n        color: $navbar-light-active-color;\n      }\n    }\n  }\n}\n\n// White links against a dark background\n.navbar-dark {\n  .navbar-brand {\n    color: $navbar-dark-brand-color;\n\n    @include hover-focus() {\n      color: $navbar-dark-brand-hover-color;\n    }\n  }\n\n  .navbar-nav {\n    .nav-link {\n      color: $navbar-dark-color;\n\n      @include hover-focus() {\n        color: $navbar-dark-hover-color;\n      }\n\n      &.disabled {\n        color: $navbar-dark-disabled-color;\n      }\n    }\n\n    .show > .nav-link,\n    .active > .nav-link,\n    .nav-link.show,\n    .nav-link.active {\n      color: $navbar-dark-active-color;\n    }\n  }\n\n  .navbar-toggler {\n    color: $navbar-dark-color;\n    border-color: $navbar-dark-toggler-border-color;\n  }\n\n  .navbar-toggler-icon {\n    background-image: escape-svg($navbar-dark-toggler-icon-bg);\n  }\n\n  .navbar-text {\n    color: $navbar-dark-color;\n    a {\n      color: $navbar-dark-active-color;\n\n      @include hover-focus() {\n        color: $navbar-dark-active-color;\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: $card-height;\n  word-wrap: break-word;\n  background-color: $card-bg;\n  background-clip: border-box;\n  border: $card-border-width solid $card-border-color;\n  @include border-radius($card-border-radius);\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius($card-inner-border-radius);\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius($card-inner-border-radius);\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  // Workaround for the image size bug in IE\n  // See: https://github.com/twbs/bootstrap/pull/28855\n  min-height: 1px;\n  padding: $card-spacer-x;\n  color: $card-color;\n}\n\n.card-title {\n  margin-bottom: $card-spacer-y;\n}\n\n.card-subtitle {\n  margin-top: -$card-spacer-y * .5;\n  margin-bottom: 0;\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  @include hover() {\n    text-decoration: none;\n  }\n\n  + .card-link {\n    margin-left: $card-spacer-x;\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: $card-spacer-y $card-spacer-x;\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: $card-cap-color;\n  background-color: $card-cap-bg;\n  border-bottom: $card-border-width solid $card-border-color;\n\n  &:first-child {\n    @include border-radius($card-inner-border-radius $card-inner-border-radius 0 0);\n  }\n}\n\n.card-footer {\n  padding: $card-spacer-y $card-spacer-x;\n  color: $card-cap-color;\n  background-color: $card-cap-bg;\n  border-top: $card-border-width solid $card-border-color;\n\n  &:last-child {\n    @include border-radius(0 0 $card-inner-border-radius $card-inner-border-radius);\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: -$card-spacer-x * .5;\n  margin-bottom: -$card-spacer-y;\n  margin-left: -$card-spacer-x * .5;\n  border-bottom: 0;\n}\n\n.card-header-pills {\n  margin-right: -$card-spacer-x * .5;\n  margin-left: -$card-spacer-x * .5;\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: $card-img-overlay-padding;\n  @include border-radius($card-inner-border-radius);\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  flex-shrink: 0; // For IE: https://github.com/twbs/bootstrap/issues/29396\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius($card-inner-border-radius);\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius($card-inner-border-radius);\n}\n\n\n// Card deck\n\n.card-deck {\n  .card {\n    margin-bottom: $card-deck-margin;\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    margin-right: -$card-deck-margin;\n    margin-left: -$card-deck-margin;\n\n    .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-right: $card-deck-margin;\n      margin-bottom: 0; // Override the default\n      margin-left: $card-deck-margin;\n    }\n  }\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: $card-group-margin;\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-bottom: 0;\n\n      + .card {\n        margin-left: 0;\n        border-left: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-right-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-left-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n\n\n//\n// Columns\n//\n\n.card-columns {\n  .card {\n    margin-bottom: $card-columns-margin;\n  }\n\n  @include media-breakpoint-up(sm) {\n    column-count: $card-columns-count;\n    column-gap: $card-columns-gap;\n    orphans: 1;\n    widows: 1;\n\n    .card {\n      display: inline-block; // Don't let them vertically span multiple columns\n      width: 100%; // Don't let their width change\n    }\n  }\n}\n\n\n//\n// Accordion\n//\n\n.accordion {\n  overflow-anchor: none;\n\n  > .card {\n    overflow: hidden;\n\n    &:not(:last-of-type) {\n      border-bottom: 0;\n      @include border-bottom-radius(0);\n    }\n\n    &:not(:first-of-type) {\n      @include border-top-radius(0);\n    }\n\n    > .card-header {\n      @include border-radius(0);\n      margin-bottom: -$card-border-width;\n    }\n  }\n}\n",".breadcrumb {\n  display: flex;\n  flex-wrap: wrap;\n  padding: $breadcrumb-padding-y $breadcrumb-padding-x;\n  margin-bottom: $breadcrumb-margin-bottom;\n  @include font-size($breadcrumb-font-size);\n  list-style: none;\n  background-color: $breadcrumb-bg;\n  @include border-radius($breadcrumb-border-radius);\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-left: $breadcrumb-item-padding;\n\n    &::before {\n      float: left; // Suppress inline spacings and underlining of the separator\n      padding-right: $breadcrumb-item-padding;\n      color: $breadcrumb-divider-color;\n      content: escape-svg($breadcrumb-divider);\n    }\n  }\n\n  // IE9-11 hack to properly handle hyperlink underlines for breadcrumbs built\n  // without `<ul>`s. The `::before` pseudo-element generates an element\n  // *within* the .breadcrumb-item and thereby inherits the `text-decoration`.\n  //\n  // To trick IE into suppressing the underline, we give the pseudo-element an\n  // underline and then immediately remove it.\n  + .breadcrumb-item:hover::before {\n    text-decoration: underline;\n  }\n  // stylelint-disable-next-line no-duplicate-selectors\n  + .breadcrumb-item:hover::before {\n    text-decoration: none;\n  }\n\n  &.active {\n    color: $breadcrumb-active-color;\n  }\n}\n",".pagination {\n  display: flex;\n  @include list-unstyled();\n  @include border-radius();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: $pagination-padding-y $pagination-padding-x;\n  margin-left: -$pagination-border-width;\n  line-height: $pagination-line-height;\n  color: $pagination-color;\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: $pagination-bg;\n  border: $pagination-border-width solid $pagination-border-color;\n\n  &:hover {\n    z-index: 2;\n    color: $pagination-hover-color;\n    text-decoration: none;\n    background-color: $pagination-hover-bg;\n    border-color: $pagination-hover-border-color;\n  }\n\n  &:focus {\n    z-index: 3;\n    outline: $pagination-focus-outline;\n    box-shadow: $pagination-focus-box-shadow;\n  }\n}\n\n.page-item {\n  &:first-child {\n    .page-link {\n      margin-left: 0;\n      @include border-left-radius($border-radius);\n    }\n  }\n  &:last-child {\n    .page-link {\n      @include border-right-radius($border-radius);\n    }\n  }\n\n  &.active .page-link {\n    z-index: 3;\n    color: $pagination-active-color;\n    background-color: $pagination-active-bg;\n    border-color: $pagination-active-border-color;\n  }\n\n  &.disabled .page-link {\n    color: $pagination-disabled-color;\n    pointer-events: none;\n    // Opinionated: remove the \"hand\" cursor set previously for .page-link\n    cursor: auto;\n    background-color: $pagination-disabled-bg;\n    border-color: $pagination-disabled-border-color;\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $line-height-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $line-height-sm, $pagination-border-radius-sm);\n}\n","// Pagination\n\n@mixin pagination-size($padding-y, $padding-x, $font-size, $line-height, $border-radius) {\n  .page-link {\n    padding: $padding-y $padding-x;\n    @include font-size($font-size);\n    line-height: $line-height;\n  }\n\n  .page-item {\n    &:first-child {\n      .page-link {\n        @include border-left-radius($border-radius);\n      }\n    }\n    &:last-child {\n      .page-link {\n        @include border-right-radius($border-radius);\n      }\n    }\n  }\n}\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  display: inline-block;\n  padding: $badge-padding-y $badge-padding-x;\n  @include font-size($badge-font-size);\n  font-weight: $badge-font-weight;\n  line-height: 1;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius($badge-border-radius);\n  @include transition($badge-transition);\n\n  @at-root a#{&} {\n    @include hover-focus() {\n      text-decoration: none;\n    }\n  }\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n\n// Pill badges\n//\n// Make them extra rounded with a modifier to replace v3's badges.\n\n.badge-pill {\n  padding-right: $badge-pill-padding-x;\n  padding-left: $badge-pill-padding-x;\n  @include border-radius($badge-pill-border-radius);\n}\n\n// Colors\n//\n// Contextual variations (linked badges get darker on :hover).\n\n@each $color, $value in $theme-colors {\n  .badge-#{$color} {\n    @include badge-variant($value);\n  }\n}\n","@mixin badge-variant($bg) {\n  color: color-yiq($bg);\n  background-color: $bg;\n\n  @at-root a#{&} {\n    @include hover-focus() {\n      color: color-yiq($bg);\n      background-color: darken($bg, 10%);\n    }\n\n    &:focus,\n    &.focus {\n      outline: 0;\n      box-shadow: 0 0 0 $badge-focus-width rgba($bg, .5);\n    }\n  }\n}\n",".jumbotron {\n  padding: $jumbotron-padding ($jumbotron-padding * .5);\n  margin-bottom: $jumbotron-padding;\n  color: $jumbotron-color;\n  background-color: $jumbotron-bg;\n  @include border-radius($border-radius-lg);\n\n  @include media-breakpoint-up(sm) {\n    padding: ($jumbotron-padding * 2) $jumbotron-padding;\n  }\n}\n\n.jumbotron-fluid {\n  padding-right: 0;\n  padding-left: 0;\n  @include border-radius(0);\n}\n","//\n// Base styles\n//\n\n.alert {\n  position: relative;\n  padding: $alert-padding-y $alert-padding-x;\n  margin-bottom: $alert-margin-bottom;\n  border: $alert-border-width solid transparent;\n  @include border-radius($alert-border-radius);\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-right: $close-font-size + $alert-padding-x * 2;\n\n  // Adjust close link position\n  .close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: 2;\n    padding: $alert-padding-y $alert-padding-x;\n    color: inherit;\n  }\n}\n\n\n// Alternate styles\n//\n// Generate contextual modifier classes for colorizing the alert.\n\n@each $color, $value in $theme-colors {\n  .alert-#{$color} {\n    @include alert-variant(theme-color-level($color, $alert-bg-level), theme-color-level($color, $alert-border-level), theme-color-level($color, $alert-color-level));\n  }\n}\n","@mixin alert-variant($background, $border, $color) {\n  color: $color;\n  @include gradient-bg($background);\n  border-color: $border;\n\n  hr {\n    border-top-color: darken($border, 5%);\n  }\n\n  .alert-link {\n    color: darken($color, 10%);\n  }\n}\n","// Disable animation if transitions are disabled\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    from { background-position: $progress-height 0; }\n    to { background-position: 0 0; }\n  }\n}\n\n.progress {\n  display: flex;\n  height: $progress-height;\n  overflow: hidden; // force rounded corners by cropping it\n  line-height: 0;\n  @include font-size($progress-font-size);\n  background-color: $progress-bg;\n  @include border-radius($progress-border-radius);\n  @include box-shadow($progress-box-shadow);\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: $progress-bar-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $progress-bar-bg;\n  @include transition($progress-bar-transition);\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: $progress-height $progress-height;\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-prefers-reduced-motion-media-query {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n",".media {\n  display: flex;\n  align-items: flex-start;\n}\n\n.media-body {\n  flex: 1;\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius($list-group-border-radius);\n}\n\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: $list-group-action-color;\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  // Hover state\n  @include hover-focus() {\n    z-index: 1; // Place hover/focus items above their siblings for proper border styling\n    color: $list-group-action-hover-color;\n    text-decoration: none;\n    background-color: $list-group-hover-bg;\n  }\n\n  &:active {\n    color: $list-group-action-active-color;\n    background-color: $list-group-action-active-bg;\n  }\n}\n\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: $list-group-item-padding-y $list-group-item-padding-x;\n  color: $list-group-color;\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: $list-group-bg;\n  border: $list-group-border-width solid $list-group-border-color;\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: $list-group-disabled-color;\n    pointer-events: none;\n    background-color: $list-group-disabled-bg;\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: $list-group-active-color;\n    background-color: $list-group-active-bg;\n    border-color: $list-group-active-border-color;\n  }\n\n  & + & {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: -$list-group-border-width;\n      border-top-width: $list-group-border-width;\n    }\n  }\n}\n\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child {\n          @include border-bottom-left-radius($list-group-border-radius);\n          @include border-top-right-radius(0);\n        }\n\n        &:last-child {\n          @include border-top-right-radius($list-group-border-radius);\n          @include border-bottom-left-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: $list-group-border-width;\n          border-left-width: 0;\n\n          &.active {\n            margin-left: -$list-group-border-width;\n            border-left-width: $list-group-border-width;\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 $list-group-border-width;\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// Contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $color, $value in $theme-colors {\n  @include list-group-item-variant($color, theme-color-level($color, -9), theme-color-level($color, 6));\n}\n","// List Groups\n\n@mixin list-group-item-variant($state, $background, $color) {\n  .list-group-item-#{$state} {\n    color: $color;\n    background-color: $background;\n\n    &.list-group-item-action {\n      @include hover-focus() {\n        color: $color;\n        background-color: darken($background, 5%);\n      }\n\n      &.active {\n        color: $white;\n        background-color: $color;\n        border-color: $color;\n      }\n    }\n  }\n}\n",".close {\n  float: right;\n  @include font-size($close-font-size);\n  font-weight: $close-font-weight;\n  line-height: 1;\n  color: $close-color;\n  text-shadow: $close-text-shadow;\n  opacity: .5;\n\n  // Override <a>'s hover style\n  @include hover() {\n    color: $close-color;\n    text-decoration: none;\n  }\n\n  &:not(:disabled):not(.disabled) {\n    @include hover-focus() {\n      opacity: .75;\n    }\n  }\n}\n\n// Additional properties for button version\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n// stylelint-disable-next-line selector-no-qualifying-type\nbutton.close {\n  padding: 0;\n  background-color: transparent;\n  border: 0;\n}\n\n// Future-proof disabling of clicks on `<a>` elements\n\n// stylelint-disable-next-line selector-no-qualifying-type\na.close.disabled {\n  pointer-events: none;\n}\n",".toast {\n  // Prevents from shrinking in IE11, when in a flex container\n  // See https://github.com/twbs/bootstrap/issues/28341\n  flex-basis: $toast-max-width;\n  max-width: $toast-max-width;\n  @include font-size($toast-font-size);\n  color: $toast-color;\n  background-color: $toast-background-color;\n  background-clip: padding-box;\n  border: $toast-border-width solid $toast-border-color;\n  box-shadow: $toast-box-shadow;\n  opacity: 0;\n  @include border-radius($toast-border-radius);\n\n  &:not(:last-child) {\n    margin-bottom: $toast-padding-x;\n  }\n\n  &.showing {\n    opacity: 1;\n  }\n\n  &.show {\n    display: block;\n    opacity: 1;\n  }\n\n  &.hide {\n    display: none;\n  }\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: $toast-padding-y $toast-padding-x;\n  color: $toast-header-color;\n  background-color: $toast-header-background-color;\n  background-clip: padding-box;\n  border-bottom: $toast-border-width solid $toast-header-border-color;\n  @include border-top-radius(subtract($toast-border-radius, $toast-border-width));\n}\n\n.toast-body {\n  padding: $toast-padding-x; // apply to both vertical and horizontal\n}\n","// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n.modal-open {\n  // Kill the scroll on the body\n  overflow: hidden;\n\n  .modal {\n    overflow-x: hidden;\n    overflow-y: auto;\n  }\n}\n\n// Container that the modal scrolls within\n.modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex-modal;\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: $modal-dialog-margin;\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    @include transition($modal-transition);\n    transform: $modal-fade-transform;\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  display: flex; // IE10/11\n  max-height: subtract(100%, $modal-dialog-margin * 2);\n\n  .modal-content {\n    max-height: subtract(100vh, $modal-dialog-margin * 2); // IE10/11\n    overflow: hidden;\n  }\n\n  .modal-header,\n  .modal-footer {\n    flex-shrink: 0;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: subtract(100%, $modal-dialog-margin * 2);\n\n  // Ensure `modal-dialog-centered` extends the full height of the view (IE10/11)\n  &::before {\n    display: block; // IE10\n    height: subtract(100vh, $modal-dialog-margin * 2);\n    height: min-content; // Reset height to 0 except on IE\n    content: \"\";\n  }\n\n  // Ensure `.modal-body` shows scrollbar (IE10/11)\n  &.modal-dialog-scrollable {\n    flex-direction: column;\n    justify-content: center;\n    height: 100%;\n\n    .modal-content {\n      max-height: none;\n    }\n\n    &::before {\n      content: none;\n    }\n  }\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: $modal-content-color;\n  pointer-events: auto;\n  background-color: $modal-content-bg;\n  background-clip: padding-box;\n  border: $modal-content-border-width solid $modal-content-border-color;\n  @include border-radius($modal-content-border-radius);\n  @include box-shadow($modal-content-box-shadow-xs);\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex-modal-backdrop;\n  width: 100vw;\n  height: 100vh;\n  background-color: $modal-backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $modal-backdrop-opacity; }\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  align-items: flex-start; // so the close btn always stays on the upper right corner\n  justify-content: space-between; // Put modal header elements (title and dismiss) on opposite ends\n  padding: $modal-header-padding;\n  border-bottom: $modal-header-border-width solid $modal-header-border-color;\n  @include border-top-radius($modal-content-inner-border-radius);\n\n  .close {\n    padding: $modal-header-padding;\n    // auto on the left force icon to the right even when there is no .modal-title\n    margin: (-$modal-header-padding-y) (-$modal-header-padding-x) (-$modal-header-padding-y) auto;\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: $modal-title-line-height;\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: $modal-inner-padding;\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: $modal-inner-padding - $modal-footer-margin-between * .5;\n  border-top: $modal-footer-border-width solid $modal-footer-border-color;\n  @include border-bottom-radius($modal-content-inner-border-radius);\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: $modal-footer-margin-between * .5;\n  }\n}\n\n// Measure scrollbar width for padding body during modal show/hide\n.modal-scrollbar-measure {\n  position: absolute;\n  top: -9999px;\n  width: 50px;\n  height: 50px;\n  overflow: scroll;\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: $modal-md;\n    margin: $modal-dialog-margin-y-sm-up auto;\n  }\n\n  .modal-dialog-scrollable {\n    max-height: subtract(100%, $modal-dialog-margin-y-sm-up * 2);\n\n    .modal-content {\n      max-height: subtract(100vh, $modal-dialog-margin-y-sm-up * 2);\n    }\n  }\n\n  .modal-dialog-centered {\n    min-height: subtract(100%, $modal-dialog-margin-y-sm-up * 2);\n\n    &::before {\n      height: subtract(100vh, $modal-dialog-margin-y-sm-up * 2);\n      height: min-content;\n    }\n  }\n\n  .modal-content {\n    @include box-shadow($modal-content-box-shadow-sm-up);\n  }\n\n  .modal-sm { max-width: $modal-sm; }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    max-width: $modal-lg;\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl { max-width: $modal-xl; }\n}\n","// Base class\n.tooltip {\n  position: absolute;\n  z-index: $zindex-tooltip;\n  display: block;\n  margin: $tooltip-margin;\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size($tooltip-font-size);\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: $tooltip-opacity; }\n\n  .arrow {\n    position: absolute;\n    display: block;\n    width: $tooltip-arrow-width;\n    height: $tooltip-arrow-height;\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top {\n  padding: $tooltip-arrow-height 0;\n\n  .arrow {\n    bottom: 0;\n\n    &::before {\n      top: 0;\n      border-width: $tooltip-arrow-height ($tooltip-arrow-width * .5) 0;\n      border-top-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-right {\n  padding: 0 $tooltip-arrow-height;\n\n  .arrow {\n    left: 0;\n    width: $tooltip-arrow-height;\n    height: $tooltip-arrow-width;\n\n    &::before {\n      right: 0;\n      border-width: ($tooltip-arrow-width * .5) $tooltip-arrow-height ($tooltip-arrow-width * .5) 0;\n      border-right-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-bottom {\n  padding: $tooltip-arrow-height 0;\n\n  .arrow {\n    top: 0;\n\n    &::before {\n      bottom: 0;\n      border-width: 0 ($tooltip-arrow-width * .5) $tooltip-arrow-height;\n      border-bottom-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-left {\n  padding: 0 $tooltip-arrow-height;\n\n  .arrow {\n    right: 0;\n    width: $tooltip-arrow-height;\n    height: $tooltip-arrow-width;\n\n    &::before {\n      left: 0;\n      border-width: ($tooltip-arrow-width * .5) 0 ($tooltip-arrow-width * .5) $tooltip-arrow-height;\n      border-left-color: $tooltip-arrow-color;\n    }\n  }\n}\n\n.bs-tooltip-auto {\n  &[x-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[x-placement^=\"right\"] {\n    @extend .bs-tooltip-right;\n  }\n  &[x-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[x-placement^=\"left\"] {\n    @extend .bs-tooltip-left;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: $tooltip-max-width;\n  padding: $tooltip-padding-y $tooltip-padding-x;\n  color: $tooltip-color;\n  text-align: center;\n  background-color: $tooltip-bg;\n  @include border-radius($tooltip-border-radius);\n}\n","@mixin reset-text() {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n}\n",".popover {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: $zindex-popover;\n  display: block;\n  max-width: $popover-max-width;\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size($popover-font-size);\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: $popover-bg;\n  background-clip: padding-box;\n  border: $popover-border-width solid $popover-border-color;\n  @include border-radius($popover-border-radius);\n  @include box-shadow($popover-box-shadow);\n\n  .arrow {\n    position: absolute;\n    display: block;\n    width: $popover-arrow-width;\n    height: $popover-arrow-height;\n    margin: 0 $popover-border-radius;\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-popover-top {\n  margin-bottom: $popover-arrow-height;\n\n  > .arrow {\n    bottom: subtract(-$popover-arrow-height, $popover-border-width);\n\n    &::before {\n      bottom: 0;\n      border-width: $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-top-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      bottom: $popover-border-width;\n      border-width: $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-top-color: $popover-arrow-color;\n    }\n  }\n}\n\n.bs-popover-right {\n  margin-left: $popover-arrow-height;\n\n  > .arrow {\n    left: subtract(-$popover-arrow-height, $popover-border-width);\n    width: $popover-arrow-height;\n    height: $popover-arrow-width;\n    margin: $popover-border-radius 0; // make sure the arrow does not touch the popover's rounded corners\n\n    &::before {\n      left: 0;\n      border-width: ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-right-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      left: $popover-border-width;\n      border-width: ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5) 0;\n      border-right-color: $popover-arrow-color;\n    }\n  }\n}\n\n.bs-popover-bottom {\n  margin-top: $popover-arrow-height;\n\n  > .arrow {\n    top: subtract(-$popover-arrow-height, $popover-border-width);\n\n    &::before {\n      top: 0;\n      border-width: 0 ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5);\n      border-bottom-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      top: $popover-border-width;\n      border-width: 0 ($popover-arrow-width * .5) $popover-arrow-height ($popover-arrow-width * .5);\n      border-bottom-color: $popover-arrow-color;\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: $popover-arrow-width;\n    margin-left: -$popover-arrow-width * .5;\n    content: \"\";\n    border-bottom: $popover-border-width solid $popover-header-bg;\n  }\n}\n\n.bs-popover-left {\n  margin-right: $popover-arrow-height;\n\n  > .arrow {\n    right: subtract(-$popover-arrow-height, $popover-border-width);\n    width: $popover-arrow-height;\n    height: $popover-arrow-width;\n    margin: $popover-border-radius 0; // make sure the arrow does not touch the popover's rounded corners\n\n    &::before {\n      right: 0;\n      border-width: ($popover-arrow-width * .5) 0 ($popover-arrow-width * .5) $popover-arrow-height;\n      border-left-color: $popover-arrow-outer-color;\n    }\n\n    &::after {\n      right: $popover-border-width;\n      border-width: ($popover-arrow-width * .5) 0 ($popover-arrow-width * .5) $popover-arrow-height;\n      border-left-color: $popover-arrow-color;\n    }\n  }\n}\n\n.bs-popover-auto {\n  &[x-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[x-placement^=\"right\"] {\n    @extend .bs-popover-right;\n  }\n  &[x-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[x-placement^=\"left\"] {\n    @extend .bs-popover-left;\n  }\n}\n\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: $popover-header-padding-y $popover-header-padding-x;\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size($font-size-base);\n  color: $popover-header-color;\n  background-color: $popover-header-bg;\n  border-bottom: $popover-border-width solid darken($popover-header-bg, 5%);\n  @include border-top-radius($popover-inner-border-radius);\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: $popover-body-padding-y $popover-body-padding-x;\n  color: $popover-body-color;\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-left and .carousel-item-right is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-left and .active.carousel-item-right is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-left and .carousel-item-prev.carousel-item-right\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-left),\n.active.carousel-item-right {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-right),\n.active.carousel-item-left {\n  transform: translateX(-100%);\n}\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-left,\n  .carousel-item-prev.carousel-item-right {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-left,\n  .active.carousel-item-right {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: $carousel-control-color;\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  @include hover-focus() {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  @if $enable-gradients {\n    background-image: linear-gradient(90deg, rgba($black, .25), rgba($black, .001));\n  }\n}\n.carousel-control-next {\n  right: 0;\n  @if $enable-gradients {\n    background-image: linear-gradient(270deg, rgba($black, .25), rgba($black, .001));\n  }\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background: 50% / 100% 100% no-repeat;\n}\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg);\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg);\n}\n\n\n// Optional indicator pips\n//\n// Add an ordered list with the following class and add a list item for each\n// slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 15;\n  display: flex;\n  justify-content: center;\n  padding-left: 0; // override <ol> default\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-left: $carousel-control-width;\n  list-style: none;\n\n  li {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: $carousel-indicator-active-bg;\n    background-clip: padding-box;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: .5;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: 1;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: 20px;\n  left: (100% - $carousel-caption-width) * .5;\n  z-index: 10;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  color: $carousel-caption-color;\n  text-align: center;\n}\n","@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n","//\n// Rotating border\n//\n\n@keyframes spinner-border {\n  to { transform: rotate(360deg); }\n}\n\n.spinner-border {\n  display: inline-block;\n  width: $spinner-width;\n  height: $spinner-height;\n  vertical-align: $spinner-vertical-align;\n  border: $spinner-border-width solid currentcolor;\n  border-right-color: transparent;\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: .75s linear infinite spinner-border;\n}\n\n.spinner-border-sm {\n  width: $spinner-width-sm;\n  height: $spinner-height-sm;\n  border-width: $spinner-border-width-sm;\n}\n\n//\n// Growing circle\n//\n\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n\n.spinner-grow {\n  display: inline-block;\n  width: $spinner-width;\n  height: $spinner-height;\n  vertical-align: $spinner-vertical-align;\n  background-color: currentcolor;\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  opacity: 0;\n  animation: .75s linear infinite spinner-grow;\n}\n\n.spinner-grow-sm {\n  width: $spinner-width-sm;\n  height: $spinner-height-sm;\n}\n\n@if $enable-prefers-reduced-motion-media-query {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      animation-duration: 1.5s;\n    }\n  }\n}\n","// stylelint-disable declaration-no-important\n\n.align-baseline    { vertical-align: baseline !important; } // Browser default\n.align-top         { vertical-align: top !important; }\n.align-middle      { vertical-align: middle !important; }\n.align-bottom      { vertical-align: bottom !important; }\n.align-text-bottom { vertical-align: text-bottom !important; }\n.align-text-top    { vertical-align: text-top !important; }\n","// stylelint-disable declaration-no-important\n\n// Contextual backgrounds\n\n@mixin bg-variant($parent, $color, $ignore-warning: false) {\n  #{$parent} {\n    background-color: $color !important;\n  }\n  a#{$parent},\n  button#{$parent} {\n    @include hover-focus() {\n      background-color: darken($color, 10%) !important;\n    }\n  }\n  @include deprecate(\"The `bg-variant` mixin\", \"v4.4.0\", \"v5\", $ignore-warning);\n}\n\n@mixin bg-gradient-variant($parent, $color, $ignore-warning: false) {\n  #{$parent} {\n    background: $color linear-gradient(180deg, mix($body-bg, $color, 15%), $color) repeat-x !important;\n  }\n  @include deprecate(\"The `bg-gradient-variant` mixin\", \"v4.5.0\", \"v5\", $ignore-warning);\n}\n","// stylelint-disable declaration-no-important\n\n@each $color, $value in $theme-colors {\n  @include bg-variant(\".bg-#{$color}\", $value, true);\n}\n\n@if $enable-gradients {\n  @each $color, $value in $theme-colors {\n    @include bg-gradient-variant(\".bg-gradient-#{$color}\", $value, true);\n  }\n}\n\n.bg-white {\n  background-color: $white !important;\n}\n\n.bg-transparent {\n  background-color: transparent !important;\n}\n","// stylelint-disable property-disallowed-list, declaration-no-important\n\n//\n// Border\n//\n\n.border         { border: $border-width solid $border-color !important; }\n.border-top     { border-top: $border-width solid $border-color !important; }\n.border-right   { border-right: $border-width solid $border-color !important; }\n.border-bottom  { border-bottom: $border-width solid $border-color !important; }\n.border-left    { border-left: $border-width solid $border-color !important; }\n\n.border-0        { border: 0 !important; }\n.border-top-0    { border-top: 0 !important; }\n.border-right-0  { border-right: 0 !important; }\n.border-bottom-0 { border-bottom: 0 !important; }\n.border-left-0   { border-left: 0 !important; }\n\n@each $color, $value in $theme-colors {\n  .border-#{$color} {\n    border-color: $value !important;\n  }\n}\n\n.border-white {\n  border-color: $white !important;\n}\n\n//\n// Border-radius\n//\n\n.rounded-sm {\n  border-radius: $border-radius-sm !important;\n}\n\n.rounded {\n  border-radius: $border-radius !important;\n}\n\n.rounded-top {\n  border-top-left-radius: $border-radius !important;\n  border-top-right-radius: $border-radius !important;\n}\n\n.rounded-right {\n  border-top-right-radius: $border-radius !important;\n  border-bottom-right-radius: $border-radius !important;\n}\n\n.rounded-bottom {\n  border-bottom-right-radius: $border-radius !important;\n  border-bottom-left-radius: $border-radius !important;\n}\n\n.rounded-left {\n  border-top-left-radius: $border-radius !important;\n  border-bottom-left-radius: $border-radius !important;\n}\n\n.rounded-lg {\n  border-radius: $border-radius-lg !important;\n}\n\n.rounded-circle {\n  border-radius: 50% !important;\n}\n\n.rounded-pill {\n  border-radius: $rounded-pill !important;\n}\n\n.rounded-0 {\n  border-radius: 0 !important;\n}\n","// stylelint-disable declaration-no-important\n\n//\n// Utilities for common `display` values\n//\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @each $value in $displays {\n      .d#{$infix}-#{$value} { display: $value !important; }\n    }\n  }\n}\n\n\n//\n// Utilities for toggling `display` in print\n//\n\n@media print {\n  @each $value in $displays {\n    .d-print-#{$value} { display: $value !important; }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.embed-responsive {\n  position: relative;\n  display: block;\n  width: 100%;\n  padding: 0;\n  overflow: hidden;\n\n  &::before {\n    display: block;\n    content: \"\";\n  }\n\n  .embed-responsive-item,\n  iframe,\n  embed,\n  object,\n  video {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    border: 0;\n  }\n}\n\n@each $embed-responsive-aspect-ratio in $embed-responsive-aspect-ratios {\n  $embed-responsive-aspect-ratio-x: nth($embed-responsive-aspect-ratio, 1);\n  $embed-responsive-aspect-ratio-y: nth($embed-responsive-aspect-ratio, 2);\n\n  .embed-responsive-#{$embed-responsive-aspect-ratio-x}by#{$embed-responsive-aspect-ratio-y} {\n    &::before {\n      padding-top: percentage(divide($embed-responsive-aspect-ratio-y, $embed-responsive-aspect-ratio-x));\n    }\n  }\n}\n","// stylelint-disable declaration-no-important\n\n// Flex variation\n//\n// Custom styles for additional flex alignment options.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .flex#{$infix}-row            { flex-direction: row !important; }\n    .flex#{$infix}-column         { flex-direction: column !important; }\n    .flex#{$infix}-row-reverse    { flex-direction: row-reverse !important; }\n    .flex#{$infix}-column-reverse { flex-direction: column-reverse !important; }\n\n    .flex#{$infix}-wrap         { flex-wrap: wrap !important; }\n    .flex#{$infix}-nowrap       { flex-wrap: nowrap !important; }\n    .flex#{$infix}-wrap-reverse { flex-wrap: wrap-reverse !important; }\n    .flex#{$infix}-fill         { flex: 1 1 auto !important; }\n    .flex#{$infix}-grow-0       { flex-grow: 0 !important; }\n    .flex#{$infix}-grow-1       { flex-grow: 1 !important; }\n    .flex#{$infix}-shrink-0     { flex-shrink: 0 !important; }\n    .flex#{$infix}-shrink-1     { flex-shrink: 1 !important; }\n\n    .justify-content#{$infix}-start   { justify-content: flex-start !important; }\n    .justify-content#{$infix}-end     { justify-content: flex-end !important; }\n    .justify-content#{$infix}-center  { justify-content: center !important; }\n    .justify-content#{$infix}-between { justify-content: space-between !important; }\n    .justify-content#{$infix}-around  { justify-content: space-around !important; }\n\n    .align-items#{$infix}-start    { align-items: flex-start !important; }\n    .align-items#{$infix}-end      { align-items: flex-end !important; }\n    .align-items#{$infix}-center   { align-items: center !important; }\n    .align-items#{$infix}-baseline { align-items: baseline !important; }\n    .align-items#{$infix}-stretch  { align-items: stretch !important; }\n\n    .align-content#{$infix}-start   { align-content: flex-start !important; }\n    .align-content#{$infix}-end     { align-content: flex-end !important; }\n    .align-content#{$infix}-center  { align-content: center !important; }\n    .align-content#{$infix}-between { align-content: space-between !important; }\n    .align-content#{$infix}-around  { align-content: space-around !important; }\n    .align-content#{$infix}-stretch { align-content: stretch !important; }\n\n    .align-self#{$infix}-auto     { align-self: auto !important; }\n    .align-self#{$infix}-start    { align-self: flex-start !important; }\n    .align-self#{$infix}-end      { align-self: flex-end !important; }\n    .align-self#{$infix}-center   { align-self: center !important; }\n    .align-self#{$infix}-baseline { align-self: baseline !important; }\n    .align-self#{$infix}-stretch  { align-self: stretch !important; }\n  }\n}\n","// stylelint-disable declaration-no-important\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .float#{$infix}-left  { float: left !important; }\n    .float#{$infix}-right { float: right !important; }\n    .float#{$infix}-none  { float: none !important; }\n  }\n}\n","// stylelint-disable declaration-no-important\n\n@each $value in $user-selects {\n  .user-select-#{$value} { user-select: $value !important; }\n}\n","// stylelint-disable declaration-no-important\n\n@each $value in $overflows {\n  .overflow-#{$value} { overflow: $value !important; }\n}\n","// stylelint-disable declaration-no-important\n\n// Common values\n@each $position in $positions {\n  .position-#{$position} { position: $position !important; }\n}\n\n// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.sticky-top {\n  @supports (position: sticky) {\n    position: sticky;\n    top: 0;\n    z-index: $zindex-sticky;\n  }\n}\n","//\n// Screenreaders\n//\n\n.sr-only {\n  @include sr-only();\n}\n\n.sr-only-focusable {\n  @include sr-only-focusable();\n}\n","// Only display content to screen readers\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin sr-only() {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n// Use in conjunction with .sr-only to only display content when it's focused.\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\n//\n// Credit: HTML5 Boilerplate\n\n@mixin sr-only-focusable() {\n  &:active,\n  &:focus {\n    position: static;\n    width: auto;\n    height: auto;\n    overflow: visible;\n    clip: auto;\n    white-space: normal;\n  }\n}\n","// stylelint-disable declaration-no-important\n\n.shadow-sm { box-shadow: $box-shadow-sm !important; }\n.shadow { box-shadow: $box-shadow !important; }\n.shadow-lg { box-shadow: $box-shadow-lg !important; }\n.shadow-none { box-shadow: none !important; }\n","// stylelint-disable declaration-no-important\n\n// Width and height\n\n@each $prop, $abbrev in (width: w, height: h) {\n  @each $size, $length in $sizes {\n    .#{$abbrev}-#{$size} { #{$prop}: $length !important; }\n  }\n}\n\n.mw-100 { max-width: 100% !important; }\n.mh-100 { max-height: 100% !important; }\n\n// Viewport additional helpers\n\n.min-vw-100 { min-width: 100vw !important; }\n.min-vh-100 { min-height: 100vh !important; }\n\n.vw-100 { width: 100vw !important; }\n.vh-100 { height: 100vh !important; }\n","// stylelint-disable declaration-no-important\n\n// Margin and Padding\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @each $prop, $abbrev in (margin: m, padding: p) {\n      @each $size, $length in $spacers {\n        .#{$abbrev}#{$infix}-#{$size} { #{$prop}: $length !important; }\n        .#{$abbrev}t#{$infix}-#{$size},\n        .#{$abbrev}y#{$infix}-#{$size} {\n          #{$prop}-top: $length !important;\n        }\n        .#{$abbrev}r#{$infix}-#{$size},\n        .#{$abbrev}x#{$infix}-#{$size} {\n          #{$prop}-right: $length !important;\n        }\n        .#{$abbrev}b#{$infix}-#{$size},\n        .#{$abbrev}y#{$infix}-#{$size} {\n          #{$prop}-bottom: $length !important;\n        }\n        .#{$abbrev}l#{$infix}-#{$size},\n        .#{$abbrev}x#{$infix}-#{$size} {\n          #{$prop}-left: $length !important;\n        }\n      }\n    }\n\n    // Negative margins (e.g., where `.mb-n1` is negative version of `.mb-1`)\n    @each $size, $length in $spacers {\n      @if \"#{$size}\" != \"0\" {\n        .m#{$infix}-n#{$size} { margin: -$length !important; }\n        .mt#{$infix}-n#{$size},\n        .my#{$infix}-n#{$size} {\n          margin-top: -$length !important;\n        }\n        .mr#{$infix}-n#{$size},\n        .mx#{$infix}-n#{$size} {\n          margin-right: -$length !important;\n        }\n        .mb#{$infix}-n#{$size},\n        .my#{$infix}-n#{$size} {\n          margin-bottom: -$length !important;\n        }\n        .ml#{$infix}-n#{$size},\n        .mx#{$infix}-n#{$size} {\n          margin-left: -$length !important;\n        }\n      }\n    }\n\n    // Some special margin utils\n    .m#{$infix}-auto { margin: auto !important; }\n    .mt#{$infix}-auto,\n    .my#{$infix}-auto {\n      margin-top: auto !important;\n    }\n    .mr#{$infix}-auto,\n    .mx#{$infix}-auto {\n      margin-right: auto !important;\n    }\n    .mb#{$infix}-auto,\n    .my#{$infix}-auto {\n      margin-bottom: auto !important;\n    }\n    .ml#{$infix}-auto,\n    .mx#{$infix}-auto {\n      margin-left: auto !important;\n    }\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::after {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 1;\n    // Just in case `pointer-events: none` is set on a parent\n    pointer-events: auto;\n    content: \"\";\n    // IE10 bugfix, see https://stackoverflow.com/questions/16947967/ie10-hover-pseudo-class-doesnt-work-without-background-color\n    background-color: rgba(0, 0, 0, 0);\n  }\n}\n","// stylelint-disable declaration-no-important\n\n//\n// Text\n//\n\n.text-monospace { font-family: $font-family-monospace !important; }\n\n// Alignment\n\n.text-justify  { text-align: justify !important; }\n.text-wrap     { white-space: normal !important; }\n.text-nowrap   { white-space: nowrap !important; }\n.text-truncate { @include text-truncate(); }\n\n// Responsive alignment\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .text#{$infix}-left   { text-align: left !important; }\n    .text#{$infix}-right  { text-align: right !important; }\n    .text#{$infix}-center { text-align: center !important; }\n  }\n}\n\n// Transformation\n\n.text-lowercase  { text-transform: lowercase !important; }\n.text-uppercase  { text-transform: uppercase !important; }\n.text-capitalize { text-transform: capitalize !important; }\n\n// Weight and italics\n\n.font-weight-light   { font-weight: $font-weight-light !important; }\n.font-weight-lighter { font-weight: $font-weight-lighter !important; }\n.font-weight-normal  { font-weight: $font-weight-normal !important; }\n.font-weight-bold    { font-weight: $font-weight-bold !important; }\n.font-weight-bolder  { font-weight: $font-weight-bolder !important; }\n.font-italic         { font-style: italic !important; }\n\n// Contextual colors\n\n.text-white { color: $white !important; }\n\n@each $color, $value in $theme-colors {\n  @include text-emphasis-variant(\".text-#{$color}\", $value, true);\n}\n\n.text-body { color: $body-color !important; }\n.text-muted { color: $text-muted !important; }\n\n.text-black-50 { color: rgba($black, .5) !important; }\n.text-white-50 { color: rgba($white, .5) !important; }\n\n// Misc\n\n.text-hide {\n  @include text-hide($ignore-warning: true);\n}\n\n.text-decoration-none { text-decoration: none !important; }\n\n.text-break {\n  word-break: break-word !important; // Deprecated, but avoids issues with flex containers\n  word-wrap: break-word !important; // Used instead of `overflow-wrap` for IE & Edge Legacy\n}\n\n// Reset\n\n.text-reset { color: inherit !important; }\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n","// stylelint-disable declaration-no-important\n\n// Typography\n\n@mixin text-emphasis-variant($parent, $color, $ignore-warning: false) {\n  #{$parent} {\n    color: $color !important;\n  }\n  @if $emphasized-link-hover-darken-percentage != 0 {\n    a#{$parent} {\n      @include hover-focus() {\n        color: darken($color, $emphasized-link-hover-darken-percentage) !important;\n      }\n    }\n  }\n  @include deprecate(\"`text-emphasis-variant()`\", \"v4.4.0\", \"v5\", $ignore-warning);\n}\n","// CSS image replacement\n@mixin text-hide($ignore-warning: false) {\n  // stylelint-disable-next-line font-family-no-missing-generic-family-keyword\n  font: 0/0 a;\n  color: transparent;\n  text-shadow: none;\n  background-color: transparent;\n  border: 0;\n\n  @include deprecate(\"`text-hide()`\", \"v4.1.0\", \"v5\", $ignore-warning);\n}\n","// stylelint-disable declaration-no-important\n\n//\n// Visibility utilities\n//\n\n.visible {\n  visibility: visible !important;\n}\n\n.invisible {\n  visibility: hidden !important;\n}\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type\n\n// Source: https://github.com/h5bp/main.css/blob/master/src/_print.css\n\n// ==========================================================================\n// Print styles.\n// Inlined to avoid the additional HTTP request:\n// https://www.phpied.com/delay-loading-your-print-css/\n// ==========================================================================\n\n@if $enable-print-styles {\n  @media print {\n    *,\n    *::before,\n    *::after {\n      // Bootstrap specific; comment out `color` and `background`\n      //color: $black !important; // Black prints faster\n      text-shadow: none !important;\n      //background: transparent !important;\n      box-shadow: none !important;\n    }\n\n    a {\n      &:not(.btn) {\n        text-decoration: underline;\n      }\n    }\n\n    // Bootstrap specific; comment the following selector out\n    //a[href]::after {\n    //  content: \" (\" attr(href) \")\";\n    //}\n\n    abbr[title]::after {\n      content: \" (\" attr(title) \")\";\n    }\n\n    // Bootstrap specific; comment the following selector out\n    //\n    // Don't show links that are fragment identifiers,\n    // or use the `javascript:` pseudo protocol\n    //\n\n    //a[href^=\"#\"]::after,\n    //a[href^=\"javascript:\"]::after {\n    // content: \"\";\n    //}\n\n    pre {\n      white-space: pre-wrap !important;\n    }\n    pre,\n    blockquote {\n      border: $border-width solid $gray-500; // Bootstrap custom code; using `$border-width` instead of 1px\n      page-break-inside: avoid;\n    }\n\n    tr,\n    img {\n      page-break-inside: avoid;\n    }\n\n    p,\n    h2,\n    h3 {\n      orphans: 3;\n      widows: 3;\n    }\n\n    h2,\n    h3 {\n      page-break-after: avoid;\n    }\n\n    // Bootstrap specific changes start\n\n    // Specify a size and min-width to make printing closer across browsers.\n    // We don't set margin here because it breaks `size` in Chrome. We also\n    // don't use `!important` on `size` as it breaks in Chrome.\n    @page {\n      size: $print-page-size;\n    }\n    body {\n      min-width: $print-body-min-width !important;\n    }\n    .container {\n      min-width: $print-body-min-width !important;\n    }\n\n    // Bootstrap components\n    .navbar {\n      display: none;\n    }\n    .badge {\n      border: $border-width solid $black;\n    }\n\n    .table {\n      border-collapse: collapse !important;\n\n      td,\n      th {\n        background-color: $white !important;\n      }\n    }\n\n    .table-bordered {\n      th,\n      td {\n        border: 1px solid $gray-300 !important;\n      }\n    }\n\n    .table-dark {\n      color: inherit;\n\n      th,\n      td,\n      thead th,\n      tbody + tbody {\n        border-color: $table-border-color;\n      }\n    }\n\n    .table .thead-dark th {\n      color: inherit;\n      border-color: $table-border-color;\n    }\n\n    // Bootstrap specific changes end\n  }\n}\n","// \n// accordions.scss\n//\n\n.custom-accordionwitharrow {\n    .card {\n        +.card {\n            margin-top: 0.5rem;\n        }\n        .card-header{\n            background-color: transparent;\n        }\n    }\n\n    .accordion-arrow {\n        font-size: 1.2rem;\n    }\n\n    a {\n        &.collapsed {\n            i.accordion-arrow {\n                &:before {\n                    content: \"\\e831\";\n                }\n            }\n        }\n    }\n}\n\n// Custom Accordion\n\n.custom-accordion {\n    .card {\n        overflow: visible;\n        border-color: transparent !important;\n        border-left: 2px dashed $gray-300 !important;\n        box-shadow: none;\n        padding-left: 40px;\n\n        .card-header {\n            border-radius: 7px !important;\n\n            &:before {\n                content: \"\";\n                position: absolute;\n                left: 6px;\n                top: 22px;\n                width: 42px;\n                height: 2px;\n                background: $gray-300;\n            }\n        }\n\n        .icon {\n            position: absolute;\n            left: -18px;\n            top: -2px;\n        }\n    }\n}","// \n// badge.scss\n//\n.badge-soft {\n    color: $gray-800;\n}\n\n// badge soft\n\n@mixin badge-soft-variant($bg) {\n    background-color: rgba($bg, 0.2);\n    color: $bg !important;\n}\n\n@each $color, $value in $theme-colors {\n    .badge-soft-#{$color} {\n      @include badge-soft-variant($value);\n    }\n}","// \n// backgrounds.scss\n//\n\n\n@each $color,\n$value in $theme-colors {\n    .bg-soft-#{$color} {\n        background-color: rgba(($value), 0.25) !important;\n    }\n}\n\n// Gradient\n.bg-gradient {\n    background: $bg-gradient;\n}\n","\n// \n// breadcrumb.scss\n//\n\n\n// Breadcrumb item arrow\n.breadcrumb-item {\n    +.breadcrumb-item {\n        &::before {\n            font-family: \"unicons\";\n        }\n    }\n}\n  ","// \n// buttons.scss\n//\n\n.btn {\n    color: $white;\n    \n\n    &:focus {\n        box-shadow: none;\n    }\n\n    .icon {\n        svg {\n            width: 1rem;\n            height: 1rem;\n            margin-left: 0.1rem;\n            margin-top: -2px;\n        }\n    }\n}\n\n.btn-rounded {\n    border-radius: 2em;\n}\n\n//\n// light button\n// \n.btn-light,.btn-white {\n    color: $gray-900;\n}\n\n.btn-white {\n    border-color: $gray-300;\n\n    @include hover-focus {\n        background-color: $gray-300;\n        border-color: $gray-400;\n    }\n}\n//\n// Link buttons\n//\n// Make a button look and behave like a link\n.btn-link {\n    font-weight: $font-weight-normal;\n    color: $link-color;\n    background-color: transparent;\n    @include hover {\n        color: $link-hover-color;\n        text-decoration: $link-hover-decoration;\n        background-color: transparent;\n        border-color: transparent;\n    }\n    &:focus,\n    &.focus {\n        text-decoration: $link-hover-decoration;\n        border-color: transparent;\n        box-shadow: none;\n    }\n    &:disabled,\n    &.disabled {\n        color: $btn-link-disabled-color;\n        pointer-events: none;\n    } // No need for an active state here\n} \n\n\n// \n// Button Extra Small Size\n// \n\n.btn-xs {\n    padding: .2rem .6rem;\n    font-size: .75rem;\n    border-radius: .15rem;\n}\n\n// Soft variants\n@mixin btn-variant-soft($bg, $color) {\n    background-color: rgba($bg, $btn-soft-bg-opacity);\n    color: $color;\n    border-color: rgba($color, $btn-soft-bg-opacity);\n\n    &:focus {\n        box-shadow: none;\n    }\n\n    @include hover-focus {\n        background-color: fade-in(rgba($bg, $btn-soft-bg-opacity), .05);\n        color: $color;\n    }\n}\n\n@each $color, $value in $theme-colors {\n    .btn-soft-#{$color} {\n        @include btn-variant-soft($value, $value);\n    }\n}\n\n//\n// Alternate buttons\n//\n@each $color,\n$value in $theme-colors {\n    .btn-outline-#{$color} {\n        @include button-outline-variant($value);\n        &:focus {\n            box-shadow: none;\n        }\n    }\n}","// \n// card.scss\n//\n\n.card {\n    margin-bottom: $grid-gutter-width;\n    box-shadow: $box-shadow-sm;\n    border-radius: 10px;\n    background-color: $card-bg;\n}\n\n.card-drop {\n    display: inline-block;\n    font-size: 20px;\n    line-height: 30px;\n    color: inherit;\n    height: 30px;\n    width: 30px;\n    border-radius: 50%;\n    text-align: center;\n    margin-top: -6px;\n    &:hover {\n        background-color: $gray-200;\n        color: $dark;\n    }\n}\n\n\n// Card title / Card Header\n.card-title,\n.card-header {\n    margin-top: 0;\n}\n\n.card-nav {\n    margin: -0.5rem 0;\n}\n\n// Custom card box\n.card-box {\n    background-color: $card-bg;\n    padding: $card-spacer-x;\n    box-shadow: $box-shadow-sm;\n    margin-bottom: $grid-gutter-width;\n    @include border-radius($card-border-radius);\n}\n\n.header-title {\n    font-size: 1.04rem;\n    font-weight: 700;\n}\n\n.sub-header {\n    margin-bottom: $grid-gutter-width;\n    color: $gray-600;\n}","// \n// dropdown.scss\n//\n\n.dropdown-menu {\n    box-shadow: $box-shadow;\n    animation-name: DropDownSlide;\n    animation-duration: .3s;\n    animation-fill-mode: both;\n    margin: 0;\n    font-size: $font-size-base;\n    position: absolute;\n    z-index: 1000;\n\n    &.show {\n        top: 100%!important;\n    }\n}\n\n.dropdown-menu-right {\n    right: 0!important;\n    left: auto!important;\n}\n\n.dropdown-menu[x-placement^=right],.dropdown-menu[x-placement^=top],.dropdown-menu[x-placement^=left]{\n    top: auto !important;\n    animation: none !important;\n}\n\n@keyframes DropDownSlide {\n    100% {\n        -webkit-transform: translateY(0);\n        transform: translateY(0)\n    }\n    0% {\n        -webkit-transform: translateY(-20px);\n        transform: translateY(-20px)\n    }\n}\n\n\n// Dropdown Large (Custom)\n.dropdown-lg {\n    width: $dropdown-lg-width;\n}\n\n@include media-breakpoint-down(sm) {\n    .dropdown-lg {\n        width: 200px !important;\n    }\n}\n\n.drop-ani-none {\n    .dropdown-menu{\n        top: 0 !important;\n        animation: none !important;\n    }\n}\n","//\n// forms.scss\n//\n\n// Form-control light\n.form-control-light {\n    background-color: $gray-100;\n    border-color: $gray-100;\n}\n\n\n// Form elements (Color and Range)\ninput.form-control[type=\"color\"],\ninput.form-control[type=\"range\"] {\n    min-height: 39px;\n}\n\n\n// Custom select\n.custom-select.is-invalid, .form-control.is-invalid,.custom-select:invalid, .form-control:invalid,\n.custom-select.is-valid, .form-control.is-valid, .custom-select:valid,.form-control:valid {\n    &:focus {\n        box-shadow: none !important;\n    }\n}\n\n// Comment box\n.comment-area-box {\n    .form-control {\n        border-color: $gray-300;\n        border-radius: $input-border-radius $input-border-radius 0 0;\n    }\n    .comment-area-btn {\n        background-color: $gray-100;\n        padding: 10px;\n        border: 1px solid $gray-300;\n        border-top: none;\n        border-radius: 0 0 $input-border-radius $input-border-radius;\n    }\n}\n\n// Input\ninput {\n    &:focus {\n        outline: none;\n    }\n}","// \n// modal.scss\n//\n\n\n// Title text within header\n.modal-title {\n    margin-top: 0;\n}\n\n// Full modal\n.modal-full {\n    width: 92%;\n    max-width: none;\n}\n\n// Custom animation modal\n.modal-demo {\n    background-color: $white;\n    width: 600px !important;\n    border-radius: 4px;\n    display: none;\n    position: relative;\n    .close {\n        position: absolute;\n        top: 15px;\n        right: 25px;\n        color: $light;\n    }\n}\n\n@media (max-width: 768px) {\n    .modal-demo {\n        width: 96% !important;\n    }\n}\n\n.custom-modal-title {\n    padding: 15px 25px 15px 25px;\n    line-height: 22px;\n    font-size: 18px;\n    background-color: $dark;\n    color: $white;\n    text-align: left;\n    margin: 0;\n}\n\n.custom-modal-text {\n    padding: 20px;\n}\n\n.custombox-modal-wrapper {\n    text-align: left;\n}\n\n.custombox-modal-flash,\n.custombox-modal-rotatedown {\n    .close {\n        top: 20px;\n        z-index: 9999;\n    }\n}","// \n// nav.scss\n//\n\n\n// Bootstrap override - turn nav tab with broder\n\n.nav-tabs {\n    border-bottom: 2px solid rgba($gray-600, 0.2);\n\n    .nav-item {\n        margin-bottom: -2px;\n    }\n\n    li {\n        a {\n            border-color: transparent !important;\n            padding: 0.625rem 1.25rem;\n        }\n        a.active {\n            border-bottom: 2px solid $primary !important;\n        }\n    }\n}\n\n// pills\n.nav-tabs,.nav-pills {\n    > li {\n        > a {\n            color: $gray-700;\n            font-weight: $font-weight-bold;\n        }\n    }\n}\n\n.nav-pills {\n    background: $body-bg;\n    border-radius: $border-radius;\n    padding: 6px 2px;\n\n    .nav-link {\n        background-color: transparent;\n        color: $body-color;\n    }\n\n    .nav-link.active,\n    .show>.nav-link {\n        color: $body-color;\n        background-color: $card-bg;\n        box-shadow: $box-shadow-sm;\n    }\n}\n\n\n//Navtab custom\n.navtab-bg {\n    li {\n        >a {\n            background-color: $gray-300;\n            margin: 0 5px;\n        }\n    }\n}\n\n.tab-content {\n    // padding: 20px 0 0 0;\n}  ","// \n// pagination.scss\n//\n\n\n// Pagination rounded (Custom)\n.pagination-rounded {\n  .page-link {\n    border-radius: 30px !important;\n    margin: 0 3px;\n    border: none;\n  }\n}","// \n// popover.scss\n//\n\n.popover-header {\n    margin-top: 0;\n}","// \n// progress.scss\n//\n\n// Custom height\n\n// Progress height small\n.progress-sm {\n  height: 5px;\n}\n\n\n// Progress height medium\n.progress-md {\n  height: 8px;\n}\n\n\n// Progress height large\n.progress-lg {\n  height: 12px;\n}\n\n// Progress height extra large\n.progress-xl {\n  height: 15px;\n}\n\n// Progress height dubble extra large\n.progress-xxl {\n  height: 25px;\n}\n\n\n/* Progressbar Vertical */\n.progress-vertical {\n  min-height: 250px;\n  height: 250px;\n  width: 10px;\n  position: relative;\n  display: inline-block;\n  margin-bottom: 0;\n  margin-right: 20px;\n\n  .progress-bar {\n    width: 100%;\n  }\n\n  &.progress-xl {\n    width: 15px;\n  }\n\n  &.progress-lg {\n    width: 12px;\n  }\n\n  &.progress-md {\n    width: 8px;\n  }\n\n  &.progress-sm {\n    width: 5px;\n  }\n}\n\n.progress-vertical-bottom {\n  min-height: 250px;\n  height: 250px;\n  position: relative;\n  width: 10px;\n  display: inline-block;\n  margin-bottom: 0;\n  margin-right: 20px;\n\n  .progress-bar {\n    width: 100%;\n    bottom: 0;\n    position: absolute;\n  }\n\n  &.progress-xl {\n    width: 15px;\n  }\n\n  &.progress-lg {\n    width: 12px;\n  }\n\n  &.progress-md {\n    width: 8px;\n  }\n\n  &.progress-sm {\n    width: 5px;\n  }\n}\n\n// Progress with percentage\n\n.progress-w-percent {\n  min-height: 20px;\n  margin-bottom: 20px;\n\n  .progress {\n    width: 80%;\n    float: left;\n    margin-top: 8px;\n  }\n\n  .progress-value {\n    width: 20%;\n    float: right;\n    text-align: right;\n    line-height: 20px;\n  }\n}","//\n// reboot.scss\n//\n\n\n// a\n\na {\n  text-decoration: none !important;\n\n  &:focus {\n    outline: none;\n  }\n}\n\n// Forms\nlabel {\n  font-weight: $font-weight-semibold;\n}\n\n// Buttons\nbutton:focus {\n  outline: none;\n}\n\n// blockquote\n\n.blockquote{\n  padding: 10px 20px;\n  margin-bottom: 20px;\n  border-left: 4px solid $gray-200;\n  \n  &.blockquote-reverse{\n    border-left: 0;\n    border-right: 4px solid $gray-200;\n    text-align: right;\n  }\n}\n\n\n// Icons\n.icon-dual {\n  color: $gray-600;\n  fill: rgba($gray-600, 0.12);\n}\n\n@each $color, $value in $theme-colors {\n  .icon-dual-#{$color} {\n    color: $value;\n    fill: rgba($value, 0.16);\n  }\n}\n\n.icon-xs {\n  height: 16px;\n  width: 16px;\n}\n\n.icon-lg {\n  height: 32px;\n  width: 32px;\n}\n\n.icon-xl {\n  height: 48px;\n  width: 48px;\n}\n\n.icon-xxl {\n  height: 72px;\n  width: 72px;\n}","// \n// tables.scss\n//\n\n\n//Table centered (Custom)\n.table-centered {\n    td,th {\n        vertical-align: middle !important;\n    }\n}\n\n\n// Custom table components (Custom)\n.table {\n    th {\n        font-weight: $font-weight-bold;\n    }\n    .table-user {\n        img {\n            height: 30px;\n            width: 30px;\n        }\n    }\n}\n\n.action-icon {\n    color: $gray-600;\n    font-size: 1.2rem;\n    display: inline-block;\n    padding: 0 3px;\n\n    &:hover {\n        color: $gray-700;\n    }\n}\n\n// Tables fluid\n.table-nowrap {\n    th, td {\n      white-space: nowrap;\n    }\n}","// \n// type.scss\n//\n\n.h1,\n.h2,\n.h3,\n.h4,\n.h5,\n.h6,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n    margin: 10px 0;\n    font-family: $font-family-secondary;\n    color: $gray-700;\n    font-weight: $font-weight-semibold;\n}\n\np {\n    line-height: 1.6;\n}\n\n// Font sizes (Custom)\n.font-size-11 {\n    font-size: 11px !important;\n}\n\n.font-size-12 {\n    font-size: 12px !important;\n}\n\n.font-size-13 {\n    font-size: 13px !important;\n}\n\n.font-size-14 {\n    font-size: 14px !important;\n}\n\n.font-size-15 {\n    font-size: 15px !important;\n}\n\n.font-size-16 {\n    font-size: 16px !important;\n}\n\n.font-size-17 {\n    font-size: 17px !important;\n}\n\n.font-size-18 {\n    font-size: 18px !important;\n}\n\n.font-size-19 {\n    font-size: 19px !important;\n}\n\n.font-size-20 {\n    font-size: 20px !important;\n}\n\n.font-size-22 {\n    font-size: 22px !important;\n}\n\n.font-size-24 {\n    font-size: 24px !important;\n}\n\n// text utilies\n.text-unline-dashed {\n    border-bottom: $gray-400 1px dashed !important;\n    padding-bottom: 1px;\n}","@font-face {\n  font-family: 'unicons';\n  src: url('./fonts/unicons.eot?2256574');\n  src: url('./fonts/unicons.eot?2256574#iefix') format('embedded-opentype'),\n  url('./fonts/unicons.woff2?2256574') format('woff2'),\n  url('./fonts/unicons.woff?2256574') format('woff'),\n  url('./fonts/unicons.ttf?2256574') format('truetype'),\n  url('./fonts/unicons.svg?2256574#unicons') format('svg');\n  font-weight: normal;\n  font-style: normal;\n}\n\n/* Chrome hack: SVG is rendered more smooth in Windozze. 100% magic, uncomment if you need it. */\n/* Note, that will break hinting! In other OS-es font will be not as sharp as it could be */\n/*\n@media screen and (-webkit-min-device-pixel-ratio:0) {\n  @font-face {\n    font-family: 'unicons';\n    src: url('./ts/unicons.svg?2256574#unicons') format('svg');\n  }\n}\n*/\n\n.uil {\n  line-height: inherit;\n}\n\n[class^=\"uil-\"]:before, [class*=\" uil-\"]:before {\n  font-family: \"unicons\";\n  font-style: normal;\n  font-weight: normal;\n  speak: none;\n\n  display: inline-block;\n  text-decoration: inherit;\n  width: 1em;\n  // margin-right: .2em;\n  text-align: center;\n  /* opacity: .8; */\n\n  /* For safety - reset parent styles, that can break glyph codes*/\n  font-variant: normal;\n  text-transform: none;\n\n  /* fix buttons height, for twitter bootstrap */\n  line-height: 1em;\n\n  /* Animation center compensation - margins should be symmetric */\n  /* remove if not needed */\n  // margin-left: .2em;\n\n  /* you can be more comfortable with increased icons size */\n  font-size: 120%;\n\n  /* Font smoothing. That was taken from TWBS */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n\n  /* Uncomment for 3D effect */\n  /* text-shadow: 1px 1px 1px rgba(127, 127, 127, 0.3); */\n}\n\n.uil-0-plus:before {\n  content: '\\e800';\n}\n\n/* '' */\n.uil-10-plus:before {\n  content: '\\e801';\n}\n\n/* '' */\n.uil-12-plus:before {\n  content: '\\e802';\n}\n\n/* '' */\n.uil-13-plus:before {\n  content: '\\e803';\n}\n\n/* '' */\n.uil-16-plus:before {\n  content: '\\e804';\n}\n\n/* '' */\n.uil-17-plus:before {\n  content: '\\e805';\n}\n\n/* '' */\n.uil-18-plus:before {\n  content: '\\e806';\n}\n\n/* '' */\n.uil-21-plus:before {\n  content: '\\e807';\n}\n\n/* '' */\n.uil-3-plus:before {\n  content: '\\e808';\n}\n\n/* '' */\n.uil-500px:before {\n  content: '\\e809';\n}\n\n/* '' */\n.uil-6-plus:before {\n  content: '\\e80a';\n}\n\n/* '' */\n.uil-abacus:before {\n  content: '\\e80b';\n}\n\n/* '' */\n.uil-accessible-icon-alt:before {\n  content: '\\e80c';\n}\n\n/* '' */\n.uil-adjust-alt:before {\n  content: '\\e80d';\n}\n\n/* '' */\n.uil-adjust-circle:before {\n  content: '\\e80e';\n}\n\n/* '' */\n.uil-adjust-half:before {\n  content: '\\e80f';\n}\n\n/* '' */\n.uil-adjust:before {\n  content: '\\e810';\n}\n\n/* '' */\n.uil-adobe-alt:before {\n  content: '\\e811';\n}\n\n/* '' */\n.uil-adobe:before {\n  content: '\\e812';\n}\n\n/* '' */\n.uil-airplay:before {\n  content: '\\e813';\n}\n\n/* '' */\n.uil-align-alt:before {\n  content: '\\e814';\n}\n\n/* '' */\n.uil-align-center-alt:before {\n  content: '\\e815';\n}\n\n/* '' */\n.uil-align-center-h:before {\n  content: '\\e816';\n}\n\n/* '' */\n.uil-align-center-justify:before {\n  content: '\\e817';\n}\n\n/* '' */\n.uil-align-center-v:before {\n  content: '\\e818';\n}\n\n/* '' */\n.uil-align-center:before {\n  content: '\\e819';\n}\n\n/* '' */\n.uil-align-justify:before {\n  content: '\\e81a';\n}\n\n/* '' */\n.uil-align-left-justify:before {\n  content: '\\e81b';\n}\n\n/* '' */\n.uil-align-left:before {\n  content: '\\e81c';\n}\n\n/* '' */\n.uil-align-letter-right:before {\n  content: '\\e81d';\n}\n\n/* '' */\n.uil-align-right-justify:before {\n  content: '\\e81e';\n}\n\n/* '' */\n.uil-align-right:before {\n  content: '\\e81f';\n}\n\n/* '' */\n.uil-align:before {\n  content: '\\e820';\n}\n\n/* '' */\n.uil-amazon:before {\n  content: '\\e821';\n}\n\n/* '' */\n.uil-ambulance:before {\n  content: '\\e822';\n}\n\n/* '' */\n.uil-analysis:before {\n  content: '\\e823';\n}\n\n/* '' */\n.uil-analytics:before {\n  content: '\\e824';\n}\n\n/* '' */\n.uil-anchor:before {\n  content: '\\e825';\n}\n\n/* '' */\n.uil-android-alt:before {\n  content: '\\e826';\n}\n\n/* '' */\n.uil-android-phone-slash:before {\n  content: '\\e827';\n}\n\n/* '' */\n.uil-android:before {\n  content: '\\e828';\n}\n\n/* '' */\n.uil-angle-double-down:before {\n  content: '\\e829';\n}\n\n/* '' */\n.uil-angle-double-left:before {\n  content: '\\e82a';\n}\n\n/* '' */\n.uil-angle-double-right:before {\n  content: '\\e82b';\n}\n\n/* '' */\n.uil-angle-double-up:before {\n  content: '\\e82c';\n}\n\n/* '' */\n.uil-angle-down:before {\n  content: '\\e82d';\n}\n\n/* '' */\n.uil-angle-left:before {\n  content: '\\e82e';\n}\n\n/* '' */\n.uil-angle-right-b:before {\n  content: '\\e82f';\n}\n\n/* '' */\n.uil-angle-right:before {\n  content: '\\e830';\n}\n\n/* '' */\n.uil-angle-up:before {\n  content: '\\e831';\n}\n\n/* '' */\n.uil-angry:before {\n  content: '\\e832';\n}\n\n/* '' */\n.uil-ankh:before {\n  content: '\\e833';\n}\n\n/* '' */\n.uil-annoyed-alt:before {\n  content: '\\e834';\n}\n\n/* '' */\n.uil-annoyed:before {\n  content: '\\e835';\n}\n\n/* '' */\n.uil-apple-alt:before {\n  content: '\\e836';\n}\n\n/* '' */\n.uil-apple:before {\n  content: '\\e837';\n}\n\n/* '' */\n.uil-apps:before {\n  content: '\\e838';\n}\n\n/* '' */\n.uil-archive-alt:before {\n  content: '\\e839';\n}\n\n/* '' */\n.uil-archive:before {\n  content: '\\e83a';\n}\n\n/* '' */\n.uil-archway:before {\n  content: '\\e83b';\n}\n\n/* '' */\n.uil-arrow-break:before {\n  content: '\\e83c';\n}\n\n/* '' */\n.uil-arrow-circle-down:before {\n  content: '\\e83d';\n}\n\n/* '' */\n.uil-arrow-circle-left:before {\n  content: '\\e83e';\n}\n\n/* '' */\n.uil-arrow-circle-right:before {\n  content: '\\e83f';\n}\n\n/* '' */\n.uil-arrow-circle-up:before {\n  content: '\\e840';\n}\n\n/* '' */\n.uil-arrow-compress-h:before {\n  content: '\\e841';\n}\n\n/* '' */\n.uil-arrow-down-left:before {\n  content: '\\e842';\n}\n\n/* '' */\n.uil-arrow-down-right:before {\n  content: '\\e843';\n}\n\n/* '' */\n.uil-arrow-down:before {\n  content: '\\e844';\n}\n\n/* '' */\n.uil-arrow-from-right:before {\n  content: '\\e845';\n}\n\n/* '' */\n.uil-arrow-from-top:before {\n  content: '\\e846';\n}\n\n/* '' */\n.uil-arrow-growth:before {\n  content: '\\e847';\n}\n\n/* '' */\n.uil-arrow-left:before {\n  content: '\\e848';\n}\n\n/* '' */\n.uil-arrow-random:before {\n  content: '\\e849';\n}\n\n/* '' */\n.uil-arrow-resize-diagonal:before {\n  content: '\\e84a';\n}\n\n/* '' */\n.uil-arrow-right:before {\n  content: '\\e84b';\n}\n\n/* '' */\n.uil-arrow-to-bottom:before {\n  content: '\\e84c';\n}\n\n/* '' */\n.uil-arrow-to-right:before {\n  content: '\\e84d';\n}\n\n/* '' */\n.uil-arrow-up-left:before {\n  content: '\\e84e';\n}\n\n/* '' */\n.uil-arrow-up-right:before {\n  content: '\\e84f';\n}\n\n/* '' */\n.uil-arrow-up:before {\n  content: '\\e850';\n}\n\n/* '' */\n.uil-arrows-h-alt:before {\n  content: '\\e851';\n}\n\n/* '' */\n.uil-arrows-h:before {\n  content: '\\e852';\n}\n\n/* '' */\n.uil-arrows-left-down:before {\n  content: '\\e853';\n}\n\n/* '' */\n.uil-arrows-maximize:before {\n  content: '\\e854';\n}\n\n/* '' */\n.uil-arrows-merge:before {\n  content: '\\e855';\n}\n\n/* '' */\n.uil-arrows-resize-h:before {\n  content: '\\e856';\n}\n\n/* '' */\n.uil-arrows-resize-v:before {\n  content: '\\e857';\n}\n\n/* '' */\n.uil-arrows-resize:before {\n  content: '\\e858';\n}\n\n/* '' */\n.uil-arrows-right-down:before {\n  content: '\\e859';\n}\n\n/* '' */\n.uil-arrows-shrink-h:before {\n  content: '\\e85a';\n}\n\n/* '' */\n.uil-arrows-shrink-v:before {\n  content: '\\e85b';\n}\n\n/* '' */\n.uil-arrows-up-right:before {\n  content: '\\e85c';\n}\n\n/* '' */\n.uil-arrows-v-alt:before {\n  content: '\\e85d';\n}\n\n/* '' */\n.uil-arrows-v:before {\n  content: '\\e85e';\n}\n\n/* '' */\n.uil-assistive-listening-systems:before {\n  content: '\\e85f';\n}\n\n/* '' */\n.uil-asterisk:before {\n  content: '\\e860';\n}\n\n/* '' */\n.uil-at:before {\n  content: '\\e861';\n}\n\n/* '' */\n.uil-atm-card:before {\n  content: '\\e862';\n}\n\n/* '' */\n.uil-atom:before {\n  content: '\\e863';\n}\n\n/* '' */\n.uil-auto-flash:before {\n  content: '\\e864';\n}\n\n/* '' */\n.uil-award-alt:before {\n  content: '\\e865';\n}\n\n/* '' */\n.uil-award:before {\n  content: '\\e866';\n}\n\n/* '' */\n.uil-baby-carriage:before {\n  content: '\\e867';\n}\n\n/* '' */\n.uil-backpack:before {\n  content: '\\e868';\n}\n\n/* '' */\n.uil-backspace:before {\n  content: '\\e869';\n}\n\n/* '' */\n.uil-backward:before {\n  content: '\\e86a';\n}\n\n/* '' */\n.uil-bag-alt:before {\n  content: '\\e86b';\n}\n\n/* '' */\n.uil-bag-slash:before {\n  content: '\\e86c';\n}\n\n/* '' */\n.uil-bag:before {\n  content: '\\e86d';\n}\n\n/* '' */\n.uil-balance-scale:before {\n  content: '\\e86e';\n}\n\n/* '' */\n.uil-ball:before {\n  content: '\\e86f';\n}\n\n/* '' */\n.uil-ban:before {\n  content: '\\e870';\n}\n\n/* '' */\n.uil-bars:before {\n  content: '\\e871';\n}\n\n/* '' */\n.uil-baseball-ball:before {\n  content: '\\e872';\n}\n\n/* '' */\n.uil-basketball-hoop:before {\n  content: '\\e873';\n}\n\n/* '' */\n.uil-basketball:before {\n  content: '\\e874';\n}\n\n/* '' */\n.uil-bath:before {\n  content: '\\e875';\n}\n\n/* '' */\n.uil-battery-bolt:before {\n  content: '\\e876';\n}\n\n/* '' */\n.uil-battery-empty:before {\n  content: '\\e877';\n}\n\n/* '' */\n.uil-bed-double:before {\n  content: '\\e878';\n}\n\n/* '' */\n.uil-bed:before {\n  content: '\\e879';\n}\n\n/* '' */\n.uil-behance-alt:before {\n  content: '\\e87a';\n}\n\n/* '' */\n.uil-behance:before {\n  content: '\\e87b';\n}\n\n/* '' */\n.uil-bell-school:before {\n  content: '\\e87c';\n}\n\n/* '' */\n.uil-bell-slash:before {\n  content: '\\e87d';\n}\n\n/* '' */\n.uil-bell:before {\n  content: '\\e87e';\n}\n\n/* '' */\n.uil-bill:before {\n  content: '\\e87f';\n}\n\n/* '' */\n.uil-bitcoin-alt:before {\n  content: '\\e880';\n}\n\n/* '' */\n.uil-bitcoin-bold:before {\n  content: '\\e881';\n}\n\n/* '' */\n.uil-bitcoin-circle:before {\n  content: '\\e882';\n}\n\n/* '' */\n.uil-bitcoin:before {\n  content: '\\e883';\n}\n\n/* '' */\n.uil-black-berry:before {\n  content: '\\e884';\n}\n\n/* '' */\n.uil-blogger-alt:before {\n  content: '\\e885';\n}\n\n/* '' */\n.uil-blogger:before {\n  content: '\\e886';\n}\n\n/* '' */\n.uil-bluetooth-b:before {\n  content: '\\e887';\n}\n\n/* '' */\n.uil-bold:before {\n  content: '\\e888';\n}\n\n/* '' */\n.uil-bolt-alt:before {\n  content: '\\e889';\n}\n\n/* '' */\n.uil-bolt-slash:before {\n  content: '\\e88a';\n}\n\n/* '' */\n.uil-bolt:before {\n  content: '\\e88b';\n}\n\n/* '' */\n.uil-book-alt:before {\n  content: '\\e88c';\n}\n\n/* '' */\n.uil-book-medical:before {\n  content: '\\e88d';\n}\n\n/* '' */\n.uil-book-open:before {\n  content: '\\e88e';\n}\n\n/* '' */\n.uil-book-reader:before {\n  content: '\\e88f';\n}\n\n/* '' */\n.uil-book:before {\n  content: '\\e890';\n}\n\n/* '' */\n.uil-bookmark-full:before {\n  content: '\\e891';\n}\n\n/* '' */\n.uil-bookmark:before {\n  content: '\\e892';\n}\n\n/* '' */\n.uil-books:before {\n  content: '\\e893';\n}\n\n/* '' */\n.uil-boombox:before {\n  content: '\\e894';\n}\n\n/* '' */\n.uil-border-alt:before {\n  content: '\\e895';\n}\n\n/* '' */\n.uil-border-bottom:before {\n  content: '\\e896';\n}\n\n/* '' */\n.uil-border-clear:before {\n  content: '\\e897';\n}\n\n/* '' */\n.uil-border-horizontal:before {\n  content: '\\e898';\n}\n\n/* '' */\n.uil-border-inner:before {\n  content: '\\e899';\n}\n\n/* '' */\n.uil-border-left:before {\n  content: '\\e89a';\n}\n\n/* '' */\n.uil-border-out:before {\n  content: '\\e89b';\n}\n\n/* '' */\n.uil-border-right:before {\n  content: '\\e89c';\n}\n\n/* '' */\n.uil-border-top:before {\n  content: '\\e89d';\n}\n\n/* '' */\n.uil-border-vertical:before {\n  content: '\\e89e';\n}\n\n/* '' */\n.uil-bowling-ball:before {\n  content: '\\e89f';\n}\n\n/* '' */\n.uil-box:before {\n  content: '\\e8a0';\n}\n\n/* '' */\n.uil-briefcase-alt:before {\n  content: '\\e8a1';\n}\n\n/* '' */\n.uil-briefcase:before {\n  content: '\\e8a2';\n}\n\n/* '' */\n.uil-bright:before {\n  content: '\\e8a3';\n}\n\n/* '' */\n.uil-brightness-empty:before {\n  content: '\\e8a4';\n}\n\n/* '' */\n.uil-brightness-half:before {\n  content: '\\e8a5';\n}\n\n/* '' */\n.uil-brightness-low:before {\n  content: '\\e8a6';\n}\n\n/* '' */\n.uil-brightness-minus:before {\n  content: '\\e8a7';\n}\n\n/* '' */\n.uil-brightness-plus:before {\n  content: '\\e8a8';\n}\n\n/* '' */\n.uil-brightness:before {\n  content: '\\e8a9';\n}\n\n/* '' */\n.uil-bring-bottom:before {\n  content: '\\e8aa';\n}\n\n/* '' */\n.uil-bring-front:before {\n  content: '\\e8ab';\n}\n\n/* '' */\n.uil-brush-alt:before {\n  content: '\\e8ac';\n}\n\n/* '' */\n.uil-bug:before {\n  content: '\\e8ad';\n}\n\n/* '' */\n.uil-building:before {\n  content: '\\e8ae';\n}\n\n/* '' */\n.uil-bullseye:before {\n  content: '\\e8af';\n}\n\n/* '' */\n.uil-bus-alt:before {\n  content: '\\e8b0';\n}\n\n/* '' */\n.uil-bus-school:before {\n  content: '\\e8b1';\n}\n\n/* '' */\n.uil-bus:before {\n  content: '\\e8b2';\n}\n\n/* '' */\n.uil-calcualtor:before {\n  content: '\\e8b3';\n}\n\n/* '' */\n.uil-calculator-alt:before {\n  content: '\\e8b4';\n}\n\n/* '' */\n.uil-calculator:before {\n  content: '\\e8b5';\n}\n\n/* '' */\n.uil-calendar-alt:before {\n  content: '\\e8b6';\n}\n\n/* '' */\n.uil-calendar-slash:before {\n  content: '\\e8b7';\n}\n\n/* '' */\n.uil-calender:before {\n  content: '\\e8b8';\n}\n\n/* '' */\n.uil-calling:before {\n  content: '\\e8b9';\n}\n\n/* '' */\n.uil-camera-change:before {\n  content: '\\e8ba';\n}\n\n/* '' */\n.uil-camera-plus:before {\n  content: '\\e8bb';\n}\n\n/* '' */\n.uil-camera-slash:before {\n  content: '\\e8bc';\n}\n\n/* '' */\n.uil-camera:before {\n  content: '\\e8bd';\n}\n\n/* '' */\n.uil-cancel:before {\n  content: '\\e8be';\n}\n\n/* '' */\n.uil-capsule:before {\n  content: '\\e8bf';\n}\n\n/* '' */\n.uil-capture:before {\n  content: '\\e8c0';\n}\n\n/* '' */\n.uil-car-sideview:before {\n  content: '\\e8c1';\n}\n\n/* '' */\n.uil-car-slash:before {\n  content: '\\e8c2';\n}\n\n/* '' */\n.uil-car-wash:before {\n  content: '\\e8c3';\n}\n\n/* '' */\n.uil-car:before {\n  content: '\\e8c4';\n}\n\n/* '' */\n.uil-card-atm:before {\n  content: '\\e8c5';\n}\n\n/* '' */\n.uil-caret-right:before {\n  content: '\\e8c6';\n}\n\n/* '' */\n.uil-cart:before {\n  content: '\\e8c7';\n}\n\n/* '' */\n.uil-cell:before {\n  content: '\\e8c8';\n}\n\n/* '' */\n.uil-celsius:before {\n  content: '\\e8c9';\n}\n\n/* '' */\n.uil-chart-bar-alt:before {\n  content: '\\e8ca';\n}\n\n/* '' */\n.uil-chart-bar:before {\n  content: '\\e8cb';\n}\n\n/* '' */\n.uil-chart-down:before {\n  content: '\\e8cc';\n}\n\n/* '' */\n.uil-chart-growth-alt:before {\n  content: '\\e8cd';\n}\n\n/* '' */\n.uil-chart-growth:before {\n  content: '\\e8ce';\n}\n\n/* '' */\n.uil-chart-line:before {\n  content: '\\e8cf';\n}\n\n/* '' */\n.uil-chart-pie-alt:before {\n  content: '\\e8d0';\n}\n\n/* '' */\n.uil-chart-pie:before {\n  content: '\\e8d1';\n}\n\n/* '' */\n.uil-chart:before {\n  content: '\\e8d2';\n}\n\n/* '' */\n.uil-chat-bubble-user:before {\n  content: '\\e8d3';\n}\n\n/* '' */\n.uil-chat-info:before {\n  content: '\\e8d4';\n}\n\n/* '' */\n.uil-chat:before {\n  content: '\\e8d5';\n}\n\n/* '' */\n.uil-check-circle:before {\n  content: '\\e8d6';\n}\n\n/* '' */\n.uil-check-square:before {\n  content: '\\e8d7';\n}\n\n/* '' */\n.uil-check:before {\n  content: '\\e8d8';\n}\n\n/* '' */\n.uil-circle-layer:before {\n  content: '\\e8d9';\n}\n\n/* '' */\n.uil-circle:before {\n  content: '\\e8da';\n}\n\n/* '' */\n.uil-circuit:before {\n  content: '\\e8db';\n}\n\n/* '' */\n.uil-clapper-board:before {\n  content: '\\e8dc';\n}\n\n/* '' */\n.uil-clipboard-alt:before {\n  content: '\\e8dd';\n}\n\n/* '' */\n.uil-clipboard-blank:before {\n  content: '\\e8de';\n}\n\n/* '' */\n.uil-clipboard-notes:before {\n  content: '\\e8df';\n}\n\n/* '' */\n.uil-clipboard:before {\n  content: '\\e8e0';\n}\n\n/* '' */\n.uil-clock-eight:before {\n  content: '\\e8e1';\n}\n\n/* '' */\n.uil-clock-five:before {\n  content: '\\e8e2';\n}\n\n/* '' */\n.uil-clock-nine:before {\n  content: '\\e8e3';\n}\n\n/* '' */\n.uil-clock-seven:before {\n  content: '\\e8e4';\n}\n\n/* '' */\n.uil-clock-ten:before {\n  content: '\\e8e5';\n}\n\n/* '' */\n.uil-clock-three:before {\n  content: '\\e8e6';\n}\n\n/* '' */\n.uil-clock-two:before {\n  content: '\\e8e7';\n}\n\n/* '' */\n.uil-clock:before {\n  content: '\\e8e8';\n}\n\n/* '' */\n.uil-closed-captioning:before {\n  content: '\\e8e9';\n}\n\n/* '' */\n.uil-cloud-block:before {\n  content: '\\e8ea';\n}\n\n/* '' */\n.uil-cloud-bookmark:before {\n  content: '\\e8eb';\n}\n\n/* '' */\n.uil-cloud-check:before {\n  content: '\\e8ec';\n}\n\n/* '' */\n.uil-cloud-computing:before {\n  content: '\\e8ed';\n}\n\n/* '' */\n.uil-cloud-data-connection:before {\n  content: '\\e8ee';\n}\n\n/* '' */\n.uil-cloud-database-tree:before {\n  content: '\\e8ef';\n}\n\n/* '' */\n.uil-cloud-download:before {\n  content: '\\e8f0';\n}\n\n/* '' */\n.uil-cloud-drizzle:before {\n  content: '\\e8f1';\n}\n\n/* '' */\n.uil-cloud-exclamation:before {\n  content: '\\e8f2';\n}\n\n/* '' */\n.uil-cloud-hail:before {\n  content: '\\e8f3';\n}\n\n/* '' */\n.uil-cloud-heart:before {\n  content: '\\e8f4';\n}\n\n/* '' */\n.uil-cloud-info:before {\n  content: '\\e8f5';\n}\n\n/* '' */\n.uil-cloud-lock:before {\n  content: '\\e8f6';\n}\n\n/* '' */\n.uil-cloud-meatball:before {\n  content: '\\e8f7';\n}\n\n/* '' */\n.uil-cloud-moon-hail:before {\n  content: '\\e8f8';\n}\n\n/* '' */\n.uil-cloud-moon-meatball:before {\n  content: '\\e8f9';\n}\n\n/* '' */\n.uil-cloud-moon-rain:before {\n  content: '\\e8fa';\n}\n\n/* '' */\n.uil-cloud-moon-showers:before {\n  content: '\\e8fb';\n}\n\n/* '' */\n.uil-cloud-moon:before {\n  content: '\\e8fc';\n}\n\n/* '' */\n.uil-cloud-question:before {\n  content: '\\e8fd';\n}\n\n/* '' */\n.uil-cloud-rain-sun:before {\n  content: '\\e8fe';\n}\n\n/* '' */\n.uil-cloud-rain:before {\n  content: '\\e8ff';\n}\n\n/* '' */\n.uil-cloud-redo:before {\n  content: '\\e900';\n}\n\n/* '' */\n.uil-cloud-set:before {\n  content: '\\e901';\n}\n\n/* '' */\n.uil-cloud-share:before {\n  content: '\\e902';\n}\n\n/* '' */\n.uil-cloud-shield:before {\n  content: '\\e903';\n}\n\n/* '' */\n.uil-cloud-showers-alt:before {\n  content: '\\e904';\n}\n\n/* '' */\n.uil-cloud-showers-heavy:before {\n  content: '\\e905';\n}\n\n/* '' */\n.uil-cloud-showers:before {\n  content: '\\e906';\n}\n\n/* '' */\n.uil-cloud-slash:before {\n  content: '\\e907';\n}\n\n/* '' */\n.uil-cloud-sun-hail:before {\n  content: '\\e908';\n}\n\n/* '' */\n.uil-cloud-sun-meatball:before {\n  content: '\\e909';\n}\n\n/* '' */\n.uil-cloud-sun-rain-alt:before {\n  content: '\\e90a';\n}\n\n/* '' */\n.uil-cloud-sun-rain:before {\n  content: '\\e90b';\n}\n\n/* '' */\n.uil-cloud-sun-tear:before {\n  content: '\\e90c';\n}\n\n/* '' */\n.uil-cloud-sun:before {\n  content: '\\e90d';\n}\n\n/* '' */\n.uil-cloud-times:before {\n  content: '\\e90e';\n}\n\n/* '' */\n.uil-cloud-unlock:before {\n  content: '\\e90f';\n}\n\n/* '' */\n.uil-cloud-upload:before {\n  content: '\\e910';\n}\n\n/* '' */\n.uil-cloud-wifi:before {\n  content: '\\e911';\n}\n\n/* '' */\n.uil-cloud-wind:before {\n  content: '\\e912';\n}\n\n/* '' */\n.uil-cloud:before {\n  content: '\\e913';\n}\n\n/* '' */\n.uil-clouds:before {\n  content: '\\e914';\n}\n\n/* '' */\n.uil-club:before {\n  content: '\\e915';\n}\n\n/* '' */\n.uil-code:before {\n  content: '\\e916';\n}\n\n/* '' */\n.uil-coffee:before {\n  content: '\\e917';\n}\n\n/* '' */\n.uil-cog:before {\n  content: '\\e918';\n}\n\n/* '' */\n.uil-coins:before {\n  content: '\\e919';\n}\n\n/* '' */\n.uil-columns:before {\n  content: '\\e91a';\n}\n\n/* '' */\n.uil-comment-alt-block:before {\n  content: '\\e91b';\n}\n\n/* '' */\n.uil-comment-alt-chart-lines:before {\n  content: '\\e91c';\n}\n\n/* '' */\n.uil-comment-alt-check:before {\n  content: '\\e91d';\n}\n\n/* '' */\n.uil-comment-alt-dots:before {\n  content: '\\e91e';\n}\n\n/* '' */\n.uil-comment-alt-download:before {\n  content: '\\e91f';\n}\n\n/* '' */\n.uil-comment-alt-edit:before {\n  content: '\\e920';\n}\n\n/* '' */\n.uil-comment-alt-exclamation:before {\n  content: '\\e921';\n}\n\n/* '' */\n.uil-comment-alt-heart:before {\n  content: '\\e922';\n}\n\n/* '' */\n.uil-comment-alt-image:before {\n  content: '\\e923';\n}\n\n/* '' */\n.uil-comment-alt-info:before {\n  content: '\\e924';\n}\n\n/* '' */\n.uil-comment-alt-lines:before {\n  content: '\\e925';\n}\n\n/* '' */\n.uil-comment-alt-lock:before {\n  content: '\\e926';\n}\n\n/* '' */\n.uil-comment-alt-medical:before {\n  content: '\\e927';\n}\n\n/* '' */\n.uil-comment-alt-message:before {\n  content: '\\e928';\n}\n\n/* '' */\n.uil-comment-alt-notes:before {\n  content: '\\e929';\n}\n\n/* '' */\n.uil-comment-alt-plus:before {\n  content: '\\e92a';\n}\n\n/* '' */\n.uil-comment-alt-question:before {\n  content: '\\e92b';\n}\n\n/* '' */\n.uil-comment-alt-redo:before {\n  content: '\\e92c';\n}\n\n/* '' */\n.uil-comment-alt-search:before {\n  content: '\\e92d';\n}\n\n/* '' */\n.uil-comment-alt-share:before {\n  content: '\\e92e';\n}\n\n/* '' */\n.uil-comment-alt-shield:before {\n  content: '\\e92f';\n}\n\n/* '' */\n.uil-comment-alt-slash:before {\n  content: '\\e930';\n}\n\n/* '' */\n.uil-comment-alt-upload:before {\n  content: '\\e931';\n}\n\n/* '' */\n.uil-comment-alt-verify:before {\n  content: '\\e932';\n}\n\n/* '' */\n.uil-comment-alt:before {\n  content: '\\e933';\n}\n\n/* '' */\n.uil-comment-block:before {\n  content: '\\e934';\n}\n\n/* '' */\n.uil-comment-chart-line:before {\n  content: '\\e935';\n}\n\n/* '' */\n.uil-comment-check:before {\n  content: '\\e936';\n}\n\n/* '' */\n.uil-comment-dots:before {\n  content: '\\e937';\n}\n\n/* '' */\n.uil-comment-download:before {\n  content: '\\e938';\n}\n\n/* '' */\n.uil-comment-edit:before {\n  content: '\\e939';\n}\n\n/* '' */\n.uil-comment-exclamation:before {\n  content: '\\e93a';\n}\n\n/* '' */\n.uil-comment-heart:before {\n  content: '\\e93b';\n}\n\n/* '' */\n.uil-comment-image:before {\n  content: '\\e93c';\n}\n\n/* '' */\n.uil-comment-info-alt:before {\n  content: '\\e93d';\n}\n\n/* '' */\n.uil-comment-info:before {\n  content: '\\e93e';\n}\n\n/* '' */\n.uil-comment-lines:before {\n  content: '\\e93f';\n}\n\n/* '' */\n.uil-comment-lock:before {\n  content: '\\e940';\n}\n\n/* '' */\n.uil-comment-medical:before {\n  content: '\\e941';\n}\n\n/* '' */\n.uil-comment-message:before {\n  content: '\\e942';\n}\n\n/* '' */\n.uil-comment-notes:before {\n  content: '\\e943';\n}\n\n/* '' */\n.uil-comment-plus:before {\n  content: '\\e944';\n}\n\n/* '' */\n.uil-comment-question:before {\n  content: '\\e945';\n}\n\n/* '' */\n.uil-comment-redo:before {\n  content: '\\e946';\n}\n\n/* '' */\n.uil-comment-search:before {\n  content: '\\e947';\n}\n\n/* '' */\n.uil-comment-share:before {\n  content: '\\e948';\n}\n\n/* '' */\n.uil-comment-shield:before {\n  content: '\\e949';\n}\n\n/* '' */\n.uil-comment-slash:before {\n  content: '\\e94a';\n}\n\n/* '' */\n.uil-comment-upload:before {\n  content: '\\e94b';\n}\n\n/* '' */\n.uil-comment-verify:before {\n  content: '\\e94c';\n}\n\n/* '' */\n.uil-comment:before {\n  content: '\\e94d';\n}\n\n/* '' */\n.uil-comments-alt:before {\n  content: '\\e94e';\n}\n\n/* '' */\n.uil-comments:before {\n  content: '\\e94f';\n}\n\n/* '' */\n.uil-commnet-alt-slash:before {\n  content: '\\e950';\n}\n\n/* '' */\n.uil-compact-disc:before {\n  content: '\\e951';\n}\n\n/* '' */\n.uil-compass:before {\n  content: '\\e952';\n}\n\n/* '' */\n.uil-compress-alt-left:before {\n  content: '\\e953';\n}\n\n/* '' */\n.uil-compress-alt:before {\n  content: '\\e954';\n}\n\n/* '' */\n.uil-compress-arrows:before {\n  content: '\\e955';\n}\n\n/* '' */\n.uil-compress-lines:before {\n  content: '\\e956';\n}\n\n/* '' */\n.uil-compress-point:before {\n  content: '\\e957';\n}\n\n/* '' */\n.uil-compress-v:before {\n  content: '\\e958';\n}\n\n/* '' */\n.uil-compress:before {\n  content: '\\e959';\n}\n\n/* '' */\n.uil-computer-mouse:before {\n  content: '\\e95a';\n}\n\n/* '' */\n.uil-confused:before {\n  content: '\\e95b';\n}\n\n/* '' */\n.uil-constructor:before {\n  content: '\\e95c';\n}\n\n/* '' */\n.uil-copy-alt:before {\n  content: '\\e95d';\n}\n\n/* '' */\n.uil-copy-landscape:before {\n  content: '\\e95e';\n}\n\n/* '' */\n.uil-copy:before {\n  content: '\\e95f';\n}\n\n/* '' */\n.uil-copyright:before {\n  content: '\\e960';\n}\n\n/* '' */\n.uil-corner-down-left:before {\n  content: '\\e961';\n}\n\n/* '' */\n.uil-corner-down-right-alt:before {\n  content: '\\e962';\n}\n\n/* '' */\n.uil-corner-down-right:before {\n  content: '\\e963';\n}\n\n/* '' */\n.uil-corner-left-down:before {\n  content: '\\e964';\n}\n\n/* '' */\n.uil-corner-right-down:before {\n  content: '\\e965';\n}\n\n/* '' */\n.uil-corner-up-left-alt:before {\n  content: '\\e966';\n}\n\n/* '' */\n.uil-corner-up-left:before {\n  content: '\\e967';\n}\n\n/* '' */\n.uil-corner-up-right-alt:before {\n  content: '\\e968';\n}\n\n/* '' */\n.uil-corner-up-right:before {\n  content: '\\e969';\n}\n\n/* '' */\n.uil-creative-commons-pd-alt:before {\n  content: '\\e96a';\n}\n\n/* '' */\n.uil-creative-commons-pd:before {\n  content: '\\e96b';\n}\n\n/* '' */\n.uil-crockery:before {\n  content: '\\e96c';\n}\n\n/* '' */\n.uil-crop-alt-rotate-left:before {\n  content: '\\e96d';\n}\n\n/* '' */\n.uil-crop-alt-rotate-right:before {\n  content: '\\e96e';\n}\n\n/* '' */\n.uil-crop-alt:before {\n  content: '\\e96f';\n}\n\n/* '' */\n.uil-crosshair-alt:before {\n  content: '\\e970';\n}\n\n/* '' */\n.uil-crosshair:before {\n  content: '\\e971';\n}\n\n/* '' */\n.uil-crosshairs:before {\n  content: '\\e972';\n}\n\n/* '' */\n.uil-cube:before {\n  content: '\\e973';\n}\n\n/* '' */\n.uil-dashboard:before {\n  content: '\\e974';\n}\n\n/* '' */\n.uil-data-sharing:before {\n  content: '\\e975';\n}\n\n/* '' */\n.uil-database-alt:before {\n  content: '\\e976';\n}\n\n/* '' */\n.uil-database:before {\n  content: '\\e977';\n}\n\n/* '' */\n.uil-desert:before {\n  content: '\\e978';\n}\n\n/* '' */\n.uil-desktop-alt-slash:before {\n  content: '\\e979';\n}\n\n/* '' */\n.uil-desktop-alt:before {\n  content: '\\e97a';\n}\n\n/* '' */\n.uil-desktop-cloud-alt:before {\n  content: '\\e97b';\n}\n\n/* '' */\n.uil-desktop-slash:before {\n  content: '\\e97c';\n}\n\n/* '' */\n.uil-desktop:before {\n  content: '\\e97d';\n}\n\n/* '' */\n.uil-dialpad-alt:before {\n  content: '\\e97e';\n}\n\n/* '' */\n.uil-dialpad:before {\n  content: '\\e97f';\n}\n\n/* '' */\n.uil-diamond:before {\n  content: '\\e980';\n}\n\n/* '' */\n.uil-diary-alt:before {\n  content: '\\e981';\n}\n\n/* '' */\n.uil-diary:before {\n  content: '\\e982';\n}\n\n/* '' */\n.uil-dice-five:before {\n  content: '\\e983';\n}\n\n/* '' */\n.uil-dice-four:before {\n  content: '\\e984';\n}\n\n/* '' */\n.uil-dice-one:before {\n  content: '\\e985';\n}\n\n/* '' */\n.uil-dice-six:before {\n  content: '\\e986';\n}\n\n/* '' */\n.uil-dice-three:before {\n  content: '\\e987';\n}\n\n/* '' */\n.uil-dice-two:before {\n  content: '\\e988';\n}\n\n/* '' */\n.uil-direction:before {\n  content: '\\e989';\n}\n\n/* '' */\n.uil-directions:before {\n  content: '\\e98a';\n}\n\n/* '' */\n.uil-dizzy-meh:before {\n  content: '\\e98b';\n}\n\n/* '' */\n.uil-dna:before {\n  content: '\\e98c';\n}\n\n/* '' */\n.uil-document-layout-center:before {\n  content: '\\e98d';\n}\n\n/* '' */\n.uil-document-layout-left:before {\n  content: '\\e98e';\n}\n\n/* '' */\n.uil-document-layout-right:before {\n  content: '\\e98f';\n}\n\n/* '' */\n.uil-document:before {\n  content: '\\e990';\n}\n\n/* '' */\n.uil-dollar-alt:before {\n  content: '\\e991';\n}\n\n/* '' */\n.uil-dollar-sign-alt:before {\n  content: '\\e992';\n}\n\n/* '' */\n.uil-dollar-sign:before {\n  content: '\\e993';\n}\n\n/* '' */\n.uil-down-arrow:before {\n  content: '\\e994';\n}\n\n/* '' */\n.uil-download-alt:before {\n  content: '\\e995';\n}\n\n/* '' */\n.uil-dribbble:before {\n  content: '\\e996';\n}\n\n/* '' */\n.uil-drill:before {\n  content: '\\e997';\n}\n\n/* '' */\n.uil-dropbox:before {\n  content: '\\e998';\n}\n\n/* '' */\n.uil-dumbbell:before {\n  content: '\\e999';\n}\n\n/* '' */\n.uil-ear:before {\n  content: '\\e99a';\n}\n\n/* '' */\n.uil-edit-alt:before {\n  content: '\\e99b';\n}\n\n/* '' */\n.uil-edit:before {\n  content: '\\e99c';\n}\n\n/* '' */\n.uil-ellipsis-h:before {\n  content: '\\e99d';\n}\n\n/* '' */\n.uil-ellipsis-v:before {\n  content: '\\e99e';\n}\n\n/* '' */\n.uil-emoji:before {\n  content: '\\e99f';\n}\n\n/* '' */\n.uil-enter:before {\n  content: '\\e9a0';\n}\n\n/* '' */\n.uil-entry:before {\n  content: '\\e9a1';\n}\n\n/* '' */\n.uil-envelope-add:before {\n  content: '\\e9a2';\n}\n\n/* '' */\n.uil-envelope-alt:before {\n  content: '\\e9a3';\n}\n\n/* '' */\n.uil-envelope-block:before {\n  content: '\\e9a4';\n}\n\n/* '' */\n.uil-envelope-bookmark:before {\n  content: '\\e9a5';\n}\n\n/* '' */\n.uil-envelope-check:before {\n  content: '\\e9a6';\n}\n\n/* '' */\n.uil-envelope-download-alt:before {\n  content: '\\e9a7';\n}\n\n/* '' */\n.uil-envelope-download:before {\n  content: '\\e9a8';\n}\n\n/* '' */\n.uil-envelope-edit:before {\n  content: '\\e9a9';\n}\n\n/* '' */\n.uil-envelope-exclamation:before {\n  content: '\\e9aa';\n}\n\n/* '' */\n.uil-envelope-heart:before {\n  content: '\\e9ab';\n}\n\n/* '' */\n.uil-envelope-info:before {\n  content: '\\e9ac';\n}\n\n/* '' */\n.uil-envelope-lock:before {\n  content: '\\e9ad';\n}\n\n/* '' */\n.uil-envelope-minus:before {\n  content: '\\e9ae';\n}\n\n/* '' */\n.uil-envelope-open:before {\n  content: '\\e9af';\n}\n\n/* '' */\n.uil-envelope-question:before {\n  content: '\\e9b0';\n}\n\n/* '' */\n.uil-envelope-receive:before {\n  content: '\\e9b1';\n}\n\n/* '' */\n.uil-envelope-redo:before {\n  content: '\\e9b2';\n}\n\n/* '' */\n.uil-envelope-search:before {\n  content: '\\e9b3';\n}\n\n/* '' */\n.uil-envelope-send:before {\n  content: '\\e9b4';\n}\n\n/* '' */\n.uil-envelope-share:before {\n  content: '\\e9b5';\n}\n\n/* '' */\n.uil-envelope-shield:before {\n  content: '\\e9b6';\n}\n\n/* '' */\n.uil-envelope-star:before {\n  content: '\\e9b7';\n}\n\n/* '' */\n.uil-envelope-times:before {\n  content: '\\e9b8';\n}\n\n/* '' */\n.uil-envelope-upload-alt:before {\n  content: '\\e9b9';\n}\n\n/* '' */\n.uil-envelope-upload:before {\n  content: '\\e9ba';\n}\n\n/* '' */\n.uil-envelope:before {\n  content: '\\e9bb';\n}\n\n/* '' */\n.uil-envelopes:before {\n  content: '\\e9bc';\n}\n\n/* '' */\n.uil-equal-circle:before {\n  content: '\\e9bd';\n}\n\n/* '' */\n.uil-euro-circle:before {\n  content: '\\e9be';\n}\n\n/* '' */\n.uil-euro:before {\n  content: '\\e9bf';\n}\n\n/* '' */\n.uil-exchange-alt:before {\n  content: '\\e9c0';\n}\n\n/* '' */\n.uil-exchange:before {\n  content: '\\e9c1';\n}\n\n/* '' */\n.uil-exclamation-circle:before {\n  content: '\\e9c2';\n}\n\n/* '' */\n.uil-exclamation-octagon:before {\n  content: '\\e9c3';\n}\n\n/* '' */\n.uil-exclamation-triangle:before {\n  content: '\\e9c4';\n}\n\n/* '' */\n.uil-exclude:before {\n  content: '\\e9c5';\n}\n\n/* '' */\n.uil-exit:before {\n  content: '\\e9c6';\n}\n\n/* '' */\n.uil-expand-alt:before {\n  content: '\\e9c7';\n}\n\n/* '' */\n.uil-expand-arrows-alt:before {\n  content: '\\e9c8';\n}\n\n/* '' */\n.uil-expand-arrows:before {\n  content: '\\e9c9';\n}\n\n/* '' */\n.uil-expand-from-corner:before {\n  content: '\\e9ca';\n}\n\n/* '' */\n.uil-expand-left:before {\n  content: '\\e9cb';\n}\n\n/* '' */\n.uil-expand-right:before {\n  content: '\\e9cc';\n}\n\n/* '' */\n.uil-export:before {\n  content: '\\e9cd';\n}\n\n/* '' */\n.uil-exposure-alt:before {\n  content: '\\e9ce';\n}\n\n/* '' */\n.uil-exposure-increase:before {\n  content: '\\e9cf';\n}\n\n/* '' */\n.uil-external-link-alt:before {\n  content: '\\e9d0';\n}\n\n/* '' */\n.uil-eye-slash:before {\n  content: '\\e9d1';\n}\n\n/* '' */\n.uil-eye:before {\n  content: '\\e9d2';\n}\n\n/* '' */\n.uil-facebook-f:before {\n  content: '\\e9d3';\n}\n\n/* '' */\n.uil-facebook-messenger-alt:before {\n  content: '\\e9d4';\n}\n\n/* '' */\n.uil-facebook-messenger:before {\n  content: '\\e9d5';\n}\n\n/* '' */\n.uil-facebook:before {\n  content: '\\e9d6';\n}\n\n/* '' */\n.uil-fahrenheit:before {\n  content: '\\e9d7';\n}\n\n/* '' */\n.uil-fast-mail-alt:before {\n  content: '\\e9d8';\n}\n\n/* '' */\n.uil-fast-mail:before {\n  content: '\\e9d9';\n}\n\n/* '' */\n.uil-favorite:before {\n  content: '\\e9da';\n}\n\n/* '' */\n.uil-feedback:before {\n  content: '\\e9db';\n}\n\n/* '' */\n.uil-file-alt:before {\n  content: '\\e9dc';\n}\n\n/* '' */\n.uil-file-blank:before {\n  content: '\\e9dd';\n}\n\n/* '' */\n.uil-file-block-alt:before {\n  content: '\\e9de';\n}\n\n/* '' */\n.uil-file-bookmark-alt:before {\n  content: '\\e9df';\n}\n\n/* '' */\n.uil-file-check-alt:before {\n  content: '\\e9e0';\n}\n\n/* '' */\n.uil-file-check:before {\n  content: '\\e9e1';\n}\n\n/* '' */\n.uil-file-contract-dollar:before {\n  content: '\\e9e2';\n}\n\n/* '' */\n.uil-file-copy-alt:before {\n  content: '\\e9e3';\n}\n\n/* '' */\n.uil-file-download-alt:before {\n  content: '\\e9e4';\n}\n\n/* '' */\n.uil-file-download:before {\n  content: '\\e9e5';\n}\n\n/* '' */\n.uil-file-edit-alt:before {\n  content: '\\e9e6';\n}\n\n/* '' */\n.uil-file-exclamation-alt:before {\n  content: '\\e9e7';\n}\n\n/* '' */\n.uil-file-exclamation:before {\n  content: '\\e9e8';\n}\n\n/* '' */\n.uil-file-heart:before {\n  content: '\\e9e9';\n}\n\n/* '' */\n.uil-file-info-alt:before {\n  content: '\\e9ea';\n}\n\n/* '' */\n.uil-file-landscape-alt:before {\n  content: '\\e9eb';\n}\n\n/* '' */\n.uil-file-landscape:before {\n  content: '\\e9ec';\n}\n\n/* '' */\n.uil-file-lanscape-slash:before {\n  content: '\\e9ed';\n}\n\n/* '' */\n.uil-file-lock-alt:before {\n  content: '\\e9ee';\n}\n\n/* '' */\n.uil-file-medical-alt:before {\n  content: '\\e9ef';\n}\n\n/* '' */\n.uil-file-medical:before {\n  content: '\\e9f0';\n}\n\n/* '' */\n.uil-file-minus-alt:before {\n  content: '\\e9f1';\n}\n\n/* '' */\n.uil-file-minus:before {\n  content: '\\e9f2';\n}\n\n/* '' */\n.uil-file-network:before {\n  content: '\\e9f3';\n}\n\n/* '' */\n.uil-file-plus-alt:before {\n  content: '\\e9f4';\n}\n\n/* '' */\n.uil-file-plus:before {\n  content: '\\e9f5';\n}\n\n/* '' */\n.uil-file-question-alt:before {\n  content: '\\e9f6';\n}\n\n/* '' */\n.uil-file-question:before {\n  content: '\\e9f7';\n}\n\n/* '' */\n.uil-file-redo-alt:before {\n  content: '\\e9f8';\n}\n\n/* '' */\n.uil-file-search-alt:before {\n  content: '\\e9f9';\n}\n\n/* '' */\n.uil-file-share-alt:before {\n  content: '\\e9fa';\n}\n\n/* '' */\n.uil-file-shield-alt:before {\n  content: '\\e9fb';\n}\n\n/* '' */\n.uil-file-slash:before {\n  content: '\\e9fc';\n}\n\n/* '' */\n.uil-file-times-alt:before {\n  content: '\\e9fd';\n}\n\n/* '' */\n.uil-file-times:before {\n  content: '\\e9fe';\n}\n\n/* '' */\n.uil-file-upload-alt:before {\n  content: '\\e9ff';\n}\n\n/* '' */\n.uil-file-upload:before {\n  content: '\\ea00';\n}\n\n/* '' */\n.uil-file:before {\n  content: '\\ea01';\n}\n\n/* '' */\n.uil-files-landscapes-alt:before {\n  content: '\\ea02';\n}\n\n/* '' */\n.uil-files-landscapes:before {\n  content: '\\ea03';\n}\n\n/* '' */\n.uil-film:before {\n  content: '\\ea04';\n}\n\n/* '' */\n.uil-filter-slash:before {\n  content: '\\ea05';\n}\n\n/* '' */\n.uil-filter:before {\n  content: '\\ea06';\n}\n\n/* '' */\n.uil-fire:before {\n  content: '\\ea07';\n}\n\n/* '' */\n.uil-flask-potion:before {\n  content: '\\ea08';\n}\n\n/* '' */\n.uil-flask:before {\n  content: '\\ea09';\n}\n\n/* '' */\n.uil-flip-h-alt:before {\n  content: '\\ea0a';\n}\n\n/* '' */\n.uil-flip-h:before {\n  content: '\\ea0b';\n}\n\n/* '' */\n.uil-flip-v-alt:before {\n  content: '\\ea0c';\n}\n\n/* '' */\n.uil-flip-v:before {\n  content: '\\ea0d';\n}\n\n/* '' */\n.uil-flower:before {\n  content: '\\ea0e';\n}\n\n/* '' */\n.uil-focus-add:before {\n  content: '\\ea0f';\n}\n\n/* '' */\n.uil-focus-target:before {\n  content: '\\ea10';\n}\n\n/* '' */\n.uil-focus:before {\n  content: '\\ea11';\n}\n\n/* '' */\n.uil-folder-check:before {\n  content: '\\ea12';\n}\n\n/* '' */\n.uil-folder-download:before {\n  content: '\\ea13';\n}\n\n/* '' */\n.uil-folder-exclamation:before {\n  content: '\\ea14';\n}\n\n/* '' */\n.uil-folder-heart:before {\n  content: '\\ea15';\n}\n\n/* '' */\n.uil-folder-info:before {\n  content: '\\ea16';\n}\n\n/* '' */\n.uil-folder-lock:before {\n  content: '\\ea17';\n}\n\n/* '' */\n.uil-folder-medical:before {\n  content: '\\ea18';\n}\n\n/* '' */\n.uil-folder-minus:before {\n  content: '\\ea19';\n}\n\n/* '' */\n.uil-folder-network:before {\n  content: '\\ea1a';\n}\n\n/* '' */\n.uil-folder-plus:before {\n  content: '\\ea1b';\n}\n\n/* '' */\n.uil-folder-question:before {\n  content: '\\ea1c';\n}\n\n/* '' */\n.uil-folder-slash:before {\n  content: '\\ea1d';\n}\n\n/* '' */\n.uil-folder-times:before {\n  content: '\\ea1e';\n}\n\n/* '' */\n.uil-folder-upload:before {\n  content: '\\ea1f';\n}\n\n/* '' */\n.uil-folder:before {\n  content: '\\ea20';\n}\n\n/* '' */\n.uil-food:before {\n  content: '\\ea21';\n}\n\n/* '' */\n.uil-football-american:before {\n  content: '\\ea22';\n}\n\n/* '' */\n.uil-football-ball:before {\n  content: '\\ea23';\n}\n\n/* '' */\n.uil-football:before {\n  content: '\\ea24';\n}\n\n/* '' */\n.uil-forecastcloud-moon-tear:before {\n  content: '\\ea25';\n}\n\n/* '' */\n.uil-forwaded-call:before {\n  content: '\\ea26';\n}\n\n/* '' */\n.uil-forward:before {\n  content: '\\ea27';\n}\n\n/* '' */\n.uil-frown:before {\n  content: '\\ea28';\n}\n\n/* '' */\n.uil-game-structure:before {\n  content: '\\ea29';\n}\n\n/* '' */\n.uil-game:before {\n  content: '\\ea2a';\n}\n\n/* '' */\n.uil-gift:before {\n  content: '\\ea2b';\n}\n\n/* '' */\n.uil-github-alt:before {\n  content: '\\ea2c';\n}\n\n/* '' */\n.uil-github:before {\n  content: '\\ea2d';\n}\n\n/* '' */\n.uil-glass-martini-alt-slash:before {\n  content: '\\ea2e';\n}\n\n/* '' */\n.uil-glass-martini-alt:before {\n  content: '\\ea2f';\n}\n\n/* '' */\n.uil-glass-martini:before {\n  content: '\\ea30';\n}\n\n/* '' */\n.uil-glass-tea:before {\n  content: '\\ea31';\n}\n\n/* '' */\n.uil-glass:before {\n  content: '\\ea32';\n}\n\n/* '' */\n.uil-globe:before {\n  content: '\\ea33';\n}\n\n/* '' */\n.uil-gold:before {\n  content: '\\ea34';\n}\n\n/* '' */\n.uil-google-drive-alt:before {\n  content: '\\ea35';\n}\n\n/* '' */\n.uil-google-drive:before {\n  content: '\\ea36';\n}\n\n/* '' */\n.uil-google-hangouts-alt:before {\n  content: '\\ea37';\n}\n\n/* '' */\n.uil-google-hangouts:before {\n  content: '\\ea38';\n}\n\n/* '' */\n.uil-google-play:before {\n  content: '\\ea39';\n}\n\n/* '' */\n.uil-google:before {\n  content: '\\ea3a';\n}\n\n/* '' */\n.uil-graduation-hat:before {\n  content: '\\ea3b';\n}\n\n/* '' */\n.uil-graph-bar:before {\n  content: '\\ea3c';\n}\n\n/* '' */\n.uil-grid:before {\n  content: '\\ea3d';\n}\n\n/* '' */\n.uil-grids:before {\n  content: '\\ea3e';\n}\n\n/* '' */\n.uil-grin-tongue-wink-alt:before {\n  content: '\\ea3f';\n}\n\n/* '' */\n.uil-grin-tongue-wink:before {\n  content: '\\ea40';\n}\n\n/* '' */\n.uil-grin:before {\n  content: '\\ea41';\n}\n\n/* '' */\n.uil-grip-horizontal-line:before {\n  content: '\\ea42';\n}\n\n/* '' */\n.uil-hdd:before {\n  content: '\\ea43';\n}\n\n/* '' */\n.uil-headphones-alt:before {\n  content: '\\ea44';\n}\n\n/* '' */\n.uil-headphones:before {\n  content: '\\ea45';\n}\n\n/* '' */\n.uil-heart-alt:before {\n  content: '\\ea46';\n}\n\n/* '' */\n.uil-heart-medical:before {\n  content: '\\ea47';\n}\n\n/* '' */\n.uil-heart-rate:before {\n  content: '\\ea48';\n}\n\n/* '' */\n.uil-heart-sign:before {\n  content: '\\ea49';\n}\n\n/* '' */\n.uil-heart:before {\n  content: '\\ea4a';\n}\n\n/* '' */\n.uil-heartbeat:before {\n  content: '\\ea4b';\n}\n\n/* '' */\n.uil-history-alt:before {\n  content: '\\ea4c';\n}\n\n/* '' */\n.uil-history:before {\n  content: '\\ea4d';\n}\n\n/* '' */\n.uil-home-alt:before {\n  content: '\\ea4e';\n}\n\n/* '' */\n.uil-home:before {\n  content: '\\ea4f';\n}\n\n/* '' */\n.uil-horizontal-align-center:before {\n  content: '\\ea50';\n}\n\n/* '' */\n.uil-horizontal-align-left:before {\n  content: '\\ea51';\n}\n\n/* '' */\n.uil-horizontal-align-right:before {\n  content: '\\ea52';\n}\n\n/* '' */\n.uil-horizontal-distribution-center:before {\n  content: '\\ea53';\n}\n\n/* '' */\n.uil-horizontal-distribution-left:before {\n  content: '\\ea54';\n}\n\n/* '' */\n.uil-horizontal-distribution-right:before {\n  content: '\\ea55';\n}\n\n/* '' */\n.uil-hourglass:before {\n  content: '\\ea56';\n}\n\n/* '' */\n.uil-html3-alt:before {\n  content: '\\ea57';\n}\n\n/* '' */\n.uil-html3:before {\n  content: '\\ea58';\n}\n\n/* '' */\n.uil-hunting:before {\n  content: '\\ea59';\n}\n\n/* '' */\n.uil-image-alt-slash:before {\n  content: '\\ea5a';\n}\n\n/* '' */\n.uil-image-block:before {\n  content: '\\ea5b';\n}\n\n/* '' */\n.uil-image-broken:before {\n  content: '\\ea5c';\n}\n\n/* '' */\n.uil-image-check:before {\n  content: '\\ea5d';\n}\n\n/* '' */\n.uil-image-download:before {\n  content: '\\ea5e';\n}\n\n/* '' */\n.uil-image-edit:before {\n  content: '\\ea5f';\n}\n\n/* '' */\n.uil-image-lock:before {\n  content: '\\ea60';\n}\n\n/* '' */\n.uil-image-minus:before {\n  content: '\\ea61';\n}\n\n/* '' */\n.uil-image-plus:before {\n  content: '\\ea62';\n}\n\n/* '' */\n.uil-image-question:before {\n  content: '\\ea63';\n}\n\n/* '' */\n.uil-image-redo:before {\n  content: '\\ea64';\n}\n\n/* '' */\n.uil-image-resize-landscape:before {\n  content: '\\ea65';\n}\n\n/* '' */\n.uil-image-resize-square:before {\n  content: '\\ea66';\n}\n\n/* '' */\n.uil-image-search:before {\n  content: '\\ea67';\n}\n\n/* '' */\n.uil-image-share:before {\n  content: '\\ea68';\n}\n\n/* '' */\n.uil-image-shield:before {\n  content: '\\ea69';\n}\n\n/* '' */\n.uil-image-slash:before {\n  content: '\\ea6a';\n}\n\n/* '' */\n.uil-image-times:before {\n  content: '\\ea6b';\n}\n\n/* '' */\n.uil-image-upload:before {\n  content: '\\ea6c';\n}\n\n/* '' */\n.uil-image-v:before {\n  content: '\\ea6d';\n}\n\n/* '' */\n.uil-image:before {\n  content: '\\ea6e';\n}\n\n/* '' */\n.uil-images:before {\n  content: '\\ea6f';\n}\n\n/* '' */\n.uil-import:before {\n  content: '\\ea70';\n}\n\n/* '' */\n.uil-incoming-call:before {\n  content: '\\ea71';\n}\n\n/* '' */\n.uil-info-circle:before {\n  content: '\\ea72';\n}\n\n/* '' */\n.uil-instagram-alt:before {\n  content: '\\ea73';\n}\n\n/* '' */\n.uil-instagram:before {\n  content: '\\ea74';\n}\n\n/* '' */\n.uil-intercom-alt:before {\n  content: '\\ea75';\n}\n\n/* '' */\n.uil-intercom:before {\n  content: '\\ea76';\n}\n\n/* '' */\n.uil-invoice:before {\n  content: '\\ea77';\n}\n\n/* '' */\n.uil-italic:before {\n  content: '\\ea78';\n}\n\n/* '' */\n.uil-jackhammer:before {\n  content: '\\ea79';\n}\n\n/* '' */\n.uil-java-script:before {\n  content: '\\ea7a';\n}\n\n/* '' */\n.uil-kayak:before {\n  content: '\\ea7b';\n}\n\n/* '' */\n.uil-key-skeleton-alt:before {\n  content: '\\ea7c';\n}\n\n/* '' */\n.uil-key-skeleton:before {\n  content: '\\ea7d';\n}\n\n/* '' */\n.uil-keyboard-alt:before {\n  content: '\\ea7e';\n}\n\n/* '' */\n.uil-keyboard-hide:before {\n  content: '\\ea7f';\n}\n\n/* '' */\n.uil-keyboard-show:before {\n  content: '\\ea80';\n}\n\n/* '' */\n.uil-keyboard:before {\n  content: '\\ea81';\n}\n\n/* '' */\n.uil-keyhole-circle:before {\n  content: '\\ea82';\n}\n\n/* '' */\n.uil-keyhole-square-full:before {\n  content: '\\ea83';\n}\n\n/* '' */\n.uil-keyhole-square:before {\n  content: '\\ea84';\n}\n\n/* '' */\n.uil-kid:before {\n  content: '\\ea85';\n}\n\n/* '' */\n.uil-label-alt:before {\n  content: '\\ea86';\n}\n\n/* '' */\n.uil-label:before {\n  content: '\\ea87';\n}\n\n/* '' */\n.uil-lamp:before {\n  content: '\\ea88';\n}\n\n/* '' */\n.uil-laptop-cloud:before {\n  content: '\\ea89';\n}\n\n/* '' */\n.uil-laptop:before {\n  content: '\\ea8a';\n}\n\n/* '' */\n.uil-laughing:before {\n  content: '\\ea8b';\n}\n\n/* '' */\n.uil-layer-group-slash:before {\n  content: '\\ea8c';\n}\n\n/* '' */\n.uil-layer-group:before {\n  content: '\\ea8d';\n}\n\n/* '' */\n.uil-layers-alt:before {\n  content: '\\ea8e';\n}\n\n/* '' */\n.uil-layers-slash:before {\n  content: '\\ea8f';\n}\n\n/* '' */\n.uil-layers:before {\n  content: '\\ea90';\n}\n\n/* '' */\n.uil-left-arrow-from-left:before {\n  content: '\\ea91';\n}\n\n/* '' */\n.uil-left-arrow-to-left:before {\n  content: '\\ea92';\n}\n\n/* '' */\n.uil-left-indent-alt:before {\n  content: '\\ea93';\n}\n\n/* '' */\n.uil-left-indent:before {\n  content: '\\ea94';\n}\n\n/* '' */\n.uil-left-to-right-text-direction:before {\n  content: '\\ea95';\n}\n\n/* '' */\n.uil-life-ring:before {\n  content: '\\ea96';\n}\n\n/* '' */\n.uil-lightbulb-alt:before {\n  content: '\\ea97';\n}\n\n/* '' */\n.uil-lightbulb:before {\n  content: '\\ea98';\n}\n\n/* '' */\n.uil-line-alt:before {\n  content: '\\ea99';\n}\n\n/* '' */\n.uil-line-spacing:before {\n  content: '\\ea9a';\n}\n\n/* '' */\n.uil-line:before {\n  content: '\\ea9b';\n}\n\n/* '' */\n.uil-link-alt:before {\n  content: '\\ea9c';\n}\n\n/* '' */\n.uil-link-broken:before {\n  content: '\\ea9d';\n}\n\n/* '' */\n.uil-link-h:before {\n  content: '\\ea9e';\n}\n\n/* '' */\n.uil-link:before {\n  content: '\\ea9f';\n}\n\n/* '' */\n.uil-linkedin-alt:before {\n  content: '\\eaa0';\n}\n\n/* '' */\n.uil-linkedin:before {\n  content: '\\eaa1';\n}\n\n/* '' */\n.uil-list-ui-alt:before {\n  content: '\\eaa2';\n}\n\n/* '' */\n.uil-list-ul:before {\n  content: '\\eaa3';\n}\n\n/* '' */\n.uil-location-arrow-alt:before {\n  content: '\\eaa4';\n}\n\n/* '' */\n.uil-location-arrow:before {\n  content: '\\eaa5';\n}\n\n/* '' */\n.uil-location-pin-alt:before {\n  content: '\\eaa6';\n}\n\n/* '' */\n.uil-location-point:before {\n  content: '\\eaa7';\n}\n\n/* '' */\n.uil-location:before {\n  content: '\\eaa8';\n}\n\n/* '' */\n.uil-lock-access:before {\n  content: '\\eaa9';\n}\n\n/* '' */\n.uil-lock-alt:before {\n  content: '\\eaaa';\n}\n\n/* '' */\n.uil-lock-open-alt:before {\n  content: '\\eaab';\n}\n\n/* '' */\n.uil-lock-slash:before {\n  content: '\\eaac';\n}\n\n/* '' */\n.uil-lock:before {\n  content: '\\eaad';\n}\n\n/* '' */\n.uil-mailbox-alt:before {\n  content: '\\eaae';\n}\n\n/* '' */\n.uil-mailbox:before {\n  content: '\\eaaf';\n}\n\n/* '' */\n.uil-map-marker-alt:before {\n  content: '\\eab0';\n}\n\n/* '' */\n.uil-map-marker-edit:before {\n  content: '\\eab1';\n}\n\n/* '' */\n.uil-map-marker-info:before {\n  content: '\\eab2';\n}\n\n/* '' */\n.uil-map-marker-minus:before {\n  content: '\\eab3';\n}\n\n/* '' */\n.uil-map-marker-plus:before {\n  content: '\\eab4';\n}\n\n/* '' */\n.uil-map-marker-question:before {\n  content: '\\eab5';\n}\n\n/* '' */\n.uil-map-marker-shield:before {\n  content: '\\eab6';\n}\n\n/* '' */\n.uil-map-marker-slash:before {\n  content: '\\eab7';\n}\n\n/* '' */\n.uil-map-marker:before {\n  content: '\\eab8';\n}\n\n/* '' */\n.uil-map-pin-alt:before {\n  content: '\\eab9';\n}\n\n/* '' */\n.uil-map-pin:before {\n  content: '\\eaba';\n}\n\n/* '' */\n.uil-map:before {\n  content: '\\eabb';\n}\n\n/* '' */\n.uil-mars:before {\n  content: '\\eabc';\n}\n\n/* '' */\n.uil-master-card:before {\n  content: '\\eabd';\n}\n\n/* '' */\n.uil-maximize-left:before {\n  content: '\\eabe';\n}\n\n/* '' */\n.uil-medal:before {\n  content: '\\eabf';\n}\n\n/* '' */\n.uil-medical-drip:before {\n  content: '\\eac0';\n}\n\n/* '' */\n.uil-medical-square-full:before {\n  content: '\\eac1';\n}\n\n/* '' */\n.uil-medical-square:before {\n  content: '\\eac2';\n}\n\n/* '' */\n.uil-medical:before {\n  content: '\\eac3';\n}\n\n/* '' */\n.uil-medium-m:before {\n  content: '\\eac4';\n}\n\n/* '' */\n.uil-medkit:before {\n  content: '\\eac5';\n}\n\n/* '' */\n.uil-meeting-board:before {\n  content: '\\eac6';\n}\n\n/* '' */\n.uil-megaphone:before {\n  content: '\\eac7';\n}\n\n/* '' */\n.uil-meh-alt:before {\n  content: '\\eac8';\n}\n\n/* '' */\n.uil-meh-closed-eye:before {\n  content: '\\eac9';\n}\n\n/* '' */\n.uil-meh:before {\n  content: '\\eaca';\n}\n\n/* '' */\n.uil-message:before {\n  content: '\\eacb';\n}\n\n/* '' */\n.uil-metro:before {\n  content: '\\eacc';\n}\n\n/* '' */\n.uil-microphone-slash:before {\n  content: '\\eacd';\n}\n\n/* '' */\n.uil-microphone:before {\n  content: '\\eace';\n}\n\n/* '' */\n.uil-minus-circle:before {\n  content: '\\eacf';\n}\n\n/* '' */\n.uil-minus-path:before {\n  content: '\\ead0';\n}\n\n/* '' */\n.uil-minus-square-full:before {\n  content: '\\ead1';\n}\n\n/* '' */\n.uil-minus-square:before {\n  content: '\\ead2';\n}\n\n/* '' */\n.uil-minus:before {\n  content: '\\ead3';\n}\n\n/* '' */\n.uil-missed-call:before {\n  content: '\\ead4';\n}\n\n/* '' */\n.uil-mobey-bill-slash:before {\n  content: '\\ead5';\n}\n\n/* '' */\n.uil-mobile-android-alt:before {\n  content: '\\ead6';\n}\n\n/* '' */\n.uil-mobile-android:before {\n  content: '\\ead7';\n}\n\n/* '' */\n.uil-mobile-vibrate:before {\n  content: '\\ead8';\n}\n\n/* '' */\n.uil-modem:before {\n  content: '\\ead9';\n}\n\n/* '' */\n.uil-money-bill-stack:before {\n  content: '\\eada';\n}\n\n/* '' */\n.uil-money-bill:before {\n  content: '\\eadb';\n}\n\n/* '' */\n.uil-money-insert:before {\n  content: '\\eadc';\n}\n\n/* '' */\n.uil-money-stack:before {\n  content: '\\eadd';\n}\n\n/* '' */\n.uil-money-withdraw:before {\n  content: '\\eade';\n}\n\n/* '' */\n.uil-money-withdrawal:before {\n  content: '\\eadf';\n}\n\n/* '' */\n.uil-moneybag-alt:before {\n  content: '\\eae0';\n}\n\n/* '' */\n.uil-moneybag:before {\n  content: '\\eae1';\n}\n\n/* '' */\n.uil-monitor-heart-rate:before {\n  content: '\\eae2';\n}\n\n/* '' */\n.uil-monitor:before {\n  content: '\\eae3';\n}\n\n/* '' */\n.uil-moon-eclipse:before {\n  content: '\\eae4';\n}\n\n/* '' */\n.uil-moon:before {\n  content: '\\eae5';\n}\n\n/* '' */\n.uil-moonset:before {\n  content: '\\eae6';\n}\n\n/* '' */\n.uil-mountains-sun:before {\n  content: '\\eae7';\n}\n\n/* '' */\n.uil-mountains:before {\n  content: '\\eae8';\n}\n\n/* '' */\n.uil-mouse-alt:before {\n  content: '\\eae9';\n}\n\n/* '' */\n.uil-mouse:before {\n  content: '\\eaea';\n}\n\n/* '' */\n.uil-multiply:before {\n  content: '\\eaeb';\n}\n\n/* '' */\n.uil-music-note:before {\n  content: '\\eaec';\n}\n\n/* '' */\n.uil-music-tune-slash:before {\n  content: '\\eaed';\n}\n\n/* '' */\n.uil-music:before {\n  content: '\\eaee';\n}\n\n/* '' */\n.uil-n-a:before {\n  content: '\\eaef';\n}\n\n/* '' */\n.uil-navigator:before {\n  content: '\\eaf0';\n}\n\n/* '' */\n.uil-nerd:before {\n  content: '\\eaf1';\n}\n\n/* '' */\n.uil-newspaper:before {\n  content: '\\eaf2';\n}\n\n/* '' */\n.uil-ninja:before {\n  content: '\\eaf3';\n}\n\n/* '' */\n.uil-no-entry:before {\n  content: '\\eaf4';\n}\n\n/* '' */\n.uil-notebooks:before {\n  content: '\\eaf5';\n}\n\n/* '' */\n.uil-notes:before {\n  content: '\\eaf6';\n}\n\n/* '' */\n.uil-object-group:before {\n  content: '\\eaf7';\n}\n\n/* '' */\n.uil-object-ungroup:before {\n  content: '\\eaf8';\n}\n\n/* '' */\n.uil-octagon:before {\n  content: '\\eaf9';\n}\n\n/* '' */\n.uil-opera-alt:before {\n  content: '\\eafa';\n}\n\n/* '' */\n.uil-opera:before {\n  content: '\\eafb';\n}\n\n/* '' */\n.uil-outgoing-call:before {\n  content: '\\eafc';\n}\n\n/* '' */\n.uil-package:before {\n  content: '\\eafd';\n}\n\n/* '' */\n.uil-padlock:before {\n  content: '\\eafe';\n}\n\n/* '' */\n.uil-paint-tool:before {\n  content: '\\eaff';\n}\n\n/* '' */\n.uil-palette:before {\n  content: '\\eb00';\n}\n\n/* '' */\n.uil-panorama-h-alt:before {\n  content: '\\eb01';\n}\n\n/* '' */\n.uil-panorama-h:before {\n  content: '\\eb02';\n}\n\n/* '' */\n.uil-panorama-v:before {\n  content: '\\eb03';\n}\n\n/* '' */\n.uil-paperclip:before {\n  content: '\\eb04';\n}\n\n/* '' */\n.uil-paragraph:before {\n  content: '\\eb05';\n}\n\n/* '' */\n.uil-parcel:before {\n  content: '\\eb06';\n}\n\n/* '' */\n.uil-parking-square:before {\n  content: '\\eb07';\n}\n\n/* '' */\n.uil-pathfinder-unite:before {\n  content: '\\eb08';\n}\n\n/* '' */\n.uil-pathfinder:before {\n  content: '\\eb09';\n}\n\n/* '' */\n.uil-pause-circle:before {\n  content: '\\eb0a';\n}\n\n/* '' */\n.uil-pause:before {\n  content: '\\eb0b';\n}\n\n/* '' */\n.uil-paypal:before {\n  content: '\\eb0c';\n}\n\n/* '' */\n.uil-pen:before {\n  content: '\\eb0d';\n}\n\n/* '' */\n.uil-pentagon:before {\n  content: '\\eb0e';\n}\n\n/* '' */\n.uil-percentage:before {\n  content: '\\eb0f';\n}\n\n/* '' */\n.uil-phone-alt:before {\n  content: '\\eb10';\n}\n\n/* '' */\n.uil-phone-pause:before {\n  content: '\\eb11';\n}\n\n/* '' */\n.uil-phone-slash:before {\n  content: '\\eb12';\n}\n\n/* '' */\n.uil-phone-times:before {\n  content: '\\eb13';\n}\n\n/* '' */\n.uil-phone-volume:before {\n  content: '\\eb14';\n}\n\n/* '' */\n.uil-phone:before {\n  content: '\\eb15';\n}\n\n/* '' */\n.uil-picture:before {\n  content: '\\eb16';\n}\n\n/* '' */\n.uil-plane-arrival:before {\n  content: '\\eb17';\n}\n\n/* '' */\n.uil-plane-departure:before {\n  content: '\\eb18';\n}\n\n/* '' */\n.uil-plane-fly:before {\n  content: '\\eb19';\n}\n\n/* '' */\n.uil-plane:before {\n  content: '\\eb1a';\n}\n\n/* '' */\n.uil-play-circle:before {\n  content: '\\eb1b';\n}\n\n/* '' */\n.uil-play:before {\n  content: '\\eb1c';\n}\n\n/* '' */\n.uil-plug:before {\n  content: '\\eb1d';\n}\n\n/* '' */\n.uil-plus-circle:before {\n  content: '\\eb1e';\n}\n\n/* '' */\n.uil-plus-square:before {\n  content: '\\eb1f';\n}\n\n/* '' */\n.uil-plus:before {\n  content: '\\eb20';\n}\n\n/* '' */\n.uil-podium:before {\n  content: '\\eb21';\n}\n\n/* '' */\n.uil-polygon:before {\n  content: '\\eb22';\n}\n\n/* '' */\n.uil-post-stamp:before {\n  content: '\\eb23';\n}\n\n/* '' */\n.uil-postcard:before {\n  content: '\\eb24';\n}\n\n/* '' */\n.uil-pound-circle:before {\n  content: '\\eb25';\n}\n\n/* '' */\n.uil-pound:before {\n  content: '\\eb26';\n}\n\n/* '' */\n.uil-power:before {\n  content: '\\eb27';\n}\n\n/* '' */\n.uil-prescription-bottle:before {\n  content: '\\eb28';\n}\n\n/* '' */\n.uil-presentation-check:before {\n  content: '\\eb29';\n}\n\n/* '' */\n.uil-presentation-edit:before {\n  content: '\\eb2a';\n}\n\n/* '' */\n.uil-presentation-line:before {\n  content: '\\eb2b';\n}\n\n/* '' */\n.uil-presentation-lines-alt:before {\n  content: '\\eb2c';\n}\n\n/* '' */\n.uil-presentation-minus:before {\n  content: '\\eb2d';\n}\n\n/* '' */\n.uil-presentation-play:before {\n  content: '\\eb2e';\n}\n\n/* '' */\n.uil-presentation-plus:before {\n  content: '\\eb2f';\n}\n\n/* '' */\n.uil-presentation-times:before {\n  content: '\\eb30';\n}\n\n/* '' */\n.uil-presentation:before {\n  content: '\\eb31';\n}\n\n/* '' */\n.uil-previous:before {\n  content: '\\eb32';\n}\n\n/* '' */\n.uil-pricetag-alt:before {\n  content: '\\eb33';\n}\n\n/* '' */\n.uil-print-slash:before {\n  content: '\\eb34';\n}\n\n/* '' */\n.uil-print:before {\n  content: '\\eb35';\n}\n\n/* '' */\n.uil-process:before {\n  content: '\\eb36';\n}\n\n/* '' */\n.uil-processor:before {\n  content: '\\eb37';\n}\n\n/* '' */\n.uil-pump:before {\n  content: '\\eb38';\n}\n\n/* '' */\n.uil-puzzle-piece:before {\n  content: '\\eb39';\n}\n\n/* '' */\n.uil-question-circle:before {\n  content: '\\eb3a';\n}\n\n/* '' */\n.uil-raddit-alien-alt:before {\n  content: '\\eb3b';\n}\n\n/* '' */\n.uil-rainbow:before {\n  content: '\\eb3c';\n}\n\n/* '' */\n.uil-raindrops-alt:before {\n  content: '\\eb3d';\n}\n\n/* '' */\n.uil-raindrops:before {\n  content: '\\eb3e';\n}\n\n/* '' */\n.uil-react:before {\n  content: '\\eb3f';\n}\n\n/* '' */\n.uil-receipt-alt:before {\n  content: '\\eb40';\n}\n\n/* '' */\n.uil-receipt:before {\n  content: '\\eb41';\n}\n\n/* '' */\n.uil-record-audio:before {\n  content: '\\eb42';\n}\n\n/* '' */\n.uil-reddit-alien-alt:before {\n  content: '\\eb43';\n}\n\n/* '' */\n.uil-redo:before {\n  content: '\\eb44';\n}\n\n/* '' */\n.uil-refresh:before {\n  content: '\\eb45';\n}\n\n/* '' */\n.uil-registered:before {\n  content: '\\eb46';\n}\n\n/* '' */\n.uil-repeat:before {\n  content: '\\eb47';\n}\n\n/* '' */\n.uil-restaurant:before {\n  content: '\\eb48';\n}\n\n/* '' */\n.uil-right-indent-alt:before {\n  content: '\\eb49';\n}\n\n/* '' */\n.uil-right-to-left-text-direction:before {\n  content: '\\eb4a';\n}\n\n/* '' */\n.uil-robot:before {\n  content: '\\eb4b';\n}\n\n/* '' */\n.uil-rope-way:before {\n  content: '\\eb4c';\n}\n\n/* '' */\n.uil-rotate-360:before {\n  content: '\\eb4d';\n}\n\n/* '' */\n.uil-rss-alt:before {\n  content: '\\eb4e';\n}\n\n/* '' */\n.uil-rss-interface:before {\n  content: '\\eb4f';\n}\n\n/* '' */\n.uil-rss:before {\n  content: '\\eb50';\n}\n\n/* '' */\n.uil-ruler-combined:before {\n  content: '\\eb51';\n}\n\n/* '' */\n.uil-ruler:before {\n  content: '\\eb52';\n}\n\n/* '' */\n.uil-sad-cry:before {\n  content: '\\eb53';\n}\n\n/* '' */\n.uil-sad-crying:before {\n  content: '\\eb54';\n}\n\n/* '' */\n.uil-sad-dizzy:before {\n  content: '\\eb55';\n}\n\n/* '' */\n.uil-sad-squint:before {\n  content: '\\eb56';\n}\n\n/* '' */\n.uil-sad:before {\n  content: '\\eb57';\n}\n\n/* '' */\n.uil-scaling-left:before {\n  content: '\\eb58';\n}\n\n/* '' */\n.uil-scaling-right:before {\n  content: '\\eb59';\n}\n\n/* '' */\n.uil-scenery:before {\n  content: '\\eb5a';\n}\n\n/* '' */\n.uil-schedule:before {\n  content: '\\eb5b';\n}\n\n/* '' */\n.uil-science:before {\n  content: '\\eb5c';\n}\n\n/* '' */\n.uil-screw:before {\n  content: '\\eb5d';\n}\n\n/* '' */\n.uil-scroll-h:before {\n  content: '\\eb5e';\n}\n\n/* '' */\n.uil-scroll:before {\n  content: '\\eb5f';\n}\n\n/* '' */\n.uil-search-alt:before {\n  content: '\\eb60';\n}\n\n/* '' */\n.uil-search-minus:before {\n  content: '\\eb61';\n}\n\n/* '' */\n.uil-search-plus:before {\n  content: '\\eb62';\n}\n\n/* '' */\n.uil-search:before {\n  content: '\\eb63';\n}\n\n/* '' */\n.uil-selfie:before {\n  content: '\\eb64';\n}\n\n/* '' */\n.uil-server-alt:before {\n  content: '\\eb65';\n}\n\n/* '' */\n.uil-server-connection:before {\n  content: '\\eb66';\n}\n\n/* '' */\n.uil-server-network-alt:before {\n  content: '\\eb67';\n}\n\n/* '' */\n.uil-server-network:before {\n  content: '\\eb68';\n}\n\n/* '' */\n.uil-server:before {\n  content: '\\eb69';\n}\n\n/* '' */\n.uil-servers:before {\n  content: '\\eb6a';\n}\n\n/* '' */\n.uil-servicemark:before {\n  content: '\\eb6b';\n}\n\n/* '' */\n.uil-share-alt:before {\n  content: '\\eb6c';\n}\n\n/* '' */\n.uil-shield-check:before {\n  content: '\\eb6d';\n}\n\n/* '' */\n.uil-shield-exclamation:before {\n  content: '\\eb6e';\n}\n\n/* '' */\n.uil-shield-question:before {\n  content: '\\eb6f';\n}\n\n/* '' */\n.uil-shield-slash:before {\n  content: '\\eb70';\n}\n\n/* '' */\n.uil-shield:before {\n  content: '\\eb71';\n}\n\n/* '' */\n.uil-ship:before {\n  content: '\\eb72';\n}\n\n/* '' */\n.uil-shop:before {\n  content: '\\eb73';\n}\n\n/* '' */\n.uil-shopping-basket:before {\n  content: '\\eb74';\n}\n\n/* '' */\n.uil-shopping-cart-alt:before {\n  content: '\\eb75';\n}\n\n/* '' */\n.uil-shopping-trolley:before {\n  content: '\\eb76';\n}\n\n/* '' */\n.uil-shovel:before {\n  content: '\\eb77';\n}\n\n/* '' */\n.uil-shrink:before {\n  content: '\\eb78';\n}\n\n/* '' */\n.uil-shuffle:before {\n  content: '\\eb79';\n}\n\n/* '' */\n.uil-shutter-alt:before {\n  content: '\\eb7a';\n}\n\n/* '' */\n.uil-shutter:before {\n  content: '\\eb7b';\n}\n\n/* '' */\n.uil-sick:before {\n  content: '\\eb7c';\n}\n\n/* '' */\n.uil-sigma:before {\n  content: '\\eb7d';\n}\n\n/* '' */\n.uil-sign-alt:before {\n  content: '\\eb7e';\n}\n\n/* '' */\n.uil-sign-in-alt:before {\n  content: '\\eb7f';\n}\n\n/* '' */\n.uil-sign-left:before {\n  content: '\\eb80';\n}\n\n/* '' */\n.uil-sign-out-alt:before {\n  content: '\\eb81';\n}\n\n/* '' */\n.uil-sign-right:before {\n  content: '\\eb82';\n}\n\n/* '' */\n.uil-signal-alt-3:before {\n  content: '\\eb83';\n}\n\n/* '' */\n.uil-signal-alt:before {\n  content: '\\eb84';\n}\n\n/* '' */\n.uil-signal:before {\n  content: '\\eb85';\n}\n\n/* '' */\n.uil-silence:before {\n  content: '\\eb86';\n}\n\n/* '' */\n.uil-silent-squint:before {\n  content: '\\eb87';\n}\n\n/* '' */\n.uil-sim-card:before {\n  content: '\\eb88';\n}\n\n/* '' */\n.uil-sitemap:before {\n  content: '\\eb89';\n}\n\n/* '' */\n.uil-skip-forward-alt:before {\n  content: '\\eb8a';\n}\n\n/* '' */\n.uil-skip-forward-circle:before {\n  content: '\\eb8b';\n}\n\n/* '' */\n.uil-skip-forward:before {\n  content: '\\eb8c';\n}\n\n/* '' */\n.uil-skype-alt:before {\n  content: '\\eb8d';\n}\n\n/* '' */\n.uil-skype:before {\n  content: '\\eb8e';\n}\n\n/* '' */\n.uil-slack-alt:before {\n  content: '\\eb8f';\n}\n\n/* '' */\n.uil-slack:before {\n  content: '\\eb90';\n}\n\n/* '' */\n.uil-sliders-v-alt:before {\n  content: '\\eb91';\n}\n\n/* '' */\n.uil-sliders-v:before {\n  content: '\\eb92';\n}\n\n/* '' */\n.uil-smile-beam:before {\n  content: '\\eb93';\n}\n\n/* '' */\n.uil-smile-dizzy:before {\n  content: '\\eb94';\n}\n\n/* '' */\n.uil-smile-squint-wink-alt:before {\n  content: '\\eb95';\n}\n\n/* '' */\n.uil-smile-squint-wink:before {\n  content: '\\eb96';\n}\n\n/* '' */\n.uil-smile-wink-alt:before {\n  content: '\\eb97';\n}\n\n/* '' */\n.uil-smile-wink:before {\n  content: '\\eb98';\n}\n\n/* '' */\n.uil-smile:before {\n  content: '\\eb99';\n}\n\n/* '' */\n.uil-snapchat-alt:before {\n  content: '\\eb9a';\n}\n\n/* '' */\n.uil-snapchat-ghost:before {\n  content: '\\eb9b';\n}\n\n/* '' */\n.uil-snapchat-square:before {\n  content: '\\eb9c';\n}\n\n/* '' */\n.uil-snow-flake:before {\n  content: '\\eb9d';\n}\n\n/* '' */\n.uil-snowflake-alt:before {\n  content: '\\eb9e';\n}\n\n/* '' */\n.uil-snowflake:before {\n  content: '\\eb9f';\n}\n\n/* '' */\n.uil-sort-amount-down:before {\n  content: '\\eba0';\n}\n\n/* '' */\n.uil-sort-amount-up:before {\n  content: '\\eba1';\n}\n\n/* '' */\n.uil-sort:before {\n  content: '\\eba2';\n}\n\n/* '' */\n.uil-sorting:before {\n  content: '\\eba3';\n}\n\n/* '' */\n.uil-space-key:before {\n  content: '\\eba4';\n}\n\n/* '' */\n.uil-spade:before {\n  content: '\\eba5';\n}\n\n/* '' */\n.uil-sperms:before {\n  content: '\\eba6';\n}\n\n/* '' */\n.uil-spin:before {\n  content: '\\eba7';\n}\n\n/* '' */\n.uil-sport:before {\n  content: '\\eba8';\n}\n\n/* '' */\n.uil-square-full:before {\n  content: '\\eba9';\n}\n\n/* '' */\n.uil-square-shape:before {\n  content: '\\ebaa';\n}\n\n/* '' */\n.uil-square:before {\n  content: '\\ebab';\n}\n\n/* '' */\n.uil-squint:before {\n  content: '\\ebac';\n}\n\n/* '' */\n.uil-star-half-alt:before {\n  content: '\\ebad';\n}\n\n/* '' */\n.uil-star:before {\n  content: '\\ebae';\n}\n\n/* '' */\n.uil-step-backward-alt:before {\n  content: '\\ebaf';\n}\n\n/* '' */\n.uil-step-backward-circle:before {\n  content: '\\ebb0';\n}\n\n/* '' */\n.uil-step-backward:before {\n  content: '\\ebb1';\n}\n\n/* '' */\n.uil-step-forward:before {\n  content: '\\ebb2';\n}\n\n/* '' */\n.uil-stop-circle:before {\n  content: '\\ebb3';\n}\n\n/* '' */\n.uil-stopwatch-slash:before {\n  content: '\\ebb4';\n}\n\n/* '' */\n.uil-stopwatch:before {\n  content: '\\ebb5';\n}\n\n/* '' */\n.uil-store-alt:before {\n  content: '\\ebb6';\n}\n\n/* '' */\n.uil-store:before {\n  content: '\\ebb7';\n}\n\n/* '' */\n.uil-streering:before {\n  content: '\\ebb8';\n}\n\n/* '' */\n.uil-stretcher:before {\n  content: '\\ebb9';\n}\n\n/* '' */\n.uil-subject:before {\n  content: '\\ebba';\n}\n\n/* '' */\n.uil-subway-alt:before {\n  content: '\\ebbb';\n}\n\n/* '' */\n.uil-subway:before {\n  content: '\\ebbc';\n}\n\n/* '' */\n.uil-suitcase-alt:before {\n  content: '\\ebbd';\n}\n\n/* '' */\n.uil-suitcase:before {\n  content: '\\ebbe';\n}\n\n/* '' */\n.uil-sun:before {\n  content: '\\ebbf';\n}\n\n/* '' */\n.uil-sunset:before {\n  content: '\\ebc0';\n}\n\n/* '' */\n.uil-surprise:before {\n  content: '\\ebc1';\n}\n\n/* '' */\n.uil-swatchbook:before {\n  content: '\\ebc2';\n}\n\n/* '' */\n.uil-swiggy:before {\n  content: '\\ebc3';\n}\n\n/* '' */\n.uil-swimmer:before {\n  content: '\\ebc4';\n}\n\n/* '' */\n.uil-symbol:before {\n  content: '\\ebc5';\n}\n\n/* '' */\n.uil-sync-exclamation:before {\n  content: '\\ebc6';\n}\n\n/* '' */\n.uil-sync-slash:before {\n  content: '\\ebc7';\n}\n\n/* '' */\n.uil-sync:before {\n  content: '\\ebc8';\n}\n\n/* '' */\n.uil-syringe:before {\n  content: '\\ebc9';\n}\n\n/* '' */\n.uil-table:before {\n  content: '\\ebca';\n}\n\n/* '' */\n.uil-tablet:before {\n  content: '\\ebcb';\n}\n\n/* '' */\n.uil-tablets:before {\n  content: '\\ebcc';\n}\n\n/* '' */\n.uil-tachometer-fast:before {\n  content: '\\ebcd';\n}\n\n/* '' */\n.uil-tag-alt:before {\n  content: '\\ebce';\n}\n\n/* '' */\n.uil-tag:before {\n  content: '\\ebcf';\n}\n\n/* '' */\n.uil-tape:before {\n  content: '\\ebd0';\n}\n\n/* '' */\n.uil-taxi:before {\n  content: '\\ebd1';\n}\n\n/* '' */\n.uil-tear:before {\n  content: '\\ebd2';\n}\n\n/* '' */\n.uil-technology:before {\n  content: '\\ebd3';\n}\n\n/* '' */\n.uil-telegram-alt:before {\n  content: '\\ebd4';\n}\n\n/* '' */\n.uil-telegram:before {\n  content: '\\ebd5';\n}\n\n/* '' */\n.uil-telescope:before {\n  content: '\\ebd6';\n}\n\n/* '' */\n.uil-temperature-empty:before {\n  content: '\\ebd7';\n}\n\n/* '' */\n.uil-temperature-half:before {\n  content: '\\ebd8';\n}\n\n/* '' */\n.uil-temperature-minus:before {\n  content: '\\ebd9';\n}\n\n/* '' */\n.uil-temperature-plus:before {\n  content: '\\ebda';\n}\n\n/* '' */\n.uil-temperature-quarter:before {\n  content: '\\ebdb';\n}\n\n/* '' */\n.uil-temperature-three-quarter:before {\n  content: '\\ebdc';\n}\n\n/* '' */\n.uil-temperature:before {\n  content: '\\ebdd';\n}\n\n/* '' */\n.uil-text-fields:before {\n  content: '\\ebde';\n}\n\n/* '' */\n.uil-text-size:before {\n  content: '\\ebdf';\n}\n\n/* '' */\n.uil-text-strike-through:before {\n  content: '\\ebe0';\n}\n\n/* '' */\n.uil-text:before {\n  content: '\\ebe1';\n}\n\n/* '' */\n.uil-th-large:before {\n  content: '\\ebe2';\n}\n\n/* '' */\n.uil-th-slash:before {\n  content: '\\ebe3';\n}\n\n/* '' */\n.uil-th:before {\n  content: '\\ebe4';\n}\n\n/* '' */\n.uil-thermometer:before {\n  content: '\\ebe5';\n}\n\n/* '' */\n.uil-thumbs-down:before {\n  content: '\\ebe6';\n}\n\n/* '' */\n.uil-thumbs-up:before {\n  content: '\\ebe7';\n}\n\n/* '' */\n.uil-thunderstorm-moon:before {\n  content: '\\ebe8';\n}\n\n/* '' */\n.uil-thunderstorm-sun:before {\n  content: '\\ebe9';\n}\n\n/* '' */\n.uil-thunderstorm:before {\n  content: '\\ebea';\n}\n\n/* '' */\n.uil-ticket:before {\n  content: '\\ebeb';\n}\n\n/* '' */\n.uil-times-circle:before {\n  content: '\\ebec';\n}\n\n/* '' */\n.uil-times-square:before {\n  content: '\\ebed';\n}\n\n/* '' */\n.uil-times:before {\n  content: '\\ebee';\n}\n\n/* '' */\n.uil-toggle-off:before {\n  content: '\\ebef';\n}\n\n/* '' */\n.uil-toggle-on:before {\n  content: '\\ebf0';\n}\n\n/* '' */\n.uil-top-arrow-from-top:before {\n  content: '\\ebf1';\n}\n\n/* '' */\n.uil-top-arrow-to-top:before {\n  content: '\\ebf2';\n}\n\n/* '' */\n.uil-tornado:before {\n  content: '\\ebf3';\n}\n\n/* '' */\n.uil-trademark-circle:before {\n  content: '\\ebf4';\n}\n\n/* '' */\n.uil-trademark:before {\n  content: '\\ebf5';\n}\n\n/* '' */\n.uil-traffic-barrier:before {\n  content: '\\ebf6';\n}\n\n/* '' */\n.uil-trash-alt:before {\n  content: '\\ebf7';\n}\n\n/* '' */\n.uil-trash:before {\n  content: '\\ebf8';\n}\n\n/* '' */\n.uil-trees:before {\n  content: '\\ebf9';\n}\n\n/* '' */\n.uil-triangle:before {\n  content: '\\ebfa';\n}\n\n/* '' */\n.uil-trophy:before {\n  content: '\\ebfb';\n}\n\n/* '' */\n.uil-trowel:before {\n  content: '\\ebfc';\n}\n\n/* '' */\n.uil-truck-case:before {\n  content: '\\ebfd';\n}\n\n/* '' */\n.uil-truck-loading:before {\n  content: '\\ebfe';\n}\n\n/* '' */\n.uil-truck:before {\n  content: '\\ebff';\n}\n\n/* '' */\n.uil-tumblr-alt:before {\n  content: '\\ec00';\n}\n\n/* '' */\n.uil-tumblr-square:before {\n  content: '\\ec01';\n}\n\n/* '' */\n.uil-tumblr:before {\n  content: '\\ec02';\n}\n\n/* '' */\n.uil-tv-retro-slash:before {\n  content: '\\ec03';\n}\n\n/* '' */\n.uil-tv-retro:before {\n  content: '\\ec04';\n}\n\n/* '' */\n.uil-twitter-alt:before {\n  content: '\\ec05';\n}\n\n/* '' */\n.uil-twitter:before {\n  content: '\\ec06';\n}\n\n/* '' */\n.uil-umbrella:before {\n  content: '\\ec07';\n}\n\n/* '' */\n.uil-unamused:before {\n  content: '\\ec08';\n}\n\n/* '' */\n.uil-underline:before {\n  content: '\\ec09';\n}\n\n/* '' */\n.uil-university:before {\n  content: '\\ec0a';\n}\n\n/* '' */\n.uil-unlock-alt:before {\n  content: '\\ec0b';\n}\n\n/* '' */\n.uil-unlock:before {\n  content: '\\ec0c';\n}\n\n/* '' */\n.uil-upload-alt:before {\n  content: '\\ec0d';\n}\n\n/* '' */\n.uil-upload:before {\n  content: '\\ec0e';\n}\n\n/* '' */\n.uil-usd-circle:before {\n  content: '\\ec0f';\n}\n\n/* '' */\n.uil-usd-square:before {\n  content: '\\ec10';\n}\n\n/* '' */\n.uil-user-check:before {\n  content: '\\ec11';\n}\n\n/* '' */\n.uil-user-circle:before {\n  content: '\\ec12';\n}\n\n/* '' */\n.uil-user-exclamation:before {\n  content: '\\ec13';\n}\n\n/* '' */\n.uil-user-hard-hat:before {\n  content: '\\ec14';\n}\n\n/* '' */\n.uil-user-minus:before {\n  content: '\\ec15';\n}\n\n/* '' */\n.uil-user-plus:before {\n  content: '\\ec16';\n}\n\n/* '' */\n.uil-user-square:before {\n  content: '\\ec17';\n}\n\n/* '' */\n.uil-user-times:before {\n  content: '\\ec18';\n}\n\n/* '' */\n.uil-user:before {\n  content: '\\ec19';\n}\n\n/* '' */\n.uil-users-alt:before {\n  content: '\\ec1a';\n}\n\n/* '' */\n.uil-utensils-alt:before {\n  content: '\\ec1b';\n}\n\n/* '' */\n.uil-utensils:before {\n  content: '\\ec1c';\n}\n\n/* '' */\n.uil-vector-square-alt:before {\n  content: '\\ec1d';\n}\n\n/* '' */\n.uil-vector-square:before {\n  content: '\\ec1e';\n}\n\n/* '' */\n.uil-venus:before {\n  content: '\\ec1f';\n}\n\n/* '' */\n.uil-vertical-align-bottom:before {\n  content: '\\ec20';\n}\n\n/* '' */\n.uil-vertical-align-center:before {\n  content: '\\ec21';\n}\n\n/* '' */\n.uil-vertical-align-top:before {\n  content: '\\ec22';\n}\n\n/* '' */\n.uil-vertical-distribute-bottom:before {\n  content: '\\ec23';\n}\n\n/* '' */\n.uil-vertical-distribution-center:before {\n  content: '\\ec24';\n}\n\n/* '' */\n.uil-vertical-distribution-top:before {\n  content: '\\ec25';\n}\n\n/* '' */\n.uil-video-slash:before {\n  content: '\\ec26';\n}\n\n/* '' */\n.uil-video:before {\n  content: '\\ec27';\n}\n\n/* '' */\n.uil-visual-studio:before {\n  content: '\\ec28';\n}\n\n/* '' */\n.uil-vk-alt:before {\n  content: '\\ec29';\n}\n\n/* '' */\n.uil-vk:before {\n  content: '\\ec2a';\n}\n\n/* '' */\n.uil-voicemail-rectangle:before {\n  content: '\\ec2b';\n}\n\n/* '' */\n.uil-voicemail:before {\n  content: '\\ec2c';\n}\n\n/* '' */\n.uil-volleyball:before {\n  content: '\\ec2d';\n}\n\n/* '' */\n.uil-volume-down:before {\n  content: '\\ec2e';\n}\n\n/* '' */\n.uil-volume-mute:before {\n  content: '\\ec2f';\n}\n\n/* '' */\n.uil-volume-off:before {\n  content: '\\ec30';\n}\n\n/* '' */\n.uil-volume-up:before {\n  content: '\\ec31';\n}\n\n/* '' */\n.uil-volume:before {\n  content: '\\ec32';\n}\n\n/* '' */\n.uil-vuejs-alt:before {\n  content: '\\ec33';\n}\n\n/* '' */\n.uil-vuejs:before {\n  content: '\\ec34';\n}\n\n/* '' */\n.uil-wall:before {\n  content: '\\ec35';\n}\n\n/* '' */\n.uil-wallet:before {\n  content: '\\ec36';\n}\n\n/* '' */\n.uil-watch-alt:before {\n  content: '\\ec37';\n}\n\n/* '' */\n.uil-watch:before {\n  content: '\\ec38';\n}\n\n/* '' */\n.uil-water-drop-slash:before {\n  content: '\\ec39';\n}\n\n/* '' */\n.uil-water-glass:before {\n  content: '\\ec3a';\n}\n\n/* '' */\n.uil-water:before {\n  content: '\\ec3b';\n}\n\n/* '' */\n.uil-web-grid-alt:before {\n  content: '\\ec3c';\n}\n\n/* '' */\n.uil-web-grid:before {\n  content: '\\ec3d';\n}\n\n/* '' */\n.uil-web-section-alt:before {\n  content: '\\ec3e';\n}\n\n/* '' */\n.uil-web-section:before {\n  content: '\\ec3f';\n}\n\n/* '' */\n.uil-webcam:before {\n  content: '\\ec40';\n}\n\n/* '' */\n.uil-weight:before {\n  content: '\\ec41';\n}\n\n/* '' */\n.uil-whatsapp:before {\n  content: '\\ec42';\n}\n\n/* '' */\n.uil-wheel-barrow:before {\n  content: '\\ec43';\n}\n\n/* '' */\n.uil-wheelchair-alt:before {\n  content: '\\ec44';\n}\n\n/* '' */\n.uil-wheelchair:before {\n  content: '\\ec45';\n}\n\n/* '' */\n.uil-wifi-router:before {\n  content: '\\ec46';\n}\n\n/* '' */\n.uil-wifi-slash:before {\n  content: '\\ec47';\n}\n\n/* '' */\n.uil-wifi:before {\n  content: '\\ec48';\n}\n\n/* '' */\n.uil-wind-moon:before {\n  content: '\\ec49';\n}\n\n/* '' */\n.uil-wind-sun:before {\n  content: '\\ec4a';\n}\n\n/* '' */\n.uil-wind:before {\n  content: '\\ec4b';\n}\n\n/* '' */\n.uil-window-grid:before {\n  content: '\\ec4c';\n}\n\n/* '' */\n.uil-window-maximize:before {\n  content: '\\ec4d';\n}\n\n/* '' */\n.uil-window-restore:before {\n  content: '\\ec4e';\n}\n\n/* '' */\n.uil-window-section:before {\n  content: '\\ec4f';\n}\n\n/* '' */\n.uil-window:before {\n  content: '\\ec50';\n}\n\n/* '' */\n.uil-windsock:before {\n  content: '\\ec51';\n}\n\n/* '' */\n.uil-wrap-text:before {\n  content: '\\ec52';\n}\n\n/* '' */\n.uil-wrench:before {\n  content: '\\ec53';\n}\n\n/* '' */\n.uil-yellow:before {\n  content: '\\ec54';\n}\n\n/* '' */\n.uil-yen-circle:before {\n  content: '\\ec55';\n}\n\n/* '' */\n.uil-yen:before {\n  content: '\\ec56';\n}\n\n/* '' */\n.uil-yin-yang:before {\n  content: '\\ec57';\n}\n\n/* '' */\n.uil-youtube-alt:before {\n  content: '\\ec58';\n}\n\n/* '' */\n.uil-youtube:before {\n  content: '\\ec59';\n}\n\n/* '' */\n","\n// Plugins\n@import \"custom/plugins/icons\";\n\n.dropdown-toggle::after {\n  content: none;\n}","\n/* =======================\n    TABLE OF CSS\n    1. Fonts \n    2. General \n    3. Left Menu \n    4. Topbar \n    5. Page Head \n    6. Footer \n    7. Horizontal Nav \n    8. Right Sidebar \n    9. Layouts \n    10. Helper \n    11. Social \n    12. Widgets \n    13. Custom Checkbox \n    14. Custom Radio \n    15. Print \n    16. Preloader \n    17. Plugins \n    18. Components Demo \n    19. Tasks \n    20. Email \n    21. Timeline \n    22. Extra Pages \n    23. Authentication \n   ======================= */\n\n\n\n//Fonts\n/* 1. Fonts */\n@import \"custom/fonts/fonts\";\n\n//Core files\n@import \"./node_modules/bootstrap/scss/functions\";\n@import \"./node_modules/bootstrap/scss/variables\";\n@import \"variables-dark\";\n@import \"./node_modules/bootstrap/scss/mixins.scss\";\n\n// Structure\n/* 2. General */\n@import \"custom/structure/general\";\n/* 3. Left Menu */\n@import \"custom/structure/left-menu\";\n/* 4. Topbar */\n@import \"custom/structure/topbar\";\n/* 5. Page Head */\n@import \"custom/structure/page-head\";\n/* 6. Footer */\n@import \"custom/structure/footer\";\n/* 7. Horizontal Nav */\n@import \"custom/structure/horizontal-nav\";\n/* 8. Right Sidebar */\n@import \"custom/structure/right-sidebar\";\n/* 9. Layouts */\n@import \"custom/structure/layouts\";\n\n//Components\n/* 10. Helper */\n@import \"custom/components/helper\";\n/* 11. Social */\n@import \"custom/components/social\";\n/* 12. Widgets */\n@import \"custom/components/widgets\";\n/* 13. Custom Checkbox */\n@import \"custom/components/custom-checkbox\";\n/* 14. Custom Radio */\n@import \"custom/components/custom-radio\";\n/* 15. Print */\n@import \"custom/components/print\";\n/* 16. Preloader */\n@import \"custom/components/preloader\";\n\n// Plugins\n/* 17. Plugins */\n@import \"custom/plugins/slimscroll\";\n@import \"custom/plugins/apexcharts\";\n@import \"custom/plugins/calendar\";\n@import \"custom/plugins/react-select\";\n@import \"custom/plugins/multiple-select\";\n@import \"custom/plugins/flatpickr\";\n@import \"custom/plugins/bootstrap-touchspin\";\n@import \"custom/plugins/parsley\";\n@import \"custom/plugins/form-wizard\";\n@import \"custom/plugins/editor\";\n@import \"custom/plugins/dropzone\";\n@import \"custom/plugins/datatable\";\n@import \"custom/plugins/table-list-js\";\n@import \"custom/plugins/kanban\";\n@import \"custom/plugins/metismenu\";\n\n@import \"source-tabs\";\n@import \"main\";\n\n//Pages\n/* 18. Components Demo */\n@import \"custom/pages/components-demo\";\n/* 19. Tasks */\n@import \"custom/pages/tasks\";\n/* 20. Email */\n@import \"custom/pages/email\";\n/* 21. Timeline */\n@import \"custom/pages/timeline\";\n/* 22. Extra Pages */\n@import \"custom/pages/extra-pages\";\n/* 23. Authentication */\n@import \"custom/pages/authentication\";\n@import \"custom/plugins/grid\";\n\n","// \n// general.scss\n//\n\nhtml {\n  position: relative;\n  min-height: 100%;\n}\n\nbody {\n  padding-bottom: 10px;\n  overflow-x: hidden;\n  background:$body-bg\n}\n\nbutton {\n  outline: transparent;\n  background: transparent;\n  border: none;\n}\n\nfieldset {\n  font-family: sans-serif;\n  border: 1px solid #1F497D;\n  background: #fff;\n  border-radius: 5px;\n  padding: 15px;\n\n  label {\n    font-size: smaller;\n  }\n}\n\nfieldset legend {\n  background: #ffffff;\n  color: #045a5e;\n  padding: 8px 10px;\n  font-size: 13px;\n  border-radius: 4px;\n  box-shadow: 0 0 0 1px #045a5e;\n  margin-left: 6px;\n}","// \n// menu.scss\n//\n\n.button {\n  background-color: #4CAF50; /* Green */\n  border: none;\n  color: white;\n  padding: 1px 10px;\n  text-align: center;\n  text-decoration: none;\n  display: inline-block;\n  font-size: 13px;\n  margin: 4px 2px;\n  transition-duration: 0.4s;\n  cursor: pointer;\n}\n.button4 {\n  background-color: white;\n  color: black;\n  border: 2px solid #e7e7e7;\n}\n\n.button4:hover {background-color: #e7e7e7;}\n\n.button5 {\n  background-color: white;\n  color: black;\n  border: 2px solid #e7e7e7;\n}\n\n.button5:hover {\n  background-color: #555555;\n  color: white;\n}\n\n\n.nav-second-level-dark,\n.nav-thrid-level-dark {\n    li {\n        a {\n            padding: 8px 20px;\n            color:  #038FDD !important;\n            display: block;\n            position: relative;\n            transition: all 0.4s;\n            &:focus,\n            &:hover {\n                color: #fa8c15 !important;\n            }\n        }\n        > a.active {\n           color: #fa8c15 !important;\n        }\n    }\n}\n\n.nav-second-level,\n.nav-thrid-level {\n    li {\n        a {\n            padding: 8px 20px;\n            color: $menu-item;\n            display: block;\n            position: relative;\n            transition: all 0.4s;\n            &:focus,\n            &:hover {\n                color: $menu-item-hover;\n            }\n        }\n        > a.active {\n            color: $menu-item-active;\n        }\n    }\n}\n\n\n\n// Wrapper\n#wrapper {\n    height: 100%;\n    overflow: hidden;\n    width: 100%;\n}\n\n//Content Page\n.content-page {\n    margin-left: $leftbar-width;\n    overflow: hidden;\n    padding: 0px 12.5px 5px 12.5px;\n    min-height: 80vh;\n    margin-top: $topbar-height;\n}\n\n.For-Themes{\n    display: flex;\n    justify-content: space-evenly;\n    margin-top: 10px;\n}\n\n\n// Sidemenu\n.left-side-menu-dark {\n    width: $leftbar-width;\n    background: #003366;\n    // background: $bg-leftbar-light; \n    bottom: 0;\n    // padding: 30px 0;\n    padding: 0 0 30px 0;\n    position: fixed;\n    top: $topbar-height;\n    transition-duration: .2s;\n    box-shadow: 1px 0.05rem 0.01rem rgba(75,75,90,.075);\n    z-index: 99;\n\n    .sidebar-content {\n        height: 100%;\n        padding-bottom: 30px;\n    }\n}\n.left-side-menu-light {\n    width: $leftbar-width;\n    // background: #003366;\n    background: $bg-leftbar-light; \n    bottom: 0;\n    // padding: 30px 0;\n    padding: 0 0 30px 0;\n    position: fixed;\n    top: $topbar-height;\n    transition-duration: .2s;\n    box-shadow: 1px 0.05rem 0.01rem rgba(75,75,90,.075);\n    z-index: 99;\n\n    .sidebar-content {\n        height: 100%;\n        padding-bottom: 30px;\n    }\n}\n\n\n\n// Sidebar\n#sidebar-menu {\n    padding-bottom: 30px;\n    >ul {\n        >li {\n            &.mm-active{\n                >a{\n                    border-left: 3px solid $menu-item-active;\n                    color: $menu-item-active;\n                    background-color: $menu-item-bg-hover;\n                    svg {\n                        color: $menu-item-active;\n                        fill: rgba($menu-item-active, 0.10);\n                    }\n                }\n            }\n            >a {\n                color: $menu-item;\n                display: block;\n                padding: 12px 30px;\n                font-size: 15px;\n                font-weight: 400;\n                position: relative;\n                transition: all 0.4s;\n                border-left: 3px solid transparent;\n\n                svg {\n                    display: inline-block;\n                    width: 16px;\n                    height: 16px;\n                    margin: 0 10px 0 3px;\n                    color: $menu-item;\n                    fill: rgba($menu-item, 0.12);\n                }\n\n                &:hover,\n                &:focus,\n                &:active {\n                    color: $menu-item-hover;\n                    text-decoration: none;\n                    background-color: $menu-item-bg-hover;\n                    \n                    svg {\n                        color: $menu-item-active;\n                        fill: rgba($menu-item-active, 0.10);\n                    }\n                }\n                >span {\n                    vertical-align: middle;\n                }\n\n                i {\n                    display: inline-block;\n                    line-height: 1rem;\n                    margin: 0 10px 0 3px;\n                    text-align: center;\n                    vertical-align: middle;\n                    width: 20px;\n                }\n\n                &.active {\n                    border-left: 3px solid $menu-item-active;\n                    color: $menu-item-active;\n                    background-color: $menu-item-bg-hover;\n\n                    svg {\n                        color: $menu-item-active;\n                        fill: rgba($menu-item-active, 0.10);\n                    }\n                }\n               \n            }\n            \n            \n            > ul {\n                padding-left: 43px;\n\n                ul {\n                    padding-left: 20px;\n                }\n            }\n        }\n    }\n    .menu-arrow {\n        transition: transform .15s;\n        position: absolute;\n        right: 30px;\n        display: inline-block;\n        font-family: 'unicons';\n        text-rendering: auto;\n        line-height: 1.3rem;\n        font-size: 0.9rem;\n        transform: translate(0, 0);\n        top: 15px;\n        &:before {\n            content: \"\\e82f\";\n        }\n    }\n    \n    .badge{\n        margin-top: 3px;\n    }\n\n    .nav-second-level{\n        >li{\n            .menu-arrow{\n                top: 8px;\n            }\n        }\n    }\n\n    li.mm-active {\n        > a {\n            > span.menu-arrow {\n                transform: rotate(90deg);\n            }\n        }\n    }\n\n    .menu-title {\n        padding: 15px 30px 10px 30px;\n        letter-spacing: .05em;\n        pointer-events: none;\n        cursor: default;\n        font-size: 0.6875rem;\n        text-transform: uppercase;\n        color: $menu-item;\n    }\n}\n#sidebar-menu-dark {\n    padding-bottom: 30px;\n    >ul {\n        >li {\n            &.mm-active{\n                >a{\n                    border-left: 3px solid $menu-item-active;\n                     color: #fa8c15 !important;\n                    // background-color: $menu-item-bg-hover;\n                    svg {\n                        color: $menu-item-active;\n                        fill: rgba($menu-item-active, 0.10);\n                    }\n                }\n            }\n            >a {\n                color:#038FDD;\n                display: block;\n                padding: 12px 30px;\n                font-size: 15px;\n                font-weight: 400;\n                position: relative;\n                transition: all 0.4s;\n                border-left: 3px solid transparent;\n\n                svg {\n                    display: inline-block;\n                    width: 16px;\n                    height: 16px;\n                    margin: 0 10px 0 3px;\n                    // color: $menu-item;\n                    fill: rgba($menu-item, 0.12);\n                }\n\n                &:hover,\n                &:focus,\n                &:active {\n                     color: #fa8c15;\n                    text-decoration: none;\n                    // background-color: $menu-item-bg-hover; to stop white background from appearing\n                    \n                    svg {\n                        color: $menu-item-active;\n                        fill: rgba($menu-item-active, 0.10);\n                    }\n                }\n                >span {\n                    vertical-align: middle;\n                }\n\n                i {\n                    display: inline-block;\n                    line-height: 1rem;\n                    margin: 0 10px 0 3px;\n                    text-align: center;\n                    vertical-align: middle;\n                    width: 20px;\n                }\n\n                &.active {\n                    border-left: 3px solid $menu-item-active;\n                    color:  #fa8c15;\n\n                    svg {\n                        // color: $menu-item-active;\n                        fill: rgba($menu-item-active, 0.10);\n                    }\n                }\n               \n            }\n            \n            \n            > ul {\n                padding-left: 43px;\n\n                ul {\n                    padding-left: 20px;\n                }\n            }\n        }\n    }\n    .menu-arrow {\n        transition: transform .15s;\n        position: absolute;\n        right: 30px;\n        display: inline-block;\n        font-family: 'unicons';\n        text-rendering: auto;\n        line-height: 1.3rem;\n        font-size: 0.9rem;\n        transform: translate(0, 0);\n        top: 15px;\n        &:before {\n            content: \"\\e82f\";\n        }\n    }\n    \n    .badge{\n        margin-top: 3px;\n    }\n\n    .nav-second-level{\n        >li{\n            .menu-arrow{\n                top: 8px;\n            }\n        }\n    }\n\n    li.mm-active {\n        > a {\n            > span.menu-arrow {\n                transform: rotate(90deg);\n            }\n        }\n    }\n\n    .menu-title {\n        padding: 15px 30px 10px 30px;\n        letter-spacing: .05em;\n        pointer-events: none;\n        cursor: default;\n        font-size: 0.6875rem;\n        text-transform: uppercase;\n        color: $menu-item;\n    }\n}\n// user profile\n.user-profile {\n    padding: 15px 20px 15px 30px;\n\n    .avatar-xs {\n        display: none;\n    }\n\n    .pro-user-name {\n        color: $menu-item;\n        font-weight: $font-weight-semibold;\n    }\n\n    .pro-user-desc {\n        text-transform: uppercase;\n        font-size: 0.6rem;\n        font-weight: 700;\n        letter-spacing: 1px;\n    }\n\n    .dropdown-toggle {\n        svg {\n            width: 18px;\n            height: 18px;\n            color: $menu-item;\n            background-color: rgba($menu-item, 0.10);\n            border-radius: 3px;\n        }\n    }\n}\n.user-profile-dark {\n    padding: 15px 20px 15px 30px;\n\n    .avatar-xs {\n        display: none;\n    }\n\n    .pro-user-name {\n         color:  #038FDD !important;\n        font-weight: $font-weight-semibold;\n    }\n\n    .pro-user-desc {\n        text-transform: uppercase;\n        font-size: 0.6rem;\n        font-weight: 700;\n        letter-spacing: 1px;\n         color:  #038FDD !important;\n    }\n\n    .dropdown-toggle {\n        svg {\n            width: 18px;\n            height: 18px;\n          color:  #038FDD !important;\n            background-color: rgba($menu-item, 0.10);\n            border-radius: 3px;\n        }\n    }\n}\n\n.left-side-menu-condensed {\n    .logo {\n        width: $leftbar-width-collapsed !important;\n        text-align: center;\n        span{\n            &.logo-lg {\n                display: none;\n            }\n            &.logo-sm {\n                display: block !important;\n            }\n        }\n    }\n\n    // Topbar\n    .navbar-custom {\n        left: 0 !important;\n        padding-left: 10px;\n        .button-menu-mobile.disable-btn{\n            display: block !important;\n        }\n    }\n\n    // Side menu\n    .left-side-menu {\n        position: absolute;\n        width: $leftbar-width-collapsed !important;\n        z-index: 5;\n\n        .slimScrollDiv,\n        .slimscroll-menu {\n            overflow: inherit !important;\n            height: auto !important;\n        }\n        .slimScrollBar {\n            visibility: hidden;\n        }\n\n        .sidebar-content {\n            height: auto;\n        }\n\n        // Sidebar Menu\n        #sidebar-menu {\n            .menu-title,\n            .menu-arrow,\n            .label,\n            .badge {\n                display: none !important;\n            }\n\n            > ul {\n                > li {\n                    position: relative;\n                    white-space: nowrap;\n\n                    > a {\n                        padding: 15px;\n                        min-height: 54px;\n                        transition: none;\n                        margin: 0px;\n            \n                        &:hover,\n                        &:active,\n                        &:focus {\n                                  color: $menu-item-hover;\n                        }\n\n                        svg{\n                            width: 26px;\n                        }\n\n                        span {\n                            display: none;\n                            padding-left: 25px;\n                            vertical-align: baseline;\n                        }\n                        &.active{\n                            background-color: $menu-item-bg-hover;\n                        }\n\n                    }\n                    \n                    &:hover  {\n                        > a {\n                            position: relative;\n                            width: calc(190px + #{$leftbar-width-collapsed});\n                            color: $menu-item-active !important;\n                            background-color: $menu-item-bg-hover;\n                            transition: none;\n\n                            span {\n                                display: inline;\n                            }\n                        }\n\n                        a.open,a.mm-active {\n                            :after {\n                                display: none;\n                            }\n                        }\n\n                        > ul {\n                            display: block;\n                            left: $leftbar-width-collapsed;\n                            position: absolute;\n                            width: 190px;\n                            height: auto !important;\n                            box-shadow: $box-shadow-sm;\n\n                            ul {\n                                box-shadow: $box-shadow-sm;\n                            }\n                            a {\n                                box-shadow: none;\n                                padding: 8px 20px;\n                                position: relative;\n                                width: 190px;\n                                z-index: 6;\n                                &:hover {\n                                    color: $menu-item-hover;\n                                }\n                            }\n                        }\n                    }\n                }\n\n                ul {\n                    padding: 5px 0;\n                    z-index: 9999;\n                    display: none;\n                    background-color: $bg-leftbar-light;\n\n                    li {\n                        &:hover {\n                            > ul {\n                                display: block;\n                                left: 190px;\n                                margin-top: -36px;\n                                height: auto !important;\n                                position: absolute;\n                                width: 190px;\n                            }\n                        }\n\n                        > a {\n                            span.pull-right {\n                                position: absolute;\n                                right: 20px;\n                                top: 12px;\n                                transform: rotate(270deg);\n                            }\n                        }\n                    }\n                    li.active {\n                        a {\n                            color: $menu-item-hover-color-dark;\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n    .user-profile {\n        padding: 15px;\n    \n        .avatar-sm {\n            display: none;\n        }\n\n        .avatar-xs {\n            display: block;\n        }\n\n        .pro-user-name,\n        .pro-user-desc {\n            display: none;\n        }\n    \n        .profile-dropdown-menu {\n            .dropdown-toggle {\n                svg {\n                    background-color: transparent;\n                }\n            }\n        }\n    }\n\n    // Content Page\n    .content-page {\n        margin-left: $leftbar-width-collapsed !important;\n    }\n\n    //Footer\n    .footer {\n        left: $leftbar-width-collapsed !important;\n    }\n\n    //User box\n    .user-box {\n        display: none;\n    }\n}\n\n// Body min-height set\n\n@media (min-width: 769px){\n    body.left-side-menu-condensed {\n        min-height: 1200px;\n    }\n}\n\n@media (max-width: 1024px){\n    .left-side-menu{\n        top: $topbar-height;\n        padding: 12px 0;\n    }\n\n    .left-side-menu-condensed {\n        .left-side-menu{\n            padding-top: 12px;\n        }\n    }\n}\n\n\n@include media-breakpoint-down(sm) {\n    body {\n        overflow-x: hidden;\n    }\n    .left-side-menu {\n        display: none;\n        z-index: 10 !important;\n        top: $topbar-height;\n    }\n    .sidebar-enable {\n        .left-side-menu {\n            display: block;\n        }\n    }\n    .content-page,.left-side-menu-condensed .content-page {\n        margin-left: 0 !important;\n        padding: 0 10px;\n    }\n    .pro-user-name {\n        display: none;\n    }\n    .logo-box {\n        display: none;\n    }\n}\n\n\n","// \n// topbar.scss\n//\n\n\n.navbar-custom {\n    padding: 0px 0px 0 32px;\n    position: fixed;\n    top: 0px;\n    left: 0px;\n    right: 0px;\n    height: $topbar-height;\n    z-index: 100;\n    background-color: $bg-topbar-light;\n    box-shadow: $box-shadow-sm;\n\n    .topnav-menu {\n        > li {\n            float: left;\n        }\n        .nav-link {\n            padding: 0 15px;\n            color: $menu-item;\n            min-width: 32px;\n            display: block;\n            line-height: $topbar-height;\n            text-align: center;\n            max-height: $topbar-height;\n            cursor: pointer;\n\n            svg {\n                height: 20px;\n                width: 20px;\n                color: $menu-item;\n                fill: rgba($menu-item, 0.12);\n            }\n\n            &:hover,\n            &:focus,\n            &:active {\n                svg {\n                    color: $menu-item-active;\n                    fill: rgba($menu-item-active, 0.10);\n                }\n            }\n        }\n    }\n    .dropdown.show {\n        .nav-link {\n            background-color: rgba($white,0.05);\n        }   \n    }\n\n    .menu-left {\n        overflow: hidden;\n    }\n\n    /* Search */\n    .app-search {\n        padding: 17px 0;\n        overflow: hidden;\n        margin-left: 15px;\n        margin-right: 15px;\n        form {\n            max-width: 320px;\n        }\n        .form-control {\n            border: 1px solid transparent;\n            height: 38px;\n            padding-left: 40px;\n            padding-right: 20px;\n             border: 1.5px solid $body-bg;\n             border-radius: 0px;\n            &:focus {\n                background-color: $white;\n                border: 1px solid $body-bg;\n            }\n        }\n        //--------------------------------------------------------forSvg----------------------------------------------------------\n        svg {\n            position: absolute;\n            z-index: 10;\n            font-size: 18px;\n            color: #16BFC7;\n            line-height: 38px;\n            left: 10px;\n            top: 10px;\n            width: 20px;\n            height: 20px\n        }\n    }\n    \n\n    .button-menu-mobile {\n        border: none;\n        color: $gray-500;\n        display: block;\n        height: $topbar-height;\n        line-height: $topbar-height;\n        width: 60px;\n        background-color: transparent;\n        font-size: 24px;\n        cursor: pointer;\n        margin-right: 45px;\n\n        &.disable-btn {\n            display: none;\n        }\n\n        .menu-icon {\n            display: inline-block;\n        }\n        .close-icon {\n            display: none;\n        }\n\n        &.open {\n            .menu-icon {\n                display: none;\n            }\n            .close-icon {\n                display: inline-block;\n            }\n        }\n    }\n\n    // Logo\n    .logo {\n        // width: $leftbar-width;\n\n        span.logo-sm {\n            display: none;\n        }\n    }\n}\n\n.text-logo {\n    text-transform: uppercase;\n    font-weight: 900;\n    letter-spacing: 1px;\n}\n\n/* Notification */\n@keyframes blinker {\n    50% {\n      opacity: 0;\n    }\n}\n\n.noti-scroll {\n    max-height: 230px;\n}\n\n.notification-list {\n    margin-left: 0;\n\n    .noti-title {\n        background-color: transparent;\n        padding: 7px 20px 15px;\n    }\n\n    .noti-icon {\n        font-size: 21px;\n        vertical-align: middle;\n    }\n\n    .noti-icon-badge {\n        display: inline-block;\n        position: absolute;\n        top: 24px;\n        right: 16px;\n        width: 12px;\n        height: 12px;\n        background-color: $danger;\n        border: 2px solid $bg-topbar-light;\n        border-radius: 50%;\n        box-shadow: $box-shadow-lg;\n        animation: blinker 3s linear infinite;\n        animation-fill-mode: initial;\n    }\n\n    .notify-item {\n        padding: 12px 20px;\n\n        .notify-icon {\n            float: left;\n            height: 36px;\n            width: 36px;\n            font-size: 16px;\n            line-height: 36px;\n            text-align: center;\n            margin-right: 10px;\n            border-radius: 50%;\n            color: $white;\n        }\n\n        .notify-details {\n            margin-bottom: 5px;\n            overflow: hidden;\n            margin-left: 45px;\n            text-overflow: ellipsis;\n            white-space: nowrap;\n            color: $gray-800;\n            line-height: 1.5;\n            \n            b {\n                font-weight: 500;\n            }\n            small {\n                display: block;\n            }\n            span {\n                display: block;\n                overflow: hidden;\n                text-overflow: ellipsis;\n                white-space: nowrap;\n                font-size: 13px;\n            }\n        }\n        \n        .user-msg {\n            margin-left: 45px;\n            white-space: normal;\n            line-height: 16px;\n        }\n    }\n    .profile-dropdown-items {\n        .notify-item {\n            padding: $dropdown-item-padding-y $dropdown-item-padding-x;\n        }\n    }\n}\n\n.profile-dropdown {\n    display: none;\n}\n\n.profile-dropdown-items {\n    width: 170px;\n    i {\n        vertical-align: middle;\n        margin-right: 5px;\n    }\n}\n\n.nav-user {\n    padding: 0 12px !important;\n    img {\n        height: 32px;\n        width: 32px;\n    }\n}\n\n\n@media (max-width: 1024px){\n    .navbar-custom {\n        left: 0;\n        padding: 0 10px;\n        margin: 0px;\n        .button-menu-mobile.disable-btn {\n            display: block;\n\n        }\n\n        .logo{\n            display: none;\n        }\n    }\n}\n\n@include media-breakpoint-down(xs) {\n    .navbar-custom{\n        .page-title{\n            display: none;\n        }\n    }\n}\n\n","// \n// page-title.scss\n//\n\n.page-title-topbar {\n    font-size: 20px;\n    margin: 0;\n    line-height: $topbar-height;\n}\n\n.page-title {\n    .breadcrumb {\n        background-color: transparent;\n        padding: 0;\n        margin-bottom: 0;\n    }\n\n    h4 {\n        font-size: 19px;\n    }\n}","// \n// footer.scss\n//\n\n.footer {\n    bottom: 0;\n    padding: 19px 15px 20px;\n    position: absolute;\n    right: 0;\n    color: $gray-600;\n    left: $leftbar-width;\n    .footer-links {\n        a {\n            color: $gray-600;\n            margin-left: 1.5rem;\n            transition: all .4s;\n            &:hover {\n                color: $gray-900;\n            }\n            &:first-of-type {\n                margin-left: 0;\n            }\n        }\n    }\n}\n\n.footer-alt {\n    left: 0 !important;\n    text-align: center;\n    background-color: transparent;\n}\n\n@include media-breakpoint-down(sm) {\n    .footer {\n        left: 0 !important;\n        text-align: center;\n    }\n}","// \n// horizontal-nav.scss\n//\n\nbody[data-layout=\"topnav\"] {\n    .container-fluid {\n        padding-right: $grid-gutter-width;\n        padding-left: $grid-gutter-width;\n    }\n\n    .navbar-custom {\n        position: relative;\n        padding: 0px;\n        .topnav-menu {\n            .nav-link{\n                &:hover,\n                &:focus,\n                &:active {\n                    svg {\n                        color: $menu-item;\n                    }\n                }\n            }\n        }\n    }\n\n    .content-page {\n        margin-top: 0px;\n        margin-left: 0px !important;\n        padding: 05px 0px 5px 0;\n    }\n\n    .footer {\n        left: 0;\n    }\n\n    .user-profile{\n        padding: 20px 0px;\n    }\n\n    .profile-dropdown {\n        display: block;\n    }\n\n    @media (max-width: 1024px)  {\n        .button-menu-mobile.disable-btn {\n            display: none;\n        }\n    }\n\n    @media (max-width: 375px)  {\n        .button-menu-mobile.disable-btn {\n            display: block;\n        }\n    }\n}\n\n\n.topnav {\n    background: $bg-topnav;\n}\n\n.topbar-nav {\n    margin: 0;\n    padding: 0;\n\n    .badge {\n        display: none;\n    }\n\n    .metismenu {\n        display: flex;\n        flex-direction: column;\n        margin: 0;\n\n        .has-arrow {\n            &:after {\n                width: 0.4em;\n                height: 0.4em;\n                right: 1rem;\n                transform: rotate(45deg) translate(0, -50%);\n            }\n        }\n\n        .menu-title {\n            display: none;\n        }\n\n        li {\n            &:hover,\n            &:focus,\n            &:active {\n                color: $menu-item-hover;\n                text-decoration: none;\n\n                svg {\n                    color: $menu-item-active;\n                    fill: rgba($menu-item-active, 0.10);\n                }\n            }\n\n            a {\n                color: $menu-item;\n                font-size: 1rem;\n                position: relative;\n                padding: 1rem;\n                display: block;\n\n                svg {\n                    display: inline-block;\n                    width: 16px;\n                    height: 16px;\n                    margin: 0 5px 0 0;\n                    color: $menu-item;\n                    fill: rgba($menu-item, 0.12);\n                }\n\n                >span {\n                    vertical-align: middle;\n                }\n\n                &:hover,\n                &:focus,\n                &:active {\n                    color: $menu-item-hover;\n                    text-decoration: none;\n\n                    svg {\n                        color: $menu-item-active;\n                        fill: rgba($menu-item-active, 0.10);\n                    }\n                }\n            }\n\n            &:nth-child(2) {\n                a {\n                    padding-left: 0px;\n                }\n            }\n\n            .menu-arrow {\n                transition: transform .15s;\n                display: inline-block;\n                font-family: 'unicons';\n                text-rendering: auto;\n                line-height: 1.3rem;\n                font-size: 1.25rem;\n                transform: translate(0, 0);\n                vertical-align: middle;\n                margin-left: 5px;\n                &:before {\n                    content: \"\\e82d\";\n                }\n            }\n\n            &.mm-active {\n                > a {\n                    color: $menu-item-active;\n                    svg {\n                        color: $menu-item-active;\n                        fill: rgba($menu-item-active, 0.10);\n                    }\n\n                    > span.menu-arrow {\n                        transform: rotate(180deg);\n                    }\n                }\n            }\n\n            &.active {\n                > a {\n                    color: $menu-item-active;\n                    svg {\n                        color: $menu-item-active;\n                        fill: rgba($menu-item-active, 0.10);\n                    }\n                }\n            }\n\n            .nav-second-level {\n                color: $menu-item;\n                background-color: $bg-topnav;\n                background-clip: padding-box;\n                border-radius: 0 0 $dropdown-border-radius $dropdown-border-radius;\n                min-width: calc(#{$dropdown-min-width} + 1.5rem);\n                @include font-size(calc(#{$dropdown-font-size} - 0.01rem));\n                box-shadow: $dropdown-box-shadow;\n                padding: $dropdown-padding-y 0;\n\n                li {\n                    &:hover,\n                    &:focus,\n                    &:active {\n                        color: $menu-item-hover;\n                        text-decoration: none;\n                    }\n                    &:first-of-type {\n                        padding-top: $dropdown-padding-y;\n                    }\n\n                    &:last-of-type {\n                        padding-bottom: $dropdown-padding-y;\n                    }\n                }\n\n                a {\n                    display: block;\n                    width: 100%;\n                    padding: $dropdown-item-padding-y $dropdown-item-padding-x !important;\n                    clear: both;\n                    font-size: $font-size-base;\n                    font-weight: $font-weight-base;\n                    line-height: $line-height-base;\n                    white-space: nowrap;\n                    background-color: transparent;\n                    border: 0;\n\n                    @include hover-focus {\n                        color: $dropdown-link-hover-color;\n                        text-decoration: none;\n                        @include gradient-bg($dropdown-link-hover-bg);\n                    }\n                }\n\n                .has-arrow {\n                    &:after {\n                        margin-top: -2px;\n                    }\n                }\n                .menu-arrow {\n                    float: right;\n                }\n            }\n\n            .nav-third-level {\n                color: $menu-item;\n                min-width: calc(#{$dropdown-min-width} + 1.5rem);\n                \n                li {\n                    &:hover,\n                    &:focus,\n                    &:active {\n                        color: $menu-item-hover;\n                        text-decoration: none;\n                    }\n                    &:first-of-type {\n                        padding-top: $dropdown-padding-y;\n                    }\n\n                    &:last-of-type {\n                        padding-bottom: $dropdown-padding-y;\n                    }\n                }\n\n                a {\n                    display: block;\n                    width: 100%;\n                    padding: $dropdown-item-padding-y $dropdown-item-padding-x !important;\n                    clear: both;\n                    font-size: $font-size-base;\n                    font-weight: $font-weight-base;\n                    line-height: $line-height-base;\n                    white-space: nowrap;\n                    background-color: transparent;\n                    border: 0;\n                    padding-left: 2.2rem !important;\n\n                    @include hover-focus {\n                        color: $dropdown-link-hover-color;\n                        text-decoration: none;\n                        @include gradient-bg($dropdown-link-hover-bg);\n                    }\n                }\n\n                .has-arrow {\n                    &:after {\n                        margin-top: -2px;\n                    }\n                }\n                .menu-arrow {\n                    float: right;\n                }\n            }\n        }\n    }\n}\n\n\n@include media-breakpoint-up(lg) {\n    body[data-layout=\"topnav\"] {\n        .container-fluid {\n            max-width: 85%;\n        }\n\n        .navbar-custom {\n            .logo{\n                display: block;\n                span{\n                    &.logo-sm{\n                        display: none !important;\n                    }\n                    &.logo-lg{\n                        display: block;\n                    }\n                }\n            }\n        }\n        &.left-side-menu-condensed {\n            .navbar-custom {\n                .button-menu-mobile.disable-btn{\n                    display: none !important;\n                }\n            }\n        }\n\n        &.boxed-layout {\n            .container-fluid {\n                max-width: 97%;\n            }\n        }\n    }\n\n    .topbar-nav {\n    \n        .metismenu {\n            \n            flex-direction: row;\n\n            >li {\n                flex-direction: column;\n\n                >ul {\n                    position: absolute;\n                    z-index: 1001;\n\n                }\n            }\n\n            .side-nav-item {\n                &:first-of-type {\n                    .side-nav-link {\n                        padding-left: 0;\n                    }\n                }\n\n            }\n\n        }\n    }\n\n    .navbar-toggle {\n        display: none;\n    }\n}\n\n@include media-breakpoint-down(md) {\n    body[data-layout=topnav]{\n        .navbar-custom{\n            .container-fluid{\n                padding-right: 12px;\n                padding-left: 12px;\n            }\n        }\n    }\n    .topnav {\n        overflow: auto;\n    }\n    .topbar-nav{\n        max-height: 400px;\n        .metismenu {\n            li{\n                a{\n                    padding: 15px 0px;\n                    \n                }\n                .nav-second-level{\n                    box-shadow: none;\n                    padding-top: 0px;\n                    li:first-of-type{\n                        padding: 0;\n                    }\n                    a{\n                        padding-right: 0px !important;\n                        &:hover, &:focus{\n                            background-color:transparent;\n                        }\n                    }\n                }\n\n                .menu-arrow{\n                    float: right;\n                    margin-top: 2px;\n                }\n            }\n        } \n    }\n}\n\n\n@media(min-width:992px) and (max-width:1180px){\n    .topbar-nav {\n        .metismenu {\n            li {\n                .menu-arrow{\n                    display: none;\n                }\n            }\n        }\n    }\n}","//\n// right-sidebar.scss\n//\n\n.right-bar {\n    background-color: $bg-rightbar;\n    box-shadow: 0 0 24px 0 rgba(0, 0, 0, 0.06), 0 1px 0 0 rgba(0, 0, 0, 0.02);\n    display: block;\n    position: fixed;\n    transition: all 200ms ease-out;\n    width: $rightbar-width;\n    z-index: 9999;\n    float: right !important;\n    right: -($rightbar-width + 10px);\n    top: 0;\n    bottom: 0;\n    padding-bottom: 60px;\n\n    .rightbar-title {\n        // border-bottom: 2px solid $gray-300;\n        padding: 25px 25px;\n    }\n    .right-bar-toggle {\n        height: 24px;\n        width: 24px;\n        line-height: 24px;\n        text-align: center;\n        border-radius: 50%;\n        margin-top: -4px;\n    }\n    .demo-img {\n        height: 200px;\n    }\n}\n\n// Rightbar overlay\n.rightbar-overlay {\n    background-color: rgba($dark, 0.55);\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    display: none;\n    z-index: 9998;\n    transition: all .2s ease-out;\n}\n\n.right-bar-enabled {\n    .right-bar {\n        right: 0;\n    }\n    .rightbar-overlay {\n        display: block;\n    }\n}\n\n@include media-breakpoint-down(sm) {\n    .right-bar {\n        overflow: auto;\n        .slimscroll-menu {\n            height: auto !important;\n        }\n    }\n}\n\n\n.activity-widget{\n    .activity-list{\n        border-bottom: 1px solid $gray-200;\n        padding: 12px 0px;\n        &:last-child{\n            border: none;\n        }\n    }\n}\n\n.upgrade-wid{\n    .laptop-img{\n        position: relative;\n        bottom: 22px;\n    }\n}","// \n// layouts.scss\n//\n\n// scrollable-layout\n\n@include media-breakpoint-up(xl) {\n.scrollable-layout{\n    padding-bottom: 0;\n    #wrapper {\n        display: flex;\n    }\n\n    .left-side-menu{\n        position: relative;\n        min-width: 250px;\n        min-height: 100vh;\n    }\n\n    .navbar-custom {\n        position: absolute;\n    }\n\n    .content-page {\n        margin-left: 0;\n        width: 100%;\n        padding-bottom: 60px;\n    }\n\n    &.left-side-menu-condensed{\n        .left-side-menu{\n            min-width: 70px;\n        }\n        .content-page {\n            margin-left: 0px!important;\n        }\n    }\n}\n\n}\n\n// boxed-layout\n\n.boxed-layout {\n    background: darken($body-bg, 2%);\n\n    #wrapper {\n        max-width: $boxed-layout-width;\n        margin: 0 auto;\n        box-shadow: $box-shadow;\n        background: $body-bg;\n    }\n\n    .navbar-custom {\n        max-width: $boxed-layout-width;\n        margin: 0 auto;\n    }\n\n    .footer {\n        margin: 0 auto;\n        max-width: calc(#{$boxed-layout-width} - #{$leftbar-width});\n        background: $body-bg;\n    }\n\n    &.left-side-menu-condensed {\n        min-height: auto;\n        .footer {\n            max-width: calc(#{$boxed-layout-width} - #{$leftbar-width-collapsed});\n        }\n    }\n}","//\n// helper.scss\n//\n\n// Minimum width\n\n.width-xs {\n  min-width: 80px;\n}\n\n.width-sm {\n  min-width: 95px;\n}\n\n.width-md {\n  min-width: 110px;\n}\n\n.width-lg {\n  min-width: 140px;\n}\n\n.width-xl {\n  min-width: 160px;\n}\n\n\n// Font Family\n.font-family-secondary {\n  font-family: $font-family-secondary;\n}\n\n// avatar height\n.avatar-xs {\n  height: 1.5rem;\n  width: 1.5rem;\n}\n\n.avatar-sm {\n  height: 2.25rem;\n  width: 2.25rem;\n}\n\n.avatar {\n  height: 3rem;\n  width: 3rem;\n}\n\n.avatar-md {\n  height: 3.5rem;\n  width: 3.5rem;\n}\n\n.avatar-lg {\n  height: 4.5rem;\n  width: 4.5rem;\n}\n\n.avatar-xl {\n  height: 6rem;\n  width: 6rem;\n}\n\n.avatar-xxl {\n  height: 7.5rem;\n  width: 7.5rem;\n}\n\n.avatar-title {\n  align-items: center;\n  color: $white;\n  display: flex;\n  height: 100%;\n  justify-content: center;\n  width: 100%;\n}\n\n.avatar-group {\n  padding-left: 12px;\n  .avatar-group-item {\n    margin: 0 0 10px -12px;\n    display: inline-block;\n    border: 2px solid $white;\n    border-radius: 50%;\n  }\n}\n\n\n// Font weight help class\n\n.font-weight-medium {\n  font-weight: 500;\n}\n\n.font-weight-semibold {\n  font-weight: 600;\n}\n\n\n// Text specify lines (Only chrome browser support)\n\n.sp-line-1,\n.sp-line-2,\n.sp-line-3,\n.sp-line-4 {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n.sp-line-1 {\n  -webkit-line-clamp: 1;\n}\n\n.sp-line-2 {\n  -webkit-line-clamp: 2;\n}\n\n\n.sp-line-3 {\n  -webkit-line-clamp: 3;\n}\n\n.sp-line-4 {\n  -webkit-line-clamp: 4;\n}\n\n// pull in\n\n.pull-in {\n  margin-left: -$card-spacer-x;\n  margin-right: -$card-spacer-x;\n}","\n// \n// social.scss\n//\n\n.social-list-item {\n    height: 2rem;\n    width: 2rem;\n    line-height: calc(2rem - 4px);\n    display: block;\n    border: 2px solid $gray-500;\n    border-radius: 50%;\n    color: $gray-500;\n}  ","// \n// widgets.scss\n//\n\n\n// Simple tile box\n.widget-flat {\n    position: relative;\n    overflow: hidden;\n\n    i.widget-icon {\n        font-size: 36px;\n    }\n}\n\n/* Chat widget */\n\n.conversation-list {\n    list-style: none;\n    height: 332px;\n    padding: 0 7px;\n\n    li {\n        margin-bottom: 24px;\n    }\n\n    .chat-avatar {\n        float: left;\n        text-align: center;\n        width: 34px;\n\n        img {\n            border-radius: 100%;\n            width: 100%;\n        }\n\n        i {\n            font-size: 12px;\n            font-style: normal;\n        }\n    }\n\n    .ctext-wrap {\n        background: lighten($primary, 32%);\n        color: $primary;\n        border-radius: $border-radius;\n        display: inline-block;\n        padding: 4px 12px;\n        position: relative;\n        min-width: 160px;\n\n        i {\n            display: block;\n            font-size: 12px;\n            font-style: normal;\n            font-weight: $font-weight-bold;\n            position: relative;\n        }\n\n        p {\n            margin: 0;\n            padding-top: 3px;\n        }\n\n        &:after {\n            right: 98%;\n            top: 0;\n            border: solid transparent;\n            content: \" \";\n            height: 0;\n            width: 0;\n            position: absolute;\n            pointer-events: none;\n            border-top-color: lighten($primary, 32%);\n            border-width: 6px;\n            margin-left: -1px;\n            border-right-color: lighten($primary, 32%);\n        }\n    }\n\n    .conversation-text {\n        float: left;\n        font-size: 12px;\n        margin-left: 12px;\n        width: 70%;\n    }\n\n    .odd {\n        .chat-avatar {\n            float: right !important;\n        }\n\n        .conversation-text {\n            float: right !important;\n            margin-right: 12px;\n            text-align: right;\n            width: 70% !important;\n        }\n\n        .ctext-wrap {\n            background-color: $gray-300;\n            color: $gray-700;\n            &:after {\n                border-color: transparent;\n                border-left-color: $gray-300;\n                border-top-color: $gray-300;\n                left: 99% !important;\n            }\n        }\n    }\n}\n\n/* profile / users */\n.profile-widget {\n    position: relative;\n\n    .card-action {\n        position: absolute;\n        right: 7px;\n        top: 12px;\n        z-index: 100;\n    }\n\n    .card-img-top {\n        max-height: 220px;\n    }\n\n    .profile-info {\n        margin-top: -2.7rem;\n    }\n}\n\n.calendar-widget {\n    .flatpickr-calendar {\n        box-shadow: none;\n        border: $border-width solid $border-color !important;\n    }\n    .flatpickr-input {\n        display: none;\n    }\n}\n","// \n// Custom-checkbox.scss\n//\n\n.checkbox {\n    label {\n        display: inline-block;\n        padding-left: 8px;\n        position: relative;\n        font-weight: normal;\n        margin-bottom: 0;\n        &::before {\n            background-color: $gray-300;\n            border-radius: 3px;\n            border: 2px solid $gray-300;\n            content: \"\";\n            display: inline-block;\n            height: 18px;\n            left: 0;\n            margin-left: -18px;\n            position: absolute;\n            transition: 0.3s ease-in-out;\n            width: 18px;\n            outline: none !important;\n            top: 2px;\n        }\n        &::after {\n            color: $gray-700;\n            display: inline-block;\n            font-size: 11px;\n            height: 18px;\n            left: 0;\n            margin-left: -18px;\n            padding-left: 3px;\n            padding-top: 2px;\n            position: absolute;\n            top: 0;\n            width: 18px;\n        }\n    }\n    input[type=\"checkbox\"] {\n        cursor: pointer;\n        opacity: 0;\n        z-index: 1;\n        outline: none !important;\n        &:disabled+label {\n            opacity: 0.65;\n        }\n    }\n    input[type=\"checkbox\"]:focus+label {\n        &::before {\n            outline-offset: -2px;\n            outline: none;\n        }\n    }\n    input[type=\"checkbox\"]:checked+label {\n        &::after {\n            content: \"\";\n            position: absolute;\n            top: 6px;\n            left: 7px;\n            display: table;\n            width: 4px;\n            height: 8px;\n            border: 2px solid $gray-700;\n            border-top-width: 0;\n            border-left-width: 0;\n            -webkit-transform: rotate(45deg);\n            -ms-transform: rotate(45deg);\n            -o-transform: rotate(45deg);\n            transform: rotate(45deg);\n        }\n    }\n    input[type=\"checkbox\"]:disabled+label {\n        &::before {\n            background-color: $light;\n            cursor: not-allowed;\n        }\n    }\n}\n\n.checkbox.checkbox-circle {\n    label {\n        &::before {\n            border-radius: 50%;\n        }\n    }\n}\n\n.checkbox.checkbox-inline {\n    margin-top: 0;\n}\n\n.checkbox.checkbox-single {\n    input {\n        height: 18px;\n        width: 18px;\n        position: absolute;\n    }\n    label {\n        height: 18px;\n        width: 18px;\n        &:before {\n            margin-left: 0;\n        }\n        &:after {\n            margin-left: 0;\n        }\n    }\n}\n\n@each $color,\n$value in $theme-colors {\n    .checkbox-#{$color} {\n        input[type=\"checkbox\"]:checked+label {\n            &::before {\n                background-color: $value;\n                border-color: $value;\n            }\n            &::after {\n                border-color: $white;\n            }\n        }\n    }\n}","// \n// custom-radio.scss\n//\n\n.radio {\n    label {\n        display: inline-block;\n        padding-left: 8px;\n        position: relative;\n        font-weight: normal;\n        margin-bottom: 0;\n        &::before {\n            -o-transition: border 0.5s ease-in-out;\n            -webkit-transition: border 0.5s ease-in-out;\n            background-color: $white;\n            border-radius: 50%;\n            border: 2px solid $gray-600;\n            content: \"\";\n            display: inline-block;\n            height: 18px;\n            left: 0;\n            margin-left: -18px;\n            position: absolute;\n            transition: border 0.5s ease-in-out;\n            width: 18px;\n            outline: none !important;\n        }\n        &::after {\n            -moz-transition: -moz-transform 0.1s cubic-bezier(0.8, -0.33, 0.2, 1.33);\n            -ms-transform: scale(0, 0);\n            -o-transform: scale(0, 0);\n            -o-transition: -o-transform 0.1s cubic-bezier(0.8, -0.33, 0.2, 1.33);\n            -webkit-transform: scale(0, 0);\n            -webkit-transition: -webkit-transform 0.1s cubic-bezier(0.8, -0.33, 0.2, 1.33);\n            background-color: $gray-700;\n            border-radius: 50%;\n            content: \" \";\n            display: inline-block;\n            height: 10px;\n            left: 6px;\n            margin-left: -20px;\n            position: absolute;\n            top: 4px;\n            transform: scale(0, 0);\n            transition: transform 0.1s cubic-bezier(0.8, -0.33, 0.2, 1.33);\n            width: 10px;\n        }\n    }\n    input[type=\"radio\"] {\n        cursor: pointer;\n        opacity: 0;\n        z-index: 1;\n        outline: none !important;\n        &:disabled+label {\n            opacity: 0.65;\n        }\n    }\n    input[type=\"radio\"]:focus+label {\n        &::before {\n            outline-offset: -2px;\n            outline: 5px auto -webkit-focus-ring-color;\n            outline: thin dotted;\n        }\n    }\n    input[type=\"radio\"]:checked+label {\n        &::after {\n            -ms-transform: scale(1, 1);\n            -o-transform: scale(1, 1);\n            -webkit-transform: scale(1, 1);\n            transform: scale(1, 1);\n        }\n    }\n    input[type=\"radio\"]:disabled+label {\n        &::before {\n            cursor: not-allowed;\n        }\n    }\n}\n\n.radio.radio-inline {\n    margin-top: 0;\n}\n\n.radio.radio-single {\n    label {\n        height: 17px;\n    }\n}\n\n@each $color,\n$value in $theme-colors {\n    .radio-#{$color} {\n        input[type=\"radio\"]+label {\n            &::after {\n                background-color: $value;\n            }\n        }\n        input[type=\"radio\"]:checked+label {\n            &::before {\n                border-color: $value;\n            }\n            &::after {\n                background-color: $value;\n            }\n        }\n    }\n}","// \n// print.scss\n//\n\n// Used invoice page\n@media print {\n    .left-side-menu,\n    .right-bar,\n    .page-title-box,\n    .navbar-custom,\n    .footer {\n        display: none;\n    }\n    .card-body,\n    .content-page,\n    .right-bar,\n    .content,\n    body {\n        padding: 0;\n        margin: 0;\n    }\n}","// \n// preloader.scss\n//\n\n.preloader {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba($white, 0.75);\n    z-index: 9999;\n}\n\n.status {\n    height: 80px;\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    margin: -40px 0 0 -40px;\n}\n\n.spinner {\n    > div {\n        display: inline-block;\n        width: 16px;\n        height: 16px;\n        background: $white;\n        border: 2px solid $primary;\n        border-radius: 50%;\n        animation: circle-loader 1s infinite ease-in-out both;\n        margin: 0px 7px;\n    }\n    .circle1 {\n        animation-delay: -0.32s;\n    }\n    .circle2 {\n        animation-delay: -0.16s;\n    }\n}\n\n\n@keyframes circle-loader {\n    0%, 80%, 100% { \n        transform: scale(0.4);\n    } 40% { \n        transform: scale(1.0);\n    }\n}","//\n// slimscroll.scss\n//\n\n.slimScrollDiv {\n    height: auto !important;\n}\n\n.ps .ps__rail-y {\n    background: transparent !important;\n\n    &:hover {\n        background: transparent !important;\n    }\n}\n\n.ps__thumb-y {\n    width: 4px !important;\n    background: #eff1f5;\n}\n\n.ps__rail-y:hover>.ps__thumb-y,\n.ps__rail-y:focus>.ps__thumb-y,\n.ps__rail-y.ps--clicking .ps__thumb-y {\n    width: 4px !important;\n    background: #eff1f5;\n}","//\n// apexcharts.scss\n//\n.apex-charts {\n    min-height: 10px !important;\n\n    text {\n        font-family: $font-family-base !important;\n        fill: $gray-700;\n    }\n\n    .apexcharts-canvas {\n        margin: 0 auto;\n    }\n}\n\n.apexcharts-tooltip-title,\n.apexcharts-tooltip-text {\n    font-family: $font-family-base !important;\n}\n\n.apexcharts-legend-series {\n    font-weight: 400;\n}\n\n.apexcharts-gridline {\n    pointer-events: none;\n    stroke: $apex-grid-color;\n}\n\n.apexcharts-legend-text {\n    color: $gray-600 !important;\n    font-family: $font-family-base !important;\n    font-size: 13px !important;\n}\n\n.apexcharts-pie-label {\n    fill: $white !important;\n}\n\n.apexcharts-yaxis,\n.apexcharts-xaxis {\n    text {\n        font-family: $font-family-base !important;\n        fill: $gray-500;\n    }\n}\n\n.apexcharts-point-annotations,\n.apexcharts-xaxis-annotations,\n.apexcharts-yaxis-annotations {\n    text {\n        fill: $white;\n    }\n}\n\n.apexcharts-radar-series {\n    polygon {\n        fill: transparent;\n        stroke: $gray-300;\n    }\n\n    line {\n        stroke: $gray-300;\n    }\n}\n\n.apexcharts-pie-label,\n.apexcharts-datalabel,\n.apexcharts-datalabel-label,\n.apexcharts-datalabel-value {\n    fill: $white !important;\n}","// \n// calendar.scss\n//\n@import '~@fullcalendar/core/main.css';\n@import '~@fullcalendar/daygrid/main.css';\n@import '~@fullcalendar/bootstrap/main.css';\n@import '~@fullcalendar/timegrid/main.css';\n@import '~@fullcalendar/list/main.css';\n\n.calendar {\n    float: left;\n    margin-bottom: 0;\n}\n\n.fc-view {\n    margin-top: 30px;\n}\n\n.none-border {\n    .modal-footer {\n        border-top: none;\n    }\n}\n\n.fc-toolbar {\n    margin: 10px 0 5px 0;\n\n    h2 {\n        font-size: 1.25rem;\n        line-height: 1.875rem;\n        text-transform: uppercase;\n    }\n}\n\n.fc-day-grid-event {\n    .fc-time {\n        font-weight: $font-weight-medium;\n    }\n}\n\nth.fc-day-header {\n    padding: 0.5rem 0;\n}\n\n.fc-day {\n    background: transparent;\n}\n\n.fc-toolbar {\n\n    .fc-state-active,\n    .ui-state-active,\n    button:focus,\n    button:hover,\n    .ui-state-hover {\n        z-index: 0;\n    }\n}\n\n.fc {\n    th.fc-widget-header {\n        background: $gray-300;\n        font-size: 13px;\n        line-height: 20px;\n        padding: 10px 0;\n        text-transform: uppercase;\n        font-weight: $font-weight-medium;\n    }\n}\n\n.fc-unthemed {\n\n    th,\n    td,\n    thead,\n    tbody,\n    .fc-divider,\n    .fc-row,\n    .fc-popover {\n        border-color: $gray-300;\n    }\n\n    td.fc-today,\n    .fc-divider {\n        background: $gray-300;\n    }\n}\n\n\n.fc-button {\n    background: $gray-300;\n    border: none;\n    color: $gray-700;\n    text-transform: capitalize;\n    box-shadow: none;\n    border-radius: 3px;\n    margin: 0 3px;\n    padding: 6px 12px;\n    height: auto;\n}\n\n.fc-text-arrow {\n    font-family: inherit;\n    font-size: 1rem;\n}\n\n.fc-state-hover {\n    background: $gray-300;\n}\n\n.fc-state-highlight {\n    background: $gray-300;\n}\n\n.fc-state-down,\n.fc-state-active,\n.fc-state-disabled {\n    background-color: $primary;\n    color: $white;\n    text-shadow: none;\n}\n\n.fc-cell-overlay {\n    background: $gray-300;\n}\n\n.fc-unthemed {\n    .fc-today {\n        background: $white;\n    }\n}\n\n.fc-event {\n    border-radius: 2px !important;\n    border: none !important;\n    border-color: transparent !important;\n    cursor: move;\n    font-size: 0.8125rem !important;\n    margin: 5px 7px !important;\n    padding: 5px 5px !important;\n    text-align: center !important;\n}\n\n.external-event {\n    cursor: move;\n    margin: 10px 0;\n    padding: 8px 10px;\n    color: $white;\n    border-radius: 4px;\n}\n\n.fc-basic-view {\n    td.fc-week-number {\n        span {\n            padding-right: 8px;\n        }\n    }\n\n    td.fc-day-number {\n        padding-right: 8px;\n    }\n\n    .fc-content {\n        color: $white;\n    }\n}\n\n.fc-time-grid-event {\n    .fc-content {\n        color: $white;\n    }\n}\n\n@include media-breakpoint-down(sm) {\n    .fc-toolbar {\n        display: block;\n\n        .fc-left,\n        .fc-right,\n        .fc-center {\n            float: none;\n            display: block;\n            clear: both;\n            margin: 10px 0;\n        }\n    }\n\n    .fc {\n        .fc-toolbar {\n            >* {\n                >* {\n                    float: none;\n                }\n            }\n        }\n    }\n\n    .fc-today-button {\n        display: none;\n    }\n}\n\n// overriding button sizes\n.fc-toolbar {\n    .btn {\n        @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-line-height-sm, $btn-border-radius-sm);\n    }\n}","//\n// react select\n//\n\n.react-select {\n    > div {\n        border: $input-border-width solid $input-border-color;\n        background-color: transparent;\n\n        &:hover {\n            border: $input-border-width solid $input-border-color;\n        }\n    }\n\n    .react-select__single-value {\n        color: $input-color;\n    }\n}\n\n.rbt-token {\n    background-color: rgba($primary,0.2) !important;\n    color: $primary !important;\n}\n\n.rbt-input-multi.focus {\n    box-shadow: none !important;\n    background-color: $input-focus-bg !important;\n    border-color: $input-focus-border-color !important;\n}\n\n.react-select__control--is-focused {\n    border-color: $input-focus-border-color !important;\n    box-shadow: none !important;\n}\n\n.react-select__indicator-separator {\n    display: none;\n}\n\n.react-select__dropdown-indicator {\n    color: $gray-600;\n}\n\n.react-select__menu {\n    background-color: $dropdown-bg !important;\n    box-shadow: $box-shadow !important;\n    border: none !important;\n    border-radius: $dropdown-border-radius !important;\n    z-index: $zindex-dropdown !important;\n}\n\n.react-select__menu-list {\n    border: $dropdown-border-width solid $dropdown-border-color !important;\n    border-radius: $dropdown-border-radius !important\n}\n\n.react-select__option {\n    padding: $dropdown-item-padding-y $dropdown-item-padding-x !important;\n    color: $dropdown-link-color !important;\n\n    &:hover {\n        color: $dropdown-link-hover-color !important;\n        background-color: $dropdown-link-hover-bg !important;\n    }\n}\n\n.react-select__option--is-focused,\n.react-select__option--is-selected {\n    color: $dropdown-link-hover-color !important;\n    background-color: $dropdown-link-hover-bg !important;\n}\n\n.react-select__multi-value {\n    background-color: rgba($primary,0.2) !important;\n    color: $primary !important;\n\n    .react-select__multi-value__label {\n        color: $primary;\n    }\n\n    .react-select__multi-value__remove {\n        &:hover {\n            background-color: rgba($primary,0.2) !important;\n            color: $primary !important;\n        }\n    }\n}","//\n// multi-select.scss\n//\n\n.ms-container {\n    background: transparent url('../images/plugin/multiple-arrow.png') no-repeat 50% 50%;\n    width: auto;\n    max-width: 370px;\n    \n    .ms-list {\n        box-shadow: none;\n        border: $input-border-width solid $input-border-color;\n\n        &.ms-focus {\n            box-shadow: none;\n            border: $input-border-width solid $input-focus-border-color;\n        }\n    }\n    .ms-selectable {\n        background-color: $input-bg;\n        li {\n            &.ms-elem-selectable {\n                border: none;\n                padding: 5px 10px;\n                color: $gray-600;\n            }\n            &.ms-hover {\n                background-color: $primary;\n                color: $white;\n            }\n        }\n    }\n    .ms-selection {\n        background-color: $input-bg;\n        li{\n            &.ms-elem-selection {\n                border: none;\n                padding: 5px 10px;\n                color: $gray-600;\n            }\n            &.ms-hover {\n                background-color: $primary;\n                color: $white;\n            }\n        }\n    }\n}\n\n.ms-selectable {\n    box-shadow: none;\n    outline: none !important;\n}\n\n.ms-optgroup-label {\n    font-weight: $font-weight-medium;\n    font-family: $font-family-secondary;\n    color: $dark !important;\n    font-size: 13px;\n}","@import '~flatpickr/dist/flatpickr.css';\n\n.flatpickr-calendar {\n  overflow: hidden;\n  background-color: $card-bg;\n  box-shadow: none;\n  border: 2px solid $gray-300;\n\n  .flatpickr-time {\n    border: none !important;\n\n    input,\n    .flatpickr-am-pm {\n      color: $gray-600;\n\n      &:focus,\n      &:hover {\n        background: $gray-300;\n      }\n    }\n  }\n}\n\n.flatpickr-day {\n  color: $gray-600;\n\n  &.selected,\n  &.startRange,\n  &.endRange,\n  &.selected.inRange,\n  &.startRange.inRange,\n  &.endRange.inRange,\n  &.selected:focus,\n  &.startRange:focus,\n  &.endRange:focus,\n  &.selected:hover,\n  &.startRange:hover,\n  &.endRange:hover,\n  &.selected.prevMonthDay,\n  &.startRange.prevMonthDay,\n  &.endRange.prevMonthDay,\n  &.selected.nextMonthDay,\n  &.startRange.nextMonthDay,\n  &.endRange.nextMonthDay {\n    background: $primary !important;\n    border-color: $primary !important;\n  }\n\n  &.selected.startRange + .endRange:not(:nth-child(7n+1)),\n  &.startRange.startRange + .endRange:not(:nth-child(7n+1)),\n  &.endRange.startRange + .endRange:not(:nth-child(7n+1)) {\n    box-shadow: -10px 0 0 $primary !important;\n  }\n\n  &.today {\n    border-color: $gray-300 !important;\n  }\n\n  &.inRange {\n    background: darken($bg-leftbar-light, 4%) !important;\n    border-color: darken($bg-leftbar-light, 4%) !important;\n    box-shadow: -10px 0 0 darken($bg-leftbar-light, 4%) !important;\n\n    &.nextMonthDay {\n      background: darken($bg-leftbar-light, 4%) !important;\n      border-color: darken($bg-leftbar-light, 4%) !important;\n    }\n  }\n\n  &.flatpickr-disabled,\n  &.flatpickr-disabled:hover,\n  &.prevMonthDay,\n  &.nextMonthDay,\n  &.notAllowed,\n  &.notAllowed.prevMonthDay,\n  &.notAllowed.nextMonthDay {\n    color: rgba($gray-600, 0.4);\n  }\n\n  &.prevMonthDay.inRange,\n  &.nextMonthDay.inRange,\n  &.today.inRange,\n  &.today:hover,\n  &.today:focus,\n  &.prevMonthDay.today.inRange,\n  &.nextMonthDay.today.inRange,\n  &:hover,\n  &.prevMonthDay:hover,\n  &.nextMonthDay:hover,\n  &:focus,\n  &.prevMonthDay:focus,\n  &.nextMonthDay:focus {\n    background: $gray-300 !important;\n    border-color: $gray-300 !important;\n    color: $gray-600;\n  }\n}\n\n.flatpickr-time {\n\n  input:hover,\n  .flatpickr-am-pm:hover,\n  input:focus,\n  .flatpickr-am-pm:focus {\n    background: $gray-100 !important;\n  }\n}\n\n.flatpickr-months {\n\n  // background: $primary;\n  .flatpickr-month {\n    height: 48px !important;\n  }\n\n  .flatpickr-prev-month,\n  .flatpickr-next-month {\n    fill: $body-color !important;\n  }\n}\n\n.flatpickr-current-month {\n  color: $body-color;\n  font-size: 1rem !important;\n  padding: 8px 0 0 0 !important;\n\n  .flatpickr-monthDropdown-months {\n    .flatpickr-monthDropdown-month {\n      color: $gray-700;\n    }\n  }\n}\n\n.flatpickr-weekdays {\n  background: $primary !important;\n  display: none;\n}\n\n.flatpickr-weekday {\n  color: rgba($white, 0.6) !important;\n}","//\n// bootstrap-touchspin.scss\n//\n \n.bootstrap-touchspin {\n    .btn {\n        .input-group-text {\n            padding: 0;\n            border: none;\n            background-color: transparent;\n            color: inherit;\n        }\n    }\n}","//\n// parsley.scss\n//\n \n.parsley-errors-list {\n  margin: 0;\n  padding: 0;\n\n  > li {\n    list-style: none;\n    color: $danger;\n    margin-top: 10px;\n    padding: 4px 7px 4px 28px;\n    position: relative;\n    display: inline-block;\n    background-color: rgba($danger, 0.2);\n    border-radius: 7px;\n  \n    &:before {\n      content: \"\\ebee\";\n      font-family: \"unicons\";\n      position: absolute;\n      left: 8px;\n      top: 4px;\n    }\n    &:after {\n      content: \"\";\n      border: 8px solid transparent;\n      border-bottom-color: rgba($danger, 0.2);\n      position: absolute;\n      left: 14px;\n      top: -16px;\n    }\n  }\n}\n\n.parsley-error {\n  border-color: $danger;\n}\n\n.parsley-success {\n  border-color: $success;\n}","//\n// formm-wizard.scss\n//\n\n.sw-main{\n    box-shadow: none;\n    border: 1px solid darken($gray-300, 2%);\n    \n    .sw-toolbar{\n        background: transparent;\n        padding: 10px;\n    }\n    .step-content{\n        background-color: transparent !important;\n    }\n}\n\n// sw-theme-default\n\n.sw-theme-default{\n    .step-content{\n        background-color: transparent;\n    }\n\n    >ul.step-anchor{\n        >li{\n            >a{\n                color: $gray-600;\n                &:hover{\n                    color: $gray-600; \n                }\n                &:after{\n                    background: $primary;\n                }\n            }\n            &.active{\n                >a{\n                    color: $primary !important;\n                }\n            }\n            &.done{\n                >a{\n                    color: $gray-600 !important;\n                    &:after{\n                        background: $success;\n                    }\n                }\n            }\n        }\n    }\n}\n\n// sw-theme-arrows\n\n.sw-theme-arrows{\n    >ul.step-anchor{\n        background: $gray-300;\n        border-bottom-color: $gray-300;\n        \n        >li{\n            >a, >a:hover{\n                background: $gray-300;\n                color: $gray-600;\n            }\n\n            >a{\n                &::after{\n                    border-left-color: $gray-300!important;\n                }\n                &::before{\n                    border-left-color: $gray-400 !important;\n                }\n            }\n            &.active{\n                >a{\n                    background: $primary !important;\n                    border-color: $primary !important;\n                    &:after{\n                        border-left-color: $primary !important;\n                    }\n                }\n            }\n\n            &.done{\n                >a{\n                    background: lighten($primary, 24%) !important;\n                    border-color: lighten($primary, 24%) !important;\n                    &:after{\n                        border-left-color: lighten($primary, 24%) !important;\n                    }\n                    &::before{\n                        border-left-color: $primary !important;\n                    }\n                }\n            }\n        }\n    }\n}\n\n// sw-theme-circles\n\n.sw-theme-circles{\n    >ul.step-anchor{\n        margin-top: 30px;\n        background-color: transparent;\n        &:before{\n            background-color:$gray-300;\n        }\n        >li{\n            \n            >a{\n                font-size: 14px;\n                width: 40px;\n                height: 40px;\n                padding: 12px 0;\n                background-color:$gray-300;\n                border-color: $gray-200 !important;\n                box-shadow: none !important;\n                &:hover{\n                    background-color:$gray-300;\n                    \n                }\n\n                small {\n                    bottom: -20px;\n                    width: 100%;\n                }\n            }\n\n            >a, >a:hover{\n                color: $gray-600;\n                small{\n                    color: $gray-600;\n                }\n            }\n            &.active{\n                >a{\n                    background: $primary !important;\n                    border-color: $primary !important;\n                    color: $white !important;\n                    >small{\n                        color: $primary;\n                    }\n                }\n            }\n\n            &.done{\n                >a{\n                    background: $success !important;\n                    border-color: $success !important;\n                    color: $white !important;\n                    >small{\n                        color: $success;\n                    }\n                }\n            }\n        }\n    }\n}\n\n// sw-theme-dots\n\n.sw-theme-dots{\n    >ul.step-anchor{\n        background-color: transparent;\n        &:before{\n            background-color: $gray-300;\n        }\n        >li{\n            >a{\n                &:before{\n                    bottom: -6px;\n                    background: $gray-300;\n                }\n\n                &:after{\n                    left: 45%;\n                    bottom: -8px;\n                    background: $gray-400;\n                }\n            }\n            >a, >a:hover, >a:focus{\n                color: $gray-600;\n            }\n            &.active{\n                >a{\n                    color: $primary;\n                    &:after{\n                        background: $primary;\n                    }\n                }\n            }\n            &.done{\n                >a{\n                    color: $success;\n                    &:after{\n                        background: $success;\n                    }\n                }\n            }\n        }\n    }\n}\n\n\n\n// responsive\n\n@media (max-width: 768px){\n    .sw-main{\n        >ul.step-anchor{\n            >li{\n                display: block;\n                width: 100%;\n            }\n        }\n    }\n    .sw-theme-circles{\n        >ul.step-anchor{\n            >li>a{\n                >small{\n                    bottom: 14px;\n                    left: 76px;\n                }\n            }\n        }\n    }\n    .sw-theme-dots{\n        >ul.step-anchor{\n            >li{\n                >a:after {\n                    top: -36px;\n                    left: -31px !important;\n                }\n            }\n        }\n    }\n}","//\n// editor.scss\n//\n\n/* rich text editor */\n.rich-editor-wrapper {\n  border: 1px solid $border-color;\n  border-radius: 0.25rem;\n  min-height: 220px;\n\n  .rich-editor {\n    padding: 0.45rem 0.9rem;\n    font-size: 0.875rem;\n    font-weight: 400;\n    line-height: 1.5;\n    color: $body-color;\n  }\n\n  .rdw-dropdown-wrapper {\n    box-shadow: none;\n    border: 1px solid $border-color;\n    border-radius: 0.25rem;\n  }\n}\n\n.hide-toolbar {\n  display: none !important;\n}\n\n@include media-breakpoint-down(sm) {\n  .rich-editor-wrapper {\n    min-height: 300px;\n  }\n}\n\n.rdw-editor-toolbar {\n  background: transparent !important;\n  color: $body-color;\n  border: 1px solid $border-color !important;\n\n  .rdw-option-wrapper {\n    background: transparent !important;\n    border: 1px solid $border-color !important;\n\n    &:hover {\n      box-shadow: none !important;\n    }\n  }\n}","// \n// dropzone.scss\n//\n\n.dropzone {\n  border: 2px dashed rgba($dark, 0.2);\n  background: lighten($gray-200, 4%);\n  border-radius: 6px;\n}","//\n// datatable.scss\n//\n\n\n.react-bootstrap-table-pagination-list .pagination {\n    justify-content: flex-end;\n}\n\n.react-bootstrap-table {\n    table {\n        table-layout: auto;\n    }\n}\n\n@include media-breakpoint-down(sm) {\n    .react-bootstrap-table-pagination-list .pagination {\n        margin-top: 10px;\n        justify-content: flex-start;\n    }\n}\n\n.react-bs-table-sizePerPage-dropdown {\n    .btn {\n        padding: 0.28rem 0.8rem;\n        font-size: 0.875rem;\n        line-height: 1.5;\n        border-radius: 0.15rem;\n    }\n}","\n//\n// Table list js.scss\n//\n\n#pagination-list{\n  .pagination {\n    li{\n      a{\n        padding: .5rem .75rem;\n        border-radius: 50%;\n        display: block;\n        line-height: 1.25;\n        margin: 0 3px;\n      }\n      &.active{\n        a{\n          background-color: $primary;\n          color: $white;\n        }\n      }\n    }\n  }\n}\n\n#transaction-list{\n  .sort{\n    background: $custom-select-background;\n  }\n}\n\n#noresult-list{\n  .error-message {\n    display:none;\n  }\n}\n","// \n// taskboard.scss\n//\n\n.tasklist {\n    min-height: 40px;\n    margin-bottom: 0;\n    > li {\n      background-color: $card-bg;\n      box-shadow: $box-shadow-sm;\n      padding: 20px;\n      margin-bottom: 24px;\n      border-radius: 7px;\n      &:last-of-type {\n        margin-bottom: 0;\n        .btn-sm {\n          padding: 2px 8px;\n          font-size: 12px;\n        }\n      }\n    }\n  \n}\n\n\n\n.task-placeholder {\n  border: 1px dashed $gray-300 !important;\n  background-color: $card-bg !important;\n  padding: 20px;\n  box-shadow: none !important;\n}","/*!\n* metismenujs - v1.4.0\n* A menu plugin\n* https://github.com/onokumus/metismenujs#readme\n*\n* Made by Osman Nuri Okumus <onokumus@gmail.com> (https://github.com/onokumus)\n* Under MIT License\n*/\n\n:where(html) {\n  --mm-transition-timing-function: ease;\n  --mm-trantisition-duration: 0.35s;\n}\n\n.metismenu .mm-collapse:not(.mm-show) {\n  display: none;\n}\n\n.metismenu .mm-collapsing {\n  position: relative;\n  height: 0;\n  overflow: hidden;\n  flex-wrap: nowrap;\n  transition: height var(--mm-trantisition-duration) var(--mm-transition-timing-function);\n}\n\n.metismenu .has-arrow {\n  position: relative;\n}\n\n.metismenu .has-arrow::after {\n  position: absolute;\n  content: \"\";\n  width: 0.5em;\n  height: 0.5em;\n  border-width: 0 0 1px 1px;\n  border-style: solid;\n  border-color: initial;\n  inset-inline-end: 1em;\n  transform: rotate(45deg) translate(0, -50%);\n  transform-origin: top;\n  top: 50%;\n  transition: transform var(--mm-trantisition-duration) var(--mm-transition-timing-function);\n}\n\n*[dir=\"rtl\"] .metismenu .has-arrow::after {\n  transform: rotate(-135deg) translate(0, -50%);\n}\n\n.metismenu .mm-active>.has-arrow::after,\n.metismenu .has-arrow[aria-expanded=\"true\"]::after {\n  transform: rotate(-45deg) translate(0, -50%);\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .metismenu .mm-collapsing,\n  .metismenu .has-arrow::after {\n    transition-duration: 0.000000001s;\n  }\n}","// Metis Menu Overwrite\n@import './node_modules/metismenujs/scss/metismenujs';\n\n.metismenu {\n    padding: 0;\n\n    li {\n        list-style: none;\n\n        a {\n            &[aria-expanded=\"true\"] {\n                color: $menu-item-active !important;\n            }\n        }\n    }\n\n    ul {\n        padding: 0;\n\n        li {\n            width: 100%;\n        }\n    }\n\n    .mm-collapse:not(.mm-show) {\n        display: none;\n    }\n\n    .mm-collapsing {\n        position: relative;\n        height: 0;\n        overflow: hidden;\n        transition-timing-function: ease;\n        transition-duration: .35s;\n        transition-property: height, visibility;\n    }\n}","\n.recon-names {\n\n  ul {\n    padding: 0;\n    margin: 0;\n    min-width: 170px;\n    font-size: 12px;\n  }\n\n  li {\n    padding: 0;\n    margin: 0;\n    height: 40px;\n  }\n\n}\n",".cron_builder_bordering {\n    border: none;\n    border-top: none;\n    text-align: center;\n    padding: 10px;\n    background: #fff;\n}\n.cron_builder_bordering_dark {\n    border: 1px solid #ddd;\n    border-top: none;\n    text-align: center;\n    padding: 10px;\n    background: #323742;\n    color: white;\n}\n.cron_builder_bordering input, .cron_builder_bordering select {\n    width: 100px;\n    margin-right: 10px;\n    margin-left: 10px;\n    border: none;\n    border-radius: 4px;\n    outline: none;\n    padding-left: 5px;\n    cursor: pointer;\n}\n.cron_builder_bordering_dark input, .cron_builder_bordering_dark select {\n    width: 100px;\n    margin-right: 10px;\n    margin-left: 10px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    outline: none;\n    padding-left: 5px;\n    cursor: pointer;\n    background-color: #323742;\n    color: white;\n}\n.df {\n    display: flex;\n}\n.cron-builder-bg {\n    background-color: #086090;\n    color: white;\n    text-align: center;\n    margin-bottom: 4px;\n    padding: 8px 0px;\n}\n.cron-builder-bg-dark {\n    background-color: #323742;\n    color: white;\n    text-align: center;\n    margin-bottom: 4px;\n    padding: 8px 0px;\n}\n.cron_builder_bordering select {\n    background-color: white;\n    width: 75px;\n    cursor: pointer;\n    padding: 4px 2px;\n    border-radius: 4px;\n}\n.cron_builder_bordering_dark select {\n    background-color: #323742;\n    color: white;\n    width: 75px;\n    cursor: pointer;\n    padding: 4px 2px;\n    border-radius: 4px;\n}\n.cron_builder_bordering select option:hover {\n    background-color: #086090;\n}\n.cron_builder_bordering_dark select option:hover {\n    background-color: #323742;\n}\n.well-small input {\n    width: auto !important;\n}\n.cron_builder_bordering input[type='radio'] {\n    margin-top: 0px;\n    vertical-align: middle;\n}\n.cron_builder_bordering_dark input[type='radio'] {\n    margin-top: 0px;\n    vertical-align: middle;\n}\n.cron_builder {\n    border: 1px solid #d0cbcb;\n    padding: 5px;\n    background-color: #dddef13d;\n    width: 100%;\n    // max-width: 600px;\n}\n.cron_builder_dark {\n    border: 1px solid #d0cbcb;\n    padding: 5px;\n    background-color: #64687C;\n    width: 100%;\n    // max-width: 600px;\n}\n.text_align_left {\n    text-align: left;\n}\n.cron_builder .nav li {\n    cursor: pointer;\n    flex: 0 0 85px;\n    text-align: center;\n}\n.cron_builder .nav li a {\n    color:#337ab7;\n\n}\n.cron_builder_dark .nav li {\n    cursor: pointer;\n    flex: 0 0 85px;\n    text-align: center;\n}\n.cron_builder_dark .nav li a {\n    color:white;\n\n}\n.cron_builder .nav-tabs .nav-link:focus, .cron_builder .nav-tabs .nav-link:hover {\n    box-shadow: 5px 1px #16BFC7;\n      border: 1px solid #16BFC7;\n      border-bottom: none !important;\n    background-color: white;\n    // border-color: transparent transparent transparent;\n    // background-color: #eeeeee;\n}\n.cron_builder_dark .nav-tabs .nav-link:focus, .cron_builder_dark .nav-tabs .nav-link:hover {\n    justify-content: space-around;\n    box-shadow: 5px 1px #16BFC7;\n      border: 1px solid #16BFC7;\n      border-bottom: none;\n    background-color: transparent;\n    // border-color: transparent transparent transparent;\n    // background-color: #eeeeee;\n}\n.cron_builder .nav-tabs .nav-item.show .nav-link, .cron_builder .nav-tabs .nav-link.active {\n    box-shadow: 5px 1px #16BFC7;\n      border: 1px solid #16BFC7;\n      border-bottom: none !important;\n    background-color: #dddef13d;\n    color: black !important;\n    // border-color: #dee2e6 #dee2e6 #fff;\n    // background-color: #ffffff;\n}\n.cron_builder_dark .nav-tabs{\n    justify-content: space-around;\n}\n.cron_builder_dark .nav-tabs .nav-item.show .nav-link, .cron_builder_dark .nav-tabs .nav-link.active {\n    box-shadow: 5px 1px #16BFC7;\n      border: 1px solid #16BFC7;\n      border-bottom: none !important;\n    background-color: #323742;\n    color: #16BFC7 !important;\n    // border-color: #dee2e6 #dee2e6 #fff;\n    // background-color: #ffffff;\n}\n.cron_builder { \n    font-size: 14px;\n}\n.cron_builder_dark { \n    font-size: 14px;\n}\n.cron_builder .well {\n    min-height: 20px;\n    padding: 19px;\n    margin-bottom: 20px;\n    background-color: #f5f5f5;\n    border: 1px solid #e3e3e3;\n    border-radius: 4px;\n    /* -webkit-box-shadow: inset 0 1px 1px rgb(0 0 0 / 5%); */\n    /* box-shadow: inset 0 1px 1px rgb(0 0 0 / 5%); */\n}\n.cron_builder_dark .well {\n    min-height: 20px;\n    padding: 19px;\n    margin-bottom: 20px;\n    background-color: #64687C !important;\n    border: 1px solid #e3e3e3;\n    border-radius: 4px;\n    /* -webkit-box-shadow: inset 0 1px 1px rgb(0 0 0 / 5%); */\n    /* box-shadow: inset 0 1px 1px rgb(0 0 0 / 5%); */\n}\n@media screen and (max-width:767px) {\n    .cron_builder .nav li {\n        cursor: pointer;\n        flex: 0 0 65px;\n        text-align: center;\n    }\n}\n@media screen and (max-width:767px) {\n    .cron_builder_dark .nav li {\n        cursor: pointer;\n        flex: 0 0 65px;\n        text-align: center;\n    }\n}",".ruleGroup {\n  padding: 0.5rem;\n  border: 1px solid #7f81a2;\n  border-radius: 4px;\n  background: rgba(0, 75, 183, 0.2);\n\n  .rule,\n  .ruleGroup {\n    margin-top: 0.5rem;\n    margin-left: 0.5rem;\n  }\n\n  .ruleGroup-combinators.betweenRules {\n    margin-top: 0.5rem;\n  }\n\n  .ruleGroup-notToggle {\n    margin-right: 0.5rem;\n  }\n}\n","@import '~react-perfect-scrollbar/dist/css/styles.css';\n@import 'cron-builder';\n@import 'react-querybuilder/dist/query-builder.scss';\n\n.react-datepicker__time-container {\n    width: 90px !important;\n\n    .react-datepicker__time {\n        width: 90px !important;\n\n        .react-datepicker__time-box {\n            width: 90px !important;\n\n            ul.react-datepicker__time-list {\n                width: 90px !important;\n            }\n        }\n    }\n\n    .react-datepicker__header:not(.react-datepicker__header--has-time-select) {\n        height: 64px;\n    }\n}\n\n.text-muted {\n    color: #4bb3bc !important;\n}\n\n.for-update-recon-setup {\n    margin-top: 20px;\n}\n\n.card-title {\n    color: #4bb3bc !important;\n}\n\n.btn-primary {\n    color: #fff;\n    background: #16bfc7;\n    border: none;\n}\n\n.btn-link {\n    color: #16bfc7 !important;\n}\n\n.btn-primary.disabled,\n.btn-primary:disabled {\n    color: #fff !important;\n    background-color: #566768 !important;\n    border-color: #566768 !important;\n}\n\n.list-group-item.active {\n    z-index: 2;\n    color: #fff;\n    background-color: #16bfc7 !important;\n    border-color: #16bfc7 !important;\n}\n\n.box-layout {\n    border: 0px solid;\n    padding: 0px !important;\n    width: 30vh !important;\n    border-radius: 3px;\n    height: fit-content;\n    min-height: 86vh;\n    margin-left: 10px;\n    margin-right: 10px;\n    box-shadow: 2px 2px 2px #443c7c14;\n}\n\n.view-style {\n    background: rgba(0, 75, 183, 0.2) !important;\n    border: 1px solid #7f81a2 !important;\n    border-radius: 2px !important;\n}\n\n.view-text-box-dark {\n    background-color: #3b3b3b;\n    color: white !important;\n    border-color: rgb(118, 118, 118) !important;\n    border-radius: 2px !important;\n    height: 23px;\n    box-sizing: border-box;\n    font-size: inherit;\n    font-family: inherit;\n    border: 1px solid;\n}\n\n.view-text-box {\n    height: 23px;\n    box-sizing: border-box;\n    font-size: inherit;\n    font-family: inherit;\n    border: 1px solid;\n}\n\n.box-layout-dark {\n    background-color: #494e67;\n}\n\n.box-layout-white {\n    background-color: #ffffff;\n}\n\n.contextMenu {\n    z-index: 999;\n    position: fixed;\n    opacity: 1;\n    pointer-events: auto;\n    top: 172px;\n    left: 331px;\n    border: 1px solid #16bfc7;\n    background-color: #16bfc7;\n    padding: 5px;\n    border-radius: 3px;\n    color: #fff;\n}\n\n.forHeader {\n    margin: 0px 0px 0px 0px !important;\n    height: 50px !important;\n    padding-top: 5px !important;\n    background-color: #373c53 !important;\n    border-radius: 3px !important;\n    font-size: 16px !important;\n    padding-top: 12px !important;\n    padding-left: 13px !important;\n}\n\n.forHeaderSource {\n    margin: 0px 0px 0px 0px !important;\n    height: 50px !important;\n    padding-top: 5px !important;\n    background-color: #373c53 !important;\n    border-radius: 3px !important;\n    font-size: 16px !important;\n    padding-top: 12px !important;\n    padding-left: 13px !important;\n    width: 231px !important;\n}\n\n.forHeader-dark {\n    background-color: #373c53 !important;\n}\n\n.forHeader-white {\n    background-color: #d7e1ec !important;\n    color: black !important;\n}\n\n.nav-tabs li a.active {\n    color: #16bfc7 !important;\n    border-radius: 0px !important;\n    font-size: 14px !important;\n    border: none !important;\n    width: 100% !important;\n}\n\n.for-edit-button {\n    float: right;\n}\n\n.for-nav-item {\n    padding-left: 10px;\n}\n\n.for-title-name {\n    font-size: 19px;\n    padding-top: 10px;\n    font-weight: 100;\n}\n\n.for-title-name-white {\n    color: black;\n}\n\n.for-title-name-dark {\n    color: white;\n}\n\n.commentHeight {\n    height: 130px !important;\n}\n\n.nav-tabs .nav-link {\n    font-size: 14px;\n    padding: 5.5px 0px 5px 20px;\n    font-weight: normal;\n}\n\n.nav-tabs {\n    border-bottom: none !important;\n}\n\n.col-md-2 {\n    flex: 0 0 16.66667%;\n    max-width: 15%;\n}\n\n.for-closing-icon {\n    width: 25px;\n    margin: 12px 10px 0px 24px;\n    opacity: 0.7;\n}\n\n.for-source-type-layout {\n    margin-top: 8px;\n    margin-right: 20px;\n}\n\n.top-recon-container {\n    display: flex;\n    justify-content: space-between;\n}\n\n.for-recon-card-header-white {\n    background-color: white;\n}\n\n.for-recon-card-header-dark {\n    background-color: #494e67 !important;\n}\n\n.btn-secondary {\n    color: #fff;\n    background-color: #16bfc7;\n    border: none;\n}\n\n.btn-secondary:hover {\n    color: #fff;\n    background-color: #16bfc7;\n    border: none;\n    opacity: 0.8;\n}\n\n.btn-secondary:focus {\n    color: #fff;\n    background-color: #16bfc7;\n    border: none;\n}\n\n.for-recon-cardBody {\n    padding: 0px;\n}\n\n.for-recon-card-white {\n    background-color: white;\n}\n\n.for-recon-card-dark {\n    background-color: #494e67;\n}\n\n.for-layout-recon {\n    display: flex;\n    justify-content: flex-start;\n}\n\n.for-select {\n    width: 12vw !important;\n    height: 25px;\n    border-radius: 4px;\n    border: 0.5px solid;\n    background-color: transparent;\n    margin-top: 0.1px;\n    padding: 2px;\n    font-size: 15px;\n    opacity: 0.8;\n}\n\n// .for-select-white{\n\n// }\n\n.for-select-dark {\n    border-color: white;\n    color: white !important;\n    background-color: #373c53;\n}\n\n// .css-1uccc91-singleValue{\n//     color: white;\n// }\n\n.css-yk16xz-control {\n    border-color: black;\n    color: black !important;\n    background-color: white;\n}\n\n.for-recon-save-botton {\n    position: fixed;\n    top: 110px;\n    right: 13px;\n    z-index: 999;\n}\n\n.top-bar-dark {\n    width: 300px;\n    background-color: #121317;\n}\n\n.top-bar-light {\n    width: 250px;\n    background-color: #f6f6f6;\n}\n\n.TOP-CONTAINER {\n    display: flex;\n    flex-direction: column;\n}\n\n// For Source explorer\n.InContainer .ag-cell-inline-editing {\n    height: 100%;\n}\n\n//---------------------------------------------------------------------------------------------------------------------------------------------------\n\n.ps__thumb-x {\n    background-color: transparent;\n    border-radius: 6px;\n    transition: background-color 0.2s linear, height 0.2s ease-in-out;\n    -webkit-transition: background-color 0.2s linear, height 0.2s ease-in-out;\n    height: 6px;\n    bottom: 2px;\n    position: absolute;\n}\n\n.ps__thumb-y {\n    background-color: transparent;\n    border-radius: 6px;\n    transition: background-color 0.2s linear, height 0.2s ease-in-out;\n    -webkit-transition: background-color 0.2s linear, height 0.2s ease-in-out;\n    height: 6px;\n    bottom: 2px;\n    position: absolute;\n}\n\n.main-common {\n    transition: margin-left 0.5s;\n    margin-top: 62px;\n    padding-left: 30px !important;\n    padding-right: 30px !important;\n\n    @media screen and (max-height: 450px) {\n        .sidebar {\n            padding-top: 15px;\n        }\n\n        .sidebar a {\n            font-size: 18px;\n        }\n    }\n}\n\n.main {\n    margin-left: 78px;\n}\n\n.main2 {\n    margin-left: 300px !important;\n}\n\n#sidebar-menu>ul>li>a {\n    color: #6e768e;\n    display: block;\n    padding: 12px 35px !important;\n    font-size: 15px;\n    font-weight: 400;\n    position: relative;\n    transition: all 0.4s;\n    border-left: 3px solid transparent;\n    margin-left: -13px;\n}\n\n#sidebar-menu>ul>li>a svg {\n    display: inline-block;\n    width: 16px;\n    height: 16px;\n    margin: 0 20px 0 9px;\n    color: #6e768e;\n    fill: rgba(110, 118, 142, 0.12);\n}\n\n.user-profile {\n    padding: 14px 20px 14px 40px !important;\n}\n\n#sidebar-menu>ul>li>a>span {\n    vertical-align: middle;\n    margin-left: 18px;\n}\n\n.media-body {\n    flex: 1;\n    margin-left: 6px;\n}\n\n#sidebar-menu .menu-arrow {\n    transition: transform 0.15s;\n    position: absolute;\n    right: 30px;\n    display: inline-block;\n    font-family: 'unicons';\n    text-rendering: auto;\n    line-height: 1.3rem;\n    font-size: 0.9rem;\n    transform: translate(0, 0);\n    top: 15px;\n    /* left: 9px; */\n    margin-right: 15px;\n}\n\n.nav-second-level li a,\n.nav-thrid-level li a {\n    padding: 9px 49px;\n    color: #6e768e;\n    display: block;\n    position: relative;\n    transition: all 0.4s;\n}\n\n#sidebar-menu {\n    padding-bottom: 30px;\n}\n\n.footer {\n    bottom: 0;\n    padding: 19px 15px 20px;\n    position: absolute;\n    right: 0;\n    color: #8790a4;\n    left: 759px;\n}\n\n.sidebar {\n    position: fixed;\n    margin-top: 10px !important;\n    z-index: 1;\n    top: 3px;\n    left: 0;\n    overflow-x: hidden;\n    transition: 0.5s;\n    padding-top: 60px;\n    white-space: nowrap;\n    height: 1600px;\n}\n\n.sidebar-light {\n    width: 78px;\n    // background-color: white !;\n}\n\n.sidebar-dark {\n    width: 300px !important;\n    // background:#262939 !important;\n}\n\n.sidebar a {\n    padding: 8px 8px 8px 32px;\n    text-decoration: none;\n    font-size: 15px;\n    color: #818181;\n    display: block;\n    transition: 0.3s;\n}\n\n.sidebar a:hover {\n    color: #f1f1f1;\n}\n\n.sidebar .closebtn {\n    position: absolute;\n    top: 0;\n    right: 25px;\n    font-size: 36px;\n    margin-left: 50px;\n}\n\n.material-icons,\n.icon-text {\n    vertical-align: middle;\n}\n\n.material-icons {\n    padding-bottom: 3px;\n}\n\n.for-recon-select-container {\n    display: flex !important;\n}\n\n.for-select-recon-explorer {\n    padding: 5px !important;\n    margin-top: 5px !important;\n    width: 200px;\n}\n\n.recon-names {\n    &.recon-nav-item {\n        text-align: left;\n        display: block;\n        width: 100%;\n    }\n}\n\n.source-settings-button {\n    margin-top: 10vh;\n}\n\n.ag-theme-alpine .ag-cell-wrapper>*:not(.ag-cell-value):not(.ag-group-value) {\n    height: 20px;\n    display: flex;\n    align-items: center;\n    flex: none;\n}\n\n.for-settings-tab {\n    margin-left: 0px !important;\n    margin-top: 0px !important;\n    padding: 25px;\n    width: 383px;\n    border-radius: 0px;\n    height: 80vh;\n    overflow: auto;\n}\n\n.for-settings-tab-light {\n    background-color: white;\n}\n\n.for-settings-tab-dark {\n    background-color: #494e67;\n}\n\n.for-tab-title {\n    font-size: 20px;\n    font-style: italic;\n    color: #16bfc7;\n    border: 1px solid;\n    width: 158px;\n    padding-left: 39px;\n}\n\n.table th {\n    font-weight: 700;\n    width: 266px;\n}\n\n.ruleGroup {\n    .ruleGroup-header {\n        padding: 5px;\n    }\n\n    .rule-value {\n        width: 30%;\n    }\n\n    .rule-operators {\n        width: 30%;\n    }\n\n    .rule-fields {\n        width: 30%;\n    }\n\n    .ruleGroup-combinators {\n        width: 30%;\n    }\n}\n\n.cron_builder {\n    width: 100%;\n\n    .nav-tabs {\n        justify-content: space-around;\n    }\n}\n\n.headingContainer {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n}\n\n// .card {\n//     margin-bottom: 24px;\n//     border-radius: 10px;\n//     background: #494E67;\n// }\n\n.for-modal-body-calculations {\n    height: fit-content !important;\n    min-height: 490px !important;\n    padding-bottom: 26px;\n    border-radius: 10px;\n}\n\n.css-26l3qy-menu {\n    position: absolute !important;\n    z-index: 99999999 !important;\n}\n\nfieldset legend {\n    background: transparent !important;\n    color: cadetblue;\n    padding: 8px 10px;\n    font-size: 13px;\n    border-radius: 4px;\n    box-shadow: 0 0 0 1px #3b414e;\n    margin-left: 6px;\n}\n\nfieldset {\n    font-family: sans-serif;\n    border: 1px solid #3b414e;\n    background: transparent !important;\n    border-radius: 5px;\n    padding: 15px;\n    margin-top: 20px;\n    height: 370px;\n}\n\n.for-card-header {\n    border-radius: 5px;\n}\n\n.for-card-footer {\n    border-radius: 0px 0px 5px 5px;\n}\n\n.table th,\n.table td {\n    padding: 0.75rem;\n    vertical-align: top;\n    font-size: 13px !important;\n    width: 104px !important;\n    border: none;\n    padding-left: 15px;\n}\n\n.table-bordered {\n    border: 1px solid;\n}\n\n.table thead th {\n    vertical-align: bottom;\n    border-bottom: 1px solid;\n}\n\n.for-add-fields-button {\n    padding-left: 8px;\n    padding-top: 8px;\n}\n\n.for-dashboard-reco {\n    position: absolute;\n    z-index: 9;\n    top: 106px;\n    left: 166px;\n}\n\n.for-salesChart {\n    display: flex;\n    justify-content: space-between;\n}\n\n.buttonMargin {\n    margin-top: 10px;\n    margin-left: 10px !important;\n}\n\n.topbar-text-width {\n    width: 150px;\n}\n\n.for-layout-graph {\n    justify-content: space-between !important;\n}\n\n.for-graphql-modal {\n    margin-top: 300px !important;\n}\n\n.for-link-top {\n    color: #4bb4bc !important;\n}\n\n.for-scheme-color {\n    color: #4bb3bc;\n    font-size: 18.5px;\n}\n\n.remove-border {\n    border-bottom: none !important;\n}\n\n.forFormSource {\n    margin-left: 475px !important;\n}\n\n.date-search-button {\n    margin-left: 7px;\n}\n\n.for-label {\n    width: 175px;\n}\n\n.InContainer {\n    display: flex !important;\n    justify-content: space-between !important;\n}\n\n.forUpperDashboard {\n    max-height: 8vh;\n    display: flex !important;\n    justify-content: center !important;\n}\n\n.export {\n    height: 35px;\n    width: 35px;\n    margin-left: 10px;\n    margin-top: 2px;\n}\n\n#filter-text-box {\n    height: 32px !important;\n    margin-top: 6px !important;\n}\n\n.filter-text-box {\n    height: 32px !important;\n    margin-top: 10px !important;\n}\n\n.ps {\n    overflow-y: auto !important;\n}\n\n.submit-button {\n    // margin-top: 1px !important;\n    margin-top: 1px !important;\n    margin-bottom: 0px !important;\n    border: none;\n}\n\n.for-modal {\n    top: -200px;\n    left: 100px;\n    width: 82%;\n}\n\n.match-status-container {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n    margin-left: -146px !important;\n    font-size: 15px;\n    margin-top: 20px;\n}\n\n.for-multiselect {\n    margin-left: 100px;\n    width: 410px;\n}\n\n.for-search-button {\n    margin: 16px 0px 0px 321px !important;\n    width: 112px;\n}\n\n.for-search-button-date-source {\n    margin: 16px 0px 0px 295px !important;\n    width: 112px;\n}\n\n.for-clear-button-recon {\n    margin: 16px 0px 0px 25px !important;\n    width: 112px;\n}\n\n.for-showAllItems-button-recon {\n    margin: 16px 0px 0px 25px !important;\n    width: 135px;\n}\n\n.remove-border {\n    border-bottom: none !important;\n    width: 500px;\n}\n\n.forForm {\n    margin-top: 33px;\n    width: 980px;\n    display: flex;\n    justify-content: space-evenly;\n}\n\n.for-height {\n    height: 28px;\n}\n\n.process-date {\n    font-size: 20px;\n    margin-top: 6px;\n    text-align: center;\n    margin-right: 5px;\n    font-weight: bolder;\n}\n\n.for-label-recon {\n    width: 180px;\n    margin-left: -23px;\n}\n\n// .react-datepicker__input-container {\n//     position: relative;\n//     display: inline-block;\n//     width: 125%;\n//     margin-left: -26px;\n// }\n\n.forMargin {\n    margin: 6px;\n}\n\n.calculation-container {\n    margin-bottom: -7px;\n    display: flex;\n    justify-content: space-evenly !important;\n}\n\n.calculation-container-context {\n    width: 1400px !important;\n    display: flex;\n    justify-content: space-evenly !important;\n}\n\n.calculation-headings {\n    font-weight: bold;\n    font-size: 16px;\n}\n\n// ---- Dashboard spinner\n\n.middle {\n    top: 40%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    position: absolute;\n    z-index: 999 !important;\n}\n\n.bar {\n    width: 10px;\n    height: 70px;\n    background: #fff;\n    display: inline-block;\n    transform-origin: bottom center;\n    border-top-right-radius: 20px;\n    border-top-left-radius: 20px;\n    /*   box-shadow:5px 10px 20px inset rgba(255,23,25.2); */\n    animation: loader 1.2s linear infinite;\n}\n\n.bar1 {\n    animation-delay: 0.1s;\n}\n\n.bar2 {\n    animation-delay: 0.2s;\n}\n\n.bar3 {\n    animation-delay: 0.3s;\n}\n\n.bar4 {\n    animation-delay: 0.4s;\n}\n\n.bar5 {\n    animation-delay: 0.5s;\n}\n\n.bar6 {\n    animation-delay: 0.6s;\n}\n\n.bar7 {\n    animation-delay: 0.7s;\n}\n\n.bar8 {\n    animation-delay: 0.8s;\n}\n\n@keyframes loader {\n    0% {\n        transform: scaleY(0.1);\n        background: red;\n    }\n\n    50% {\n        transform: scaleY(1);\n        background: yellowgreen;\n    }\n\n    100% {\n        transform: scaleY(0.1);\n        background: transparent;\n    }\n}\n\n/* Style the tab */\n.tab {\n    height: 50px;\n    overflow: hidden;\n    background-color: #d7e1ec;\n    // min-height: 50px;\n    // border: 1px solid #ccc;\n    // border-bottom: 1px solid #D7E1EC !important;\n}\n\n.tab-dark {\n    height: 50px;\n    overflow: hidden;\n    background-color: #373c53;\n    // min-height: 50px;\n    // border: 1px solid #ccc;\n    // border-bottom: 1px solid #3b414e !important;\n}\n\n// tab style for trigger event\n.tab-trigger {\n    height: 58px;\n    overflow: hidden;\n    background-color: #d7e1ec;\n    // min-height: 50px;\n    // border: 1px solid #ccc;\n    // border-bottom: 1px solid #D7E1EC !important;\n}\n\n.tab-dark-trigger {\n    height: 58px;\n    overflow: hidden;\n    background-color: #373c53;\n    // min-height: 50px;\n    // border: 1px solid #ccc;\n    // border-bottom: 1px solid #3b414e !important;\n}\n\n/* Style the buttons that are used to open the tab content */\n.tab li {\n    background-color: inherit;\n    float: left;\n    border: none;\n    outline: none;\n    cursor: pointer;\n    padding: 14px 16px;\n    transition: 0.3s;\n}\n\n.tab-dark li {\n    background-color: inherit;\n    float: left;\n    border: none;\n    outline: none;\n    cursor: pointer;\n    padding: 14px 16px;\n    transition: 0.3s;\n    color: white;\n}\n\n/* Change background color of buttons on hover */\n.tab li:hover {\n    background-color: white;\n}\n\n.tab-dark li:hover {\n    background-color: #64687c;\n}\n\n/* Create an active/current tablink class */\n.tab li.active {\n    box-shadow: 5px 1px #16bfc7;\n    border: 1px solid #16bfc7;\n    border-bottom: none !important;\n    background-color: none;\n}\n\n.tab-dark li.active {\n    box-shadow: 5px 1px #16bfc7;\n    border: 1px solid #16bfc7;\n    border-bottom: none !important;\n    background-color: none;\n}\n\n/* Trigger event tabs use their own wrapper class, so they need the same\n   button, hover and active-tab treatment as .tab / .tab-dark */\n.tab-trigger li,\n.tab-dark-trigger li {\n    background-color: inherit;\n    float: left;\n    border: none;\n    outline: none;\n    cursor: pointer;\n    padding: 14px 16px;\n    transition: 0.3s;\n}\n\n.tab-dark-trigger li {\n    color: white;\n}\n\n.tab-trigger li:hover {\n    background-color: white;\n}\n\n.tab-dark-trigger li:hover {\n    background-color: #64687c;\n}\n\n.tab-trigger li.active,\n.tab-dark-trigger li.active {\n    box-shadow: 5px 1px #16bfc7;\n    border: 1px solid #16bfc7;\n    border-bottom: none !important;\n    background-color: none;\n}\n\n.table .condition-width {\n    width: 30% !important;\n}\n\n.table .action-width {\n    width: 10% !important;\n}\n\n.list-group-item-dark {\n    background-color: #494e67 !important;\n    color: #a1a8b8;\n}\n\n.react-datepicker-wrapper {\n    width: 100%;\n}\n\n.ag-row-group.ag-row-level-0 {\n    background-color: rgba(24, 29, 31, 0.07);\n}\n\n.ag-row-group.ag-row-level-1 {\n    background-color: rgba(24, 29, 31, 0.07);\n}\n\n.ag-row-group.ag-row-level-2 {\n    background-color: rgba(24, 29, 31, 0.07);\n}\n\n.ag-theme-alpine-dark {\n    --ag-background-color: #494e67;\n    --ag-foreground-color: white;\n    --ag-border-color: grey;\n    --ag-secondary-border-color: grey;\n    --ag-modal-overlay-background-color: rgba(24, 29, 31, 0.66);\n    --ag-header-background-color: #494e67;\n    --ag-tooltip-background-color: #222628;\n    --ag-odd-row-background-color: #494e67;\n    --ag-header-cell-hover-background-color: #494e67;\n    --ag-header-cell-moving-background-color: #494e67;\n    --ag-control-panel-background-color: #494e67;\n    --ag-subheader-background-color: #000;\n    --ag-input-disabled-background-color: #282c2f;\n    --ag-input-focus-box-shadow: 0 0 2px 0.5px rgba(255, 255, 255, 0.5), 0 0 4px 3px var(--ag-input-focus-border-color);\n    --ag-card-shadow: 0 1px 20px 1px black;\n    --ag-disabled-foreground-color: rgba(255, 255, 255, 0.5);\n    --ag-chip-background-color: rgba(255, 255, 255, 0.07);\n    --ag-input-disabled-border-color: rgba(104, 104, 110, 0.3);\n    --ag-input-disabled-background-color: rgba(104, 104, 110, 0.07);\n}\n\n.div-img {\n    position: fixed;\n    bottom: 5px;\n    right: 5px;\n    padding: 10px;\n    justify-content: center;\n    align-items: center;\n    display: flex;\n    padding-top: 20%;\n}\n\n// @keyframes spin {\n//     from {\n//         transform: scaleX(-1);\n//     }\n//     to {\n//         transform: scaleX(1);\n//     }\n//   }\n.enlarge {\n    transition: transform 0.2s;\n    width: 50px;\n    height: 50px;\n    margin: 0 auto;\n    // background-color: rgb(241, 241, 247);\n    border-radius: 0px;\n    // border: 1px solid black;\n    // animation: spin 3s linear infinite;\n}\n\n.enlarge:hover {\n    transform: scale(1.5);\n    // animation: none;\n}\n\n$dot-width: 10px;\n$dot-color: #3b5998;\n$speed: 1.5s;\n\n.typing {\n    position: relative;\n\n    .typingDot {\n        content: '';\n        animation: blink $speed infinite;\n        animation-fill-mode: both;\n        height: $dot-width;\n        width: $dot-width;\n        background: $dot-color;\n        position: absolute;\n        left: 0;\n        top: 0;\n        border-radius: 50%;\n\n        &:nth-child(2) {\n            animation-delay: 0.2s;\n            margin-left: $dot-width * 1.5;\n        }\n\n        &:nth-child(3) {\n            animation-delay: 0.4s;\n            margin-left: $dot-width * 3;\n        }\n    }\n}\n\n@keyframes blink {\n    0% {\n        opacity: 0.1;\n    }\n\n    20% {\n        opacity: 1;\n    }\n\n    100% {\n        opacity: 0.1;\n    }\n}\n\n//\n\n.floating-button {\n    position: fixed;\n    top: 120px;\n    bottom: 20px;\n    /* Adjust as needed */\n    right: 20px;\n    /* Adjust as needed */\n    //color: #00ffb0; /* Text color */\n    border: none;\n    border-radius: 5%;\n    /* Makes the button circular */\n    width: 50px;\n    /* Adjust as needed */\n    height: 50px;\n    /* Adjust as needed */\n    font-size: 20px;\n    text-align: center;\n    line-height: 50px;\n    /* Vertically center the text */\n    cursor: pointer;\n    z-index: 1000;\n    /* Ensure the button is above other content */\n}\n\n//\n.join-line {\n    position: relative;\n    padding-left: 20px;\n}\n\n.join-line:before {\n    content: '';\n    position: absolute;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    width: 2px;\n    background-color: #dee2e6;\n}\n\n.query-section {\n    background-color: #f8f9fa;\n    border-radius: 5px;\n    padding: 15px;\n}\n\n.table-hover tbody tr:hover {\n    background-color: rgba(0, 0, 0, 0.03);\n    cursor: pointer;\n}\n\ntable .override-font {\n    font-size: 16px !important;\n}","// \n// components-demo.scss\n//\n\n// Demo Only\n.button-list {\n    margin-left: -8px;\n    margin-bottom: -12px;\n    \n    .btn {\n        margin-bottom: 12px;\n        margin-left: 8px;\n    }\n}\n\n\n// Icon demo ( Demo only )\n.icons-list-demo {\n    div {\n        cursor: pointer;\n        line-height: 45px;\n        white-space: nowrap;\n        text-overflow: ellipsis;\n        display: block;\n        overflow: hidden;\n        color: $gray-600;\n        p {\n            margin-bottom: 0;\n            line-height: inherit;\n        }\n    }\n    i {\n        text-align: center;\n        vertical-align: middle;\n        font-size: 22px;\n        width: 50px;\n        height: 50px;\n        line-height: 50px;\n        margin-right: 12px;\n        border-radius: 50%;\n        display: inline-block;\n        transition: all 0.2s;\n    }\n    .col-lg-4 {\n        border-radius: 3px;\n        background-clip: padding-box;\n        margin-top: 10px;\n\n        &:hover {\n            i {\n                background-color: $primary;\n                color: $white;\n                text-shadow: 5px 5px rgba($white, 0.2);\n            }\n        }\n    }\n}\n\n.icons-list  {\n    .icon-item{\n        padding: 15px 0;\n        color: $gray-600;\n        svg{\n            margin-right: 10px;\n        }\n        \n        span{\n            line-height: 30px;\n            display: inline-block;\n            vertical-align: middle;\n        }\n    }\n}","// \n// tasks.scss\n//\n\n.board {\n    display: block;\n    white-space: nowrap;\n    overflow-x: auto;\n}\n\n.tasks {\n    display: inline-block;\n    width: 22rem;\n    padding: 0 1rem 1rem 1rem;\n    vertical-align: top;\n    margin-bottom: $grid-gutter-width;\n    background-color: $card-bg;\n    @include border-radius($border-radius-sm);\n\n    &.tasks:not(:last-child) {\n        margin-right: 1.25rem;\n    }\n\n    .card {\n        white-space: normal;\n        margin-top: 1rem;\n    }\n\n    .task-header {\n        background-color: $card-bg;\n        padding: 1rem;\n        margin: 0 -1rem;\n        @include border-radius($border-radius-sm);\n    }\n}\n\n.task-list-items {\n    min-height: 100px;\n    position: relative;\n\n    .card {\n        cursor: pointer;\n    }\n\n    &:before {\n        content: \"No Tasks\";\n        position: absolute;\n        line-height: 110px;\n        width: 100%;\n        text-align: center;\n        font-weight: 600;\n    }\n}\n\n\n// Task add modal\n.task-modal-content {\n    .form-control-light {\n        background-color: lighten($gray-200, 2.5%) !important;\n        border-color: lighten($gray-200, 2.5%) !important;\n    }\n}\n\n// task - gantt\n.gantt-task-details {\n    min-width: 220px;\n}\n\n// task search\n.task-search {\n    .search-input {\n        padding-left: 32px;\n        z-index: 10;\n    }\n    .icon-search {\n        z-index: 11;\n        position: absolute;\n        left: 10px;\n        top: 10px;\n    }\n}\n\n.cursor-pointer {\n    cursor: pointer;\n}","// \n// email.scss\n//\n\n.email-container {\n    margin-bottom: $grid-gutter-width;\n    background-color: $card-bg;\n    .inbox-leftbar {\n        padding: $card-spacer-x;\n        width: 250px;\n        float: left;\n        // padding: 0 20px 20px 10px;\n        padding-bottom: 184px;\n        margin-bottom: -184px;\n    }\n\n    .inbox-rightbar {\n        margin-left: 250px;\n        border-left: 5px solid $body-bg;\n        padding: 0 0 1.5rem 25px;\n    }\n}\n\n\n\n.message-list {\n    display: block;\n    padding-left: 0;\n\n    li {\n        position: relative;\n        display: block;\n        height: 48px;\n        line-height: 48px;\n        cursor: default;\n        transition-duration: .3s;\n        background: $card-bg;\n        margin-bottom: 1px;\n        box-shadow: $box-shadow-sm;\n\n        a {\n            color: $gray-700;\n        }\n\n        &:hover {\n            box-shadow: $box-shadow;\n            transition-duration: .05s;\n        }\n\n        .col-mail {\n            float: left;\n            position: relative;\n        }\n\n        .col-mail-1 {\n            width: 320px;\n\n            .star-toggle,\n            .checkbox-wrapper-mail,\n            .dot {\n                display: block;\n                float: left;\n            }\n\n            .dot {\n                border: 4px solid transparent;\n                border-radius: 100px;\n                margin: 22px 26px 0;\n                height: 0;\n                width: 0;\n                line-height: 0;\n                font-size: 0;\n            }\n\n            .checkbox-wrapper-mail {\n                margin: 15px 10px 0 20px;\n            }\n\n            .star-toggle {\n                color: $gray-500;\n                margin-left: 10px;\n            }\n\n            .title {\n                position: absolute;\n                top: 0;\n                left: 100px;\n                right: 0;\n                text-overflow: ellipsis;\n                overflow: hidden;\n                white-space: nowrap;\n                margin-bottom: 0;\n                line-height: 50px;\n            }\n        }\n\n        .col-mail-2 {\n            position: absolute;\n            top: 0;\n            left: 320px;\n            right: 0;\n            bottom: 0;\n\n            .subject,\n            .date {\n                position: absolute;\n                top: 0;\n            }\n\n            .subject {\n                left: 0;\n                right: 110px;\n                text-overflow: ellipsis;\n                overflow: hidden;\n                white-space: nowrap;\n            }\n\n            .date {\n                right: 0;\n                width: 100px;\n                padding-left: 10px;\n            }\n        }\n    }\n\n    li.active,\n    li.mail-selected {\n        background: $gray-100;\n        transition-duration: .05s;\n    }\n\n    li.active,\n    li.active:hover {\n        box-shadow: inset 3px 0 0 $cyan;\n    }\n\n    li.unread a {\n        // font-weight: $font-weight-semibold;\n        color: darken($dark, 5%);\n    }\n\n    .checkbox-wrapper-mail {\n        cursor: pointer;\n        height: 20px;\n        width: 20px;\n        position: relative;\n        display: inline-block;\n        box-shadow: inset 0 0 0 2px $gray-400;\n        border-radius: 3px;\n\n        input {\n            opacity: 0;\n            cursor: pointer;\n        }\n\n        input:checked~label {\n            opacity: 1;\n        }\n\n        label {\n            position: absolute;\n            top: 3px;\n            left: 3px;\n            right: 3px;\n            bottom: 3px;\n            cursor: pointer;\n            background: $gray-600;\n            opacity: 0;\n            margin-bottom: 0 !important;\n            transition-duration: .05s;\n        }\n\n        label:active {\n            background: #87949b;\n        }\n    }\n}\n\n.mail-list {\n    a {\n        color: $gray-700;\n        padding: 7px 10px;\n        display: block;\n    }\n}\n\n.reply-box {\n    border: 2px solid $light;\n}\n\n@media (max-width: 648px) {\n    .email-container {\n        .inbox-leftbar {\n                width: 100%;\n                float: none;\n                margin-bottom: 21px;\n                padding-bottom: 1.25rem;\n        }\n\n        .inbox-rightbar {\n            margin-left: 0;\n            border: 0;\n            padding-left: 0;\n        }\n    }\n\n}\n\n@media (max-width: 520px) {\n    .inbox-rightbar {\n        >.btn-group {\n            margin-bottom: 10px;\n        }\n    }\n\n    .message-list li {\n        .col-mail-1 {\n            width: 150px;\n\n            .title {\n                left: 80px;\n            }\n        }\n\n        .col-mail-2 {\n            left: 160px;\n\n            .date {\n                text-align: right;\n                padding-right: 10px;\n                padding-left: 20px;\n            }\n        }\n    }\n}\n\n.chatbox {\n    position: fixed;\n    right: 35px;\n    bottom: 10px;\n    width: 300px;\n    background-color: $card-bg;\n    border-radius: $border-radius;\n    box-shadow: $box-shadow;\n    z-index: 99;\n\n    .chat-input {\n        .form-control {\n            padding-right: 60px;\n        }\n    }\n\n    .chat-link {\n        position: absolute;\n        right: 4px;\n        top: 10px\n    }\n}\n","// \n// timeline.scss\n//\n\n/************** Horizontal timeline **************/ \n\n.left-timeline{\n    .events{\n        border-left: 3px solid $gray-300;\n        padding-left: 35px;\n        .event-list{\n            position: relative;\n            &::before{\n                content: \"\";\n                position: absolute;\n                left: -45px;\n                top: 6px;\n                height: 18px;\n                width: 18px;\n                background-color: $primary;\n                border-radius: 50%;\n                border: 5px solid $card-bg;\n                z-index: 9;\n            }\n            &::after{\n                content: \"\";\n                position: absolute;\n                left: -38px;\n                top: 14px;\n                height: 3px;\n                width: 30px;\n                background-color: $gray-300;\n            }\n        }\n    }\n\n    .album {\n        img {\n            height: 36px;\n            width: auto;\n            border-radius: 4px;\n        }\n    }\n}\n\n\n// timeline center\n\n\n.timeline {\n    margin-bottom: 50px;\n    position: relative;\n    &:before {\n        background-color: $gray-300;\n        bottom: 0;\n        content: \"\";\n        left: 50%;\n        position: absolute;\n        top: 30px;\n        width: 2px;\n        z-index: 0;\n    }\n    .time-show {\n        margin-bottom: 30px;\n        margin-top: 30px;\n        position: relative;\n    }\n    .timeline-box {\n        display: block;\n        position: relative;\n        padding: 20px;\n    }\n    .timeline-album {\n        margin-top: 12px;\n        a {\n            display: inline-block;\n            margin-right: 5px;\n        }\n        img {\n            height: 36px;\n            width: auto;\n            border-radius: 3px;\n        }\n    }\n}\n\n@include media-breakpoint-up(md) {\n    .timeline {\n        .time-show {\n            right: 69px;\n            text-align: right;\n        }\n        .timeline-box {\n            margin-left: 15px;\n        }\n        .timeline-icon {\n            background: $primary;\n            border-radius: 50%;\n            display: block;\n            height: 20px;\n            left: -24px;\n            margin-top: -10px;\n            position: absolute;\n            text-align: center;\n            top: 15%;\n            width: 20px;\n            border: 5px solid $card-bg;\n            z-index: 9;\n            &:before {\n                content: \"\";\n                position: absolute;\n                height: 3px;\n                width: 19px;\n                background-color: $gray-300;\n                left: 15px;\n                top: 3px;\n            }\n        }\n        .timeline-desk {\n            display: table-cell;\n            vertical-align: top;\n            width: 50%;\n        }\n    }\n    .timeline-item {\n        display: flex;\n        &:before {\n            content: \"\";\n            display: block;\n            width: 50%;\n        }\n\n        &.timeline-item-left {\n            &:after {\n                content: \"\";\n                display: block;\n                width: 50%;\n            }\n            .timeline-desk {\n                .album {\n                    float: right;\n                    margin-top: 20px;\n                    a {\n                        float: right;\n                        margin-left: 5px;\n                    }\n                }\n            }\n            .timeline-icon {\n                left: auto;\n                right: -26px;\n                &:before{\n                    left: auto;\n                    right: 15px;\n                }\n            }\n            &:before {\n                display: none;\n            }\n            .timeline-box {\n                margin-right: 15px;\n                margin-left: 0;\n                text-align: right;\n            }\n        }\n    }\n}\n\n@include media-breakpoint-down(sm) {\n    .timeline {\n        .time-show {\n            text-align: center;\n            position: relative;\n        }\n        .event-date{\n            float: left !important;\n            margin-right: 1.5rem;\n            margin-left: 0 !important;\n        }\n        .timeline-icon {\n            display: none;\n        }\n        \n    }\n}","// \n// extra-pages.scss\n//\n\n// pricing\n\n.card-pricing{\n    .card-pricing-features{\n        li{\n            padding: 10px;\n            &:before{\n                color: $primary;\n            }\n        }\n    }\n}\n\n","// \n// authentication.scss\n//\n\n// authentication pages background\nbody {\n    &.authentication-bg {\n        background-size: cover;\n        background-repeat: no-repeat;\n        padding-bottom: 0;\n    }\n}\n\n\n.authentication-form {\n    .form-group {\n        .input-group-text {\n            background-color: transparent;\n\n            svg {\n                height: 22px;\n                width: 22px;\n            }\n        }\n    }\n}\n\n.icon-fb {\n    color: #3c5a98;\n}\n\n.icon-google {\n    color: #e94134;\n}\n\n.auth-page-sidebar {\n    padding: 0;\n    background-image: url('../images/Login.png');\n    background-repeat: no-repeat;\n    background-size: cover;\n    height: 100%;\n    position: relative;\n\n    .overlay {\n        flex: 1;\n        position: absolute;\n        top: 0;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        background-color: rgba($black,.4);\n    }\n\n    .auth-user-testimonial {\n        text-align: center;\n        color: $white;\n        position: absolute;\n        margin: 0 auto;\n        padding: 0 1.75rem;\n        bottom: 3rem;\n        left: 0;\n        right: 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
